
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec52e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec52e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("biuEp", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $dBHwk = parcelRequire("dBHwk");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $2rasJ = parcelRequire("2rasJ");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $2rasJ.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $dBHwk.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $2rasJ.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $2rasJ.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("dBHwk", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("2rasJ", function(module, exports) {
'use strict';

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
'use strict';

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    depth: Infinity,
    encode: true,
    encodeDotInKeys: false,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel, depth, currentDepth) {
    var obj = object;
    if (currentDepth > depth) throw new RangeError('Input depth exceeded depth option of ' + depth);
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === 'undefined') step = 0;
    }
    obj = typeof filter === 'function' ? filter(prefix, obj) : obj;
    if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iBfJ5.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v, $e5dd19a945a45bbb$var$defaults.encoder, charset, 'value', format);
        });
        objKeys = [
            {
                value: obj.length > 0 ? $iBfJ5.toCoercible(obj).join(',') || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = String(prefix);
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel, depth, currentDepth + 1));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $i1Gbt.default;
    if (typeof opts.format !== 'undefined') {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === 'function' || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if ($e5dd19a945a45bbb$var$has.call($e5dd19a945a45bbb$var$arrayPrefixGenerators, opts.arrayFormat)) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $e5dd19a945a45bbb$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $e5dd19a945a45bbb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : $e5dd19a945a45bbb$var$defaults.depth,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $e5dd19a945a45bbb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        var encodedKey = options.encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(value, encodedKey, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel, options.depth, 0));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("LlIML", function(module, exports) {
'use strict';

var $eEkyn = parcelRequire("eEkyn");

var $e7DLx = parcelRequire("e7DLx");

var $76oEb = parcelRequire("76oEb");

var $b0JRY = parcelRequire("b0JRY");

var $7Emfc = parcelRequire("7Emfc");
var $08e53d4ef2e1f8ef$var$makeChannel = $7Emfc || $b0JRY || $76oEb;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) {
                var keyDesc = key && Object(key) === key ? 'the given object key' : $e7DLx(key);
                throw new $eEkyn('Side channel does not contain ' + keyDesc);
            }
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $08e53d4ef2e1f8ef$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    return channel;
};

});
parcelRegister("eEkyn", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === 'function' && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === 'function' ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === 'function' && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === 'function' ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, '$&_');
}

var $4kvQX = parcelRequire("4kvQX");
var $a48090c7c3dfd2b6$var$inspectCustom = $4kvQX.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
var $a48090c7c3dfd2b6$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $a48090c7c3dfd2b6$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, 'quoteStyle') && !$a48090c7c3dfd2b6$var$has($a48090c7c3dfd2b6$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($a48090c7c3dfd2b6$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $a48090c7c3dfd2b6$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $a48090c7c3dfd2b6$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === 'object' && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = '<' + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return '[' + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $a48090c7c3dfd2b6$var$$join.call(xs, ', ') + ' ]';
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $a48090c7c3dfd2b6$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === 'function' && $4kvQX) return $4kvQX(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf('Map', $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf('Set', $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakMap');
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakSet');
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf('WeakRef');
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $a48090c7c3dfd2b6$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $a48090c7c3dfd2b6$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, '&quot;');
}
function $a48090c7c3dfd2b6$var$canTrustToString(obj) {
    return !$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === 'object' && ($a48090c7c3dfd2b6$var$toStringTag in obj || typeof obj[$a48090c7c3dfd2b6$var$toStringTag] !== 'undefined'));
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Array]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Date]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object RegExp]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Error]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object String]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Number]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === '[object Boolean]' && $a48090c7c3dfd2b6$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $a48090c7c3dfd2b6$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, 'single', opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === 'function' ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("4kvQX", function(module, exports) {
"use strict";

});


parcelRegister("76oEb", function(module, exports) {
'use strict';

var $e7DLx = parcelRequire("e7DLx");

var $eEkyn = parcelRequire("eEkyn");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $52bc36570c76608b$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $52bc36570c76608b$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $52bc36570c76608b$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $52bc36570c76608b$var$listSet = function(objects, key, value) {
    var node = $52bc36570c76608b$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $52bc36570c76608b$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$52bc36570c76608b$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $52bc36570c76608b$var$listDelete = function(objects, key) {
    if (objects) return $52bc36570c76608b$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn('Side channel does not contain ' + $e7DLx(key));
        },
        'delete': function(key) {
            var deletedNode = $52bc36570c76608b$var$listDelete($o, key);
            if (deletedNode && $o && !$o.next) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $52bc36570c76608b$var$listGet($o, key);
        },
        has: function(key) {
            return $52bc36570c76608b$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $52bc36570c76608b$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    return channel;
};

});

parcelRegister("b0JRY", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $eW390 = parcelRequire("eW390");

var $e7DLx = parcelRequire("e7DLx");

var $eEkyn = parcelRequire("eEkyn");
var $8043468335131548$var$$Map = $1zENl('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $8043468335131548$var$$mapGet = $eW390('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $8043468335131548$var$$mapSet = $eW390('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $8043468335131548$var$$mapHas = $eW390('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $8043468335131548$var$$mapDelete = $eW390('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $8043468335131548$var$$mapSize = $eW390('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$8043468335131548$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn('Side channel does not contain ' + $e7DLx(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $8043468335131548$var$$mapDelete($m, key);
                if ($8043468335131548$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $8043468335131548$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $8043468335131548$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $8043468335131548$var$$Map();
            $8043468335131548$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;

var $90JBs = parcelRequire("90JBs");

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");

var $bdePV = parcelRequire("bdePV");

var $dK8VM = parcelRequire("dK8VM");

var $7F9c3 = parcelRequire("7F9c3");

var $4l7TM = parcelRequire("4l7TM");

var $brYbP = parcelRequire("brYbP");

var $1rWQg = parcelRequire("1rWQg");

var $4J7z9 = parcelRequire("4J7z9");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $dYOee = parcelRequire("dYOee");

var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $dYOee ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $dYOee(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $3ERI6 = parcelRequire("3ERI6");

var $eim86 = parcelRequire("eim86");

var $TxOUG = parcelRequire("TxOUG");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$3ERI6 ? undefined : $3ERI6(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5A49f,
    '%eval%': eval,
    '%EvalError%': $hDtVy,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6($3ERI6([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $90JBs,
    '%Object.getOwnPropertyDescriptor%': $dYOee,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9RC8m,
    '%ReferenceError%': $2BaZq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5Ox6r,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $eEkyn,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hFSMY,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9pzbV,
    '%Function.prototype.apply%': $xMvSJ,
    '%Object.defineProperty%': $jAy3M,
    '%Object.getPrototypeOf%': $eim86,
    '%Math.abs%': $bdePV,
    '%Math.floor%': $dK8VM,
    '%Math.max%': $7F9c3,
    '%Math.min%': $4l7TM,
    '%Math.pow%': $brYbP,
    '%Math.round%': $1rWQg,
    '%Math.sign%': $4J7z9,
    '%Reflect.getPrototypeOf%': $TxOUG
};
if ($3ERI6) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $3ERI6($3ERI6(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3ERI6) value = $3ERI6(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call($9pzbV, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call($xMvSJ, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call($9pzbV, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call($9pzbV, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call($9pzbV, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eEkyn('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eEkyn('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5Ox6r('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($dYOee && i + 1 >= parts.length) {
                var desc = $dYOee(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("90JBs", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5A49f", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("hFSMY", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bdePV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("dK8VM", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("7F9c3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4l7TM", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("brYbP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1rWQg", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4J7z9", function(module, exports) {
'use strict';

var $4oiz9 = parcelRequire("4oiz9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4oiz9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4oiz9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("dYOee", function(module, exports) {
'use strict';

var $d4L75 = parcelRequire("d4L75");
var $a2d7d74e83f6c3ed$require$$gOPD = $d4L75;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$require$$gOPD;

});
parcelRegister("d4L75", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("3ERI6", function(module, exports) {
'use strict';

var $TxOUG = parcelRequire("TxOUG");

var $eim86 = parcelRequire("eim86");

var $7kfw3 = parcelRequire("7kfw3");
/** @type {import('.')} */ module.exports = $TxOUG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TxOUG(O);
} : $eim86 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eim86(O);
} : $7kfw3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7kfw3(O);
} : null;

});
parcelRegister("TxOUG", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eim86", function(module, exports) {
'use strict';

var $90JBs = parcelRequire("90JBs");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $90JBs.getPrototypeOf || null;

});

parcelRegister("7kfw3", function(module, exports) {
'use strict';

var $jyxCz = parcelRequire("jyxCz");

var $dYOee = parcelRequire("dYOee");
var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $dYOee && $dYOee(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $jyxCz([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;

});
parcelRegister("jyxCz", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $eEkyn = parcelRequire("eEkyn");

var $9pzbV = parcelRequire("9pzbV");

var $3YvJT = parcelRequire("3YvJT");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eEkyn('a function is required');
    return $3YvJT($gvair, $9pzbV, args);
};

});
parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pzbV", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3YvJT", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");

var $8qWPV = parcelRequire("8qWPV");
/** @type {import('./actualApply')} */ module.exports = $8qWPV || $gvair.call($9pzbV, $xMvSJ);

});
parcelRegister("xMvSJ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("8qWPV", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("4c4Ky", function(module, exports) {
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("eW390", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $jyxCz = parcelRequire("jyxCz");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $jyxCz([
    $1zENl('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $jyxCz(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("7Emfc", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $eW390 = parcelRequire("eW390");

var $e7DLx = parcelRequire("e7DLx");

var $b0JRY = parcelRequire("b0JRY");

var $eEkyn = parcelRequire("eEkyn");
var $591d8612c5fec170$var$$WeakMap = $1zENl('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $591d8612c5fec170$var$$weakMapGet = $eW390('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $591d8612c5fec170$var$$weakMapSet = $eW390('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $591d8612c5fec170$var$$weakMapHas = $eW390('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $591d8612c5fec170$var$$weakMapDelete = $eW390('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $591d8612c5fec170$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn('Side channel does not contain ' + $e7DLx(key));
        },
        'delete': function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapDelete($wm, key);
            } else if ($b0JRY) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $591d8612c5fec170$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($591d8612c5fec170$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $591d8612c5fec170$var$$WeakMap();
                $591d8612c5fec170$var$$weakMapSet($wm, key, value);
            } else if ($b0JRY) {
                if (!$m) $m = $b0JRY();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $b0JRY;

});


parcelRegister("iBfJ5", function(module, exports) {
'use strict';

var $i1Gbt = parcelRequire("i1Gbt");

var $LlIML = parcelRequire("LlIML");

var $jAy3M = parcelRequire("jAy3M");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $d8a7e190fdc9c6e7$var$overflowChannel = $LlIML();
var $d8a7e190fdc9c6e7$var$markOverflow = function markOverflow(obj, maxIndex) {
    $d8a7e190fdc9c6e7$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $d8a7e190fdc9c6e7$var$isOverflow = function isOverflow(obj) {
    return $d8a7e190fdc9c6e7$var$overflowChannel.has(obj);
};
var $d8a7e190fdc9c6e7$var$getMaxIndex = function getMaxIndex(obj) {
    return $d8a7e190fdc9c6e7$var$overflowChannel.get(obj);
};
var $d8a7e190fdc9c6e7$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $d8a7e190fdc9c6e7$var$overflowChannel.set(obj, maxIndex);
};
// Track containers produced by a `strictMerge` conflict wrap, and their current max numeric index,
// so repeated conflicts on one path append instead of nesting a new wrapper each time
var $d8a7e190fdc9c6e7$var$conflictChannel = $LlIML();
var $d8a7e190fdc9c6e7$var$markConflict = function markConflict(obj, maxIndex) {
    $d8a7e190fdc9c6e7$var$conflictChannel.set(obj, maxIndex);
    return obj;
};
var $d8a7e190fdc9c6e7$var$isConflict = function isConflict(obj) {
    return $d8a7e190fdc9c6e7$var$conflictChannel.has(obj);
};
var $d8a7e190fdc9c6e7$var$getConflictIndex = function getConflictIndex(obj) {
    return $d8a7e190fdc9c6e7$var$conflictChannel.get(obj);
};
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && $jAy3M) $jAy3M(obj, key, {
        configurable: true,
        enumerable: true,
        value: value,
        writable: true
    });
    else obj[key] = value;
};
var $d8a7e190fdc9c6e7$var$maxNumericIndex = function maxNumericIndex(obj, min) {
    var max = min;
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; ++i){
        var num = parseInt(keys[i], 10);
        if (String(num) === keys[i] && num > max) max = num;
    }
    return max;
};
var $d8a7e190fdc9c6e7$var$limitedPair = function limitedPair(first, second, options) {
    var pair = [
        first,
        second
    ];
    if (options && typeof options.arrayLimit === 'number' && pair.length > options.arrayLimit) {
        if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(pair, options), 1);
    }
    return pair;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($d8a7e190fdc9c6e7$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $d8a7e190fdc9c6e7$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $d8a7e190fdc9c6e7$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge && $d8a7e190fdc9c6e7$var$isConflict(target)) {
                var nextConflict = $d8a7e190fdc9c6e7$var$getConflictIndex(target) + 1;
                if (options.throwOnLimitExceeded && typeof options.arrayLimit === 'number' && nextConflict >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                target[nextConflict] = source;
                $d8a7e190fdc9c6e7$var$markConflict(target, nextConflict);
            } else if (options && options.strictMerge) {
                var conflict = $d8a7e190fdc9c6e7$var$limitedPair(target, source, options);
                return $d8a7e190fdc9c6e7$var$isArray(conflict) ? $d8a7e190fdc9c6e7$var$markConflict(conflict, 1) : conflict;
            } else if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return $d8a7e190fdc9c6e7$var$limitedPair(target, source, options);
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($d8a7e190fdc9c6e7$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $d8a7e190fdc9c6e7$var$markOverflow(result, $d8a7e190fdc9c6e7$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) {
        mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
        if ($d8a7e190fdc9c6e7$var$isConflict(target)) // the array may have grown past its last conflict, so continue after its last index
        $d8a7e190fdc9c6e7$var$markConflict(mergeTarget, target.length - 1);
    }
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(target, options), target.length - 1);
        }
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) $d8a7e190fdc9c6e7$var$setProperty(acc, key, merge(acc[key], value, options));
        else $d8a7e190fdc9c6e7$var$setProperty(acc, key, value);
        if ($d8a7e190fdc9c6e7$var$isOverflow(source) && !$d8a7e190fdc9c6e7$var$isOverflow(acc)) $d8a7e190fdc9c6e7$var$markOverflow(acc, $d8a7e190fdc9c6e7$var$maxNumericIndex(acc, $d8a7e190fdc9c6e7$var$getMaxIndex(source)));
        if ($d8a7e190fdc9c6e7$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $d8a7e190fdc9c6e7$var$getMaxIndex(acc)) $d8a7e190fdc9c6e7$var$setMaxIndex(acc, keyNum);
        }
        if ($d8a7e190fdc9c6e7$var$isConflict(acc)) {
            var conflictKey = parseInt(key, 10);
            if (String(conflictKey) === key && conflictKey > $d8a7e190fdc9c6e7$var$getConflictIndex(acc)) $d8a7e190fdc9c6e7$var$markConflict(acc, conflictKey);
        }
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        $d8a7e190fdc9c6e7$var$setProperty(acc, key, source[key]);
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, defaultDecoder, charset) {
    // With no `%` there is no escape to expand, in either charset: `unescape` has
    // nothing to match, and `decodeURIComponent` is the identity on such a string
    // (and cannot throw). So only `+` -> ' ' remains, and often not even that.
    if (typeof str === 'string' && str.indexOf('%') === -1) return str.indexOf('+') === -1 ? str : str.replace(/\+/g, ' ');
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$hasToPrimitive = typeof Symbol === 'function' && typeof Symbol.toPrimitive === 'symbol';
var $d8a7e190fdc9c6e7$var$arrayJoin = Array.prototype.join;
var $d8a7e190fdc9c6e7$var$arrayToString = Array.prototype.toString;
var $d8a7e190fdc9c6e7$var$objectToString = Object.prototype.toString;
// an object with no callable toString (eg, from JSON, or null-prototype) would make String() or join() throw,
// so it becomes its primitive valueOf or else Object.prototype.toString; arrays are walked like join walks them,
// copied only once an element changes, with an array already being joined becoming '' as engines do for cycles
var $d8a7e190fdc9c6e7$var$toCoercible = function toCoercible(value, joining) {
    if (!value || typeof value !== 'object' && typeof value !== 'function') return value;
    if ($d8a7e190fdc9c6e7$var$hasToPrimitive && value[Symbol.toPrimitive] != null) return value;
    if ($d8a7e190fdc9c6e7$var$isArray(value) && value.toString === $d8a7e190fdc9c6e7$var$arrayToString && value.join === $d8a7e190fdc9c6e7$var$arrayJoin) {
        var ancestors = joining || $LlIML();
        if (ancestors.has(value)) return '';
        ancestors.set(value, true);
        var copy;
        for(var i = 0; i < value.length; i += 1){
            var item = value[i];
            var coerced = toCoercible(item, ancestors);
            if (!copy && coerced !== item) {
                copy = [];
                for(var j = 0; j < i; j += 1)copy[j] = value[j];
            }
            if (copy) copy[i] = coerced;
        }
        ancestors['delete'](value);
        return copy || value;
    }
    if (typeof value.toString === 'function') return value;
    var valueOf = value.valueOf;
    if (typeof valueOf === 'function') {
        var primitive = valueOf.call(value);
        if (!primitive || typeof primitive !== 'object' && typeof primitive !== 'function') return String(primitive);
    }
    return $d8a7e190fdc9c6e7$var$objectToString.call(value);
};
var $d8a7e190fdc9c6e7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String($d8a7e190fdc9c6e7$var$toCoercible(str));
    if (charset === 'iso-8859-1') // `escape` leaves `+` untouched, but a literal `+` is decoded back to a space,
    // so it must be percent-encoded to round-trip (the utf-8 path already does this).
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    }).replace(/\+/g, '%2B');
    var out = '';
    for(var j = 0; j < string.length; j += $d8a7e190fdc9c6e7$var$limit){
        var segment = string.length >= $d8a7e190fdc9c6e7$var$limit ? string.slice(j, j + $d8a7e190fdc9c6e7$var$limit) : string;
        if (j + $d8a7e190fdc9c6e7$var$limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = $LlIML();
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs.set(val, true);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if ($d8a7e190fdc9c6e7$var$isOverflow(a)) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        // spread `b` one level, matching the `[].concat(a, b)` used below, so a
        // collection appended to an already-overflowed object is flattened
        // rather than nested under a single index
        var bValues = $d8a7e190fdc9c6e7$var$isArray(b) ? b : [
            b
        ];
        var newIndex = $d8a7e190fdc9c6e7$var$getMaxIndex(a);
        for(var i = 0; i < bValues.length; ++i){
            newIndex += 1;
            a[newIndex] = bValues[i];
        }
        $d8a7e190fdc9c6e7$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $d8a7e190fdc9c6e7$var$markOverflow($d8a7e190fdc9c6e7$var$arrayToObject(result, {
            plainObjects: plainObjects
        }), result.length - 1);
    }
    return result;
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isOverflow: $d8a7e190fdc9c6e7$var$isOverflow,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    markOverflow: $d8a7e190fdc9c6e7$var$markOverflow,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge,
    toCoercible: $d8a7e190fdc9c6e7$var$toCoercible
};

});
parcelRegister("i1Gbt", function(module, exports) {
'use strict';
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
'use strict';

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$getPrototypeOf = Object.getPrototypeOf;
var $8ec5fc0fdc198ba4$var$isPlainContainer = function isPlainContainer(value) {
    if (!value || typeof value !== 'object') return false;
    if ($8ec5fc0fdc198ba4$var$isArray(value)) return true;
    var proto = $8ec5fc0fdc198ba4$var$getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};
var $8ec5fc0fdc198ba4$var$emptyCopyOf = function emptyCopyOf(value) {
    if ($8ec5fc0fdc198ba4$var$isArray(value)) {
        var arr = [];
        arr.length = value.length;
        return arr;
    }
    return $8ec5fc0fdc198ba4$var$getPrototypeOf(value) === null ? {
        __proto__: null
    } : {};
};
// `merge` and `compact` modify the containers they are given, so copy the caller's arrays and plain objects first
var $8ec5fc0fdc198ba4$var$copyInput = function copyInput(input) {
    var copies = $LlIML();
    var result = {};
    var queue = [
        {
            source: input,
            target: result
        }
    ];
    for(var i = 0; i < queue.length; ++i){
        var source = queue[i].source;
        var target = queue[i].target;
        var keys = Object.keys(source);
        for(var j = 0; j < keys.length; ++j){
            var value = source[keys[j]];
            if ($8ec5fc0fdc198ba4$var$isPlainContainer(value)) {
                if (!copies.has(value)) {
                    var copy = $8ec5fc0fdc198ba4$var$emptyCopyOf(value);
                    copies.set(value, copy);
                    queue[queue.length] = {
                        source: value,
                        target: copy
                    };
                }
                target[keys[j]] = copies.get(value);
            } else target[keys[j]] = value;
        }
    }
    return result;
};
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $iBfJ5.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while(commaIndex > -1){
                commaCount += 1;
                if (commaCount >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        // `[]` belongs to the key, so look for it at the split point, not anywhere in the part
        var isEmptyBracketKey = pos > 1 && part.slice(pos - 2, pos) === '[]';
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options, $8ec5fc0fdc198ba4$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(String(val));
        if (isEmptyBracketKey) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $8ec5fc0fdc198ba4$var$isArray(val) && val.length > options.arrayLimit) val = $iBfJ5.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        if (key !== null) {
            var existing = $8ec5fc0fdc198ba4$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || isEmptyBracketKey)) obj[key] = $iBfJ5.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($iBfJ5.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $iBfJ5.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $iBfJ5.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Behaves like `key.replace(/\.([^.[]+)/g, '[$1]')`, but only rewrites a dot
// that sits at bracket depth 0. A literal dot already inside a `[...]` segment
// is left untouched instead of corrupting the key (e.g. "outer[a.b]"). (#617)
var $8ec5fc0fdc198ba4$var$topLevelDotsToBrackets = function topLevelDotsToBrackets(key) {
    var result = '';
    var depth = 0;
    for(var i = 0; i < key.length; i += 1){
        var cu = key.charCodeAt(i);
        if (cu === 0x5B) {
            depth += 1;
            result += '[';
        } else if (cu === 0x5D) {
            if (depth > 0) depth -= 1;
            result += ']';
        } else if (cu === 0x2E // '.'
         && depth === 0 && i + 1 < key.length && key.charCodeAt(i + 1) !== 0x2E // not another '.'
         && key.charCodeAt(i + 1) !== 0x5B // not '['
        ) {
            var start = i + 1;
            var j = start;
            while(j < key.length && key.charCodeAt(j) !== 0x2E && key.charCodeAt(j) !== 0x5B)j += 1;
            result += '[' + key.slice(start, j) + ']';
            i = j - 1;
        } else result += key.charAt(i);
    }
    return result;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var $8ec5fc0fdc198ba4$var$splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? $8ec5fc0fdc198ba4$var$topLevelDotsToBrackets(originalKey) : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $8ec5fc0fdc198ba4$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $8ec5fc0fdc198ba4$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $8ec5fc0fdc198ba4$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $8ec5fc0fdc198ba4$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $8ec5fc0fdc198ba4$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $8ec5fc0fdc198ba4$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : $8ec5fc0fdc198ba4$var$copyInput(str);
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});



parcelRegister("aLuzK", function(module, exports) {

$parcel$export(module.exports, "eventHandlers", () => $7d6602d5c01fbe8e$export$5884fd3d92665ea6);
$parcel$export(module.exports, "applyDefaultProps", () => $7d6602d5c01fbe8e$export$2da27ad86541356b);
$parcel$export(module.exports, "TYPES", () => $7d6602d5c01fbe8e$export$426db7a6155b7a80);
$parcel$export(module.exports, "PixiComponent", () => $7d6602d5c01fbe8e$export$2a40992791448fb5);
$parcel$export(module.exports, "PixiFiber", () => $7d6602d5c01fbe8e$export$156582218858362c);
$parcel$export(module.exports, "createRoot", () => $7d6602d5c01fbe8e$export$882461b6382ed46c);
$parcel$export(module.exports, "render", () => $7d6602d5c01fbe8e$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "unmountComponentAtNode", () => $7d6602d5c01fbe8e$export$502457920280e6be);
$parcel$export(module.exports, "AppContext", () => $7d6602d5c01fbe8e$export$122994dc05ba4308);
$parcel$export(module.exports, "AppProvider", () => $7d6602d5c01fbe8e$export$c7dacf3845253dcf);
$parcel$export(module.exports, "AppConsumer", () => $7d6602d5c01fbe8e$export$c42bd7ed5c521bd0);
$parcel$export(module.exports, "withPixiApp", () => $7d6602d5c01fbe8e$export$179453dd40cee9bc);
$parcel$export(module.exports, "Stage", () => $7d6602d5c01fbe8e$export$208cd1682bd0e4b6);
$parcel$export(module.exports, "useApp", () => $7d6602d5c01fbe8e$export$fca13ab91e1a6240);
$parcel$export(module.exports, "useTick", () => $7d6602d5c01fbe8e$export$98bfbd4c9d834fed);
$parcel$export(module.exports, "withFilters", () => $7d6602d5c01fbe8e$export$8c08d75199bd74f2);
$parcel$export(module.exports, "BitmapText", () => $7d6602d5c01fbe8e$export$ae0da96467efdba0);
$parcel$export(module.exports, "Container", () => $7d6602d5c01fbe8e$export$42a852a2b6b56249);
$parcel$export(module.exports, "Graphics", () => $7d6602d5c01fbe8e$export$29d3e417456abdad);
$parcel$export(module.exports, "NineSlicePlane", () => $7d6602d5c01fbe8e$export$acdf4cb3f489544e);
$parcel$export(module.exports, "ParticleContainer", () => $7d6602d5c01fbe8e$export$e63bf72b2cfda112);
$parcel$export(module.exports, "Sprite", () => $7d6602d5c01fbe8e$export$3075603db8e6204c);
$parcel$export(module.exports, "AnimatedSprite", () => $7d6602d5c01fbe8e$export$dae599798687ad3c);
$parcel$export(module.exports, "Text", () => $7d6602d5c01fbe8e$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "TilingSprite", () => $7d6602d5c01fbe8e$export$db8370cd1ebcc819);
$parcel$export(module.exports, "SimpleMesh", () => $7d6602d5c01fbe8e$export$81b9e78682e7feca);
$parcel$export(module.exports, "SimpleRope", () => $7d6602d5c01fbe8e$export$f009a14c3f00879e);
parcelRequire("inflE");
var $cWOCu = parcelRequire("cWOCu");
parcelRequire("gD5uZ");
var $3IPo5 = parcelRequire("3IPo5");
var $5xkOK = parcelRequire("5xkOK");
parcelRequire("9fnly");
var $g9ac3 = parcelRequire("g9ac3");
var $gnwPx = parcelRequire("gnwPx");
parcelRequire("6x1UU");
var $30oUb = parcelRequire("30oUb");
parcelRequire("9WNrE");
var $1FuXs = parcelRequire("1FuXs");
parcelRequire("4hxmX");
var $j4bZM = parcelRequire("j4bZM");
var $8C3Kt = parcelRequire("8C3Kt");
var $dFgHQ = parcelRequire("dFgHQ");
parcelRequire("2oNag");
var $aQlRF = parcelRequire("aQlRF");
parcelRequire("jW6UI");
var $3uiak = parcelRequire("3uiak");
parcelRequire("XZ4uF");
var $4URvW = parcelRequire("4URvW");
parcelRequire("3xGdr");
var $68KVj = parcelRequire("68KVj");
parcelRequire("b6saP");
var $jiPZB = parcelRequire("jiPZB");

var $lmRm8 = parcelRequire("lmRm8");

var $acw62 = parcelRequire("acw62");
parcelRequire("gbrJV");
var $12K8P = parcelRequire("12K8P");
parcelRequire("jje6E");
var $3J55z = parcelRequire("3J55z");

var $c9Z8w = parcelRequire("c9Z8w");
function $7d6602d5c01fbe8e$var$P(e1) {
    return $7d6602d5c01fbe8e$var$P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
        return typeof e1;
    } : function(e1) {
        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
    }, $7d6602d5c01fbe8e$var$P(e1);
}
function $7d6602d5c01fbe8e$var$E(e1) {
    var n = function(e1, n) {
        if ("object" !== $7d6602d5c01fbe8e$var$P(e1) || null === e1) return e1;
        var t = e1[Symbol.toPrimitive];
        if (void 0 !== t) {
            var r = t.call(e1, n || "default");
            if ("object" !== $7d6602d5c01fbe8e$var$P(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === n ? String : Number)(e1);
    }(e1, "string");
    return "symbol" === $7d6602d5c01fbe8e$var$P(n) ? n : String(n);
}
function $7d6602d5c01fbe8e$var$_(e1, n, t) {
    return (n = $7d6602d5c01fbe8e$var$E(n)) in e1 ? Object.defineProperty(e1, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e1[n] = t, e1;
}
function $7d6602d5c01fbe8e$var$C(e1, n) {
    (null == n || n > e1.length) && (n = e1.length);
    for(var t = 0, r = new Array(n); t < n; t++)r[t] = e1[t];
    return r;
}
function $7d6602d5c01fbe8e$var$z(e1) {
    return function(e1) {
        if (Array.isArray(e1)) return $7d6602d5c01fbe8e$var$C(e1);
    }(e1) || function(e1) {
        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
    }(e1) || function(e1, n) {
        if (e1) {
            if ("string" == typeof e1) return $7d6602d5c01fbe8e$var$C(e1, n);
            var t = Object.prototype.toString.call(e1).slice(8, -1);
            return "Object" === t && e1.constructor && (t = e1.constructor.name), "Map" === t || "Set" === t ? Array.from(e1) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7d6602d5c01fbe8e$var$C(e1, n) : void 0;
        }
    }(e1) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $7d6602d5c01fbe8e$var$N(e1, n) {
    for(var t = arguments.length, r = new Array(t > 2 ? t - 2 : 0), l = 2; l < t; l++)r[l - 2] = arguments[l];
}
var $7d6602d5c01fbe8e$var$I = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $7d6602d5c01fbe8e$var$T(e1) {
    return e1 && e1.__esModule && Object.prototype.hasOwnProperty.call(e1, "default") ? e1.default : e1;
}
var $7d6602d5c01fbe8e$var$R = function(e1) {
    return null == e1;
};
function $7d6602d5c01fbe8e$var$O(e1) {
    var n = [];
    if (void 0 === e1) return n;
    if ("string" == typeof e1) n = e1.split(",");
    else if ("number" == typeof e1) n = [
        e1
    ];
    else if (Array.isArray(e1)) n = $7d6602d5c01fbe8e$var$z(e1);
    else {
        if (null === e1 || "object" !== $7d6602d5c01fbe8e$var$P(e1)) return n;
        n = [
            e1 && (null == e1 ? void 0 : e1.x) || 0,
            e1 && (null == e1 ? void 0 : e1.y) || 0
        ];
    }
    return n.filter(function(e1) {
        return !$7d6602d5c01fbe8e$var$R(e1) && !isNaN(e1);
    }).map(Number);
}
function $7d6602d5c01fbe8e$var$j(e1, n) {
    if (e1.length !== n.length) return !1;
    for(var t = 0; t < e1.length; t++)if (e1[t] !== n[t]) return !1;
    return !0;
}
function $7d6602d5c01fbe8e$var$L(e1) {
    return e1 instanceof (0, $gnwPx.Point) || e1 instanceof (0, $g9ac3.ObservablePoint);
}
var $7d6602d5c01fbe8e$export$5884fd3d92665ea6 = [
    "click",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "mouseupoutside",
    "tap",
    "touchstart",
    "touchmove",
    "touchend",
    "touchendoutside",
    "pointercancel",
    "pointerout",
    "pointerover",
    "pointertap",
    "pointerdown",
    "pointerup",
    "pointerupoutside",
    "pointermove",
    "rightclick",
    "rightdown",
    "rightup",
    "rightupoutside",
    "touchcancel",
    "touchendoutside",
    "touchmove",
    "touchstart"
];
function $7d6602d5c01fbe8e$var$D(e1, n, t) {
    if ($7d6602d5c01fbe8e$var$L(e1[n]) && $7d6602d5c01fbe8e$var$L(t)) e1[n].copyFrom(t);
    else if ($7d6602d5c01fbe8e$var$L(e1[n])) {
        var r = $7d6602d5c01fbe8e$var$O(t);
        $7d6602d5c01fbe8e$var$N(void 0 !== r && r.length > 0 && r.length < 3, "The property `%s` is a `PIXI.Point` or `PIXI.ObservablePoint` and must be set to a comma-separated string of either 1 or 2 coordinates, a 1 or 2 element array containing coordinates, or a PIXI Point/ObservablePoint. If only one coordinate is given then X and Y will be set to the provided value. Received: `%s` of type `%s`.", n, JSON.stringify(t), $7d6602d5c01fbe8e$var$P(t)), e1[n].set(r.shift(), r.shift());
    } else e1[n] = t;
}
var $7d6602d5c01fbe8e$var$U, $7d6602d5c01fbe8e$var$F = function(e1) {
    var n, t = e1;
    if (!Array.isArray(t)) {
        if (n = e1, "[object Object]" !== Object.prototype.toString.call(n)) throw new Error("collection needs to be an Array or Object");
        t = Object.keys(e1);
    }
    var r = {};
    return t.forEach(function(e1) {
        r[e1] = !0;
    }), function(e1) {
        return void 0 !== r[e1];
    };
}, $7d6602d5c01fbe8e$var$A = function(e1) {
    return function() {
        return !e1.apply(void 0, arguments);
    };
}, $7d6602d5c01fbe8e$var$Q = "children", $7d6602d5c01fbe8e$var$H = ($7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$U = {}, $7d6602d5c01fbe8e$var$Q, !0), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$U, "parent", !0), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$U, "worldAlpha", !0), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$U, "worldTransform", !0), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$U, "worldVisible", !0), $7d6602d5c01fbe8e$var$U), $7d6602d5c01fbe8e$var$B = {
    alpha: 1,
    buttonMode: !1,
    cacheAsBitmap: !1,
    cursor: null,
    filterArea: null,
    filters: null,
    hitArea: null,
    interactive: !1,
    mask: null,
    pivot: 0,
    position: 0,
    renderable: !0,
    rotation: 0,
    scale: 1,
    skew: 0,
    transform: null,
    visible: !0,
    x: 0,
    y: 0
}, $7d6602d5c01fbe8e$var$W = function(n, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, l = function(e1) {
        return requestAnimationFrame(function() {
            var n, t;
            null == e1 || null === (n = e1.__reactpixi) || void 0 === n || null === (t = n.root) || void 0 === t || t.emit("__REACT_PIXI_REQUEST_RENDER__");
        });
    }, a = function(e1, t) {
        if (r.hasOwnProperty(e1)) return $7d6602d5c01fbe8e$var$N(t.typeofs.some(function(n) {
            return $7d6602d5c01fbe8e$var$P(r[e1]) === n;
        }) || t.instanceofs.some(function(n) {
            return r[e1] instanceof n;
        }), "".concat(n, " ").concat(e1, " prop is invalid")), r[e1];
    };
    if (r.texture) return $7d6602d5c01fbe8e$var$N(r.texture instanceof (0, $cWOCu.Texture), "".concat(n, " texture needs to be typeof `Texture`")), r.texture;
    var i = a("image", {
        typeofs: [
            "string"
        ],
        instanceofs: [
            HTMLImageElement
        ]
    }) || a("video", {
        typeofs: [
            "string"
        ],
        instanceofs: [
            HTMLVideoElement
        ]
    }) || a("source", {
        typeofs: [
            "string",
            "number"
        ],
        instanceofs: [
            HTMLImageElement,
            HTMLVideoElement,
            HTMLCanvasElement,
            (0, $cWOCu.Texture)
        ]
    });
    $7d6602d5c01fbe8e$var$N(!!i, "".concat(n, " could not get texture from props"));
    var o = (0, $cWOCu.Texture).from(i);
    return o.__reactpixi = {
        root: t
    }, o.once("update", l), o.once("loaded", l), o.valid && l(o), o;
}, $7d6602d5c01fbe8e$var$$ = $7d6602d5c01fbe8e$var$A($7d6602d5c01fbe8e$var$F([].concat($7d6602d5c01fbe8e$var$z(Object.keys($7d6602d5c01fbe8e$var$H)), $7d6602d5c01fbe8e$var$z($7d6602d5c01fbe8e$export$5884fd3d92665ea6))));
function $7d6602d5c01fbe8e$export$2da27ad86541356b(e1, t, r) {
    var l = !1;
    if ($7d6602d5c01fbe8e$var$N((0, $5xkOK.DisplayObject).prototype.isPrototypeOf(e1), "instance needs to be typeof `DisplayObject`, got `%s`", $7d6602d5c01fbe8e$var$P(e1)), !r.ignoreEvents) for(var a = "function" == typeof e1.removeListener, i = "function" == typeof e1.on, o = 0; o < $7d6602d5c01fbe8e$export$5884fd3d92665ea6.length; o++){
        var u = $7d6602d5c01fbe8e$export$5884fd3d92665ea6[o];
        t[u] !== r[u] && (l = !0, "function" == typeof t[u] && a && e1.removeListener(u, t[u]), "function" == typeof r[u] && i && e1.on(u, r[u]));
    }
    var s = Object.keys(r || {});
    if (r.overwriteProps) {
        for(var c = 0; c < s.length; c++){
            var f = s[c];
            t[f] !== r[f] && (l = !0, $7d6602d5c01fbe8e$var$D(e1, f, r[f]));
        }
        return l;
    }
    for(var d = s.filter($7d6602d5c01fbe8e$var$$), p = 0; p < d.length; p++){
        var m = d[p], h = r[m];
        r[m] !== t[m] && (l = !0), void 0 !== h ? $7d6602d5c01fbe8e$var$D(e1, m, h) : m in $7d6602d5c01fbe8e$var$B ? (console.warn("setting default value: ".concat(m, ", from: ").concat(e1[m], " to: ").concat(h, " for"), e1), l = !0, $7d6602d5c01fbe8e$var$D(e1, m, $7d6602d5c01fbe8e$var$B[m])) : console.warn("ignoring prop: ".concat(m, ", from ").concat(e1[m], " to ").concat(h, " for"), e1);
    }
    return l;
}
var $7d6602d5c01fbe8e$var$X = function(e1, n) {
    var t = n.text, r = n.style;
    return new (0, $30oUb.BitmapText)(t, r);
}, $7d6602d5c01fbe8e$var$q = function() {
    return new (0, $3IPo5.Container);
};
function $7d6602d5c01fbe8e$var$G(e1, n) {
    if (null == e1) return {};
    var t, r, l = function(e1, n) {
        if (null == e1) return {};
        var t, r, l = {}, a = Object.keys(e1);
        for(r = 0; r < a.length; r++)t = a[r], n.indexOf(t) >= 0 || (l[t] = e1[t]);
        return l;
    }(e1, n);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e1);
        for(r = 0; r < a.length; r++)t = a[r], n.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e1, t) && (l[t] = e1[t]);
    }
    return l;
}
var $7d6602d5c01fbe8e$var$Y = [
    "draw",
    "geometry"
], $7d6602d5c01fbe8e$var$K = function(e1, n) {
    var t = n.geometry;
    $7d6602d5c01fbe8e$var$N(!t || t instanceof (0, $1FuXs.Graphics), "Graphics geometry needs to be a `PIXI.Graphics`");
    var r = t ? new (0, $1FuXs.Graphics)(t.geometry) : new (0, $1FuXs.Graphics);
    return r.applyProps = function(e1, n, t) {
        var l = t.draw;
        t.geometry;
        var a = $7d6602d5c01fbe8e$export$2da27ad86541356b(e1, n, $7d6602d5c01fbe8e$var$G(t, $7d6602d5c01fbe8e$var$Y));
        return n.draw !== l && "function" == typeof l && (a = !0, l.call(r, r)), a;
    }, r;
}, $7d6602d5c01fbe8e$var$J = [
    "image",
    "texture"
], $7d6602d5c01fbe8e$var$Z = function(e1, n) {
    var t = n.leftWidth, r = void 0 === t ? 10 : t, l = n.topHeight, a = void 0 === l ? 10 : l, i = n.rightWidth, u = void 0 === i ? 10 : i, s = n.bottomHeight, c = void 0 === s ? 10 : s, f = $7d6602d5c01fbe8e$var$W("NineSlicePlane", e1, n), d = new (0, $j4bZM.NineSlicePlane)(f, r, a, u, c);
    return d.applyProps = function(n, t, r) {
        var l = r.image, a = r.texture, i = $7d6602d5c01fbe8e$export$2da27ad86541356b(n, t, $7d6602d5c01fbe8e$var$G(r, $7d6602d5c01fbe8e$var$J));
        return (l || a) && (a !== t.texture && (i = !0), n.texture = $7d6602d5c01fbe8e$var$W("NineSlicePlane", e1, r)), i;
    }, d;
};
function $7d6602d5c01fbe8e$var$ee(e1, n) {
    var t = Object.keys(e1);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e1);
        n && (r = r.filter(function(n) {
            return Object.getOwnPropertyDescriptor(e1, n).enumerable;
        })), t.push.apply(t, r);
    }
    return t;
}
function $7d6602d5c01fbe8e$var$ne(e1) {
    for(var n = 1; n < arguments.length; n++){
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $7d6602d5c01fbe8e$var$ee(Object(t), !0).forEach(function(n) {
            $7d6602d5c01fbe8e$var$_(e1, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(t)) : $7d6602d5c01fbe8e$var$ee(Object(t)).forEach(function(n) {
            Object.defineProperty(e1, n, Object.getOwnPropertyDescriptor(t, n));
        });
    }
    return e1;
}
var $7d6602d5c01fbe8e$var$te = function(e1, n) {
    var t = n.maxSize, r = void 0 === t ? 1500 : t, l = n.batchSize, a = void 0 === l ? 16384 : l, i = n.autoResize, o = void 0 !== i && i, u = $7d6602d5c01fbe8e$var$ne($7d6602d5c01fbe8e$var$ne({}, {
        vertices: !1,
        scale: !0,
        position: !0,
        rotation: !0,
        uvs: !0,
        tint: !0
    }), n.properties || {}), s = $7d6602d5c01fbe8e$var$ne($7d6602d5c01fbe8e$var$ne({}, {
        children: !1,
        texture: !1,
        baseTexture: !1
    }), n.destroyOptions || {}), f = new (0, $aQlRF.ParticleContainer)(r, u, a, o);
    return f.willUnmount = function(e1, n, t) {
        e1.destroy(s);
    }, f;
}, $7d6602d5c01fbe8e$var$re = [
    "image",
    "texture"
], $7d6602d5c01fbe8e$var$le = function(e1, n) {
    var t = new (0, $3uiak.Sprite)($7d6602d5c01fbe8e$var$W("Sprite", e1, n));
    return t.applyProps = function(n, t, r) {
        var l = r.image, a = r.texture, i = $7d6602d5c01fbe8e$export$2da27ad86541356b(n, t, $7d6602d5c01fbe8e$var$G(r, $7d6602d5c01fbe8e$var$re));
        return (a && t.texture !== r.texture || l && t.image !== r.image) && (t.texture !== r.texture && (i = !0), n.texture = $7d6602d5c01fbe8e$var$W("Sprite", e1, r)), i;
    }, t;
}, $7d6602d5c01fbe8e$var$ae = [
    "textures",
    "isPlaying",
    "initialFrame",
    "images"
], $7d6602d5c01fbe8e$var$ie = function(n, t) {
    var r = t.textures, l = t.images, a = t.isPlaying, i = void 0 === a || a, o = t.initialFrame, u = function(n) {
        return n.map(function(n) {
            return $7d6602d5c01fbe8e$var$N(n instanceof (0, $cWOCu.Texture) || (null == n ? void 0 : n.texture), "AnimationSprite texture needs to be an array of `PIXI.Texture` or `{ texture: PIXI.Texture, time:\n                number }`"), n;
        });
    }, s = l ? (0, $4URvW.AnimatedSprite).fromImages(l) : new (0, $4URvW.AnimatedSprite)(u(r));
    return s[i ? "gotoAndPlay" : "gotoAndStop"](o || 0), s.applyProps = function(n, t, r) {
        var l = r.textures, a = r.isPlaying, i = r.initialFrame, o = r.images, c = $7d6602d5c01fbe8e$export$2da27ad86541356b(n, t, $7d6602d5c01fbe8e$var$G(r, $7d6602d5c01fbe8e$var$ae));
        if (o && t.images !== o) {
            for(var f = [], d = 0; d < o.length; ++d)f.push((0, $cWOCu.Texture).from(o[d]));
            n.textures = f, c = !0;
        }
        if (l && t.textures !== l && (n.textures = u(l), c = !0), a !== t.isPlaying || i !== t.initialFrame) {
            var p = "number" == typeof i ? i : s.currentFrame || 0;
            s[a ? "gotoAndPlay" : "gotoAndStop"](p), c = !0;
        }
        return c;
    }, s;
}, $7d6602d5c01fbe8e$var$oe = function(e1, n) {
    var t = n.text, r = void 0 === t ? "" : t, l = n.style, a = void 0 === l ? {} : l, i = n.isSprite, o = new (0, $68KVj.Text)(r, a);
    return i ? (o.updateText(), new (0, $3uiak.Sprite)(o.texture)) : o;
}, $7d6602d5c01fbe8e$var$ue = [
    "tileScale",
    "tilePosition",
    "image",
    "texture"
], $7d6602d5c01fbe8e$var$se = function(e1, n) {
    var t = n.width, r = void 0 === t ? 100 : t, l = n.height, a = void 0 === l ? 100 : l, i = $7d6602d5c01fbe8e$var$W("TilingSprite", e1, n), o = new (0, $jiPZB.TilingSprite)(i, r, a);
    return o.applyProps = function(n, t, r) {
        var l = r.tileScale, a = r.tilePosition, i = r.image, o = r.texture, u = $7d6602d5c01fbe8e$export$2da27ad86541356b(n, t, $7d6602d5c01fbe8e$var$G(r, $7d6602d5c01fbe8e$var$ue));
        if (a) {
            var s, c = $7d6602d5c01fbe8e$var$O(a);
            (s = n.tilePosition).set.apply(s, $7d6602d5c01fbe8e$var$z(c)), u = !$7d6602d5c01fbe8e$var$j($7d6602d5c01fbe8e$var$O(t.tilePosition), c) || u;
        }
        if (l) {
            var f, d = $7d6602d5c01fbe8e$var$O(l);
            (f = n.tileScale).set.apply(f, $7d6602d5c01fbe8e$var$z(d)), u = !$7d6602d5c01fbe8e$var$j($7d6602d5c01fbe8e$var$O(t.tileScale), d) || u;
        }
        return (i || o) && (o !== t.texture && (u = !0), n.texture = $7d6602d5c01fbe8e$var$W("Sprite", e1, r)), u;
    }, o;
}, $7d6602d5c01fbe8e$var$ce = [
    "image",
    "texture"
], $7d6602d5c01fbe8e$var$fe = function(e1, n) {
    var t = $7d6602d5c01fbe8e$var$W("Mesh", e1, n), r = n.vertices, l = n.uvs, a = n.indices, i = n.drawMode, o = void 0 === i ? (0, $lmRm8.DRAW_MODES).TRIANGLES : i, s = new (0, $8C3Kt.SimpleMesh)(t, r, l, a, o);
    return s.applyProps = function(n, t, r) {
        var l = r.image, a = r.texture, i = $7d6602d5c01fbe8e$export$2da27ad86541356b(n, t, $7d6602d5c01fbe8e$var$G(r, $7d6602d5c01fbe8e$var$ce));
        return (l || a) && (a !== t.texture && (i = !0), n.texture = $7d6602d5c01fbe8e$var$W("Mesh", e1, r)), i;
    }, s;
}, $7d6602d5c01fbe8e$var$de = [
    "image",
    "texture"
], $7d6602d5c01fbe8e$var$pe = function(e1, n) {
    var t = $7d6602d5c01fbe8e$var$W("SimpleRope", e1, n), r = n.points, l = new (0, $dFgHQ.SimpleRope)(t, r);
    return l.applyProps = function(n, t, r) {
        var l = r.image, a = r.texture, i = $7d6602d5c01fbe8e$var$G(r, $7d6602d5c01fbe8e$var$de);
        $7d6602d5c01fbe8e$var$N(Array.isArray(r.points), "SimpleRope points needs to be %s", "Array<PIXI.Point>");
        var o = $7d6602d5c01fbe8e$export$2da27ad86541356b(n, t, i);
        return (l || a) && (a !== t.texture && (o = !0), n.texture = $7d6602d5c01fbe8e$var$W("SimpleRope", e1, r)), o;
    }, l;
}, $7d6602d5c01fbe8e$var$me = Object.freeze({
    __proto__: null,
    BitmapText: $7d6602d5c01fbe8e$var$X,
    Container: $7d6602d5c01fbe8e$var$q,
    Graphics: $7d6602d5c01fbe8e$var$K,
    NineSlicePlane: $7d6602d5c01fbe8e$var$Z,
    ParticleContainer: $7d6602d5c01fbe8e$var$te,
    Sprite: $7d6602d5c01fbe8e$var$le,
    Text: $7d6602d5c01fbe8e$var$oe,
    TilingSprite: $7d6602d5c01fbe8e$var$se,
    SimpleMesh: $7d6602d5c01fbe8e$var$fe,
    SimpleRope: $7d6602d5c01fbe8e$var$pe,
    AnimatedSprite: $7d6602d5c01fbe8e$var$ie
});
function $7d6602d5c01fbe8e$var$he(e1, n) {
    var t = Object.keys(e1);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e1);
        n && (r = r.filter(function(n) {
            return Object.getOwnPropertyDescriptor(e1, n).enumerable;
        })), t.push.apply(t, r);
    }
    return t;
}
function $7d6602d5c01fbe8e$var$ge(e1) {
    for(var n = 1; n < arguments.length; n++){
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $7d6602d5c01fbe8e$var$he(Object(t), !0).forEach(function(n) {
            $7d6602d5c01fbe8e$var$_(e1, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(t)) : $7d6602d5c01fbe8e$var$he(Object(t)).forEach(function(n) {
            Object.defineProperty(e1, n, Object.getOwnPropertyDescriptor(t, n));
        });
    }
    return e1;
}
var $7d6602d5c01fbe8e$export$426db7a6155b7a80 = {
    BitmapText: "BitmapText",
    Container: "Container",
    Graphics: "Graphics",
    NineSlicePlane: "NineSlicePlane",
    ParticleContainer: "ParticleContainer",
    Sprite: "Sprite",
    AnimatedSprite: "AnimatedSprite",
    Text: "Text",
    TilingSprite: "TilingSprite",
    SimpleMesh: "SimpleMesh",
    SimpleRope: "SimpleRope"
}, $7d6602d5c01fbe8e$var$ye = Object.keys($7d6602d5c01fbe8e$export$426db7a6155b7a80).reduce(function(e1, n) {
    return $7d6602d5c01fbe8e$var$ge($7d6602d5c01fbe8e$var$ge({}, e1), {}, $7d6602d5c01fbe8e$var$_({}, n, $7d6602d5c01fbe8e$var$me[n]));
}, {}), $7d6602d5c01fbe8e$var$be = {};
function $7d6602d5c01fbe8e$export$2a40992791448fb5(e1, n) {
    return $7d6602d5c01fbe8e$var$N(!!e1, "Expect type to be defined, got `%s`", e1), $7d6602d5c01fbe8e$var$N(!$7d6602d5c01fbe8e$export$426db7a6155b7a80[e1], "Component `%s` could not be created, already exists in default components.", e1), $7d6602d5c01fbe8e$var$be[e1] = n, e1;
}
var $7d6602d5c01fbe8e$var$xe, $7d6602d5c01fbe8e$var$we, $7d6602d5c01fbe8e$var$ke, $7d6602d5c01fbe8e$var$Pe, $7d6602d5c01fbe8e$var$Ee = {}, $7d6602d5c01fbe8e$var$_e = {}, $7d6602d5c01fbe8e$var$Ce = {
    get exports () {
        return $7d6602d5c01fbe8e$var$_e;
    },
    set exports (e){
        $7d6602d5c01fbe8e$var$_e = e;
    }
}, $7d6602d5c01fbe8e$var$ze = {};
function $7d6602d5c01fbe8e$var$Ne() {
    return $7d6602d5c01fbe8e$var$we || ($7d6602d5c01fbe8e$var$we = 1, $7d6602d5c01fbe8e$var$Ce.exports = ($7d6602d5c01fbe8e$var$xe || ($7d6602d5c01fbe8e$var$xe = 1, function(e1) {
        function n(e1, n) {
            var t = e1.length;
            e1.push(n);
            e: for(; 0 < t;){
                var r = t - 1 >>> 1, a = e1[r];
                if (!(0 < l(a, n))) break e;
                e1[r] = n, e1[t] = a, t = r;
            }
        }
        function t(e1) {
            return 0 === e1.length ? null : e1[0];
        }
        function r(e1) {
            if (0 === e1.length) return null;
            var n = e1[0], t = e1.pop();
            if (t !== n) {
                e1[0] = t;
                e: for(var r = 0, a = e1.length, i = a >>> 1; r < i;){
                    var o = 2 * (r + 1) - 1, u = e1[o], s = o + 1, c = e1[s];
                    if (0 > l(u, t)) s < a && 0 > l(c, u) ? (e1[r] = c, e1[s] = t, r = s) : (e1[r] = u, e1[o] = t, r = o);
                    else {
                        if (!(s < a && 0 > l(c, t))) break e;
                        e1[r] = c, e1[s] = t, r = s;
                    }
                }
            }
            return n;
        }
        function l(e1, n) {
            var t = e1.sortIndex - n.sortIndex;
            return 0 !== t ? t : e1.id - n.id;
        }
        if ("object" == typeof performance && "function" == typeof performance.now) {
            var a = performance;
            e1.unstable_now = function() {
                return a.now();
            };
        } else {
            var i = Date, o = i.now();
            e1.unstable_now = function() {
                return i.now() - o;
            };
        }
        var u = [], s = [], c = 1, f = null, d = 3, p = !1, m = !1, h = !1, g = "function" == typeof setTimeout ? setTimeout : null, v = "function" == typeof clearTimeout ? clearTimeout : null, y = "undefined" != typeof setImmediate ? setImmediate : null;
        function b(e1) {
            for(var l = t(s); null !== l;){
                if (null === l.callback) r(s);
                else {
                    if (!(l.startTime <= e1)) break;
                    r(s), l.sortIndex = l.expirationTime, n(u, l);
                }
                l = t(s);
            }
        }
        function S(e1) {
            if (h = !1, b(e1), !m) {
                if (null !== t(u)) m = !0, R(x);
                else {
                    var n = t(s);
                    null !== n && O(S, n.startTime - e1);
                }
            }
        }
        function x(n, l) {
            m = !1, h && (h = !1, v(E), E = -1), p = !0;
            var a = d;
            try {
                for(b(l), f = t(u); null !== f && (!(f.expirationTime > l) || n && !z());){
                    var i = f.callback;
                    if ("function" == typeof i) {
                        f.callback = null, d = f.priorityLevel;
                        var o = i(f.expirationTime <= l);
                        l = e1.unstable_now(), "function" == typeof o ? f.callback = o : f === t(u) && r(u), b(l);
                    } else r(u);
                    f = t(u);
                }
                if (null !== f) var c = !0;
                else {
                    var g = t(s);
                    null !== g && O(S, g.startTime - l), c = !1;
                }
                return c;
            } finally{
                f = null, d = a, p = !1;
            }
        }
        "undefined" != typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
        var w, k = !1, P = null, E = -1, _ = 5, C = -1;
        function z() {
            return !(e1.unstable_now() - C < _);
        }
        function N() {
            if (null !== P) {
                var n = e1.unstable_now();
                C = n;
                var t = !0;
                try {
                    t = P(!0, n);
                } finally{
                    t ? w() : (k = !1, P = null);
                }
            } else k = !1;
        }
        if ("function" == typeof y) w = function() {
            y(N);
        };
        else if ("undefined" != typeof MessageChannel) {
            var I = new MessageChannel, T = I.port2;
            I.port1.onmessage = N, w = function() {
                T.postMessage(null);
            };
        } else w = function() {
            g(N, 0);
        };
        function R(e1) {
            P = e1, k || (k = !0, w());
        }
        function O(n, t) {
            E = g(function() {
                n(e1.unstable_now());
            }, t);
        }
        e1.unstable_IdlePriority = 5, e1.unstable_ImmediatePriority = 1, e1.unstable_LowPriority = 4, e1.unstable_NormalPriority = 3, e1.unstable_Profiling = null, e1.unstable_UserBlockingPriority = 2, e1.unstable_cancelCallback = function(e1) {
            e1.callback = null;
        }, e1.unstable_continueExecution = function() {
            m || p || (m = !0, R(x));
        }, e1.unstable_forceFrameRate = function(e1) {
            0 > e1 || 125 < e1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : _ = 0 < e1 ? Math.floor(1e3 / e1) : 5;
        }, e1.unstable_getCurrentPriorityLevel = function() {
            return d;
        }, e1.unstable_getFirstCallbackNode = function() {
            return t(u);
        }, e1.unstable_next = function(e1) {
            switch(d){
                case 1:
                case 2:
                case 3:
                    var n = 3;
                    break;
                default:
                    n = d;
            }
            var t = d;
            d = n;
            try {
                return e1();
            } finally{
                d = t;
            }
        }, e1.unstable_pauseExecution = function() {}, e1.unstable_requestPaint = function() {}, e1.unstable_runWithPriority = function(e1, n) {
            switch(e1){
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                default:
                    e1 = 3;
            }
            var t = d;
            d = e1;
            try {
                return n();
            } finally{
                d = t;
            }
        }, e1.unstable_scheduleCallback = function(r, l, a) {
            var i = e1.unstable_now();
            switch(a = "object" == typeof a && null !== a && "number" == typeof (a = a.delay) && 0 < a ? i + a : i, r){
                case 1:
                    var o = -1;
                    break;
                case 2:
                    o = 250;
                    break;
                case 5:
                    o = 1073741823;
                    break;
                case 4:
                    o = 1e4;
                    break;
                default:
                    o = 5e3;
            }
            return r = {
                id: c++,
                callback: l,
                priorityLevel: r,
                startTime: a,
                expirationTime: o = a + o,
                sortIndex: -1
            }, a > i ? (r.sortIndex = a, n(s, r), null === t(u) && r === t(s) && (h ? (v(E), E = -1) : h = !0, O(S, a - i))) : (r.sortIndex = o, n(u, r), m || p || (m = !0, R(x))), r;
        }, e1.unstable_shouldYield = z, e1.unstable_wrapCallback = function(e1) {
            var n = d;
            return function() {
                var t = d;
                d = n;
                try {
                    return e1.apply(this, arguments);
                } finally{
                    d = t;
                }
            };
        };
    }($7d6602d5c01fbe8e$var$ze)), $7d6602d5c01fbe8e$var$ze)), $7d6602d5c01fbe8e$var$_e;
}
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $7d6602d5c01fbe8e$var$Ie() {
    return $7d6602d5c01fbe8e$var$Pe || ($7d6602d5c01fbe8e$var$Pe = 1, $7d6602d5c01fbe8e$var$ke = function(e1) {
        var n = {}, t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))), r = $7d6602d5c01fbe8e$var$Ne(), l = Object.assign;
        function a(e1) {
            for(var n = "https://reactjs.org/docs/error-decoder.html?invariant=" + e1, t = 1; t < arguments.length; t++)n += "&args[]=" + encodeURIComponent(arguments[t]);
            return "Minified React error #" + e1 + "; visit " + n + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, o = Symbol.for("react.element"), u = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), p = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), x = Symbol.iterator;
        function w(e1) {
            return null === e1 || "object" != typeof e1 ? null : "function" == typeof (e1 = x && e1[x] || e1["@@iterator"]) ? e1 : null;
        }
        function k(e1) {
            if (null == e1) return null;
            if ("function" == typeof e1) return e1.displayName || e1.name || null;
            if ("string" == typeof e1) return e1;
            switch(e1){
                case s:
                    return "Fragment";
                case u:
                    return "Portal";
                case f:
                    return "Profiler";
                case c:
                    return "StrictMode";
                case h:
                    return "Suspense";
                case v:
                    return "SuspenseList";
            }
            if ("object" == typeof e1) switch(e1.$$typeof){
                case p:
                    return (e1.displayName || "Context") + ".Consumer";
                case d:
                    return (e1._context.displayName || "Context") + ".Provider";
                case m:
                    var n = e1.render;
                    return (e1 = e1.displayName) || (e1 = "" !== (e1 = n.displayName || n.name || "") ? "ForwardRef(" + e1 + ")" : "ForwardRef"), e1;
                case y:
                    return null !== (n = e1.displayName || null) ? n : k(e1.type) || "Memo";
                case b:
                    n = e1._payload, e1 = e1._init;
                    try {
                        return k(e1(n));
                    } catch (e1) {}
            }
            return null;
        }
        function P(e1) {
            var n = e1.type;
            switch(e1.tag){
                case 24:
                    return "Cache";
                case 9:
                    return (n.displayName || "Context") + ".Consumer";
                case 10:
                    return (n._context.displayName || "Context") + ".Provider";
                case 18:
                    return "DehydratedFragment";
                case 11:
                    return e1 = (e1 = n.render).displayName || e1.name || "", n.displayName || ("" !== e1 ? "ForwardRef(" + e1 + ")" : "ForwardRef");
                case 7:
                    return "Fragment";
                case 5:
                    return n;
                case 4:
                    return "Portal";
                case 3:
                    return "Root";
                case 6:
                    return "Text";
                case 16:
                    return k(n);
                case 8:
                    return n === c ? "StrictMode" : "Mode";
                case 22:
                    return "Offscreen";
                case 12:
                    return "Profiler";
                case 21:
                    return "Scope";
                case 13:
                    return "Suspense";
                case 19:
                    return "SuspenseList";
                case 25:
                    return "TracingMarker";
                case 1:
                case 0:
                case 17:
                case 2:
                case 14:
                case 15:
                    if ("function" == typeof n) return n.displayName || n.name || null;
                    if ("string" == typeof n) return n;
            }
            return null;
        }
        function E(e1) {
            var n = e1, t = e1;
            if (e1.alternate) for(; n.return;)n = n.return;
            else {
                e1 = n;
                do 0 != (4098 & (n = e1).flags) && (t = n.return), e1 = n.return;
                while (e1);
            }
            return 3 === n.tag ? t : null;
        }
        function _(e1) {
            if (E(e1) !== e1) throw Error(a(188));
        }
        function C(e1) {
            var n = e1.alternate;
            if (!n) {
                if (null === (n = E(e1))) throw Error(a(188));
                return n !== e1 ? null : e1;
            }
            for(var t = e1, r = n;;){
                var l = t.return;
                if (null === l) break;
                var i = l.alternate;
                if (null === i) {
                    if (null !== (r = l.return)) {
                        t = r;
                        continue;
                    }
                    break;
                }
                if (l.child === i.child) {
                    for(i = l.child; i;){
                        if (i === t) return _(l), e1;
                        if (i === r) return _(l), n;
                        i = i.sibling;
                    }
                    throw Error(a(188));
                }
                if (t.return !== r.return) t = l, r = i;
                else {
                    for(var o = !1, u = l.child; u;){
                        if (u === t) {
                            o = !0, t = l, r = i;
                            break;
                        }
                        if (u === r) {
                            o = !0, r = l, t = i;
                            break;
                        }
                        u = u.sibling;
                    }
                    if (!o) {
                        for(u = i.child; u;){
                            if (u === t) {
                                o = !0, t = i, r = l;
                                break;
                            }
                            if (u === r) {
                                o = !0, r = i, t = l;
                                break;
                            }
                            u = u.sibling;
                        }
                        if (!o) throw Error(a(189));
                    }
                }
                if (t.alternate !== r) throw Error(a(190));
            }
            if (3 !== t.tag) throw Error(a(188));
            return t.stateNode.current === t ? e1 : n;
        }
        function z(e1) {
            return null !== (e1 = C(e1)) ? N(e1) : null;
        }
        function N(e1) {
            if (5 === e1.tag || 6 === e1.tag) return e1;
            for(e1 = e1.child; null !== e1;){
                var n = N(e1);
                if (null !== n) return n;
                e1 = e1.sibling;
            }
            return null;
        }
        function I(e1) {
            if (5 === e1.tag || 6 === e1.tag) return e1;
            for(e1 = e1.child; null !== e1;){
                if (4 !== e1.tag) {
                    var n = I(e1);
                    if (null !== n) return n;
                }
                e1 = e1.sibling;
            }
            return null;
        }
        var T, R = Array.isArray, O = e1.getPublicInstance, j = e1.getRootHostContext, L = e1.getChildHostContext, M = e1.prepareForCommit, D = e1.resetAfterCommit, U = e1.createInstance, F = e1.appendInitialChild, A = e1.finalizeInitialChildren, Q = e1.prepareUpdate, H = e1.shouldSetTextContent, B = e1.createTextInstance, W = e1.scheduleTimeout, $ = e1.cancelTimeout, V = e1.noTimeout, X = e1.isPrimaryRenderer, q = e1.supportsMutation, G = e1.supportsPersistence, Y = e1.supportsHydration, K = e1.getInstanceFromNode, J = e1.preparePortalMount, Z = e1.getCurrentEventPriority, ee = e1.detachDeletedInstance, ne = e1.supportsMicrotasks, te = e1.scheduleMicrotask, re = e1.supportsTestSelectors, le = e1.findFiberRoot, ae = e1.getBoundingRect, ie = e1.getTextContent, oe = e1.isHiddenSubtree, ue = e1.matchAccessibilityRole, se = e1.setFocusIfFocusable, ce = e1.setupIntersectionObserver, fe = e1.appendChild, de = e1.appendChildToContainer, pe = e1.commitTextUpdate, me = e1.commitMount, he = e1.commitUpdate, ge = e1.insertBefore, ve = e1.insertInContainerBefore, ye = e1.removeChild, be = e1.removeChildFromContainer, Se = e1.resetTextContent, xe = e1.hideInstance, we = e1.hideTextInstance, ke = e1.unhideInstance, Pe = e1.unhideTextInstance, Ee = e1.clearContainer, _e = e1.cloneInstance, Ce = e1.createContainerChildSet, ze = e1.appendChildToContainerChildSet, Ie = e1.finalizeContainerChildren, Te = e1.replaceContainerChildren, Re = e1.cloneHiddenInstance, Oe = e1.cloneHiddenTextInstance, je = e1.canHydrateInstance, Le = e1.canHydrateTextInstance, Me = e1.canHydrateSuspenseInstance, De = e1.isSuspenseInstancePending, Ue = e1.isSuspenseInstanceFallback, Fe = e1.getSuspenseInstanceFallbackErrorDetails, Ae = e1.registerSuspenseInstanceRetry, Qe = e1.getNextHydratableSibling, He = e1.getFirstHydratableChild, Be = e1.getFirstHydratableChildWithinContainer, We = e1.getFirstHydratableChildWithinSuspenseInstance, $e = e1.hydrateInstance, Ve = e1.hydrateTextInstance, Xe = e1.hydrateSuspenseInstance, qe = e1.getNextHydratableInstanceAfterSuspenseInstance, Ge = e1.commitHydratedContainer, Ye = e1.commitHydratedSuspenseInstance, Ke = e1.clearSuspenseBoundary, Je = e1.clearSuspenseBoundaryFromContainer, Ze = e1.shouldDeleteUnhydratedTailInstances, en = e1.didNotMatchHydratedContainerTextInstance, nn = e1.didNotMatchHydratedTextInstance;
        function tn(e1) {
            if (void 0 === T) try {
                throw Error();
            } catch (e1) {
                var n = e1.stack.trim().match(/\n( *(at )?)/);
                T = n && n[1] || "";
            }
            return "\n" + T + e1;
        }
        var rn = !1;
        function ln(e1, n) {
            if (!e1 || rn) return "";
            rn = !0;
            var t = Error.prepareStackTrace;
            Error.prepareStackTrace = void 0;
            try {
                if (n) {
                    if (n = function() {
                        throw Error();
                    }, Object.defineProperty(n.prototype, "props", {
                        set: function() {
                            throw Error();
                        }
                    }), "object" == typeof Reflect && Reflect.construct) {
                        try {
                            Reflect.construct(n, []);
                        } catch (e1) {
                            var r = e1;
                        }
                        Reflect.construct(e1, [], n);
                    } else {
                        try {
                            n.call();
                        } catch (e1) {
                            r = e1;
                        }
                        e1.call(n.prototype);
                    }
                } else {
                    try {
                        throw Error();
                    } catch (e1) {
                        r = e1;
                    }
                    e1();
                }
            } catch (n) {
                if (n && r && "string" == typeof n.stack) {
                    for(var l = n.stack.split("\n"), a = r.stack.split("\n"), i = l.length - 1, o = a.length - 1; 1 <= i && 0 <= o && l[i] !== a[o];)o--;
                    for(; 1 <= i && 0 <= o; i--, o--)if (l[i] !== a[o]) {
                        if (1 !== i || 1 !== o) do if (i--, 0 > --o || l[i] !== a[o]) {
                            var u = "\n" + l[i].replace(" at new ", " at ");
                            return e1.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e1.displayName)), u;
                        }
                        while (1 <= i && 0 <= o);
                        break;
                    }
                }
            } finally{
                rn = !1, Error.prepareStackTrace = t;
            }
            return (e1 = e1 ? e1.displayName || e1.name : "") ? tn(e1) : "";
        }
        var an = Object.prototype.hasOwnProperty, on = [], un = -1;
        function sn(e1) {
            return {
                current: e1
            };
        }
        function cn(e1) {
            0 > un || (e1.current = on[un], on[un] = null, un--);
        }
        function fn(e1, n) {
            un++, on[un] = e1.current, e1.current = n;
        }
        var dn = {}, pn = sn(dn), mn = sn(!1), hn = dn;
        function gn(e1, n) {
            var t = e1.type.contextTypes;
            if (!t) return dn;
            var r = e1.stateNode;
            if (r && r.__reactInternalMemoizedUnmaskedChildContext === n) return r.__reactInternalMemoizedMaskedChildContext;
            var l, a = {};
            for(l in t)a[l] = n[l];
            return r && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = n, e1.__reactInternalMemoizedMaskedChildContext = a), a;
        }
        function vn(e1) {
            return null != (e1 = e1.childContextTypes);
        }
        function yn() {
            cn(mn), cn(pn);
        }
        function bn(e1, n, t) {
            if (pn.current !== dn) throw Error(a(168));
            fn(pn, n), fn(mn, t);
        }
        function Sn(e1, n, t) {
            var r = e1.stateNode;
            if (n = n.childContextTypes, "function" != typeof r.getChildContext) return t;
            for(var i in r = r.getChildContext())if (!(i in n)) throw Error(a(108, P(e1) || "Unknown", i));
            return l({}, t, r);
        }
        function xn(e1) {
            return e1 = (e1 = e1.stateNode) && e1.__reactInternalMemoizedMergedChildContext || dn, hn = pn.current, fn(pn, e1), fn(mn, mn.current), !0;
        }
        function wn(e1, n, t) {
            var r = e1.stateNode;
            if (!r) throw Error(a(169));
            t ? (e1 = Sn(e1, n, hn), r.__reactInternalMemoizedMergedChildContext = e1, cn(mn), cn(pn), fn(pn, e1)) : cn(mn), fn(mn, t);
        }
        var kn = Math.clz32 ? Math.clz32 : function(e1) {
            return 0 === (e1 >>>= 0) ? 32 : 31 - (Pn(e1) / En | 0) | 0;
        }, Pn = Math.log, En = Math.LN2;
        var _n = 64, Cn = 4194304;
        function zn(e1) {
            switch(e1 & -e1){
                case 1:
                    return 1;
                case 2:
                    return 2;
                case 4:
                    return 4;
                case 8:
                    return 8;
                case 16:
                    return 16;
                case 32:
                    return 32;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                    return 4194240 & e1;
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    return 130023424 & e1;
                case 134217728:
                    return 134217728;
                case 268435456:
                    return 268435456;
                case 536870912:
                    return 536870912;
                case 1073741824:
                    return 1073741824;
                default:
                    return e1;
            }
        }
        function Nn(e1, n) {
            var t = e1.pendingLanes;
            if (0 === t) return 0;
            var r = 0, l = e1.suspendedLanes, a = e1.pingedLanes, i = 268435455 & t;
            if (0 !== i) {
                var o = i & ~l;
                0 !== o ? r = zn(o) : 0 !== (a &= i) && (r = zn(a));
            } else 0 !== (i = t & ~l) ? r = zn(i) : 0 !== a && (r = zn(a));
            if (0 === r) return 0;
            if (0 !== n && n !== r && 0 == (n & l) && ((l = r & -r) >= (a = n & -n) || 16 === l && 0 != (4194240 & a))) return n;
            if (0 != (4 & r) && (r |= 16 & t), 0 !== (n = e1.entangledLanes)) for(e1 = e1.entanglements, n &= r; 0 < n;)l = 1 << (t = 31 - kn(n)), r |= e1[t], n &= ~l;
            return r;
        }
        function In(e1, n) {
            switch(e1){
                case 1:
                case 2:
                case 4:
                    return n + 250;
                case 8:
                case 16:
                case 32:
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                    return n + 5e3;
                default:
                    return -1;
            }
        }
        function Tn(e1) {
            return 0 !== (e1 = -1073741825 & e1.pendingLanes) ? e1 : 1073741824 & e1 ? 1073741824 : 0;
        }
        function Rn() {
            var e1 = _n;
            return 0 == (4194240 & (_n <<= 1)) && (_n = 64), e1;
        }
        function On(e1) {
            for(var n = [], t = 0; 31 > t; t++)n.push(e1);
            return n;
        }
        function jn(e1, n, t) {
            e1.pendingLanes |= n, 536870912 !== n && (e1.suspendedLanes = 0, e1.pingedLanes = 0), (e1 = e1.eventTimes)[n = 31 - kn(n)] = t;
        }
        function Ln(e1, n) {
            var t = e1.entangledLanes |= n;
            for(e1 = e1.entanglements; t;){
                var r = 31 - kn(t), l = 1 << r;
                l & n | e1[r] & n && (e1[r] |= n), t &= ~l;
            }
        }
        var Mn = 0;
        function Dn(e1) {
            return 1 < (e1 &= -e1) ? 4 < e1 ? 0 != (268435455 & e1) ? 16 : 536870912 : 4 : 1;
        }
        var Un = r.unstable_scheduleCallback, Fn = r.unstable_cancelCallback, An = r.unstable_shouldYield, Qn = r.unstable_requestPaint, Hn = r.unstable_now, Bn = r.unstable_ImmediatePriority, Wn = r.unstable_UserBlockingPriority, $n = r.unstable_NormalPriority, Vn = r.unstable_IdlePriority, Xn = null, qn = null;
        var Gn = "function" == typeof Object.is ? Object.is : function(e1, n) {
            return e1 === n && (0 !== e1 || 1 / e1 == 1 / n) || e1 != e1 && n != n;
        }, Yn = null, Kn = !1, Jn = !1;
        function Zn(e1) {
            null === Yn ? Yn = [
                e1
            ] : Yn.push(e1);
        }
        function et() {
            if (!Jn && null !== Yn) {
                Jn = !0;
                var e1 = 0, n = Mn;
                try {
                    var t = Yn;
                    for(Mn = 1; e1 < t.length; e1++){
                        var r = t[e1];
                        do r = r(!0);
                        while (null !== r);
                    }
                    Yn = null, Kn = !1;
                } catch (n) {
                    throw null !== Yn && (Yn = Yn.slice(e1 + 1)), Un(Bn, et), n;
                } finally{
                    Mn = n, Jn = !1;
                }
            }
            return null;
        }
        var nt = [], tt = 0, rt = null, lt = 0, at = [], it = 0, ot = null, ut = 1, st = "";
        function ct(e1, n) {
            nt[tt++] = lt, nt[tt++] = rt, rt = e1, lt = n;
        }
        function ft(e1, n, t) {
            at[it++] = ut, at[it++] = st, at[it++] = ot, ot = e1;
            var r = ut;
            e1 = st;
            var l = 32 - kn(r) - 1;
            r &= ~(1 << l), t += 1;
            var a = 32 - kn(n) + l;
            if (30 < a) {
                var i = l - l % 5;
                a = (r & (1 << i) - 1).toString(32), r >>= i, l -= i, ut = 1 << 32 - kn(n) + l | t << l | r, st = a + e1;
            } else ut = 1 << a | t << l | r, st = e1;
        }
        function dt(e1) {
            null !== e1.return && (ct(e1, 1), ft(e1, 1, 0));
        }
        function pt(e1) {
            for(; e1 === rt;)rt = nt[--tt], nt[tt] = null, lt = nt[--tt], nt[tt] = null;
            for(; e1 === ot;)ot = at[--it], at[it] = null, st = at[--it], at[it] = null, ut = at[--it], at[it] = null;
        }
        var mt = null, ht = null, gt = !1, vt = !1, yt = null;
        function bt(e1, n) {
            var t = oo(5, null, null, 0);
            t.elementType = "DELETED", t.stateNode = n, t.return = e1, null === (n = e1.deletions) ? (e1.deletions = [
                t
            ], e1.flags |= 16) : n.push(t);
        }
        function St(e1, n) {
            switch(e1.tag){
                case 5:
                    return null !== (n = je(n, e1.type, e1.pendingProps)) && (e1.stateNode = n, mt = e1, ht = He(n), !0);
                case 6:
                    return null !== (n = Le(n, e1.pendingProps)) && (e1.stateNode = n, mt = e1, ht = null, !0);
                case 13:
                    if (null !== (n = Me(n))) {
                        var t = null !== ot ? {
                            id: ut,
                            overflow: st
                        } : null;
                        return e1.memoizedState = {
                            dehydrated: n,
                            treeContext: t,
                            retryLane: 1073741824
                        }, (t = oo(18, null, null, 0)).stateNode = n, t.return = e1, e1.child = t, mt = e1, ht = null, !0;
                    }
                    return !1;
                default:
                    return !1;
            }
        }
        function xt(e1) {
            return 0 != (1 & e1.mode) && 0 == (128 & e1.flags);
        }
        function wt(e1) {
            if (gt) {
                var n = ht;
                if (n) {
                    var t = n;
                    if (!St(e1, n)) {
                        if (xt(e1)) throw Error(a(418));
                        n = Qe(t);
                        var r = mt;
                        n && St(e1, n) ? bt(r, t) : (e1.flags = -4097 & e1.flags | 2, gt = !1, mt = e1);
                    }
                } else {
                    if (xt(e1)) throw Error(a(418));
                    e1.flags = -4097 & e1.flags | 2, gt = !1, mt = e1;
                }
            }
        }
        function kt(e1) {
            for(e1 = e1.return; null !== e1 && 5 !== e1.tag && 3 !== e1.tag && 13 !== e1.tag;)e1 = e1.return;
            mt = e1;
        }
        function Pt(e1) {
            if (!Y || e1 !== mt) return !1;
            if (!gt) return kt(e1), gt = !0, !1;
            if (3 !== e1.tag && (5 !== e1.tag || Ze(e1.type) && !H(e1.type, e1.memoizedProps))) {
                var n = ht;
                if (n) {
                    if (xt(e1)) throw Et(), Error(a(418));
                    for(; n;)bt(e1, n), n = Qe(n);
                }
            }
            if (kt(e1), 13 === e1.tag) {
                if (!Y) throw Error(a(316));
                if (!(e1 = null !== (e1 = e1.memoizedState) ? e1.dehydrated : null)) throw Error(a(317));
                ht = qe(e1);
            } else ht = mt ? Qe(e1.stateNode) : null;
            return !0;
        }
        function Et() {
            for(var e1 = ht; e1;)e1 = Qe(e1);
        }
        function _t() {
            Y && (ht = mt = null, vt = gt = !1);
        }
        function Ct(e1) {
            null === yt ? yt = [
                e1
            ] : yt.push(e1);
        }
        var zt = i.ReactCurrentBatchConfig;
        function Nt(e1, n) {
            if (Gn(e1, n)) return !0;
            if ("object" != typeof e1 || null === e1 || "object" != typeof n || null === n) return !1;
            var t = Object.keys(e1), r = Object.keys(n);
            if (t.length !== r.length) return !1;
            for(r = 0; r < t.length; r++){
                var l = t[r];
                if (!an.call(n, l) || !Gn(e1[l], n[l])) return !1;
            }
            return !0;
        }
        function It(e1) {
            switch(e1.tag){
                case 5:
                    return tn(e1.type);
                case 16:
                    return tn("Lazy");
                case 13:
                    return tn("Suspense");
                case 19:
                    return tn("SuspenseList");
                case 0:
                case 2:
                case 15:
                    return e1 = ln(e1.type, !1);
                case 11:
                    return e1 = ln(e1.type.render, !1);
                case 1:
                    return e1 = ln(e1.type, !0);
                default:
                    return "";
            }
        }
        function Tt(e1, n) {
            if (e1 && e1.defaultProps) {
                for(var t in n = l({}, n), e1 = e1.defaultProps)void 0 === n[t] && (n[t] = e1[t]);
                return n;
            }
            return n;
        }
        var Rt = sn(null), Ot = null, jt = null, Lt = null;
        function Mt() {
            Lt = jt = Ot = null;
        }
        function Dt(e1, n, t) {
            X ? (fn(Rt, n._currentValue), n._currentValue = t) : (fn(Rt, n._currentValue2), n._currentValue2 = t);
        }
        function Ut(e1) {
            var n = Rt.current;
            cn(Rt), X ? e1._currentValue = n : e1._currentValue2 = n;
        }
        function Ft(e1, n, t) {
            for(; null !== e1;){
                var r = e1.alternate;
                if ((e1.childLanes & n) !== n ? (e1.childLanes |= n, null !== r && (r.childLanes |= n)) : null !== r && (r.childLanes & n) !== n && (r.childLanes |= n), e1 === t) break;
                e1 = e1.return;
            }
        }
        function At(e1, n) {
            Ot = e1, Lt = jt = null, null !== (e1 = e1.dependencies) && null !== e1.firstContext && (0 != (e1.lanes & n) && (Ll = !0), e1.firstContext = null);
        }
        function Qt(e1) {
            var n = X ? e1._currentValue : e1._currentValue2;
            if (Lt !== e1) {
                if (e1 = {
                    context: e1,
                    memoizedValue: n,
                    next: null
                }, null === jt) {
                    if (null === Ot) throw Error(a(308));
                    jt = e1, Ot.dependencies = {
                        lanes: 0,
                        firstContext: e1
                    };
                } else jt = jt.next = e1;
            }
            return n;
        }
        var Ht = null;
        function Bt(e1) {
            null === Ht ? Ht = [
                e1
            ] : Ht.push(e1);
        }
        function Wt(e1, n, t, r) {
            var l = n.interleaved;
            return null === l ? (t.next = t, Bt(n)) : (t.next = l.next, l.next = t), n.interleaved = t, $t(e1, r);
        }
        function $t(e1, n) {
            e1.lanes |= n;
            var t = e1.alternate;
            for(null !== t && (t.lanes |= n), t = e1, e1 = e1.return; null !== e1;)e1.childLanes |= n, null !== (t = e1.alternate) && (t.childLanes |= n), t = e1, e1 = e1.return;
            return 3 === t.tag ? t.stateNode : null;
        }
        var Vt = !1;
        function Xt(e1) {
            e1.updateQueue = {
                baseState: e1.memoizedState,
                firstBaseUpdate: null,
                lastBaseUpdate: null,
                shared: {
                    pending: null,
                    interleaved: null,
                    lanes: 0
                },
                effects: null
            };
        }
        function qt(e1, n) {
            e1 = e1.updateQueue, n.updateQueue === e1 && (n.updateQueue = {
                baseState: e1.baseState,
                firstBaseUpdate: e1.firstBaseUpdate,
                lastBaseUpdate: e1.lastBaseUpdate,
                shared: e1.shared,
                effects: e1.effects
            });
        }
        function Gt(e1, n) {
            return {
                eventTime: e1,
                lane: n,
                tag: 0,
                payload: null,
                callback: null,
                next: null
            };
        }
        function Yt(e1, n, t) {
            var r = e1.updateQueue;
            if (null === r) return null;
            if (r = r.shared, 0 != (2 & ri)) {
                var l = r.pending;
                return null === l ? n.next = n : (n.next = l.next, l.next = n), r.pending = n, $t(e1, t);
            }
            return null === (l = r.interleaved) ? (n.next = n, Bt(r)) : (n.next = l.next, l.next = n), r.interleaved = n, $t(e1, t);
        }
        function Kt(e1, n, t) {
            if (null !== (n = n.updateQueue) && (n = n.shared, 0 != (4194240 & t))) {
                var r = n.lanes;
                t |= r &= e1.pendingLanes, n.lanes = t, Ln(e1, t);
            }
        }
        function Jt(e1, n) {
            var t = e1.updateQueue, r = e1.alternate;
            if (null !== r && t === (r = r.updateQueue)) {
                var l = null, a = null;
                if (null !== (t = t.firstBaseUpdate)) {
                    do {
                        var i = {
                            eventTime: t.eventTime,
                            lane: t.lane,
                            tag: t.tag,
                            payload: t.payload,
                            callback: t.callback,
                            next: null
                        };
                        null === a ? l = a = i : a = a.next = i, t = t.next;
                    }while (null !== t);
                    null === a ? l = a = n : a = a.next = n;
                } else l = a = n;
                return t = {
                    baseState: r.baseState,
                    firstBaseUpdate: l,
                    lastBaseUpdate: a,
                    shared: r.shared,
                    effects: r.effects
                }, void (e1.updateQueue = t);
            }
            null === (e1 = t.lastBaseUpdate) ? t.firstBaseUpdate = n : e1.next = n, t.lastBaseUpdate = n;
        }
        function Zt(e1, n, t, r) {
            var a = e1.updateQueue;
            Vt = !1;
            var i = a.firstBaseUpdate, o = a.lastBaseUpdate, u = a.shared.pending;
            if (null !== u) {
                a.shared.pending = null;
                var s = u, c = s.next;
                s.next = null, null === o ? i = c : o.next = c, o = s;
                var f = e1.alternate;
                null !== f && (u = (f = f.updateQueue).lastBaseUpdate) !== o && (null === u ? f.firstBaseUpdate = c : u.next = c, f.lastBaseUpdate = s);
            }
            if (null !== i) {
                var d = a.baseState;
                for(o = 0, f = c = s = null, u = i;;){
                    var p = u.lane, m = u.eventTime;
                    if ((r & p) === p) {
                        null !== f && (f = f.next = {
                            eventTime: m,
                            lane: 0,
                            tag: u.tag,
                            payload: u.payload,
                            callback: u.callback,
                            next: null
                        });
                        e: {
                            var h = e1, g = u;
                            switch(p = n, m = t, g.tag){
                                case 1:
                                    if ("function" == typeof (h = g.payload)) {
                                        d = h.call(m, d, p);
                                        break e;
                                    }
                                    d = h;
                                    break e;
                                case 3:
                                    h.flags = -65537 & h.flags | 128;
                                case 0:
                                    if (null == (p = "function" == typeof (h = g.payload) ? h.call(m, d, p) : h)) break e;
                                    d = l({}, d, p);
                                    break e;
                                case 2:
                                    Vt = !0;
                            }
                        }
                        null !== u.callback && 0 !== u.lane && (e1.flags |= 64, null === (p = a.effects) ? a.effects = [
                            u
                        ] : p.push(u));
                    } else m = {
                        eventTime: m,
                        lane: p,
                        tag: u.tag,
                        payload: u.payload,
                        callback: u.callback,
                        next: null
                    }, null === f ? (c = f = m, s = d) : f = f.next = m, o |= p;
                    if (null === (u = u.next)) {
                        if (null === (u = a.shared.pending)) break;
                        u = (p = u).next, p.next = null, a.lastBaseUpdate = p, a.shared.pending = null;
                    }
                }
                if (null === f && (s = d), a.baseState = s, a.firstBaseUpdate = c, a.lastBaseUpdate = f, null !== (n = a.shared.interleaved)) {
                    a = n;
                    do o |= a.lane, a = a.next;
                    while (a !== n);
                } else null === i && (a.shared.lanes = 0);
                fi |= o, e1.lanes = o, e1.memoizedState = d;
            }
        }
        function er(e1, n, t) {
            if (e1 = n.effects, n.effects = null, null !== e1) for(n = 0; n < e1.length; n++){
                var r = e1[n], l = r.callback;
                if (null !== l) {
                    if (r.callback = null, r = t, "function" != typeof l) throw Error(a(191, l));
                    l.call(r);
                }
            }
        }
        var nr = (new t.Component).refs;
        function tr(e1, n, t, r) {
            t = null == (t = t(r, n = e1.memoizedState)) ? n : l({}, n, t), e1.memoizedState = t, 0 === e1.lanes && (e1.updateQueue.baseState = t);
        }
        var rr = {
            isMounted: function(e1) {
                return !!(e1 = e1._reactInternals) && E(e1) === e1;
            },
            enqueueSetState: function(e1, n, t) {
                e1 = e1._reactInternals;
                var r = Ti(), l = Ri(e1), a = Gt(r, l);
                a.payload = n, null != t && (a.callback = t), null !== (n = Yt(e1, a, l)) && (Oi(n, e1, l, r), Kt(n, e1, l));
            },
            enqueueReplaceState: function(e1, n, t) {
                e1 = e1._reactInternals;
                var r = Ti(), l = Ri(e1), a = Gt(r, l);
                a.tag = 1, a.payload = n, null != t && (a.callback = t), null !== (n = Yt(e1, a, l)) && (Oi(n, e1, l, r), Kt(n, e1, l));
            },
            enqueueForceUpdate: function(e1, n) {
                e1 = e1._reactInternals;
                var t = Ti(), r = Ri(e1), l = Gt(t, r);
                l.tag = 2, null != n && (l.callback = n), null !== (n = Yt(e1, l, r)) && (Oi(n, e1, r, t), Kt(n, e1, r));
            }
        };
        function lr(e1, n, t, r, l, a, i) {
            return "function" == typeof (e1 = e1.stateNode).shouldComponentUpdate ? e1.shouldComponentUpdate(r, a, i) : !n.prototype || !n.prototype.isPureReactComponent || !Nt(t, r) || !Nt(l, a);
        }
        function ar(e1, n, t) {
            var r = !1, l = dn, a = n.contextType;
            return "object" == typeof a && null !== a ? a = Qt(a) : (l = vn(n) ? hn : pn.current, a = (r = null != (r = n.contextTypes)) ? gn(e1, l) : dn), n = new n(t, a), e1.memoizedState = null !== n.state && void 0 !== n.state ? n.state : null, n.updater = rr, e1.stateNode = n, n._reactInternals = e1, r && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = l, e1.__reactInternalMemoizedMaskedChildContext = a), n;
        }
        function ir(e1, n, t, r) {
            e1 = n.state, "function" == typeof n.componentWillReceiveProps && n.componentWillReceiveProps(t, r), "function" == typeof n.UNSAFE_componentWillReceiveProps && n.UNSAFE_componentWillReceiveProps(t, r), n.state !== e1 && rr.enqueueReplaceState(n, n.state, null);
        }
        function or(e1, n, t, r) {
            var l = e1.stateNode;
            l.props = t, l.state = e1.memoizedState, l.refs = nr, Xt(e1);
            var a = n.contextType;
            "object" == typeof a && null !== a ? l.context = Qt(a) : (a = vn(n) ? hn : pn.current, l.context = gn(e1, a)), l.state = e1.memoizedState, "function" == typeof (a = n.getDerivedStateFromProps) && (tr(e1, n, a, t), l.state = e1.memoizedState), "function" == typeof n.getDerivedStateFromProps || "function" == typeof l.getSnapshotBeforeUpdate || "function" != typeof l.UNSAFE_componentWillMount && "function" != typeof l.componentWillMount || (n = l.state, "function" == typeof l.componentWillMount && l.componentWillMount(), "function" == typeof l.UNSAFE_componentWillMount && l.UNSAFE_componentWillMount(), n !== l.state && rr.enqueueReplaceState(l, l.state, null), Zt(e1, t, l, r), l.state = e1.memoizedState), "function" == typeof l.componentDidMount && (e1.flags |= 4194308);
        }
        function ur(e1, n, t) {
            if (null !== (e1 = t.ref) && "function" != typeof e1 && "object" != typeof e1) {
                if (t._owner) {
                    if (t = t._owner) {
                        if (1 !== t.tag) throw Error(a(309));
                        var r = t.stateNode;
                    }
                    if (!r) throw Error(a(147, e1));
                    var l = r, i = "" + e1;
                    return null !== n && null !== n.ref && "function" == typeof n.ref && n.ref._stringRef === i ? n.ref : (n = function(e1) {
                        var n = l.refs;
                        n === nr && (n = l.refs = {}), null === e1 ? delete n[i] : n[i] = e1;
                    }, n._stringRef = i, n);
                }
                if ("string" != typeof e1) throw Error(a(284));
                if (!t._owner) throw Error(a(290, e1));
            }
            return e1;
        }
        function sr(e1, n) {
            throw e1 = Object.prototype.toString.call(n), Error(a(31, "[object Object]" === e1 ? "object with keys {" + Object.keys(n).join(", ") + "}" : e1));
        }
        function cr(e1) {
            return (0, e1._init)(e1._payload);
        }
        function fr(e1) {
            function n(n, t) {
                if (e1) {
                    var r = n.deletions;
                    null === r ? (n.deletions = [
                        t
                    ], n.flags |= 16) : r.push(t);
                }
            }
            function t(t, r) {
                if (!e1) return null;
                for(; null !== r;)n(t, r), r = r.sibling;
                return null;
            }
            function r(e1, n) {
                for(e1 = new Map; null !== n;)null !== n.key ? e1.set(n.key, n) : e1.set(n.index, n), n = n.sibling;
                return e1;
            }
            function l(e1, n) {
                return (e1 = so(e1, n)).index = 0, e1.sibling = null, e1;
            }
            function i(n, t, r) {
                return n.index = r, e1 ? null !== (r = n.alternate) ? (r = r.index) < t ? (n.flags |= 2, t) : r : (n.flags |= 2, t) : (n.flags |= 1048576, t);
            }
            function c(n) {
                return e1 && null === n.alternate && (n.flags |= 2), n;
            }
            function f(e1, n, t, r) {
                return null === n || 6 !== n.tag ? ((n = mo(t, e1.mode, r)).return = e1, n) : ((n = l(n, t)).return = e1, n);
            }
            function d(e1, n, t, r) {
                var a = t.type;
                return a === s ? m(e1, n, t.props.children, r, t.key) : null !== n && (n.elementType === a || "object" == typeof a && null !== a && a.$$typeof === b && cr(a) === n.type) ? ((r = l(n, t.props)).ref = ur(e1, n, t), r.return = e1, r) : ((r = co(t.type, t.key, t.props, null, e1.mode, r)).ref = ur(e1, n, t), r.return = e1, r);
            }
            function p(e1, n, t, r) {
                return null === n || 4 !== n.tag || n.stateNode.containerInfo !== t.containerInfo || n.stateNode.implementation !== t.implementation ? ((n = ho(t, e1.mode, r)).return = e1, n) : ((n = l(n, t.children || [])).return = e1, n);
            }
            function m(e1, n, t, r, a) {
                return null === n || 7 !== n.tag ? ((n = fo(t, e1.mode, r, a)).return = e1, n) : ((n = l(n, t)).return = e1, n);
            }
            function h(e1, n, t) {
                if ("string" == typeof n && "" !== n || "number" == typeof n) return (n = mo("" + n, e1.mode, t)).return = e1, n;
                if ("object" == typeof n && null !== n) {
                    switch(n.$$typeof){
                        case o:
                            return (t = co(n.type, n.key, n.props, null, e1.mode, t)).ref = ur(e1, null, n), t.return = e1, t;
                        case u:
                            return (n = ho(n, e1.mode, t)).return = e1, n;
                        case b:
                            return h(e1, (0, n._init)(n._payload), t);
                    }
                    if (R(n) || w(n)) return (n = fo(n, e1.mode, t, null)).return = e1, n;
                    sr(e1, n);
                }
                return null;
            }
            function g(e1, n, t, r) {
                var l = null !== n ? n.key : null;
                if ("string" == typeof t && "" !== t || "number" == typeof t) return null !== l ? null : f(e1, n, "" + t, r);
                if ("object" == typeof t && null !== t) {
                    switch(t.$$typeof){
                        case o:
                            return t.key === l ? d(e1, n, t, r) : null;
                        case u:
                            return t.key === l ? p(e1, n, t, r) : null;
                        case b:
                            return g(e1, n, (l = t._init)(t._payload), r);
                    }
                    if (R(t) || w(t)) return null !== l ? null : m(e1, n, t, r, null);
                    sr(e1, t);
                }
                return null;
            }
            function v(e1, n, t, r, l) {
                if ("string" == typeof r && "" !== r || "number" == typeof r) return f(n, e1 = e1.get(t) || null, "" + r, l);
                if ("object" == typeof r && null !== r) {
                    switch(r.$$typeof){
                        case o:
                            return d(n, e1 = e1.get(null === r.key ? t : r.key) || null, r, l);
                        case u:
                            return p(n, e1 = e1.get(null === r.key ? t : r.key) || null, r, l);
                        case b:
                            return v(e1, n, t, (0, r._init)(r._payload), l);
                    }
                    if (R(r) || w(r)) return m(n, e1 = e1.get(t) || null, r, l, null);
                    sr(n, r);
                }
                return null;
            }
            function y(l, a, o, u) {
                for(var s = null, c = null, f = a, d = a = 0, p = null; null !== f && d < o.length; d++){
                    f.index > d ? (p = f, f = null) : p = f.sibling;
                    var m = g(l, f, o[d], u);
                    if (null === m) {
                        null === f && (f = p);
                        break;
                    }
                    e1 && f && null === m.alternate && n(l, f), a = i(m, a, d), null === c ? s = m : c.sibling = m, c = m, f = p;
                }
                if (d === o.length) return t(l, f), gt && ct(l, d), s;
                if (null === f) {
                    for(; d < o.length; d++)null !== (f = h(l, o[d], u)) && (a = i(f, a, d), null === c ? s = f : c.sibling = f, c = f);
                    return gt && ct(l, d), s;
                }
                for(f = r(l, f); d < o.length; d++)null !== (p = v(f, l, d, o[d], u)) && (e1 && null !== p.alternate && f.delete(null === p.key ? d : p.key), a = i(p, a, d), null === c ? s = p : c.sibling = p, c = p);
                return e1 && f.forEach(function(e1) {
                    return n(l, e1);
                }), gt && ct(l, d), s;
            }
            function S(l, o, u, s) {
                var c = w(u);
                if ("function" != typeof c) throw Error(a(150));
                if (null == (u = c.call(u))) throw Error(a(151));
                for(var f = c = null, d = o, p = o = 0, m = null, y = u.next(); null !== d && !y.done; p++, y = u.next()){
                    d.index > p ? (m = d, d = null) : m = d.sibling;
                    var b = g(l, d, y.value, s);
                    if (null === b) {
                        null === d && (d = m);
                        break;
                    }
                    e1 && d && null === b.alternate && n(l, d), o = i(b, o, p), null === f ? c = b : f.sibling = b, f = b, d = m;
                }
                if (y.done) return t(l, d), gt && ct(l, p), c;
                if (null === d) {
                    for(; !y.done; p++, y = u.next())null !== (y = h(l, y.value, s)) && (o = i(y, o, p), null === f ? c = y : f.sibling = y, f = y);
                    return gt && ct(l, p), c;
                }
                for(d = r(l, d); !y.done; p++, y = u.next())null !== (y = v(d, l, p, y.value, s)) && (e1 && null !== y.alternate && d.delete(null === y.key ? p : y.key), o = i(y, o, p), null === f ? c = y : f.sibling = y, f = y);
                return e1 && d.forEach(function(e1) {
                    return n(l, e1);
                }), gt && ct(l, p), c;
            }
            return function e1(r, a, i, f) {
                if ("object" == typeof i && null !== i && i.type === s && null === i.key && (i = i.props.children), "object" == typeof i && null !== i) {
                    switch(i.$$typeof){
                        case o:
                            e: {
                                for(var d = i.key, p = a; null !== p;){
                                    if (p.key === d) {
                                        if ((d = i.type) === s) {
                                            if (7 === p.tag) {
                                                t(r, p.sibling), (a = l(p, i.props.children)).return = r, r = a;
                                                break e;
                                            }
                                        } else if (p.elementType === d || "object" == typeof d && null !== d && d.$$typeof === b && cr(d) === p.type) {
                                            t(r, p.sibling), (a = l(p, i.props)).ref = ur(r, p, i), a.return = r, r = a;
                                            break e;
                                        }
                                        t(r, p);
                                        break;
                                    }
                                    n(r, p), p = p.sibling;
                                }
                                i.type === s ? ((a = fo(i.props.children, r.mode, f, i.key)).return = r, r = a) : ((f = co(i.type, i.key, i.props, null, r.mode, f)).ref = ur(r, a, i), f.return = r, r = f);
                            }
                            return c(r);
                        case u:
                            e: {
                                for(p = i.key; null !== a;){
                                    if (a.key === p) {
                                        if (4 === a.tag && a.stateNode.containerInfo === i.containerInfo && a.stateNode.implementation === i.implementation) {
                                            t(r, a.sibling), (a = l(a, i.children || [])).return = r, r = a;
                                            break e;
                                        }
                                        t(r, a);
                                        break;
                                    }
                                    n(r, a), a = a.sibling;
                                }
                                (a = ho(i, r.mode, f)).return = r, r = a;
                            }
                            return c(r);
                        case b:
                            return e1(r, a, (p = i._init)(i._payload), f);
                    }
                    if (R(i)) return y(r, a, i, f);
                    if (w(i)) return S(r, a, i, f);
                    sr(r, i);
                }
                return "string" == typeof i && "" !== i || "number" == typeof i ? (i = "" + i, null !== a && 6 === a.tag ? (t(r, a.sibling), (a = l(a, i)).return = r, r = a) : (t(r, a), (a = mo(i, r.mode, f)).return = r, r = a), c(r)) : t(r, a);
            };
        }
        var dr = fr(!0), pr = fr(!1), mr = {}, hr = sn(mr), gr = sn(mr), vr = sn(mr);
        function yr(e1) {
            if (e1 === mr) throw Error(a(174));
            return e1;
        }
        function br(e1, n) {
            fn(vr, n), fn(gr, e1), fn(hr, mr), e1 = j(n), cn(hr), fn(hr, e1);
        }
        function Sr() {
            cn(hr), cn(gr), cn(vr);
        }
        function xr(e1) {
            var n = yr(vr.current), t = yr(hr.current);
            t !== (n = L(t, e1.type, n)) && (fn(gr, e1), fn(hr, n));
        }
        function wr(e1) {
            gr.current === e1 && (cn(hr), cn(gr));
        }
        var kr = sn(0);
        function Pr(e1) {
            for(var n = e1; null !== n;){
                if (13 === n.tag) {
                    var t = n.memoizedState;
                    if (null !== t && (null === (t = t.dehydrated) || De(t) || Ue(t))) return n;
                } else if (19 === n.tag && void 0 !== n.memoizedProps.revealOrder) {
                    if (0 != (128 & n.flags)) return n;
                } else if (null !== n.child) {
                    n.child.return = n, n = n.child;
                    continue;
                }
                if (n === e1) break;
                for(; null === n.sibling;){
                    if (null === n.return || n.return === e1) return null;
                    n = n.return;
                }
                n.sibling.return = n.return, n = n.sibling;
            }
            return null;
        }
        var Er = [];
        function _r() {
            for(var e1 = 0; e1 < Er.length; e1++){
                var n = Er[e1];
                X ? n._workInProgressVersionPrimary = null : n._workInProgressVersionSecondary = null;
            }
            Er.length = 0;
        }
        var Cr = i.ReactCurrentDispatcher, zr = i.ReactCurrentBatchConfig, Nr = 0, Ir = null, Tr = null, Rr = null, Or = !1, jr = !1, Lr = 0, Mr = 0;
        function Dr() {
            throw Error(a(321));
        }
        function Ur(e1, n) {
            if (null === n) return !1;
            for(var t = 0; t < n.length && t < e1.length; t++)if (!Gn(e1[t], n[t])) return !1;
            return !0;
        }
        function Fr(e1, n, t, r, l, i) {
            if (Nr = i, Ir = n, n.memoizedState = null, n.updateQueue = null, n.lanes = 0, Cr.current = null === e1 || null === e1.memoizedState ? wl : kl, e1 = t(r, l), jr) {
                i = 0;
                do {
                    if (jr = !1, Lr = 0, 25 <= i) throw Error(a(301));
                    i += 1, Rr = Tr = null, n.updateQueue = null, Cr.current = Pl, e1 = t(r, l);
                }while (jr);
            }
            if (Cr.current = xl, n = null !== Tr && null !== Tr.next, Nr = 0, Rr = Tr = Ir = null, Or = !1, n) throw Error(a(300));
            return e1;
        }
        function Ar() {
            var e1 = 0 !== Lr;
            return Lr = 0, e1;
        }
        function Qr() {
            var e1 = {
                memoizedState: null,
                baseState: null,
                baseQueue: null,
                queue: null,
                next: null
            };
            return null === Rr ? Ir.memoizedState = Rr = e1 : Rr = Rr.next = e1, Rr;
        }
        function Hr() {
            if (null === Tr) {
                var e1 = Ir.alternate;
                e1 = null !== e1 ? e1.memoizedState : null;
            } else e1 = Tr.next;
            var n = null === Rr ? Ir.memoizedState : Rr.next;
            if (null !== n) Rr = n, Tr = e1;
            else {
                if (null === e1) throw Error(a(310));
                e1 = {
                    memoizedState: (Tr = e1).memoizedState,
                    baseState: Tr.baseState,
                    baseQueue: Tr.baseQueue,
                    queue: Tr.queue,
                    next: null
                }, null === Rr ? Ir.memoizedState = Rr = e1 : Rr = Rr.next = e1;
            }
            return Rr;
        }
        function Br(e1, n) {
            return "function" == typeof n ? n(e1) : n;
        }
        function Wr(e1) {
            var n = Hr(), t = n.queue;
            if (null === t) throw Error(a(311));
            t.lastRenderedReducer = e1;
            var r = Tr, l = r.baseQueue, i = t.pending;
            if (null !== i) {
                if (null !== l) {
                    var o = l.next;
                    l.next = i.next, i.next = o;
                }
                r.baseQueue = l = i, t.pending = null;
            }
            if (null !== l) {
                i = l.next, r = r.baseState;
                var u = o = null, s = null, c = i;
                do {
                    var f = c.lane;
                    if ((Nr & f) === f) null !== s && (s = s.next = {
                        lane: 0,
                        action: c.action,
                        hasEagerState: c.hasEagerState,
                        eagerState: c.eagerState,
                        next: null
                    }), r = c.hasEagerState ? c.eagerState : e1(r, c.action);
                    else {
                        var d = {
                            lane: f,
                            action: c.action,
                            hasEagerState: c.hasEagerState,
                            eagerState: c.eagerState,
                            next: null
                        };
                        null === s ? (u = s = d, o = r) : s = s.next = d, Ir.lanes |= f, fi |= f;
                    }
                    c = c.next;
                }while (null !== c && c !== i);
                null === s ? o = r : s.next = u, Gn(r, n.memoizedState) || (Ll = !0), n.memoizedState = r, n.baseState = o, n.baseQueue = s, t.lastRenderedState = r;
            }
            if (null !== (e1 = t.interleaved)) {
                l = e1;
                do i = l.lane, Ir.lanes |= i, fi |= i, l = l.next;
                while (l !== e1);
            } else null === l && (t.lanes = 0);
            return [
                n.memoizedState,
                t.dispatch
            ];
        }
        function $r(e1) {
            var n = Hr(), t = n.queue;
            if (null === t) throw Error(a(311));
            t.lastRenderedReducer = e1;
            var r = t.dispatch, l = t.pending, i = n.memoizedState;
            if (null !== l) {
                t.pending = null;
                var o = l = l.next;
                do i = e1(i, o.action), o = o.next;
                while (o !== l);
                Gn(i, n.memoizedState) || (Ll = !0), n.memoizedState = i, null === n.baseQueue && (n.baseState = i), t.lastRenderedState = i;
            }
            return [
                i,
                r
            ];
        }
        function Vr() {}
        function Xr(e1, n) {
            var t = Ir, r = Hr(), l = n(), i = !Gn(r.memoizedState, l);
            if (i && (r.memoizedState = l, Ll = !0), r = r.queue, al(Yr.bind(null, t, r, e1), [
                e1
            ]), r.getSnapshot !== n || i || null !== Rr && 1 & Rr.memoizedState.tag) {
                if (t.flags |= 2048, el(9, Gr.bind(null, t, r, l, n), void 0, null), null === li) throw Error(a(349));
                0 != (30 & Nr) || qr(t, n, l);
            }
            return l;
        }
        function qr(e1, n, t) {
            e1.flags |= 16384, e1 = {
                getSnapshot: n,
                value: t
            }, null === (n = Ir.updateQueue) ? (n = {
                lastEffect: null,
                stores: null
            }, Ir.updateQueue = n, n.stores = [
                e1
            ]) : null === (t = n.stores) ? n.stores = [
                e1
            ] : t.push(e1);
        }
        function Gr(e1, n, t, r) {
            n.value = t, n.getSnapshot = r, Kr(n) && Jr(e1);
        }
        function Yr(e1, n, t) {
            return t(function() {
                Kr(n) && Jr(e1);
            });
        }
        function Kr(e1) {
            var n = e1.getSnapshot;
            e1 = e1.value;
            try {
                var t = n();
                return !Gn(e1, t);
            } catch (e1) {
                return !0;
            }
        }
        function Jr(e1) {
            var n = $t(e1, 1);
            null !== n && Oi(n, e1, 1, -1);
        }
        function Zr(e1) {
            var n = Qr();
            return "function" == typeof e1 && (e1 = e1()), n.memoizedState = n.baseState = e1, e1 = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: Br,
                lastRenderedState: e1
            }, n.queue = e1, e1 = e1.dispatch = vl.bind(null, Ir, e1), [
                n.memoizedState,
                e1
            ];
        }
        function el(e1, n, t, r) {
            return e1 = {
                tag: e1,
                create: n,
                destroy: t,
                deps: r,
                next: null
            }, null === (n = Ir.updateQueue) ? (n = {
                lastEffect: null,
                stores: null
            }, Ir.updateQueue = n, n.lastEffect = e1.next = e1) : null === (t = n.lastEffect) ? n.lastEffect = e1.next = e1 : (r = t.next, t.next = e1, e1.next = r, n.lastEffect = e1), e1;
        }
        function nl() {
            return Hr().memoizedState;
        }
        function tl(e1, n, t, r) {
            var l = Qr();
            Ir.flags |= e1, l.memoizedState = el(1 | n, t, void 0, void 0 === r ? null : r);
        }
        function rl(e1, n, t, r) {
            var l = Hr();
            r = void 0 === r ? null : r;
            var a = void 0;
            if (null !== Tr) {
                var i = Tr.memoizedState;
                if (a = i.destroy, null !== r && Ur(r, i.deps)) return void (l.memoizedState = el(n, t, a, r));
            }
            Ir.flags |= e1, l.memoizedState = el(1 | n, t, a, r);
        }
        function ll(e1, n) {
            return tl(8390656, 8, e1, n);
        }
        function al(e1, n) {
            return rl(2048, 8, e1, n);
        }
        function il(e1, n) {
            return rl(4, 2, e1, n);
        }
        function ol(e1, n) {
            return rl(4, 4, e1, n);
        }
        function ul(e1, n) {
            return "function" == typeof n ? (e1 = e1(), n(e1), function() {
                n(null);
            }) : null != n ? (e1 = e1(), n.current = e1, function() {
                n.current = null;
            }) : void 0;
        }
        function sl(e1, n, t) {
            return t = null != t ? t.concat([
                e1
            ]) : null, rl(4, 4, ul.bind(null, n, e1), t);
        }
        function cl() {}
        function fl(e1, n) {
            var t = Hr();
            n = void 0 === n ? null : n;
            var r = t.memoizedState;
            return null !== r && null !== n && Ur(n, r[1]) ? r[0] : (t.memoizedState = [
                e1,
                n
            ], e1);
        }
        function dl(e1, n) {
            var t = Hr();
            n = void 0 === n ? null : n;
            var r = t.memoizedState;
            return null !== r && null !== n && Ur(n, r[1]) ? r[0] : (e1 = e1(), t.memoizedState = [
                e1,
                n
            ], e1);
        }
        function pl(e1, n, t) {
            return 0 == (21 & Nr) ? (e1.baseState && (e1.baseState = !1, Ll = !0), e1.memoizedState = t) : (Gn(t, n) || (t = Rn(), Ir.lanes |= t, fi |= t, e1.baseState = !0), n);
        }
        function ml(e1, n) {
            var t = Mn;
            Mn = 0 !== t && 4 > t ? t : 4, e1(!0);
            var r = zr.transition;
            zr.transition = {};
            try {
                e1(!1), n();
            } finally{
                Mn = t, zr.transition = r;
            }
        }
        function hl() {
            return Hr().memoizedState;
        }
        function gl(e1, n, t) {
            var r = Ri(e1);
            if (t = {
                lane: r,
                action: t,
                hasEagerState: !1,
                eagerState: null,
                next: null
            }, yl(e1)) bl(n, t);
            else if (null !== (t = Wt(e1, n, t, r))) Oi(t, e1, r, Ti()), Sl(t, n, r);
        }
        function vl(e1, n, t) {
            var r = Ri(e1), l = {
                lane: r,
                action: t,
                hasEagerState: !1,
                eagerState: null,
                next: null
            };
            if (yl(e1)) bl(n, l);
            else {
                var a = e1.alternate;
                if (0 === e1.lanes && (null === a || 0 === a.lanes) && null !== (a = n.lastRenderedReducer)) try {
                    var i = n.lastRenderedState, o = a(i, t);
                    if (l.hasEagerState = !0, l.eagerState = o, Gn(o, i)) {
                        var u = n.interleaved;
                        return null === u ? (l.next = l, Bt(n)) : (l.next = u.next, u.next = l), void (n.interleaved = l);
                    }
                } catch (e1) {}
                null !== (t = Wt(e1, n, l, r)) && (Oi(t, e1, r, l = Ti()), Sl(t, n, r));
            }
        }
        function yl(e1) {
            var n = e1.alternate;
            return e1 === Ir || null !== n && n === Ir;
        }
        function bl(e1, n) {
            jr = Or = !0;
            var t = e1.pending;
            null === t ? n.next = n : (n.next = t.next, t.next = n), e1.pending = n;
        }
        function Sl(e1, n, t) {
            if (0 != (4194240 & t)) {
                var r = n.lanes;
                t |= r &= e1.pendingLanes, n.lanes = t, Ln(e1, t);
            }
        }
        var xl = {
            readContext: Qt,
            useCallback: Dr,
            useContext: Dr,
            useEffect: Dr,
            useImperativeHandle: Dr,
            useInsertionEffect: Dr,
            useLayoutEffect: Dr,
            useMemo: Dr,
            useReducer: Dr,
            useRef: Dr,
            useState: Dr,
            useDebugValue: Dr,
            useDeferredValue: Dr,
            useTransition: Dr,
            useMutableSource: Dr,
            useSyncExternalStore: Dr,
            useId: Dr,
            unstable_isNewReconciler: !1
        }, wl = {
            readContext: Qt,
            useCallback: function(e1, n) {
                return Qr().memoizedState = [
                    e1,
                    void 0 === n ? null : n
                ], e1;
            },
            useContext: Qt,
            useEffect: ll,
            useImperativeHandle: function(e1, n, t) {
                return t = null != t ? t.concat([
                    e1
                ]) : null, tl(4194308, 4, ul.bind(null, n, e1), t);
            },
            useLayoutEffect: function(e1, n) {
                return tl(4194308, 4, e1, n);
            },
            useInsertionEffect: function(e1, n) {
                return tl(4, 2, e1, n);
            },
            useMemo: function(e1, n) {
                var t = Qr();
                return n = void 0 === n ? null : n, e1 = e1(), t.memoizedState = [
                    e1,
                    n
                ], e1;
            },
            useReducer: function(e1, n, t) {
                var r = Qr();
                return n = void 0 !== t ? t(n) : n, r.memoizedState = r.baseState = n, e1 = {
                    pending: null,
                    interleaved: null,
                    lanes: 0,
                    dispatch: null,
                    lastRenderedReducer: e1,
                    lastRenderedState: n
                }, r.queue = e1, e1 = e1.dispatch = gl.bind(null, Ir, e1), [
                    r.memoizedState,
                    e1
                ];
            },
            useRef: function(e1) {
                return e1 = {
                    current: e1
                }, Qr().memoizedState = e1;
            },
            useState: Zr,
            useDebugValue: cl,
            useDeferredValue: function(e1) {
                return Qr().memoizedState = e1;
            },
            useTransition: function() {
                var e1 = Zr(!1), n = e1[0];
                return e1 = ml.bind(null, e1[1]), Qr().memoizedState = e1, [
                    n,
                    e1
                ];
            },
            useMutableSource: function() {},
            useSyncExternalStore: function(e1, n, t) {
                var r = Ir, l = Qr();
                if (gt) {
                    if (void 0 === t) throw Error(a(407));
                    t = t();
                } else {
                    if (t = n(), null === li) throw Error(a(349));
                    0 != (30 & Nr) || qr(r, n, t);
                }
                l.memoizedState = t;
                var i = {
                    value: t,
                    getSnapshot: n
                };
                return l.queue = i, ll(Yr.bind(null, r, i, e1), [
                    e1
                ]), r.flags |= 2048, el(9, Gr.bind(null, r, i, t, n), void 0, null), t;
            },
            useId: function() {
                var e1 = Qr(), n = li.identifierPrefix;
                if (gt) {
                    var t = st;
                    n = ":" + n + "R" + (t = (ut & ~(1 << 32 - kn(ut) - 1)).toString(32) + t), 0 < (t = Lr++) && (n += "H" + t.toString(32)), n += ":";
                } else n = ":" + n + "r" + (t = Mr++).toString(32) + ":";
                return e1.memoizedState = n;
            },
            unstable_isNewReconciler: !1
        }, kl = {
            readContext: Qt,
            useCallback: fl,
            useContext: Qt,
            useEffect: al,
            useImperativeHandle: sl,
            useInsertionEffect: il,
            useLayoutEffect: ol,
            useMemo: dl,
            useReducer: Wr,
            useRef: nl,
            useState: function() {
                return Wr(Br);
            },
            useDebugValue: cl,
            useDeferredValue: function(e1) {
                return pl(Hr(), Tr.memoizedState, e1);
            },
            useTransition: function() {
                return [
                    Wr(Br)[0],
                    Hr().memoizedState
                ];
            },
            useMutableSource: Vr,
            useSyncExternalStore: Xr,
            useId: hl,
            unstable_isNewReconciler: !1
        }, Pl = {
            readContext: Qt,
            useCallback: fl,
            useContext: Qt,
            useEffect: al,
            useImperativeHandle: sl,
            useInsertionEffect: il,
            useLayoutEffect: ol,
            useMemo: dl,
            useReducer: $r,
            useRef: nl,
            useState: function() {
                return $r(Br);
            },
            useDebugValue: cl,
            useDeferredValue: function(e1) {
                var n = Hr();
                return null === Tr ? n.memoizedState = e1 : pl(n, Tr.memoizedState, e1);
            },
            useTransition: function() {
                return [
                    $r(Br)[0],
                    Hr().memoizedState
                ];
            },
            useMutableSource: Vr,
            useSyncExternalStore: Xr,
            useId: hl,
            unstable_isNewReconciler: !1
        };
        function El(e1, n) {
            try {
                var t = "", r = n;
                do t += It(r), r = r.return;
                while (r);
                var l = t;
            } catch (e1) {
                l = "\nError generating stack: " + e1.message + "\n" + e1.stack;
            }
            return {
                value: e1,
                source: n,
                stack: l,
                digest: null
            };
        }
        function _l(e1, n, t) {
            return {
                value: e1,
                source: null,
                stack: null != t ? t : null,
                digest: null != n ? n : null
            };
        }
        function Cl(e1, n) {
            try {
                console.error(n.value);
            } catch (e1) {
                setTimeout(function() {
                    throw e1;
                });
            }
        }
        var zl = "function" == typeof WeakMap ? WeakMap : Map;
        function Nl(e1, n, t) {
            (t = Gt(-1, t)).tag = 3, t.payload = {
                element: null
            };
            var r = n.value;
            return t.callback = function() {
                xi || (xi = !0, wi = r), Cl(0, n);
            }, t;
        }
        function Il(e1, n, t) {
            (t = Gt(-1, t)).tag = 3;
            var r = e1.type.getDerivedStateFromError;
            if ("function" == typeof r) {
                var l = n.value;
                t.payload = function() {
                    return r(l);
                }, t.callback = function() {
                    Cl(0, n);
                };
            }
            var a = e1.stateNode;
            return null !== a && "function" == typeof a.componentDidCatch && (t.callback = function() {
                Cl(0, n), "function" != typeof r && (null === ki ? ki = new Set([
                    this
                ]) : ki.add(this));
                var e1 = n.stack;
                this.componentDidCatch(n.value, {
                    componentStack: null !== e1 ? e1 : ""
                });
            }), t;
        }
        function Tl(e1, n, t) {
            var r = e1.pingCache;
            if (null === r) {
                r = e1.pingCache = new zl;
                var l = new Set;
                r.set(n, l);
            } else void 0 === (l = r.get(n)) && (l = new Set, r.set(n, l));
            l.has(t) || (l.add(t), e1 = no.bind(null, e1, n, t), n.then(e1, e1));
        }
        function Rl(e1) {
            do {
                var n;
                if ((n = 13 === e1.tag) && (n = null === (n = e1.memoizedState) || null !== n.dehydrated), n) return e1;
                e1 = e1.return;
            }while (null !== e1);
            return null;
        }
        function Ol(e1, n, t, r, l) {
            return 0 == (1 & e1.mode) ? (e1 === n ? e1.flags |= 65536 : (e1.flags |= 128, t.flags |= 131072, t.flags &= -52805, 1 === t.tag && (null === t.alternate ? t.tag = 17 : ((n = Gt(-1, 1)).tag = 2, Yt(t, n, 1))), t.lanes |= 1), e1) : (e1.flags |= 65536, e1.lanes = l, e1);
        }
        var jl = i.ReactCurrentOwner, Ll = !1;
        function Ml(e1, n, t, r) {
            n.child = null === e1 ? pr(n, null, t, r) : dr(n, e1.child, t, r);
        }
        function Dl(e1, n, t, r, l) {
            t = t.render;
            var a = n.ref;
            return At(n, l), r = Fr(e1, n, t, r, a, l), t = Ar(), null === e1 || Ll ? (gt && t && dt(n), n.flags |= 1, Ml(e1, n, r, l), n.child) : (n.updateQueue = e1.updateQueue, n.flags &= -2053, e1.lanes &= ~l, ia(e1, n, l));
        }
        function Ul(e1, n, t, r, l) {
            if (null === e1) {
                var a = t.type;
                return "function" != typeof a || uo(a) || void 0 !== a.defaultProps || null !== t.compare || void 0 !== t.defaultProps ? ((e1 = co(t.type, null, r, n, n.mode, l)).ref = n.ref, e1.return = n, n.child = e1) : (n.tag = 15, n.type = a, Fl(e1, n, a, r, l));
            }
            if (a = e1.child, 0 == (e1.lanes & l)) {
                var i = a.memoizedProps;
                if ((t = null !== (t = t.compare) ? t : Nt)(i, r) && e1.ref === n.ref) return ia(e1, n, l);
            }
            return n.flags |= 1, (e1 = so(a, r)).ref = n.ref, e1.return = n, n.child = e1;
        }
        function Fl(e1, n, t, r, l) {
            if (null !== e1) {
                var a = e1.memoizedProps;
                if (Nt(a, r) && e1.ref === n.ref) {
                    if (Ll = !1, n.pendingProps = r = a, 0 == (e1.lanes & l)) return n.lanes = e1.lanes, ia(e1, n, l);
                    0 != (131072 & e1.flags) && (Ll = !0);
                }
            }
            return Hl(e1, n, t, r, l);
        }
        function Al(e1, n, t) {
            var r = n.pendingProps, l = r.children, a = null !== e1 ? e1.memoizedState : null;
            if ("hidden" === r.mode) {
                if (0 == (1 & n.mode)) n.memoizedState = {
                    baseLanes: 0,
                    cachePool: null,
                    transitions: null
                }, fn(ui, oi), oi |= t;
                else {
                    if (0 == (1073741824 & t)) return e1 = null !== a ? a.baseLanes | t : t, n.lanes = n.childLanes = 1073741824, n.memoizedState = {
                        baseLanes: e1,
                        cachePool: null,
                        transitions: null
                    }, n.updateQueue = null, fn(ui, oi), oi |= e1, null;
                    n.memoizedState = {
                        baseLanes: 0,
                        cachePool: null,
                        transitions: null
                    }, r = null !== a ? a.baseLanes : t, fn(ui, oi), oi |= r;
                }
            } else null !== a ? (r = a.baseLanes | t, n.memoizedState = null) : r = t, fn(ui, oi), oi |= r;
            return Ml(e1, n, l, t), n.child;
        }
        function Ql(e1, n) {
            var t = n.ref;
            (null === e1 && null !== t || null !== e1 && e1.ref !== t) && (n.flags |= 512, n.flags |= 2097152);
        }
        function Hl(e1, n, t, r, l) {
            var a = vn(t) ? hn : pn.current;
            return a = gn(n, a), At(n, l), t = Fr(e1, n, t, r, a, l), r = Ar(), null === e1 || Ll ? (gt && r && dt(n), n.flags |= 1, Ml(e1, n, t, l), n.child) : (n.updateQueue = e1.updateQueue, n.flags &= -2053, e1.lanes &= ~l, ia(e1, n, l));
        }
        function Bl(e1, n, t, r, l) {
            if (vn(t)) {
                var a = !0;
                xn(n);
            } else a = !1;
            if (At(n, l), null === n.stateNode) aa(e1, n), ar(n, t, r), or(n, t, r, l), r = !0;
            else if (null === e1) {
                var i = n.stateNode, o = n.memoizedProps;
                i.props = o;
                var u = i.context, s = t.contextType;
                "object" == typeof s && null !== s ? s = Qt(s) : s = gn(n, s = vn(t) ? hn : pn.current);
                var c = t.getDerivedStateFromProps, f = "function" == typeof c || "function" == typeof i.getSnapshotBeforeUpdate;
                f || "function" != typeof i.UNSAFE_componentWillReceiveProps && "function" != typeof i.componentWillReceiveProps || (o !== r || u !== s) && ir(n, i, r, s), Vt = !1;
                var d = n.memoizedState;
                i.state = d, Zt(n, r, i, l), u = n.memoizedState, o !== r || d !== u || mn.current || Vt ? ("function" == typeof c && (tr(n, t, c, r), u = n.memoizedState), (o = Vt || lr(n, t, o, r, d, u, s)) ? (f || "function" != typeof i.UNSAFE_componentWillMount && "function" != typeof i.componentWillMount || ("function" == typeof i.componentWillMount && i.componentWillMount(), "function" == typeof i.UNSAFE_componentWillMount && i.UNSAFE_componentWillMount()), "function" == typeof i.componentDidMount && (n.flags |= 4194308)) : ("function" == typeof i.componentDidMount && (n.flags |= 4194308), n.memoizedProps = r, n.memoizedState = u), i.props = r, i.state = u, i.context = s, r = o) : ("function" == typeof i.componentDidMount && (n.flags |= 4194308), r = !1);
            } else {
                i = n.stateNode, qt(e1, n), o = n.memoizedProps, s = n.type === n.elementType ? o : Tt(n.type, o), i.props = s, f = n.pendingProps, d = i.context, "object" == typeof (u = t.contextType) && null !== u ? u = Qt(u) : u = gn(n, u = vn(t) ? hn : pn.current);
                var p = t.getDerivedStateFromProps;
                (c = "function" == typeof p || "function" == typeof i.getSnapshotBeforeUpdate) || "function" != typeof i.UNSAFE_componentWillReceiveProps && "function" != typeof i.componentWillReceiveProps || (o !== f || d !== u) && ir(n, i, r, u), Vt = !1, d = n.memoizedState, i.state = d, Zt(n, r, i, l);
                var m = n.memoizedState;
                o !== f || d !== m || mn.current || Vt ? ("function" == typeof p && (tr(n, t, p, r), m = n.memoizedState), (s = Vt || lr(n, t, s, r, d, m, u) || !1) ? (c || "function" != typeof i.UNSAFE_componentWillUpdate && "function" != typeof i.componentWillUpdate || ("function" == typeof i.componentWillUpdate && i.componentWillUpdate(r, m, u), "function" == typeof i.UNSAFE_componentWillUpdate && i.UNSAFE_componentWillUpdate(r, m, u)), "function" == typeof i.componentDidUpdate && (n.flags |= 4), "function" == typeof i.getSnapshotBeforeUpdate && (n.flags |= 1024)) : ("function" != typeof i.componentDidUpdate || o === e1.memoizedProps && d === e1.memoizedState || (n.flags |= 4), "function" != typeof i.getSnapshotBeforeUpdate || o === e1.memoizedProps && d === e1.memoizedState || (n.flags |= 1024), n.memoizedProps = r, n.memoizedState = m), i.props = r, i.state = m, i.context = u, r = s) : ("function" != typeof i.componentDidUpdate || o === e1.memoizedProps && d === e1.memoizedState || (n.flags |= 4), "function" != typeof i.getSnapshotBeforeUpdate || o === e1.memoizedProps && d === e1.memoizedState || (n.flags |= 1024), r = !1);
            }
            return Wl(e1, n, t, r, a, l);
        }
        function Wl(e1, n, t, r, l, a) {
            Ql(e1, n);
            var i = 0 != (128 & n.flags);
            if (!r && !i) return l && wn(n, t, !1), ia(e1, n, a);
            r = n.stateNode, jl.current = n;
            var o = i && "function" != typeof t.getDerivedStateFromError ? null : r.render();
            return n.flags |= 1, null !== e1 && i ? (n.child = dr(n, e1.child, null, a), n.child = dr(n, null, o, a)) : Ml(e1, n, o, a), n.memoizedState = r.state, l && wn(n, t, !0), n.child;
        }
        function $l(e1) {
            var n = e1.stateNode;
            n.pendingContext ? bn(0, n.pendingContext, n.pendingContext !== n.context) : n.context && bn(0, n.context, !1), br(e1, n.containerInfo);
        }
        function Vl(e1, n, t, r, l) {
            return _t(), Ct(l), n.flags |= 256, Ml(e1, n, t, r), n.child;
        }
        var Xl, ql, Gl, Yl, Kl = {
            dehydrated: null,
            treeContext: null,
            retryLane: 0
        };
        function Jl(e1) {
            return {
                baseLanes: e1,
                cachePool: null,
                transitions: null
            };
        }
        function Zl(e1, n, t) {
            var r, l = n.pendingProps, i = kr.current, o = !1, u = 0 != (128 & n.flags);
            if ((r = u) || (r = (null === e1 || null !== e1.memoizedState) && 0 != (2 & i)), r ? (o = !0, n.flags &= -129) : null !== e1 && null === e1.memoizedState || (i |= 1), fn(kr, 1 & i), null === e1) return wt(n), null !== (e1 = n.memoizedState) && null !== (e1 = e1.dehydrated) ? (0 == (1 & n.mode) ? n.lanes = 1 : Ue(e1) ? n.lanes = 8 : n.lanes = 1073741824, null) : (u = l.children, e1 = l.fallback, o ? (l = n.mode, o = n.child, u = {
                mode: "hidden",
                children: u
            }, 0 == (1 & l) && null !== o ? (o.childLanes = 0, o.pendingProps = u) : o = po(u, l, 0, null), e1 = fo(e1, l, t, null), o.return = n, e1.return = n, o.sibling = e1, n.child = o, n.child.memoizedState = Jl(t), n.memoizedState = Kl, e1) : ea(n, u));
            if (null !== (i = e1.memoizedState) && null !== (r = i.dehydrated)) return function(e1, n, t, r, l, i, o) {
                if (t) return 256 & n.flags ? (n.flags &= -257, na(e1, n, o, r = _l(Error(a(422))))) : null !== n.memoizedState ? (n.child = e1.child, n.flags |= 128, null) : (i = r.fallback, l = n.mode, r = po({
                    mode: "visible",
                    children: r.children
                }, l, 0, null), (i = fo(i, l, o, null)).flags |= 2, r.return = n, i.return = n, r.sibling = i, n.child = r, 0 != (1 & n.mode) && dr(n, e1.child, null, o), n.child.memoizedState = Jl(o), n.memoizedState = Kl, i);
                if (0 == (1 & n.mode)) return na(e1, n, o, null);
                if (Ue(l)) return r = Fe(l).digest, i = Error(a(419)), r = _l(i, r, void 0), na(e1, n, o, r);
                if (t = 0 != (o & e1.childLanes), Ll || t) {
                    if (null !== (r = li)) {
                        switch(o & -o){
                            case 4:
                                l = 2;
                                break;
                            case 16:
                                l = 8;
                                break;
                            case 64:
                            case 128:
                            case 256:
                            case 512:
                            case 1024:
                            case 2048:
                            case 4096:
                            case 8192:
                            case 16384:
                            case 32768:
                            case 65536:
                            case 131072:
                            case 262144:
                            case 524288:
                            case 1048576:
                            case 2097152:
                            case 4194304:
                            case 8388608:
                            case 16777216:
                            case 33554432:
                            case 67108864:
                                l = 32;
                                break;
                            case 536870912:
                                l = 268435456;
                                break;
                            default:
                                l = 0;
                        }
                        0 !== (l = 0 != (l & (r.suspendedLanes | o)) ? 0 : l) && l !== i.retryLane && (i.retryLane = l, $t(e1, l), Oi(r, e1, l, -1));
                    }
                    return $i(), na(e1, n, o, r = _l(Error(a(421))));
                }
                return De(l) ? (n.flags |= 128, n.child = e1.child, n = ro.bind(null, e1), Ae(l, n), null) : (e1 = i.treeContext, Y && (ht = We(l), mt = n, gt = !0, yt = null, vt = !1, null !== e1 && (at[it++] = ut, at[it++] = st, at[it++] = ot, ut = e1.id, st = e1.overflow, ot = n)), n = ea(n, r.children), n.flags |= 4096, n);
            }(e1, n, u, l, r, i, t);
            if (o) {
                o = l.fallback, u = n.mode, r = (i = e1.child).sibling;
                var s = {
                    mode: "hidden",
                    children: l.children
                };
                return 0 == (1 & u) && n.child !== i ? ((l = n.child).childLanes = 0, l.pendingProps = s, n.deletions = null) : (l = so(i, s)).subtreeFlags = 14680064 & i.subtreeFlags, null !== r ? o = so(r, o) : (o = fo(o, u, t, null)).flags |= 2, o.return = n, l.return = n, l.sibling = o, n.child = l, l = o, o = n.child, u = null === (u = e1.child.memoizedState) ? Jl(t) : {
                    baseLanes: u.baseLanes | t,
                    cachePool: null,
                    transitions: u.transitions
                }, o.memoizedState = u, o.childLanes = e1.childLanes & ~t, n.memoizedState = Kl, l;
            }
            return e1 = (o = e1.child).sibling, l = so(o, {
                mode: "visible",
                children: l.children
            }), 0 == (1 & n.mode) && (l.lanes = t), l.return = n, l.sibling = null, null !== e1 && (null === (t = n.deletions) ? (n.deletions = [
                e1
            ], n.flags |= 16) : t.push(e1)), n.child = l, n.memoizedState = null, l;
        }
        function ea(e1, n) {
            return (n = po({
                mode: "visible",
                children: n
            }, e1.mode, 0, null)).return = e1, e1.child = n;
        }
        function na(e1, n, t, r) {
            return null !== r && Ct(r), dr(n, e1.child, null, t), (e1 = ea(n, n.pendingProps.children)).flags |= 2, n.memoizedState = null, e1;
        }
        function ta(e1, n, t) {
            e1.lanes |= n;
            var r = e1.alternate;
            null !== r && (r.lanes |= n), Ft(e1.return, n, t);
        }
        function ra(e1, n, t, r, l) {
            var a = e1.memoizedState;
            null === a ? e1.memoizedState = {
                isBackwards: n,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: t,
                tailMode: l
            } : (a.isBackwards = n, a.rendering = null, a.renderingStartTime = 0, a.last = r, a.tail = t, a.tailMode = l);
        }
        function la(e1, n, t) {
            var r = n.pendingProps, l = r.revealOrder, a = r.tail;
            if (Ml(e1, n, r.children, t), 0 != (2 & (r = kr.current))) r = 1 & r | 2, n.flags |= 128;
            else {
                if (null !== e1 && 0 != (128 & e1.flags)) e: for(e1 = n.child; null !== e1;){
                    if (13 === e1.tag) null !== e1.memoizedState && ta(e1, t, n);
                    else if (19 === e1.tag) ta(e1, t, n);
                    else if (null !== e1.child) {
                        e1.child.return = e1, e1 = e1.child;
                        continue;
                    }
                    if (e1 === n) break e;
                    for(; null === e1.sibling;){
                        if (null === e1.return || e1.return === n) break e;
                        e1 = e1.return;
                    }
                    e1.sibling.return = e1.return, e1 = e1.sibling;
                }
                r &= 1;
            }
            if (fn(kr, r), 0 == (1 & n.mode)) n.memoizedState = null;
            else switch(l){
                case "forwards":
                    for(t = n.child, l = null; null !== t;)null !== (e1 = t.alternate) && null === Pr(e1) && (l = t), t = t.sibling;
                    null === (t = l) ? (l = n.child, n.child = null) : (l = t.sibling, t.sibling = null), ra(n, !1, l, t, a);
                    break;
                case "backwards":
                    for(t = null, l = n.child, n.child = null; null !== l;){
                        if (null !== (e1 = l.alternate) && null === Pr(e1)) {
                            n.child = l;
                            break;
                        }
                        e1 = l.sibling, l.sibling = t, t = l, l = e1;
                    }
                    ra(n, !0, t, null, a);
                    break;
                case "together":
                    ra(n, !1, null, null, void 0);
                    break;
                default:
                    n.memoizedState = null;
            }
            return n.child;
        }
        function aa(e1, n) {
            0 == (1 & n.mode) && null !== e1 && (e1.alternate = null, n.alternate = null, n.flags |= 2);
        }
        function ia(e1, n, t) {
            if (null !== e1 && (n.dependencies = e1.dependencies), fi |= n.lanes, 0 == (t & n.childLanes)) return null;
            if (null !== e1 && n.child !== e1.child) throw Error(a(153));
            if (null !== n.child) {
                for(t = so(e1 = n.child, e1.pendingProps), n.child = t, t.return = n; null !== e1.sibling;)e1 = e1.sibling, (t = t.sibling = so(e1, e1.pendingProps)).return = n;
                t.sibling = null;
            }
            return n.child;
        }
        function oa(e1) {
            e1.flags |= 4;
        }
        function ua(e1, n) {
            if (null !== e1 && e1.child === n.child) return !0;
            if (0 != (16 & n.flags)) return !1;
            for(e1 = n.child; null !== e1;){
                if (0 != (12854 & e1.flags) || 0 != (12854 & e1.subtreeFlags)) return !1;
                e1 = e1.sibling;
            }
            return !0;
        }
        if (q) Xl = function(e1, n) {
            for(var t = n.child; null !== t;){
                if (5 === t.tag || 6 === t.tag) F(e1, t.stateNode);
                else if (4 !== t.tag && null !== t.child) {
                    t.child.return = t, t = t.child;
                    continue;
                }
                if (t === n) break;
                for(; null === t.sibling;){
                    if (null === t.return || t.return === n) return;
                    t = t.return;
                }
                t.sibling.return = t.return, t = t.sibling;
            }
        }, ql = function() {}, Gl = function(e1, n, t, r, l) {
            if ((e1 = e1.memoizedProps) !== r) {
                var a = n.stateNode, i = yr(hr.current);
                t = Q(a, t, e1, r, l, i), (n.updateQueue = t) && oa(n);
            }
        }, Yl = function(e1, n, t, r) {
            t !== r && oa(n);
        };
        else if (G) {
            Xl = function(e1, n, t, r) {
                for(var l = n.child; null !== l;){
                    if (5 === l.tag) {
                        var a = l.stateNode;
                        t && r && (a = Re(a, l.type, l.memoizedProps, l)), F(e1, a);
                    } else if (6 === l.tag) a = l.stateNode, t && r && (a = Oe(a, l.memoizedProps, l)), F(e1, a);
                    else if (4 !== l.tag) {
                        if (22 === l.tag && null !== l.memoizedState) null !== (a = l.child) && (a.return = l), Xl(e1, l, !0, !0);
                        else if (null !== l.child) {
                            l.child.return = l, l = l.child;
                            continue;
                        }
                    }
                    if (l === n) break;
                    for(; null === l.sibling;){
                        if (null === l.return || l.return === n) return;
                        l = l.return;
                    }
                    l.sibling.return = l.return, l = l.sibling;
                }
            };
            var sa = function(e1, n, t, r) {
                for(var l = n.child; null !== l;){
                    if (5 === l.tag) {
                        var a = l.stateNode;
                        t && r && (a = Re(a, l.type, l.memoizedProps, l)), ze(e1, a);
                    } else if (6 === l.tag) a = l.stateNode, t && r && (a = Oe(a, l.memoizedProps, l)), ze(e1, a);
                    else if (4 !== l.tag) {
                        if (22 === l.tag && null !== l.memoizedState) null !== (a = l.child) && (a.return = l), sa(e1, l, !0, !0);
                        else if (null !== l.child) {
                            l.child.return = l, l = l.child;
                            continue;
                        }
                    }
                    if (l === n) break;
                    for(; null === l.sibling;){
                        if (null === l.return || l.return === n) return;
                        l = l.return;
                    }
                    l.sibling.return = l.return, l = l.sibling;
                }
            };
            ql = function(e1, n) {
                var t = n.stateNode;
                if (!ua(e1, n)) {
                    e1 = t.containerInfo;
                    var r = Ce(e1);
                    sa(r, n, !1, !1), t.pendingChildren = r, oa(n), Ie(e1, r);
                }
            }, Gl = function(e1, n, t, r, l) {
                var a = e1.stateNode, i = e1.memoizedProps;
                if ((e1 = ua(e1, n)) && i === r) n.stateNode = a;
                else {
                    var o = n.stateNode, u = yr(hr.current), s = null;
                    i !== r && (s = Q(o, t, i, r, l, u)), e1 && null === s ? n.stateNode = a : (a = _e(a, s, t, i, r, n, e1, o), A(a, t, r, l, u) && oa(n), n.stateNode = a, e1 ? oa(n) : Xl(a, n, !1, !1));
                }
            }, Yl = function(e1, n, t, r) {
                t !== r ? (e1 = yr(vr.current), t = yr(hr.current), n.stateNode = B(r, e1, t, n), oa(n)) : n.stateNode = e1.stateNode;
            };
        } else ql = function() {}, Gl = function() {}, Yl = function() {};
        function ca(e1, n) {
            if (!gt) switch(e1.tailMode){
                case "hidden":
                    n = e1.tail;
                    for(var t = null; null !== n;)null !== n.alternate && (t = n), n = n.sibling;
                    null === t ? e1.tail = null : t.sibling = null;
                    break;
                case "collapsed":
                    t = e1.tail;
                    for(var r = null; null !== t;)null !== t.alternate && (r = t), t = t.sibling;
                    null === r ? n || null === e1.tail ? e1.tail = null : e1.tail.sibling = null : r.sibling = null;
            }
        }
        function fa(e1) {
            var n = null !== e1.alternate && e1.alternate.child === e1.child, t = 0, r = 0;
            if (n) for(var l = e1.child; null !== l;)t |= l.lanes | l.childLanes, r |= 14680064 & l.subtreeFlags, r |= 14680064 & l.flags, l.return = e1, l = l.sibling;
            else for(l = e1.child; null !== l;)t |= l.lanes | l.childLanes, r |= l.subtreeFlags, r |= l.flags, l.return = e1, l = l.sibling;
            return e1.subtreeFlags |= r, e1.childLanes = t, n;
        }
        function da(e1, n, t) {
            var r = n.pendingProps;
            switch(pt(n), n.tag){
                case 2:
                case 16:
                case 15:
                case 0:
                case 11:
                case 7:
                case 8:
                case 12:
                case 9:
                case 14:
                    return fa(n), null;
                case 1:
                case 17:
                    return vn(n.type) && yn(), fa(n), null;
                case 3:
                    return t = n.stateNode, Sr(), cn(mn), cn(pn), _r(), t.pendingContext && (t.context = t.pendingContext, t.pendingContext = null), null !== e1 && null !== e1.child || (Pt(n) ? oa(n) : null === e1 || e1.memoizedState.isDehydrated && 0 == (256 & n.flags) || (n.flags |= 1024, null !== yt && (Di(yt), yt = null))), ql(e1, n), fa(n), null;
                case 5:
                    wr(n), t = yr(vr.current);
                    var l = n.type;
                    if (null !== e1 && null != n.stateNode) Gl(e1, n, l, r, t), e1.ref !== n.ref && (n.flags |= 512, n.flags |= 2097152);
                    else {
                        if (!r) {
                            if (null === n.stateNode) throw Error(a(166));
                            return fa(n), null;
                        }
                        if (e1 = yr(hr.current), Pt(n)) {
                            if (!Y) throw Error(a(175));
                            e1 = $e(n.stateNode, n.type, n.memoizedProps, t, e1, n, !vt), n.updateQueue = e1, null !== e1 && oa(n);
                        } else {
                            var i = U(l, r, t, e1, n);
                            Xl(i, n, !1, !1), n.stateNode = i, A(i, l, r, t, e1) && oa(n);
                        }
                        null !== n.ref && (n.flags |= 512, n.flags |= 2097152);
                    }
                    return fa(n), null;
                case 6:
                    if (e1 && null != n.stateNode) Yl(e1, n, e1.memoizedProps, r);
                    else {
                        if ("string" != typeof r && null === n.stateNode) throw Error(a(166));
                        if (e1 = yr(vr.current), t = yr(hr.current), Pt(n)) {
                            if (!Y) throw Error(a(176));
                            if (e1 = n.stateNode, t = n.memoizedProps, (r = Ve(e1, t, n, !vt)) && null !== (l = mt)) switch(l.tag){
                                case 3:
                                    en(l.stateNode.containerInfo, e1, t, 0 != (1 & l.mode));
                                    break;
                                case 5:
                                    nn(l.type, l.memoizedProps, l.stateNode, e1, t, 0 != (1 & l.mode));
                            }
                            r && oa(n);
                        } else n.stateNode = B(r, e1, t, n);
                    }
                    return fa(n), null;
                case 13:
                    if (cn(kr), r = n.memoizedState, null === e1 || null !== e1.memoizedState && null !== e1.memoizedState.dehydrated) {
                        if (gt && null !== ht && 0 != (1 & n.mode) && 0 == (128 & n.flags)) Et(), _t(), n.flags |= 98560, l = !1;
                        else if (l = Pt(n), null !== r && null !== r.dehydrated) {
                            if (null === e1) {
                                if (!l) throw Error(a(318));
                                if (!Y) throw Error(a(344));
                                if (!(l = null !== (l = n.memoizedState) ? l.dehydrated : null)) throw Error(a(317));
                                Xe(l, n);
                            } else _t(), 0 == (128 & n.flags) && (n.memoizedState = null), n.flags |= 4;
                            fa(n), l = !1;
                        } else null !== yt && (Di(yt), yt = null), l = !0;
                        if (!l) return 65536 & n.flags ? n : null;
                    }
                    return 0 != (128 & n.flags) ? (n.lanes = t, n) : ((t = null !== r) !== (null !== e1 && null !== e1.memoizedState) && t && (n.child.flags |= 8192, 0 != (1 & n.mode) && (null === e1 || 0 != (1 & kr.current) ? 0 === si && (si = 3) : $i())), null !== n.updateQueue && (n.flags |= 4), fa(n), null);
                case 4:
                    return Sr(), ql(e1, n), null === e1 && J(n.stateNode.containerInfo), fa(n), null;
                case 10:
                    return Ut(n.type._context), fa(n), null;
                case 19:
                    if (cn(kr), null === (l = n.memoizedState)) return fa(n), null;
                    if (r = 0 != (128 & n.flags), null === (i = l.rendering)) {
                        if (r) ca(l, !1);
                        else {
                            if (0 !== si || null !== e1 && 0 != (128 & e1.flags)) for(e1 = n.child; null !== e1;){
                                if (null !== (i = Pr(e1))) {
                                    for(n.flags |= 128, ca(l, !1), null !== (e1 = i.updateQueue) && (n.updateQueue = e1, n.flags |= 4), n.subtreeFlags = 0, e1 = t, t = n.child; null !== t;)l = e1, (r = t).flags &= 14680066, null === (i = r.alternate) ? (r.childLanes = 0, r.lanes = l, r.child = null, r.subtreeFlags = 0, r.memoizedProps = null, r.memoizedState = null, r.updateQueue = null, r.dependencies = null, r.stateNode = null) : (r.childLanes = i.childLanes, r.lanes = i.lanes, r.child = i.child, r.subtreeFlags = 0, r.deletions = null, r.memoizedProps = i.memoizedProps, r.memoizedState = i.memoizedState, r.updateQueue = i.updateQueue, r.type = i.type, l = i.dependencies, r.dependencies = null === l ? null : {
                                        lanes: l.lanes,
                                        firstContext: l.firstContext
                                    }), t = t.sibling;
                                    return fn(kr, 1 & kr.current | 2), n.child;
                                }
                                e1 = e1.sibling;
                            }
                            null !== l.tail && Hn() > vi && (n.flags |= 128, r = !0, ca(l, !1), n.lanes = 4194304);
                        }
                    } else {
                        if (!r) {
                            if (null !== (e1 = Pr(i))) {
                                if (n.flags |= 128, r = !0, null !== (e1 = e1.updateQueue) && (n.updateQueue = e1, n.flags |= 4), ca(l, !0), null === l.tail && "hidden" === l.tailMode && !i.alternate && !gt) return fa(n), null;
                            } else 2 * Hn() - l.renderingStartTime > vi && 1073741824 !== t && (n.flags |= 128, r = !0, ca(l, !1), n.lanes = 4194304);
                        }
                        l.isBackwards ? (i.sibling = n.child, n.child = i) : (null !== (e1 = l.last) ? e1.sibling = i : n.child = i, l.last = i);
                    }
                    return null !== l.tail ? (n = l.tail, l.rendering = n, l.tail = n.sibling, l.renderingStartTime = Hn(), n.sibling = null, e1 = kr.current, fn(kr, r ? 1 & e1 | 2 : 1 & e1), n) : (fa(n), null);
                case 22:
                case 23:
                    return Qi(), t = null !== n.memoizedState, null !== e1 && null !== e1.memoizedState !== t && (n.flags |= 8192), t && 0 != (1 & n.mode) ? 0 != (1073741824 & oi) && (fa(n), q && 6 & n.subtreeFlags && (n.flags |= 8192)) : fa(n), null;
                case 24:
                case 25:
                    return null;
            }
            throw Error(a(156, n.tag));
        }
        function pa(e1, n) {
            switch(pt(n), n.tag){
                case 1:
                    return vn(n.type) && yn(), 65536 & (e1 = n.flags) ? (n.flags = -65537 & e1 | 128, n) : null;
                case 3:
                    return Sr(), cn(mn), cn(pn), _r(), 0 != (65536 & (e1 = n.flags)) && 0 == (128 & e1) ? (n.flags = -65537 & e1 | 128, n) : null;
                case 5:
                    return wr(n), null;
                case 13:
                    if (cn(kr), null !== (e1 = n.memoizedState) && null !== e1.dehydrated) {
                        if (null === n.alternate) throw Error(a(340));
                        _t();
                    }
                    return 65536 & (e1 = n.flags) ? (n.flags = -65537 & e1 | 128, n) : null;
                case 19:
                    return cn(kr), null;
                case 4:
                    return Sr(), null;
                case 10:
                    return Ut(n.type._context), null;
                case 22:
                case 23:
                    return Qi(), null;
                default:
                    return null;
            }
        }
        var ma = !1, ha = !1, ga = "function" == typeof WeakSet ? WeakSet : Set, va = null;
        function ya(e1, n) {
            var t = e1.ref;
            if (null !== t) {
                if ("function" == typeof t) try {
                    t(null);
                } catch (t) {
                    eo(e1, n, t);
                }
                else t.current = null;
            }
        }
        function ba(e1, n, t) {
            try {
                t();
            } catch (t) {
                eo(e1, n, t);
            }
        }
        var Sa = !1;
        function xa(e1, n, t) {
            var r = n.updateQueue;
            if (null !== (r = null !== r ? r.lastEffect : null)) {
                var l = r = r.next;
                do {
                    if ((l.tag & e1) === e1) {
                        var a = l.destroy;
                        l.destroy = void 0, void 0 !== a && ba(n, t, a);
                    }
                    l = l.next;
                }while (l !== r);
            }
        }
        function wa(e1, n) {
            if (null !== (n = null !== (n = n.updateQueue) ? n.lastEffect : null)) {
                var t = n = n.next;
                do {
                    if ((t.tag & e1) === e1) {
                        var r = t.create;
                        t.destroy = r();
                    }
                    t = t.next;
                }while (t !== n);
            }
        }
        function ka(e1) {
            var n = e1.ref;
            if (null !== n) {
                var t = e1.stateNode;
                if (5 === e1.tag) e1 = O(t);
                else e1 = t;
                "function" == typeof n ? n(e1) : n.current = e1;
            }
        }
        function Pa(e1) {
            var n = e1.alternate;
            null !== n && (e1.alternate = null, Pa(n)), e1.child = null, e1.deletions = null, e1.sibling = null, 5 === e1.tag && null !== (n = e1.stateNode) && ee(n), e1.stateNode = null, e1.return = null, e1.dependencies = null, e1.memoizedProps = null, e1.memoizedState = null, e1.pendingProps = null, e1.stateNode = null, e1.updateQueue = null;
        }
        function Ea(e1) {
            return 5 === e1.tag || 3 === e1.tag || 4 === e1.tag;
        }
        function _a(e1) {
            e: for(;;){
                for(; null === e1.sibling;){
                    if (null === e1.return || Ea(e1.return)) return null;
                    e1 = e1.return;
                }
                for(e1.sibling.return = e1.return, e1 = e1.sibling; 5 !== e1.tag && 6 !== e1.tag && 18 !== e1.tag;){
                    if (2 & e1.flags) continue e;
                    if (null === e1.child || 4 === e1.tag) continue e;
                    e1.child.return = e1, e1 = e1.child;
                }
                if (!(2 & e1.flags)) return e1.stateNode;
            }
        }
        function Ca(e1, n, t) {
            var r = e1.tag;
            if (5 === r || 6 === r) e1 = e1.stateNode, n ? ve(t, e1, n) : de(t, e1);
            else if (4 !== r && null !== (e1 = e1.child)) for(Ca(e1, n, t), e1 = e1.sibling; null !== e1;)Ca(e1, n, t), e1 = e1.sibling;
        }
        function za(e1, n, t) {
            var r = e1.tag;
            if (5 === r || 6 === r) e1 = e1.stateNode, n ? ge(t, e1, n) : fe(t, e1);
            else if (4 !== r && null !== (e1 = e1.child)) for(za(e1, n, t), e1 = e1.sibling; null !== e1;)za(e1, n, t), e1 = e1.sibling;
        }
        var Na = null, Ia = !1;
        function Ta(e1, n, t) {
            for(t = t.child; null !== t;)Ra(e1, n, t), t = t.sibling;
        }
        function Ra(e1, n, t) {
            if (qn && "function" == typeof qn.onCommitFiberUnmount) try {
                qn.onCommitFiberUnmount(Xn, t);
            } catch (e1) {}
            switch(t.tag){
                case 5:
                    ha || ya(t, n);
                case 6:
                    if (q) {
                        var r = Na, l = Ia;
                        Na = null, Ta(e1, n, t), Ia = l, null !== (Na = r) && (Ia ? be(Na, t.stateNode) : ye(Na, t.stateNode));
                    } else Ta(e1, n, t);
                    break;
                case 18:
                    q && null !== Na && (Ia ? Je(Na, t.stateNode) : Ke(Na, t.stateNode));
                    break;
                case 4:
                    q ? (r = Na, l = Ia, Na = t.stateNode.containerInfo, Ia = !0, Ta(e1, n, t), Na = r, Ia = l) : (G && (r = t.stateNode.containerInfo, l = Ce(r), Te(r, l)), Ta(e1, n, t));
                    break;
                case 0:
                case 11:
                case 14:
                case 15:
                    if (!ha && null !== (r = t.updateQueue) && null !== (r = r.lastEffect)) {
                        l = r = r.next;
                        do {
                            var a = l, i = a.destroy;
                            a = a.tag, void 0 !== i && (0 != (2 & a) || 0 != (4 & a)) && ba(t, n, i), l = l.next;
                        }while (l !== r);
                    }
                    Ta(e1, n, t);
                    break;
                case 1:
                    if (!ha && (ya(t, n), "function" == typeof (r = t.stateNode).componentWillUnmount)) try {
                        r.props = t.memoizedProps, r.state = t.memoizedState, r.componentWillUnmount();
                    } catch (e1) {
                        eo(t, n, e1);
                    }
                    Ta(e1, n, t);
                    break;
                case 21:
                    Ta(e1, n, t);
                    break;
                case 22:
                    1 & t.mode ? (ha = (r = ha) || null !== t.memoizedState, Ta(e1, n, t), ha = r) : Ta(e1, n, t);
                    break;
                default:
                    Ta(e1, n, t);
            }
        }
        function Oa(e1) {
            var n = e1.updateQueue;
            if (null !== n) {
                e1.updateQueue = null;
                var t = e1.stateNode;
                null === t && (t = e1.stateNode = new ga), n.forEach(function(n) {
                    var r = lo.bind(null, e1, n);
                    t.has(n) || (t.add(n), n.then(r, r));
                });
            }
        }
        function ja(e1, n) {
            var t = n.deletions;
            if (null !== t) for(var r = 0; r < t.length; r++){
                var l = t[r];
                try {
                    var i = e1, o = n;
                    if (q) {
                        var u = o;
                        e: for(; null !== u;){
                            switch(u.tag){
                                case 5:
                                    Na = u.stateNode, Ia = !1;
                                    break e;
                                case 3:
                                case 4:
                                    Na = u.stateNode.containerInfo, Ia = !0;
                                    break e;
                            }
                            u = u.return;
                        }
                        if (null === Na) throw Error(a(160));
                        Ra(i, o, l), Na = null, Ia = !1;
                    } else Ra(i, o, l);
                    var s = l.alternate;
                    null !== s && (s.return = null), l.return = null;
                } catch (e1) {
                    eo(l, n, e1);
                }
            }
            if (12854 & n.subtreeFlags) for(n = n.child; null !== n;)La(n, e1), n = n.sibling;
        }
        function La(e1, n) {
            var t = e1.alternate, r = e1.flags;
            switch(e1.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    if (ja(n, e1), Ma(e1), 4 & r) {
                        try {
                            xa(3, e1, e1.return), wa(3, e1);
                        } catch (n) {
                            eo(e1, e1.return, n);
                        }
                        try {
                            xa(5, e1, e1.return);
                        } catch (n) {
                            eo(e1, e1.return, n);
                        }
                    }
                    break;
                case 1:
                    ja(n, e1), Ma(e1), 512 & r && null !== t && ya(t, t.return);
                    break;
                case 5:
                    if (ja(n, e1), Ma(e1), 512 & r && null !== t && ya(t, t.return), q) {
                        if (32 & e1.flags) {
                            var l = e1.stateNode;
                            try {
                                Se(l);
                            } catch (n) {
                                eo(e1, e1.return, n);
                            }
                        }
                        if (4 & r && null != (l = e1.stateNode)) {
                            var i = e1.memoizedProps;
                            if (t = null !== t ? t.memoizedProps : i, r = e1.type, n = e1.updateQueue, e1.updateQueue = null, null !== n) try {
                                he(l, n, r, t, i, e1);
                            } catch (n) {
                                eo(e1, e1.return, n);
                            }
                        }
                    }
                    break;
                case 6:
                    if (ja(n, e1), Ma(e1), 4 & r && q) {
                        if (null === e1.stateNode) throw Error(a(162));
                        l = e1.stateNode, i = e1.memoizedProps, t = null !== t ? t.memoizedProps : i;
                        try {
                            pe(l, t, i);
                        } catch (n) {
                            eo(e1, e1.return, n);
                        }
                    }
                    break;
                case 3:
                    if (ja(n, e1), Ma(e1), 4 & r) {
                        if (q && Y && null !== t && t.memoizedState.isDehydrated) try {
                            Ge(n.containerInfo);
                        } catch (n) {
                            eo(e1, e1.return, n);
                        }
                        if (G) {
                            l = n.containerInfo, i = n.pendingChildren;
                            try {
                                Te(l, i);
                            } catch (n) {
                                eo(e1, e1.return, n);
                            }
                        }
                    }
                    break;
                case 4:
                    if (ja(n, e1), Ma(e1), 4 & r && G) {
                        l = (i = e1.stateNode).containerInfo, i = i.pendingChildren;
                        try {
                            Te(l, i);
                        } catch (n) {
                            eo(e1, e1.return, n);
                        }
                    }
                    break;
                case 13:
                    ja(n, e1), Ma(e1), 8192 & (l = e1.child).flags && (i = null !== l.memoizedState, l.stateNode.isHidden = i, !i || null !== l.alternate && null !== l.alternate.memoizedState || (gi = Hn())), 4 & r && Oa(e1);
                    break;
                case 22:
                    var o = null !== t && null !== t.memoizedState;
                    if (1 & e1.mode ? (ha = (t = ha) || o, ja(n, e1), ha = t) : ja(n, e1), Ma(e1), 8192 & r) {
                        if (t = null !== e1.memoizedState, (e1.stateNode.isHidden = t) && !o && 0 != (1 & e1.mode)) for(va = e1, r = e1.child; null !== r;){
                            for(n = va = r; null !== va;){
                                var u = (o = va).child;
                                switch(o.tag){
                                    case 0:
                                    case 11:
                                    case 14:
                                    case 15:
                                        xa(4, o, o.return);
                                        break;
                                    case 1:
                                        ya(o, o.return);
                                        var s = o.stateNode;
                                        if ("function" == typeof s.componentWillUnmount) {
                                            var c = o, f = o.return;
                                            try {
                                                var d = c;
                                                s.props = d.memoizedProps, s.state = d.memoizedState, s.componentWillUnmount();
                                            } catch (e1) {
                                                eo(c, f, e1);
                                            }
                                        }
                                        break;
                                    case 5:
                                        ya(o, o.return);
                                        break;
                                    case 22:
                                        if (null !== o.memoizedState) {
                                            Aa(n);
                                            continue;
                                        }
                                }
                                null !== u ? (u.return = o, va = u) : Aa(n);
                            }
                            r = r.sibling;
                        }
                        if (q) {
                            e: if (r = null, q) for(n = e1;;){
                                if (5 === n.tag) {
                                    if (null === r) {
                                        r = n;
                                        try {
                                            l = n.stateNode, t ? xe(l) : ke(n.stateNode, n.memoizedProps);
                                        } catch (n) {
                                            eo(e1, e1.return, n);
                                        }
                                    }
                                } else if (6 === n.tag) {
                                    if (null === r) try {
                                        i = n.stateNode, t ? we(i) : Pe(i, n.memoizedProps);
                                    } catch (n) {
                                        eo(e1, e1.return, n);
                                    }
                                } else if ((22 !== n.tag && 23 !== n.tag || null === n.memoizedState || n === e1) && null !== n.child) {
                                    n.child.return = n, n = n.child;
                                    continue;
                                }
                                if (n === e1) break e;
                                for(; null === n.sibling;){
                                    if (null === n.return || n.return === e1) break e;
                                    r === n && (r = null), n = n.return;
                                }
                                r === n && (r = null), n.sibling.return = n.return, n = n.sibling;
                            }
                        }
                    }
                    break;
                case 19:
                    ja(n, e1), Ma(e1), 4 & r && Oa(e1);
                    break;
                case 21:
                    break;
                default:
                    ja(n, e1), Ma(e1);
            }
        }
        function Ma(e1) {
            var n = e1.flags;
            if (2 & n) {
                try {
                    if (q) {
                        e: {
                            for(var t = e1.return; null !== t;){
                                if (Ea(t)) {
                                    var r = t;
                                    break e;
                                }
                                t = t.return;
                            }
                            throw Error(a(160));
                        }
                        switch(r.tag){
                            case 5:
                                var l = r.stateNode;
                                32 & r.flags && (Se(l), r.flags &= -33), za(e1, _a(e1), l);
                                break;
                            case 3:
                            case 4:
                                var i = r.stateNode.containerInfo;
                                Ca(e1, _a(e1), i);
                                break;
                            default:
                                throw Error(a(161));
                        }
                    }
                } catch (n) {
                    eo(e1, e1.return, n);
                }
                e1.flags &= -3;
            }
            4096 & n && (e1.flags &= -4097);
        }
        function Da(e1, n, t) {
            va = e1, Ua(e1);
        }
        function Ua(e1, n, t) {
            for(var r = 0 != (1 & e1.mode); null !== va;){
                var l = va, a = l.child;
                if (22 === l.tag && r) {
                    var i = null !== l.memoizedState || ma;
                    if (!i) {
                        var o = l.alternate, u = null !== o && null !== o.memoizedState || ha;
                        o = ma;
                        var s = ha;
                        if (ma = i, (ha = u) && !s) for(va = l; null !== va;)u = (i = va).child, 22 === i.tag && null !== i.memoizedState ? Qa(l) : null !== u ? (u.return = i, va = u) : Qa(l);
                        for(; null !== a;)va = a, Ua(a), a = a.sibling;
                        va = l, ma = o, ha = s;
                    }
                    Fa(e1);
                } else 0 != (8772 & l.subtreeFlags) && null !== a ? (a.return = l, va = a) : Fa(e1);
            }
        }
        function Fa(e1) {
            for(; null !== va;){
                var n = va;
                if (0 != (8772 & n.flags)) {
                    var t = n.alternate;
                    try {
                        if (0 != (8772 & n.flags)) switch(n.tag){
                            case 0:
                            case 11:
                            case 15:
                                ha || wa(5, n);
                                break;
                            case 1:
                                var r = n.stateNode;
                                if (4 & n.flags && !ha) {
                                    if (null === t) r.componentDidMount();
                                    else {
                                        var l = n.elementType === n.type ? t.memoizedProps : Tt(n.type, t.memoizedProps);
                                        r.componentDidUpdate(l, t.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
                                    }
                                }
                                var i = n.updateQueue;
                                null !== i && er(n, i, r);
                                break;
                            case 3:
                                var o = n.updateQueue;
                                if (null !== o) {
                                    if (t = null, null !== n.child) switch(n.child.tag){
                                        case 5:
                                            t = O(n.child.stateNode);
                                            break;
                                        case 1:
                                            t = n.child.stateNode;
                                    }
                                    er(n, o, t);
                                }
                                break;
                            case 5:
                                var u = n.stateNode;
                                null === t && 4 & n.flags && me(u, n.type, n.memoizedProps, n);
                                break;
                            case 6:
                            case 4:
                            case 12:
                            case 19:
                            case 17:
                            case 21:
                            case 22:
                            case 23:
                            case 25:
                                break;
                            case 13:
                                if (Y && null === n.memoizedState) {
                                    var s = n.alternate;
                                    if (null !== s) {
                                        var c = s.memoizedState;
                                        if (null !== c) {
                                            var f = c.dehydrated;
                                            null !== f && Ye(f);
                                        }
                                    }
                                }
                                break;
                            default:
                                throw Error(a(163));
                        }
                        ha || 512 & n.flags && ka(n);
                    } catch (e1) {
                        eo(n, n.return, e1);
                    }
                }
                if (n === e1) {
                    va = null;
                    break;
                }
                if (null !== (t = n.sibling)) {
                    t.return = n.return, va = t;
                    break;
                }
                va = n.return;
            }
        }
        function Aa(e1) {
            for(; null !== va;){
                var n = va;
                if (n === e1) {
                    va = null;
                    break;
                }
                var t = n.sibling;
                if (null !== t) {
                    t.return = n.return, va = t;
                    break;
                }
                va = n.return;
            }
        }
        function Qa(e1) {
            for(; null !== va;){
                var n = va;
                try {
                    switch(n.tag){
                        case 0:
                        case 11:
                        case 15:
                            var t = n.return;
                            try {
                                wa(4, n);
                            } catch (e1) {
                                eo(n, t, e1);
                            }
                            break;
                        case 1:
                            var r = n.stateNode;
                            if ("function" == typeof r.componentDidMount) {
                                var l = n.return;
                                try {
                                    r.componentDidMount();
                                } catch (e1) {
                                    eo(n, l, e1);
                                }
                            }
                            var a = n.return;
                            try {
                                ka(n);
                            } catch (e1) {
                                eo(n, a, e1);
                            }
                            break;
                        case 5:
                            var i = n.return;
                            try {
                                ka(n);
                            } catch (e1) {
                                eo(n, i, e1);
                            }
                    }
                } catch (e1) {
                    eo(n, n.return, e1);
                }
                if (n === e1) {
                    va = null;
                    break;
                }
                var o = n.sibling;
                if (null !== o) {
                    o.return = n.return, va = o;
                    break;
                }
                va = n.return;
            }
        }
        var Ha = 0, Ba = 1, Wa = 2, $a = 3, Va = 4;
        if ("function" == typeof Symbol && Symbol.for) {
            var Xa = Symbol.for;
            Ha = Xa("selector.component"), Ba = Xa("selector.has_pseudo_class"), Wa = Xa("selector.role"), $a = Xa("selector.test_id"), Va = Xa("selector.text");
        }
        function qa(e1) {
            var n = K(e1);
            if (null != n) {
                if ("string" != typeof n.memoizedProps["data-testname"]) throw Error(a(364));
                return n;
            }
            if (null === (e1 = le(e1))) throw Error(a(362));
            return e1.stateNode.current;
        }
        function Ga(e1, n) {
            switch(n.$$typeof){
                case Ha:
                    if (e1.type === n.value) return !0;
                    break;
                case Ba:
                    e: {
                        n = n.value, e1 = [
                            e1,
                            0
                        ];
                        for(var t = 0; t < e1.length;){
                            var r = e1[t++], l = e1[t++], i = n[l];
                            if (5 !== r.tag || !oe(r)) {
                                for(; null != i && Ga(r, i);)i = n[++l];
                                if (l === n.length) {
                                    n = !0;
                                    break e;
                                }
                                for(r = r.child; null !== r;)e1.push(r, l), r = r.sibling;
                            }
                        }
                        n = !1;
                    }
                    return n;
                case Wa:
                    if (5 === e1.tag && ue(e1.stateNode, n.value)) return !0;
                    break;
                case Va:
                    if ((5 === e1.tag || 6 === e1.tag) && null !== (e1 = ie(e1)) && 0 <= e1.indexOf(n.value)) return !0;
                    break;
                case $a:
                    if (5 === e1.tag && "string" == typeof (e1 = e1.memoizedProps["data-testname"]) && e1.toLowerCase() === n.value.toLowerCase()) return !0;
                    break;
                default:
                    throw Error(a(365));
            }
            return !1;
        }
        function Ya(e1) {
            switch(e1.$$typeof){
                case Ha:
                    return "<" + (k(e1.value) || "Unknown") + ">";
                case Ba:
                    return ":has(" + (Ya(e1) || "") + ")";
                case Wa:
                    return '[role="' + e1.value + '"]';
                case Va:
                    return '"' + e1.value + '"';
                case $a:
                    return '[data-testname="' + e1.value + '"]';
                default:
                    throw Error(a(365));
            }
        }
        function Ka(e1, n) {
            var t = [];
            e1 = [
                e1,
                0
            ];
            for(var r = 0; r < e1.length;){
                var l = e1[r++], a = e1[r++], i = n[a];
                if (5 !== l.tag || !oe(l)) {
                    for(; null != i && Ga(l, i);)i = n[++a];
                    if (a === n.length) t.push(l);
                    else for(l = l.child; null !== l;)e1.push(l, a), l = l.sibling;
                }
            }
            return t;
        }
        function Ja(e1, n) {
            if (!re) throw Error(a(363));
            e1 = Ka(e1 = qa(e1), n), n = [], e1 = Array.from(e1);
            for(var t = 0; t < e1.length;){
                var r = e1[t++];
                if (5 === r.tag) oe(r) || n.push(r.stateNode);
                else for(r = r.child; null !== r;)e1.push(r), r = r.sibling;
            }
            return n;
        }
        var Za = Math.ceil, ei = i.ReactCurrentDispatcher, ni = i.ReactCurrentOwner, ti = i.ReactCurrentBatchConfig, ri = 0, li = null, ai = null, ii = 0, oi = 0, ui = sn(0), si = 0, ci = null, fi = 0, di = 0, pi = 0, mi = null, hi = null, gi = 0, vi = 1 / 0, yi = null;
        function bi() {
            vi = Hn() + 500;
        }
        var Si, xi = !1, wi = null, ki = null, Pi = !1, Ei = null, _i = 0, Ci = 0, zi = null, Ni = -1, Ii = 0;
        function Ti() {
            return 0 != (6 & ri) ? Hn() : -1 !== Ni ? Ni : Ni = Hn();
        }
        function Ri(e1) {
            return 0 == (1 & e1.mode) ? 1 : 0 != (2 & ri) && 0 !== ii ? ii & -ii : null !== zt.transition ? (0 === Ii && (Ii = Rn()), Ii) : 0 !== (e1 = Mn) ? e1 : Z();
        }
        function Oi(e1, n, t, r) {
            if (50 < Ci) throw Ci = 0, zi = null, Error(a(185));
            jn(e1, t, r), 0 != (2 & ri) && e1 === li || (e1 === li && (0 == (2 & ri) && (di |= t), 4 === si && Ui(e1, ii)), ji(e1, r), 1 === t && 0 === ri && 0 == (1 & n.mode) && (bi(), Kn && et()));
        }
        function ji(e1, n) {
            var t = e1.callbackNode;
            !function(e1, n) {
                for(var t = e1.suspendedLanes, r = e1.pingedLanes, l = e1.expirationTimes, a = e1.pendingLanes; 0 < a;){
                    var i = 31 - kn(a), o = 1 << i, u = l[i];
                    -1 === u ? 0 != (o & t) && 0 == (o & r) || (l[i] = In(o, n)) : u <= n && (e1.expiredLanes |= o), a &= ~o;
                }
            }(e1, n);
            var r = Nn(e1, e1 === li ? ii : 0);
            if (0 === r) null !== t && Fn(t), e1.callbackNode = null, e1.callbackPriority = 0;
            else if (n = r & -r, e1.callbackPriority !== n) {
                if (null != t && Fn(t), 1 === n) 0 === e1.tag ? function(e1) {
                    Kn = !0, Zn(e1);
                }(Fi.bind(null, e1)) : Zn(Fi.bind(null, e1)), ne ? te(function() {
                    0 == (6 & ri) && et();
                }) : Un(Bn, et), t = null;
                else {
                    switch(Dn(r)){
                        case 1:
                            t = Bn;
                            break;
                        case 4:
                            t = Wn;
                            break;
                        case 16:
                        default:
                            t = $n;
                            break;
                        case 536870912:
                            t = Vn;
                    }
                    t = ao(t, Li.bind(null, e1));
                }
                e1.callbackPriority = n, e1.callbackNode = t;
            }
        }
        function Li(e1, n) {
            if (Ni = -1, Ii = 0, 0 != (6 & ri)) throw Error(a(327));
            var t = e1.callbackNode;
            if (Ji() && e1.callbackNode !== t) return null;
            var r = Nn(e1, e1 === li ? ii : 0);
            if (0 === r) return null;
            if (0 != (30 & r) || 0 != (r & e1.expiredLanes) || n) n = Vi(e1, r);
            else {
                n = r;
                var l = ri;
                ri |= 2;
                var i = Wi();
                for(li === e1 && ii === n || (yi = null, bi(), Hi(e1, n));;)try {
                    qi();
                    break;
                } catch (n) {
                    Bi(e1, n);
                }
                Mt(), ei.current = i, ri = l, null !== ai ? n = 0 : (li = null, ii = 0, n = si);
            }
            if (0 !== n) {
                if (2 === n && 0 !== (l = Tn(e1)) && (r = l, n = Mi(e1, l)), 1 === n) throw t = ci, Hi(e1, 0), Ui(e1, r), ji(e1, Hn()), t;
                if (6 === n) Ui(e1, r);
                else {
                    if (l = e1.current.alternate, 0 == (30 & r) && !function(e1) {
                        for(var n = e1;;){
                            if (16384 & n.flags) {
                                var t = n.updateQueue;
                                if (null !== t && null !== (t = t.stores)) for(var r = 0; r < t.length; r++){
                                    var l = t[r], a = l.getSnapshot;
                                    l = l.value;
                                    try {
                                        if (!Gn(a(), l)) return !1;
                                    } catch (e1) {
                                        return !1;
                                    }
                                }
                            }
                            if (t = n.child, 16384 & n.subtreeFlags && null !== t) t.return = n, n = t;
                            else {
                                if (n === e1) break;
                                for(; null === n.sibling;){
                                    if (null === n.return || n.return === e1) return !0;
                                    n = n.return;
                                }
                                n.sibling.return = n.return, n = n.sibling;
                            }
                        }
                        return !0;
                    }(l) && (2 === (n = Vi(e1, r)) && 0 !== (i = Tn(e1)) && (r = i, n = Mi(e1, i)), 1 === n)) throw t = ci, Hi(e1, 0), Ui(e1, r), ji(e1, Hn()), t;
                    switch(e1.finishedWork = l, e1.finishedLanes = r, n){
                        case 0:
                        case 1:
                            throw Error(a(345));
                        case 2:
                        case 5:
                            Ki(e1, hi, yi);
                            break;
                        case 3:
                            if (Ui(e1, r), (130023424 & r) === r && 10 < (n = gi + 500 - Hn())) {
                                if (0 !== Nn(e1, 0)) break;
                                if (((l = e1.suspendedLanes) & r) !== r) {
                                    Ti(), e1.pingedLanes |= e1.suspendedLanes & l;
                                    break;
                                }
                                e1.timeoutHandle = W(Ki.bind(null, e1, hi, yi), n);
                                break;
                            }
                            Ki(e1, hi, yi);
                            break;
                        case 4:
                            if (Ui(e1, r), (4194240 & r) === r) break;
                            for(n = e1.eventTimes, l = -1; 0 < r;){
                                var o = 31 - kn(r);
                                i = 1 << o, (o = n[o]) > l && (l = o), r &= ~i;
                            }
                            if (r = l, 10 < (r = (120 > (r = Hn() - r) ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * Za(r / 1960)) - r)) {
                                e1.timeoutHandle = W(Ki.bind(null, e1, hi, yi), r);
                                break;
                            }
                            Ki(e1, hi, yi);
                            break;
                        default:
                            throw Error(a(329));
                    }
                }
            }
            return ji(e1, Hn()), e1.callbackNode === t ? Li.bind(null, e1) : null;
        }
        function Mi(e1, n) {
            var t = mi;
            return e1.current.memoizedState.isDehydrated && (Hi(e1, n).flags |= 256), 2 !== (e1 = Vi(e1, n)) && (n = hi, hi = t, null !== n && Di(n)), e1;
        }
        function Di(e1) {
            null === hi ? hi = e1 : hi.push.apply(hi, e1);
        }
        function Ui(e1, n) {
            for(n &= ~pi, n &= ~di, e1.suspendedLanes |= n, e1.pingedLanes &= ~n, e1 = e1.expirationTimes; 0 < n;){
                var t = 31 - kn(n), r = 1 << t;
                e1[t] = -1, n &= ~r;
            }
        }
        function Fi(e1) {
            if (0 != (6 & ri)) throw Error(a(327));
            Ji();
            var n = Nn(e1, 0);
            if (0 == (1 & n)) return ji(e1, Hn()), null;
            var t = Vi(e1, n);
            if (0 !== e1.tag && 2 === t) {
                var r = Tn(e1);
                0 !== r && (n = r, t = Mi(e1, r));
            }
            if (1 === t) throw t = ci, Hi(e1, 0), Ui(e1, n), ji(e1, Hn()), t;
            if (6 === t) throw Error(a(345));
            return e1.finishedWork = e1.current.alternate, e1.finishedLanes = n, Ki(e1, hi, yi), ji(e1, Hn()), null;
        }
        function Ai(e1) {
            null !== Ei && 0 === Ei.tag && 0 == (6 & ri) && Ji();
            var n = ri;
            ri |= 1;
            var t = ti.transition, r = Mn;
            try {
                if (ti.transition = null, Mn = 1, e1) return e1();
            } finally{
                Mn = r, ti.transition = t, 0 == (6 & (ri = n)) && et();
            }
        }
        function Qi() {
            oi = ui.current, cn(ui);
        }
        function Hi(e1, n) {
            e1.finishedWork = null, e1.finishedLanes = 0;
            var t = e1.timeoutHandle;
            if (t !== V && (e1.timeoutHandle = V, $(t)), null !== ai) for(t = ai.return; null !== t;){
                var r = t;
                switch(pt(r), r.tag){
                    case 1:
                        null != (r = r.type.childContextTypes) && yn();
                        break;
                    case 3:
                        Sr(), cn(mn), cn(pn), _r();
                        break;
                    case 5:
                        wr(r);
                        break;
                    case 4:
                        Sr();
                        break;
                    case 13:
                    case 19:
                        cn(kr);
                        break;
                    case 10:
                        Ut(r.type._context);
                        break;
                    case 22:
                    case 23:
                        Qi();
                }
                t = t.return;
            }
            if (li = e1, ai = e1 = so(e1.current, null), ii = oi = n, si = 0, ci = null, pi = di = fi = 0, hi = mi = null, null !== Ht) {
                for(n = 0; n < Ht.length; n++)if (null !== (r = (t = Ht[n]).interleaved)) {
                    t.interleaved = null;
                    var l = r.next, a = t.pending;
                    if (null !== a) {
                        var i = a.next;
                        a.next = l, r.next = i;
                    }
                    t.pending = r;
                }
                Ht = null;
            }
            return e1;
        }
        function Bi(e1, n) {
            for(;;){
                var t = ai;
                try {
                    if (Mt(), Cr.current = xl, Or) {
                        for(var r = Ir.memoizedState; null !== r;){
                            var l = r.queue;
                            null !== l && (l.pending = null), r = r.next;
                        }
                        Or = !1;
                    }
                    if (Nr = 0, Rr = Tr = Ir = null, jr = !1, Lr = 0, ni.current = null, null === t || null === t.return) {
                        si = 1, ci = n, ai = null;
                        break;
                    }
                    e: {
                        var i = e1, o = t.return, u = t, s = n;
                        if (n = ii, u.flags |= 32768, null !== s && "object" == typeof s && "function" == typeof s.then) {
                            var c = s, f = u, d = f.tag;
                            if (0 == (1 & f.mode) && (0 === d || 11 === d || 15 === d)) {
                                var p = f.alternate;
                                p ? (f.updateQueue = p.updateQueue, f.memoizedState = p.memoizedState, f.lanes = p.lanes) : (f.updateQueue = null, f.memoizedState = null);
                            }
                            var m = Rl(o);
                            if (null !== m) {
                                m.flags &= -257, Ol(m, o, u, 0, n), 1 & m.mode && Tl(i, c, n), s = c;
                                var h = (n = m).updateQueue;
                                if (null === h) {
                                    var g = new Set;
                                    g.add(s), n.updateQueue = g;
                                } else h.add(s);
                                break e;
                            }
                            if (0 == (1 & n)) {
                                Tl(i, c, n), $i();
                                break e;
                            }
                            s = Error(a(426));
                        } else if (gt && 1 & u.mode) {
                            var v = Rl(o);
                            if (null !== v) {
                                0 == (65536 & v.flags) && (v.flags |= 256), Ol(v, o, u, 0, n), Ct(El(s, u));
                                break e;
                            }
                        }
                        i = s = El(s, u), 4 !== si && (si = 2), null === mi ? mi = [
                            i
                        ] : mi.push(i), i = o;
                        do {
                            switch(i.tag){
                                case 3:
                                    i.flags |= 65536, n &= -n, i.lanes |= n, Jt(i, Nl(0, s, n));
                                    break e;
                                case 1:
                                    u = s;
                                    var y = i.type, b = i.stateNode;
                                    if (0 == (128 & i.flags) && ("function" == typeof y.getDerivedStateFromError || null !== b && "function" == typeof b.componentDidCatch && (null === ki || !ki.has(b)))) {
                                        i.flags |= 65536, n &= -n, i.lanes |= n, Jt(i, Il(i, u, n));
                                        break e;
                                    }
                            }
                            i = i.return;
                        }while (null !== i);
                    }
                    Yi(t);
                } catch (e1) {
                    n = e1, ai === t && null !== t && (ai = t = t.return);
                    continue;
                }
                break;
            }
        }
        function Wi() {
            var e1 = ei.current;
            return ei.current = xl, null === e1 ? xl : e1;
        }
        function $i() {
            0 !== si && 3 !== si && 2 !== si || (si = 4), null === li || 0 == (268435455 & fi) && 0 == (268435455 & di) || Ui(li, ii);
        }
        function Vi(e1, n) {
            var t = ri;
            ri |= 2;
            var r = Wi();
            for(li === e1 && ii === n || (yi = null, Hi(e1, n));;)try {
                Xi();
                break;
            } catch (n) {
                Bi(e1, n);
            }
            if (Mt(), ri = t, ei.current = r, null !== ai) throw Error(a(261));
            return li = null, ii = 0, si;
        }
        function Xi() {
            for(; null !== ai;)Gi(ai);
        }
        function qi() {
            for(; null !== ai && !An();)Gi(ai);
        }
        function Gi(e1) {
            var n = Si(e1.alternate, e1, oi);
            e1.memoizedProps = e1.pendingProps, null === n ? Yi(e1) : ai = n, ni.current = null;
        }
        function Yi(e1) {
            var n = e1;
            do {
                var t = n.alternate;
                if (e1 = n.return, 0 == (32768 & n.flags)) {
                    if (null !== (t = da(t, n, oi))) return void (ai = t);
                } else {
                    if (null !== (t = pa(t, n))) return t.flags &= 32767, void (ai = t);
                    if (null === e1) return si = 6, void (ai = null);
                    e1.flags |= 32768, e1.subtreeFlags = 0, e1.deletions = null;
                }
                if (null !== (n = n.sibling)) return void (ai = n);
                ai = n = e1;
            }while (null !== n);
            0 === si && (si = 5);
        }
        function Ki(e1, n, t) {
            var r = Mn, l = ti.transition;
            try {
                ti.transition = null, Mn = 1, function(e1, n, t, r) {
                    do Ji();
                    while (null !== Ei);
                    if (0 != (6 & ri)) throw Error(a(327));
                    t = e1.finishedWork;
                    var l = e1.finishedLanes;
                    if (null === t) return null;
                    if (e1.finishedWork = null, e1.finishedLanes = 0, t === e1.current) throw Error(a(177));
                    e1.callbackNode = null, e1.callbackPriority = 0;
                    var i = t.lanes | t.childLanes;
                    if (function(e1, n) {
                        var t = e1.pendingLanes & ~n;
                        e1.pendingLanes = n, e1.suspendedLanes = 0, e1.pingedLanes = 0, e1.expiredLanes &= n, e1.mutableReadLanes &= n, e1.entangledLanes &= n, n = e1.entanglements;
                        var r = e1.eventTimes;
                        for(e1 = e1.expirationTimes; 0 < t;){
                            var l = 31 - kn(t), a = 1 << l;
                            n[l] = 0, r[l] = -1, e1[l] = -1, t &= ~a;
                        }
                    }(e1, i), e1 === li && (ai = li = null, ii = 0), 0 == (2064 & t.subtreeFlags) && 0 == (2064 & t.flags) || Pi || (Pi = !0, ao($n, function() {
                        return Ji(), null;
                    })), i = 0 != (15990 & t.flags), 0 != (15990 & t.subtreeFlags) || i) {
                        i = ti.transition, ti.transition = null;
                        var o = Mn;
                        Mn = 1;
                        var u = ri;
                        ri |= 4, ni.current = null, function(e1, n) {
                            for(M(e1.containerInfo), va = n; null !== va;)if (n = (e1 = va).child, 0 != (1028 & e1.subtreeFlags) && null !== n) n.return = e1, va = n;
                            else for(; null !== va;){
                                e1 = va;
                                try {
                                    var t = e1.alternate;
                                    if (0 != (1024 & e1.flags)) switch(e1.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                        case 5:
                                        case 6:
                                        case 4:
                                        case 17:
                                            break;
                                        case 1:
                                            if (null !== t) {
                                                var r = t.memoizedProps, l = t.memoizedState, i = e1.stateNode, o = i.getSnapshotBeforeUpdate(e1.elementType === e1.type ? r : Tt(e1.type, r), l);
                                                i.__reactInternalSnapshotBeforeUpdate = o;
                                            }
                                            break;
                                        case 3:
                                            q && Ee(e1.stateNode.containerInfo);
                                            break;
                                        default:
                                            throw Error(a(163));
                                    }
                                } catch (n) {
                                    eo(e1, e1.return, n);
                                }
                                if (null !== (n = e1.sibling)) {
                                    n.return = e1.return, va = n;
                                    break;
                                }
                                va = e1.return;
                            }
                            t = Sa, Sa = !1;
                        }(e1, t), La(t, e1), D(e1.containerInfo), e1.current = t, Da(t), Qn(), ri = u, Mn = o, ti.transition = i;
                    } else e1.current = t;
                    if (Pi && (Pi = !1, Ei = e1, _i = l), i = e1.pendingLanes, 0 === i && (ki = null), function(e1) {
                        if (qn && "function" == typeof qn.onCommitFiberRoot) try {
                            qn.onCommitFiberRoot(Xn, e1, void 0, 128 == (128 & e1.current.flags));
                        } catch (e1) {}
                    }(t.stateNode), ji(e1, Hn()), null !== n) for(r = e1.onRecoverableError, t = 0; t < n.length; t++)l = n[t], r(l.value, {
                        componentStack: l.stack,
                        digest: l.digest
                    });
                    if (xi) throw xi = !1, e1 = wi, wi = null, e1;
                    0 != (1 & _i) && 0 !== e1.tag && Ji(), i = e1.pendingLanes, 0 != (1 & i) ? e1 === zi ? Ci++ : (Ci = 0, zi = e1) : Ci = 0, et();
                }(e1, n, t, r);
            } finally{
                ti.transition = l, Mn = r;
            }
            return null;
        }
        function Ji() {
            if (null !== Ei) {
                var e1 = Dn(_i), n = ti.transition, t = Mn;
                try {
                    if (ti.transition = null, Mn = 16 > e1 ? 16 : e1, null === Ei) var r = !1;
                    else {
                        if (e1 = Ei, Ei = null, _i = 0, 0 != (6 & ri)) throw Error(a(331));
                        var l = ri;
                        for(ri |= 4, va = e1.current; null !== va;){
                            var i = va, o = i.child;
                            if (0 != (16 & va.flags)) {
                                var u = i.deletions;
                                if (null !== u) {
                                    for(var s = 0; s < u.length; s++){
                                        var c = u[s];
                                        for(va = c; null !== va;){
                                            var f = va;
                                            switch(f.tag){
                                                case 0:
                                                case 11:
                                                case 15:
                                                    xa(8, f, i);
                                            }
                                            var d = f.child;
                                            if (null !== d) d.return = f, va = d;
                                            else for(; null !== va;){
                                                var p = (f = va).sibling, m = f.return;
                                                if (Pa(f), f === c) {
                                                    va = null;
                                                    break;
                                                }
                                                if (null !== p) {
                                                    p.return = m, va = p;
                                                    break;
                                                }
                                                va = m;
                                            }
                                        }
                                    }
                                    var h = i.alternate;
                                    if (null !== h) {
                                        var g = h.child;
                                        if (null !== g) {
                                            h.child = null;
                                            do {
                                                var v = g.sibling;
                                                g.sibling = null, g = v;
                                            }while (null !== g);
                                        }
                                    }
                                    va = i;
                                }
                            }
                            if (0 != (2064 & i.subtreeFlags) && null !== o) o.return = i, va = o;
                            else e: for(; null !== va;){
                                if (0 != (2048 & (i = va).flags)) switch(i.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        xa(9, i, i.return);
                                }
                                var y = i.sibling;
                                if (null !== y) {
                                    y.return = i.return, va = y;
                                    break e;
                                }
                                va = i.return;
                            }
                        }
                        var b = e1.current;
                        for(va = b; null !== va;){
                            var S = (o = va).child;
                            if (0 != (2064 & o.subtreeFlags) && null !== S) S.return = o, va = S;
                            else e: for(o = b; null !== va;){
                                if (0 != (2048 & (u = va).flags)) try {
                                    switch(u.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            wa(9, u);
                                    }
                                } catch (e1) {
                                    eo(u, u.return, e1);
                                }
                                if (u === o) {
                                    va = null;
                                    break e;
                                }
                                var x = u.sibling;
                                if (null !== x) {
                                    x.return = u.return, va = x;
                                    break e;
                                }
                                va = u.return;
                            }
                        }
                        if (ri = l, et(), qn && "function" == typeof qn.onPostCommitFiberRoot) try {
                            qn.onPostCommitFiberRoot(Xn, e1);
                        } catch (e1) {}
                        r = !0;
                    }
                    return r;
                } finally{
                    Mn = t, ti.transition = n;
                }
            }
            return !1;
        }
        function Zi(e1, n, t) {
            e1 = Yt(e1, n = Nl(0, n = El(t, n), 1), 1), n = Ti(), null !== e1 && (jn(e1, 1, n), ji(e1, n));
        }
        function eo(e1, n, t) {
            if (3 === e1.tag) Zi(e1, e1, t);
            else for(; null !== n;){
                if (3 === n.tag) {
                    Zi(n, e1, t);
                    break;
                }
                if (1 === n.tag) {
                    var r = n.stateNode;
                    if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === ki || !ki.has(r))) {
                        n = Yt(n, e1 = Il(n, e1 = El(t, e1), 1), 1), e1 = Ti(), null !== n && (jn(n, 1, e1), ji(n, e1));
                        break;
                    }
                }
                n = n.return;
            }
        }
        function no(e1, n, t) {
            var r = e1.pingCache;
            null !== r && r.delete(n), n = Ti(), e1.pingedLanes |= e1.suspendedLanes & t, li === e1 && (ii & t) === t && (4 === si || 3 === si && (130023424 & ii) === ii && 500 > Hn() - gi ? Hi(e1, 0) : pi |= t), ji(e1, n);
        }
        function to(e1, n) {
            0 === n && (0 == (1 & e1.mode) ? n = 1 : (n = Cn, 0 == (130023424 & (Cn <<= 1)) && (Cn = 4194304)));
            var t = Ti();
            null !== (e1 = $t(e1, n)) && (jn(e1, n, t), ji(e1, t));
        }
        function ro(e1) {
            var n = e1.memoizedState, t = 0;
            null !== n && (t = n.retryLane), to(e1, t);
        }
        function lo(e1, n) {
            var t = 0;
            switch(e1.tag){
                case 13:
                    var r = e1.stateNode, l = e1.memoizedState;
                    null !== l && (t = l.retryLane);
                    break;
                case 19:
                    r = e1.stateNode;
                    break;
                default:
                    throw Error(a(314));
            }
            null !== r && r.delete(n), to(e1, t);
        }
        function ao(e1, n) {
            return Un(e1, n);
        }
        function io(e1, n, t, r) {
            this.tag = e1, this.key = t, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = n, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
        }
        function oo(e1, n, t, r) {
            return new io(e1, n, t, r);
        }
        function uo(e1) {
            return !(!(e1 = e1.prototype) || !e1.isReactComponent);
        }
        function so(e1, n) {
            var t = e1.alternate;
            return null === t ? ((t = oo(e1.tag, n, e1.key, e1.mode)).elementType = e1.elementType, t.type = e1.type, t.stateNode = e1.stateNode, t.alternate = e1, e1.alternate = t) : (t.pendingProps = n, t.type = e1.type, t.flags = 0, t.subtreeFlags = 0, t.deletions = null), t.flags = 14680064 & e1.flags, t.childLanes = e1.childLanes, t.lanes = e1.lanes, t.child = e1.child, t.memoizedProps = e1.memoizedProps, t.memoizedState = e1.memoizedState, t.updateQueue = e1.updateQueue, n = e1.dependencies, t.dependencies = null === n ? null : {
                lanes: n.lanes,
                firstContext: n.firstContext
            }, t.sibling = e1.sibling, t.index = e1.index, t.ref = e1.ref, t;
        }
        function co(e1, n, t, r, l, i) {
            var o = 2;
            if (r = e1, "function" == typeof e1) uo(e1) && (o = 1);
            else if ("string" == typeof e1) o = 5;
            else e: switch(e1){
                case s:
                    return fo(t.children, l, i, n);
                case c:
                    o = 8, l |= 8;
                    break;
                case f:
                    return (e1 = oo(12, t, n, 2 | l)).elementType = f, e1.lanes = i, e1;
                case h:
                    return (e1 = oo(13, t, n, l)).elementType = h, e1.lanes = i, e1;
                case v:
                    return (e1 = oo(19, t, n, l)).elementType = v, e1.lanes = i, e1;
                case S:
                    return po(t, l, i, n);
                default:
                    if ("object" == typeof e1 && null !== e1) switch(e1.$$typeof){
                        case d:
                            o = 10;
                            break e;
                        case p:
                            o = 9;
                            break e;
                        case m:
                            o = 11;
                            break e;
                        case y:
                            o = 14;
                            break e;
                        case b:
                            o = 16, r = null;
                            break e;
                    }
                    throw Error(a(130, null == e1 ? e1 : typeof e1, ""));
            }
            return (n = oo(o, t, n, l)).elementType = e1, n.type = r, n.lanes = i, n;
        }
        function fo(e1, n, t, r) {
            return (e1 = oo(7, e1, r, n)).lanes = t, e1;
        }
        function po(e1, n, t, r) {
            return (e1 = oo(22, e1, r, n)).elementType = S, e1.lanes = t, e1.stateNode = {
                isHidden: !1
            }, e1;
        }
        function mo(e1, n, t) {
            return (e1 = oo(6, e1, null, n)).lanes = t, e1;
        }
        function ho(e1, n, t) {
            return (n = oo(4, null !== e1.children ? e1.children : [], e1.key, n)).lanes = t, n.stateNode = {
                containerInfo: e1.containerInfo,
                pendingChildren: null,
                implementation: e1.implementation
            }, n;
        }
        function go(e1, n, t, r, l) {
            this.tag = n, this.containerInfo = e1, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = V, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = On(0), this.expirationTimes = On(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = On(0), this.identifierPrefix = r, this.onRecoverableError = l, Y && (this.mutableSourceEagerHydrationData = null);
        }
        function vo(e1, n, t, r, l, a, i, o, u) {
            return e1 = new go(e1, n, t, o, u), 1 === n ? (n = 1, !0 === a && (n |= 8)) : n = 0, a = oo(3, null, null, n), e1.current = a, a.stateNode = e1, a.memoizedState = {
                element: r,
                isDehydrated: t,
                cache: null,
                transitions: null,
                pendingSuspenseBoundaries: null
            }, Xt(a), e1;
        }
        function yo(e1) {
            if (!e1) return dn;
            e: {
                if (E(e1 = e1._reactInternals) !== e1 || 1 !== e1.tag) throw Error(a(170));
                var n = e1;
                do {
                    switch(n.tag){
                        case 3:
                            n = n.stateNode.context;
                            break e;
                        case 1:
                            if (vn(n.type)) {
                                n = n.stateNode.__reactInternalMemoizedMergedChildContext;
                                break e;
                            }
                    }
                    n = n.return;
                }while (null !== n);
                throw Error(a(171));
            }
            if (1 === e1.tag) {
                var t = e1.type;
                if (vn(t)) return Sn(e1, t, n);
            }
            return n;
        }
        function bo(e1) {
            var n = e1._reactInternals;
            if (void 0 === n) {
                if ("function" == typeof e1.render) throw Error(a(188));
                throw e1 = Object.keys(e1).join(","), Error(a(268, e1));
            }
            return null === (e1 = z(n)) ? null : e1.stateNode;
        }
        function So(e1, n) {
            if (null !== (e1 = e1.memoizedState) && null !== e1.dehydrated) {
                var t = e1.retryLane;
                e1.retryLane = 0 !== t && t < n ? t : n;
            }
        }
        function xo(e1, n) {
            So(e1, n), (e1 = e1.alternate) && So(e1, n);
        }
        function wo(e1) {
            return null === (e1 = z(e1)) ? null : e1.stateNode;
        }
        function ko() {
            return null;
        }
        return Si = function(e1, n, t) {
            if (null !== e1) {
                if (e1.memoizedProps !== n.pendingProps || mn.current) Ll = !0;
                else {
                    if (0 == (e1.lanes & t) && 0 == (128 & n.flags)) return Ll = !1, function(e1, n, t) {
                        switch(n.tag){
                            case 3:
                                $l(n), _t();
                                break;
                            case 5:
                                xr(n);
                                break;
                            case 1:
                                vn(n.type) && xn(n);
                                break;
                            case 4:
                                br(n, n.stateNode.containerInfo);
                                break;
                            case 10:
                                Dt(0, n.type._context, n.memoizedProps.value);
                                break;
                            case 13:
                                var r = n.memoizedState;
                                if (null !== r) return null !== r.dehydrated ? (fn(kr, 1 & kr.current), n.flags |= 128, null) : 0 != (t & n.child.childLanes) ? Zl(e1, n, t) : (fn(kr, 1 & kr.current), null !== (e1 = ia(e1, n, t)) ? e1.sibling : null);
                                fn(kr, 1 & kr.current);
                                break;
                            case 19:
                                if (r = 0 != (t & n.childLanes), 0 != (128 & e1.flags)) {
                                    if (r) return la(e1, n, t);
                                    n.flags |= 128;
                                }
                                var l = n.memoizedState;
                                if (null !== l && (l.rendering = null, l.tail = null, l.lastEffect = null), fn(kr, kr.current), r) break;
                                return null;
                            case 22:
                            case 23:
                                return n.lanes = 0, Al(e1, n, t);
                        }
                        return ia(e1, n, t);
                    }(e1, n, t);
                    Ll = 0 != (131072 & e1.flags);
                }
            } else Ll = !1, gt && 0 != (1048576 & n.flags) && ft(n, lt, n.index);
            switch(n.lanes = 0, n.tag){
                case 2:
                    var r = n.type;
                    aa(e1, n), e1 = n.pendingProps;
                    var l = gn(n, pn.current);
                    At(n, t), l = Fr(null, n, r, e1, l, t);
                    var i = Ar();
                    return n.flags |= 1, "object" == typeof l && null !== l && "function" == typeof l.render && void 0 === l.$$typeof ? (n.tag = 1, n.memoizedState = null, n.updateQueue = null, vn(r) ? (i = !0, xn(n)) : i = !1, n.memoizedState = null !== l.state && void 0 !== l.state ? l.state : null, Xt(n), l.updater = rr, n.stateNode = l, l._reactInternals = n, or(n, r, e1, t), n = Wl(null, n, r, !0, i, t)) : (n.tag = 0, gt && i && dt(n), Ml(null, n, l, t), n = n.child), n;
                case 16:
                    r = n.elementType;
                    e: {
                        switch(aa(e1, n), e1 = n.pendingProps, r = (l = r._init)(r._payload), n.type = r, l = n.tag = function(e1) {
                            if ("function" == typeof e1) return uo(e1) ? 1 : 0;
                            if (null != e1) {
                                if ((e1 = e1.$$typeof) === m) return 11;
                                if (e1 === y) return 14;
                            }
                            return 2;
                        }(r), e1 = Tt(r, e1), l){
                            case 0:
                                n = Hl(null, n, r, e1, t);
                                break e;
                            case 1:
                                n = Bl(null, n, r, e1, t);
                                break e;
                            case 11:
                                n = Dl(null, n, r, e1, t);
                                break e;
                            case 14:
                                n = Ul(null, n, r, Tt(r.type, e1), t);
                                break e;
                        }
                        throw Error(a(306, r, ""));
                    }
                    return n;
                case 0:
                    return r = n.type, l = n.pendingProps, Hl(e1, n, r, l = n.elementType === r ? l : Tt(r, l), t);
                case 1:
                    return r = n.type, l = n.pendingProps, Bl(e1, n, r, l = n.elementType === r ? l : Tt(r, l), t);
                case 3:
                    e: {
                        if ($l(n), null === e1) throw Error(a(387));
                        r = n.pendingProps, l = (i = n.memoizedState).element, qt(e1, n), Zt(n, r, null, t);
                        var o = n.memoizedState;
                        if (r = o.element, Y && i.isDehydrated) {
                            if (i = {
                                element: r,
                                isDehydrated: !1,
                                cache: o.cache,
                                pendingSuspenseBoundaries: o.pendingSuspenseBoundaries,
                                transitions: o.transitions
                            }, n.updateQueue.baseState = i, n.memoizedState = i, 256 & n.flags) {
                                n = Vl(e1, n, r, t, l = El(Error(a(423)), n));
                                break e;
                            }
                            if (r !== l) {
                                n = Vl(e1, n, r, t, l = El(Error(a(424)), n));
                                break e;
                            }
                            for(Y && (ht = Be(n.stateNode.containerInfo), mt = n, gt = !0, yt = null, vt = !1), t = pr(n, null, r, t), n.child = t; t;)t.flags = -3 & t.flags | 4096, t = t.sibling;
                        } else {
                            if (_t(), r === l) {
                                n = ia(e1, n, t);
                                break e;
                            }
                            Ml(e1, n, r, t);
                        }
                        n = n.child;
                    }
                    return n;
                case 5:
                    return xr(n), null === e1 && wt(n), r = n.type, l = n.pendingProps, i = null !== e1 ? e1.memoizedProps : null, o = l.children, H(r, l) ? o = null : null !== i && H(r, i) && (n.flags |= 32), Ql(e1, n), Ml(e1, n, o, t), n.child;
                case 6:
                    return null === e1 && wt(n), null;
                case 13:
                    return Zl(e1, n, t);
                case 4:
                    return br(n, n.stateNode.containerInfo), r = n.pendingProps, null === e1 ? n.child = dr(n, null, r, t) : Ml(e1, n, r, t), n.child;
                case 11:
                    return r = n.type, l = n.pendingProps, Dl(e1, n, r, l = n.elementType === r ? l : Tt(r, l), t);
                case 7:
                    return Ml(e1, n, n.pendingProps, t), n.child;
                case 8:
                case 12:
                    return Ml(e1, n, n.pendingProps.children, t), n.child;
                case 10:
                    e: {
                        if (r = n.type._context, l = n.pendingProps, i = n.memoizedProps, Dt(0, r, o = l.value), null !== i) {
                            if (Gn(i.value, o)) {
                                if (i.children === l.children && !mn.current) {
                                    n = ia(e1, n, t);
                                    break e;
                                }
                            } else for(null !== (i = n.child) && (i.return = n); null !== i;){
                                var u = i.dependencies;
                                if (null !== u) {
                                    o = i.child;
                                    for(var s = u.firstContext; null !== s;){
                                        if (s.context === r) {
                                            if (1 === i.tag) {
                                                (s = Gt(-1, t & -t)).tag = 2;
                                                var c = i.updateQueue;
                                                if (null !== c) {
                                                    var f = (c = c.shared).pending;
                                                    null === f ? s.next = s : (s.next = f.next, f.next = s), c.pending = s;
                                                }
                                            }
                                            i.lanes |= t, null !== (s = i.alternate) && (s.lanes |= t), Ft(i.return, t, n), u.lanes |= t;
                                            break;
                                        }
                                        s = s.next;
                                    }
                                } else if (10 === i.tag) o = i.type === n.type ? null : i.child;
                                else if (18 === i.tag) {
                                    if (null === (o = i.return)) throw Error(a(341));
                                    o.lanes |= t, null !== (u = o.alternate) && (u.lanes |= t), Ft(o, t, n), o = i.sibling;
                                } else o = i.child;
                                if (null !== o) o.return = i;
                                else for(o = i; null !== o;){
                                    if (o === n) {
                                        o = null;
                                        break;
                                    }
                                    if (null !== (i = o.sibling)) {
                                        i.return = o.return, o = i;
                                        break;
                                    }
                                    o = o.return;
                                }
                                i = o;
                            }
                        }
                        Ml(e1, n, l.children, t), n = n.child;
                    }
                    return n;
                case 9:
                    return l = n.type, r = n.pendingProps.children, At(n, t), r = r(l = Qt(l)), n.flags |= 1, Ml(e1, n, r, t), n.child;
                case 14:
                    return l = Tt(r = n.type, n.pendingProps), Ul(e1, n, r, l = Tt(r.type, l), t);
                case 15:
                    return Fl(e1, n, n.type, n.pendingProps, t);
                case 17:
                    return r = n.type, l = n.pendingProps, l = n.elementType === r ? l : Tt(r, l), aa(e1, n), n.tag = 1, vn(r) ? (e1 = !0, xn(n)) : e1 = !1, At(n, t), ar(n, r, l), or(n, r, l, t), Wl(null, n, r, !0, e1, t);
                case 19:
                    return la(e1, n, t);
                case 22:
                    return Al(e1, n, t);
            }
            throw Error(a(156, n.tag));
        }, n.attemptContinuousHydration = function(e1) {
            if (13 === e1.tag) {
                var n = $t(e1, 134217728);
                if (null !== n) Oi(n, e1, 134217728, Ti());
                xo(e1, 134217728);
            }
        }, n.attemptDiscreteHydration = function(e1) {
            if (13 === e1.tag) {
                var n = $t(e1, 1);
                if (null !== n) Oi(n, e1, 1, Ti());
                xo(e1, 1);
            }
        }, n.attemptHydrationAtCurrentPriority = function(e1) {
            if (13 === e1.tag) {
                var n = Ri(e1), t = $t(e1, n);
                if (null !== t) Oi(t, e1, n, Ti());
                xo(e1, n);
            }
        }, n.attemptSynchronousHydration = function(e1) {
            switch(e1.tag){
                case 3:
                    var n = e1.stateNode;
                    if (n.current.memoizedState.isDehydrated) {
                        var t = zn(n.pendingLanes);
                        0 !== t && (Ln(n, 1 | t), ji(n, Hn()), 0 == (6 & ri) && (bi(), et()));
                    }
                    break;
                case 13:
                    Ai(function() {
                        var n = $t(e1, 1);
                        if (null !== n) {
                            var t = Ti();
                            Oi(n, e1, 1, t);
                        }
                    }), xo(e1, 1);
            }
        }, n.batchedUpdates = function(e1, n) {
            var t = ri;
            ri |= 1;
            try {
                return e1(n);
            } finally{
                0 === (ri = t) && (bi(), Kn && et());
            }
        }, n.createComponentSelector = function(e1) {
            return {
                $$typeof: Ha,
                value: e1
            };
        }, n.createContainer = function(e1, n, t, r, l, a, i) {
            return vo(e1, n, !1, null, 0, r, 0, a, i);
        }, n.createHasPseudoClassSelector = function(e1) {
            return {
                $$typeof: Ba,
                value: e1
            };
        }, n.createHydrationContainer = function(e1, n, t, r, l, a, i, o, u) {
            return (e1 = vo(t, r, !0, e1, 0, a, 0, o, u)).context = yo(null), t = e1.current, (a = Gt(r = Ti(), l = Ri(t))).callback = null != n ? n : null, Yt(t, a, l), e1.current.lanes = l, jn(e1, l, r), ji(e1, r), e1;
        }, n.createPortal = function(e1, n, t) {
            var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
            return {
                $$typeof: u,
                key: null == r ? null : "" + r,
                children: e1,
                containerInfo: n,
                implementation: t
            };
        }, n.createRoleSelector = function(e1) {
            return {
                $$typeof: Wa,
                value: e1
            };
        }, n.createTestNameSelector = function(e1) {
            return {
                $$typeof: $a,
                value: e1
            };
        }, n.createTextSelector = function(e1) {
            return {
                $$typeof: Va,
                value: e1
            };
        }, n.deferredUpdates = function(e1) {
            var n = Mn, t = ti.transition;
            try {
                return ti.transition = null, Mn = 16, e1();
            } finally{
                Mn = n, ti.transition = t;
            }
        }, n.discreteUpdates = function(e1, n, t, r, l) {
            var a = Mn, i = ti.transition;
            try {
                return ti.transition = null, Mn = 1, e1(n, t, r, l);
            } finally{
                Mn = a, ti.transition = i, 0 === ri && bi();
            }
        }, n.findAllNodes = Ja, n.findBoundingRects = function(e1, n) {
            if (!re) throw Error(a(363));
            n = Ja(e1, n), e1 = [];
            for(var t = 0; t < n.length; t++)e1.push(ae(n[t]));
            for(n = e1.length - 1; 0 < n; n--)for(var r = (t = e1[n]).x, l = r + t.width, i = t.y, o = i + t.height, u = n - 1; 0 <= u; u--)if (n !== u) {
                var s = e1[u], c = s.x, f = c + s.width, d = s.y, p = d + s.height;
                if (r >= c && i >= d && l <= f && o <= p) {
                    e1.splice(n, 1);
                    break;
                }
                if (!(r !== c || t.width !== s.width || p < i || d > o)) {
                    d > i && (s.height += d - i, s.y = i), p < o && (s.height = o - d), e1.splice(n, 1);
                    break;
                }
                if (!(i !== d || t.height !== s.height || f < r || c > l)) {
                    c > r && (s.width += c - r, s.x = r), f < l && (s.width = l - c), e1.splice(n, 1);
                    break;
                }
            }
            return e1;
        }, n.findHostInstance = bo, n.findHostInstanceWithNoPortals = function(e1) {
            return null === (e1 = null !== (e1 = C(e1)) ? I(e1) : null) ? null : e1.stateNode;
        }, n.findHostInstanceWithWarning = function(e1) {
            return bo(e1);
        }, n.flushControlled = function(e1) {
            var n = ri;
            ri |= 1;
            var t = ti.transition, r = Mn;
            try {
                ti.transition = null, Mn = 1, e1();
            } finally{
                Mn = r, ti.transition = t, 0 === (ri = n) && (bi(), et());
            }
        }, n.flushPassiveEffects = Ji, n.flushSync = Ai, n.focusWithin = function(e1, n) {
            if (!re) throw Error(a(363));
            for(n = Ka(e1 = qa(e1), n), n = Array.from(n), e1 = 0; e1 < n.length;){
                var t = n[e1++];
                if (!oe(t)) {
                    if (5 === t.tag && se(t.stateNode)) return !0;
                    for(t = t.child; null !== t;)n.push(t), t = t.sibling;
                }
            }
            return !1;
        }, n.getCurrentUpdatePriority = function() {
            return Mn;
        }, n.getFindAllNodesFailureDescription = function(e1, n) {
            if (!re) throw Error(a(363));
            var t = 0, r = [];
            e1 = [
                qa(e1),
                0
            ];
            for(var l = 0; l < e1.length;){
                var i = e1[l++], o = e1[l++], u = n[o];
                if ((5 !== i.tag || !oe(i)) && (Ga(i, u) && (r.push(Ya(u)), ++o > t && (t = o)), o < n.length)) for(i = i.child; null !== i;)e1.push(i, o), i = i.sibling;
            }
            if (t < n.length) {
                for(e1 = []; t < n.length; t++)e1.push(Ya(n[t]));
                return "findAllNodes was able to match part of the selector:\n  " + r.join(" > ") + "\n\nNo matching component was found for:\n  " + e1.join(" > ");
            }
            return null;
        }, n.getPublicRootInstance = function(e1) {
            return (e1 = e1.current).child ? 5 === e1.child.tag ? O(e1.child.stateNode) : e1.child.stateNode : null;
        }, n.injectIntoDevTools = function(e1) {
            if (e1 = {
                bundleType: e1.bundleType,
                version: e1.version,
                rendererPackageName: e1.rendererPackageName,
                rendererConfig: e1.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setErrorHandler: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: i.ReactCurrentDispatcher,
                findHostInstanceByFiber: wo,
                findFiberByHostInstance: e1.findFiberByHostInstance || ko,
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null,
                reconcilerVersion: "18.2.0"
            }, "undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) e1 = !1;
            else {
                var n = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (n.isDisabled || !n.supportsFiber) e1 = !0;
                else {
                    try {
                        Xn = n.inject(e1), qn = n;
                    } catch (e1) {}
                    e1 = !!n.checkDCE;
                }
            }
            return e1;
        }, n.isAlreadyRendering = function() {
            return !1;
        }, n.observeVisibleRects = function(e1, n, t, r) {
            if (!re) throw Error(a(363));
            e1 = Ja(e1, n);
            var l = ce(e1, t, r).disconnect;
            return {
                disconnect: function() {
                    l();
                }
            };
        }, n.registerMutableSourceForHydration = function(e1, n) {
            var t = n._getVersion;
            t = t(n._source), null == e1.mutableSourceEagerHydrationData ? e1.mutableSourceEagerHydrationData = [
                n,
                t
            ] : e1.mutableSourceEagerHydrationData.push(n, t);
        }, n.runWithPriority = function(e1, n) {
            var t = Mn;
            try {
                return Mn = e1, n();
            } finally{
                Mn = t;
            }
        }, n.shouldError = function() {
            return null;
        }, n.shouldSuspend = function() {
            return !1;
        }, n.updateContainer = function(e1, n, t, r) {
            var l = n.current, a = Ti(), i = Ri(l);
            return t = yo(t), null === n.context ? n.context = t : n.pendingContext = t, (n = Gt(a, i)).payload = {
                element: e1
            }, null !== (r = void 0 === r ? null : r) && (n.callback = r), null !== (e1 = Yt(l, n, i)) && (Oi(e1, l, i, a), Kt(e1, l, i)), i;
        }, n;
    }), $7d6602d5c01fbe8e$var$ke;
}
({
    get exports () {
        return $7d6602d5c01fbe8e$var$Ee;
    },
    set exports (e){
        $7d6602d5c01fbe8e$var$Ee = e;
    }
}).exports = $7d6602d5c01fbe8e$var$Ie();
var $7d6602d5c01fbe8e$var$Te = $7d6602d5c01fbe8e$var$T($7d6602d5c01fbe8e$var$Ee), $7d6602d5c01fbe8e$var$Re = {
    name: "root",
    private: !0,
    workspaces: [
        "packages/*"
    ],
    scripts: {
        build: "nx run-many --target=build --all --parallel",
        "build:force": "nx run-many --target=build --all --parallel --skip-nx-cache",
        "build:docs": "nx run @pixi/react-docs:deploy",
        clean: "rimraf packages/*/dist packages/*/build",
        lint: "eslint .",
        prepare: "husky install",
        prerelease: "./scripts/checkReleaseBranch.mjs && npm run lint && npm run test:force && npm run build:force",
        release: "lerna publish --no-private",
        test: "nx run-many --target=test --all --parallel",
        "test:force": "nx run-many --target=test --all --parallel --skip-nx-cache",
        "test:ci": "nx run-many --target=test:ci --all --parallel",
        "test:ci:force": "nx run-many --target=test:ci --all --parallel --skip-nx-cache",
        "test:types": "nx run-many --target=test:types --all --parallel",
        "test:types:force": "nx run-many --target=test:types --all --parallel --skip-nx-cache"
    },
    husky: {
        hooks: {
            "pre-commit": "lint-staged"
        }
    },
    "lint-staged": {
        "*.{ts,js,mjs}": [
            "eslint --cache --fix"
        ]
    },
    resolutions: {
        "get-pkg-repo": "4.1.1",
        "hosted-git-info": "^2.1.4"
    },
    dependencies: {
        "@babel/runtime": "^7.14.8",
        "@pixi/app": "^7.1.1",
        "@pixi/constants": "^7.1.1",
        "@pixi/core": "^7.1.1",
        "@pixi/display": "^7.1.1",
        "@pixi/extensions": "^7.1.1",
        "@pixi/graphics": "^7.1.1",
        "@pixi/math": "^7.1.1",
        "@pixi/mesh": "^7.1.1",
        "@pixi/mesh-extras": "^7.1.1",
        "@pixi/particle-container": "^7.1.1",
        "@pixi/sprite": "^7.1.1",
        "@pixi/sprite-animated": "^7.1.1",
        "@pixi/sprite-tiling": "^7.1.1",
        "@pixi/text": "^7.1.1",
        "@pixi/text-bitmap": "^7.1.1",
        "@pixi/ticker": "^7.1.1",
        "@react-spring/animated": "^9.6.1",
        "@react-spring/types": "^9.6.1",
        react: "^18.0.0",
        "react-dom": "^18.0.0",
        "react-reconciler": "0.29.0",
        "react-spring": "^9.6.1"
    },
    devDependencies: {
        "@babel/cli": "^7.20.7",
        "@babel/core": "^7.20.7",
        "@babel/eslint-parser": "^7.19.1",
        "@babel/plugin-transform-runtime": "^7.19.6",
        "@babel/preset-env": "^7.20.2",
        "@babel/preset-react": "^7.18.6",
        "@nrwl/nx-cloud": "latest",
        "@pixi/eslint-config": "^4.0.1",
        "@rollup/plugin-alias": "^4.0.2",
        "@rollup/plugin-babel": "^6.0.3",
        "@rollup/plugin-commonjs": "^24.0.0",
        "@rollup/plugin-json": "^6.0.0",
        "@rollup/plugin-node-resolve": "^15.0.1",
        "@rollup/plugin-replace": "^5.0.2",
        "@rollup/plugin-terser": "^0.2.1",
        "@rollup/plugin-typescript": "^10.0.1",
        "@types/jest": "^29.2.4",
        "@types/react": "17.0.15",
        "@types/react-dom": "17.0.9",
        "@types/react-reconciler": "0.28.2",
        "babel-jest": "^29.3.1",
        "babel-plugin-module-resolver": "4.1.0",
        "cross-env": "^7.0.3",
        eslint: "^8.29.0",
        "eslint-plugin-react": "^7.31.11",
        husky: "^8.0.2",
        jest: "^29.3.1",
        "jest-environment-jsdom": "^29.3.1",
        "jest-extended": "^3.2.0",
        "jest-watch-typeahead": "^2.2.1",
        lerna: "^6.0.3",
        "lint-staged": "^13.1.0",
        nx: "15.3.0",
        rimraf: "^3.0.2",
        rollup: "^3.7.0",
        "rollup-plugin-filesize": "^9.1.2",
        "rollup-plugin-visualizer": "^5.9.0",
        "ts-jest": "^29.0.3",
        "ts-node": "^10.9.1",
        typescript: "^4.9.4"
    }
}, $7d6602d5c01fbe8e$var$Oe = {}, $7d6602d5c01fbe8e$var$je = {
    get exports () {
        return $7d6602d5c01fbe8e$var$Oe;
    },
    set exports (e){
        $7d6602d5c01fbe8e$var$Oe = e;
    }
};
(function() {
    var e1, n, t, r, l, a;
    "undefined" != typeof performance && null !== performance && performance.now ? $7d6602d5c01fbe8e$var$je.exports = function() {
        return performance.now();
    } : Date.now ? ($7d6602d5c01fbe8e$var$je.exports = function() {
        return Date.now() - t;
    }, t = Date.now()) : ($7d6602d5c01fbe8e$var$je.exports = function() {
        return (new Date).getTime() - t;
    }, t = (new Date).getTime());
}).call($7d6602d5c01fbe8e$var$I);
var $7d6602d5c01fbe8e$var$Le, $7d6602d5c01fbe8e$var$Me = {}, $7d6602d5c01fbe8e$var$De = {};
({
    get exports () {
        return $7d6602d5c01fbe8e$var$Me;
    },
    set exports (e){
        $7d6602d5c01fbe8e$var$Me = e;
    }
}).exports = ($7d6602d5c01fbe8e$var$Le || ($7d6602d5c01fbe8e$var$Le = 1, $7d6602d5c01fbe8e$var$De.ConcurrentRoot = 1, $7d6602d5c01fbe8e$var$De.ContinuousEventPriority = 4, $7d6602d5c01fbe8e$var$De.DefaultEventPriority = 16, $7d6602d5c01fbe8e$var$De.DiscreteEventPriority = 1, $7d6602d5c01fbe8e$var$De.IdleEventPriority = 536870912, $7d6602d5c01fbe8e$var$De.LegacyRoot = 0), $7d6602d5c01fbe8e$var$De);
var $7d6602d5c01fbe8e$var$Ue = {};
function $7d6602d5c01fbe8e$var$Fe(e1, n) {
    e1.addChild && (e1.addChild(n), "function" == typeof n.didMount && n.didMount(n, e1));
}
function $7d6602d5c01fbe8e$var$Ae(e1, n) {
    var t, r, l;
    null === (t = e1.willUnmount) || void 0 === t || t.call(e1, e1, n), !1 !== (null === (r = e1.config) || void 0 === r ? void 0 : r.destroyChildren) && null !== (l = e1.children) && void 0 !== l && l.length && $7d6602d5c01fbe8e$var$z(e1.children).forEach(function(n) {
        $7d6602d5c01fbe8e$var$Ae(n, e1);
    });
}
function $7d6602d5c01fbe8e$var$Qe(e1, n) {
    var t;
    $7d6602d5c01fbe8e$var$Ae(n, e1), e1.removeChild(n);
    var r = null !== (t = n.config) && void 0 !== t ? t : {}, l = r.destroy, a = void 0 === l || l, i = r.destroyChildren, o = void 0 === i || i, u = r.destroyTexture, s = void 0 !== u && u, c = r.destroyBaseTexture, f = void 0 !== c && c;
    a && n.destroy({
        children: o,
        texture: s,
        baseTexture: f
    });
}
function $7d6602d5c01fbe8e$var$He(e1, n, t) {
    $7d6602d5c01fbe8e$var$N(n !== t, "pixi-react: PixiFiber cannot insert node before itself"), -1 !== e1.children.indexOf(n) && e1.removeChild(n);
    var r = e1.getChildIndex(t);
    e1.addChildAt(n, r);
}
var $7d6602d5c01fbe8e$var$Be = null, $7d6602d5c01fbe8e$export$156582218858362c = $7d6602d5c01fbe8e$var$Te({
    getRootHostContext: function() {
        return $7d6602d5c01fbe8e$var$Ue;
    },
    getChildHostContext: function(e1) {
        return e1;
    },
    getChildHostContextForEventComponent: function(e1) {
        return e1;
    },
    getPublicInstance: function(e1) {
        return e1;
    },
    getCurrentEventPriority: function() {
        return function() {
            var e1, n;
            if ("undefined" == typeof window) return $7d6602d5c01fbe8e$var$Me.DefaultEventPriority;
            switch(null === (e1 = window) || void 0 === e1 || null === (n = e1.event) || void 0 === n ? void 0 : n.type){
                case "click":
                case "contextmenu":
                case "dblclick":
                case "pointercancel":
                case "pointerdown":
                case "pointerup":
                    return $7d6602d5c01fbe8e$var$Me.DiscreteEventPriority;
                case "pointermove":
                case "pointerout":
                case "pointerover":
                case "pointerenter":
                case "pointerleave":
                case "wheel":
                    return $7d6602d5c01fbe8e$var$Me.ContinuousEventPriority;
                default:
                    return $7d6602d5c01fbe8e$var$Me.DefaultEventPriority;
            }
        }();
    },
    prepareForCommit: function() {
        return null;
    },
    resetAfterCommit: function() {},
    createInstance: function(e1) {
        var n, t, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = $7d6602d5c01fbe8e$var$ye[e1];
        if ("function" == typeof a && (n = a(l, r)), !n) {
            var i = $7d6602d5c01fbe8e$var$be[e1];
            i && ((n = i.create(r, {
                root: l
            })).didMount = i.didMount ? i.didMount.bind(n) : void 0, n.willUnmount = i.willUnmount ? i.willUnmount.bind(n) : void 0, n.applyProps = i.applyProps ? i.applyProps.bind(n) : void 0, n.config = i.config);
        }
        return n && (n.__reactpixi = {
            root: l
        }, ("function" == typeof (null === (t = n) || void 0 === t ? void 0 : t.applyProps) ? n.applyProps : $7d6602d5c01fbe8e$export$2da27ad86541356b)(n, {}, r)), n;
    },
    hideInstance: function(e1) {
        e1.visible = !1;
    },
    unhideInstance: function(e1, n) {
        var t = null == n || !n.hasOwnProperty("visible") || n.visible;
        e1.visible = t;
    },
    finalizeInitialChildren: function(e1, n, t) {
        return !1;
    },
    prepareUpdate: function(e1, n, t, r, l, a) {
        return $7d6602d5c01fbe8e$var$Be = function(e1, n, t, r) {
            var l = null;
            for(var a in t)!r.hasOwnProperty(a) && t.hasOwnProperty(a) && null !== t[a] && (a === $7d6602d5c01fbe8e$var$Q || (l || (l = []), l.push(a, null)));
            for(var i in r){
                var o = r[i], u = null !== t ? t[i] : void 0;
                !r.hasOwnProperty(i) || o === u || null === o && null === u || i === $7d6602d5c01fbe8e$var$Q || (l || (l = []), l.push(i, o));
            }
            return l;
        }(0, 0, t, r);
    },
    shouldSetTextContent: function(e1, n) {
        return !1;
    },
    shouldDeprioritizeSubtree: function(e1, n) {
        var t = void 0 === n.alpha || n.alpha > 0, r = void 0 === n.renderable || !0 === n.renderable, l = void 0 === n.visible || !0 === n.visible;
        return !(t && r && l);
    },
    createTextInstance: function(e1, n, t) {
        $7d6602d5c01fbe8e$var$N(!1, 'pixi-react: Error trying to add text node "'.concat(e1, '"'), "PixiFiber does not support text nodes as children of a Pixi component. To pass a string value to your component, use a property other than children. If you wish to display some text, you can use &lt;Text text={string} /&gt; instead.");
    },
    unhideTextInstance: function(e1, n) {},
    mountEventComponent: function() {},
    updateEventComponent: function() {},
    handleEventTarget: function() {},
    scheduleTimeout: setTimeout,
    cancelTimeout: clearTimeout,
    noTimeout: -1,
    warnsIfNotActing: !1,
    now: $7d6602d5c01fbe8e$var$Oe,
    isPrimaryRenderer: !1,
    supportsMutation: !0,
    supportsPersistence: !1,
    supportsHydration: !1,
    supportsMicrotasks: !0,
    scheduleMicrotask: queueMicrotask,
    appendInitialChild: function() {
        for(var e1, n, t = arguments.length, r = new Array(t), l = 0; l < t; l++)r[l] = arguments[l];
        var a = $7d6602d5c01fbe8e$var$Fe.apply(null, r);
        return null === (e1 = r[0].__reactpixi) || void 0 === e1 || null === (n = e1.root) || void 0 === n || n.emit("__REACT_PIXI_REQUEST_RENDER__", {
            detail: "appendInitialChild"
        }), a;
    },
    appendChild: function() {
        for(var e1, n, t = arguments.length, r = new Array(t), l = 0; l < t; l++)r[l] = arguments[l];
        var a = $7d6602d5c01fbe8e$var$Fe.apply(null, r);
        return null === (e1 = r[0].__reactpixi) || void 0 === e1 || null === (n = e1.root) || void 0 === n || n.emit("__REACT_PIXI_REQUEST_RENDER__", {
            detail: "appendChild"
        }), a;
    },
    appendChildToContainer: function() {
        for(var e1, n, t = arguments.length, r = new Array(t), l = 0; l < t; l++)r[l] = arguments[l];
        var a = $7d6602d5c01fbe8e$var$Fe.apply(null, r);
        return null === (e1 = r[0].__reactpixi) || void 0 === e1 || null === (n = e1.root) || void 0 === n || n.emit("__REACT_PIXI_REQUEST_RENDER__", {
            detail: "appendChildToContainer"
        }), a;
    },
    removeChild: function() {
        for(var e1, n, t = arguments.length, r = new Array(t), l = 0; l < t; l++)r[l] = arguments[l];
        var a = $7d6602d5c01fbe8e$var$Qe.apply(null, r);
        return null === (e1 = r[0].__reactpixi) || void 0 === e1 || null === (n = e1.root) || void 0 === n || n.emit("__REACT_PIXI_REQUEST_RENDER__", {
            detail: "removeChild"
        }), a;
    },
    removeChildFromContainer: function() {
        for(var e1, n, t = arguments.length, r = new Array(t), l = 0; l < t; l++)r[l] = arguments[l];
        var a = $7d6602d5c01fbe8e$var$Qe.apply(null, r);
        return null === (e1 = r[0].__reactpixi) || void 0 === e1 || null === (n = e1.root) || void 0 === n || n.emit("__REACT_PIXI_REQUEST_RENDER__", {
            detail: "removeChildFromContainer"
        }), a;
    },
    insertBefore: $7d6602d5c01fbe8e$var$He,
    insertInContainerBefore: function() {
        for(var e1, n, t = arguments.length, r = new Array(t), l = 0; l < t; l++)r[l] = arguments[l];
        var a = $7d6602d5c01fbe8e$var$He.apply(null, r);
        return null === (e1 = r[0].__reactpixi) || void 0 === e1 || null === (n = e1.root) || void 0 === n || n.emit("__REACT_PIXI_REQUEST_RENDER__", {
            detail: "insertInContainerBefore"
        }), a;
    },
    commitUpdate: function(e1, n, t, r, l) {
        var a, i, o = e1 && e1.applyProps;
        ("function" != typeof o && (o = $7d6602d5c01fbe8e$export$2da27ad86541356b), o(e1, r, l) || $7d6602d5c01fbe8e$var$Be) && (null === (a = e1.__reactpixi) || void 0 === a || null === (i = a.root) || void 0 === i || i.emit("__REACT_PIXI_REQUEST_RENDER__", {
            detail: "commitUpdate"
        }));
    },
    commitMount: function(e1, n, t, r, l) {},
    commitTextUpdate: function(e1, n, t) {},
    resetTextContent: function(e1) {},
    clearContainer: function(e1) {},
    getFundamentalComponentInstance: function(e1) {
        throw new Error("Not yet implemented.");
    },
    mountFundamentalComponent: function(e1) {
        throw new Error("Not yet implemented.");
    },
    shouldUpdateFundamentalComponent: function(e1) {
        throw new Error("Not yet implemented.");
    },
    unmountFundamentalComponent: function(e1) {
        throw new Error("Not yet implemented.");
    },
    getInstanceFromNode: function(e1) {
        throw new Error("Not yet implemented.");
    },
    isOpaqueHydratingObject: function(e1) {
        throw new Error("Not yet implemented");
    },
    makeOpaqueHydratingObject: function(e1) {
        throw new Error("Not yet implemented.");
    },
    makeClientIdInDEV: function(e1) {
        throw new Error("Not yet implemented");
    },
    beforeActiveInstanceBlur: function(e1) {},
    afterActiveInstanceBlur: function() {},
    detachDeletedInstance: function() {},
    preparePortalMount: function(e1) {}
}), $7d6602d5c01fbe8e$var$$e = $7d6602d5c01fbe8e$var$Re.dependencies["react-dom"].replace(/[^0-9.]/g, ""), $7d6602d5c01fbe8e$var$Ve = $7d6602d5c01fbe8e$var$Re.name;
$7d6602d5c01fbe8e$export$156582218858362c.injectIntoDevTools({
    bundleType: 0,
    version: $7d6602d5c01fbe8e$var$$e,
    rendererPackageName: $7d6602d5c01fbe8e$var$Ve,
    findHostInstanceByFiber: $7d6602d5c01fbe8e$export$156582218858362c.findHostInstance
});
var $7d6602d5c01fbe8e$var$Xe = new Map;
function $7d6602d5c01fbe8e$var$qe(e1) {
    if ($7d6602d5c01fbe8e$var$N((0, $3IPo5.Container).prototype.isPrototypeOf(e1), "Invalid argument `container`, expected instance of `PIXI.Container`."), $7d6602d5c01fbe8e$var$Xe.has(e1)) {
        var n = $7d6602d5c01fbe8e$var$Xe.get(e1).pixiFiberContainer;
        $7d6602d5c01fbe8e$export$156582218858362c.updateContainer(null, n, void 0, function() {
            $7d6602d5c01fbe8e$var$Xe.delete(e1);
        });
    }
}
function $7d6602d5c01fbe8e$export$882461b6382ed46c(e1) {
    $7d6602d5c01fbe8e$var$N((0, $3IPo5.Container).prototype.isPrototypeOf(e1), "Invalid argument `container`, expected instance of `PIXI.Container`.");
    var n = $7d6602d5c01fbe8e$var$Xe.get(e1);
    if ($7d6602d5c01fbe8e$var$N(!n, "Pixi React: createRoot should only be called once"), !n) {
        var r = $7d6602d5c01fbe8e$export$156582218858362c.createContainer(e1);
        n = {
            pixiFiberContainer: r,
            reactRoot: {
                render: function(e1) {
                    return $7d6602d5c01fbe8e$export$156582218858362c.updateContainer(e1, r, void 0), $7d6602d5c01fbe8e$export$156582218858362c.getPublicRootInstance(r);
                },
                unmount: function() {
                    $7d6602d5c01fbe8e$var$qe(e1), $7d6602d5c01fbe8e$var$Xe.delete(e1);
                }
            }
        }, $7d6602d5c01fbe8e$var$Xe.set(e1, n);
    }
    return n.reactRoot;
}
function $7d6602d5c01fbe8e$export$b3890eb0ae9dca99(e1, n, t) {
    var r;
    (console.warn("Pixi React Deprecation Warning: render is deprecated, use createRoot instead"), void 0 !== t && console.warn("Pixi React Deprecation Warning: render callback no longer exists in React 18"), $7d6602d5c01fbe8e$var$Xe.has(n)) ? r = $7d6602d5c01fbe8e$var$Xe.get(n).reactRoot : r = $7d6602d5c01fbe8e$export$882461b6382ed46c(n);
    return r.render(e1);
}
function $7d6602d5c01fbe8e$export$502457920280e6be(e1) {
    $7d6602d5c01fbe8e$var$qe(e1);
}
function $7d6602d5c01fbe8e$var$Je() {
    return $7d6602d5c01fbe8e$var$Je = Object.assign ? Object.assign.bind() : function(e1) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e1[r] = t[r]);
        }
        return e1;
    }, $7d6602d5c01fbe8e$var$Je.apply(this, arguments);
}
function $7d6602d5c01fbe8e$var$Ze(e1, n) {
    if (!(e1 instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $7d6602d5c01fbe8e$var$en(e1, n) {
    for(var t = 0; t < n.length; t++){
        var r = n[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e1, $7d6602d5c01fbe8e$var$E(r.key), r);
    }
}
function $7d6602d5c01fbe8e$var$nn(e1) {
    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e1;
}
function $7d6602d5c01fbe8e$var$tn(e1, n) {
    return $7d6602d5c01fbe8e$var$tn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, n) {
        return e1.__proto__ = n, e1;
    }, $7d6602d5c01fbe8e$var$tn(e1, n);
}
function $7d6602d5c01fbe8e$var$rn(e1, n) {
    if (n && ("object" === $7d6602d5c01fbe8e$var$P(n) || "function" == typeof n)) return n;
    if (void 0 !== n) throw new TypeError("Derived constructors may only return object or undefined");
    return $7d6602d5c01fbe8e$var$nn(e1);
}
function $7d6602d5c01fbe8e$var$ln(e1) {
    return $7d6602d5c01fbe8e$var$ln = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
        return e1.__proto__ || Object.getPrototypeOf(e1);
    }, $7d6602d5c01fbe8e$var$ln(e1);
}
var $7d6602d5c01fbe8e$export$122994dc05ba4308 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null), $7d6602d5c01fbe8e$export$c7dacf3845253dcf = $7d6602d5c01fbe8e$export$122994dc05ba4308.Provider, $7d6602d5c01fbe8e$export$c42bd7ed5c521bd0 = $7d6602d5c01fbe8e$export$122994dc05ba4308.Consumer, $7d6602d5c01fbe8e$export$179453dd40cee9bc = function(e1) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7d6602d5c01fbe8e$export$c42bd7ed5c521bd0, null, function(r) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e1, $7d6602d5c01fbe8e$var$Je({}, n, {
                ref: t,
                app: r
            }));
        });
    });
    return n.displayName = "withPIXIApp(".concat(e1.displayName || e1.name, ")"), n;
};
function $7d6602d5c01fbe8e$var$cn(e1) {
    var n = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (e1) {
            return !1;
        }
    }();
    return function() {
        var t, r = $7d6602d5c01fbe8e$var$ln(e1);
        if (n) {
            var l = $7d6602d5c01fbe8e$var$ln(this).constructor;
            t = Reflect.construct(r, arguments, l);
        } else t = r.apply(this, arguments);
        return $7d6602d5c01fbe8e$var$rn(this, t);
    };
}
function $7d6602d5c01fbe8e$var$fn(e1, n) {
    var t = Object.keys(e1);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e1);
        n && (r = r.filter(function(n) {
            return Object.getOwnPropertyDescriptor(e1, n).enumerable;
        })), t.push.apply(t, r);
    }
    return t;
}
function $7d6602d5c01fbe8e$var$dn(e1) {
    for(var n = 1; n < arguments.length; n++){
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $7d6602d5c01fbe8e$var$fn(Object(t), !0).forEach(function(n) {
            $7d6602d5c01fbe8e$var$_(e1, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(t)) : $7d6602d5c01fbe8e$var$fn(Object(t)).forEach(function(n) {
            Object.defineProperty(e1, n, Object.getOwnPropertyDescriptor(t, n));
        });
    }
    return e1;
}
var $7d6602d5c01fbe8e$var$pn = function() {}, $7d6602d5c01fbe8e$var$mn = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    onMount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    raf: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    renderOnComponentChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        autoStart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        useContextAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        backgroundAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        autoDensity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        antialias: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        preserveDrawingBuffer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        resolution: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        forceCanvas: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        clearBeforeRender: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        powerPreference: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        sharedTicker: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        sharedLoader: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        resizeTo: function(e1, n) {
            var t = e1[n];
            t && $7d6602d5c01fbe8e$var$N(t === window || t instanceof HTMLElement, "Invalid prop `resizeTo` of type ".concat($7d6602d5c01fbe8e$var$P(t), ", expect `window` or an `HTMLElement`."));
        },
        view: function(e1, n, t) {
            var r = e1[n];
            r && $7d6602d5c01fbe8e$var$N(r instanceof HTMLCanvasElement, "Invalid prop `view` of type ".concat($7d6602d5c01fbe8e$var$P(r), ", supplied to ").concat(t, ", expected `<canvas> Element`"));
        }
    })
}, $7d6602d5c01fbe8e$var$hn = {
    width: 800,
    height: 600,
    onMount: $7d6602d5c01fbe8e$var$pn,
    onUnmount: $7d6602d5c01fbe8e$var$pn,
    raf: !0,
    renderOnComponentChange: !0
};
var $7d6602d5c01fbe8e$var$gn = function(e1) {
    !function(e1, n) {
        if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
        e1.prototype = Object.create(n && n.prototype, {
            constructor: {
                value: e1,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e1, "prototype", {
            writable: !1
        }), n && $7d6602d5c01fbe8e$var$tn(e1, n);
    }(a, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    var n, t, r, l = $7d6602d5c01fbe8e$var$cn(a);
    function a() {
        var e1;
        $7d6602d5c01fbe8e$var$Ze(this, a);
        for(var n = arguments.length, t = new Array(n), r = 0; r < n; r++)t[r] = arguments[r];
        return $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$nn(e1 = l.call.apply(l, [
            this
        ].concat(t))), "_canvas", null), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$nn(e1), "_mediaQuery", null), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$nn(e1), "_ticker", null), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$nn(e1), "_needsUpdate", !0), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$nn(e1), "app", null), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$nn(e1), "updateSize", function() {
            var n = e1.props, t = n.width, r = n.height, l = n.options;
            null != l && l.resolution || (e1.app.renderer.resolution = window.devicePixelRatio, e1.resetInteractionManager()), e1.app.renderer.resize(t, r);
        }), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$nn(e1), "needsRenderUpdate", function() {
            e1._needsUpdate = !0;
        }), $7d6602d5c01fbe8e$var$_($7d6602d5c01fbe8e$var$nn(e1), "renderStage", function() {
            var n = e1.props, t = n.renderOnComponentChange;
            !n.raf && t && e1._needsUpdate && (e1._needsUpdate = !1, e1.app.renderer.render(e1.app.stage));
        }), e1;
    }
    return n = a, t = [
        {
            key: "componentDidMount",
            value: function() {
                var e1 = this.props, n = e1.onMount, t = e1.width, r = e1.height, l = e1.options, a = e1.raf, i = e1.renderOnComponentChange;
                this.app = new (0, $12K8P.Application)($7d6602d5c01fbe8e$var$dn($7d6602d5c01fbe8e$var$dn({
                    width: t,
                    height: r,
                    view: this._canvas
                }, l), {}, {
                    autoDensity: !1 !== (null == l ? void 0 : l.autoDensity)
                })), this.app.ticker.autoStart = !1, this.app.ticker[a ? "start" : "stop"](), this.app.stage.__reactpixi = {
                    root: this.app.stage
                }, this.mountNode = $7d6602d5c01fbe8e$export$156582218858362c.createContainer(this.app.stage), $7d6602d5c01fbe8e$export$156582218858362c.updateContainer(this.getChildren(), this.mountNode, this), n(this.app), null != l && l.autoDensity && window.matchMedia && void 0 === (null == l ? void 0 : l.resolution) && (this._mediaQuery = window.matchMedia("(-webkit-min-device-pixel-ratio: 1.3), (min-resolution: 120dpi)"), this._mediaQuery.addListener(this.updateSize)), i && !a && (this._ticker = new (0, $3J55z.Ticker), this._ticker.autoStart = !0, this._ticker.add(this.renderStage), this.app.stage.on("__REACT_PIXI_REQUEST_RENDER__", this.needsRenderUpdate)), this.updateSize(), this.renderStage();
            }
        },
        {
            key: "componentDidUpdate",
            value: function(e1, n, t) {
                var r, l = this.props, a = l.width, i = l.height, o = l.raf, u = l.renderOnComponentChange, s = l.options;
                void 0 !== (null == s ? void 0 : s.resolution) && (null == e1 ? void 0 : e1.options.resolution) !== (null == s ? void 0 : s.resolution) && (this.app.renderer.resolution = s.resolution, this.resetInteractionManager()), e1.height === i && e1.width === a && (null === (r = e1.options) || void 0 === r ? void 0 : r.resolution) === (null == s ? void 0 : s.resolution) || this.updateSize(), e1.raf !== o && this.app.ticker[o ? "start" : "stop"](), $7d6602d5c01fbe8e$export$156582218858362c.updateContainer(this.getChildren(), this.mountNode, this), e1.width === a && e1.height === i && e1.raf === o && e1.renderOnComponentChange === u && e1.options === s || (this._needsUpdate = !0, this.renderStage());
            }
        },
        {
            key: "resetInteractionManager",
            value: function() {
                var e1 = this.app.renderer.plugins.interaction;
                null != e1 && e1.resolution && (e1.resolution = this.app.renderer.resolution);
            }
        },
        {
            key: "getChildren",
            value: function() {
                var e1 = this.props.children;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7d6602d5c01fbe8e$export$c7dacf3845253dcf, {
                    value: this.app
                }, e1);
            }
        },
        {
            key: "componentDidCatch",
            value: function(e1, n) {
                console.error("Error occurred in `Stage`."), console.error(e1), console.error(n);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.props.onUnmount(this.app), this._ticker && (this._ticker.remove(this.renderStage), this._ticker.destroy()), this.app.stage.off("__REACT_PIXI_REQUEST_RENDER__", this.needsRenderUpdate), $7d6602d5c01fbe8e$export$156582218858362c.updateContainer(null, this.mountNode, this), this._mediaQuery && (this._mediaQuery.removeListener(this.updateSize), this._mediaQuery = null), this.app.destroy();
            }
        },
        {
            key: "render",
            value: function() {
                var e1, n, t = this, r = this.props.options;
                return r && r.view ? ($7d6602d5c01fbe8e$var$N(r.view instanceof HTMLCanvasElement, "options.view needs to be a `HTMLCanvasElement`"), null) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", $7d6602d5c01fbe8e$var$Je({}, (e1 = this.props, n = [].concat($7d6602d5c01fbe8e$var$z(Object.keys($7d6602d5c01fbe8e$var$mn)), $7d6602d5c01fbe8e$var$z(Object.keys($7d6602d5c01fbe8e$var$B))), Object.keys(e1).filter(function(e1) {
                    return !n.includes(e1);
                }).reduce(function(n, t) {
                    return $7d6602d5c01fbe8e$var$dn($7d6602d5c01fbe8e$var$dn({}, n), {}, $7d6602d5c01fbe8e$var$_({}, t, e1[t]));
                }, {})), {
                    ref: function(e1) {
                        return t._canvas = e1;
                    }
                }));
            }
        }
    ], $7d6602d5c01fbe8e$var$en(n.prototype, t), r && $7d6602d5c01fbe8e$var$en(n, r), Object.defineProperty(n, "prototype", {
        writable: !1
    }), a;
}();
$7d6602d5c01fbe8e$var$gn.propTypes = $7d6602d5c01fbe8e$var$mn, $7d6602d5c01fbe8e$var$gn.defaultProps = $7d6602d5c01fbe8e$var$hn;
var $7d6602d5c01fbe8e$export$208cd1682bd0e4b6 = $7d6602d5c01fbe8e$var$gn;
function $7d6602d5c01fbe8e$export$fca13ab91e1a6240() {
    var e1 = (0, $acw62.useContext)($7d6602d5c01fbe8e$export$122994dc05ba4308);
    return $7d6602d5c01fbe8e$var$N(e1 instanceof (0, $12K8P.Application), "No Context found with `%s`. Make sure to wrap component with `%s`", "PIXI.Application", "AppProvider"), e1;
}
function $7d6602d5c01fbe8e$export$98bfbd4c9d834fed(e1) {
    var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], t = $7d6602d5c01fbe8e$export$fca13ab91e1a6240();
    $7d6602d5c01fbe8e$var$N("function" == typeof e1, "`useTick` needs a callback function."), $7d6602d5c01fbe8e$var$N(t instanceof (0, $12K8P.Application), "No Context found with `%s`. Make sure to wrap component with `%s`", "PIXI.Application", "AppProvider");
    var r = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        r.current = e1;
    }, [
        e1
    ]), (0, $acw62.useEffect)(function() {
        if (n) {
            var e1 = function(e1) {
                return r.current.apply(t.ticker, [
                    e1,
                    t.ticker
                ]);
            };
            return t.ticker.add(e1), function() {
                t.ticker && t.ticker.remove(e1);
            };
        }
    }, [
        n
    ]);
}
function $7d6602d5c01fbe8e$var$Sn() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch (e1) {
        return !1;
    }
}
function $7d6602d5c01fbe8e$var$xn(e1, n, t) {
    return $7d6602d5c01fbe8e$var$xn = $7d6602d5c01fbe8e$var$Sn() ? Reflect.construct.bind() : function(e1, n, t) {
        var r = [
            null
        ];
        r.push.apply(r, n);
        var l = new (Function.bind.apply(e1, r));
        return t && $7d6602d5c01fbe8e$var$tn(l, t.prototype), l;
    }, $7d6602d5c01fbe8e$var$xn.apply(null, arguments);
}
var $7d6602d5c01fbe8e$var$wn = [
    "children",
    "apply"
];
function $7d6602d5c01fbe8e$var$kn(e1, n) {
    var t = Object.keys(e1);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e1);
        n && (r = r.filter(function(n) {
            return Object.getOwnPropertyDescriptor(e1, n).enumerable;
        })), t.push.apply(t, r);
    }
    return t;
}
function $7d6602d5c01fbe8e$var$Pn(e1) {
    for(var n = 1; n < arguments.length; n++){
        var t = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $7d6602d5c01fbe8e$var$kn(Object(t), !0).forEach(function(n) {
            $7d6602d5c01fbe8e$var$_(e1, n, t[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(t)) : $7d6602d5c01fbe8e$var$kn(Object(t)).forEach(function(n) {
            Object.defineProperty(e1, n, Object.getOwnPropertyDescriptor(t, n));
        });
    }
    return e1;
}
var $7d6602d5c01fbe8e$export$8c08d75199bd74f2 = function(e1, n) {
    $7d6602d5c01fbe8e$var$N("object" === $7d6602d5c01fbe8e$var$P(n), "Second argument needs to be an indexed object with { prop: Filter }");
    var t = Object.keys(n), r = function(r) {
        var l = r.children, a = r.apply, i = $7d6602d5c01fbe8e$var$G(r, $7d6602d5c01fbe8e$var$wn), o = (0, $acw62.useRef)((0, $acw62.useMemo)(function() {
            return t.map(function(e1) {
                var t, r = (null == i || null === (t = i[e1]) || void 0 === t ? void 0 : t.construct) || [];
                return $7d6602d5c01fbe8e$var$xn(n[e1], $7d6602d5c01fbe8e$var$z(r));
            });
        }, [
            t
        ])), u = (0, $acw62.useMemo)(function() {
            return t.reduce(function(e1, n, t) {
                return $7d6602d5c01fbe8e$var$Pn($7d6602d5c01fbe8e$var$Pn({}, e1), {}, $7d6602d5c01fbe8e$var$_({}, n, o.current[t]));
            }, {});
        }, [
            t
        ]), s = (0, $acw62.useMemo)(function() {
            return Object.keys(i).filter($7d6602d5c01fbe8e$var$A($7d6602d5c01fbe8e$var$F(t))).reduce(function(e1, n) {
                return $7d6602d5c01fbe8e$var$Pn($7d6602d5c01fbe8e$var$Pn({}, e1), {}, $7d6602d5c01fbe8e$var$_({}, n, i[n]));
            }, {});
        }, [
            i,
            t
        ]);
        return t.forEach(function(e1, n) {
            return Object.assign(o.current[n], i[e1]);
        }), a && function() {
            for(var e1 = arguments.length, n = new Array(e1), t = 0; t < e1; t++)n[t] = arguments[t];
            return n.every(function(e1) {
                return "function" == typeof e1;
            });
        }(a) && a.call(e1, u), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e1, $7d6602d5c01fbe8e$var$Je({}, s, {
            filters: o.current
        }), l);
    };
    return r.displayName = "FilterWrapper", r.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        apply: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }, r;
}, $7d6602d5c01fbe8e$export$ae0da96467efdba0 = $7d6602d5c01fbe8e$export$426db7a6155b7a80.BitmapText, $7d6602d5c01fbe8e$export$42a852a2b6b56249 = $7d6602d5c01fbe8e$export$426db7a6155b7a80.Container, $7d6602d5c01fbe8e$export$29d3e417456abdad = $7d6602d5c01fbe8e$export$426db7a6155b7a80.Graphics, $7d6602d5c01fbe8e$export$acdf4cb3f489544e = $7d6602d5c01fbe8e$export$426db7a6155b7a80.NineSlicePlane, $7d6602d5c01fbe8e$export$e63bf72b2cfda112 = $7d6602d5c01fbe8e$export$426db7a6155b7a80.ParticleContainer, $7d6602d5c01fbe8e$export$3075603db8e6204c = $7d6602d5c01fbe8e$export$426db7a6155b7a80.Sprite, $7d6602d5c01fbe8e$export$dae599798687ad3c = $7d6602d5c01fbe8e$export$426db7a6155b7a80.AnimatedSprite, $7d6602d5c01fbe8e$export$5f1af8db9871e1d6 = $7d6602d5c01fbe8e$export$426db7a6155b7a80.Text, $7d6602d5c01fbe8e$export$db8370cd1ebcc819 = $7d6602d5c01fbe8e$export$426db7a6155b7a80.TilingSprite, $7d6602d5c01fbe8e$export$81b9e78682e7feca = $7d6602d5c01fbe8e$export$426db7a6155b7a80.SimpleMesh, $7d6602d5c01fbe8e$export$f009a14c3f00879e = $7d6602d5c01fbe8e$export$426db7a6155b7a80.SimpleRope;

});
parcelRegister("inflE", function(module, exports) {
$parcel$export(module.exports, "Color", () => (parcelRequire("1PNws")).Color);
$parcel$export(module.exports, "ALPHA_MODES", () => (parcelRequire("lmRm8")).ALPHA_MODES);
$parcel$export(module.exports, "BLEND_MODES", () => (parcelRequire("lmRm8")).BLEND_MODES);
$parcel$export(module.exports, "CLEAR_MODES", () => (parcelRequire("lmRm8")).CLEAR_MODES);
$parcel$export(module.exports, "DRAW_MODES", () => (parcelRequire("lmRm8")).DRAW_MODES);
$parcel$export(module.exports, "FORMATS", () => (parcelRequire("lmRm8")).FORMATS);
$parcel$export(module.exports, "MASK_TYPES", () => (parcelRequire("lmRm8")).MASK_TYPES);
$parcel$export(module.exports, "MIPMAP_MODES", () => (parcelRequire("lmRm8")).MIPMAP_MODES);
$parcel$export(module.exports, "MSAA_QUALITY", () => (parcelRequire("lmRm8")).MSAA_QUALITY);
$parcel$export(module.exports, "SCALE_MODES", () => (parcelRequire("lmRm8")).SCALE_MODES);
$parcel$export(module.exports, "TYPES", () => (parcelRequire("lmRm8")).TYPES);
$parcel$export(module.exports, "WRAP_MODES", () => (parcelRequire("lmRm8")).WRAP_MODES);
$parcel$export(module.exports, "extensions", () => (parcelRequire("5RvHb")).extensions);
$parcel$export(module.exports, "ExtensionType", () => (parcelRequire("5RvHb")).ExtensionType);
$parcel$export(module.exports, "Circle", () => (parcelRequire("8mUry")).Circle);
$parcel$export(module.exports, "DEG_TO_RAD", () => (parcelRequire("lbGGA")).DEG_TO_RAD);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("gBsEB")).Ellipse);
$parcel$export(module.exports, "Matrix", () => (parcelRequire("6wJoy")).Matrix);
$parcel$export(module.exports, "ObservablePoint", () => (parcelRequire("g9ac3")).ObservablePoint);
$parcel$export(module.exports, "PI_2", () => (parcelRequire("lbGGA")).PI_2);
$parcel$export(module.exports, "Point", () => (parcelRequire("gnwPx")).Point);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("duPDq")).Polygon);
$parcel$export(module.exports, "RAD_TO_DEG", () => (parcelRequire("lbGGA")).RAD_TO_DEG);
$parcel$export(module.exports, "Rectangle", () => (parcelRequire("kZOeV")).Rectangle);
$parcel$export(module.exports, "RoundedRectangle", () => (parcelRequire("3qn70")).RoundedRectangle);
$parcel$export(module.exports, "SHAPES", () => (parcelRequire("lbGGA")).SHAPES);
$parcel$export(module.exports, "Transform", () => (parcelRequire("9jXhN")).Transform);
$parcel$export(module.exports, "settings", () => (parcelRequire("16eqM")).settings);
$parcel$export(module.exports, "Ticker", () => (parcelRequire("3J55z")).Ticker);
$parcel$export(module.exports, "UPDATE_PRIORITY", () => (parcelRequire("iaX63")).UPDATE_PRIORITY);

$parcel$export(module.exports, "BaseTexture", () => (parcelRequire("4oWO8")).BaseTexture);
$parcel$export(module.exports, "BatchDrawCall", () => (parcelRequire("6qB4i")).BatchDrawCall);
$parcel$export(module.exports, "BatchGeometry", () => (parcelRequire("7Gazv")).BatchGeometry);
$parcel$export(module.exports, "BatchTextureArray", () => (parcelRequire("ajAp7")).BatchTextureArray);
$parcel$export(module.exports, "Buffer", () => (parcelRequire("3u4Xc")).Buffer);
$parcel$export(module.exports, "BufferResource", () => (parcelRequire("1oZjy")).BufferResource);
$parcel$export(module.exports, "Filter", () => (parcelRequire("3x7iq")).Filter);
$parcel$export(module.exports, "Geometry", () => (parcelRequire("5K7Rq")).Geometry);
$parcel$export(module.exports, "ObjectRenderer", () => (parcelRequire("hDOsC")).ObjectRenderer);
$parcel$export(module.exports, "Program", () => (parcelRequire("k7n3P")).Program);
$parcel$export(module.exports, "QuadUv", () => (parcelRequire("eVEcT")).QuadUv);
$parcel$export(module.exports, "RenderTexture", () => (parcelRequire("4UuR4")).RenderTexture);
$parcel$export(module.exports, "SVGResource", () => (parcelRequire("h8Rzw")).SVGResource);
$parcel$export(module.exports, "Shader", () => (parcelRequire("2cKpP")).Shader);
$parcel$export(module.exports, "State", () => (parcelRequire("bUqaG")).State);
$parcel$export(module.exports, "Texture", () => (parcelRequire("cWOCu")).Texture);
$parcel$export(module.exports, "TextureMatrix", () => (parcelRequire("aHJRR")).TextureMatrix);
$parcel$export(module.exports, "UniformGroup", () => (parcelRequire("BpNwR")).UniformGroup);
$parcel$export(module.exports, "VideoResource", () => (parcelRequire("iqQDF")).VideoResource);
$parcel$export(module.exports, "ViewableBuffer", () => (parcelRequire("kZVXo")).ViewableBuffer);
$parcel$export(module.exports, "autoDetectRenderer", () => (parcelRequire("jZ2Bd")).autoDetectRenderer);
$parcel$export(module.exports, "defaultFilterVertex", () => (parcelRequire("17owa")).defaultFilterVertex);
$parcel$export(module.exports, "defaultVertex", () => (parcelRequire("17owa")).defaultVertex);
$parcel$export(module.exports, "utils", () => (parcelRequire("lFGyw")));
parcelRequire("19oHW");
parcelRequire("8HZMw");
parcelRequire("lmRm8");
parcelRequire("5RvHb");
parcelRequire("9fnly");
parcelRequire("hWIIU");
parcelRequire("fVntm");
parcelRequire("jje6E");

var $lFGyw = parcelRequire("lFGyw");

var $jZ2Bd = parcelRequire("jZ2Bd");

var $h9VM5 = parcelRequire("h9VM5");

var $6qB4i = parcelRequire("6qB4i");

var $7Gazv = parcelRequire("7Gazv");

var $jNmcM = parcelRequire("jNmcM");

var $6kk4I = parcelRequire("6kk4I");

var $70Dpm = parcelRequire("70Dpm");

var $ajAp7 = parcelRequire("ajAp7");

var $hDOsC = parcelRequire("hDOsC");

var $9LLGA = parcelRequire("9LLGA");

var $3x7iq = parcelRequire("3x7iq");

var $aQmAq = parcelRequire("aQmAq");

var $bXe1x = parcelRequire("bXe1x");
parcelRequire("aGSQK");

var $bkval = parcelRequire("bkval");

var $17owa = parcelRequire("17owa");

var $9Tsjp = parcelRequire("9Tsjp");

var $8ermx = parcelRequire("8ermx");

var $9FWzE = parcelRequire("9FWzE");

var $2bZnA = parcelRequire("2bZnA");

var $2IRuE = parcelRequire("2IRuE");

var $3u4Xc = parcelRequire("3u4Xc");

var $cccDW = parcelRequire("cccDW");

var $5K7Rq = parcelRequire("5K7Rq");

var $1AXaI = parcelRequire("1AXaI");

var $kZVXo = parcelRequire("kZVXo");
parcelRequire("bxBZi");

var $giCpI = parcelRequire("giCpI");

var $1GdhN = parcelRequire("1GdhN");

var $jLQZ8 = parcelRequire("jLQZ8");

var $ihQE2 = parcelRequire("ihQE2");

var $Hj4cm = parcelRequire("Hj4cm");

var $awCJH = parcelRequire("awCJH");

var $1de3N = parcelRequire("1de3N");

var $hCwyL = parcelRequire("hCwyL");

var $h8gz4 = parcelRequire("h8gz4");

var $8Faf6 = parcelRequire("8Faf6");

var $4UuR4 = parcelRequire("4UuR4");

var $9V6Rf = parcelRequire("9V6Rf");

var $jxrL2 = parcelRequire("jxrL2");

var $3tYCB = parcelRequire("3tYCB");

var $k7n3P = parcelRequire("k7n3P");

var $2cKpP = parcelRequire("2cKpP");

var $1JxSm = parcelRequire("1JxSm");

var $BpNwR = parcelRequire("BpNwR");

var $2deXx = parcelRequire("2deXx");

var $2tsgU = parcelRequire("2tsgU");

var $70kNL = parcelRequire("70kNL");

var $7W4Qd = parcelRequire("7W4Qd");

var $d0Qk2 = parcelRequire("d0Qk2");

var $5MhZE = parcelRequire("5MhZE");

var $1rTbL = parcelRequire("1rTbL");

var $bUqaG = parcelRequire("bUqaG");

var $jIxy5 = parcelRequire("jIxy5");
parcelRequire("91EPG");
parcelRequire("dqI8m");

var $4oWO8 = parcelRequire("4oWO8");

var $hfBPA = parcelRequire("hfBPA");
parcelRequire("5g4kz");

var $cWOCu = parcelRequire("cWOCu");

var $iDGF3 = parcelRequire("iDGF3");

var $aHJRR = parcelRequire("aHJRR");

var $dq44e = parcelRequire("dq44e");

var $9WwWG = parcelRequire("9WwWG");

var $9zIzb = parcelRequire("9zIzb");

var $idUGs = parcelRequire("idUGs");

var $ivGFf = parcelRequire("ivGFf");

var $eVEcT = parcelRequire("eVEcT");

var $h5Bby = parcelRequire("h5Bby");

var $6BfGe = parcelRequire("6BfGe");

var $bmxlM = parcelRequire("bmxlM");

var $fbY8e = parcelRequire("fbY8e");

var $ls824 = parcelRequire("ls824");

var $e4rs8 = parcelRequire("e4rs8");

var $12R2z = parcelRequire("12R2z");

var $1oZjy = parcelRequire("1oZjy");

var $1rY8B = parcelRequire("1rY8B");

var $hTaGg = parcelRequire("hTaGg");

var $165nJ = parcelRequire("165nJ");

var $9iM43 = parcelRequire("9iM43");

var $h8Rzw = parcelRequire("h8Rzw");

var $iqQDF = parcelRequire("iqQDF");
const $e870c5b5c5473fba$export$a4ad2735b021c132 = "7.4.0";

});
parcelRegister("19oHW", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
parcelRequire("lFGyw");
var $1Koy5 = parcelRequire("1Koy5");

var $jNmcM = parcelRequire("jNmcM");

var $3x7iq = parcelRequire("3x7iq");

var $k7n3P = parcelRequire("k7n3P");
parcelRequire("dqI8m");

var $4oWO8 = parcelRequire("4oWO8");

var $9LLGA = parcelRequire("9LLGA");

var $h9VM5 = parcelRequire("h9VM5");

var $h5Bby = parcelRequire("h5Bby");

var $1rTbL = parcelRequire("1rTbL");

var $iDGF3 = parcelRequire("iDGF3");
(0, $16eqM.settings).PREFER_ENV = (0, $lmRm8.ENV).WEBGL2;
(0, $16eqM.settings).STRICT_TEXTURE_CACHE = !1;
(0, $16eqM.settings).RENDER_OPTIONS = {
    ...(0, $9LLGA.ContextSystem).defaultOptions,
    ...(0, $h9VM5.BackgroundSystem).defaultOptions,
    ...(0, $h5Bby.ViewSystem).defaultOptions,
    ...(0, $1rTbL.StartupSystem).defaultOptions
};
Object.defineProperties((0, $16eqM.settings), {
    /**
   * @static
   * @name WRAP_MODE
   * @memberof PIXI.settings
   * @type {PIXI.WRAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.wrapMode
   */ WRAP_MODE: {
        get () {
            return (0, $4oWO8.BaseTexture).defaultOptions.wrapMode;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.WRAP_MODE is deprecated, use BaseTexture.defaultOptions.wrapMode"), (0, $4oWO8.BaseTexture).defaultOptions.wrapMode = value;
        }
    },
    /**
   * @static
   * @name SCALE_MODE
   * @memberof PIXI.settings
   * @type {PIXI.SCALE_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.scaleMode
   */ SCALE_MODE: {
        get () {
            return (0, $4oWO8.BaseTexture).defaultOptions.scaleMode;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.SCALE_MODE is deprecated, use BaseTexture.defaultOptions.scaleMode"), (0, $4oWO8.BaseTexture).defaultOptions.scaleMode = value;
        }
    },
    /**
   * @static
   * @name MIPMAP_TEXTURES
   * @memberof PIXI.settings
   * @type {PIXI.MIPMAP_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.mipmap
   */ MIPMAP_TEXTURES: {
        get () {
            return (0, $4oWO8.BaseTexture).defaultOptions.mipmap;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.MIPMAP_TEXTURES is deprecated, use BaseTexture.defaultOptions.mipmap"), (0, $4oWO8.BaseTexture).defaultOptions.mipmap = value;
        }
    },
    /**
   * @static
   * @name ANISOTROPIC_LEVEL
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.BaseTexture.defaultOptions.anisotropicLevel
   */ ANISOTROPIC_LEVEL: {
        get () {
            return (0, $4oWO8.BaseTexture).defaultOptions.anisotropicLevel;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.ANISOTROPIC_LEVEL is deprecated, use BaseTexture.defaultOptions.anisotropicLevel"), (0, $4oWO8.BaseTexture).defaultOptions.anisotropicLevel = value;
        }
    },
    /**
   * Default filter resolution.
   * @static
   * @name FILTER_RESOLUTION
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {number|null}
   * @see PIXI.Filter.defaultResolution
   */ FILTER_RESOLUTION: {
        get () {
            return (0, $1Koy5.deprecation)("7.1.0", "settings.FILTER_RESOLUTION is deprecated, use Filter.defaultResolution"), (0, $3x7iq.Filter).defaultResolution;
        },
        set (value) {
            (0, $3x7iq.Filter).defaultResolution = value;
        }
    },
    /**
   * Default filter samples.
   * @static
   * @name FILTER_MULTISAMPLE
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {PIXI.MSAA_QUALITY}
   * @see PIXI.Filter.defaultMultisample
   */ FILTER_MULTISAMPLE: {
        get () {
            return (0, $1Koy5.deprecation)("7.1.0", "settings.FILTER_MULTISAMPLE is deprecated, use Filter.defaultMultisample"), (0, $3x7iq.Filter).defaultMultisample;
        },
        set (value) {
            (0, $3x7iq.Filter).defaultMultisample = value;
        }
    },
    /**
   * The maximum textures that this device supports.
   * @static
   * @name SPRITE_MAX_TEXTURES
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @see PIXI.BatchRenderer.defaultMaxTextures
   * @type {number}
   */ SPRITE_MAX_TEXTURES: {
        get () {
            return (0, $jNmcM.BatchRenderer).defaultMaxTextures;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.SPRITE_MAX_TEXTURES is deprecated, use BatchRenderer.defaultMaxTextures"), (0, $jNmcM.BatchRenderer).defaultMaxTextures = value;
        }
    },
    /**
   * The default sprite batch size.
   *
   * The default aims to balance desktop and mobile devices.
   * @static
   * @name SPRITE_BATCH_SIZE
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.defaultBatchSize
   * @deprecated since 7.1.0
   * @type {number}
   */ SPRITE_BATCH_SIZE: {
        get () {
            return (0, $jNmcM.BatchRenderer).defaultBatchSize;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.SPRITE_BATCH_SIZE is deprecated, use BatchRenderer.defaultBatchSize"), (0, $jNmcM.BatchRenderer).defaultBatchSize = value;
        }
    },
    /**
   * Can we upload the same buffer in a single frame?
   * @static
   * @name CAN_UPLOAD_SAME_BUFFER
   * @memberof PIXI.settings
   * @see PIXI.BatchRenderer.canUploadSameBuffer
   * @deprecated since 7.1.0
   * @type {boolean}
   */ CAN_UPLOAD_SAME_BUFFER: {
        get () {
            return (0, $jNmcM.BatchRenderer).canUploadSameBuffer;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.CAN_UPLOAD_SAME_BUFFER is deprecated, use BatchRenderer.canUploadSameBuffer"), (0, $jNmcM.BatchRenderer).canUploadSameBuffer = value;
        }
    },
    /**
   * Default Garbage Collection mode.
   * @static
   * @name GC_MODE
   * @memberof PIXI.settings
   * @type {PIXI.GC_MODES}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMode
   */ GC_MODE: {
        get () {
            return (0, $iDGF3.TextureGCSystem).defaultMode;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.GC_MODE is deprecated, use TextureGCSystem.defaultMode"), (0, $iDGF3.TextureGCSystem).defaultMode = value;
        }
    },
    /**
   * Default Garbage Collection max idle.
   * @static
   * @name GC_MAX_IDLE
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultMaxIdle
   */ GC_MAX_IDLE: {
        get () {
            return (0, $iDGF3.TextureGCSystem).defaultMaxIdle;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.GC_MAX_IDLE is deprecated, use TextureGCSystem.defaultMaxIdle"), (0, $iDGF3.TextureGCSystem).defaultMaxIdle = value;
        }
    },
    /**
   * Default Garbage Collection maximum check count.
   * @static
   * @name GC_MAX_CHECK_COUNT
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.TextureGCSystem.defaultCheckCountMax
   */ GC_MAX_CHECK_COUNT: {
        get () {
            return (0, $iDGF3.TextureGCSystem).defaultCheckCountMax;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.GC_MAX_CHECK_COUNT is deprecated, use TextureGCSystem.defaultCheckCountMax"), (0, $iDGF3.TextureGCSystem).defaultCheckCountMax = value;
        }
    },
    /**
   * Default specify float precision in vertex shader.
   * @static
   * @name PRECISION_VERTEX
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultVertexPrecision
   */ PRECISION_VERTEX: {
        get () {
            return (0, $k7n3P.Program).defaultVertexPrecision;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.PRECISION_VERTEX is deprecated, use Program.defaultVertexPrecision"), (0, $k7n3P.Program).defaultVertexPrecision = value;
        }
    },
    /**
   * Default specify float precision in fragment shader.
   * @static
   * @name PRECISION_FRAGMENT
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @deprecated since 7.1.0
   * @see PIXI.Program.defaultFragmentPrecision
   */ PRECISION_FRAGMENT: {
        get () {
            return (0, $k7n3P.Program).defaultFragmentPrecision;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.PRECISION_FRAGMENT is deprecated, use Program.defaultFragmentPrecision"), (0, $k7n3P.Program).defaultFragmentPrecision = value;
        }
    }
});

});
parcelRegister("lmRm8", function(module, exports) {

$parcel$export(module.exports, "ENV", () => $551209d754b5b429$export$83401e34d5e11bf4);
$parcel$export(module.exports, "RENDERER_TYPE", () => $551209d754b5b429$export$747c566515e2a1d9);
$parcel$export(module.exports, "BUFFER_BITS", () => $551209d754b5b429$export$c07ea8ac66dac49);
$parcel$export(module.exports, "BLEND_MODES", () => $551209d754b5b429$export$f821c68fe9beaecf);
$parcel$export(module.exports, "DRAW_MODES", () => $551209d754b5b429$export$91100badd8469338);
$parcel$export(module.exports, "FORMATS", () => $551209d754b5b429$export$e9c4b7b466aa8274);
$parcel$export(module.exports, "TARGETS", () => $551209d754b5b429$export$d1ff3caf57547dc5);
$parcel$export(module.exports, "TYPES", () => $551209d754b5b429$export$426db7a6155b7a80);
$parcel$export(module.exports, "SAMPLER_TYPES", () => $551209d754b5b429$export$8ee8af3637d728f5);
$parcel$export(module.exports, "SCALE_MODES", () => $551209d754b5b429$export$6b734c6a0bba8473);
$parcel$export(module.exports, "WRAP_MODES", () => $551209d754b5b429$export$2ab395cfb0dd2f0f);
$parcel$export(module.exports, "MIPMAP_MODES", () => $551209d754b5b429$export$16f6fb5da874bbfd);
$parcel$export(module.exports, "ALPHA_MODES", () => $551209d754b5b429$export$d56550d454401b73);
$parcel$export(module.exports, "CLEAR_MODES", () => $551209d754b5b429$export$784901839554cbc3);
$parcel$export(module.exports, "GC_MODES", () => $551209d754b5b429$export$5c6ba89c1f52b344);
$parcel$export(module.exports, "PRECISION", () => $551209d754b5b429$export$d6d3992f3becc879);
$parcel$export(module.exports, "MASK_TYPES", () => $551209d754b5b429$export$dbbea138c5d144);
$parcel$export(module.exports, "MSAA_QUALITY", () => $551209d754b5b429$export$1eadd657d5acc2f2);
$parcel$export(module.exports, "BUFFER_TYPE", () => $551209d754b5b429$export$b595a7e482202b96);
var $551209d754b5b429$export$83401e34d5e11bf4 = /* @__PURE__ */ ((ENV2)=>(ENV2[ENV2.WEBGL_LEGACY = 0] = "WEBGL_LEGACY", ENV2[ENV2.WEBGL = 1] = "WEBGL", ENV2[ENV2.WEBGL2 = 2] = "WEBGL2", ENV2))($551209d754b5b429$export$83401e34d5e11bf4 || {}), $551209d754b5b429$export$747c566515e2a1d9 = /* @__PURE__ */ ((RENDERER_TYPE2)=>(RENDERER_TYPE2[RENDERER_TYPE2.UNKNOWN = 0] = "UNKNOWN", RENDERER_TYPE2[RENDERER_TYPE2.WEBGL = 1] = "WEBGL", RENDERER_TYPE2[RENDERER_TYPE2.CANVAS = 2] = "CANVAS", RENDERER_TYPE2))($551209d754b5b429$export$747c566515e2a1d9 || {}), $551209d754b5b429$export$c07ea8ac66dac49 = /* @__PURE__ */ ((BUFFER_BITS2)=>(BUFFER_BITS2[BUFFER_BITS2.COLOR = 16384] = "COLOR", BUFFER_BITS2[BUFFER_BITS2.DEPTH = 256] = "DEPTH", BUFFER_BITS2[BUFFER_BITS2.STENCIL = 1024] = "STENCIL", BUFFER_BITS2))($551209d754b5b429$export$c07ea8ac66dac49 || {}), $551209d754b5b429$export$f821c68fe9beaecf = /* @__PURE__ */ ((BLEND_MODES2)=>(BLEND_MODES2[BLEND_MODES2.NORMAL = 0] = "NORMAL", BLEND_MODES2[BLEND_MODES2.ADD = 1] = "ADD", BLEND_MODES2[BLEND_MODES2.MULTIPLY = 2] = "MULTIPLY", BLEND_MODES2[BLEND_MODES2.SCREEN = 3] = "SCREEN", BLEND_MODES2[BLEND_MODES2.OVERLAY = 4] = "OVERLAY", BLEND_MODES2[BLEND_MODES2.DARKEN = 5] = "DARKEN", BLEND_MODES2[BLEND_MODES2.LIGHTEN = 6] = "LIGHTEN", BLEND_MODES2[BLEND_MODES2.COLOR_DODGE = 7] = "COLOR_DODGE", BLEND_MODES2[BLEND_MODES2.COLOR_BURN = 8] = "COLOR_BURN", BLEND_MODES2[BLEND_MODES2.HARD_LIGHT = 9] = "HARD_LIGHT", BLEND_MODES2[BLEND_MODES2.SOFT_LIGHT = 10] = "SOFT_LIGHT", BLEND_MODES2[BLEND_MODES2.DIFFERENCE = 11] = "DIFFERENCE", BLEND_MODES2[BLEND_MODES2.EXCLUSION = 12] = "EXCLUSION", BLEND_MODES2[BLEND_MODES2.HUE = 13] = "HUE", BLEND_MODES2[BLEND_MODES2.SATURATION = 14] = "SATURATION", BLEND_MODES2[BLEND_MODES2.COLOR = 15] = "COLOR", BLEND_MODES2[BLEND_MODES2.LUMINOSITY = 16] = "LUMINOSITY", BLEND_MODES2[BLEND_MODES2.NORMAL_NPM = 17] = "NORMAL_NPM", BLEND_MODES2[BLEND_MODES2.ADD_NPM = 18] = "ADD_NPM", BLEND_MODES2[BLEND_MODES2.SCREEN_NPM = 19] = "SCREEN_NPM", BLEND_MODES2[BLEND_MODES2.NONE = 20] = "NONE", BLEND_MODES2[BLEND_MODES2.SRC_OVER = 0] = "SRC_OVER", BLEND_MODES2[BLEND_MODES2.SRC_IN = 21] = "SRC_IN", BLEND_MODES2[BLEND_MODES2.SRC_OUT = 22] = "SRC_OUT", BLEND_MODES2[BLEND_MODES2.SRC_ATOP = 23] = "SRC_ATOP", BLEND_MODES2[BLEND_MODES2.DST_OVER = 24] = "DST_OVER", BLEND_MODES2[BLEND_MODES2.DST_IN = 25] = "DST_IN", BLEND_MODES2[BLEND_MODES2.DST_OUT = 26] = "DST_OUT", BLEND_MODES2[BLEND_MODES2.DST_ATOP = 27] = "DST_ATOP", BLEND_MODES2[BLEND_MODES2.ERASE = 26] = "ERASE", BLEND_MODES2[BLEND_MODES2.SUBTRACT = 28] = "SUBTRACT", BLEND_MODES2[BLEND_MODES2.XOR = 29] = "XOR", BLEND_MODES2))($551209d754b5b429$export$f821c68fe9beaecf || {}), $551209d754b5b429$export$91100badd8469338 = /* @__PURE__ */ ((DRAW_MODES2)=>(DRAW_MODES2[DRAW_MODES2.POINTS = 0] = "POINTS", DRAW_MODES2[DRAW_MODES2.LINES = 1] = "LINES", DRAW_MODES2[DRAW_MODES2.LINE_LOOP = 2] = "LINE_LOOP", DRAW_MODES2[DRAW_MODES2.LINE_STRIP = 3] = "LINE_STRIP", DRAW_MODES2[DRAW_MODES2.TRIANGLES = 4] = "TRIANGLES", DRAW_MODES2[DRAW_MODES2.TRIANGLE_STRIP = 5] = "TRIANGLE_STRIP", DRAW_MODES2[DRAW_MODES2.TRIANGLE_FAN = 6] = "TRIANGLE_FAN", DRAW_MODES2))($551209d754b5b429$export$91100badd8469338 || {}), $551209d754b5b429$export$e9c4b7b466aa8274 = /* @__PURE__ */ ((FORMATS2)=>(FORMATS2[FORMATS2.RGBA = 6408] = "RGBA", FORMATS2[FORMATS2.RGB = 6407] = "RGB", FORMATS2[FORMATS2.RG = 33319] = "RG", FORMATS2[FORMATS2.RED = 6403] = "RED", FORMATS2[FORMATS2.RGBA_INTEGER = 36249] = "RGBA_INTEGER", FORMATS2[FORMATS2.RGB_INTEGER = 36248] = "RGB_INTEGER", FORMATS2[FORMATS2.RG_INTEGER = 33320] = "RG_INTEGER", FORMATS2[FORMATS2.RED_INTEGER = 36244] = "RED_INTEGER", FORMATS2[FORMATS2.ALPHA = 6406] = "ALPHA", FORMATS2[FORMATS2.LUMINANCE = 6409] = "LUMINANCE", FORMATS2[FORMATS2.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", FORMATS2[FORMATS2.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", FORMATS2[FORMATS2.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", FORMATS2))($551209d754b5b429$export$e9c4b7b466aa8274 || {}), $551209d754b5b429$export$d1ff3caf57547dc5 = /* @__PURE__ */ ((TARGETS2)=>(TARGETS2[TARGETS2.TEXTURE_2D = 3553] = "TEXTURE_2D", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", TARGETS2[TARGETS2.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", TARGETS2[TARGETS2.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", TARGETS2))($551209d754b5b429$export$d1ff3caf57547dc5 || {}), $551209d754b5b429$export$426db7a6155b7a80 = /* @__PURE__ */ ((TYPES2)=>(TYPES2[TYPES2.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", TYPES2[TYPES2.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", TYPES2[TYPES2.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", TYPES2[TYPES2.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", TYPES2[TYPES2.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", TYPES2[TYPES2.UNSIGNED_INT = 5125] = "UNSIGNED_INT", TYPES2[TYPES2.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", TYPES2[TYPES2.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", TYPES2[TYPES2.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", TYPES2[TYPES2.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", TYPES2[TYPES2.BYTE = 5120] = "BYTE", TYPES2[TYPES2.SHORT = 5122] = "SHORT", TYPES2[TYPES2.INT = 5124] = "INT", TYPES2[TYPES2.FLOAT = 5126] = "FLOAT", TYPES2[TYPES2.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", TYPES2[TYPES2.HALF_FLOAT = 36193] = "HALF_FLOAT", TYPES2))($551209d754b5b429$export$426db7a6155b7a80 || {}), $551209d754b5b429$export$8ee8af3637d728f5 = /* @__PURE__ */ ((SAMPLER_TYPES2)=>(SAMPLER_TYPES2[SAMPLER_TYPES2.FLOAT = 0] = "FLOAT", SAMPLER_TYPES2[SAMPLER_TYPES2.INT = 1] = "INT", SAMPLER_TYPES2[SAMPLER_TYPES2.UINT = 2] = "UINT", SAMPLER_TYPES2))($551209d754b5b429$export$8ee8af3637d728f5 || {}), $551209d754b5b429$export$6b734c6a0bba8473 = /* @__PURE__ */ ((SCALE_MODES2)=>(SCALE_MODES2[SCALE_MODES2.NEAREST = 0] = "NEAREST", SCALE_MODES2[SCALE_MODES2.LINEAR = 1] = "LINEAR", SCALE_MODES2))($551209d754b5b429$export$6b734c6a0bba8473 || {}), $551209d754b5b429$export$2ab395cfb0dd2f0f = /* @__PURE__ */ ((WRAP_MODES2)=>(WRAP_MODES2[WRAP_MODES2.CLAMP = 33071] = "CLAMP", WRAP_MODES2[WRAP_MODES2.REPEAT = 10497] = "REPEAT", WRAP_MODES2[WRAP_MODES2.MIRRORED_REPEAT = 33648] = "MIRRORED_REPEAT", WRAP_MODES2))($551209d754b5b429$export$2ab395cfb0dd2f0f || {}), $551209d754b5b429$export$16f6fb5da874bbfd = /* @__PURE__ */ ((MIPMAP_MODES2)=>(MIPMAP_MODES2[MIPMAP_MODES2.OFF = 0] = "OFF", MIPMAP_MODES2[MIPMAP_MODES2.POW2 = 1] = "POW2", MIPMAP_MODES2[MIPMAP_MODES2.ON = 2] = "ON", MIPMAP_MODES2[MIPMAP_MODES2.ON_MANUAL = 3] = "ON_MANUAL", MIPMAP_MODES2))($551209d754b5b429$export$16f6fb5da874bbfd || {}), $551209d754b5b429$export$d56550d454401b73 = /* @__PURE__ */ ((ALPHA_MODES2)=>(ALPHA_MODES2[ALPHA_MODES2.NPM = 0] = "NPM", ALPHA_MODES2[ALPHA_MODES2.UNPACK = 1] = "UNPACK", ALPHA_MODES2[ALPHA_MODES2.PMA = 2] = "PMA", ALPHA_MODES2[ALPHA_MODES2.NO_PREMULTIPLIED_ALPHA = 0] = "NO_PREMULTIPLIED_ALPHA", ALPHA_MODES2[ALPHA_MODES2.PREMULTIPLY_ON_UPLOAD = 1] = "PREMULTIPLY_ON_UPLOAD", ALPHA_MODES2[ALPHA_MODES2.PREMULTIPLIED_ALPHA = 2] = "PREMULTIPLIED_ALPHA", ALPHA_MODES2))($551209d754b5b429$export$d56550d454401b73 || {}), $551209d754b5b429$export$784901839554cbc3 = /* @__PURE__ */ ((CLEAR_MODES2)=>(CLEAR_MODES2[CLEAR_MODES2.NO = 0] = "NO", CLEAR_MODES2[CLEAR_MODES2.YES = 1] = "YES", CLEAR_MODES2[CLEAR_MODES2.AUTO = 2] = "AUTO", CLEAR_MODES2[CLEAR_MODES2.BLEND = 0] = "BLEND", CLEAR_MODES2[CLEAR_MODES2.CLEAR = 1] = "CLEAR", CLEAR_MODES2[CLEAR_MODES2.BLIT = 2] = "BLIT", CLEAR_MODES2))($551209d754b5b429$export$784901839554cbc3 || {}), $551209d754b5b429$export$5c6ba89c1f52b344 = /* @__PURE__ */ ((GC_MODES2)=>(GC_MODES2[GC_MODES2.AUTO = 0] = "AUTO", GC_MODES2[GC_MODES2.MANUAL = 1] = "MANUAL", GC_MODES2))($551209d754b5b429$export$5c6ba89c1f52b344 || {}), $551209d754b5b429$export$d6d3992f3becc879 = /* @__PURE__ */ ((PRECISION2)=>(PRECISION2.LOW = "lowp", PRECISION2.MEDIUM = "mediump", PRECISION2.HIGH = "highp", PRECISION2))($551209d754b5b429$export$d6d3992f3becc879 || {}), $551209d754b5b429$export$dbbea138c5d144 = /* @__PURE__ */ ((MASK_TYPES2)=>(MASK_TYPES2[MASK_TYPES2.NONE = 0] = "NONE", MASK_TYPES2[MASK_TYPES2.SCISSOR = 1] = "SCISSOR", MASK_TYPES2[MASK_TYPES2.STENCIL = 2] = "STENCIL", MASK_TYPES2[MASK_TYPES2.SPRITE = 3] = "SPRITE", MASK_TYPES2[MASK_TYPES2.COLOR = 4] = "COLOR", MASK_TYPES2))($551209d754b5b429$export$dbbea138c5d144 || {}), $551209d754b5b429$export$c306f8e81b8d1ca7 = /* @__PURE__ */ ((COLOR_MASK_BITS2)=>(COLOR_MASK_BITS2[COLOR_MASK_BITS2.RED = 1] = "RED", COLOR_MASK_BITS2[COLOR_MASK_BITS2.GREEN = 2] = "GREEN", COLOR_MASK_BITS2[COLOR_MASK_BITS2.BLUE = 4] = "BLUE", COLOR_MASK_BITS2[COLOR_MASK_BITS2.ALPHA = 8] = "ALPHA", COLOR_MASK_BITS2))($551209d754b5b429$export$c306f8e81b8d1ca7 || {}), $551209d754b5b429$export$1eadd657d5acc2f2 = /* @__PURE__ */ ((MSAA_QUALITY2)=>(MSAA_QUALITY2[MSAA_QUALITY2.NONE = 0] = "NONE", MSAA_QUALITY2[MSAA_QUALITY2.LOW = 2] = "LOW", MSAA_QUALITY2[MSAA_QUALITY2.MEDIUM = 4] = "MEDIUM", MSAA_QUALITY2[MSAA_QUALITY2.HIGH = 8] = "HIGH", MSAA_QUALITY2))($551209d754b5b429$export$1eadd657d5acc2f2 || {}), $551209d754b5b429$export$b595a7e482202b96 = /* @__PURE__ */ ((BUFFER_TYPE2)=>(BUFFER_TYPE2[BUFFER_TYPE2.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", BUFFER_TYPE2[BUFFER_TYPE2.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", BUFFER_TYPE2[BUFFER_TYPE2.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", BUFFER_TYPE2))($551209d754b5b429$export$b595a7e482202b96 || {});

});

parcelRegister("fVntm", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => (parcelRequire("lQgZZ")).isMobile);
$parcel$export(module.exports, "settings", () => (parcelRequire("16eqM")).settings);

var $7ZIqf = parcelRequire("7ZIqf");
parcelRequire("jYXUw");
parcelRequire("eoFz4");

var $16eqM = parcelRequire("16eqM");

var $lQgZZ = parcelRequire("lQgZZ");

});
parcelRegister("7ZIqf", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $d86b9bbbe9c4fcd0$export$e467cc3399500025);
const $d86b9bbbe9c4fcd0$export$e467cc3399500025 = {
    /**
   * Creates a canvas element of the given size.
   * This canvas is created using the browser's native canvas element.
   * @param width - width of the canvas
   * @param height - height of the canvas
   */ createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        return canvas.width = width, canvas.height = height, canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>new DOMParser().parseFromString(xml, "text/xml")
};

});

parcelRegister("jYXUw", function(module, exports) {

});

parcelRegister("eoFz4", function(module, exports) {

});

parcelRegister("16eqM", function(module, exports) {

$parcel$export(module.exports, "settings", () => $fcbcf105ed644495$export$a5a6e0b888b2c992);

var $7ZIqf = parcelRequire("7ZIqf");
const $fcbcf105ed644495$export$a5a6e0b888b2c992 = {
    /**
   * This adapter is used to call methods that are platform dependent.
   * For example `document.createElement` only runs on the web but fails in node environments.
   * This allows us to support more platforms by abstracting away specific implementations per platform.
   *
   * By default the adapter is set to work in the browser. However you can create your own
   * by implementing the `IAdapter` interface. See `IAdapter` for more information.
   * @name ADAPTER
   * @memberof PIXI.settings
   * @type {PIXI.IAdapter}
   * @default PIXI.BrowserAdapter
   */ ADAPTER: (0, $7ZIqf.BrowserAdapter),
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @static
   * @name RESOLUTION
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */ RESOLUTION: 1,
    /**
   * Enables bitmap creation before image load. This feature is experimental.
   * @static
   * @name CREATE_IMAGE_BITMAP
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */ CREATE_IMAGE_BITMAP: !1,
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * @static
   * @memberof PIXI.settings
   * @type {boolean}
   * @default false
   */ ROUND_PIXELS: !1
};

});

parcelRegister("lQgZZ", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $cb209844fab531da$export$d0a8044dce8ff2fc);
parcelRequire("k2Zek");
var $fQsgs = parcelRequire("fQsgs");
const $cb209844fab531da$var$isMobileCall = (0, $fQsgs.default).default ?? (0, $fQsgs.default), $cb209844fab531da$export$d0a8044dce8ff2fc = $cb209844fab531da$var$isMobileCall(globalThis.navigator);

});
parcelRegister("k2Zek", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("fQsgs")).default);

var $fQsgs = parcelRequire("fQsgs");

});
parcelRegister("fQsgs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b891a30d1336f1e9$export$2e2bcd8739ae039);
var $b891a30d1336f1e9$var$appleIphone = /iPhone/i;
var $b891a30d1336f1e9$var$appleIpod = /iPod/i;
var $b891a30d1336f1e9$var$appleTablet = /iPad/i;
var $b891a30d1336f1e9$var$appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var $b891a30d1336f1e9$var$androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var $b891a30d1336f1e9$var$androidTablet = /Android/i;
var $b891a30d1336f1e9$var$amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var $b891a30d1336f1e9$var$amazonTablet = /Silk/i;
var $b891a30d1336f1e9$var$windowsPhone = /Windows Phone/i;
var $b891a30d1336f1e9$var$windowsTablet = /\bWindows(?:.+)ARM\b/i;
var $b891a30d1336f1e9$var$otherBlackBerry = /BlackBerry/i;
var $b891a30d1336f1e9$var$otherBlackBerry10 = /BB10/i;
var $b891a30d1336f1e9$var$otherOpera = /Opera Mini/i;
var $b891a30d1336f1e9$var$otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var $b891a30d1336f1e9$var$otherFirefox = /Mobile(?:.+)Firefox\b/i;
var $b891a30d1336f1e9$var$isAppleTabletOnIos13 = function(navigator1) {
    return typeof navigator1 !== 'undefined' && navigator1.platform === 'MacIntel' && typeof navigator1.maxTouchPoints === 'number' && navigator1.maxTouchPoints > 1 && typeof MSStream === 'undefined';
};
function $b891a30d1336f1e9$var$createMatch(userAgent) {
    return function(regex) {
        return regex.test(userAgent);
    };
}
function $b891a30d1336f1e9$export$2e2bcd8739ae039(param) {
    var nav = {
        userAgent: '',
        platform: '',
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== 'undefined') nav = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints || 0
    };
    else if (typeof param === 'string') nav.userAgent = param;
    else if (param && param.userAgent) nav = {
        userAgent: param.userAgent,
        platform: param.platform,
        maxTouchPoints: param.maxTouchPoints || 0
    };
    var userAgent = nav.userAgent;
    var tmp = userAgent.split('[FBAN');
    if (typeof tmp[1] !== 'undefined') userAgent = tmp[0];
    tmp = userAgent.split('Twitter');
    if (typeof tmp[1] !== 'undefined') userAgent = tmp[0];
    var match = $b891a30d1336f1e9$var$createMatch(userAgent);
    var result = {
        apple: {
            phone: match($b891a30d1336f1e9$var$appleIphone) && !match($b891a30d1336f1e9$var$windowsPhone),
            ipod: match($b891a30d1336f1e9$var$appleIpod),
            tablet: !match($b891a30d1336f1e9$var$appleIphone) && (match($b891a30d1336f1e9$var$appleTablet) || $b891a30d1336f1e9$var$isAppleTabletOnIos13(nav)) && !match($b891a30d1336f1e9$var$windowsPhone),
            universal: match($b891a30d1336f1e9$var$appleUniversal),
            device: (match($b891a30d1336f1e9$var$appleIphone) || match($b891a30d1336f1e9$var$appleIpod) || match($b891a30d1336f1e9$var$appleTablet) || match($b891a30d1336f1e9$var$appleUniversal) || $b891a30d1336f1e9$var$isAppleTabletOnIos13(nav)) && !match($b891a30d1336f1e9$var$windowsPhone)
        },
        amazon: {
            phone: match($b891a30d1336f1e9$var$amazonPhone),
            tablet: !match($b891a30d1336f1e9$var$amazonPhone) && match($b891a30d1336f1e9$var$amazonTablet),
            device: match($b891a30d1336f1e9$var$amazonPhone) || match($b891a30d1336f1e9$var$amazonTablet)
        },
        android: {
            phone: !match($b891a30d1336f1e9$var$windowsPhone) && match($b891a30d1336f1e9$var$amazonPhone) || !match($b891a30d1336f1e9$var$windowsPhone) && match($b891a30d1336f1e9$var$androidPhone),
            tablet: !match($b891a30d1336f1e9$var$windowsPhone) && !match($b891a30d1336f1e9$var$amazonPhone) && !match($b891a30d1336f1e9$var$androidPhone) && (match($b891a30d1336f1e9$var$amazonTablet) || match($b891a30d1336f1e9$var$androidTablet)),
            device: !match($b891a30d1336f1e9$var$windowsPhone) && (match($b891a30d1336f1e9$var$amazonPhone) || match($b891a30d1336f1e9$var$amazonTablet) || match($b891a30d1336f1e9$var$androidPhone) || match($b891a30d1336f1e9$var$androidTablet)) || match(/\bokhttp\b/i)
        },
        windows: {
            phone: match($b891a30d1336f1e9$var$windowsPhone),
            tablet: match($b891a30d1336f1e9$var$windowsTablet),
            device: match($b891a30d1336f1e9$var$windowsPhone) || match($b891a30d1336f1e9$var$windowsTablet)
        },
        other: {
            blackberry: match($b891a30d1336f1e9$var$otherBlackBerry),
            blackberry10: match($b891a30d1336f1e9$var$otherBlackBerry10),
            opera: match($b891a30d1336f1e9$var$otherOpera),
            firefox: match($b891a30d1336f1e9$var$otherFirefox),
            chrome: match($b891a30d1336f1e9$var$otherChrome),
            device: match($b891a30d1336f1e9$var$otherBlackBerry) || match($b891a30d1336f1e9$var$otherBlackBerry10) || match($b891a30d1336f1e9$var$otherOpera) || match($b891a30d1336f1e9$var$otherFirefox) || match($b891a30d1336f1e9$var$otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
    result.phone = result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}

});




parcelRegister("lFGyw", function(module, exports) {

$parcel$export(module.exports, "BaseTextureCache", () => (parcelRequire("5ohKV")).BaseTextureCache);
$parcel$export(module.exports, "BoundingBox", () => (parcelRequire("8XBXU")).BoundingBox);
$parcel$export(module.exports, "CanvasRenderTarget", () => (parcelRequire("8zpmK")).CanvasRenderTarget);
$parcel$export(module.exports, "DATA_URI", () => (parcelRequire("ajMPb")).DATA_URI);
$parcel$export(module.exports, "EventEmitter", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3vRz3")))));
$parcel$export(module.exports, "ProgramCache", () => (parcelRequire("5ohKV")).ProgramCache);
$parcel$export(module.exports, "TextureCache", () => (parcelRequire("5ohKV")).TextureCache);
$parcel$export(module.exports, "clearTextureCache", () => (parcelRequire("5ohKV")).clearTextureCache);
$parcel$export(module.exports, "correctBlendMode", () => (parcelRequire("lMxm0")).correctBlendMode);
$parcel$export(module.exports, "createIndicesForQuads", () => (parcelRequire("fYeJa")).createIndicesForQuads);
$parcel$export(module.exports, "decomposeDataUri", () => (parcelRequire("518Qf")).decomposeDataUri);
$parcel$export(module.exports, "deprecation", () => (parcelRequire("1Koy5")).deprecation);
$parcel$export(module.exports, "destroyTextureCache", () => (parcelRequire("5ohKV")).destroyTextureCache);
$parcel$export(module.exports, "detectVideoAlphaMode", () => (parcelRequire("iXyUR")).detectVideoAlphaMode);
$parcel$export(module.exports, "determineCrossOrigin", () => (parcelRequire("bW1QN")).determineCrossOrigin);
$parcel$export(module.exports, "earcut", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("2jYVZ")))));
$parcel$export(module.exports, "getBufferType", () => (parcelRequire("iqDX5")).getBufferType);
$parcel$export(module.exports, "getCanvasBoundingBox", () => (parcelRequire("lCRMP")).getCanvasBoundingBox);
$parcel$export(module.exports, "getResolutionOfUrl", () => (parcelRequire("6e477")).getResolutionOfUrl);
$parcel$export(module.exports, "hex2rgb", () => (parcelRequire("jWw46")).hex2rgb);
$parcel$export(module.exports, "hex2string", () => (parcelRequire("jWw46")).hex2string);
$parcel$export(module.exports, "interleaveTypedArrays", () => (parcelRequire("enKsa")).interleaveTypedArrays);
$parcel$export(module.exports, "isMobile", () => (parcelRequire("lQgZZ")).isMobile);
$parcel$export(module.exports, "isPow2", () => (parcelRequire("bpIJG")).isPow2);
$parcel$export(module.exports, "isWebGLSupported", () => (parcelRequire("3mZWL")).isWebGLSupported);
$parcel$export(module.exports, "log2", () => (parcelRequire("bpIJG")).log2);
$parcel$export(module.exports, "nextPow2", () => (parcelRequire("bpIJG")).nextPow2);
$parcel$export(module.exports, "path", () => (parcelRequire("cskZB")).path);
$parcel$export(module.exports, "premultiplyBlendMode", () => (parcelRequire("lMxm0")).premultiplyBlendMode);
$parcel$export(module.exports, "premultiplyRgba", () => (parcelRequire("lMxm0")).premultiplyRgba);
$parcel$export(module.exports, "premultiplyTint", () => (parcelRequire("lMxm0")).premultiplyTint);
$parcel$export(module.exports, "premultiplyTintToRgba", () => (parcelRequire("lMxm0")).premultiplyTintToRgba);
$parcel$export(module.exports, "removeItems", () => (parcelRequire("7aCsl")).removeItems);
$parcel$export(module.exports, "rgb2hex", () => (parcelRequire("jWw46")).rgb2hex);
$parcel$export(module.exports, "sayHello", () => (parcelRequire("6AL4N")).sayHello);
$parcel$export(module.exports, "sign", () => (parcelRequire("Xr4zf")).sign);
$parcel$export(module.exports, "skipHello", () => (parcelRequire("6AL4N")).skipHello);
$parcel$export(module.exports, "string2hex", () => (parcelRequire("jWw46")).string2hex);
$parcel$export(module.exports, "trimCanvas", () => (parcelRequire("i0JHz")).trimCanvas);
$parcel$export(module.exports, "uid", () => (parcelRequire("2yb2o")).uid);
$parcel$export(module.exports, "url", () => (parcelRequire("8MGdI")).url);
parcelRequire("8AT8C");
parcelRequire("fVntm");
var $lQgZZ = parcelRequire("lQgZZ");

var $3vRz3 = parcelRequire("3vRz3");

var $2jYVZ = parcelRequire("2jYVZ");

var $8MGdI = parcelRequire("8MGdI");

var $cskZB = parcelRequire("cskZB");

var $iXyUR = parcelRequire("iXyUR");

var $6AL4N = parcelRequire("6AL4N");

var $3mZWL = parcelRequire("3mZWL");

var $jWw46 = parcelRequire("jWw46");

var $lMxm0 = parcelRequire("lMxm0");

var $ajMPb = parcelRequire("ajMPb");

var $fYeJa = parcelRequire("fYeJa");

var $iqDX5 = parcelRequire("iqDX5");

var $enKsa = parcelRequire("enKsa");

var $bpIJG = parcelRequire("bpIJG");

var $7aCsl = parcelRequire("7aCsl");

var $Xr4zf = parcelRequire("Xr4zf");

var $2yb2o = parcelRequire("2yb2o");

var $1Koy5 = parcelRequire("1Koy5");

var $8XBXU = parcelRequire("8XBXU");

var $5ohKV = parcelRequire("5ohKV");

var $8zpmK = parcelRequire("8zpmK");

var $lCRMP = parcelRequire("lCRMP");

var $i0JHz = parcelRequire("i0JHz");

var $518Qf = parcelRequire("518Qf");

var $bW1QN = parcelRequire("bW1QN");

var $6e477 = parcelRequire("6e477");
parcelRequire("bx5CL");

});
parcelRegister("8AT8C", function(module, exports) {
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
(0, $16eqM.settings).RETINA_PREFIX = /@([0-9\.]+)x/;
(0, $16eqM.settings).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = !1;

});

parcelRegister("3vRz3", function(module, exports) {
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("2jYVZ", function(module, exports) {
'use strict';
module.exports = $1b0c9f6ca9bef72e$var$earcut;
module.exports.default = $1b0c9f6ca9bef72e$var$earcut;
function $1b0c9f6ca9bef72e$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $1b0c9f6ca9bef72e$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $1b0c9f6ca9bef72e$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $1b0c9f6ca9bef72e$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $1b0c9f6ca9bef72e$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $1b0c9f6ca9bef72e$var$equals(last, last.next)) {
        $1b0c9f6ca9bef72e$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $1b0c9f6ca9bef72e$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($1b0c9f6ca9bef72e$var$equals(p, p.next) || $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) === 0)) {
            $1b0c9f6ca9bef72e$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $1b0c9f6ca9bef72e$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) : $1b0c9f6ca9bef72e$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $1b0c9f6ca9bef72e$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $1b0c9f6ca9bef72e$var$earcutLinked($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $1b0c9f6ca9bef72e$var$cureLocalIntersections($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim);
                $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $1b0c9f6ca9bef72e$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $1b0c9f6ca9bef72e$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $1b0c9f6ca9bef72e$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $1b0c9f6ca9bef72e$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $1b0c9f6ca9bef72e$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$intersects(a, p, p.next, b) && $1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $1b0c9f6ca9bef72e$var$removeNode(p);
            $1b0c9f6ca9bef72e$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $1b0c9f6ca9bef72e$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $1b0c9f6ca9bef72e$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $1b0c9f6ca9bef72e$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $1b0c9f6ca9bef72e$var$filterPoints(a, a.next);
                c = $1b0c9f6ca9bef72e$var$filterPoints(c, c.next);
                // run earcut on each half
                $1b0c9f6ca9bef72e$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $1b0c9f6ca9bef72e$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($1b0c9f6ca9bef72e$var$getLeftmost(list));
    }
    queue.sort($1b0c9f6ca9bef72e$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $1b0c9f6ca9bef72e$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $1b0c9f6ca9bef72e$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $1b0c9f6ca9bef72e$var$eliminateHole(hole, outerNode) {
    var bridge = $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $1b0c9f6ca9bef72e$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $1b0c9f6ca9bef72e$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $1b0c9f6ca9bef72e$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $1b0c9f6ca9bef72e$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($1b0c9f6ca9bef72e$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p) {
    return $1b0c9f6ca9bef72e$var$area(m.prev, m, p.prev) < 0 && $1b0c9f6ca9bef72e$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $1b0c9f6ca9bef72e$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $1b0c9f6ca9bef72e$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $1b0c9f6ca9bef72e$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $1b0c9f6ca9bef72e$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $1b0c9f6ca9bef72e$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $1b0c9f6ca9bef72e$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a) && $1b0c9f6ca9bef72e$var$middleInside(a, b) && // locally visible
    ($1b0c9f6ca9bef72e$var$area(a.prev, a, b.prev) || $1b0c9f6ca9bef72e$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) > 0 && $1b0c9f6ca9bef72e$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $1b0c9f6ca9bef72e$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $1b0c9f6ca9bef72e$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $1b0c9f6ca9bef72e$var$intersects(p1, q1, p2, q2) {
    var o1 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, p2));
    var o2 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, q2));
    var o3 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, p1));
    var o4 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $1b0c9f6ca9bef72e$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $1b0c9f6ca9bef72e$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $1b0c9f6ca9bef72e$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $1b0c9f6ca9bef72e$var$locallyInside(a, b) {
    return $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) < 0 ? $1b0c9f6ca9bef72e$var$area(a, b, a.next) >= 0 && $1b0c9f6ca9bef72e$var$area(a, a.prev, b) >= 0 : $1b0c9f6ca9bef72e$var$area(a, b, a.prev) < 0 || $1b0c9f6ca9bef72e$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $1b0c9f6ca9bef72e$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $1b0c9f6ca9bef72e$var$splitPolygon(a, b) {
    var a2 = new $1b0c9f6ca9bef72e$var$Node(a.i, a.x, a.y), b2 = new $1b0c9f6ca9bef72e$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $1b0c9f6ca9bef72e$var$insertNode(i, x, y, last) {
    var p = new $1b0c9f6ca9bef72e$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $1b0c9f6ca9bef72e$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $1b0c9f6ca9bef72e$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$1b0c9f6ca9bef72e$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$1b0c9f6ca9bef72e$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

});

parcelRegister("8MGdI", function(module, exports) {

$parcel$export(module.exports, "url", () => $149c28eb351207a9$export$128fa18b7194ef);

var $biuEp = parcelRequire("biuEp");

var $1Koy5 = parcelRequire("1Koy5");
const $149c28eb351207a9$export$128fa18b7194ef = {
    /**
   * @deprecated since 7.3.0
   */ get parse () {
        return (0, $1Koy5.deprecation)("7.3.0", "utils.url.parse is deprecated, use native URL API instead."), $biuEp.parse;
    },
    /**
   * @deprecated since 7.3.0
   */ get format () {
        return (0, $1Koy5.deprecation)("7.3.0", "utils.url.format is deprecated, use native URL API instead."), $biuEp.format;
    },
    /**
   * @deprecated since 7.3.0
   */ get resolve () {
        return (0, $1Koy5.deprecation)("7.3.0", "utils.url.resolve is deprecated, use native URL API instead."), $biuEp.resolve;
    }
};

});
parcelRegister("1Koy5", function(module, exports) {

$parcel$export(module.exports, "deprecation", () => $5d432cd6d6627298$export$afd31d834b512e89);
const $5d432cd6d6627298$var$warnings = {};
function $5d432cd6d6627298$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($5d432cd6d6627298$var$warnings[message]) return;
    let stack = new Error().stack;
    typeof stack > "u" ? console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`) : (stack = stack.split(`
`).splice(ignoreDepth).join(`
`), console.groupCollapsed ? (console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`), console.warn(stack), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`), console.warn(stack))), $5d432cd6d6627298$var$warnings[message] = !0;
}

});


parcelRegister("cskZB", function(module, exports) {

$parcel$export(module.exports, "path", () => $e535525d266072b6$export$bb654e07daaf8c3a);
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
function $e535525d266072b6$var$assertPath(path2) {
    if (typeof path2 != "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $e535525d266072b6$var$removeUrlParams(url) {
    return url.split("?")[0].split("#")[0];
}
function $e535525d266072b6$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $e535525d266072b6$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($e535525d266072b6$var$escapeRegExp(find), "g"), replace);
}
function $e535525d266072b6$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "", lastSegmentLength = 0, lastSlash = -1, dots = 0, code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else {
            if (code === 47) break;
            code = 47;
        }
        if (code === 47) {
            if (!(lastSlash === i - 1 || dots === 1)) {
                if (lastSlash !== i - 1 && dots === 2) {
                    if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                        if (res.length > 2) {
                            const lastSlashIndex = res.lastIndexOf("/");
                            if (lastSlashIndex !== res.length - 1) {
                                lastSlashIndex === -1 ? (res = "", lastSegmentLength = 0) : (res = res.slice(0, lastSlashIndex), lastSegmentLength = res.length - 1 - res.lastIndexOf("/")), lastSlash = i, dots = 0;
                                continue;
                            }
                        } else if (res.length === 2 || res.length === 1) {
                            res = "", lastSegmentLength = 0, lastSlash = i, dots = 0;
                            continue;
                        }
                    }
                    allowAboveRoot && (res.length > 0 ? res += "/.." : res = "..", lastSegmentLength = 2);
                } else res.length > 0 ? res += `/${path2.slice(lastSlash + 1, i)}` : res = path2.slice(lastSlash + 1, i), lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i, dots = 0;
        } else code === 46 && dots !== -1 ? ++dots : dots = -1;
    }
    return res;
}
const $e535525d266072b6$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */ toPosix (path2) {
        return $e535525d266072b6$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */ getProtocol (path2) {
        $e535525d266072b6$var$assertPath(path2), path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        return matchProtocol ? matchProtocol[0] : "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        if ($e535525d266072b6$var$assertPath(url), this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $e535525d266072b6$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $16eqM.settings).ADAPTER.getBaseUrl())), rootUrl = $e535525d266072b6$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        return url = this.toPosix(url), url.startsWith("/") ? $e535525d266072b6$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1)) : this.isAbsolute(url) ? url : this.join(baseUrl, url);
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */ normalize (path2) {
        if ($e535525d266072b6$var$assertPath(path2), path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        this.hasProtocol(path2) && (protocol = this.rootname(path2), path2 = path2.slice(protocol.length));
        const trailingSeparator = path2.endsWith("/");
        return path2 = $e535525d266072b6$var$normalizeStringPosix(path2, !1), path2.length > 0 && trailingSeparator && (path2 += "/"), isAbsolute ? `/${path2}` : protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */ isAbsolute (path2) {
        return $e535525d266072b6$var$assertPath(path2), path2 = this.toPosix(path2), this.hasProtocol(path2) ? !0 : path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            if ($e535525d266072b6$var$assertPath(arg), arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    this.joinExtensions.includes(this.extname(prevArg).toLowerCase()) ? joined += `/../${arg}` : joined += `/${arg}`;
                }
            }
        }
        return joined === void 0 ? "." : this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */ dirname (path2) {
        if ($e535525d266072b6$var$assertPath(path2), path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1, matchedSlash = !0;
        const proto = this.getProtocol(path2), origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i)if (code = path2.charCodeAt(i), code === 47) {
            if (!matchedSlash) {
                end = i;
                break;
            }
        } else matchedSlash = !1;
        return end === -1 ? hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto : hasRoot && end === 1 ? "//" : proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */ rootname (path2) {
        $e535525d266072b6$var$assertPath(path2), path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/") ? root = "/" : root = this.getProtocol(path2), this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            index !== -1 ? root = path2.slice(0, index) : root = path2, root.endsWith("/") || (root += "/");
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */ basename (path2, ext) {
        $e535525d266072b6$var$assertPath(path2), ext && $e535525d266072b6$var$assertPath(ext), path2 = $e535525d266072b6$var$removeUrlParams(this.toPosix(path2));
        let start = 0, end = -1, matchedSlash = !0, i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1, firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else firstNonSlashEnd === -1 && (matchedSlash = !1, firstNonSlashEnd = i + 1), extIdx >= 0 && (code === ext.charCodeAt(extIdx) ? --extIdx === -1 && (end = i) : (extIdx = -1, end = firstNonSlashEnd));
            }
            return start === end ? end = firstNonSlashEnd : end === -1 && (end = path2.length), path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i)if (path2.charCodeAt(i) === 47) {
            if (!matchedSlash) {
                start = i + 1;
                break;
            }
        } else end === -1 && (matchedSlash = !1, end = i + 1);
        return end === -1 ? "" : path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */ extname (path2) {
        $e535525d266072b6$var$assertPath(path2), path2 = $e535525d266072b6$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1, startPart = 0, end = -1, matchedSlash = !0, preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            end === -1 && (matchedSlash = !1, end = i + 1), code === 46 ? startDot === -1 ? startDot = i : preDotState !== 1 && (preDotState = 1) : startDot !== -1 && (preDotState = -1);
        }
        return startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? "" : path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */ parse (path2) {
        $e535525d266072b6$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $e535525d266072b6$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2), isAbsolute || this.hasProtocol(path2) ? start = 1 : start = 0;
        let startDot = -1, startPart = 0, end = -1, matchedSlash = !0, i = path2.length - 1, preDotState = 0;
        for(; i >= start; --i){
            if (code = path2.charCodeAt(i), code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            end === -1 && (matchedSlash = !1, end = i + 1), code === 46 ? startDot === -1 ? startDot = i : preDotState !== 1 && (preDotState = 1) : startDot !== -1 && (preDotState = -1);
        }
        return startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1 ? end !== -1 && (startPart === 0 && isAbsolute ? ret.base = ret.name = path2.slice(1, end) : ret.base = ret.name = path2.slice(startPart, end)) : (startPart === 0 && isAbsolute ? (ret.name = path2.slice(1, startDot), ret.base = path2.slice(1, end)) : (ret.name = path2.slice(startPart, startDot), ret.base = path2.slice(startPart, end)), ret.ext = path2.slice(startDot, end)), ret.dir = this.dirname(path2), protocol && (ret.dir = protocol + ret.dir), ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("iXyUR", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $f6b1f43e16d6dace$export$8df68d58aae31877);

var $lmRm8 = parcelRequire("lmRm8");
let $f6b1f43e16d6dace$var$promise;
async function $f6b1f43e16d6dace$export$8df68d58aae31877() {
    return $f6b1f43e16d6dace$var$promise ?? ($f6b1f43e16d6dace$var$promise = (async ()=>{
        const gl = document.createElement("canvas").getContext("webgl");
        if (!gl) return (0, $lmRm8.ALPHA_MODES).UNPACK;
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2), video2.onerror = ()=>resolve(null), video2.autoplay = !1, video2.crossOrigin = "anonymous", video2.preload = "auto", video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", video2.load();
        });
        if (!video) return (0, $lmRm8.ALPHA_MODES).UNPACK;
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer), gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0), gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE), gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        return gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel), gl.deleteFramebuffer(framebuffer), gl.deleteTexture(texture), gl.getExtension("WEBGL_lose_context")?.loseContext(), pixel[0] <= pixel[3] ? (0, $lmRm8.ALPHA_MODES).PMA : (0, $lmRm8.ALPHA_MODES).UNPACK;
    })()), $f6b1f43e16d6dace$var$promise;
}

});

parcelRegister("6AL4N", function(module, exports) {

$parcel$export(module.exports, "skipHello", () => $eecbcc1f01f3f84b$export$702210f86367d7ed);
$parcel$export(module.exports, "sayHello", () => $eecbcc1f01f3f84b$export$2c6a96c059a06e7c);

var $1Koy5 = parcelRequire("1Koy5");
function $eecbcc1f01f3f84b$export$702210f86367d7ed() {
    (0, $1Koy5.deprecation)("7.0.0", "skipHello is deprecated, please use settings.RENDER_OPTIONS.hello");
}
function $eecbcc1f01f3f84b$export$2c6a96c059a06e7c() {
    (0, $1Koy5.deprecation)("7.0.0", `sayHello is deprecated, please use Renderer's "hello" option`);
}

});

parcelRegister("3mZWL", function(module, exports) {

$parcel$export(module.exports, "isWebGLSupported", () => $cd44038b470b5fa0$export$83dc396b76015322);
parcelRequire("8AT8C");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
let $cd44038b470b5fa0$var$supported;
function $cd44038b470b5fa0$export$83dc396b76015322() {
    return typeof $cd44038b470b5fa0$var$supported > "u" && ($cd44038b470b5fa0$var$supported = function() {
        const contextOptions = {
            stencil: !0,
            failIfMajorPerformanceCaveat: (0, $16eqM.settings).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
        };
        try {
            if (!(0, $16eqM.settings).ADAPTER.getWebGLRenderingContext()) return !1;
            const canvas = (0, $16eqM.settings).ADAPTER.createCanvas();
            let gl = canvas.getContext("webgl", contextOptions) || canvas.getContext("experimental-webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                loseContext && loseContext.loseContext();
            }
            return gl = null, success;
        } catch  {
            return !1;
        }
    }()), $cd44038b470b5fa0$var$supported;
}

});

parcelRegister("jWw46", function(module, exports) {

$parcel$export(module.exports, "hex2rgb", () => $74eb97447ee7d711$export$858a46ce014e0e87);
$parcel$export(module.exports, "hex2string", () => $74eb97447ee7d711$export$7a57339af2222169);
$parcel$export(module.exports, "string2hex", () => $74eb97447ee7d711$export$f6a774610dbc2f6);
$parcel$export(module.exports, "rgb2hex", () => $74eb97447ee7d711$export$883528fb0afa7177);
parcelRequire("8HZMw");
var $1PNws = parcelRequire("1PNws");

var $1Koy5 = parcelRequire("1Koy5");
function $74eb97447ee7d711$export$858a46ce014e0e87(hex, out = []) {
    return (0, $1Koy5.deprecation)("7.2.0", "utils.hex2rgb is deprecated, use Color#toRgbArray instead"), (0, $1PNws.Color).shared.setValue(hex).toRgbArray(out);
}
function $74eb97447ee7d711$export$7a57339af2222169(hex) {
    return (0, $1Koy5.deprecation)("7.2.0", "utils.hex2string is deprecated, use Color#toHex instead"), (0, $1PNws.Color).shared.setValue(hex).toHex();
}
function $74eb97447ee7d711$export$f6a774610dbc2f6(string) {
    return (0, $1Koy5.deprecation)("7.2.0", "utils.string2hex is deprecated, use Color#toNumber instead"), (0, $1PNws.Color).shared.setValue(string).toNumber();
}
function $74eb97447ee7d711$export$883528fb0afa7177(rgb) {
    return (0, $1Koy5.deprecation)("7.2.0", "utils.rgb2hex is deprecated, use Color#toNumber instead"), (0, $1PNws.Color).shared.setValue(rgb).toNumber();
}

});
parcelRegister("8HZMw", function(module, exports) {

$parcel$export(module.exports, "Color", () => (parcelRequire("1PNws")).Color);

var $1PNws = parcelRequire("1PNws");

});
parcelRegister("1PNws", function(module, exports) {

$parcel$export(module.exports, "Color", () => $6c0bc7edac0d7e9d$export$892596cec99bc70e);

var $erZA3 = parcelRequire("erZA3");

var $lCM3s = parcelRequire("lCM3s");
(0, $erZA3.extend)([
    (0, $lCM3s.default)
]);
const $6c0bc7edac0d7e9d$var$_Color = class _Color2 {
    /**
   * @param {PIXI.ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = value;
    }
    /** Get red component (0 - 1) */ get red() {
        return this._components[0];
    }
    /** Get green component (0 - 1) */ get green() {
        return this._components[1];
    }
    /** Get blue component (0 - 1) */ get blue() {
        return this._components[2];
    }
    /** Get alpha component (0 - 1) */ get alpha() {
        return this._components[3];
    }
    /**
   * Set the value, suitable for chaining
   * @param value
   * @see PIXI.Color.value
   */ setValue(value) {
        return this.value = value, this;
    }
    /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link PIXI.Color.multiply multiply},
   *   {@link PIXI.Color.premultiply premultiply} or {@link PIXI.Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   * @type {PIXI.ColorSource}
   */ set value(value) {
        if (value instanceof _Color2) this._value = this.cloneSource(value._value), this._int = value._int, this._components.set(value._components);
        else {
            if (value === null) throw new Error("Cannot set PIXI.Color#value to null");
            (this._value === null || !this.isSourceEqual(this._value, value)) && (this.normalize(value), this._value = this.cloneSource(value));
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ cloneSource(value) {
        return typeof value == "string" || typeof value == "number" || value instanceof Number || value === null ? value : Array.isArray(value) || ArrayBuffer.isView(value) ? value.slice(0) : typeof value == "object" && value !== null ? {
            ...value
        } : value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        if (type1 !== typeof value2) return !1;
        if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) return value1.length !== value2.length ? !1 : value1.every((v, i)=>v === value2[i]);
        if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1), keys2 = Object.keys(value2);
            return keys1.length !== keys2.length ? !1 : keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        return out = out ?? [], out[0] = Math.round(r * 255), out[1] = Math.round(g * 255), out[2] = Math.round(b * 255), out;
    }
    toRgbArray(out) {
        out = out ?? [];
        const [r, g, b] = this._components;
        return out[0] = r, out[1] = g, out[2] = b, out;
    }
    /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {PIXI.ColorSource} value - The color to multiply by.
   */ multiply(value) {
        const [r, g, b, a] = _Color2.temp.setValue(value)._components;
        return this._components[0] *= r, this._components[1] *= g, this._components[2] *= b, this._components[3] *= a, this.refreshInt(), this._value = null, this;
    }
    /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {PIXI.Color} - Itself.
   */ premultiply(alpha, applyToRGB = !0) {
        return applyToRGB && (this._components[0] *= alpha, this._components[1] *= alpha, this._components[2] *= alpha), this._components[3] = alpha, this.refreshInt(), this._value = null, this;
    }
    /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */ toPremultiplied(alpha, applyToRGB = !0) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255, g = this._int >> 8 & 255, b = this._int & 255;
        return applyToRGB && (r = r * alpha + 0.5 | 0, g = g * alpha + 0.5 | 0, b = b * alpha + 0.5 | 0), (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexidecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexidecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */ toHexa() {
        const alphaString = Math.round(this._components[3] * 255).toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */ setAlpha(alpha) {
        return this._components[3] = this._clamp(alpha), this;
    }
    /**
   * Rounds the specified color according to the step. This action is destructive, and will
   * override the previous `value` property to be `null`. The alpha component is not rounded.
   * @param steps - Number of steps which will be used as a cap when rounding colors
   * @deprecated since 7.3.0
   */ round(steps) {
        const [r, g, b] = this._components;
        return this._components[0] = Math.round(r * steps) / steps, this._components[1] = Math.round(g * steps) / steps, this._components[2] = Math.round(b * steps) / steps, this.refreshInt(), this._value = null, this;
    }
    toArray(out) {
        out = out ?? [];
        const [r, g, b, a] = this._components;
        return out[0] = r, out[1] = g, out[2] = b, out[3] = a, out;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ normalize(value) {
        let r, g, b, a;
        if ((typeof value == "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255, g = (int >> 8 & 255) / 255, b = (int & 255) / 255, a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) value = this._clamp(value), [r, g, b, a = 1] = value;
        else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) value = this._clamp(value, 0, 255), [r, g, b, a = 255] = value, r /= 255, g /= 255, b /= 255, a /= 255;
        else if (typeof value == "string" || typeof value == "object") {
            if (typeof value == "string") {
                const match = _Color2.HEX_PATTERN.exec(value);
                match && (value = `#${match[2]}`);
            }
            const color = (0, $erZA3.colord)(value);
            color.isValid() && ({ r: r, g: g, b: b, a: a } = color.rgba, r /= 255, g /= 255, b /= 255);
        }
        if (r !== void 0) this._components[0] = r, this._components[1] = g, this._components[2] = b, this._components[3] = a, this.refreshInt();
        else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        return typeof value == "number" ? Math.min(Math.max(value, min), max) : (value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        }), value);
    }
};
$6c0bc7edac0d7e9d$var$_Color.shared = new $6c0bc7edac0d7e9d$var$_Color(), /**
* Temporary Color object for static uses internally.
* As to not conflict with Color.shared.
* @ignore
*/ $6c0bc7edac0d7e9d$var$_Color.temp = new $6c0bc7edac0d7e9d$var$_Color(), /** Pattern for hex strings */ $6c0bc7edac0d7e9d$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $6c0bc7edac0d7e9d$export$892596cec99bc70e = $6c0bc7edac0d7e9d$var$_Color;

});
parcelRegister("erZA3", function(module, exports) {

$parcel$export(module.exports, "colord", () => $482ad42e73ee00b6$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $482ad42e73ee00b6$export$8b58be045bf06082);
var $482ad42e73ee00b6$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $482ad42e73ee00b6$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $482ad42e73ee00b6$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $482ad42e73ee00b6$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $482ad42e73ee00b6$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $482ad42e73ee00b6$var$a = function(r) {
    return {
        r: $482ad42e73ee00b6$var$e(r.r, 0, 255),
        g: $482ad42e73ee00b6$var$e(r.g, 0, 255),
        b: $482ad42e73ee00b6$var$e(r.b, 0, 255),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$o = function(r) {
    return {
        r: $482ad42e73ee00b6$var$n(r.r),
        g: $482ad42e73ee00b6$var$n(r.g),
        b: $482ad42e73ee00b6$var$n(r.b),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$i = /^#([0-9a-f]{3,8})$/i, $482ad42e73ee00b6$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $482ad42e73ee00b6$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $482ad42e73ee00b6$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $482ad42e73ee00b6$var$g = function(r) {
    return {
        h: $482ad42e73ee00b6$var$u(r.h),
        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
        l: $482ad42e73ee00b6$var$e(r.l, 0, 100),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$d = function(r) {
    return {
        h: $482ad42e73ee00b6$var$n(r.h),
        s: $482ad42e73ee00b6$var$n(r.s),
        l: $482ad42e73ee00b6$var$n(r.l),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$f = function(r) {
    var t, n, e;
    return $482ad42e73ee00b6$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $482ad42e73ee00b6$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $482ad42e73ee00b6$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $482ad42e73ee00b6$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$y = {
    string: [
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$v.exec(r) || $482ad42e73ee00b6$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $482ad42e73ee00b6$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $482ad42e73ee00b6$var$l.exec(t) || $482ad42e73ee00b6$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $482ad42e73ee00b6$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($482ad42e73ee00b6$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $482ad42e73ee00b6$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $482ad42e73ee00b6$var$t(n) && $482ad42e73ee00b6$var$t(e) && $482ad42e73ee00b6$var$t(u) ? $482ad42e73ee00b6$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(e) || !$482ad42e73ee00b6$var$t(u)) return null;
                var i = $482ad42e73ee00b6$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $482ad42e73ee00b6$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(a) || !$482ad42e73ee00b6$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $482ad42e73ee00b6$var$u(r.h),
                        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
                        v: $482ad42e73ee00b6$var$e(r.v, 0, 100),
                        a: $482ad42e73ee00b6$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $482ad42e73ee00b6$var$b(h);
            },
            "hsv"
        ]
    ]
}, $482ad42e73ee00b6$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$var$x = function(r) {
    return "string" == typeof r ? $482ad42e73ee00b6$var$N(r.trim(), $482ad42e73ee00b6$var$y.string) : "object" == typeof r && null !== r ? $482ad42e73ee00b6$var$N(r, $482ad42e73ee00b6$var$y.object) : [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$export$f61ac8b6f1f46202 = function(r) {
    return $482ad42e73ee00b6$var$x(r)[1];
}, $482ad42e73ee00b6$var$M = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: $482ad42e73ee00b6$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $482ad42e73ee00b6$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $482ad42e73ee00b6$var$$ = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $482ad42e73ee00b6$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $482ad42e73ee00b6$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $482ad42e73ee00b6$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $482ad42e73ee00b6$var$n($482ad42e73ee00b6$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $482ad42e73ee00b6$var$s($482ad42e73ee00b6$var$n(255 * a)) : "", "#" + $482ad42e73ee00b6$var$s(t) + $482ad42e73ee00b6$var$s(e) + $482ad42e73ee00b6$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $482ad42e73ee00b6$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $482ad42e73ee00b6$var$h(this.rgba), {
            h: $482ad42e73ee00b6$var$n(r.h),
            s: $482ad42e73ee00b6$var$n(r.s),
            v: $482ad42e73ee00b6$var$n(r.v),
            a: $482ad42e73ee00b6$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $482ad42e73ee00b6$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $482ad42e73ee00b6$var$c(this.rgba);
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $482ad42e73ee00b6$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $482ad42e73ee00b6$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $482ad42e73ee00b6$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $482ad42e73ee00b6$export$4d30ed660ff08d0 ? r : new $482ad42e73ee00b6$export$4d30ed660ff08d0(r);
}, $482ad42e73ee00b6$var$S = [], $482ad42e73ee00b6$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $482ad42e73ee00b6$var$S.indexOf(r) < 0 && (r($482ad42e73ee00b6$export$4d30ed660ff08d0, $482ad42e73ee00b6$var$y), $482ad42e73ee00b6$var$S.push(r));
    });
}, $482ad42e73ee00b6$export$4385e60b38654f68 = function() {
    return new $482ad42e73ee00b6$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("lCM3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf1f6e6e10c0717$export$2e2bcd8739ae039);
function $4bf1f6e6e10c0717$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});




parcelRegister("lMxm0", function(module, exports) {

$parcel$export(module.exports, "premultiplyBlendMode", () => $640150753d863d84$export$799d0d31e2f4c737);
$parcel$export(module.exports, "correctBlendMode", () => $640150753d863d84$export$3d793623cb0d1905);
$parcel$export(module.exports, "premultiplyRgba", () => $640150753d863d84$export$4fa4eaa2922d1869);
$parcel$export(module.exports, "premultiplyTint", () => $640150753d863d84$export$1ddadce6229d3efd);
$parcel$export(module.exports, "premultiplyTintToRgba", () => $640150753d863d84$export$c75351d34304eb8c);
parcelRequire("8HZMw");
var $1PNws = parcelRequire("1PNws");

var $lmRm8 = parcelRequire("lmRm8");

var $1Koy5 = parcelRequire("1Koy5");
function $640150753d863d84$var$mapPremultipliedBlendModes() {
    const pm = [], npm = [];
    for(let i = 0; i < 32; i++)pm[i] = i, npm[i] = i;
    pm[(0, $lmRm8.BLEND_MODES).NORMAL_NPM] = (0, $lmRm8.BLEND_MODES).NORMAL, pm[(0, $lmRm8.BLEND_MODES).ADD_NPM] = (0, $lmRm8.BLEND_MODES).ADD, pm[(0, $lmRm8.BLEND_MODES).SCREEN_NPM] = (0, $lmRm8.BLEND_MODES).SCREEN, npm[(0, $lmRm8.BLEND_MODES).NORMAL] = (0, $lmRm8.BLEND_MODES).NORMAL_NPM, npm[(0, $lmRm8.BLEND_MODES).ADD] = (0, $lmRm8.BLEND_MODES).ADD_NPM, npm[(0, $lmRm8.BLEND_MODES).SCREEN] = (0, $lmRm8.BLEND_MODES).SCREEN_NPM;
    const array = [];
    return array.push(npm), array.push(pm), array;
}
const $640150753d863d84$export$799d0d31e2f4c737 = $640150753d863d84$var$mapPremultipliedBlendModes();
function $640150753d863d84$export$3d793623cb0d1905(blendMode, premultiplied) {
    return $640150753d863d84$export$799d0d31e2f4c737[premultiplied ? 1 : 0][blendMode];
}
function $640150753d863d84$export$4fa4eaa2922d1869(rgb, alpha, out, premultiply = !0) {
    return (0, $1Koy5.deprecation)("7.2.0", "utils.premultiplyRgba has moved to Color.premultiply"), (0, $1PNws.Color).shared.setValue(rgb).premultiply(alpha, premultiply).toArray(out ?? new Float32Array(4));
}
function $640150753d863d84$export$1ddadce6229d3efd(tint, alpha) {
    return (0, $1Koy5.deprecation)("7.2.0", "utils.premultiplyTint has moved to Color.toPremultiplied"), (0, $1PNws.Color).shared.setValue(tint).toPremultiplied(alpha);
}
function $640150753d863d84$export$c75351d34304eb8c(tint, alpha, out, premultiply = !0) {
    return (0, $1Koy5.deprecation)("7.2.0", "utils.premultiplyTintToRgba has moved to Color.premultiply"), (0, $1PNws.Color).shared.setValue(tint).premultiply(alpha, premultiply).toArray(out ?? new Float32Array(4));
}

});

parcelRegister("ajMPb", function(module, exports) {

$parcel$export(module.exports, "DATA_URI", () => $6798a7276a625d8d$export$dbafa72958753fce);
const $6798a7276a625d8d$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;

});

parcelRegister("fYeJa", function(module, exports) {

$parcel$export(module.exports, "createIndicesForQuads", () => $86e5217de37d16a2$export$c56148e1bec42281);
function $86e5217de37d16a2$export$c56148e1bec42281(size, outBuffer = null) {
    const totalIndices = size * 6;
    if (outBuffer = outBuffer || new Uint16Array(totalIndices), outBuffer.length !== totalIndices) throw new Error(`Out buffer length is incorrect, got ${outBuffer.length} and expected ${totalIndices}`);
    for(let i = 0, j = 0; i < totalIndices; i += 6, j += 4)outBuffer[i + 0] = j + 0, outBuffer[i + 1] = j + 1, outBuffer[i + 2] = j + 2, outBuffer[i + 3] = j + 0, outBuffer[i + 4] = j + 2, outBuffer[i + 5] = j + 3;
    return outBuffer;
}

});

parcelRegister("iqDX5", function(module, exports) {

$parcel$export(module.exports, "getBufferType", () => $585981d92cbec445$export$adf72b506413cb57);
function $585981d92cbec445$export$adf72b506413cb57(array) {
    if (array.BYTES_PER_ELEMENT === 4) return array instanceof Float32Array ? "Float32Array" : array instanceof Uint32Array ? "Uint32Array" : "Int32Array";
    if (array.BYTES_PER_ELEMENT === 2) {
        if (array instanceof Uint16Array) return "Uint16Array";
    } else if (array.BYTES_PER_ELEMENT === 1 && array instanceof Uint8Array) return "Uint8Array";
    return null;
}

});

parcelRegister("enKsa", function(module, exports) {

$parcel$export(module.exports, "interleaveTypedArrays", () => $987548fb1dcc0a88$export$1ce3e224e969bb24);

var $iqDX5 = parcelRequire("iqDX5");
const $987548fb1dcc0a88$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $987548fb1dcc0a88$export$1ce3e224e969bb24(arrays, sizes) {
    let outSize = 0, stride = 0;
    const views = {};
    for(let i = 0; i < arrays.length; i++)stride += sizes[i], outSize += arrays[i].length;
    const buffer = new ArrayBuffer(outSize * 4);
    let out = null, littleOffset = 0;
    for(let i = 0; i < arrays.length; i++){
        const size = sizes[i], array = arrays[i], type = (0, $iqDX5.getBufferType)(array);
        views[type] || (views[type] = new $987548fb1dcc0a88$var$map[type](buffer)), out = views[type];
        for(let j = 0; j < array.length; j++){
            const indexStart = (j / size | 0) * stride + littleOffset, index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}

});

parcelRegister("bpIJG", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $5728f69a05940f94$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $5728f69a05940f94$export$eb50b9c078eb6ae7);
$parcel$export(module.exports, "log2", () => $5728f69a05940f94$export$b9fae0bba9d9094d);
function $5728f69a05940f94$export$f0d90cf68bd426eb(v) {
    return v += v === 0 ? 1 : 0, --v, v |= v >>> 1, v |= v >>> 2, v |= v >>> 4, v |= v >>> 8, v |= v >>> 16, v + 1;
}
function $5728f69a05940f94$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $5728f69a05940f94$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    return v >>>= shift, r |= shift, shift = (v > 15 ? 1 : 0) << 2, v >>>= shift, r |= shift, shift = (v > 3 ? 1 : 0) << 1, v >>>= shift, r |= shift, r | v >> 1;
}

});

parcelRegister("7aCsl", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $c5d3b3fba0229ba7$export$8d47c0e1ce445404);
function $c5d3b3fba0229ba7$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});

parcelRegister("Xr4zf", function(module, exports) {

$parcel$export(module.exports, "sign", () => $0014382434d06333$export$c5552dfdbc7cec71);
function $0014382434d06333$export$c5552dfdbc7cec71(n) {
    return n === 0 ? 0 : n < 0 ? -1 : 1;
}

});

parcelRegister("2yb2o", function(module, exports) {

$parcel$export(module.exports, "uid", () => $a8272ede630bda06$export$e2a22331486dcca0);
let $a8272ede630bda06$var$nextUid = 0;
function $a8272ede630bda06$export$e2a22331486dcca0() {
    return ++$a8272ede630bda06$var$nextUid;
}

});

parcelRegister("8XBXU", function(module, exports) {

$parcel$export(module.exports, "BoundingBox", () => $d323195083f71445$export$63080c4de6cfc362);
const $d323195083f71445$var$_BoundingBox = class {
    /**
   * @param left - The left coordinate value of the bounding box.
   * @param top - The top coordinate value of the bounding box.
   * @param right - The right coordinate value of the bounding box.
   * @param bottom - The bottom coordinate value of the bounding box.
   */ constructor(left, top, right, bottom){
        this.left = left, this.top = top, this.right = right, this.bottom = bottom;
    }
    /** The width of the bounding box. */ get width() {
        return this.right - this.left;
    }
    /** The height of the bounding box. */ get height() {
        return this.bottom - this.top;
    }
    /** Determines whether the BoundingBox is empty. */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
};
$d323195083f71445$var$_BoundingBox.EMPTY = new $d323195083f71445$var$_BoundingBox(0, 0, 0, 0);
let $d323195083f71445$export$63080c4de6cfc362 = $d323195083f71445$var$_BoundingBox;

});

parcelRegister("5ohKV", function(module, exports) {

$parcel$export(module.exports, "ProgramCache", () => $db4392de79d671a3$export$d47c7e291d8b6e2c);
$parcel$export(module.exports, "TextureCache", () => $db4392de79d671a3$export$4254ab7c0971430e);
$parcel$export(module.exports, "BaseTextureCache", () => $db4392de79d671a3$export$cec649a143d060b1);
$parcel$export(module.exports, "destroyTextureCache", () => $db4392de79d671a3$export$b5c9bc385f713d5a);
$parcel$export(module.exports, "clearTextureCache", () => $db4392de79d671a3$export$3ee9cef7c9878d34);
const $db4392de79d671a3$export$d47c7e291d8b6e2c = {}, $db4392de79d671a3$export$4254ab7c0971430e = /* @__PURE__ */ Object.create(null), $db4392de79d671a3$export$cec649a143d060b1 = /* @__PURE__ */ Object.create(null);
function $db4392de79d671a3$export$b5c9bc385f713d5a() {
    let key;
    for(key in $db4392de79d671a3$export$4254ab7c0971430e)$db4392de79d671a3$export$4254ab7c0971430e[key].destroy();
    for(key in $db4392de79d671a3$export$cec649a143d060b1)$db4392de79d671a3$export$cec649a143d060b1[key].destroy();
}
function $db4392de79d671a3$export$3ee9cef7c9878d34() {
    let key;
    for(key in $db4392de79d671a3$export$4254ab7c0971430e)delete $db4392de79d671a3$export$4254ab7c0971430e[key];
    for(key in $db4392de79d671a3$export$cec649a143d060b1)delete $db4392de79d671a3$export$cec649a143d060b1[key];
}

});

parcelRegister("8zpmK", function(module, exports) {

$parcel$export(module.exports, "CanvasRenderTarget", () => $b3f5765e626c2910$export$525943d4c7cdfa38);
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
class $b3f5765e626c2910$export$525943d4c7cdfa38 {
    /**
   * @param width - the width for the newly created canvas
   * @param height - the height for the newly created canvas
   * @param {number} [resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the canvas
   */ constructor(width, height, resolution){
        this._canvas = (0, $16eqM.settings).ADAPTER.createCanvas(), this._context = this._canvas.getContext("2d"), this.resolution = resolution || (0, $16eqM.settings).RESOLUTION, this.resize(width, height);
    }
    /**
   * Clears the canvas that was created by the CanvasRenderTarget class.
   * @private
   */ clear() {
        this._checkDestroyed(), this._context.setTransform(1, 0, 0, 1, 0, 0), this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    }
    /**
   * Resizes the canvas to the specified width and height.
   * @param desiredWidth - the desired width of the canvas
   * @param desiredHeight - the desired height of the canvas
   */ resize(desiredWidth, desiredHeight) {
        this._checkDestroyed(), this._canvas.width = Math.round(desiredWidth * this.resolution), this._canvas.height = Math.round(desiredHeight * this.resolution);
    }
    /** Destroys this canvas. */ destroy() {
        this._context = null, this._canvas = null;
    }
    /**
   * The width of the canvas buffer in pixels.
   * @member {number}
   */ get width() {
        return this._checkDestroyed(), this._canvas.width;
    }
    set width(val) {
        this._checkDestroyed(), this._canvas.width = Math.round(val);
    }
    /**
   * The height of the canvas buffer in pixels.
   * @member {number}
   */ get height() {
        return this._checkDestroyed(), this._canvas.height;
    }
    set height(val) {
        this._checkDestroyed(), this._canvas.height = Math.round(val);
    }
    /** The Canvas object that belongs to this CanvasRenderTarget. */ get canvas() {
        return this._checkDestroyed(), this._canvas;
    }
    /** A CanvasRenderingContext2D object representing a two-dimensional rendering context. */ get context() {
        return this._checkDestroyed(), this._context;
    }
    _checkDestroyed() {
        if (this._canvas === null) throw new TypeError("The CanvasRenderTarget has already been destroyed");
    }
}

});

parcelRegister("lCRMP", function(module, exports) {

$parcel$export(module.exports, "getCanvasBoundingBox", () => $588f8c05547daa75$export$550eedf6c679837d);

var $8XBXU = parcelRequire("8XBXU");
function $588f8c05547daa75$var$checkRow(data, width, y) {
    for(let x = 0, index = 4 * y * width; x < width; ++x, index += 4)if (data[index + 3] !== 0) return !1;
    return !0;
}
function $588f8c05547daa75$var$checkColumn(data, width, x, top, bottom) {
    const stride = 4 * width;
    for(let y = top, index = top * stride + 4 * x; y <= bottom; ++y, index += stride)if (data[index + 3] !== 0) return !1;
    return !0;
}
function $588f8c05547daa75$export$550eedf6c679837d(canvas) {
    const { width: width, height: height } = canvas, context = canvas.getContext("2d", {
        willReadFrequently: !0
    });
    if (context === null) throw new TypeError("Failed to get canvas 2D context");
    const data = context.getImageData(0, 0, width, height).data;
    let left = 0, top = 0, right = width - 1, bottom = height - 1;
    for(; top < height && $588f8c05547daa75$var$checkRow(data, width, top);)++top;
    if (top === height) return (0, $8XBXU.BoundingBox).EMPTY;
    for(; $588f8c05547daa75$var$checkRow(data, width, bottom);)--bottom;
    for(; $588f8c05547daa75$var$checkColumn(data, width, left, top, bottom);)++left;
    for(; $588f8c05547daa75$var$checkColumn(data, width, right, top, bottom);)--right;
    return ++right, ++bottom, new (0, $8XBXU.BoundingBox)(left, top, right, bottom);
}

});

parcelRegister("i0JHz", function(module, exports) {

$parcel$export(module.exports, "trimCanvas", () => $04b74dc1ecafd70d$export$658947b9914dd428);

var $lCRMP = parcelRequire("lCRMP");
function $04b74dc1ecafd70d$export$658947b9914dd428(canvas) {
    const boundingBox = (0, $lCRMP.getCanvasBoundingBox)(canvas), { width: width, height: height } = boundingBox;
    let data = null;
    if (!boundingBox.isEmpty()) {
        const context = canvas.getContext("2d");
        if (context === null) throw new TypeError("Failed to get canvas 2D context");
        data = context.getImageData(boundingBox.left, boundingBox.top, width, height);
    }
    return {
        width: width,
        height: height,
        data: data
    };
}

});

parcelRegister("518Qf", function(module, exports) {

$parcel$export(module.exports, "decomposeDataUri", () => $cda2bae04bf264cb$export$672224f9983ff723);

var $ajMPb = parcelRequire("ajMPb");
function $cda2bae04bf264cb$export$672224f9983ff723(dataUri) {
    const dataUriMatch = (0, $ajMPb.DATA_URI).exec(dataUri);
    if (dataUriMatch) return {
        mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : void 0,
        subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : void 0,
        charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : void 0,
        encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : void 0,
        data: dataUriMatch[5]
    };
}

});

parcelRegister("bW1QN", function(module, exports) {

$parcel$export(module.exports, "determineCrossOrigin", () => $f01e55b6e1f6f3d8$export$292083da55c5b406);
function $f01e55b6e1f6f3d8$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc = loc || globalThis.location;
    const parsedUrl = new URL(url, document.baseURI);
    return parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol ? "anonymous" : "";
}

});

parcelRegister("6e477", function(module, exports) {

$parcel$export(module.exports, "getResolutionOfUrl", () => $b264b48efa69e862$export$8695ab2f322d2637);
parcelRequire("8AT8C");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
function $b264b48efa69e862$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $16eqM.settings).RETINA_PREFIX?.exec(url);
    return resolution ? parseFloat(resolution[1]) : defaultValue;
}

});

parcelRegister("bx5CL", function(module, exports) {

});


parcelRegister("jNmcM", function(module, exports) {

$parcel$export(module.exports, "BatchRenderer", () => $e9a7bfc7edf84428$export$c6a34b759a134e1d);
parcelRequire("8HZMw");
var $1PNws = parcelRequire("1PNws");

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
parcelRequire("lFGyw");
var $1Koy5 = parcelRequire("1Koy5");
var $bpIJG = parcelRequire("bpIJG");
var $lMxm0 = parcelRequire("lMxm0");

var $kZVXo = parcelRequire("kZVXo");

var $2deXx = parcelRequire("2deXx");

var $bUqaG = parcelRequire("bUqaG");

var $4oWO8 = parcelRequire("4oWO8");

var $6qB4i = parcelRequire("6qB4i");

var $7Gazv = parcelRequire("7Gazv");

var $6kk4I = parcelRequire("6kk4I");

var $ajAp7 = parcelRequire("ajAp7");

var $dSjmj = parcelRequire("dSjmj");

var $1EfD8 = parcelRequire("1EfD8");

var $hDOsC = parcelRequire("hDOsC");

var $cH3eh = parcelRequire("cH3eh");

var $jhN2Q = parcelRequire("jhN2Q");
const $e9a7bfc7edf84428$var$_BatchRenderer = class _BatchRenderer2 extends (0, $hDOsC.ObjectRenderer) {
    /**
   * This will hook onto the renderer's `contextChange`
   * and `prerender` signals.
   * @param {PIXI.Renderer} renderer - The renderer this works for.
   */ constructor(renderer){
        super(renderer), this.setShaderGenerator(), this.geometryClass = (0, $7Gazv.BatchGeometry), this.vertexSize = 6, this.state = (0, $bUqaG.State).for2d(), this.size = _BatchRenderer2.defaultBatchSize * 4, this._vertexCount = 0, this._indexCount = 0, this._bufferedElements = [], this._bufferedTextures = [], this._bufferSize = 0, this._shader = null, this._packedGeometries = [], this._packedGeometryPoolSize = 2, this._flushId = 0, this._aBuffers = {}, this._iBuffers = {}, this.maxTextures = 1, this.renderer.on("prerender", this.onPrerender, this), renderer.runners.contextChange.add(this), this._dcIndex = 0, this._aIndex = 0, this._iIndex = 0, this._attributeBuffer = null, this._indexBuffer = null, this._tempBoundTextures = [];
    }
    /**
   * The maximum textures that this device supports.
   * @static
   * @default 32
   */ static get defaultMaxTextures() {
        return this._defaultMaxTextures = this._defaultMaxTextures ?? (0, $1EfD8.maxRecommendedTextures)(32), this._defaultMaxTextures;
    }
    static set defaultMaxTextures(value) {
        this._defaultMaxTextures = value;
    }
    /**
   * Can we upload the same buffer in a single frame?
   * @static
   */ static get canUploadSameBuffer() {
        return this._canUploadSameBuffer = this._canUploadSameBuffer ?? (0, $dSjmj.canUploadSameBuffer)(), this._canUploadSameBuffer;
    }
    static set canUploadSameBuffer(value) {
        this._canUploadSameBuffer = value;
    }
    /**
   * @see PIXI.BatchRenderer#maxTextures
   * @deprecated since 7.1.0
   * @readonly
   */ get MAX_TEXTURES() {
        return (0, $1Koy5.deprecation)("7.1.0", "BatchRenderer#MAX_TEXTURES renamed to BatchRenderer#maxTextures"), this.maxTextures;
    }
    /**
   * The default vertex shader source
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $jhN2Q.default;
    }
    /**
   * The default fragment shader source
   * @readonly
   */ static get defaultFragmentTemplate() {
        return 0, $cH3eh.default;
    }
    /**
   * Set the shader generator.
   * @param {object} [options]
   * @param {string} [options.vertex=PIXI.BatchRenderer.defaultVertexSrc] - Vertex shader source
   * @param {string} [options.fragment=PIXI.BatchRenderer.defaultFragmentTemplate] - Fragment shader template
   */ setShaderGenerator({ vertex: vertex = _BatchRenderer2.defaultVertexSrc, fragment: fragment = _BatchRenderer2.defaultFragmentTemplate } = {}) {
        this.shaderGenerator = new (0, $6kk4I.BatchShaderGenerator)(vertex, fragment);
    }
    /**
   * Handles the `contextChange` signal.
   *
   * It calculates `this.maxTextures` and allocating the packed-geometry object pool.
   */ contextChange() {
        const gl = this.renderer.gl;
        (0, $16eqM.settings).PREFER_ENV === (0, $lmRm8.ENV).WEBGL_LEGACY ? this.maxTextures = 1 : (this.maxTextures = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _BatchRenderer2.defaultMaxTextures), this.maxTextures = (0, $2deXx.checkMaxIfStatementsInShader)(this.maxTextures, gl)), this._shader = this.shaderGenerator.generateShader(this.maxTextures);
        for(let i = 0; i < this._packedGeometryPoolSize; i++)this._packedGeometries[i] = new this.geometryClass();
        this.initFlushBuffers();
    }
    /** Makes sure that static and dynamic flush pooled objects have correct dimensions. */ initFlushBuffers() {
        const { _drawCallPool: _drawCallPool, _textureArrayPool: _textureArrayPool } = _BatchRenderer2, MAX_SPRITES = this.size / 4, MAX_TA = Math.floor(MAX_SPRITES / this.maxTextures) + 1;
        for(; _drawCallPool.length < MAX_SPRITES;)_drawCallPool.push(new (0, $6qB4i.BatchDrawCall)());
        for(; _textureArrayPool.length < MAX_TA;)_textureArrayPool.push(new (0, $ajAp7.BatchTextureArray)());
        for(let i = 0; i < this.maxTextures; i++)this._tempBoundTextures[i] = null;
    }
    /** Handles the `prerender` signal. It ensures that flushes start from the first geometry object again. */ onPrerender() {
        this._flushId = 0;
    }
    /**
   * Buffers the "batchable" object. It need not be rendered immediately.
   * @param {PIXI.DisplayObject} element - the element to render when
   *    using this renderer
   */ render(element) {
        element._texture.valid && (this._vertexCount + element.vertexData.length / 2 > this.size && this.flush(), this._vertexCount += element.vertexData.length / 2, this._indexCount += element.indices.length, this._bufferedTextures[this._bufferSize] = element._texture.baseTexture, this._bufferedElements[this._bufferSize++] = element);
    }
    buildTexturesAndDrawCalls() {
        const { _bufferedTextures: textures, maxTextures: maxTextures } = this, textureArrays = _BatchRenderer2._textureArrayPool, batch = this.renderer.batch, boundTextures = this._tempBoundTextures, touch = this.renderer.textureGC.count;
        let TICK = ++(0, $4oWO8.BaseTexture)._globalBatch, countTexArrays = 0, texArray = textureArrays[0], start = 0;
        batch.copyBoundTextures(boundTextures, maxTextures);
        for(let i = 0; i < this._bufferSize; ++i){
            const tex = textures[i];
            textures[i] = null, tex._batchEnabled !== TICK && (texArray.count >= maxTextures && (batch.boundArray(texArray, boundTextures, TICK, maxTextures), this.buildDrawCalls(texArray, start, i), start = i, texArray = textureArrays[++countTexArrays], ++TICK), tex._batchEnabled = TICK, tex.touched = touch, texArray.elements[texArray.count++] = tex);
        }
        texArray.count > 0 && (batch.boundArray(texArray, boundTextures, TICK, maxTextures), this.buildDrawCalls(texArray, start, this._bufferSize), ++countTexArrays, ++TICK);
        for(let i = 0; i < boundTextures.length; i++)boundTextures[i] = null;
        (0, $4oWO8.BaseTexture)._globalBatch = TICK;
    }
    /**
   * Populating drawcalls for rendering
   * @param texArray
   * @param start
   * @param finish
   */ buildDrawCalls(texArray, start, finish) {
        const { _bufferedElements: elements, _attributeBuffer: _attributeBuffer, _indexBuffer: _indexBuffer, vertexSize: vertexSize } = this, drawCalls = _BatchRenderer2._drawCallPool;
        let dcIndex = this._dcIndex, aIndex = this._aIndex, iIndex = this._iIndex, drawCall = drawCalls[dcIndex];
        drawCall.start = this._iIndex, drawCall.texArray = texArray;
        for(let i = start; i < finish; ++i){
            const sprite = elements[i], tex = sprite._texture.baseTexture, spriteBlendMode = (0, $lMxm0.premultiplyBlendMode)[tex.alphaMode ? 1 : 0][sprite.blendMode];
            elements[i] = null, start < i && drawCall.blend !== spriteBlendMode && (drawCall.size = iIndex - drawCall.start, start = i, drawCall = drawCalls[++dcIndex], drawCall.texArray = texArray, drawCall.start = iIndex), this.packInterleavedGeometry(sprite, _attributeBuffer, _indexBuffer, aIndex, iIndex), aIndex += sprite.vertexData.length / 2 * vertexSize, iIndex += sprite.indices.length, drawCall.blend = spriteBlendMode;
        }
        start < finish && (drawCall.size = iIndex - drawCall.start, ++dcIndex), this._dcIndex = dcIndex, this._aIndex = aIndex, this._iIndex = iIndex;
    }
    /**
   * Bind textures for current rendering
   * @param texArray
   */ bindAndClearTexArray(texArray) {
        const textureSystem = this.renderer.texture;
        for(let j = 0; j < texArray.count; j++)textureSystem.bind(texArray.elements[j], texArray.ids[j]), texArray.elements[j] = null;
        texArray.count = 0;
    }
    updateGeometry() {
        const { _packedGeometries: packedGeometries, _attributeBuffer: attributeBuffer, _indexBuffer: indexBuffer } = this;
        _BatchRenderer2.canUploadSameBuffer ? (packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData), packedGeometries[this._flushId]._indexBuffer.update(indexBuffer), this.renderer.geometry.updateBuffers()) : (this._packedGeometryPoolSize <= this._flushId && (this._packedGeometryPoolSize++, packedGeometries[this._flushId] = new this.geometryClass()), packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData), packedGeometries[this._flushId]._indexBuffer.update(indexBuffer), this.renderer.geometry.bind(packedGeometries[this._flushId]), this.renderer.geometry.updateBuffers(), this._flushId++);
    }
    drawBatches() {
        const dcCount = this._dcIndex, { gl: gl, state: stateSystem } = this.renderer, drawCalls = _BatchRenderer2._drawCallPool;
        let curTexArray = null;
        for(let i = 0; i < dcCount; i++){
            const { texArray: texArray, type: type, size: size, start: start, blend: blend } = drawCalls[i];
            curTexArray !== texArray && (curTexArray = texArray, this.bindAndClearTexArray(texArray)), this.state.blendMode = blend, stateSystem.set(this.state), gl.drawElements(type, size, gl.UNSIGNED_SHORT, start * 2);
        }
    }
    /** Renders the content _now_ and empties the current batch. */ flush() {
        this._vertexCount !== 0 && (this._attributeBuffer = this.getAttributeBuffer(this._vertexCount), this._indexBuffer = this.getIndexBuffer(this._indexCount), this._aIndex = 0, this._iIndex = 0, this._dcIndex = 0, this.buildTexturesAndDrawCalls(), this.updateGeometry(), this.drawBatches(), this._bufferSize = 0, this._vertexCount = 0, this._indexCount = 0);
    }
    /** Starts a new sprite batch. */ start() {
        this.renderer.state.set(this.state), this.renderer.texture.ensureSamplerType(this.maxTextures), this.renderer.shader.bind(this._shader), _BatchRenderer2.canUploadSameBuffer && this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
    }
    /** Stops and flushes the current batch. */ stop() {
        this.flush();
    }
    /** Destroys this `BatchRenderer`. It cannot be used again. */ destroy() {
        for(let i = 0; i < this._packedGeometryPoolSize; i++)this._packedGeometries[i] && this._packedGeometries[i].destroy();
        this.renderer.off("prerender", this.onPrerender, this), this._aBuffers = null, this._iBuffers = null, this._packedGeometries = null, this._attributeBuffer = null, this._indexBuffer = null, this._shader && (this._shader.destroy(), this._shader = null), super.destroy();
    }
    /**
   * Fetches an attribute buffer from `this._aBuffers` that can hold atleast `size` floats.
   * @param size - minimum capacity required
   * @returns - buffer than can hold atleast `size` floats
   */ getAttributeBuffer(size) {
        const roundedP2 = (0, $bpIJG.nextPow2)(Math.ceil(size / 8)), roundedSizeIndex = (0, $bpIJG.log2)(roundedP2), roundedSize = roundedP2 * 8;
        this._aBuffers.length <= roundedSizeIndex && (this._iBuffers.length = roundedSizeIndex + 1);
        let buffer = this._aBuffers[roundedSize];
        return buffer || (this._aBuffers[roundedSize] = buffer = new (0, $kZVXo.ViewableBuffer)(roundedSize * this.vertexSize * 4)), buffer;
    }
    /**
   * Fetches an index buffer from `this._iBuffers` that can
   * have at least `size` capacity.
   * @param size - minimum required capacity
   * @returns - buffer that can fit `size` indices.
   */ getIndexBuffer(size) {
        const roundedP2 = (0, $bpIJG.nextPow2)(Math.ceil(size / 12)), roundedSizeIndex = (0, $bpIJG.log2)(roundedP2), roundedSize = roundedP2 * 12;
        this._iBuffers.length <= roundedSizeIndex && (this._iBuffers.length = roundedSizeIndex + 1);
        let buffer = this._iBuffers[roundedSizeIndex];
        return buffer || (this._iBuffers[roundedSizeIndex] = buffer = new Uint16Array(roundedSize)), buffer;
    }
    /**
   * Takes the four batching parameters of `element`, interleaves
   * and pushes them into the batching attribute/index buffers given.
   *
   * It uses these properties: `vertexData` `uvs`, `textureId` and
   * `indicies`. It also uses the "tint" of the base-texture, if
   * present.
   * @param {PIXI.DisplayObject} element - element being rendered
   * @param attributeBuffer - attribute buffer.
   * @param indexBuffer - index buffer
   * @param aIndex - number of floats already in the attribute buffer
   * @param iIndex - number of indices already in `indexBuffer`
   */ packInterleavedGeometry(element, attributeBuffer, indexBuffer, aIndex, iIndex) {
        const { uint32View: uint32View, float32View: float32View } = attributeBuffer, packedVertices = aIndex / this.vertexSize, uvs = element.uvs, indicies = element.indices, vertexData = element.vertexData, textureId = element._texture.baseTexture._batchLocation, alpha = Math.min(element.worldAlpha, 1), argb = (0, $1PNws.Color).shared.setValue(element._tintRGB).toPremultiplied(alpha, element._texture.baseTexture.alphaMode > 0);
        for(let i = 0; i < vertexData.length; i += 2)float32View[aIndex++] = vertexData[i], float32View[aIndex++] = vertexData[i + 1], float32View[aIndex++] = uvs[i], float32View[aIndex++] = uvs[i + 1], uint32View[aIndex++] = argb, float32View[aIndex++] = textureId;
        for(let i = 0; i < indicies.length; i++)indexBuffer[iIndex++] = packedVertices + indicies[i];
    }
};
$e9a7bfc7edf84428$var$_BatchRenderer.defaultBatchSize = 4096, /** @ignore */ $e9a7bfc7edf84428$var$_BatchRenderer.extension = {
    name: "batch",
    type: (0, $5RvHb.ExtensionType).RendererPlugin
}, /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchDrawCall[]}
*/ $e9a7bfc7edf84428$var$_BatchRenderer._drawCallPool = [], /**
* Pool of `BatchDrawCall` objects that `flush` used
* to create "batches" of the objects being rendered.
*
* These are never re-allocated again.
* Shared between all batch renderers because it can be only one "flush" working at the moment.
* @member {PIXI.BatchTextureArray[]}
*/ $e9a7bfc7edf84428$var$_BatchRenderer._textureArrayPool = [];
let $e9a7bfc7edf84428$export$c6a34b759a134e1d = $e9a7bfc7edf84428$var$_BatchRenderer;
(0, $5RvHb.extensions).add($e9a7bfc7edf84428$export$c6a34b759a134e1d);

});
parcelRegister("5RvHb", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $0fcbd3e56b89a698$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "extensions", () => $0fcbd3e56b89a698$export$cc3e2d3244e01b7f);
var $0fcbd3e56b89a698$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>(ExtensionType2.Renderer = "renderer", ExtensionType2.Application = "application", ExtensionType2.RendererSystem = "renderer-webgl-system", ExtensionType2.RendererPlugin = "renderer-webgl-plugin", ExtensionType2.CanvasRendererSystem = "renderer-canvas-system", ExtensionType2.CanvasRendererPlugin = "renderer-canvas-plugin", ExtensionType2.Asset = "asset", ExtensionType2.LoadParser = "load-parser", ExtensionType2.ResolveParser = "resolve-parser", ExtensionType2.CacheParser = "cache-parser", ExtensionType2.DetectionParser = "detection-parser", ExtensionType2))($0fcbd3e56b89a698$export$4f037c6ec2da4eeb || {});
const $0fcbd3e56b89a698$var$normalizeExtension = (ext)=>{
    if (typeof ext == "function" || typeof ext == "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        ext = {
            ...typeof ext.extension != "object" ? {
                type: ext.extension
            } : ext.extension,
            ref: ext
        };
    }
    if (typeof ext == "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    return typeof ext.type == "string" && (ext.type = [
        ext.type
    ]), ext;
}, $0fcbd3e56b89a698$var$normalizePriority = (ext, defaultPriority)=>$0fcbd3e56b89a698$var$normalizeExtension(ext).priority ?? defaultPriority, $0fcbd3e56b89a698$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {PIXI.extensions} For chaining.
   */ remove (...extensions2) {
        return extensions2.map($0fcbd3e56b89a698$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        }), this;
    },
    /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {PIXI.extensions} For chaining.
   */ add (...extensions2) {
        return extensions2.map($0fcbd3e56b89a698$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers, queue = this._queue;
                handlers[type] ? handlers[type]?.(ext) : (queue[type] = queue[type] || [], queue[type]?.push(ext));
            });
        }), this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function for handling when extensions are added/registered passes {@link PIXI.ExtensionFormat}.
   * @param onRemove  - Function for handling when extensions are removed/unregistered passes {@link PIXI.ExtensionFormat}.
   * @returns {PIXI.extensions} For chaining.
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers, removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd, removeHandlers[type] = onRemove;
        const queue = this._queue;
        return queue[type] && (queue[type]?.forEach((ext)=>onAdd(ext)), delete queue[type]), this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {PIXI.extensions} For chaining.
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            extension.name && (map[extension.name] = extension.ref);
        }, (extension)=>{
            extension.name && delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {PIXI.extensions} For chaining.
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            list.includes(extension.ref) || (list.push(extension.ref), list.sort((a, b)=>$0fcbd3e56b89a698$var$normalizePriority(b, defaultPriority) - $0fcbd3e56b89a698$var$normalizePriority(a, defaultPriority)));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            index !== -1 && list.splice(index, 1);
        });
    }
};

});

parcelRegister("kZVXo", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $847a0d28fb79d582$export$4fdbf0662aa3047a);
class $847a0d28fb79d582$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        typeof sizeOrBuffer == "number" ? this.rawBinaryData = new ArrayBuffer(sizeOrBuffer) : sizeOrBuffer instanceof Uint8Array ? this.rawBinaryData = sizeOrBuffer.buffer : this.rawBinaryData = sizeOrBuffer, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData);
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
    }
    /** View on the raw binary data as a `Uint16Array`. */ get uint16View() {
        return this._uint16View || (this._uint16View = new Uint16Array(this.rawBinaryData)), this._uint16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._uint16View = null, this._int32View = null, this.uint32View = null, this.float32View = null;
    }
    static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("2deXx", function(module, exports) {

$parcel$export(module.exports, "checkMaxIfStatementsInShader", () => $4b083c03bd574f03$export$fb6ad4e758d74cc0);
const $4b083c03bd574f03$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join(`
`);
function $4b083c03bd574f03$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i)i > 0 && (src += `
else `), i < maxIfs - 1 && (src += `if(test == ${i}.0){}`);
    return src;
}
function $4b083c03bd574f03$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    for(;;){
        const fragmentSrc = $4b083c03bd574f03$var$fragTemplate.replace(/%forloop%/gi, $4b083c03bd574f03$var$generateIfTestSrc(maxIfs));
        if (gl.shaderSource(shader, fragmentSrc), gl.compileShader(shader), !gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
        else break;
    }
    return maxIfs;
}

});

parcelRegister("bUqaG", function(module, exports) {

$parcel$export(module.exports, "State", () => $15a50e9cd387ae21$export$7254cc27399e90bd);

var $lmRm8 = parcelRequire("lmRm8");
const $15a50e9cd387ae21$var$BLEND = 0, $15a50e9cd387ae21$var$OFFSET = 1, $15a50e9cd387ae21$var$CULLING = 2, $15a50e9cd387ae21$var$DEPTH_TEST = 3, $15a50e9cd387ae21$var$WINDING = 4, $15a50e9cd387ae21$var$DEPTH_MASK = 5;
class $15a50e9cd387ae21$export$7254cc27399e90bd {
    constructor(){
        this.data = 0, this.blendMode = (0, $lmRm8.BLEND_MODES).NORMAL, this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
    }
    /**
   * Activates blending of the computed fragment color values.
   * @default true
   */ get blend() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$BLEND);
    }
    set blend(value) {
        !!(this.data & 1 << $15a50e9cd387ae21$var$BLEND) !== value && (this.data ^= 1 << $15a50e9cd387ae21$var$BLEND);
    }
    /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */ get offsets() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$OFFSET);
    }
    set offsets(value) {
        !!(this.data & 1 << $15a50e9cd387ae21$var$OFFSET) !== value && (this.data ^= 1 << $15a50e9cd387ae21$var$OFFSET);
    }
    /**
   * Activates culling of polygons.
   * @default false
   */ get culling() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$CULLING);
    }
    set culling(value) {
        !!(this.data & 1 << $15a50e9cd387ae21$var$CULLING) !== value && (this.data ^= 1 << $15a50e9cd387ae21$var$CULLING);
    }
    /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */ get depthTest() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$DEPTH_TEST);
    }
    set depthTest(value) {
        !!(this.data & 1 << $15a50e9cd387ae21$var$DEPTH_TEST) !== value && (this.data ^= 1 << $15a50e9cd387ae21$var$DEPTH_TEST);
    }
    /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */ get depthMask() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$DEPTH_MASK);
    }
    set depthMask(value) {
        !!(this.data & 1 << $15a50e9cd387ae21$var$DEPTH_MASK) !== value && (this.data ^= 1 << $15a50e9cd387ae21$var$DEPTH_MASK);
    }
    /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */ get clockwiseFrontFace() {
        return !!(this.data & 1 << $15a50e9cd387ae21$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        !!(this.data & 1 << $15a50e9cd387ae21$var$WINDING) !== value && (this.data ^= 1 << $15a50e9cd387ae21$var$WINDING);
    }
    /**
   * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== (0, $lmRm8.BLEND_MODES).NONE, this._blendMode = value;
    }
    /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */ get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value, this._polygonOffset = value;
    }
    static for2d() {
        const state = new $15a50e9cd387ae21$export$7254cc27399e90bd();
        return state.depthTest = !1, state.blend = !0, state;
    }
}
$15a50e9cd387ae21$export$7254cc27399e90bd.prototype.toString = function() {
    return `[@pixi/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
};

});

parcelRegister("4oWO8", function(module, exports) {

$parcel$export(module.exports, "BaseTexture", () => $2d8d497fce3a4092$export$d6306e508f184154);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
parcelRequire("lFGyw");
var $5ohKV = parcelRequire("5ohKV");
var $3vRz3 = parcelRequire("3vRz3");
var $bpIJG = parcelRequire("bpIJG");
var $2yb2o = parcelRequire("2yb2o");

var $12R2z = parcelRequire("12R2z");

var $1oZjy = parcelRequire("1oZjy");

var $fbY8e = parcelRequire("fbY8e");
const $2d8d497fce3a4092$var$defaultBufferOptions = {
    scaleMode: (0, $lmRm8.SCALE_MODES).NEAREST,
    alphaMode: (0, $lmRm8.ALPHA_MODES).NPM
}, $2d8d497fce3a4092$var$_BaseTexture = class _BaseTexture2 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param {PIXI.Resource|PIXI.ImageSource|string} [resource=null] -
   *        The current resource to use, for things that aren't Resource objects, will be converted
   *        into a Resource.
   * @param options - Collection of options, default options inherited from {@link PIXI.BaseTexture.defaultOptions}.
   * @param {PIXI.MIPMAP_MODES} [options.mipmap] - If mipmapping is enabled for texture
   * @param {number} [options.anisotropicLevel] - Anisotropic filtering level of texture
   * @param {PIXI.WRAP_MODES} [options.wrapMode] - Wrap mode for textures
   * @param {PIXI.SCALE_MODES} [options.scaleMode] - Default scale mode, linear, nearest
   * @param {PIXI.FORMATS} [options.format] - GL format type
   * @param {PIXI.TYPES} [options.type] - GL data type
   * @param {PIXI.TARGETS} [options.target] - GL texture target
   * @param {PIXI.ALPHA_MODES} [options.alphaMode] - Pre multiply the image alpha
   * @param {number} [options.width=0] - Width of the texture
   * @param {number} [options.height=0] - Height of the texture
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - Resolution of the base texture
   * @param {object} [options.resourceOptions] - Optional resource options,
   *        see {@link PIXI.autoDetectResource autoDetectResource}
   */ constructor(resource = null, options = null){
        super(), options = Object.assign({}, _BaseTexture2.defaultOptions, options);
        const { alphaMode: alphaMode, mipmap: mipmap, anisotropicLevel: anisotropicLevel, scaleMode: scaleMode, width: width, height: height, wrapMode: wrapMode, format: format, type: type, target: target, resolution: resolution, resourceOptions: resourceOptions } = options;
        resource && !(resource instanceof (0, $fbY8e.Resource)) && (resource = (0, $12R2z.autoDetectResource)(resource, resourceOptions), resource.internal = !0), this.resolution = resolution || (0, $16eqM.settings).RESOLUTION, this.width = Math.round((width || 0) * this.resolution) / this.resolution, this.height = Math.round((height || 0) * this.resolution) / this.resolution, this._mipmap = mipmap, this.anisotropicLevel = anisotropicLevel, this._wrapMode = wrapMode, this._scaleMode = scaleMode, this.format = format, this.type = type, this.target = target, this.alphaMode = alphaMode, this.uid = (0, $2yb2o.uid)(), this.touched = 0, this.isPowerOfTwo = !1, this._refreshPOT(), this._glTextures = {}, this.dirtyId = 0, this.dirtyStyleId = 0, this.cacheId = null, this.valid = width > 0 && height > 0, this.textureCacheIds = [], this.destroyed = !1, this.resource = null, this._batchEnabled = 0, this._batchLocation = 0, this.parentTextureArray = null, this.setResource(resource);
    }
    /**
   * Pixel width of the source of this texture
   * @readonly
   */ get realWidth() {
        return Math.round(this.width * this.resolution);
    }
    /**
   * Pixel height of the source of this texture
   * @readonly
   */ get realHeight() {
        return Math.round(this.height * this.resolution);
    }
    /**
   * Mipmap mode of the texture, affects downscaled images
   * @default PIXI.MIPMAP_MODES.POW2
   */ get mipmap() {
        return this._mipmap;
    }
    set mipmap(value) {
        this._mipmap !== value && (this._mipmap = value, this.dirtyStyleId++);
    }
    /**
   * The scale mode to apply when scaling this texture
   * @default PIXI.SCALE_MODES.LINEAR
   */ get scaleMode() {
        return this._scaleMode;
    }
    set scaleMode(value) {
        this._scaleMode !== value && (this._scaleMode = value, this.dirtyStyleId++);
    }
    /**
   * How the texture wraps
   * @default PIXI.WRAP_MODES.CLAMP
   */ get wrapMode() {
        return this._wrapMode;
    }
    set wrapMode(value) {
        this._wrapMode !== value && (this._wrapMode = value, this.dirtyStyleId++);
    }
    /**
   * Changes style options of BaseTexture
   * @param scaleMode - Pixi scalemode
   * @param mipmap - enable mipmaps
   * @returns - this
   */ setStyle(scaleMode, mipmap) {
        let dirty;
        return scaleMode !== void 0 && scaleMode !== this.scaleMode && (this.scaleMode = scaleMode, dirty = !0), mipmap !== void 0 && mipmap !== this.mipmap && (this.mipmap = mipmap, dirty = !0), dirty && this.dirtyStyleId++, this;
    }
    /**
   * Changes w/h/resolution. Texture becomes valid if width and height are greater than zero.
   * @param desiredWidth - Desired visual width
   * @param desiredHeight - Desired visual height
   * @param resolution - Optionally set resolution
   * @returns - this
   */ setSize(desiredWidth, desiredHeight, resolution) {
        return resolution = resolution || this.resolution, this.setRealSize(desiredWidth * resolution, desiredHeight * resolution, resolution);
    }
    /**
   * Sets real size of baseTexture, preserves current resolution.
   * @param realWidth - Full rendered width
   * @param realHeight - Full rendered height
   * @param resolution - Optionally set resolution
   * @returns - this
   */ setRealSize(realWidth, realHeight, resolution) {
        return this.resolution = resolution || this.resolution, this.width = Math.round(realWidth) / this.resolution, this.height = Math.round(realHeight) / this.resolution, this._refreshPOT(), this.update(), this;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $bpIJG.isPow2)(this.realWidth) && (0, $bpIJG.isPow2)(this.realHeight);
    }
    /**
   * Changes resolution
   * @param resolution - res
   * @returns - this
   */ setResolution(resolution) {
        const oldResolution = this.resolution;
        return oldResolution === resolution ? this : (this.resolution = resolution, this.valid && (this.width = Math.round(this.width * oldResolution) / resolution, this.height = Math.round(this.height * oldResolution) / resolution, this.emit("update", this)), this._refreshPOT(), this);
    }
    /**
   * Sets the resource if it wasn't set. Throws error if resource already present
   * @param resource - that is managing this BaseTexture
   * @returns - this
   */ setResource(resource) {
        if (this.resource === resource) return this;
        if (this.resource) throw new Error("Resource can be set only once");
        return resource.bind(this), this.resource = resource, this;
    }
    /** Invalidates the object. Texture becomes valid if width and height are greater than zero. */ update() {
        this.valid ? (this.dirtyId++, this.dirtyStyleId++, this.emit("update", this)) : this.width > 0 && this.height > 0 && (this.valid = !0, this.emit("loaded", this), this.emit("update", this));
    }
    /**
   * Handle errors with resources.
   * @private
   * @param event - Error event emitted.
   */ onError(event) {
        this.emit("error", this, event);
    }
    /**
   * Destroys this base texture.
   * The method stops if resource doesn't want this texture to be destroyed.
   * Removes texture from all caches.
   * @fires PIXI.BaseTexture#destroyed
   */ destroy() {
        this.resource && (this.resource.unbind(this), this.resource.internal && this.resource.destroy(), this.resource = null), this.cacheId && (delete (0, $5ohKV.BaseTextureCache)[this.cacheId], delete (0, $5ohKV.TextureCache)[this.cacheId], this.cacheId = null), this.valid = !1, this.dispose(), _BaseTexture2.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
    }
    /**
   * Frees the texture from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */ dispose() {
        this.emit("dispose", this);
    }
    /** Utility function for BaseTexture|Texture cast. */ castToBaseTexture() {
        return this;
    }
    /**
   * Helper function that creates a base texture based on the source you provide.
   * The source can be - image url, image element, canvas element. If the
   * source is an image url or an image element and not in the base texture
   * cache, it will be created and loaded.
   * @static
   * @param {PIXI.ImageSource|string|string[]} source - The
   *        source to create base texture from.
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.BaseTexture} The new base texture.
   */ static from(source, options, strict = (0, $16eqM.settings).STRICT_TEXTURE_CACHE) {
        const isFrame = typeof source == "string";
        let cacheId = null;
        if (isFrame) cacheId = source;
        else {
            if (!source._pixiId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source._pixiId = `${prefix}_${(0, $2yb2o.uid)()}`;
            }
            cacheId = source._pixiId;
        }
        let baseTexture = (0, $5ohKV.BaseTextureCache)[cacheId];
        if (isFrame && strict && !baseTexture) throw new Error(`The cacheId "${cacheId}" does not exist in BaseTextureCache.`);
        return baseTexture || (baseTexture = new _BaseTexture2(source, options), baseTexture.cacheId = cacheId, _BaseTexture2.addToCache(baseTexture, cacheId)), baseTexture;
    }
    /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */ static fromBuffer(buffer, width, height, options) {
        buffer = buffer || new Float32Array(width * height * 4);
        const resource = new (0, $1oZjy.BufferResource)(buffer, {
            width: width,
            height: height,
            ...options?.resourceOptions
        });
        let format, type;
        return buffer instanceof Float32Array ? (format = (0, $lmRm8.FORMATS).RGBA, type = (0, $lmRm8.TYPES).FLOAT) : buffer instanceof Int32Array ? (format = (0, $lmRm8.FORMATS).RGBA_INTEGER, type = (0, $lmRm8.TYPES).INT) : buffer instanceof Uint32Array ? (format = (0, $lmRm8.FORMATS).RGBA_INTEGER, type = (0, $lmRm8.TYPES).UNSIGNED_INT) : buffer instanceof Int16Array ? (format = (0, $lmRm8.FORMATS).RGBA_INTEGER, type = (0, $lmRm8.TYPES).SHORT) : buffer instanceof Uint16Array ? (format = (0, $lmRm8.FORMATS).RGBA_INTEGER, type = (0, $lmRm8.TYPES).UNSIGNED_SHORT) : buffer instanceof Int8Array ? (format = (0, $lmRm8.FORMATS).RGBA, type = (0, $lmRm8.TYPES).BYTE) : (format = (0, $lmRm8.FORMATS).RGBA, type = (0, $lmRm8.TYPES).UNSIGNED_BYTE), resource.internal = !0, new _BaseTexture2(resource, Object.assign({}, $2d8d497fce3a4092$var$defaultBufferOptions, {
            type: type,
            format: format
        }, options));
    }
    /**
   * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
   * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
   * @param {string} id - The id that the BaseTexture will be stored against.
   */ static addToCache(baseTexture, id) {
        id && (baseTexture.textureCacheIds.includes(id) || baseTexture.textureCacheIds.push(id), (0, $5ohKV.BaseTextureCache)[id] && (0, $5ohKV.BaseTextureCache)[id] !== baseTexture && console.warn(`BaseTexture added to the cache with an id [${id}] that already had an entry`), (0, $5ohKV.BaseTextureCache)[id] = baseTexture);
    }
    /**
   * Remove a BaseTexture from the global BaseTextureCache.
   * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
   * @returns {PIXI.BaseTexture|null} The BaseTexture that was removed.
   */ static removeFromCache(baseTexture) {
        if (typeof baseTexture == "string") {
            const baseTextureFromCache = (0, $5ohKV.BaseTextureCache)[baseTexture];
            if (baseTextureFromCache) {
                const index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
                return index > -1 && baseTextureFromCache.textureCacheIds.splice(index, 1), delete (0, $5ohKV.BaseTextureCache)[baseTexture], baseTextureFromCache;
            }
        } else if (baseTexture?.textureCacheIds) {
            for(let i = 0; i < baseTexture.textureCacheIds.length; ++i)delete (0, $5ohKV.BaseTextureCache)[baseTexture.textureCacheIds[i]];
            return baseTexture.textureCacheIds.length = 0, baseTexture;
        }
        return null;
    }
};
$2d8d497fce3a4092$var$_BaseTexture.defaultOptions = {
    /**
   * If mipmapping is enabled for texture.
   * @type {PIXI.MIPMAP_MODES}
   * @default PIXI.MIPMAP_MODES.POW2
   */ mipmap: (0, $lmRm8.MIPMAP_MODES).POW2,
    /** Anisotropic filtering level of texture */ anisotropicLevel: 0,
    /**
   * Default scale mode, linear, nearest.
   * @type {PIXI.SCALE_MODES}
   * @default PIXI.SCALE_MODES.LINEAR
   */ scaleMode: (0, $lmRm8.SCALE_MODES).LINEAR,
    /**
   * Wrap mode for textures.
   * @type {PIXI.WRAP_MODES}
   * @default PIXI.WRAP_MODES.CLAMP
   */ wrapMode: (0, $lmRm8.WRAP_MODES).CLAMP,
    /**
   * Pre multiply the image alpha
   * @type {PIXI.ALPHA_MODES}
   * @default PIXI.ALPHA_MODES.UNPACK
   */ alphaMode: (0, $lmRm8.ALPHA_MODES).UNPACK,
    /**
   * GL texture target
   * @type {PIXI.TARGETS}
   * @default PIXI.TARGETS.TEXTURE_2D
   */ target: (0, $lmRm8.TARGETS).TEXTURE_2D,
    /**
   * GL format type
   * @type {PIXI.FORMATS}
   * @default PIXI.FORMATS.RGBA
   */ format: (0, $lmRm8.FORMATS).RGBA,
    /**
   * GL data type
   * @type {PIXI.TYPES}
   * @default PIXI.TYPES.UNSIGNED_BYTE
   */ type: (0, $lmRm8.TYPES).UNSIGNED_BYTE
}, /** Global number of the texture batch, used by multi-texture renderers. */ $2d8d497fce3a4092$var$_BaseTexture._globalBatch = 0;
let $2d8d497fce3a4092$export$d6306e508f184154 = $2d8d497fce3a4092$var$_BaseTexture;

});
parcelRegister("12R2z", function(module, exports) {

$parcel$export(module.exports, "INSTALLED", () => $992246b926b958eb$export$7db5d8a07d9761e1);
$parcel$export(module.exports, "autoDetectResource", () => $992246b926b958eb$export$5eb9e949a7ff46a7);
const $992246b926b958eb$export$7db5d8a07d9761e1 = [];
function $992246b926b958eb$export$5eb9e949a7ff46a7(source, options) {
    if (!source) return null;
    let extension = "";
    if (typeof source == "string") {
        const result = /\.(\w{3,4})(?:$|\?|#)/i.exec(source);
        result && (extension = result[1].toLowerCase());
    }
    for(let i = $992246b926b958eb$export$7db5d8a07d9761e1.length - 1; i >= 0; --i){
        const ResourcePlugin = $992246b926b958eb$export$7db5d8a07d9761e1[i];
        if (ResourcePlugin.test && ResourcePlugin.test(source, extension)) return new ResourcePlugin(source, options);
    }
    throw new Error("Unrecognized source type to auto-detect Resource");
}

});

parcelRegister("1oZjy", function(module, exports) {

$parcel$export(module.exports, "BufferResource", () => $ad9971bad38b5f89$export$a79ef781de624449);

var $lmRm8 = parcelRequire("lmRm8");

var $fbY8e = parcelRequire("fbY8e");
class $ad9971bad38b5f89$export$a79ef781de624449 extends (0, $fbY8e.Resource) {
    /**
   * @param source - Source buffer
   * @param options - Options
   * @param {number} options.width - Width of the texture
   * @param {number} options.height - Height of the texture
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */ constructor(source, options){
        const { width: width, height: height } = options || {};
        if (!width || !height) throw new Error("BufferResource width or height invalid");
        super(width, height), this.data = source, this.unpackAlignment = options.unpackAlignment ?? 4;
    }
    /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture - glTexture
   * @returns - true is success
   */ upload(renderer, baseTexture, glTexture) {
        const gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, this.unpackAlignment), gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $lmRm8.ALPHA_MODES).UNPACK);
        const width = baseTexture.realWidth, height = baseTexture.realHeight;
        return glTexture.width === width && glTexture.height === height ? gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data) : (glTexture.width = width, glTexture.height = height, gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data)), !0;
    }
    /** Destroy and don't use after this. */ dispose() {
        this.data = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if buffer source
   */ static test(source) {
        return source === null || source instanceof Int8Array || source instanceof Uint8Array || source instanceof Uint8ClampedArray || source instanceof Int16Array || source instanceof Uint16Array || source instanceof Int32Array || source instanceof Uint32Array || source instanceof Float32Array;
    }
}

});
parcelRegister("fbY8e", function(module, exports) {

$parcel$export(module.exports, "Resource", () => $2c5ef8dc6ab5bab0$export$39a853cfb5a94a63);
parcelRequire("hWIIU");
var $aDHVi = parcelRequire("aDHVi");
class $2c5ef8dc6ab5bab0$export$39a853cfb5a94a63 {
    /**
   * @param width - Width of the resource
   * @param height - Height of the resource
   */ constructor(width = 0, height = 0){
        this._width = width, this._height = height, this.destroyed = !1, this.internal = !1, this.onResize = new (0, $aDHVi.Runner)("setRealSize"), this.onUpdate = new (0, $aDHVi.Runner)("update"), this.onError = new (0, $aDHVi.Runner)("onError");
    }
    /**
   * Bind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */ bind(baseTexture) {
        this.onResize.add(baseTexture), this.onUpdate.add(baseTexture), this.onError.add(baseTexture), (this._width || this._height) && this.onResize.emit(this._width, this._height);
    }
    /**
   * Unbind to a parent BaseTexture
   * @param baseTexture - Parent texture
   */ unbind(baseTexture) {
        this.onResize.remove(baseTexture), this.onUpdate.remove(baseTexture), this.onError.remove(baseTexture);
    }
    /**
   * Trigger a resize event
   * @param width - X dimension
   * @param height - Y dimension
   */ resize(width, height) {
        (width !== this._width || height !== this._height) && (this._width = width, this._height = height, this.onResize.emit(width, height));
    }
    /**
   * Has been validated
   * @readonly
   */ get valid() {
        return !!this._width && !!this._height;
    }
    /** Has been updated trigger event. */ update() {
        this.destroyed || this.onUpdate.emit();
    }
    /**
   * This can be overridden to start preloading a resource
   * or do any other prepare step.
   * @protected
   * @returns Handle the validate event
   */ load() {
        return Promise.resolve(this);
    }
    /**
   * The width of the resource.
   * @readonly
   */ get width() {
        return this._width;
    }
    /**
   * The height of the resource.
   * @readonly
   */ get height() {
        return this._height;
    }
    /**
   * Set the style, optional to override
   * @param _renderer - yeah, renderer!
   * @param _baseTexture - the texture
   * @param _glTexture - texture instance for this webgl context
   * @returns - `true` is success
   */ style(_renderer, _baseTexture, _glTexture) {
        return !1;
    }
    /** Clean up anything, this happens when destroying is ready. */ dispose() {}
    /**
   * Call when destroying resource, unbind any BaseTexture object
   * before calling this method, as reference counts are maintained
   * internally.
   */ destroy() {
        this.destroyed || (this.destroyed = !0, this.dispose(), this.onError.removeAll(), this.onError = null, this.onResize.removeAll(), this.onResize = null, this.onUpdate.removeAll(), this.onUpdate = null);
    }
    /**
   * Abstract, used to auto-detect resource type.
   * @param {*} _source - The source object
   * @param {string} _extension - The extension of source, if set
   */ static test(_source, _extension) {
        return !1;
    }
}

});
parcelRegister("hWIIU", function(module, exports) {

$parcel$export(module.exports, "Runner", () => (parcelRequire("aDHVi")).Runner);

var $aDHVi = parcelRequire("aDHVi");

});
parcelRegister("aDHVi", function(module, exports) {

$parcel$export(module.exports, "Runner", () => $e008d4155c799e69$export$571ad3bcba5a0c45);
class $e008d4155c799e69$export$571ad3bcba5a0c45 {
    /**
   * @param {string} name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [], this._name = name, this._aliasCount = 0;
    }
    /* eslint-disable jsdoc/require-param, jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /*  eslint-enable jsdoc/require-param, jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        if (arguments.length > 8) throw new Error("max arguments reached");
        const { name: name, items: items } = this;
        this._aliasCount++;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return items === this.items && this._aliasCount--, this;
    }
    ensureNonAliasedItems() {
        this._aliasCount > 0 && this.items.length > 1 && (this._aliasCount = 0, this.items = this.items.slice(0));
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * E.g. A listener passed to this Runner will require a 'complete' function.
   *
   * ```js
   * import { Runner } from '@pixi/runner';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        return item[this._name] && (this.ensureNonAliasedItems(), this.remove(item), this.items.push(item)), this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        return index !== -1 && (this.ensureNonAliasedItems(), this.items.splice(index, 1)), this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.includes(item);
    }
    /** Remove all listeners from the Runner */ removeAll() {
        return this.ensureNonAliasedItems(), this.items.length = 0, this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll(), this.items.length = 0, this._name = "";
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @type {string}
   */ get name() {
        return this._name;
    }
}
Object.defineProperties($e008d4155c799e69$export$571ad3bcba5a0c45.prototype, {
    /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method dispatch
   * @see PIXI.Runner#emit
   */ dispatch: {
        value: $e008d4155c799e69$export$571ad3bcba5a0c45.prototype.emit
    },
    /**
   * Alias for `emit`
   * @memberof PIXI.Runner#
   * @method run
   * @see PIXI.Runner#emit
   */ run: {
        value: $e008d4155c799e69$export$571ad3bcba5a0c45.prototype.emit
    }
});

});





parcelRegister("6qB4i", function(module, exports) {

$parcel$export(module.exports, "BatchDrawCall", () => $27210fb05180b1cb$export$664fd198634fda29);

var $lmRm8 = parcelRequire("lmRm8");
class $27210fb05180b1cb$export$664fd198634fda29 {
    constructor(){
        this.texArray = null, this.blend = 0, this.type = (0, $lmRm8.DRAW_MODES).TRIANGLES, this.start = 0, this.size = 0, this.data = null;
    }
}

});

parcelRegister("7Gazv", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $93dcf2ad94a668bf$export$449e8d355fd68e43);

var $lmRm8 = parcelRequire("lmRm8");

var $3u4Xc = parcelRequire("3u4Xc");

var $5K7Rq = parcelRequire("5K7Rq");
class $93dcf2ad94a668bf$export$449e8d355fd68e43 extends (0, $5K7Rq.Geometry) {
    /**
   * @param {boolean} [_static=false] - Optimization flag, where `false`
   *        is updated every frame, `true` doesn't change frame-to-frame.
   */ constructor(_static = !1){
        super(), this._buffer = new (0, $3u4Xc.Buffer)(null, _static, !1), this._indexBuffer = new (0, $3u4Xc.Buffer)(null, _static, !0), this.addAttribute("aVertexPosition", this._buffer, 2, !1, (0, $lmRm8.TYPES).FLOAT).addAttribute("aTextureCoord", this._buffer, 2, !1, (0, $lmRm8.TYPES).FLOAT).addAttribute("aColor", this._buffer, 4, !0, (0, $lmRm8.TYPES).UNSIGNED_BYTE).addAttribute("aTextureId", this._buffer, 1, !0, (0, $lmRm8.TYPES).FLOAT).addIndex(this._indexBuffer);
    }
}

});
parcelRegister("3u4Xc", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $ff838791b3783858$export$a143d493d941bafc);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("hWIIU");
var $aDHVi = parcelRequire("aDHVi");
let $ff838791b3783858$var$UID = 0;
class $ff838791b3783858$export$a143d493d941bafc {
    /**
   * @param {PIXI.IArrayBuffer} data - the data to store in the buffer.
   * @param _static - `true` for static buffer
   * @param index - `true` for index buffer
   */ constructor(data, _static = !0, index = !1){
        this.data = data || new Float32Array(1), this._glBuffers = {}, this._updateID = 0, this.index = index, this.static = _static, this.id = $ff838791b3783858$var$UID++, this.disposeRunner = new (0, $aDHVi.Runner)("disposeBuffer");
    }
    // TODO could explore flagging only a partial upload?
    /**
   * Flags this buffer as requiring an upload to the GPU.
   * @param {PIXI.IArrayBuffer|number[]} [data] - the data to update in the buffer.
   */ update(data) {
        data instanceof Array && (data = new Float32Array(data)), this.data = data || this.data, this._updateID++;
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys the buffer. */ destroy() {
        this.dispose(), this.data = null;
    }
    /**
   * Flags whether this is an index buffer.
   *
   * Index buffers are of type `ELEMENT_ARRAY_BUFFER`. Note that setting this property to false will make
   * the buffer of type `ARRAY_BUFFER`.
   *
   * For backwards compatibility.
   */ set index(value) {
        this.type = value ? (0, $lmRm8.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER : (0, $lmRm8.BUFFER_TYPE).ARRAY_BUFFER;
    }
    get index() {
        return this.type === (0, $lmRm8.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
    }
    /**
   * Helper function that creates a buffer based on an array or TypedArray
   * @param {ArrayBufferView | number[]} data - the TypedArray that the buffer will store. If this is a regular Array it will be converted to a Float32Array.
   * @returns - A new Buffer based on the data provided.
   */ static from(data) {
        return data instanceof Array && (data = new Float32Array(data)), new $ff838791b3783858$export$a143d493d941bafc(data);
    }
}

});

parcelRegister("5K7Rq", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $18b317c5775068cf$export$2db6c17465f94a2);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("hWIIU");
var $aDHVi = parcelRequire("aDHVi");
parcelRequire("lFGyw");
var $iqDX5 = parcelRequire("iqDX5");

var $2IRuE = parcelRequire("2IRuE");

var $3u4Xc = parcelRequire("3u4Xc");

var $bLgSh = parcelRequire("bLgSh");
const $18b317c5775068cf$var$byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
let $18b317c5775068cf$var$UID = 0;
const $18b317c5775068cf$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array,
    Uint16Array: Uint16Array
};
class $18b317c5775068cf$export$2db6c17465f94a2 {
    /**
   * @param buffers - An array of buffers. optional.
   * @param attributes - Of the geometry, optional structure of the attributes layout
   */ constructor(buffers = [], attributes = {}){
        this.buffers = buffers, this.indexBuffer = null, this.attributes = attributes, this.glVertexArrayObjects = {}, this.id = $18b317c5775068cf$var$UID++, this.instanced = !1, this.instanceCount = 1, this.disposeRunner = new (0, $aDHVi.Runner)("disposeGeometry"), this.refCount = 0;
    }
    /**
   *
   * Adds an attribute to the geometry
   * Note: `stride` and `start` should be `undefined` if you dont know them, not 0!
   * @param id - the name of the attribute (matching up to a shader)
   * @param {PIXI.Buffer|number[]} buffer - the buffer that holds the data of the attribute . You can also provide an Array and a buffer will be created from it.
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param normalized - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param instance - Instancing flag
   * @returns - Returns self, useful for chaining.
   */ addAttribute(id, buffer, size = 0, normalized = !1, type, stride, start, instance = !1) {
        if (!buffer) throw new Error("You must pass a buffer when creating an attribute");
        buffer instanceof (0, $3u4Xc.Buffer) || (buffer instanceof Array && (buffer = new Float32Array(buffer)), buffer = new (0, $3u4Xc.Buffer)(buffer));
        const ids = id.split("|");
        if (ids.length > 1) {
            for(let i = 0; i < ids.length; i++)this.addAttribute(ids[i], buffer, size, normalized, type);
            return this;
        }
        let bufferIndex = this.buffers.indexOf(buffer);
        return bufferIndex === -1 && (this.buffers.push(buffer), bufferIndex = this.buffers.length - 1), this.attributes[id] = new (0, $2IRuE.Attribute)(bufferIndex, size, normalized, type, stride, start, instance), this.instanced = this.instanced || instance, this;
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.buffers[this.getAttribute(id).buffer];
    }
    /**
   *
   * Adds an index buffer to the geometry
   * The index buffer contains integers, three for each triangle in the geometry, which reference the various attribute buffers (position, colour, UV coordinates, other UV coordinates, normal, …). There is only ONE index buffer.
   * @param {PIXI.Buffer|number[]} [buffer] - The buffer that holds the data of the index buffer. You can also provide an Array and a buffer will be created from it.
   * @returns - Returns self, useful for chaining.
   */ addIndex(buffer) {
        return buffer instanceof (0, $3u4Xc.Buffer) || (buffer instanceof Array && (buffer = new Uint16Array(buffer)), buffer = new (0, $3u4Xc.Buffer)(buffer)), buffer.type = (0, $lmRm8.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER, this.indexBuffer = buffer, this.buffers.includes(buffer) || this.buffers.push(buffer), this;
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * This function modifies the structure so that all current attributes become interleaved into a single buffer
   * This can be useful if your model remains static as it offers a little performance boost
   * @returns - Returns self, useful for chaining.
   */ interleave() {
        if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer) return this;
        const arrays = [], sizes = [], interleavedBuffer = new (0, $3u4Xc.Buffer)();
        let i;
        for(i in this.attributes){
            const attribute = this.attributes[i], buffer = this.buffers[attribute.buffer];
            arrays.push(buffer.data), sizes.push(attribute.size * $18b317c5775068cf$var$byteSizeMap[attribute.type] / 4), attribute.buffer = 0;
        }
        for(interleavedBuffer.data = (0, $bLgSh.interleaveTypedArrays)(arrays, sizes), i = 0; i < this.buffers.length; i++)this.buffers[i] !== this.indexBuffer && this.buffers[i].destroy();
        return this.buffers = [
            interleavedBuffer
        ], this.indexBuffer && this.buffers.push(this.indexBuffer), this;
    }
    /** Get the size of the geometries, in vertices. */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            return this.buffers[attribute.buffer].data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys the geometry. */ destroy() {
        this.dispose(), this.buffers = null, this.indexBuffer = null, this.attributes = null;
    }
    /**
   * Returns a clone of the geometry.
   * @returns - A new clone of this geometry.
   */ clone() {
        const geometry = new $18b317c5775068cf$export$2db6c17465f94a2();
        for(let i = 0; i < this.buffers.length; i++)geometry.buffers[i] = new (0, $3u4Xc.Buffer)(this.buffers[i].data.slice(0));
        for(const i in this.attributes){
            const attrib = this.attributes[i];
            geometry.attributes[i] = new (0, $2IRuE.Attribute)(attrib.buffer, attrib.size, attrib.normalized, attrib.type, attrib.stride, attrib.start, attrib.instance);
        }
        return this.indexBuffer && (geometry.indexBuffer = geometry.buffers[this.buffers.indexOf(this.indexBuffer)], geometry.indexBuffer.type = (0, $lmRm8.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER), geometry;
    }
    /**
   * Merges an array of geometries into a new single one.
   *
   * Geometry attribute styles must match for this operation to work.
   * @param geometries - array of geometries to merge
   * @returns - Shiny new geometry!
   */ static merge(geometries) {
        const geometryOut = new $18b317c5775068cf$export$2db6c17465f94a2(), arrays = [], sizes = [], offsets = [];
        let geometry;
        for(let i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(let j = 0; j < geometry.buffers.length; j++)sizes[j] = sizes[j] || 0, sizes[j] += geometry.buffers[j].data.length, offsets[j] = 0;
        }
        for(let i = 0; i < geometry.buffers.length; i++)arrays[i] = new $18b317c5775068cf$var$map[(0, $iqDX5.getBufferType)(geometry.buffers[i].data)](sizes[i]), geometryOut.buffers[i] = new (0, $3u4Xc.Buffer)(arrays[i]);
        for(let i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(let j = 0; j < geometry.buffers.length; j++)arrays[j].set(geometry.buffers[j].data, offsets[j]), offsets[j] += geometry.buffers[j].data.length;
        }
        if (geometryOut.attributes = geometry.attributes, geometry.indexBuffer) {
            geometryOut.indexBuffer = geometryOut.buffers[geometry.buffers.indexOf(geometry.indexBuffer)], geometryOut.indexBuffer.type = (0, $lmRm8.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
            let offset = 0, stride = 0, offset2 = 0, bufferIndexToCount = 0;
            for(let i = 0; i < geometry.buffers.length; i++)if (geometry.buffers[i] !== geometry.indexBuffer) {
                bufferIndexToCount = i;
                break;
            }
            for(const i in geometry.attributes){
                const attribute = geometry.attributes[i];
                (attribute.buffer | 0) === bufferIndexToCount && (stride += attribute.size * $18b317c5775068cf$var$byteSizeMap[attribute.type] / 4);
            }
            for(let i = 0; i < geometries.length; i++){
                const indexBufferData = geometries[i].indexBuffer.data;
                for(let j = 0; j < indexBufferData.length; j++)geometryOut.indexBuffer.data[j + offset2] += offset;
                offset += geometries[i].buffers[bufferIndexToCount].data.length / stride, offset2 += indexBufferData.length;
            }
        }
        return geometryOut;
    }
}

});
parcelRegister("2IRuE", function(module, exports) {

$parcel$export(module.exports, "Attribute", () => $911c13171714eb21$export$ab9c25261cd8c720);

var $lmRm8 = parcelRequire("lmRm8");
class $911c13171714eb21$export$ab9c25261cd8c720 {
    /**
   * @param buffer - the id of the buffer that this attribute will look for
   * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2.
   * @param normalized - should the data be normalized.
   * @param {PIXI.TYPES} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @param [start=0] - How far into the array to start reading values (used for interleaving data)
   * @param [instance=false] - Whether the geometry is instanced.
   * @param [divisor=1] - Divisor to use when doing instanced rendering
   */ constructor(buffer, size = 0, normalized = !1, type = (0, $lmRm8.TYPES).FLOAT, stride, start, instance, divisor = 1){
        this.buffer = buffer, this.size = size, this.normalized = normalized, this.type = type, this.stride = stride, this.start = start, this.instance = instance, this.divisor = divisor;
    }
    /** Destroys the Attribute. */ destroy() {
        this.buffer = null;
    }
    /**
   * Helper function that creates an Attribute based on the information provided
   * @param buffer - the id of the buffer that this attribute will look for
   * @param [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
   * @param [normalized=false] - should the data be normalized.
   * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
   * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
   * @returns - A new {@link PIXI.Attribute} based on the information provided
   */ static from(buffer, size, normalized, type, stride) {
        return new $911c13171714eb21$export$ab9c25261cd8c720(buffer, size, normalized, type, stride);
    }
}

});

parcelRegister("bLgSh", function(module, exports) {

$parcel$export(module.exports, "interleaveTypedArrays", () => $41444b6bc9e675bd$export$1ce3e224e969bb24);
parcelRequire("lFGyw");
var $iqDX5 = parcelRequire("iqDX5");
const $41444b6bc9e675bd$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $41444b6bc9e675bd$export$1ce3e224e969bb24(arrays, sizes) {
    let outSize = 0, stride = 0;
    const views = {};
    for(let i = 0; i < arrays.length; i++)stride += sizes[i], outSize += arrays[i].length;
    const buffer = new ArrayBuffer(outSize * 4);
    let out = null, littleOffset = 0;
    for(let i = 0; i < arrays.length; i++){
        const size = sizes[i], array = arrays[i], type = (0, $iqDX5.getBufferType)(array);
        views[type] || (views[type] = new $41444b6bc9e675bd$var$map[type](buffer)), out = views[type];
        for(let j = 0; j < array.length; j++){
            const indexStart = (j / size | 0) * stride + littleOffset, index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}

});



parcelRegister("6kk4I", function(module, exports) {

$parcel$export(module.exports, "BatchShaderGenerator", () => $8ba5966bcff4e5b1$export$9a4c4943b6fad72e);
parcelRequire("9fnly");
var $6wJoy = parcelRequire("6wJoy");

var $k7n3P = parcelRequire("k7n3P");

var $2cKpP = parcelRequire("2cKpP");

var $BpNwR = parcelRequire("BpNwR");
class $8ba5966bcff4e5b1$export$9a4c4943b6fad72e {
    /**
   * @param vertexSrc - Vertex shader
   * @param fragTemplate - Fragment shader template
   */ constructor(vertexSrc, fragTemplate){
        if (this.vertexSrc = vertexSrc, this.fragTemplate = fragTemplate, this.programCache = {}, this.defaultGroupCache = {}, !fragTemplate.includes("%count%")) throw new Error('Fragment template must contain "%count%".');
        if (!fragTemplate.includes("%forloop%")) throw new Error('Fragment template must contain "%forloop%".');
    }
    generateShader(maxTextures) {
        if (!this.programCache[maxTextures]) {
            const sampleValues = new Int32Array(maxTextures);
            for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
            this.defaultGroupCache[maxTextures] = (0, $BpNwR.UniformGroup).from({
                uSamplers: sampleValues
            }, !0);
            let fragmentSrc = this.fragTemplate;
            fragmentSrc = fragmentSrc.replace(/%count%/gi, `${maxTextures}`), fragmentSrc = fragmentSrc.replace(/%forloop%/gi, this.generateSampleSrc(maxTextures)), this.programCache[maxTextures] = new (0, $k7n3P.Program)(this.vertexSrc, fragmentSrc);
        }
        const uniforms = {
            tint: new Float32Array([
                1,
                1,
                1,
                1
            ]),
            translationMatrix: new (0, $6wJoy.Matrix)(),
            default: this.defaultGroupCache[maxTextures]
        };
        return new (0, $2cKpP.Shader)(this.programCache[maxTextures], uniforms);
    }
    generateSampleSrc(maxTextures) {
        let src = "";
        src += `
`, src += `
`;
        for(let i = 0; i < maxTextures; i++)i > 0 && (src += `
else `), i < maxTextures - 1 && (src += `if(vTextureId < ${i}.5)`), src += `
{`, src += `
	color = texture2D(uSamplers[${i}], vTextureCoord);`, src += `
}`;
        return src += `
`, src += `
`, src;
    }
}

});
parcelRegister("9fnly", function(module, exports) {

$parcel$export(module.exports, "Circle", () => (parcelRequire("8mUry")).Circle);
$parcel$export(module.exports, "DEG_TO_RAD", () => (parcelRequire("lbGGA")).DEG_TO_RAD);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("gBsEB")).Ellipse);
$parcel$export(module.exports, "Matrix", () => (parcelRequire("6wJoy")).Matrix);
$parcel$export(module.exports, "ObservablePoint", () => (parcelRequire("g9ac3")).ObservablePoint);
$parcel$export(module.exports, "PI_2", () => (parcelRequire("lbGGA")).PI_2);
$parcel$export(module.exports, "Point", () => (parcelRequire("gnwPx")).Point);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("duPDq")).Polygon);
$parcel$export(module.exports, "RAD_TO_DEG", () => (parcelRequire("lbGGA")).RAD_TO_DEG);
$parcel$export(module.exports, "Rectangle", () => (parcelRequire("kZOeV")).Rectangle);
$parcel$export(module.exports, "RoundedRectangle", () => (parcelRequire("3qn70")).RoundedRectangle);
$parcel$export(module.exports, "SHAPES", () => (parcelRequire("lbGGA")).SHAPES);
$parcel$export(module.exports, "Transform", () => (parcelRequire("9jXhN")).Transform);
$parcel$export(module.exports, "groupD8", () => (parcelRequire("e96Pm")).groupD8);

var $8mUry = parcelRequire("8mUry");

var $gBsEB = parcelRequire("gBsEB");

var $duPDq = parcelRequire("duPDq");

var $kZOeV = parcelRequire("kZOeV");

var $3qn70 = parcelRequire("3qn70");

var $e96Pm = parcelRequire("e96Pm");
parcelRequire("eCQsg");
parcelRequire("gXsnP");

var $6wJoy = parcelRequire("6wJoy");

var $g9ac3 = parcelRequire("g9ac3");

var $gnwPx = parcelRequire("gnwPx");

var $9jXhN = parcelRequire("9jXhN");

var $lbGGA = parcelRequire("lbGGA");

});
parcelRegister("8mUry", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $224e00dc89bc3e26$export$c89a927ffc67e6fa);

var $lbGGA = parcelRequire("lbGGA");

var $kZOeV = parcelRequire("kZOeV");
class $224e00dc89bc3e26$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        this.x = x, this.y = y, this.radius = radius, this.type = (0, $lbGGA.SHAPES).CIRC;
    }
    /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */ clone() {
        return new $224e00dc89bc3e26$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */ contains(x, y) {
        if (this.radius <= 0) return !1;
        const r2 = this.radius * this.radius;
        let dx = this.x - x, dy = this.y - y;
        return dx *= dx, dy *= dy, dx + dy <= r2;
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @returns The framing rectangle
   */ getBounds() {
        return new (0, $kZOeV.Rectangle)(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
    }
}
$224e00dc89bc3e26$export$c89a927ffc67e6fa.prototype.toString = function() {
    return `[@pixi/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
};

});
parcelRegister("lbGGA", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $07142e085c72c7cc$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $07142e085c72c7cc$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $07142e085c72c7cc$export$870617f62e3187f1);
$parcel$export(module.exports, "SHAPES", () => $07142e085c72c7cc$export$511e1d54a4a8684e);
const $07142e085c72c7cc$export$59ed0a0a5de1084b = Math.PI * 2, $07142e085c72c7cc$export$3f91627dc85c5d57 = 180 / Math.PI, $07142e085c72c7cc$export$870617f62e3187f1 = Math.PI / 180;
var $07142e085c72c7cc$export$511e1d54a4a8684e = /* @__PURE__ */ ((SHAPES2)=>(SHAPES2[SHAPES2.POLY = 0] = "POLY", SHAPES2[SHAPES2.RECT = 1] = "RECT", SHAPES2[SHAPES2.CIRC = 2] = "CIRC", SHAPES2[SHAPES2.ELIP = 3] = "ELIP", SHAPES2[SHAPES2.RREC = 4] = "RREC", SHAPES2))($07142e085c72c7cc$export$511e1d54a4a8684e || {});

});

parcelRegister("kZOeV", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $340a428aa13511cc$export$4617fb02663045ef);

var $lbGGA = parcelRequire("lbGGA");

var $gnwPx = parcelRequire("gnwPx");
const $340a428aa13511cc$var$tempPoints = [
    new (0, $gnwPx.Point)(),
    new (0, $gnwPx.Point)(),
    new (0, $gnwPx.Point)(),
    new (0, $gnwPx.Point)()
];
class $340a428aa13511cc$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        this.x = Number(x), this.y = Number(y), this.width = Number(width), this.height = Number(height), this.type = (0, $lbGGA.SHAPES).RECT;
    }
    /** Returns the left edge of the rectangle. */ get left() {
        return this.x;
    }
    /** Returns the right edge of the rectangle. */ get right() {
        return this.x + this.width;
    }
    /** Returns the top edge of the rectangle. */ get top() {
        return this.y;
    }
    /** Returns the bottom edge of the rectangle. */ get bottom() {
        return this.y + this.height;
    }
    /** A constant empty rectangle. */ static get EMPTY() {
        return new $340a428aa13511cc$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */ clone() {
        return new $340a428aa13511cc$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        return this.x = rectangle.x, this.y = rectangle.y, this.width = rectangle.width, this.height = rectangle.height, this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        return rectangle.x = this.x, rectangle.y = this.y, rectangle.width = this.width, rectangle.height = this.height, rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */ contains(x, y) {
        return this.width <= 0 || this.height <= 0 ? !1 : x >= this.x && x < this.x + this.width && y >= this.y && y < this.y + this.height;
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            if ((this.right > other.right ? other.right : this.right) <= x02) return !1;
            const y02 = this.y < other.y ? other.y : this.y;
            return (this.bottom > other.bottom ? other.bottom : this.bottom) > y02;
        }
        const x0 = this.left, x1 = this.right, y0 = this.top, y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return !1;
        const lt = $340a428aa13511cc$var$tempPoints[0].set(other.left, other.top), lb = $340a428aa13511cc$var$tempPoints[1].set(other.left, other.bottom), rt = $340a428aa13511cc$var$tempPoints[2].set(other.right, other.top), rb = $340a428aa13511cc$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return !1;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0 || (transform.apply(lt, lt), transform.apply(lb, lb), transform.apply(rt, rt), transform.apply(rb, rb), Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1)) return !1;
        const nx = s * (lb.y - lt.y), ny = s * (lt.x - lb.x), n00 = nx * x0 + ny * y0, n10 = nx * x1 + ny * y0, n01 = nx * x0 + ny * y1, n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return !1;
        const mx = s * (lt.y - rt.y), my = s * (rt.x - lt.x), m00 = mx * x0 + my * y0, m10 = mx * x1 + my * y0, m01 = mx * x0 + my * y1, m11 = mx * x1 + my * y1;
        return !(Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y);
    }
    /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */ pad(paddingX = 0, paddingY = paddingX) {
        return this.x -= paddingX, this.y -= paddingY, this.width += paddingX * 2, this.height += paddingY * 2, this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x), x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width), y1 = Math.max(this.y, rectangle.y), y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        return this.x = x1, this.width = Math.max(x2 - x1, 0), this.y = y1, this.height = Math.max(y2 - y1, 0), this;
    }
    /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution, y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        return this.x = Math.floor((this.x + eps) * resolution) / resolution, this.y = Math.floor((this.y + eps) * resolution) / resolution, this.width = x2 - this.x, this.height = y2 - this.y, this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x), x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width), y1 = Math.min(this.y, rectangle.y), y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        return this.x = x1, this.width = x2 - x1, this.y = y1, this.height = y2 - y1, this;
    }
}
$340a428aa13511cc$export$4617fb02663045ef.prototype.toString = function() {
    return `[@pixi/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};

});
parcelRegister("gnwPx", function(module, exports) {

$parcel$export(module.exports, "Point", () => $88931fa1c0809be8$export$baf26146a414f24a);
class $88931fa1c0809be8$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        this.x = 0, this.y = 0, this.x = x, this.y = y;
    }
    /**
   * Creates a clone of this point
   * @returns A clone of this point
   */ clone() {
        return new $88931fa1c0809be8$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */ copyFrom(p) {
        return this.set(p.x, p.y), this;
    }
    /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        return p.set(this.x, this.y), p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */ set(x = 0, y = x) {
        return this.x = x, this.y = y, this;
    }
}
$88931fa1c0809be8$export$baf26146a414f24a.prototype.toString = function() {
    return `[@pixi/math:Point x=${this.x} y=${this.y}]`;
};

});



parcelRegister("gBsEB", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $07416f9533a1f100$export$80b0269ab108fa11);

var $lbGGA = parcelRequire("lbGGA");

var $kZOeV = parcelRequire("kZOeV");
class $07416f9533a1f100$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        this.x = x, this.y = y, this.width = halfWidth, this.height = halfHeight, this.type = (0, $lbGGA.SHAPES).ELIP;
    }
    /**
   * Creates a clone of this Ellipse instance
   * @returns {PIXI.Ellipse} A copy of the ellipse
   */ clone() {
        return new $07416f9533a1f100$export$80b0269ab108fa11(this.x, this.y, this.width, this.height);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return !1;
        let normx = (x - this.x) / this.width, normy = (y - this.y) / this.height;
        return normx *= normx, normy *= normy, normx + normy <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @returns The framing rectangle
   */ getBounds() {
        return new (0, $kZOeV.Rectangle)(this.x - this.width, this.y - this.height, this.width, this.height);
    }
}
$07416f9533a1f100$export$80b0269ab108fa11.prototype.toString = function() {
    return `[@pixi/math:Ellipse x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
};

});

parcelRegister("duPDq", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $173c2dfd36fd3f4f$export$7d31b617c820d435);

var $lbGGA = parcelRequire("lbGGA");
class $173c2dfd36fd3f4f$export$7d31b617c820d435 {
    /**
   * @param {PIXI.IPointData[]|number[]} points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] != "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat, this.type = (0, $lbGGA.SHAPES).POLY, this.closeStroke = !0;
    }
    /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */ clone() {
        const points = this.points.slice(), polygon = new $173c2dfd36fd3f4f$export$7d31b617c820d435(points);
        return polygon.closeStroke = this.closeStroke, polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */ contains(x, y) {
        let inside = !1;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2], yi = this.points[i * 2 + 1], xj = this.points[j * 2], yj = this.points[j * 2 + 1];
            yi > y != yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi && (inside = !inside);
        }
        return inside;
    }
}
$173c2dfd36fd3f4f$export$7d31b617c820d435.prototype.toString = function() {
    return `[@pixi/math:PolygoncloseStroke=${this.closeStroke}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
};

});

parcelRegister("3qn70", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $cfa2d28b786e5ab9$export$d55ab2e3dc5a4263);

var $lbGGA = parcelRequire("lbGGA");
class $cfa2d28b786e5ab9$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        this.x = x, this.y = y, this.width = width, this.height = height, this.radius = radius, this.type = (0, $lbGGA.SHAPES).RREC;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */ clone() {
        return new $cfa2d28b786e5ab9$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return !1;
        if (x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height) {
            const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
            if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return !0;
            let dx = x - (this.x + radius), dy = y - (this.y + radius);
            const radius2 = radius * radius;
            if (dx * dx + dy * dy <= radius2 || (dx = x - (this.x + this.width - radius), dx * dx + dy * dy <= radius2) || (dy = y - (this.y + this.height - radius), dx * dx + dy * dy <= radius2) || (dx = x - (this.x + radius), dx * dx + dy * dy <= radius2)) return !0;
        }
        return !1;
    }
}
$cfa2d28b786e5ab9$export$d55ab2e3dc5a4263.prototype.toString = function() {
    return `[@pixi/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
};

});

parcelRegister("e96Pm", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $c91a285233559d80$export$b7bb6a2a8d203102);

var $6wJoy = parcelRequire("6wJoy");
const $c91a285233559d80$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
], $c91a285233559d80$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
], $c91a285233559d80$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
], $c91a285233559d80$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
], $c91a285233559d80$var$rotationCayley = [], $c91a285233559d80$var$rotationMatrices = [], $c91a285233559d80$var$signum = Math.sign;
function $c91a285233559d80$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $c91a285233559d80$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $c91a285233559d80$var$signum($c91a285233559d80$var$ux[i] * $c91a285233559d80$var$ux[j] + $c91a285233559d80$var$vx[i] * $c91a285233559d80$var$uy[j]), _uy = $c91a285233559d80$var$signum($c91a285233559d80$var$uy[i] * $c91a285233559d80$var$ux[j] + $c91a285233559d80$var$vy[i] * $c91a285233559d80$var$uy[j]), _vx = $c91a285233559d80$var$signum($c91a285233559d80$var$ux[i] * $c91a285233559d80$var$vx[j] + $c91a285233559d80$var$vx[i] * $c91a285233559d80$var$vy[j]), _vy = $c91a285233559d80$var$signum($c91a285233559d80$var$uy[i] * $c91a285233559d80$var$vx[j] + $c91a285233559d80$var$vy[i] * $c91a285233559d80$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($c91a285233559d80$var$ux[k] === _ux && $c91a285233559d80$var$uy[k] === _uy && $c91a285233559d80$var$vx[k] === _vx && $c91a285233559d80$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $6wJoy.Matrix)();
        mat.set($c91a285233559d80$var$ux[i], $c91a285233559d80$var$uy[i], $c91a285233559d80$var$vx[i], $c91a285233559d80$var$vy[i], 0, 0), $c91a285233559d80$var$rotationMatrices.push(mat);
    }
}
$c91a285233559d80$var$init();
const $c91a285233559d80$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @readonly
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @readonly
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @readonly
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @readonly
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @readonly
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @readonly
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @readonly
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @readonly
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @readonly
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @readonly
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @readonly
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @readonly
   */ REVERSE_DIAGONAL: 14,
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$c91a285233559d80$var$ux[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$c91a285233559d80$var$uy[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$c91a285233559d80$var$vx[ind],
    /**
   * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
   * @returns {PIXI.GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$c91a285233559d80$var$vy[ind],
    /**
   * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>rotation & 8 ? rotation & 15 : -rotation & 7,
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {PIXI.GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$c91a285233559d80$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
   * @param {PIXI.GD8Symmetry} rotationFirst - First operation
   * @returns {PIXI.GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$c91a285233559d80$var$rotationCayley[rotationSecond][$c91a285233559d80$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @param {PIXI.GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {PIXI.GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>Math.abs(dx) * 2 <= Math.abs(dy) ? dy >= 0 ? $c91a285233559d80$export$b7bb6a2a8d203102.S : $c91a285233559d80$export$b7bb6a2a8d203102.N : Math.abs(dy) * 2 <= Math.abs(dx) ? dx > 0 ? $c91a285233559d80$export$b7bb6a2a8d203102.E : $c91a285233559d80$export$b7bb6a2a8d203102.W : dy > 0 ? dx > 0 ? $c91a285233559d80$export$b7bb6a2a8d203102.SE : $c91a285233559d80$export$b7bb6a2a8d203102.SW : dx > 0 ? $c91a285233559d80$export$b7bb6a2a8d203102.NE : $c91a285233559d80$export$b7bb6a2a8d203102.NW,
    /**
   * Helps sprite to compensate texture packer rotation.
   * @param {PIXI.Matrix} matrix - sprite world matrix
   * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $c91a285233559d80$var$rotationMatrices[$c91a285233559d80$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx, mat.ty = ty, matrix.append(mat);
    }
};

});
parcelRegister("6wJoy", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $414c7fb9dda367fe$export$5b12bf1653c0dd85);

var $lbGGA = parcelRequire("lbGGA");

var $gnwPx = parcelRequire("gnwPx");
class $414c7fb9dda367fe$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        this.array = null, this.a = a, this.b = b, this.c = c, this.d = d, this.tx = tx, this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */ fromArray(array) {
        this.a = array[0], this.b = array[1], this.c = array[3], this.d = array[4], this.tx = array[2], this.ty = array[5];
    }
    /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */ set(a, b, c, d, tx, ty) {
        return this.a = a, this.b = b, this.c = c, this.d = d, this.tx = tx, this.ty = ty, this;
    }
    /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */ toArray(transpose, out) {
        this.array || (this.array = new Float32Array(9));
        const array = out || this.array;
        return transpose ? (array[0] = this.a, array[1] = this.b, array[2] = 0, array[3] = this.c, array[4] = this.d, array[5] = 0, array[6] = this.tx, array[7] = this.ty, array[8] = 1) : (array[0] = this.a, array[1] = this.c, array[2] = this.tx, array[3] = this.b, array[4] = this.d, array[5] = this.ty, array[6] = 0, array[7] = 0, array[8] = 1), array;
    }
    /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, transformed through this matrix
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $gnwPx.Point)();
        const x = pos.x, y = pos.y;
        return newPos.x = this.a * x + this.c * y + this.tx, newPos.y = this.b * x + this.d * y + this.ty, newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {PIXI.Point} The new point, inverse-transformed through this matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $gnwPx.Point)();
        const id = 1 / (this.a * this.d + this.c * -this.b), x = pos.x, y = pos.y;
        return newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id, newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id, newPos;
    }
    /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */ translate(x, y) {
        return this.tx += x, this.ty += y, this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */ scale(x, y) {
        return this.a *= x, this.d *= y, this.c *= x, this.b *= y, this.tx *= x, this.ty *= y, this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */ rotate(angle) {
        const cos = Math.cos(angle), sin = Math.sin(angle), a1 = this.a, c1 = this.c, tx1 = this.tx;
        return this.a = a1 * cos - this.b * sin, this.b = a1 * sin + this.b * cos, this.c = c1 * cos - this.d * sin, this.d = c1 * sin + this.d * cos, this.tx = tx1 * cos - this.ty * sin, this.ty = tx1 * sin + this.ty * cos, this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ append(matrix) {
        const a1 = this.a, b1 = this.b, c1 = this.c, d1 = this.d;
        return this.a = matrix.a * a1 + matrix.b * c1, this.b = matrix.a * b1 + matrix.b * d1, this.c = matrix.c * a1 + matrix.d * c1, this.d = matrix.c * b1 + matrix.d * d1, this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx, this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty, this;
    }
    /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        return this.a = Math.cos(rotation + skewY) * scaleX, this.b = Math.sin(rotation + skewY) * scaleX, this.c = -Math.sin(rotation - skewX) * scaleY, this.d = Math.cos(rotation - skewX) * scaleY, this.tx = x - (pivotX * this.a + pivotY * this.c), this.ty = y - (pivotX * this.b + pivotY * this.d), this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a, c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c, this.b = a1 * matrix.b + this.b * matrix.d, this.c = c1 * matrix.a + this.d * matrix.c, this.d = c1 * matrix.b + this.d * matrix.d;
        }
        return this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx, this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty, this;
    }
    /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */ decompose(transform) {
        const a = this.a, b = this.b, c = this.c, d = this.d, pivot = transform.pivot, skewX = -Math.atan2(-c, d), skewY = Math.atan2(b, a), delta = Math.abs(skewX + skewY);
        return delta < 1e-5 || Math.abs((0, $lbGGA.PI_2) - delta) < 1e-5 ? (transform.rotation = skewY, transform.skew.x = transform.skew.y = 0) : (transform.rotation = 0, transform.skew.x = skewX, transform.skew.y = skewY), transform.scale.x = Math.sqrt(a * a + b * b), transform.scale.y = Math.sqrt(c * c + d * d), transform.position.x = this.tx + (pivot.x * a + pivot.y * c), transform.position.y = this.ty + (pivot.x * b + pivot.y * d), transform;
    }
    /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */ invert() {
        const a1 = this.a, b1 = this.b, c1 = this.c, d1 = this.d, tx1 = this.tx, n = a1 * d1 - b1 * c1;
        return this.a = d1 / n, this.b = -b1 / n, this.c = -c1 / n, this.d = a1 / n, this.tx = (c1 * this.ty - d1 * tx1) / n, this.ty = -(a1 * this.ty - b1 * tx1) / n, this;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */ identity() {
        return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $414c7fb9dda367fe$export$5b12bf1653c0dd85();
        return matrix.a = this.a, matrix.b = this.b, matrix.c = this.c, matrix.d = this.d, matrix.tx = this.tx, matrix.ty = this.ty, matrix;
    }
    /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */ copyTo(matrix) {
        return matrix.a = this.a, matrix.b = this.b, matrix.c = this.c, matrix.d = this.d, matrix.tx = this.tx, matrix.ty = this.ty, matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param {PIXI.Matrix} matrix - The matrix to copy from.
   * @returns {PIXI.Matrix} this
   */ copyFrom(matrix) {
        return this.a = matrix.a, this.b = matrix.b, this.c = matrix.c, this.d = matrix.d, this.tx = matrix.tx, this.ty = matrix.ty, this;
    }
    /**
   * A default (identity) matrix
   * @readonly
   */ static get IDENTITY() {
        return new $414c7fb9dda367fe$export$5b12bf1653c0dd85();
    }
    /**
   * A temp matrix
   * @readonly
   */ static get TEMP_MATRIX() {
        return new $414c7fb9dda367fe$export$5b12bf1653c0dd85();
    }
}
$414c7fb9dda367fe$export$5b12bf1653c0dd85.prototype.toString = function() {
    return `[@pixi/math:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
};

});


parcelRegister("eCQsg", function(module, exports) {

});

parcelRegister("gXsnP", function(module, exports) {

});

parcelRegister("g9ac3", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $e3200063c3e77fce$export$3755aaad3fd42e52);
class $e3200063c3e77fce$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param cb - callback function triggered when `x` and/or `y` are changed
   * @param scope - owner of callback
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(cb, scope, x = 0, y = 0){
        this._x = x, this._y = y, this.cb = cb, this.scope = scope;
    }
    /**
   * Creates a clone of this point.
   * The callback and scope params can be overridden otherwise they will default
   * to the clone object's values.
   * @override
   * @param cb - The callback function triggered when `x` and/or `y` are changed
   * @param scope - The owner of the callback
   * @returns a copy of this observable point
   */ clone(cb = this.cb, scope = this.scope) {
        return new $e3200063c3e77fce$export$3755aaad3fd42e52(cb, scope, this._x, this._y);
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */ set(x = 0, y = x) {
        return (this._x !== x || this._y !== y) && (this._x = x, this._y = y, this.cb.call(this.scope)), this;
    }
    /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `IPointData`
   * @returns The observable point instance itself
   */ copyFrom(p) {
        return (this._x !== p.x || this._y !== p.y) && (this._x = p.x, this._y = p.y, this.cb.call(this.scope)), this;
    }
    /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        return p.set(this._x, this._y), p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    /** Position of the observable point on the x axis. */ get x() {
        return this._x;
    }
    set x(value) {
        this._x !== value && (this._x = value, this.cb.call(this.scope));
    }
    /** Position of the observable point on the y axis. */ get y() {
        return this._y;
    }
    set y(value) {
        this._y !== value && (this._y = value, this.cb.call(this.scope));
    }
}
$e3200063c3e77fce$export$3755aaad3fd42e52.prototype.toString = function() {
    return `[@pixi/math:ObservablePoint x=${this.x} y=${this.y} scope=${this.scope}]`;
};

});

parcelRegister("9jXhN", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $83f2cf09d03bb7ff$export$563a914cafbdc389);

var $6wJoy = parcelRequire("6wJoy");

var $g9ac3 = parcelRequire("g9ac3");
const $83f2cf09d03bb7ff$var$_Transform = class {
    constructor(){
        this.worldTransform = new (0, $6wJoy.Matrix)(), this.localTransform = new (0, $6wJoy.Matrix)(), this.position = new (0, $g9ac3.ObservablePoint)(this.onChange, this, 0, 0), this.scale = new (0, $g9ac3.ObservablePoint)(this.onChange, this, 1, 1), this.pivot = new (0, $g9ac3.ObservablePoint)(this.onChange, this, 0, 0), this.skew = new (0, $g9ac3.ObservablePoint)(this.updateSkew, this, 0, 0), this._rotation = 0, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._localID = 0, this._currentLocalID = 0, this._worldID = 0, this._parentID = 0;
    }
    /** Called when a value changes. */ onChange() {
        this._localID++;
    }
    /** Called when the skew or the rotation changes. */ updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew.y), this._sx = Math.sin(this._rotation + this.skew.y), this._cy = -Math.sin(this._rotation - this.skew.x), this._sy = Math.cos(this._rotation - this.skew.x), this._localID++;
    }
    /** Updates the local transformation matrix. */ updateLocalTransform() {
        const lt = this.localTransform;
        this._localID !== this._currentLocalID && (lt.a = this._cx * this.scale.x, lt.b = this._sx * this.scale.x, lt.c = this._cy * this.scale.y, lt.d = this._sy * this.scale.y, lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c), lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d), this._currentLocalID = this._localID, this._parentID = -1);
    }
    /**
   * Updates the local and the world transformation matrices.
   * @param parentTransform - The parent transform
   */ updateTransform(parentTransform) {
        const lt = this.localTransform;
        if (this._localID !== this._currentLocalID && (lt.a = this._cx * this.scale.x, lt.b = this._sx * this.scale.x, lt.c = this._cy * this.scale.y, lt.d = this._sy * this.scale.y, lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c), lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d), this._currentLocalID = this._localID, this._parentID = -1), this._parentID !== parentTransform._worldID) {
            const pt = parentTransform.worldTransform, wt = this.worldTransform;
            wt.a = lt.a * pt.a + lt.b * pt.c, wt.b = lt.a * pt.b + lt.b * pt.d, wt.c = lt.c * pt.a + lt.d * pt.c, wt.d = lt.c * pt.b + lt.d * pt.d, wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx, wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty, this._parentID = parentTransform._worldID, this._worldID++;
        }
    }
    /**
   * Decomposes a matrix and sets the transforms properties based on it.
   * @param matrix - The matrix to decompose
   */ setFromMatrix(matrix) {
        matrix.decompose(this), this._localID++;
    }
    /** The rotation of the object in radians. */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        this._rotation !== value && (this._rotation = value, this.updateSkew());
    }
};
$83f2cf09d03bb7ff$var$_Transform.IDENTITY = new $83f2cf09d03bb7ff$var$_Transform();
let $83f2cf09d03bb7ff$export$563a914cafbdc389 = $83f2cf09d03bb7ff$var$_Transform;
$83f2cf09d03bb7ff$export$563a914cafbdc389.prototype.toString = function() {
    return `[@pixi/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
};

});


parcelRegister("k7n3P", function(module, exports) {

$parcel$export(module.exports, "Program", () => $52e5734958fc1bae$export$b6c59b989905b650);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("lFGyw");
var $lQgZZ = parcelRequire("lQgZZ");
var $5ohKV = parcelRequire("5ohKV");

var $1pRuH = parcelRequire("1pRuH");

var $04dw3 = parcelRequire("04dw3");
parcelRequire("4lsfy");

var $dPwsf = parcelRequire("dPwsf");

var $ezyG3 = parcelRequire("ezyG3");
let $52e5734958fc1bae$var$UID = 0;
const $52e5734958fc1bae$var$nameCache = {}, $52e5734958fc1bae$var$_Program = class _Program2 {
    /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @param extra - Extra data for shader
   */ constructor(vertexSrc, fragmentSrc, name = "pixi-shader", extra = {}){
        this.extra = {}, this.id = $52e5734958fc1bae$var$UID++, this.vertexSrc = vertexSrc || _Program2.defaultVertexSrc, this.fragmentSrc = fragmentSrc || _Program2.defaultFragmentSrc, this.vertexSrc = this.vertexSrc.trim(), this.fragmentSrc = this.fragmentSrc.trim(), this.extra = extra, this.vertexSrc.substring(0, 8) !== "#version" && (name = name.replace(/\s+/g, "-"), $52e5734958fc1bae$var$nameCache[name] ? ($52e5734958fc1bae$var$nameCache[name]++, name += `-${$52e5734958fc1bae$var$nameCache[name]}`) : $52e5734958fc1bae$var$nameCache[name] = 1, this.vertexSrc = `#define SHADER_NAME ${name}
${this.vertexSrc}`, this.fragmentSrc = `#define SHADER_NAME ${name}
${this.fragmentSrc}`, this.vertexSrc = (0, $dPwsf.setPrecision)(this.vertexSrc, _Program2.defaultVertexPrecision, (0, $lmRm8.PRECISION).HIGH), this.fragmentSrc = (0, $dPwsf.setPrecision)(this.fragmentSrc, _Program2.defaultFragmentPrecision, (0, $ezyG3.getMaxFragmentPrecision)())), this.glPrograms = {}, this.syncUniforms = null;
    }
    /**
   * The default vertex shader source.
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $04dw3.default;
    }
    /**
   * The default fragment shader source.
   * @readonly
   */ static get defaultFragmentSrc() {
        return 0, $1pRuH.default;
    }
    /**
   * A short hand function to create a program based of a vertex and fragment shader.
   *
   * This method will also check to see if there is a cached program.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param name - Name for shader
   * @returns A shiny new PixiJS shader program!
   */ static from(vertexSrc, fragmentSrc, name) {
        const key = vertexSrc + fragmentSrc;
        let program = (0, $5ohKV.ProgramCache)[key];
        return program || ((0, $5ohKV.ProgramCache)[key] = program = new _Program2(vertexSrc, fragmentSrc, name)), program;
    }
};
$52e5734958fc1bae$var$_Program.defaultVertexPrecision = (0, $lmRm8.PRECISION).HIGH, /**
* Default specify float precision in fragment shader.
* iOS is best set at highp due to https://github.com/pixijs/pixijs/issues/3742
* @static
* @type {PIXI.PRECISION}
* @default PIXI.PRECISION.MEDIUM
*/ $52e5734958fc1bae$var$_Program.defaultFragmentPrecision = (0, $lQgZZ.isMobile).apple.device ? (0, $lmRm8.PRECISION).HIGH : (0, $lmRm8.PRECISION).MEDIUM;
let $52e5734958fc1bae$export$b6c59b989905b650 = $52e5734958fc1bae$var$_Program;

});
parcelRegister("1pRuH", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f35a9e14ec8702$export$2e2bcd8739ae039);
var $95f35a9e14ec8702$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor *= texture2D(uSampler, vTextureCoord);
}`;

});

parcelRegister("04dw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d5dfe8f7d1b5870$export$2e2bcd8739ae039);
var $0d5dfe8f7d1b5870$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void){
   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
   vTextureCoord = aTextureCoord;
}
`;

});

parcelRegister("4lsfy", function(module, exports) {

var $2deXx = parcelRequire("2deXx");

var $eisDF = parcelRequire("eisDF");

var $flCZd = parcelRequire("flCZd");

var $5pxYo = parcelRequire("5pxYo");

var $ezyG3 = parcelRequire("ezyG3");

var $7W4Qd = parcelRequire("7W4Qd");

var $iqofN = parcelRequire("iqofN");

var $kwXhP = parcelRequire("kwXhP");

var $f97nY = parcelRequire("f97nY");

var $dPwsf = parcelRequire("dPwsf");

var $d0Qk2 = parcelRequire("d0Qk2");

var $5MhZE = parcelRequire("5MhZE");

});
parcelRegister("eisDF", function(module, exports) {

$parcel$export(module.exports, "compileShader", () => $0dc4dba3c84abd75$export$9b5304f4eb007cf0);
function $0dc4dba3c84abd75$export$9b5304f4eb007cf0(gl, type, src) {
    const shader = gl.createShader(type);
    return gl.shaderSource(shader, src), gl.compileShader(shader), shader;
}

});

parcelRegister("flCZd", function(module, exports) {

$parcel$export(module.exports, "defaultValue", () => $103a179a1bbbbc0b$export$1a01ae0705bafd37);
function $103a179a1bbbbc0b$var$booleanArray(size) {
    const array = new Array(size);
    for(let i = 0; i < array.length; i++)array[i] = !1;
    return array;
}
function $103a179a1bbbbc0b$export$1a01ae0705bafd37(type, size) {
    switch(type){
        case "float":
            return 0;
        case "vec2":
            return new Float32Array(2 * size);
        case "vec3":
            return new Float32Array(3 * size);
        case "vec4":
            return new Float32Array(4 * size);
        case "int":
        case "uint":
        case "sampler2D":
        case "sampler2DArray":
            return 0;
        case "ivec2":
            return new Int32Array(2 * size);
        case "ivec3":
            return new Int32Array(3 * size);
        case "ivec4":
            return new Int32Array(4 * size);
        case "uvec2":
            return new Uint32Array(2 * size);
        case "uvec3":
            return new Uint32Array(3 * size);
        case "uvec4":
            return new Uint32Array(4 * size);
        case "bool":
            return !1;
        case "bvec2":
            return $103a179a1bbbbc0b$var$booleanArray(2 * size);
        case "bvec3":
            return $103a179a1bbbbc0b$var$booleanArray(3 * size);
        case "bvec4":
            return $103a179a1bbbbc0b$var$booleanArray(4 * size);
        case "mat2":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});

parcelRegister("5pxYo", function(module, exports) {

$parcel$export(module.exports, "generateUniformsSync", () => $fa25b17d2653b481$export$20c95d1c2d5a6828);

var $d0Qk2 = parcelRequire("d0Qk2");
const $fa25b17d2653b481$var$GLSL_TO_SINGLE_SETTERS_CACHED = {
    float: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1f(location, v);
    }`,
    vec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2f(location, v[0], v[1])
    }`,
    vec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3f(location, v[0], v[1], v[2])
    }`,
    vec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4f(location, v[0], v[1], v[2], v[3]);
    }`,
    int: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    ivec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
    ivec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
    ivec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
    uint: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1ui(location, v);
    }`,
    uvec2: `
    if (cv[0] !== v[0] || cv[1] !== v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2ui(location, v[0], v[1]);
    }`,
    uvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3ui(location, v[0], v[1], v[2]);
    }`,
    uvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
    }`,
    bool: `
    if (cv !== v)
    {
        cu.value = v;
        gl.uniform1i(location, v);
    }`,
    bvec2: `
    if (cv[0] != v[0] || cv[1] != v[1])
    {
        cv[0] = v[0];
        cv[1] = v[1];

        gl.uniform2i(location, v[0], v[1]);
    }`,
    bvec3: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];

        gl.uniform3i(location, v[0], v[1], v[2]);
    }`,
    bvec4: `
    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
    {
        cv[0] = v[0];
        cv[1] = v[1];
        cv[2] = v[2];
        cv[3] = v[3];

        gl.uniform4i(location, v[0], v[1], v[2], v[3]);
    }`,
    mat2: "gl.uniformMatrix2fv(location, false, v)",
    mat3: "gl.uniformMatrix3fv(location, false, v)",
    mat4: "gl.uniformMatrix4fv(location, false, v)",
    sampler2D: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    samplerCube: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`,
    sampler2DArray: `
    if (cv !== v)
    {
        cu.value = v;

        gl.uniform1i(location, v);
    }`
}, $fa25b17d2653b481$var$GLSL_TO_ARRAY_SETTERS = {
    float: "gl.uniform1fv(location, v)",
    vec2: "gl.uniform2fv(location, v)",
    vec3: "gl.uniform3fv(location, v)",
    vec4: "gl.uniform4fv(location, v)",
    mat4: "gl.uniformMatrix4fv(location, false, v)",
    mat3: "gl.uniformMatrix3fv(location, false, v)",
    mat2: "gl.uniformMatrix2fv(location, false, v)",
    int: "gl.uniform1iv(location, v)",
    ivec2: "gl.uniform2iv(location, v)",
    ivec3: "gl.uniform3iv(location, v)",
    ivec4: "gl.uniform4iv(location, v)",
    uint: "gl.uniform1uiv(location, v)",
    uvec2: "gl.uniform2uiv(location, v)",
    uvec3: "gl.uniform3uiv(location, v)",
    uvec4: "gl.uniform4uiv(location, v)",
    bool: "gl.uniform1iv(location, v)",
    bvec2: "gl.uniform2iv(location, v)",
    bvec3: "gl.uniform3iv(location, v)",
    bvec4: "gl.uniform4iv(location, v)",
    sampler2D: "gl.uniform1iv(location, v)",
    samplerCube: "gl.uniform1iv(location, v)",
    sampler2DArray: "gl.uniform1iv(location, v)"
};
function $fa25b17d2653b481$export$20c95d1c2d5a6828(group, uniformData) {
    const funcFragments = [
        `
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
    `
    ];
    for(const i in group.uniforms){
        const data = uniformData[i];
        if (!data) {
            group.uniforms[i]?.group === !0 && (group.uniforms[i].ubo ? funcFragments.push(`
                        renderer.shader.syncUniformBufferGroup(uv.${i}, '${i}');
                    `) : funcFragments.push(`
                        renderer.shader.syncUniformGroup(uv.${i}, syncData);
                    `));
            continue;
        }
        const uniform = group.uniforms[i];
        let parsed = !1;
        for(let j = 0; j < (0, $d0Qk2.uniformParsers).length; j++)if ((0, $d0Qk2.uniformParsers)[j].test(data, uniform)) {
            funcFragments.push((0, $d0Qk2.uniformParsers)[j].code(i, uniform)), parsed = !0;
            break;
        }
        if (!parsed) {
            const template = (data.size === 1 && !data.isArray ? $fa25b17d2653b481$var$GLSL_TO_SINGLE_SETTERS_CACHED : $fa25b17d2653b481$var$GLSL_TO_ARRAY_SETTERS)[data.type].replace("location", `ud["${i}"].location`);
            funcFragments.push(`
            cu = ud["${i}"];
            cv = cu.value;
            v = uv["${i}"];
            ${template};`);
        }
    }
    return new Function("ud", "uv", "renderer", "syncData", funcFragments.join(`
`));
}

});
parcelRegister("d0Qk2", function(module, exports) {

$parcel$export(module.exports, "uniformParsers", () => $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2);
const $fc2fc8e4df7776dd$export$cf9f41a7e506e2d2 = [
    // a float cache layer
    {
        test: (data)=>data.type === "float" && data.size === 1 && !data.isArray,
        code: (name)=>`
            if(uv["${name}"] !== ud["${name}"].value)
            {
                ud["${name}"].value = uv["${name}"]
                gl.uniform1f(ud["${name}"].location, uv["${name}"])
            }
            `
    },
    // handling samplers
    {
        test: (data, uniform)=>// eslint-disable-next-line max-len,no-eq-null,eqeqeq
            (data.type === "sampler2D" || data.type === "samplerCube" || data.type === "sampler2DArray") && data.size === 1 && !data.isArray && (uniform == null || uniform.castToBaseTexture !== void 0),
        code: (name)=>`t = syncData.textureCount++;

            renderer.texture.bind(uv["${name}"], t);

            if(ud["${name}"].value !== t)
            {
                ud["${name}"].value = t;
                gl.uniform1i(ud["${name}"].location, t);
; // eslint-disable-line max-len
            }`
    },
    // uploading pixi matrix object to mat3
    {
        test: (data, uniform)=>data.type === "mat3" && data.size === 1 && !data.isArray && uniform.a !== void 0,
        code: (name)=>// TODO and some smart caching dirty ids here!
            `
            gl.uniformMatrix3fv(ud["${name}"].location, false, uv["${name}"].toArray(true));
            `,
        codeUbo: (name)=>`
                var ${name}_matrix = uv.${name}.toArray(true);

                data[offset] = ${name}_matrix[0];
                data[offset+1] = ${name}_matrix[1];
                data[offset+2] = ${name}_matrix[2];
        
                data[offset + 4] = ${name}_matrix[3];
                data[offset + 5] = ${name}_matrix[4];
                data[offset + 6] = ${name}_matrix[5];
        
                data[offset + 8] = ${name}_matrix[6];
                data[offset + 9] = ${name}_matrix[7];
                data[offset + 10] = ${name}_matrix[8];
            `
    },
    // uploading a pixi point as a vec2 with caching layer
    {
        test: (data, uniform)=>data.type === "vec2" && data.size === 1 && !data.isArray && uniform.x !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.x || cv[1] !== v.y)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    gl.uniform2f(ud["${name}"].location, v.x, v.y);
                }`,
        codeUbo: (name)=>`
                v = uv.${name};

                data[offset] = v.x;
                data[offset+1] = v.y;
            `
    },
    // caching layer for a vec2
    {
        test: (data)=>data.type === "vec2" && data.size === 1 && !data.isArray,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v[0] || cv[1] !== v[1])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    gl.uniform2f(ud["${name}"].location, v[0], v[1]);
                }
            `
    },
    // upload a pixi rectangle as a vec4 with caching layer
    {
        test: (data, uniform)=>data.type === "vec4" && data.size === 1 && !data.isArray && uniform.width !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)
                {
                    cv[0] = v.x;
                    cv[1] = v.y;
                    cv[2] = v.width;
                    cv[3] = v.height;
                    gl.uniform4f(ud["${name}"].location, v.x, v.y, v.width, v.height)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.x;
                    data[offset+1] = v.y;
                    data[offset+2] = v.width;
                    data[offset+3] = v.height;
                `
    },
    // upload a pixi color as vec4 with caching layer
    {
        test: (data, uniform)=>data.type === "vec4" && data.size === 1 && !data.isArray && uniform.red !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
                    cv[3] = v.alpha;
                    gl.uniform4f(ud["${name}"].location, v.red, v.green, v.blue, v.alpha)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                    data[offset+3] = v.alpha;
                `
    },
    // upload a pixi color as a vec3 with caching layer
    {
        test: (data, uniform)=>data.type === "vec3" && data.size === 1 && !data.isArray && uniform.red !== void 0,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.a)
                {
                    cv[0] = v.red;
                    cv[1] = v.green;
                    cv[2] = v.blue;
    
                    gl.uniform3f(ud["${name}"].location, v.red, v.green, v.blue)
                }`,
        codeUbo: (name)=>`
                    v = uv.${name};

                    data[offset] = v.red;
                    data[offset+1] = v.green;
                    data[offset+2] = v.blue;
                `
    },
    // a caching layer for vec4 uploading
    {
        test: (data)=>data.type === "vec4" && data.size === 1 && !data.isArray,
        code: (name)=>`
                cv = ud["${name}"].value;
                v = uv["${name}"];

                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])
                {
                    cv[0] = v[0];
                    cv[1] = v[1];
                    cv[2] = v[2];
                    cv[3] = v[3];

                    gl.uniform4f(ud["${name}"].location, v[0], v[1], v[2], v[3])
                }`
    }
];

});


parcelRegister("ezyG3", function(module, exports) {

$parcel$export(module.exports, "getMaxFragmentPrecision", () => $d666f932fb92fed4$export$428c38e64838140);

var $lmRm8 = parcelRequire("lmRm8");

var $7W4Qd = parcelRequire("7W4Qd");
let $d666f932fb92fed4$var$maxFragmentPrecision;
function $d666f932fb92fed4$export$428c38e64838140() {
    if (!$d666f932fb92fed4$var$maxFragmentPrecision) {
        $d666f932fb92fed4$var$maxFragmentPrecision = (0, $lmRm8.PRECISION).MEDIUM;
        const gl = (0, $7W4Qd.getTestContext)();
        if (gl && gl.getShaderPrecisionFormat) {
            const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
            shaderFragment && ($d666f932fb92fed4$var$maxFragmentPrecision = shaderFragment.precision ? (0, $lmRm8.PRECISION).HIGH : (0, $lmRm8.PRECISION).MEDIUM);
        }
    }
    return $d666f932fb92fed4$var$maxFragmentPrecision;
}

});
parcelRegister("7W4Qd", function(module, exports) {

$parcel$export(module.exports, "getTestContext", () => $1093824982d9e538$export$f034b2d55f8df08b);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
const $1093824982d9e538$var$unknownContext = {};
let $1093824982d9e538$var$context = $1093824982d9e538$var$unknownContext;
function $1093824982d9e538$export$f034b2d55f8df08b() {
    if ($1093824982d9e538$var$context === $1093824982d9e538$var$unknownContext || $1093824982d9e538$var$context?.isContextLost()) {
        const canvas = (0, $16eqM.settings).ADAPTER.createCanvas();
        let gl;
        (0, $16eqM.settings).PREFER_ENV >= (0, $lmRm8.ENV).WEBGL2 && (gl = canvas.getContext("webgl2", {})), gl || (gl = canvas.getContext("webgl", {}) || canvas.getContext("experimental-webgl", {}), gl ? gl.getExtension("WEBGL_draw_buffers") : gl = null), $1093824982d9e538$var$context = gl;
    }
    return $1093824982d9e538$var$context;
}

});


parcelRegister("iqofN", function(module, exports) {

$parcel$export(module.exports, "logProgramError", () => $393c6798ea1ed6a4$export$4b35d6c62dc992b0);
function $393c6798ea1ed6a4$var$logPrettyShaderError(gl, shader) {
    const shaderSrc = gl.getShaderSource(shader).split(`
`).map((line, index)=>`${index}: ${line}`), shaderLog = gl.getShaderInfoLog(shader), splitShader = shaderLog.split(`
`), dedupe = {}, lineNumbers = splitShader.map((line)=>parseFloat(line.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((n)=>n && !dedupe[n] ? (dedupe[n] = !0, !0) : !1), logArgs = [
        ""
    ];
    lineNumbers.forEach((number)=>{
        shaderSrc[number - 1] = `%c${shaderSrc[number - 1]}%c`, logArgs.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
    });
    const fragmentSourceToLog = shaderSrc.join(`
`);
    logArgs[0] = fragmentSourceToLog, console.error(shaderLog), console.groupCollapsed("click to view full shader code"), console.warn(...logArgs), console.groupEnd();
}
function $393c6798ea1ed6a4$export$4b35d6c62dc992b0(gl, program, vertexShader, fragmentShader) {
    gl.getProgramParameter(program, gl.LINK_STATUS) || (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) || $393c6798ea1ed6a4$var$logPrettyShaderError(gl, vertexShader), gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) || $393c6798ea1ed6a4$var$logPrettyShaderError(gl, fragmentShader), console.error("PixiJS Error: Could not initialize shader."), gl.getProgramInfoLog(program) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", gl.getProgramInfoLog(program)));
}

});

parcelRegister("kwXhP", function(module, exports) {

$parcel$export(module.exports, "mapSize", () => $6ce3ebb6f0d94afe$export$50ee69a11aa2abdb);
const $6ce3ebb6f0d94afe$var$GLSL_TO_SIZE = {
    float: 1,
    vec2: 2,
    vec3: 3,
    vec4: 4,
    int: 1,
    ivec2: 2,
    ivec3: 3,
    ivec4: 4,
    uint: 1,
    uvec2: 2,
    uvec3: 3,
    uvec4: 4,
    bool: 1,
    bvec2: 2,
    bvec3: 3,
    bvec4: 4,
    mat2: 4,
    mat3: 9,
    mat4: 16,
    sampler2D: 1
};
function $6ce3ebb6f0d94afe$export$50ee69a11aa2abdb(type) {
    return $6ce3ebb6f0d94afe$var$GLSL_TO_SIZE[type];
}

});

parcelRegister("f97nY", function(module, exports) {

$parcel$export(module.exports, "mapType", () => $d1f0673787d44f4c$export$4de3a94418d86ca7);
let $d1f0673787d44f4c$var$GL_TABLE = null;
const $d1f0673787d44f4c$var$GL_TO_GLSL_TYPES = {
    FLOAT: "float",
    FLOAT_VEC2: "vec2",
    FLOAT_VEC3: "vec3",
    FLOAT_VEC4: "vec4",
    INT: "int",
    INT_VEC2: "ivec2",
    INT_VEC3: "ivec3",
    INT_VEC4: "ivec4",
    UNSIGNED_INT: "uint",
    UNSIGNED_INT_VEC2: "uvec2",
    UNSIGNED_INT_VEC3: "uvec3",
    UNSIGNED_INT_VEC4: "uvec4",
    BOOL: "bool",
    BOOL_VEC2: "bvec2",
    BOOL_VEC3: "bvec3",
    BOOL_VEC4: "bvec4",
    FLOAT_MAT2: "mat2",
    FLOAT_MAT3: "mat3",
    FLOAT_MAT4: "mat4",
    SAMPLER_2D: "sampler2D",
    INT_SAMPLER_2D: "sampler2D",
    UNSIGNED_INT_SAMPLER_2D: "sampler2D",
    SAMPLER_CUBE: "samplerCube",
    INT_SAMPLER_CUBE: "samplerCube",
    UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
    SAMPLER_2D_ARRAY: "sampler2DArray",
    INT_SAMPLER_2D_ARRAY: "sampler2DArray",
    UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
};
function $d1f0673787d44f4c$export$4de3a94418d86ca7(gl, type) {
    if (!$d1f0673787d44f4c$var$GL_TABLE) {
        const typeNames = Object.keys($d1f0673787d44f4c$var$GL_TO_GLSL_TYPES);
        $d1f0673787d44f4c$var$GL_TABLE = {};
        for(let i = 0; i < typeNames.length; ++i){
            const tn = typeNames[i];
            $d1f0673787d44f4c$var$GL_TABLE[gl[tn]] = $d1f0673787d44f4c$var$GL_TO_GLSL_TYPES[tn];
        }
    }
    return $d1f0673787d44f4c$var$GL_TABLE[type];
}

});

parcelRegister("dPwsf", function(module, exports) {

$parcel$export(module.exports, "setPrecision", () => $7b6ee34bdcbe09f4$export$c4b85a3b3361e135);

var $lmRm8 = parcelRequire("lmRm8");
function $7b6ee34bdcbe09f4$export$c4b85a3b3361e135(src, requestedPrecision, maxSupportedPrecision) {
    if (src.substring(0, 9) !== "precision") {
        let precision = requestedPrecision;
        return requestedPrecision === (0, $lmRm8.PRECISION).HIGH && maxSupportedPrecision !== (0, $lmRm8.PRECISION).HIGH && (precision = (0, $lmRm8.PRECISION).MEDIUM), `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== (0, $lmRm8.PRECISION).HIGH && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}

});

parcelRegister("5MhZE", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $62249037d7b2f875$export$70c0711f29adc5cf);
let $62249037d7b2f875$var$unsafeEval;
function $62249037d7b2f875$export$70c0711f29adc5cf() {
    if (typeof $62249037d7b2f875$var$unsafeEval == "boolean") return $62249037d7b2f875$var$unsafeEval;
    try {
        $62249037d7b2f875$var$unsafeEval = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({
            a: "b"
        }, "a", "b") === !0;
    } catch  {
        $62249037d7b2f875$var$unsafeEval = !1;
    }
    return $62249037d7b2f875$var$unsafeEval;
}

});



parcelRegister("2cKpP", function(module, exports) {

$parcel$export(module.exports, "Shader", () => $b78f65cdcfbb9b3c$export$462bb059fed9d9e5);
parcelRequire("hWIIU");
var $aDHVi = parcelRequire("aDHVi");

var $k7n3P = parcelRequire("k7n3P");

var $BpNwR = parcelRequire("BpNwR");
class $b78f65cdcfbb9b3c$export$462bb059fed9d9e5 {
    /**
   * @param program - The program the shader will use.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */ constructor(program, uniforms){
        this.uniformBindCount = 0, this.program = program, uniforms ? uniforms instanceof (0, $BpNwR.UniformGroup) ? this.uniformGroup = uniforms : this.uniformGroup = new (0, $BpNwR.UniformGroup)(uniforms) : this.uniformGroup = new (0, $BpNwR.UniformGroup)({}), this.disposeRunner = new (0, $aDHVi.Runner)("disposeShader");
    }
    // TODO move to shader system..
    checkUniformExists(name, group) {
        if (group.uniforms[name]) return !0;
        for(const i in group.uniforms){
            const uniform = group.uniforms[i];
            if (uniform.group === !0 && this.checkUniformExists(name, uniform)) return !0;
        }
        return !1;
    }
    destroy() {
        this.uniformGroup = null, this.disposeRunner.emit(this), this.disposeRunner.destroy();
    }
    /**
   * Shader uniform values, shortcut for `uniformGroup.uniforms`.
   * @readonly
   */ get uniforms() {
        return this.uniformGroup.uniforms;
    }
    /**
   * A short hand function to create a shader based of a vertex and fragment shader.
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   * @returns A shiny new PixiJS shader!
   */ static from(vertexSrc, fragmentSrc, uniforms) {
        const program = (0, $k7n3P.Program).from(vertexSrc, fragmentSrc);
        return new $b78f65cdcfbb9b3c$export$462bb059fed9d9e5(program, uniforms);
    }
}

});
parcelRegister("BpNwR", function(module, exports) {

$parcel$export(module.exports, "UniformGroup", () => $d21ea31dd94e9628$export$6601a7a2dcf79bf5);

var $lmRm8 = parcelRequire("lmRm8");

var $3u4Xc = parcelRequire("3u4Xc");
let $d21ea31dd94e9628$var$UID = 0;
class $d21ea31dd94e9628$export$6601a7a2dcf79bf5 {
    /**
   * @param {object | Buffer} [uniforms] - Custom uniforms to use to augment the built-in ones. Or a pixi buffer.
   * @param isStatic - Uniforms wont be changed after creation.
   * @param isUbo - If true, will treat this uniform group as a uniform buffer object.
   */ constructor(uniforms, isStatic, isUbo){
        this.group = !0, this.syncUniforms = {}, this.dirtyId = 0, this.id = $d21ea31dd94e9628$var$UID++, this.static = !!isStatic, this.ubo = !!isUbo, uniforms instanceof (0, $3u4Xc.Buffer) ? (this.buffer = uniforms, this.buffer.type = (0, $lmRm8.BUFFER_TYPE).UNIFORM_BUFFER, this.autoManage = !1, this.ubo = !0) : (this.uniforms = uniforms, this.ubo && (this.buffer = new (0, $3u4Xc.Buffer)(new Float32Array(1)), this.buffer.type = (0, $lmRm8.BUFFER_TYPE).UNIFORM_BUFFER, this.autoManage = !0));
    }
    update() {
        this.dirtyId++, !this.autoManage && this.buffer && this.buffer.update();
    }
    add(name, uniforms, _static) {
        if (!this.ubo) this.uniforms[name] = new $d21ea31dd94e9628$export$6601a7a2dcf79bf5(uniforms, _static);
        else throw new Error("[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them");
    }
    static from(uniforms, _static, _ubo) {
        return new $d21ea31dd94e9628$export$6601a7a2dcf79bf5(uniforms, _static, _ubo);
    }
    /**
   * A short hand function for creating a static UBO UniformGroup.
   * @param uniforms - the ubo item
   * @param _static - should this be updated each time it is used? defaults to true here!
   */ static uboFrom(uniforms, _static) {
        return new $d21ea31dd94e9628$export$6601a7a2dcf79bf5(uniforms, _static ?? !0, !0);
    }
}

});



parcelRegister("ajAp7", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $f453ad575c2dc61d$export$aa760e0febf1a758);
class $f453ad575c2dc61d$export$aa760e0febf1a758 {
    constructor(){
        this.elements = [], this.ids = [], this.count = 0;
    }
    clear() {
        for(let i = 0; i < this.count; i++)this.elements[i] = null;
        this.count = 0;
    }
}

});

parcelRegister("dSjmj", function(module, exports) {

$parcel$export(module.exports, "canUploadSameBuffer", () => $796efb3af7ab4d6c$export$b839fdc6a85f84de);
parcelRequire("fVntm");
var $lQgZZ = parcelRequire("lQgZZ");
function $796efb3af7ab4d6c$export$b839fdc6a85f84de() {
    return !(0, $lQgZZ.isMobile).apple.device;
}

});

parcelRegister("1EfD8", function(module, exports) {

$parcel$export(module.exports, "maxRecommendedTextures", () => $8a6b3c42f69f7e66$export$d7a652ff592da4b4);
parcelRequire("fVntm");
var $lQgZZ = parcelRequire("lQgZZ");
var $16eqM = parcelRequire("16eqM");
function $8a6b3c42f69f7e66$export$d7a652ff592da4b4(max) {
    let allowMax = !0;
    const navigator = (0, $16eqM.settings).ADAPTER.getNavigator();
    if ((0, $lQgZZ.isMobile).tablet || (0, $lQgZZ.isMobile).phone) {
        if ((0, $lQgZZ.isMobile).apple.device) {
            const match = navigator.userAgent.match(/OS (\d+)_(\d+)?/);
            match && parseInt(match[1], 10) < 11 && (allowMax = !1);
        }
        if ((0, $lQgZZ.isMobile).android.device) {
            const match = navigator.userAgent.match(/Android\s([0-9.]*)/);
            match && parseInt(match[1], 10) < 7 && (allowMax = !1);
        }
    }
    return allowMax ? max : 4;
}

});

parcelRegister("hDOsC", function(module, exports) {

$parcel$export(module.exports, "ObjectRenderer", () => $ec9c34a32f35795b$export$ca67b0b0fa758253);
class $ec9c34a32f35795b$export$ca67b0b0fa758253 {
    /**
   * @param renderer - The renderer this manager works for.
   */ constructor(renderer){
        this.renderer = renderer;
    }
    /** Stub method that should be used to empty the current batch by rendering objects now. */ flush() {}
    /** Generic destruction method that frees all resources. This should be called by subclasses. */ destroy() {
        this.renderer = null;
    }
    /**
   * Stub method that initializes any state required before
   * rendering starts. It is different from the `prerender`
   * signal, which occurs every frame, in that it is called
   * whenever an object requests _this_ renderer specifically.
   */ start() {}
    /** Stops the renderer. It should free up any state and become dormant. */ stop() {
        this.flush();
    }
    /**
   * Keeps the object to render. It doesn't have to be
   * rendered immediately.
   * @param {PIXI.DisplayObject} _object - The object to render.
   */ render(_object) {}
}

});

parcelRegister("cH3eh", function(module, exports) {

$parcel$export(module.exports, "default", () => $67d6815abe3a6070$export$2e2bcd8739ae039);
var $67d6815abe3a6070$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;
uniform sampler2D uSamplers[%count%];

void main(void){
    vec4 color;
    %forloop%
    gl_FragColor = color * vColor;
}
`;

});

parcelRegister("jhN2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $eff7e273d0c65ece$export$2e2bcd8739ae039);
var $eff7e273d0c65ece$export$2e2bcd8739ae039 = `precision highp float;
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;
attribute float aTextureId;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform vec4 tint;

varying vec2 vTextureCoord;
varying vec4 vColor;
varying float vTextureId;

void main(void){
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vTextureId = aTextureId;
    vColor = aColor * tint;
}
`;

});


parcelRegister("3x7iq", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $fa5f1d0edfe7960b$export$ec91da630f36d5ea);

var $lmRm8 = parcelRequire("lmRm8");

var $k7n3P = parcelRequire("k7n3P");

var $2cKpP = parcelRequire("2cKpP");

var $bUqaG = parcelRequire("bUqaG");

var $i766Z = parcelRequire("i766Z");

var $bKyeo = parcelRequire("bKyeo");
const $fa5f1d0edfe7960b$var$_Filter = class _Filter2 extends (0, $2cKpP.Shader) {
    /**
   * @param vertexSrc - The source of the vertex shader.
   * @param fragmentSrc - The source of the fragment shader.
   * @param uniforms - Custom uniforms to use to augment the built-in ones.
   */ constructor(vertexSrc, fragmentSrc, uniforms){
        const program = (0, $k7n3P.Program).from(vertexSrc || _Filter2.defaultVertexSrc, fragmentSrc || _Filter2.defaultFragmentSrc);
        super(program, uniforms), this.padding = 0, this.resolution = _Filter2.defaultResolution, this.multisample = _Filter2.defaultMultisample, this.enabled = !0, this.autoFit = !0, this.state = new (0, $bUqaG.State)();
    }
    /**
   * Applies the filter
   * @param {PIXI.FilterSystem} filterManager - The renderer to retrieve the filter from
   * @param {PIXI.RenderTexture} input - The input render target.
   * @param {PIXI.RenderTexture} output - The target to output to.
   * @param {PIXI.CLEAR_MODES} [clearMode] - Should the output be cleared before rendering to it.
   * @param {object} [_currentState] - It's current state of filter.
   *        There are some useful properties in the currentState :
   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
   */ apply(filterManager, input, output, clearMode, _currentState) {
        filterManager.applyFilter(this, input, output, clearMode);
    }
    /**
   * Sets the blend mode of the filter.
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this.state.blendMode;
    }
    set blendMode(value) {
        this.state.blendMode = value;
    }
    /**
   * The resolution of the filter. Setting this to be lower will lower the quality but
   * increase the performance of the filter.
   * If set to `null` or `0`, the resolution of the current render target is used.
   * @default PIXI.Filter.defaultResolution
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._resolution = value;
    }
    /**
   * The default vertex shader source
   * @readonly
   */ static get defaultVertexSrc() {
        return 0, $bKyeo.default;
    }
    /**
   * The default fragment shader source
   * @readonly
   */ static get defaultFragmentSrc() {
        return 0, $i766Z.default;
    }
};
$fa5f1d0edfe7960b$var$_Filter.defaultResolution = 1, /**
* Default filter samples for any filter.
* @static
* @type {PIXI.MSAA_QUALITY|null}
* @default PIXI.MSAA_QUALITY.NONE
*/ $fa5f1d0edfe7960b$var$_Filter.defaultMultisample = (0, $lmRm8.MSAA_QUALITY).NONE;
let $fa5f1d0edfe7960b$export$ec91da630f36d5ea = $fa5f1d0edfe7960b$var$_Filter;

});
parcelRegister("i766Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $d924d288fdeb2e12$export$2e2bcd8739ae039);
var $d924d288fdeb2e12$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
   gl_FragColor = texture2D(uSampler, vTextureCoord);
}
`;

});

parcelRegister("bKyeo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b91b4ae5b49abfd$export$2e2bcd8739ae039);
var $0b91b4ae5b49abfd$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;

});


parcelRegister("dqI8m", function(module, exports) {

var $h9VM5 = parcelRequire("h9VM5");

var $70Dpm = parcelRequire("70Dpm");

var $9LLGA = parcelRequire("9LLGA");

var $bXe1x = parcelRequire("bXe1x");

var $8ermx = parcelRequire("8ermx");

var $1AXaI = parcelRequire("1AXaI");

var $1GdhN = parcelRequire("1GdhN");

var $jLQZ8 = parcelRequire("jLQZ8");

var $ihQE2 = parcelRequire("ihQE2");

var $Hj4cm = parcelRequire("Hj4cm");

var $awCJH = parcelRequire("awCJH");

var $8Faf6 = parcelRequire("8Faf6");

var $jxrL2 = parcelRequire("jxrL2");

var $1JxSm = parcelRequire("1JxSm");

var $1rTbL = parcelRequire("1rTbL");

var $jIxy5 = parcelRequire("jIxy5");

var $6BfGe = parcelRequire("6BfGe");

var $iDGF3 = parcelRequire("iDGF3");

var $dq44e = parcelRequire("dq44e");

var $idUGs = parcelRequire("idUGs");

var $h5Bby = parcelRequire("h5Bby");

});
parcelRegister("h9VM5", function(module, exports) {

$parcel$export(module.exports, "BackgroundSystem", () => $7443fcf12643cbe1$export$c69cd65c8827ac23);
parcelRequire("8HZMw");
var $1PNws = parcelRequire("1PNws");

var $5RvHb = parcelRequire("5RvHb");
class $7443fcf12643cbe1$export$c69cd65c8827ac23 {
    constructor(){
        this.clearBeforeRender = !0, this._backgroundColor = new (0, $1PNws.Color)(0), this.alpha = 1;
    }
    /**
   * initiates the background system
   * @param {PIXI.IRendererOptions} options - the options for the background colors
   */ init(options) {
        this.clearBeforeRender = options.clearBeforeRender;
        const { backgroundColor: backgroundColor, background: background, backgroundAlpha: backgroundAlpha } = options, color = background ?? backgroundColor;
        color !== void 0 && (this.color = color), this.alpha = backgroundAlpha;
    }
    /**
   * The background color to fill if not transparent.
   * @member {PIXI.ColorSource}
   */ get color() {
        return this._backgroundColor.value;
    }
    set color(value) {
        this._backgroundColor.setValue(value);
    }
    /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   */ get alpha() {
        return this._backgroundColor.alpha;
    }
    set alpha(value) {
        this._backgroundColor.setAlpha(value);
    }
    /** The background color object. */ get backgroundColor() {
        return this._backgroundColor;
    }
    destroy() {}
}
$7443fcf12643cbe1$export$c69cd65c8827ac23.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.backgroundAlpha}
   * @default 1
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ backgroundAlpha: 1,
    /**
   * {@link PIXI.IRendererOptions.backgroundColor}
   * @default 0x000000
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ backgroundColor: 0,
    /**
   * {@link PIXI.IRendererOptions.clearBeforeRender}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ clearBeforeRender: !0
}, /** @ignore */ $7443fcf12643cbe1$export$c69cd65c8827ac23.extension = {
    type: [
        (0, $5RvHb.ExtensionType).RendererSystem,
        (0, $5RvHb.ExtensionType).CanvasRendererSystem
    ],
    name: "background"
};
(0, $5RvHb.extensions).add($7443fcf12643cbe1$export$c69cd65c8827ac23);

});

parcelRegister("70Dpm", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");

var $hDOsC = parcelRequire("hDOsC");
class $b80e39c4131cc29b$export$beb481275b7bcccc {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.emptyRenderer = new (0, $hDOsC.ObjectRenderer)(renderer), this.currentRenderer = this.emptyRenderer;
    }
    /**
   * Changes the current renderer to the one given in parameter
   * @param objectRenderer - The object renderer to use.
   */ setObjectRenderer(objectRenderer) {
        this.currentRenderer !== objectRenderer && (this.currentRenderer.stop(), this.currentRenderer = objectRenderer, this.currentRenderer.start());
    }
    /**
   * This should be called if you wish to do some custom rendering
   * It will basically render anything that may be batched up such as sprites
   */ flush() {
        this.setObjectRenderer(this.emptyRenderer);
    }
    /** Reset the system to an empty renderer */ reset() {
        this.setObjectRenderer(this.emptyRenderer);
    }
    /**
   * Handy function for batch renderers: copies bound textures in first maxTextures locations to array
   * sets actual _batchLocation for them
   * @param arr - arr copy destination
   * @param maxTextures - number of copied elements
   */ copyBoundTextures(arr, maxTextures) {
        const { boundTextures: boundTextures } = this.renderer.texture;
        for(let i = maxTextures - 1; i >= 0; --i)arr[i] = boundTextures[i] || null, arr[i] && (arr[i]._batchLocation = i);
    }
    /**
   * Assigns batch locations to textures in array based on boundTextures state.
   * All textures in texArray should have `_batchEnabled = _batchId`,
   * and their count should be less than `maxTextures`.
   * @param texArray - textures to bound
   * @param boundTextures - current state of bound textures
   * @param batchId - marker for _batchEnabled param of textures in texArray
   * @param maxTextures - number of texture locations to manipulate
   */ boundArray(texArray, boundTextures, batchId, maxTextures) {
        const { elements: elements, ids: ids, count: count } = texArray;
        let j = 0;
        for(let i = 0; i < count; i++){
            const tex = elements[i], loc = tex._batchLocation;
            if (loc >= 0 && loc < maxTextures && boundTextures[loc] === tex) {
                ids[i] = loc;
                continue;
            }
            for(; j < maxTextures;){
                const bound = boundTextures[j];
                if (bound && bound._batchEnabled === batchId && bound._batchLocation === j) {
                    j++;
                    continue;
                }
                ids[i] = j, tex._batchLocation = j, boundTextures[j] = tex;
                break;
            }
        }
    }
    /**
   * @ignore
   */ destroy() {
        this.renderer = null;
    }
}
$b80e39c4131cc29b$export$beb481275b7bcccc.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "batch"
};
(0, $5RvHb.extensions).add($b80e39c4131cc29b$export$beb481275b7bcccc);

});

parcelRegister("9LLGA", function(module, exports) {

$parcel$export(module.exports, "ContextSystem", () => $2d30752d87b0cf51$export$fedaac80f6f9518c);

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
let $2d30752d87b0cf51$var$CONTEXT_UID_COUNTER = 0;
class $2d30752d87b0cf51$export$fedaac80f6f9518c {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.webGLVersion = 1, this.extensions = {}, this.supports = {
            uint32Indices: !1
        }, this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
    }
    /**
   * `true` if the context is lost
   * @readonly
   */ get isLost() {
        return !this.gl || this.gl.isContextLost();
    }
    /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */ contextChange(gl) {
        this.gl = gl, this.renderer.gl = gl, this.renderer.CONTEXT_UID = $2d30752d87b0cf51$var$CONTEXT_UID_COUNTER++;
    }
    init(options) {
        if (options.context) this.initFromContext(options.context);
        else {
            const alpha = this.renderer.background.alpha < 1, premultipliedAlpha = options.premultipliedAlpha;
            this.preserveDrawingBuffer = options.preserveDrawingBuffer, this.useContextAlpha = options.useContextAlpha, this.powerPreference = options.powerPreference, this.initFromOptions({
                alpha: alpha,
                premultipliedAlpha: premultipliedAlpha,
                antialias: options.antialias,
                stencil: !0,
                preserveDrawingBuffer: options.preserveDrawingBuffer,
                powerPreference: options.powerPreference
            });
        }
    }
    /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */ initFromContext(gl) {
        this.gl = gl, this.validateContext(gl), this.renderer.gl = gl, this.renderer.CONTEXT_UID = $2d30752d87b0cf51$var$CONTEXT_UID_COUNTER++, this.renderer.runners.contextChange.emit(gl);
        const view = this.renderer.view;
        view.addEventListener !== void 0 && (view.addEventListener("webglcontextlost", this.handleContextLost, !1), view.addEventListener("webglcontextrestored", this.handleContextRestored, !1));
    }
    /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param {object} options - context attributes
   */ initFromOptions(options) {
        const gl = this.createContext(this.renderer.view, options);
        this.initFromContext(gl);
    }
    /**
   * Helper class to create a WebGL Context
   * @param canvas - the canvas element that we will get the context from
   * @param options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */ createContext(canvas, options) {
        let gl;
        if ((0, $16eqM.settings).PREFER_ENV >= (0, $lmRm8.ENV).WEBGL2 && (gl = canvas.getContext("webgl2", options)), gl) this.webGLVersion = 2;
        else if (this.webGLVersion = 1, gl = canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options), !gl) throw new Error("This browser does not support WebGL. Try using the canvas renderer");
        return this.gl = gl, this.getExtensions(), this.gl;
    }
    /** Auto-populate the {@link PIXI.ContextSystem.extensions extensions}. */ getExtensions() {
        const { gl: gl } = this, common = {
            loseContext: gl.getExtension("WEBGL_lose_context"),
            anisotropicFiltering: gl.getExtension("EXT_texture_filter_anisotropic"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            s3tc: gl.getExtension("WEBGL_compressed_texture_s3tc"),
            s3tc_sRGB: gl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
            // eslint-disable-line camelcase
            etc: gl.getExtension("WEBGL_compressed_texture_etc"),
            etc1: gl.getExtension("WEBGL_compressed_texture_etc1"),
            pvrtc: gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            atc: gl.getExtension("WEBGL_compressed_texture_atc"),
            astc: gl.getExtension("WEBGL_compressed_texture_astc"),
            bptc: gl.getExtension("EXT_texture_compression_bptc")
        };
        this.webGLVersion === 1 ? Object.assign(this.extensions, common, {
            drawBuffers: gl.getExtension("WEBGL_draw_buffers"),
            depthTexture: gl.getExtension("WEBGL_depth_texture"),
            vertexArrayObject: gl.getExtension("OES_vertex_array_object") || gl.getExtension("MOZ_OES_vertex_array_object") || gl.getExtension("WEBKIT_OES_vertex_array_object"),
            uint32ElementIndex: gl.getExtension("OES_element_index_uint"),
            // Floats and half-floats
            floatTexture: gl.getExtension("OES_texture_float"),
            floatTextureLinear: gl.getExtension("OES_texture_float_linear"),
            textureHalfFloat: gl.getExtension("OES_texture_half_float"),
            textureHalfFloatLinear: gl.getExtension("OES_texture_half_float_linear")
        }) : this.webGLVersion === 2 && Object.assign(this.extensions, common, {
            // Floats and half-floats
            colorBufferFloat: gl.getExtension("EXT_color_buffer_float")
        });
    }
    /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */ handleContextLost(event) {
        event.preventDefault(), setTimeout(()=>{
            this.gl.isContextLost() && this.extensions.loseContext && this.extensions.loseContext.restoreContext();
        }, 0);
    }
    /** Handles a restored webgl context. */ handleContextRestored() {
        this.renderer.runners.contextChange.emit(this.gl);
    }
    destroy() {
        const view = this.renderer.view;
        this.renderer = null, view.removeEventListener !== void 0 && (view.removeEventListener("webglcontextlost", this.handleContextLost), view.removeEventListener("webglcontextrestored", this.handleContextRestored)), this.gl.useProgram(null), this.extensions.loseContext && this.extensions.loseContext.loseContext();
    }
    /** Handle the post-render runner event. */ postrender() {
        this.renderer.objectRenderer.renderingToScreen && this.gl.flush();
    }
    /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */ validateContext(gl) {
        const attributes = gl.getContextAttributes(), isWebGl2 = "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext;
        isWebGl2 && (this.webGLVersion = 2), attributes && !attributes.stencil && console.warn("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
        const hasuint32 = isWebGl2 || !!gl.getExtension("OES_element_index_uint");
        this.supports.uint32Indices = hasuint32, hasuint32 || console.warn("Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly");
    }
}
$2d30752d87b0cf51$export$fedaac80f6f9518c.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.context}
   * @default null
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ context: null,
    /**
   * {@link PIXI.IRendererOptions.antialias}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ antialias: !1,
    /**
   * {@link PIXI.IRendererOptions.premultipliedAlpha}
   * @default true
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ premultipliedAlpha: !0,
    /**
   * {@link PIXI.IRendererOptions.preserveDrawingBuffer}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ preserveDrawingBuffer: !1,
    /**
   * {@link PIXI.IRendererOptions.powerPreference}
   * @default default
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ powerPreference: "default"
}, /** @ignore */ $2d30752d87b0cf51$export$fedaac80f6f9518c.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "context"
};
(0, $5RvHb.extensions).add($2d30752d87b0cf51$export$fedaac80f6f9518c);

});

parcelRegister("bXe1x", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9fnly");
var $6wJoy = parcelRequire("6wJoy");
var $gnwPx = parcelRequire("gnwPx");
var $kZOeV = parcelRequire("kZOeV");

var $9V6Rf = parcelRequire("9V6Rf");

var $BpNwR = parcelRequire("BpNwR");

var $ivGFf = parcelRequire("ivGFf");

var $eVEcT = parcelRequire("eVEcT");

var $aQmAq = parcelRequire("aQmAq");
const $a52a4a592a10e8d1$var$tempPoints = [
    new (0, $gnwPx.Point)(),
    new (0, $gnwPx.Point)(),
    new (0, $gnwPx.Point)(),
    new (0, $gnwPx.Point)()
], $a52a4a592a10e8d1$var$tempMatrix = new (0, $6wJoy.Matrix)();
class $a52a4a592a10e8d1$export$e94225c0dfac29cf {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.defaultFilterStack = [
            {}
        ], this.texturePool = new (0, $9V6Rf.RenderTexturePool)(), this.statePool = [], this.quad = new (0, $ivGFf.Quad)(), this.quadUv = new (0, $eVEcT.QuadUv)(), this.tempRect = new (0, $kZOeV.Rectangle)(), this.activeState = {}, this.globalUniforms = new (0, $BpNwR.UniformGroup)({
            outputFrame: new (0, $kZOeV.Rectangle)(),
            inputSize: new Float32Array(4),
            inputPixel: new Float32Array(4),
            inputClamp: new Float32Array(4),
            resolution: 1,
            // legacy variables
            filterArea: new Float32Array(4),
            filterClamp: new Float32Array(4)
        }, !0), this.forceClear = !1, this.useMaxPadding = !1;
    }
    init() {
        this.texturePool.setScreenSize(this.renderer.view);
    }
    /**
   * Pushes a set of filters to be applied later to the system. This will redirect further rendering into an
   * input render-texture for the rest of the filtering pipeline.
   * @param {PIXI.DisplayObject} target - The target of the filter to render.
   * @param filters - The filters to apply.
   */ push(target, filters) {
        const renderer = this.renderer, filterStack = this.defaultFilterStack, state = this.statePool.pop() || new (0, $aQmAq.FilterState)(), renderTextureSystem = renderer.renderTexture;
        let currentResolution, currentMultisample;
        if (renderTextureSystem.current) {
            const renderTexture = renderTextureSystem.current;
            currentResolution = renderTexture.resolution, currentMultisample = renderTexture.multisample;
        } else currentResolution = renderer.resolution, currentMultisample = renderer.multisample;
        let resolution = filters[0].resolution || currentResolution, multisample = filters[0].multisample ?? currentMultisample, padding = filters[0].padding, autoFit = filters[0].autoFit, legacy = filters[0].legacy ?? !0;
        for(let i = 1; i < filters.length; i++){
            const filter = filters[i];
            resolution = Math.min(resolution, filter.resolution || currentResolution), multisample = Math.min(multisample, filter.multisample ?? currentMultisample), padding = this.useMaxPadding ? Math.max(padding, filter.padding) : padding + filter.padding, autoFit = autoFit && filter.autoFit, legacy = legacy || (filter.legacy ?? !0);
        }
        filterStack.length === 1 && (this.defaultFilterStack[0].renderTexture = renderTextureSystem.current), filterStack.push(state), state.resolution = resolution, state.multisample = multisample, state.legacy = legacy, state.target = target, state.sourceFrame.copyFrom(target.filterArea || target.getBounds(!0)), state.sourceFrame.pad(padding);
        const sourceFrameProjected = this.tempRect.copyFrom(renderTextureSystem.sourceFrame);
        renderer.projection.transform && this.transformAABB($a52a4a592a10e8d1$var$tempMatrix.copyFrom(renderer.projection.transform).invert(), sourceFrameProjected), autoFit ? (state.sourceFrame.fit(sourceFrameProjected), (state.sourceFrame.width <= 0 || state.sourceFrame.height <= 0) && (state.sourceFrame.width = 0, state.sourceFrame.height = 0)) : state.sourceFrame.intersects(sourceFrameProjected) || (state.sourceFrame.width = 0, state.sourceFrame.height = 0), this.roundFrame(state.sourceFrame, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform), state.renderTexture = this.getOptimalFilterTexture(state.sourceFrame.width, state.sourceFrame.height, resolution, multisample), state.filters = filters, state.destinationFrame.width = state.renderTexture.width, state.destinationFrame.height = state.renderTexture.height;
        const destinationFrame = this.tempRect;
        destinationFrame.x = 0, destinationFrame.y = 0, destinationFrame.width = state.sourceFrame.width, destinationFrame.height = state.sourceFrame.height, state.renderTexture.filterFrame = state.sourceFrame, state.bindingSourceFrame.copyFrom(renderTextureSystem.sourceFrame), state.bindingDestinationFrame.copyFrom(renderTextureSystem.destinationFrame), state.transform = renderer.projection.transform, renderer.projection.transform = null, renderTextureSystem.bind(state.renderTexture, state.sourceFrame, destinationFrame), renderer.framebuffer.clear(0, 0, 0, 0);
    }
    /** Pops off the filter and applies it. */ pop() {
        const filterStack = this.defaultFilterStack, state = filterStack.pop(), filters = state.filters;
        this.activeState = state;
        const globalUniforms = this.globalUniforms.uniforms;
        globalUniforms.outputFrame = state.sourceFrame, globalUniforms.resolution = state.resolution;
        const inputSize = globalUniforms.inputSize, inputPixel = globalUniforms.inputPixel, inputClamp = globalUniforms.inputClamp;
        if (inputSize[0] = state.destinationFrame.width, inputSize[1] = state.destinationFrame.height, inputSize[2] = 1 / inputSize[0], inputSize[3] = 1 / inputSize[1], inputPixel[0] = Math.round(inputSize[0] * state.resolution), inputPixel[1] = Math.round(inputSize[1] * state.resolution), inputPixel[2] = 1 / inputPixel[0], inputPixel[3] = 1 / inputPixel[1], inputClamp[0] = 0.5 * inputPixel[2], inputClamp[1] = 0.5 * inputPixel[3], inputClamp[2] = state.sourceFrame.width * inputSize[2] - 0.5 * inputPixel[2], inputClamp[3] = state.sourceFrame.height * inputSize[3] - 0.5 * inputPixel[3], state.legacy) {
            const filterArea = globalUniforms.filterArea;
            filterArea[0] = state.destinationFrame.width, filterArea[1] = state.destinationFrame.height, filterArea[2] = state.sourceFrame.x, filterArea[3] = state.sourceFrame.y, globalUniforms.filterClamp = globalUniforms.inputClamp;
        }
        this.globalUniforms.update();
        const lastState = filterStack[filterStack.length - 1];
        if (this.renderer.framebuffer.blit(), filters.length === 1) filters[0].apply(this, state.renderTexture, lastState.renderTexture, (0, $lmRm8.CLEAR_MODES).BLEND, state), this.returnFilterTexture(state.renderTexture);
        else {
            let flip = state.renderTexture, flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
            flop.filterFrame = flip.filterFrame;
            let i = 0;
            for(i = 0; i < filters.length - 1; ++i){
                i === 1 && state.multisample > 1 && (flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution), flop.filterFrame = flip.filterFrame), filters[i].apply(this, flip, flop, (0, $lmRm8.CLEAR_MODES).CLEAR, state);
                const t = flip;
                flip = flop, flop = t;
            }
            filters[i].apply(this, flip, lastState.renderTexture, (0, $lmRm8.CLEAR_MODES).BLEND, state), i > 1 && state.multisample > 1 && this.returnFilterTexture(state.renderTexture), this.returnFilterTexture(flip), this.returnFilterTexture(flop);
        }
        state.clear(), this.statePool.push(state);
    }
    /**
   * Binds a renderTexture with corresponding `filterFrame`, clears it if mode corresponds.
   * @param filterTexture - renderTexture to bind, should belong to filter pool or filter stack
   * @param clearMode - clearMode, by default its CLEAR/YES. See {@link PIXI.CLEAR_MODES}
   */ bindAndClear(filterTexture, clearMode = (0, $lmRm8.CLEAR_MODES).CLEAR) {
        const { renderTexture: renderTextureSystem, state: stateSystem } = this.renderer;
        if (filterTexture === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? this.renderer.projection.transform = this.activeState.transform : this.renderer.projection.transform = null, filterTexture?.filterFrame) {
            const destinationFrame = this.tempRect;
            destinationFrame.x = 0, destinationFrame.y = 0, destinationFrame.width = filterTexture.filterFrame.width, destinationFrame.height = filterTexture.filterFrame.height, renderTextureSystem.bind(filterTexture, filterTexture.filterFrame, destinationFrame);
        } else filterTexture !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture ? renderTextureSystem.bind(filterTexture) : this.renderer.renderTexture.bind(filterTexture, this.activeState.bindingSourceFrame, this.activeState.bindingDestinationFrame);
        const autoClear = stateSystem.stateId & 1 || this.forceClear;
        (clearMode === (0, $lmRm8.CLEAR_MODES).CLEAR || clearMode === (0, $lmRm8.CLEAR_MODES).BLIT && autoClear) && this.renderer.framebuffer.clear(0, 0, 0, 0);
    }
    /**
   * Draws a filter using the default rendering process.
   *
   * This should be called only by {@link PIXI.Filter#apply}.
   * @param filter - The filter to draw.
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */ applyFilter(filter, input, output, clearMode) {
        const renderer = this.renderer;
        renderer.state.set(filter.state), this.bindAndClear(output, clearMode), filter.uniforms.uSampler = input, filter.uniforms.filterGlobals = this.globalUniforms, renderer.shader.bind(filter), filter.legacy = !!filter.program.attributeData.aTextureCoord, filter.legacy ? (this.quadUv.map(input._frame, input.filterFrame), renderer.geometry.bind(this.quadUv), renderer.geometry.draw((0, $lmRm8.DRAW_MODES).TRIANGLES)) : (renderer.geometry.bind(this.quad), renderer.geometry.draw((0, $lmRm8.DRAW_MODES).TRIANGLE_STRIP));
    }
    /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {PIXI.Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */ calculateSpriteMatrix(outputMatrix, sprite) {
        const { sourceFrame: sourceFrame, destinationFrame: destinationFrame } = this.activeState, { orig: orig } = sprite._texture, mappedMatrix = outputMatrix.set(destinationFrame.width, 0, 0, destinationFrame.height, sourceFrame.x, sourceFrame.y), worldTransform = sprite.worldTransform.copyTo((0, $6wJoy.Matrix).TEMP_MATRIX);
        return worldTransform.invert(), mappedMatrix.prepend(worldTransform), mappedMatrix.scale(1 / orig.width, 1 / orig.height), mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y), mappedMatrix;
    }
    /** Destroys this Filter System. */ destroy() {
        this.renderer = null, this.texturePool.clear(!1);
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture in real pixels.
   * @param minHeight - The minimum height of the render texture in real pixels.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns - The new render texture.
   */ getOptimalFilterTexture(minWidth, minHeight, resolution = 1, multisample = (0, $lmRm8.MSAA_QUALITY).NONE) {
        return this.texturePool.getOptimalTexture(minWidth, minHeight, resolution, multisample);
    }
    /**
   * Gets extra render texture to use inside current filter
   * To be compliant with older filters, you can use params in any order
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   * @param multisample - number of samples of the renderTexture
   */ getFilterTexture(input, resolution, multisample) {
        if (typeof input == "number") {
            const swap = input;
            input = resolution, resolution = swap;
        }
        input = input || this.activeState.renderTexture;
        const filterTexture = this.texturePool.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $lmRm8.MSAA_QUALITY).NONE);
        return filterTexture.filterFrame = input.filterFrame, filterTexture;
    }
    /**
   * Frees a render texture back into the pool.
   * @param renderTexture - The renderTarget to free
   */ returnFilterTexture(renderTexture) {
        this.texturePool.returnTexture(renderTexture);
    }
    /** Empties the texture pool. */ emptyPool() {
        this.texturePool.clear(!0);
    }
    /** Calls `texturePool.resize()`, affects fullScreen renderTextures. */ resize() {
        this.texturePool.setScreenSize(this.renderer.view);
    }
    /**
   * @param matrix - first param
   * @param rect - second param
   */ transformAABB(matrix, rect) {
        const lt = $a52a4a592a10e8d1$var$tempPoints[0], lb = $a52a4a592a10e8d1$var$tempPoints[1], rt = $a52a4a592a10e8d1$var$tempPoints[2], rb = $a52a4a592a10e8d1$var$tempPoints[3];
        lt.set(rect.left, rect.top), lb.set(rect.left, rect.bottom), rt.set(rect.right, rect.top), rb.set(rect.right, rect.bottom), matrix.apply(lt, lt), matrix.apply(lb, lb), matrix.apply(rt, rt), matrix.apply(rb, rb);
        const x0 = Math.min(lt.x, lb.x, rt.x, rb.x), y0 = Math.min(lt.y, lb.y, rt.y, rb.y), x1 = Math.max(lt.x, lb.x, rt.x, rb.x), y1 = Math.max(lt.y, lb.y, rt.y, rb.y);
        rect.x = x0, rect.y = y0, rect.width = x1 - x0, rect.height = y1 - y0;
    }
    roundFrame(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if (!(frame.width <= 0 || frame.height <= 0 || bindingSourceFrame.width <= 0 || bindingSourceFrame.height <= 0)) {
            if (transform) {
                const { a: a, b: b, c: c, d: d } = transform;
                if ((Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4)) return;
            }
            transform = transform ? $a52a4a592a10e8d1$var$tempMatrix.copyFrom(transform) : $a52a4a592a10e8d1$var$tempMatrix.identity(), transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y), this.transformAABB(transform, frame), frame.ceil(resolution), this.transformAABB(transform.invert(), frame);
        }
    }
}
$a52a4a592a10e8d1$export$e94225c0dfac29cf.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "filter"
};
(0, $5RvHb.extensions).add($a52a4a592a10e8d1$export$e94225c0dfac29cf);

});
parcelRegister("9V6Rf", function(module, exports) {

$parcel$export(module.exports, "RenderTexturePool", () => $3a228e82a25656e0$export$1a441d2b5f37dfd7);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("lFGyw");
var $bpIJG = parcelRequire("bpIJG");

var $h8gz4 = parcelRequire("h8gz4");

var $4UuR4 = parcelRequire("4UuR4");
class $3a228e82a25656e0$export$1a441d2b5f37dfd7 {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {PIXI.SCALE_MODES} [textureOptions.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
   */ constructor(textureOptions){
        this.texturePool = {}, this.textureOptions = textureOptions || {}, this.enableFullScreen = !1, this._pixelsWidth = 0, this._pixelsHeight = 0;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param realWidth - Width of texture in pixels.
   * @param realHeight - Height of texture in pixels.
   * @param multisample - Number of samples of the framebuffer.
   */ createTexture(realWidth, realHeight, multisample = (0, $lmRm8.MSAA_QUALITY).NONE) {
        const baseRenderTexture = new (0, $h8gz4.BaseRenderTexture)(Object.assign({
            width: realWidth,
            height: realHeight,
            resolution: 1,
            multisample: multisample
        }, this.textureOptions));
        return new (0, $4UuR4.RenderTexture)(baseRenderTexture);
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param multisample - Number of samples of the render texture.
   * @returns The new render texture.
   */ getOptimalTexture(minWidth, minHeight, resolution = 1, multisample = (0, $lmRm8.MSAA_QUALITY).NONE) {
        let key;
        minWidth = Math.max(Math.ceil(minWidth * resolution - 1e-6), 1), minHeight = Math.max(Math.ceil(minHeight * resolution - 1e-6), 1), !this.enableFullScreen || minWidth !== this._pixelsWidth || minHeight !== this._pixelsHeight ? (minWidth = (0, $bpIJG.nextPow2)(minWidth), minHeight = (0, $bpIJG.nextPow2)(minHeight), key = ((minWidth & 65535) << 16 | minHeight & 65535) >>> 0, multisample > 1 && (key += multisample * 4294967296)) : key = multisample > 1 ? -multisample : -1, this.texturePool[key] || (this.texturePool[key] = []);
        let renderTexture = this.texturePool[key].pop();
        return renderTexture || (renderTexture = this.createTexture(minWidth, minHeight, multisample)), renderTexture.filterPoolKey = key, renderTexture.setResolution(resolution), renderTexture;
    }
    /**
   * Gets extra texture of the same size as input renderTexture
   *
   * `getFilterTexture(input, 0.5)` or `getFilterTexture(0.5, input)`
   * @param input - renderTexture from which size and resolution will be copied
   * @param resolution - override resolution of the renderTexture
   *  It overrides, it does not multiply
   * @param multisample - number of samples of the renderTexture
   */ getFilterTexture(input, resolution, multisample) {
        const filterTexture = this.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $lmRm8.MSAA_QUALITY).NONE);
        return filterTexture.filterFrame = input.filterFrame, filterTexture;
    }
    /**
   * Place a render texture back into the pool.
   * @param renderTexture - The renderTexture to free
   */ returnTexture(renderTexture) {
        const key = renderTexture.filterPoolKey;
        renderTexture.filterFrame = null, this.texturePool[key].push(renderTexture);
    }
    /**
   * Alias for returnTexture, to be compliant with FilterSystem interface.
   * @param renderTexture - The renderTexture to free
   */ returnFilterTexture(renderTexture) {
        this.returnTexture(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        if (destroyTextures = destroyTextures !== !1, destroyTextures) for(const i in this.texturePool){
            const textures = this.texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(!0);
        }
        this.texturePool = {};
    }
    /**
   * If screen size was changed, drops all screen-sized textures,
   * sets new screen size, sets `enableFullScreen` to true
   *
   * Size is measured in pixels, `renderer.view` can be passed here, not `renderer.screen`
   * @param size - Initial size of screen.
   */ setScreenSize(size) {
        if (!(size.width === this._pixelsWidth && size.height === this._pixelsHeight)) {
            this.enableFullScreen = size.width > 0 && size.height > 0;
            for(const i in this.texturePool){
                if (!(Number(i) < 0)) continue;
                const textures = this.texturePool[i];
                if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(!0);
                this.texturePool[i] = [];
            }
            this._pixelsWidth = size.width, this._pixelsHeight = size.height;
        }
    }
}
$3a228e82a25656e0$export$1a441d2b5f37dfd7.SCREEN_KEY = -1;

});
parcelRegister("h8gz4", function(module, exports) {

$parcel$export(module.exports, "BaseRenderTexture", () => $7511dacad386c8be$export$18d268c71e34cf2c);
parcelRequire("8HZMw");
var $1PNws = parcelRequire("1PNws");

var $lmRm8 = parcelRequire("lmRm8");

var $9Tsjp = parcelRequire("9Tsjp");

var $4oWO8 = parcelRequire("4oWO8");
class $7511dacad386c8be$export$18d268c71e34cf2c extends (0, $4oWO8.BaseTexture) {
    /**
   * @param options
   * @param {number} [options.width=100] - The width of the base render texture.
   * @param {number} [options.height=100] - The height of the base render texture.
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *   for possible values.
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio
   *   of the texture being generated.
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer.
   */ constructor(options = {}){
        if (typeof options == "number") {
            const width = arguments[0], height = arguments[1], scaleMode = arguments[2], resolution = arguments[3];
            options = {
                width: width,
                height: height,
                scaleMode: scaleMode,
                resolution: resolution
            };
        }
        options.width = options.width ?? 100, options.height = options.height ?? 100, options.multisample ?? (options.multisample = (0, $lmRm8.MSAA_QUALITY).NONE), super(null, options), this.mipmap = (0, $lmRm8.MIPMAP_MODES).OFF, this.valid = !0, this._clear = new (0, $1PNws.Color)([
            0,
            0,
            0,
            0
        ]), this.framebuffer = new (0, $9Tsjp.Framebuffer)(this.realWidth, this.realHeight).addColorTexture(0, this), this.framebuffer.multisample = options.multisample, this.maskStack = [], this.filterStack = [
            {}
        ];
    }
    /** Color when clearning the texture. */ set clearColor(value) {
        this._clear.setValue(value);
    }
    get clearColor() {
        return this._clear.value;
    }
    /**
   * Color object when clearning the texture.
   * @readonly
   * @since 7.2.0
   */ get clear() {
        return this._clear;
    }
    /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */ get multisample() {
        return this.framebuffer.multisample;
    }
    set multisample(value) {
        this.framebuffer.multisample = value;
    }
    /**
   * Resizes the BaseRenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   */ resize(desiredWidth, desiredHeight) {
        this.framebuffer.resize(desiredWidth * this.resolution, desiredHeight * this.resolution), this.setRealSize(this.framebuffer.width, this.framebuffer.height);
    }
    /**
   * Frees the texture and framebuffer from WebGL memory without destroying this texture object.
   * This means you can still use the texture later which will upload it to GPU
   * memory again.
   * @fires PIXI.BaseTexture#dispose
   */ dispose() {
        this.framebuffer.dispose(), super.dispose();
    }
    /** Destroys this texture. */ destroy() {
        super.destroy(), this.framebuffer.destroyDepthTexture(), this.framebuffer = null;
    }
}

});
parcelRegister("9Tsjp", function(module, exports) {

$parcel$export(module.exports, "Framebuffer", () => $2a038313609da7f8$export$eff95f126aa67cfb);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("hWIIU");
var $aDHVi = parcelRequire("aDHVi");

var $4oWO8 = parcelRequire("4oWO8");
class $2a038313609da7f8$export$eff95f126aa67cfb {
    /**
   * @param width - Width of the frame buffer
   * @param height - Height of the frame buffer
   */ constructor(width, height){
        if (this.width = Math.round(width), this.height = Math.round(height), !this.width || !this.height) throw new Error("Framebuffer width or height is zero");
        this.stencil = !1, this.depth = !1, this.dirtyId = 0, this.dirtyFormat = 0, this.dirtySize = 0, this.depthTexture = null, this.colorTextures = [], this.glFramebuffers = {}, this.disposeRunner = new (0, $aDHVi.Runner)("disposeFramebuffer"), this.multisample = (0, $lmRm8.MSAA_QUALITY).NONE;
    }
    /**
   * Reference to the colorTexture.
   * @readonly
   */ get colorTexture() {
        return this.colorTextures[0];
    }
    /**
   * Add texture to the colorTexture array.
   * @param index - Index of the array to add the texture to
   * @param texture - Texture to add to the array
   */ addColorTexture(index = 0, texture) {
        return this.colorTextures[index] = texture || new (0, $4oWO8.BaseTexture)(null, {
            scaleMode: (0, $lmRm8.SCALE_MODES).NEAREST,
            resolution: 1,
            mipmap: (0, $lmRm8.MIPMAP_MODES).OFF,
            width: this.width,
            height: this.height
        }), this.dirtyId++, this.dirtyFormat++, this;
    }
    /**
   * Add a depth texture to the frame buffer.
   * @param texture - Texture to add.
   */ addDepthTexture(texture) {
        return this.depthTexture = texture || new (0, $4oWO8.BaseTexture)(null, {
            scaleMode: (0, $lmRm8.SCALE_MODES).NEAREST,
            resolution: 1,
            width: this.width,
            height: this.height,
            mipmap: (0, $lmRm8.MIPMAP_MODES).OFF,
            format: (0, $lmRm8.FORMATS).DEPTH_COMPONENT,
            type: (0, $lmRm8.TYPES).UNSIGNED_SHORT
        }), this.dirtyId++, this.dirtyFormat++, this;
    }
    /** Enable depth on the frame buffer. */ enableDepth() {
        return this.depth = !0, this.dirtyId++, this.dirtyFormat++, this;
    }
    /** Enable stencil on the frame buffer. */ enableStencil() {
        return this.stencil = !0, this.dirtyId++, this.dirtyFormat++, this;
    }
    /**
   * Resize the frame buffer
   * @param width - Width of the frame buffer to resize to
   * @param height - Height of the frame buffer to resize to
   */ resize(width, height) {
        if (width = Math.round(width), height = Math.round(height), !width || !height) throw new Error("Framebuffer width and height must not be zero");
        if (!(width === this.width && height === this.height)) {
            this.width = width, this.height = height, this.dirtyId++, this.dirtySize++;
            for(let i = 0; i < this.colorTextures.length; i++){
                const texture = this.colorTextures[i], resolution = texture.resolution;
                texture.setSize(width / resolution, height / resolution);
            }
            if (this.depthTexture) {
                const resolution = this.depthTexture.resolution;
                this.depthTexture.setSize(width / resolution, height / resolution);
            }
        }
    }
    /** Disposes WebGL resources that are connected to this geometry. */ dispose() {
        this.disposeRunner.emit(this, !1);
    }
    /** Destroys and removes the depth texture added to this framebuffer. */ destroyDepthTexture() {
        this.depthTexture && (this.depthTexture.destroy(), this.depthTexture = null, ++this.dirtyId, ++this.dirtyFormat);
    }
}

});


parcelRegister("4UuR4", function(module, exports) {

$parcel$export(module.exports, "RenderTexture", () => $952e32ce616eaf78$export$813984f7330b4d72);

var $cWOCu = parcelRequire("cWOCu");

var $h8gz4 = parcelRequire("h8gz4");
class $952e32ce616eaf78$export$813984f7330b4d72 extends (0, $cWOCu.Texture) {
    /**
   * @param baseRenderTexture - The base texture object that this texture uses.
   * @param frame - The rectangle frame of the texture to show.
   */ constructor(baseRenderTexture, frame){
        super(baseRenderTexture, frame), this.valid = !0, this.filterFrame = null, this.filterPoolKey = null, this.updateUvs();
    }
    /**
   * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
   * @readonly
   */ get framebuffer() {
        return this.baseTexture.framebuffer;
    }
    /**
   * Shortcut to `this.framebuffer.multisample`.
   * @default PIXI.MSAA_QUALITY.NONE
   */ get multisample() {
        return this.framebuffer.multisample;
    }
    set multisample(value) {
        this.framebuffer.multisample = value;
    }
    /**
   * Resizes the RenderTexture.
   * @param desiredWidth - The desired width to resize to.
   * @param desiredHeight - The desired height to resize to.
   * @param resizeBaseTexture - Should the baseTexture.width and height values be resized as well?
   */ resize(desiredWidth, desiredHeight, resizeBaseTexture = !0) {
        const resolution = this.baseTexture.resolution, width = Math.round(desiredWidth * resolution) / resolution, height = Math.round(desiredHeight * resolution) / resolution;
        this.valid = width > 0 && height > 0, this._frame.width = this.orig.width = width, this._frame.height = this.orig.height = height, resizeBaseTexture && this.baseTexture.resize(width, height), this.updateUvs();
    }
    /**
   * Changes the resolution of baseTexture, but does not change framebuffer size.
   * @param resolution - The new resolution to apply to RenderTexture
   */ setResolution(resolution) {
        const { baseTexture: baseTexture } = this;
        baseTexture.resolution !== resolution && (baseTexture.setResolution(resolution), this.resize(baseTexture.width, baseTexture.height, !1));
    }
    /**
   * A short hand way of creating a render texture.
   * @param options - Options
   * @param {number} [options.width=100] - The width of the render texture
   * @param {number} [options.height=100] - The height of the render texture
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.BaseTexture.defaultOptions.scaleMode] - See {@link PIXI.SCALE_MODES}
   *    for possible values
   * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the texture
   *    being generated
   * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer
   * @returns The new render texture
   */ static create(options) {
        return new $952e32ce616eaf78$export$813984f7330b4d72(new (0, $h8gz4.BaseRenderTexture)(options));
    }
}

});
parcelRegister("cWOCu", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $6ac4ad2139942545$export$5431306cf43de24a);
parcelRequire("9fnly");
var $gnwPx = parcelRequire("gnwPx");
var $kZOeV = parcelRequire("kZOeV");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
parcelRequire("lFGyw");
var $3vRz3 = parcelRequire("3vRz3");
var $6e477 = parcelRequire("6e477");
var $5ohKV = parcelRequire("5ohKV");
var $2yb2o = parcelRequire("2yb2o");

var $4oWO8 = parcelRequire("4oWO8");

var $9iM43 = parcelRequire("9iM43");

var $9WwWG = parcelRequire("9WwWG");
const $6ac4ad2139942545$var$DEFAULT_UVS = new (0, $9WwWG.TextureUvs)();
function $6ac4ad2139942545$var$removeAllHandlers(tex) {
    tex.destroy = function() {}, tex.on = function() {}, tex.once = function() {}, tex.emit = function() {};
}
class $6ac4ad2139942545$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param baseTexture - The base texture source to create the texture from
   * @param frame - The rectangle frame of the texture to show
   * @param orig - The area of original texture
   * @param trim - Trimmed rectangle of original texture
   * @param rotate - indicates how the texture was rotated by texture packer. See {@link PIXI.groupD8}
   * @param anchor - Default anchor point used for sprite placement / rotation
   * @param borders - Default borders used for 9-slice scaling. See {@link PIXI.NineSlicePlane}
   */ constructor(baseTexture, frame, orig, trim, rotate, anchor, borders){
        if (super(), this.noFrame = !1, frame || (this.noFrame = !0, frame = new (0, $kZOeV.Rectangle)(0, 0, 1, 1)), baseTexture instanceof $6ac4ad2139942545$export$5431306cf43de24a && (baseTexture = baseTexture.baseTexture), this.baseTexture = baseTexture, this._frame = frame, this.trim = trim, this.valid = !1, this.destroyed = !1, this._uvs = $6ac4ad2139942545$var$DEFAULT_UVS, this.uvMatrix = null, this.orig = orig || frame, this._rotate = Number(rotate || 0), rotate === !0) this._rotate = 2;
        else if (this._rotate % 2 !== 0) throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");
        this.defaultAnchor = anchor ? new (0, $gnwPx.Point)(anchor.x, anchor.y) : new (0, $gnwPx.Point)(0, 0), this.defaultBorders = borders, this._updateID = 0, this.textureCacheIds = [], baseTexture.valid ? this.noFrame ? baseTexture.valid && this.onBaseTextureUpdated(baseTexture) : this.frame = frame : baseTexture.once("loaded", this.onBaseTextureUpdated, this), this.noFrame && baseTexture.on("update", this.onBaseTextureUpdated, this);
    }
    /**
   * Updates this texture on the gpu.
   *
   * Calls the TextureResource update.
   *
   * If you adjusted `frame` manually, please call `updateUvs()` instead.
   */ update() {
        this.baseTexture.resource && this.baseTexture.resource.update();
    }
    /**
   * Called when the base texture is updated
   * @protected
   * @param baseTexture - The base texture.
   */ onBaseTextureUpdated(baseTexture) {
        if (this.noFrame) {
            if (!this.baseTexture.valid) return;
            this._frame.width = baseTexture.width, this._frame.height = baseTexture.height, this.valid = !0, this.updateUvs();
        } else this.frame = this._frame;
        this.emit("update", this);
    }
    /**
   * Destroys this texture
   * @param [destroyBase=false] - Whether to destroy the base texture as well
   * @fires PIXI.Texture#destroyed
   */ destroy(destroyBase) {
        if (this.baseTexture) {
            if (destroyBase) {
                const { resource: resource } = this.baseTexture;
                resource?.url && (0, $5ohKV.TextureCache)[resource.url] && $6ac4ad2139942545$export$5431306cf43de24a.removeFromCache(resource.url), this.baseTexture.destroy();
            }
            this.baseTexture.off("loaded", this.onBaseTextureUpdated, this), this.baseTexture.off("update", this.onBaseTextureUpdated, this), this.baseTexture = null;
        }
        this._frame = null, this._uvs = null, this.trim = null, this.orig = null, this.valid = !1, $6ac4ad2139942545$export$5431306cf43de24a.removeFromCache(this), this.textureCacheIds = null, this.destroyed = !0, this.emit("destroyed", this), this.removeAllListeners();
    }
    /**
   * Creates a new texture object that acts the same as this one.
   * @returns - The new texture
   */ clone() {
        const clonedFrame = this._frame.clone(), clonedOrig = this._frame === this.orig ? clonedFrame : this.orig.clone(), clonedTexture = new $6ac4ad2139942545$export$5431306cf43de24a(this.baseTexture, !this.noFrame && clonedFrame, clonedOrig, this.trim?.clone(), this.rotate, this.defaultAnchor, this.defaultBorders);
        return this.noFrame && (clonedTexture._frame = clonedFrame), clonedTexture;
    }
    /**
   * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
   * Call it after changing the frame
   */ updateUvs() {
        this._uvs === $6ac4ad2139942545$var$DEFAULT_UVS && (this._uvs = new (0, $9WwWG.TextureUvs)()), this._uvs.set(this._frame, this.baseTexture, this.rotate), this._updateID++;
    }
    /**
   * Helper function that creates a new Texture based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.BaseTexture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source -
   *        Source or array of sources to create texture from
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
   * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
   * @returns {PIXI.Texture} The newly created texture
   */ static from(source, options = {}, strict = (0, $16eqM.settings).STRICT_TEXTURE_CACHE) {
        const isFrame = typeof source == "string";
        let cacheId = null;
        if (isFrame) cacheId = source;
        else if (source instanceof (0, $4oWO8.BaseTexture)) {
            if (!source.cacheId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source.cacheId = `${prefix}-${(0, $2yb2o.uid)()}`, (0, $4oWO8.BaseTexture).addToCache(source, source.cacheId);
            }
            cacheId = source.cacheId;
        } else {
            if (!source._pixiId) {
                const prefix = options?.pixiIdPrefix || "pixiid";
                source._pixiId = `${prefix}_${(0, $2yb2o.uid)()}`;
            }
            cacheId = source._pixiId;
        }
        let texture = (0, $5ohKV.TextureCache)[cacheId];
        if (isFrame && strict && !texture) throw new Error(`The cacheId "${cacheId}" does not exist in TextureCache.`);
        return !texture && !(source instanceof (0, $4oWO8.BaseTexture)) ? (options.resolution || (options.resolution = (0, $6e477.getResolutionOfUrl)(source)), texture = new $6ac4ad2139942545$export$5431306cf43de24a(new (0, $4oWO8.BaseTexture)(source, options)), texture.baseTexture.cacheId = cacheId, (0, $4oWO8.BaseTexture).addToCache(texture.baseTexture, cacheId), $6ac4ad2139942545$export$5431306cf43de24a.addToCache(texture, cacheId)) : !texture && source instanceof (0, $4oWO8.BaseTexture) && (texture = new $6ac4ad2139942545$export$5431306cf43de24a(source), $6ac4ad2139942545$export$5431306cf43de24a.addToCache(texture, cacheId)), texture;
    }
    /**
   * Useful for loading textures via URLs. Use instead of `Texture.from` because
   * it does a better job of handling failed URLs more effectively. This also ignores
   * `PIXI.settings.STRICT_TEXTURE_CACHE`. Works for Videos, SVGs, Images.
   * @param url - The remote URL or array of URLs to load.
   * @param options - Optional options to include
   * @returns - A Promise that resolves to a Texture.
   */ static fromURL(url, options) {
        const resourceOptions = Object.assign({
            autoLoad: !1
        }, options?.resourceOptions), texture = $6ac4ad2139942545$export$5431306cf43de24a.from(url, Object.assign({
            resourceOptions: resourceOptions
        }, options), !1), resource = texture.baseTexture.resource;
        return texture.baseTexture.valid ? Promise.resolve(texture) : resource.load().then(()=>Promise.resolve(texture));
    }
    /**
   * Create a new Texture with a BufferResource from a typed array.
   * @param buffer - The optional array to use. If no data is provided, a new Float32Array is created.
   * @param width - Width of the resource
   * @param height - Height of the resource
   * @param options - See {@link PIXI.BaseTexture}'s constructor for options.
   *        Default properties are different from the constructor's defaults.
   * @param {PIXI.FORMATS} [options.format] - The format is not given, the type is inferred from the
   *        type of the buffer: `RGBA` if Float32Array, Int8Array, Uint8Array, or Uint8ClampedArray,
   *        otherwise `RGBA_INTEGER`.
   * @param {PIXI.TYPES} [options.type] - The type is not given, the type is inferred from the
   *        type of the buffer. Maps Float32Array to `FLOAT`, Int32Array to `INT`, Uint32Array to
   *        `UNSIGNED_INT`, Int16Array to `SHORT`, Uint16Array to `UNSIGNED_SHORT`, Int8Array to `BYTE`,
   *        Uint8Array/Uint8ClampedArray to `UNSIGNED_BYTE`.
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.NPM]
   * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.SCALE_MODES.NEAREST]
   * @returns - The resulting new BaseTexture
   */ static fromBuffer(buffer, width, height, options) {
        return new $6ac4ad2139942545$export$5431306cf43de24a((0, $4oWO8.BaseTexture).fromBuffer(buffer, width, height, options));
    }
    /**
   * Create a texture from a source and add to the cache.
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas|string} source - The input source.
   * @param imageUrl - File name of texture, for cache and resolving resolution.
   * @param name - Human readable name for the texture cache. If no name is
   *        specified, only `imageUrl` will be used as the cache ID.
   * @param options
   * @returns - Output texture
   */ static fromLoader(source, imageUrl, name, options) {
        const baseTexture = new (0, $4oWO8.BaseTexture)(source, Object.assign({
            scaleMode: (0, $4oWO8.BaseTexture).defaultOptions.scaleMode,
            resolution: (0, $6e477.getResolutionOfUrl)(imageUrl)
        }, options)), { resource: resource } = baseTexture;
        resource instanceof (0, $9iM43.ImageResource) && (resource.url = imageUrl);
        const texture = new $6ac4ad2139942545$export$5431306cf43de24a(baseTexture);
        return name || (name = imageUrl), (0, $4oWO8.BaseTexture).addToCache(texture.baseTexture, name), $6ac4ad2139942545$export$5431306cf43de24a.addToCache(texture, name), name !== imageUrl && ((0, $4oWO8.BaseTexture).addToCache(texture.baseTexture, imageUrl), $6ac4ad2139942545$export$5431306cf43de24a.addToCache(texture, imageUrl)), texture.baseTexture.valid ? Promise.resolve(texture) : new Promise((resolve)=>{
            texture.baseTexture.once("loaded", ()=>resolve(texture));
        });
    }
    /**
   * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
   * @param texture - The Texture to add to the cache.
   * @param id - The id that the Texture will be stored against.
   */ static addToCache(texture, id) {
        id && (texture.textureCacheIds.includes(id) || texture.textureCacheIds.push(id), (0, $5ohKV.TextureCache)[id] && (0, $5ohKV.TextureCache)[id] !== texture && console.warn(`Texture added to the cache with an id [${id}] that already had an entry`), (0, $5ohKV.TextureCache)[id] = texture);
    }
    /**
   * Remove a Texture from the global TextureCache.
   * @param texture - id of a Texture to be removed, or a Texture instance itself
   * @returns - The Texture that was removed
   */ static removeFromCache(texture) {
        if (typeof texture == "string") {
            const textureFromCache = (0, $5ohKV.TextureCache)[texture];
            if (textureFromCache) {
                const index = textureFromCache.textureCacheIds.indexOf(texture);
                return index > -1 && textureFromCache.textureCacheIds.splice(index, 1), delete (0, $5ohKV.TextureCache)[texture], textureFromCache;
            }
        } else if (texture?.textureCacheIds) {
            for(let i = 0; i < texture.textureCacheIds.length; ++i)(0, $5ohKV.TextureCache)[texture.textureCacheIds[i]] === texture && delete (0, $5ohKV.TextureCache)[texture.textureCacheIds[i]];
            return texture.textureCacheIds.length = 0, texture;
        }
        return null;
    }
    /**
   * Returns resolution of baseTexture
   * @readonly
   */ get resolution() {
        return this.baseTexture.resolution;
    }
    /**
   * The frame specifies the region of the base texture that this texture uses.
   * Please call `updateUvs()` after you change coordinates of `frame` manually.
   */ get frame() {
        return this._frame;
    }
    set frame(frame) {
        this._frame = frame, this.noFrame = !1;
        const { x: x, y: y, width: width, height: height } = frame, xNotFit = x + width > this.baseTexture.width, yNotFit = y + height > this.baseTexture.height;
        if (xNotFit || yNotFit) {
            const relationship = xNotFit && yNotFit ? "and" : "or", errorX = `X: ${x} + ${width} = ${x + width} > ${this.baseTexture.width}`, errorY = `Y: ${y} + ${height} = ${y + height} > ${this.baseTexture.height}`;
            throw new Error(`Texture Error: frame does not fit inside the base Texture dimensions: ${errorX} ${relationship} ${errorY}`);
        }
        this.valid = width && height && this.baseTexture.valid, !this.trim && !this.rotate && (this.orig = frame), this.valid && this.updateUvs();
    }
    /**
   * Indicates whether the texture is rotated inside the atlas
   * set to 2 to compensate for texture packer rotation
   * set to 6 to compensate for spine packer rotation
   * can be used to rotate or mirror sprites
   * See {@link PIXI.groupD8} for explanation
   */ get rotate() {
        return this._rotate;
    }
    set rotate(rotate) {
        this._rotate = rotate, this.valid && this.updateUvs();
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Utility function for BaseTexture|Texture cast. */ castToBaseTexture() {
        return this.baseTexture;
    }
    /** An empty texture, used often to not have to create multiple empty textures. Can not be destroyed. */ static get EMPTY() {
        return $6ac4ad2139942545$export$5431306cf43de24a._EMPTY || ($6ac4ad2139942545$export$5431306cf43de24a._EMPTY = new $6ac4ad2139942545$export$5431306cf43de24a(new (0, $4oWO8.BaseTexture)()), $6ac4ad2139942545$var$removeAllHandlers($6ac4ad2139942545$export$5431306cf43de24a._EMPTY), $6ac4ad2139942545$var$removeAllHandlers($6ac4ad2139942545$export$5431306cf43de24a._EMPTY.baseTexture)), $6ac4ad2139942545$export$5431306cf43de24a._EMPTY;
    }
    /** A white texture of 16x16 size, used for graphics and other things Can not be destroyed. */ static get WHITE() {
        if (!$6ac4ad2139942545$export$5431306cf43de24a._WHITE) {
            const canvas = (0, $16eqM.settings).ADAPTER.createCanvas(16, 16), context = canvas.getContext("2d");
            canvas.width = 16, canvas.height = 16, context.fillStyle = "white", context.fillRect(0, 0, 16, 16), $6ac4ad2139942545$export$5431306cf43de24a._WHITE = new $6ac4ad2139942545$export$5431306cf43de24a((0, $4oWO8.BaseTexture).from(canvas)), $6ac4ad2139942545$var$removeAllHandlers($6ac4ad2139942545$export$5431306cf43de24a._WHITE), $6ac4ad2139942545$var$removeAllHandlers($6ac4ad2139942545$export$5431306cf43de24a._WHITE.baseTexture);
        }
        return $6ac4ad2139942545$export$5431306cf43de24a._WHITE;
    }
}

});
parcelRegister("9iM43", function(module, exports) {

$parcel$export(module.exports, "ImageResource", () => $8d0497df0f10e502$export$6d0d25e6e731a9a2);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");

var $bmxlM = parcelRequire("bmxlM");
class $8d0497df0f10e502$export$6d0d25e6e731a9a2 extends (0, $bmxlM.BaseImageResource) {
    /**
   * @param source - image source or URL
   * @param options
   * @param {boolean} [options.autoLoad=true] - start loading process
   * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - whether its required to create
   *        a bitmap before upload
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Premultiply image alpha in bitmap
   */ constructor(source, options){
        if (options = options || {}, typeof source == "string") {
            const imageElement = new Image();
            (0, $bmxlM.BaseImageResource).crossOrigin(imageElement, source, options.crossorigin), imageElement.src = source, source = imageElement;
        }
        super(source), !source.complete && this._width && this._height && (this._width = 0, this._height = 0), this.url = source.src, this._process = null, this.preserveBitmap = !1, this.createBitmap = (options.createBitmap ?? (0, $16eqM.settings).CREATE_IMAGE_BITMAP) && !!globalThis.createImageBitmap, this.alphaMode = typeof options.alphaMode == "number" ? options.alphaMode : null, this.bitmap = null, this._load = null, options.autoLoad !== !1 && this.load();
    }
    /**
   * Returns a promise when image will be loaded and processed.
   * @param createBitmap - whether process image into bitmap
   */ load(createBitmap) {
        return this._load ? this._load : (createBitmap !== void 0 && (this.createBitmap = createBitmap), this._load = new Promise((resolve, reject)=>{
            const source = this.source;
            this.url = source.src;
            const completed = ()=>{
                this.destroyed || (source.onload = null, source.onerror = null, this.update(), this._load = null, this.createBitmap ? resolve(this.process()) : resolve(this));
            };
            source.complete && source.src ? completed() : (source.onload = completed, source.onerror = (event)=>{
                reject(event), this.onError.emit(event);
            });
        }), this._load);
    }
    /**
   * Called when we need to convert image into BitmapImage.
   * Can be called multiple times, real promise is cached inside.
   * @returns - Cached promise to fill that bitmap
   */ process() {
        const source = this.source;
        if (this._process !== null) return this._process;
        if (this.bitmap !== null || !globalThis.createImageBitmap) return Promise.resolve(this);
        const createImageBitmap = globalThis.createImageBitmap, cors = !source.crossOrigin || source.crossOrigin === "anonymous";
        return this._process = fetch(source.src, {
            mode: cors ? "cors" : "no-cors"
        }).then((r)=>r.blob()).then((blob)=>createImageBitmap(blob, 0, 0, source.width, source.height, {
                premultiplyAlpha: this.alphaMode === null || this.alphaMode === (0, $lmRm8.ALPHA_MODES).UNPACK ? "premultiply" : "none"
            })).then((bitmap)=>this.destroyed ? Promise.reject() : (this.bitmap = bitmap, this.update(), this._process = null, Promise.resolve(this))), this._process;
    }
    /**
   * Upload the image resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */ upload(renderer, baseTexture, glTexture) {
        if (typeof this.alphaMode == "number" && (baseTexture.alphaMode = this.alphaMode), !this.createBitmap) return super.upload(renderer, baseTexture, glTexture);
        if (!this.bitmap && (this.process(), !this.bitmap)) return !1;
        if (super.upload(renderer, baseTexture, glTexture, this.bitmap), !this.preserveBitmap) {
            let flag = !0;
            const glTextures = baseTexture._glTextures;
            for(const key in glTextures){
                const otherTex = glTextures[key];
                if (otherTex !== glTexture && otherTex.dirtyId !== baseTexture.dirtyId) {
                    flag = !1;
                    break;
                }
            }
            flag && (this.bitmap.close && this.bitmap.close(), this.bitmap = null);
        }
        return !0;
    }
    /** Destroys this resource. */ dispose() {
        this.source.onload = null, this.source.onerror = null, super.dispose(), this.bitmap && (this.bitmap.close(), this.bitmap = null), this._process = null, this._load = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support HTMLImageElement, and source is string or HTMLImageElement
   */ static test(source) {
        return typeof HTMLImageElement < "u" && (typeof source == "string" || source instanceof HTMLImageElement);
    }
}

});
parcelRegister("bmxlM", function(module, exports) {

$parcel$export(module.exports, "BaseImageResource", () => $9909c4093f866353$export$c87b2a1e7e3bb4a6);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("lFGyw");
var $bW1QN = parcelRequire("bW1QN");

var $fbY8e = parcelRequire("fbY8e");
class $9909c4093f866353$export$c87b2a1e7e3bb4a6 extends (0, $fbY8e.Resource) {
    /**
   * @param {PIXI.ImageSourcee} source
   */ constructor(source){
        const sourceAny = source, width = sourceAny.naturalWidth || sourceAny.videoWidth || sourceAny.displayWidth || sourceAny.width, height = sourceAny.naturalHeight || sourceAny.videoHeight || sourceAny.displayHeight || sourceAny.height;
        super(width, height), this.source = source, this.noSubImage = !1;
    }
    /**
   * Set cross origin based detecting the url and the crossorigin
   * @param element - Element to apply crossOrigin
   * @param url - URL to check
   * @param crossorigin - Cross origin value to use
   */ static crossOrigin(element, url, crossorigin) {
        crossorigin === void 0 && !url.startsWith("data:") ? element.crossOrigin = (0, $bW1QN.determineCrossOrigin)(url) : crossorigin !== !1 && (element.crossOrigin = typeof crossorigin == "string" ? crossorigin : "anonymous");
    }
    /**
   * Upload the texture to the GPU.
   * @param renderer - Upload to the renderer
   * @param baseTexture - Reference to parent texture
   * @param glTexture
   * @param {PIXI.ImageSourcee} [source] - (optional)
   * @returns - true is success
   */ upload(renderer, baseTexture, glTexture, source) {
        const gl = renderer.gl, width = baseTexture.realWidth, height = baseTexture.realHeight;
        if (source = source || this.source, typeof HTMLImageElement < "u" && source instanceof HTMLImageElement) {
            if (!source.complete || source.naturalWidth === 0) return !1;
        } else if (typeof HTMLVideoElement < "u" && source instanceof HTMLVideoElement && source.readyState <= 1) return !1;
        return gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $lmRm8.ALPHA_MODES).UNPACK), !this.noSubImage && baseTexture.target === gl.TEXTURE_2D && glTexture.width === width && glTexture.height === height ? gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, baseTexture.format, glTexture.type, source) : (glTexture.width = width, glTexture.height = height, gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, baseTexture.format, glTexture.type, source)), !0;
    }
    /**
   * Checks if source width/height was changed, resize can cause extra baseTexture update.
   * Triggers one update in any case.
   */ update() {
        if (this.destroyed) return;
        const source = this.source, width = source.naturalWidth || source.videoWidth || source.width, height = source.naturalHeight || source.videoHeight || source.height;
        this.resize(width, height), super.update();
    }
    /** Destroy this {@link PIXI.BaseImageResource} */ dispose() {
        this.source = null;
    }
}

});


parcelRegister("9WwWG", function(module, exports) {

$parcel$export(module.exports, "TextureUvs", () => $eea3d7b0746979d2$export$4efdf5c542d7171e);
parcelRequire("9fnly");
var $e96Pm = parcelRequire("e96Pm");
class $eea3d7b0746979d2$export$4efdf5c542d7171e {
    constructor(){
        this.x0 = 0, this.y0 = 0, this.x1 = 1, this.y1 = 0, this.x2 = 1, this.y2 = 1, this.x3 = 0, this.y3 = 1, this.uvsFloat32 = new Float32Array(8);
    }
    /**
   * Sets the texture Uvs based on the given frame information.
   * @protected
   * @param frame - The frame of the texture
   * @param baseFrame - The base frame of the texture
   * @param rotate - Rotation of frame, see {@link PIXI.groupD8}
   */ set(frame, baseFrame, rotate) {
        const tw = baseFrame.width, th = baseFrame.height;
        if (rotate) {
            const w2 = frame.width / 2 / tw, h2 = frame.height / 2 / th, cX = frame.x / tw + w2, cY = frame.y / th + h2;
            rotate = (0, $e96Pm.groupD8).add(rotate, (0, $e96Pm.groupD8).NW), this.x0 = cX + w2 * (0, $e96Pm.groupD8).uX(rotate), this.y0 = cY + h2 * (0, $e96Pm.groupD8).uY(rotate), rotate = (0, $e96Pm.groupD8).add(rotate, 2), this.x1 = cX + w2 * (0, $e96Pm.groupD8).uX(rotate), this.y1 = cY + h2 * (0, $e96Pm.groupD8).uY(rotate), rotate = (0, $e96Pm.groupD8).add(rotate, 2), this.x2 = cX + w2 * (0, $e96Pm.groupD8).uX(rotate), this.y2 = cY + h2 * (0, $e96Pm.groupD8).uY(rotate), rotate = (0, $e96Pm.groupD8).add(rotate, 2), this.x3 = cX + w2 * (0, $e96Pm.groupD8).uX(rotate), this.y3 = cY + h2 * (0, $e96Pm.groupD8).uY(rotate);
        } else this.x0 = frame.x / tw, this.y0 = frame.y / th, this.x1 = (frame.x + frame.width) / tw, this.y1 = frame.y / th, this.x2 = (frame.x + frame.width) / tw, this.y2 = (frame.y + frame.height) / th, this.x3 = frame.x / tw, this.y3 = (frame.y + frame.height) / th;
        this.uvsFloat32[0] = this.x0, this.uvsFloat32[1] = this.y0, this.uvsFloat32[2] = this.x1, this.uvsFloat32[3] = this.y1, this.uvsFloat32[4] = this.x2, this.uvsFloat32[5] = this.y2, this.uvsFloat32[6] = this.x3, this.uvsFloat32[7] = this.y3;
    }
}
$eea3d7b0746979d2$export$4efdf5c542d7171e.prototype.toString = function() {
    return `[@pixi/core:TextureUvs x0=${this.x0} y0=${this.y0} x1=${this.x1} y1=${this.y1} x2=${this.x2} y2=${this.y2} x3=${this.x3} y3=${this.y3}]`;
};

});




parcelRegister("ivGFf", function(module, exports) {

$parcel$export(module.exports, "Quad", () => $c9042951808e8305$export$7005c9eb6671414d);

var $5K7Rq = parcelRequire("5K7Rq");
class $c9042951808e8305$export$7005c9eb6671414d extends (0, $5K7Rq.Geometry) {
    constructor(){
        super(), this.addAttribute("aVertexPosition", new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ])).addIndex([
            0,
            1,
            3,
            2
        ]);
    }
}

});

parcelRegister("eVEcT", function(module, exports) {

$parcel$export(module.exports, "QuadUv", () => $279feea3d3a65b2d$export$4f70783f37e4ec0b);

var $3u4Xc = parcelRequire("3u4Xc");

var $5K7Rq = parcelRequire("5K7Rq");
class $279feea3d3a65b2d$export$4f70783f37e4ec0b extends (0, $5K7Rq.Geometry) {
    constructor(){
        super(), this.vertices = new Float32Array([
            -1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1
        ]), this.uvs = new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ]), this.vertexBuffer = new (0, $3u4Xc.Buffer)(this.vertices), this.uvBuffer = new (0, $3u4Xc.Buffer)(this.uvs), this.addAttribute("aVertexPosition", this.vertexBuffer).addAttribute("aTextureCoord", this.uvBuffer).addIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
    }
    /**
   * Maps two Rectangle to the quad.
   * @param targetTextureFrame - The first rectangle
   * @param destinationFrame - The second rectangle
   * @returns - Returns itself.
   */ map(targetTextureFrame, destinationFrame) {
        let x = 0, y = 0;
        return this.uvs[0] = x, this.uvs[1] = y, this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width, this.uvs[3] = y, this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width, this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height, this.uvs[6] = x, this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height, x = destinationFrame.x, y = destinationFrame.y, this.vertices[0] = x, this.vertices[1] = y, this.vertices[2] = x + destinationFrame.width, this.vertices[3] = y, this.vertices[4] = x + destinationFrame.width, this.vertices[5] = y + destinationFrame.height, this.vertices[6] = x, this.vertices[7] = y + destinationFrame.height, this.invalidate(), this;
    }
    /**
   * Legacy upload method, just marks buffers dirty.
   * @returns - Returns itself.
   */ invalidate() {
        return this.vertexBuffer._updateID++, this.uvBuffer._updateID++, this;
    }
}

});

parcelRegister("aQmAq", function(module, exports) {

$parcel$export(module.exports, "FilterState", () => $748540a892ffb32c$export$ac6e0205a419d6d6);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("9fnly");
var $kZOeV = parcelRequire("kZOeV");
class $748540a892ffb32c$export$ac6e0205a419d6d6 {
    constructor(){
        this.renderTexture = null, this.target = null, this.legacy = !1, this.resolution = 1, this.multisample = (0, $lmRm8.MSAA_QUALITY).NONE, this.sourceFrame = new (0, $kZOeV.Rectangle)(), this.destinationFrame = new (0, $kZOeV.Rectangle)(), this.bindingSourceFrame = new (0, $kZOeV.Rectangle)(), this.bindingDestinationFrame = new (0, $kZOeV.Rectangle)(), this.filters = [], this.transform = null;
    }
    /** Clears the state */ clear() {
        this.target = null, this.filters = null, this.renderTexture = null;
    }
}

});


parcelRegister("8ermx", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9fnly");
var $kZOeV = parcelRequire("kZOeV");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");

var $9Tsjp = parcelRequire("9Tsjp");

var $9FWzE = parcelRequire("9FWzE");
const $00885252945baa09$var$tempRectangle = new (0, $kZOeV.Rectangle)();
class $00885252945baa09$export$3f472331251297cd {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.managedFramebuffers = [], this.unknownFramebuffer = new (0, $9Tsjp.Framebuffer)(10, 10), this.msaaSamples = null;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0);
        const gl = this.gl = this.renderer.gl;
        if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.current = this.unknownFramebuffer, this.viewport = new (0, $kZOeV.Rectangle)(), this.hasMRT = !0, this.writeDepthTexture = !0, this.renderer.context.webGLVersion === 1) {
            let nativeDrawBuffersExtension = this.renderer.context.extensions.drawBuffers, nativeDepthTextureExtension = this.renderer.context.extensions.depthTexture;
            (0, $16eqM.settings).PREFER_ENV === (0, $lmRm8.ENV).WEBGL_LEGACY && (nativeDrawBuffersExtension = null, nativeDepthTextureExtension = null), nativeDrawBuffersExtension ? gl.drawBuffers = (activeTextures)=>nativeDrawBuffersExtension.drawBuffersWEBGL(activeTextures) : (this.hasMRT = !1, gl.drawBuffers = ()=>{}), nativeDepthTextureExtension || (this.writeDepthTexture = !1);
        } else this.msaaSamples = gl.getInternalformatParameter(gl.RENDERBUFFER, gl.RGBA8, gl.SAMPLES);
    }
    /**
   * Bind a framebuffer.
   * @param framebuffer
   * @param frame - frame, default is framebuffer size
   * @param mipLevel - optional mip level to set on the framebuffer - defaults to 0
   */ bind(framebuffer, frame, mipLevel = 0) {
        const { gl: gl } = this;
        if (framebuffer) {
            const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(framebuffer);
            this.current !== framebuffer && (this.current = framebuffer, gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.framebuffer)), fbo.mipLevel !== mipLevel && (framebuffer.dirtyId++, framebuffer.dirtyFormat++, fbo.mipLevel = mipLevel), fbo.dirtyId !== framebuffer.dirtyId && (fbo.dirtyId = framebuffer.dirtyId, fbo.dirtyFormat !== framebuffer.dirtyFormat ? (fbo.dirtyFormat = framebuffer.dirtyFormat, fbo.dirtySize = framebuffer.dirtySize, this.updateFramebuffer(framebuffer, mipLevel)) : fbo.dirtySize !== framebuffer.dirtySize && (fbo.dirtySize = framebuffer.dirtySize, this.resizeFramebuffer(framebuffer)));
            for(let i = 0; i < framebuffer.colorTextures.length; i++){
                const tex = framebuffer.colorTextures[i];
                this.renderer.texture.unbind(tex.parentTextureArray || tex);
            }
            if (framebuffer.depthTexture && this.renderer.texture.unbind(framebuffer.depthTexture), frame) {
                const mipWidth = frame.width >> mipLevel, mipHeight = frame.height >> mipLevel, scale = mipWidth / frame.width;
                this.setViewport(frame.x * scale, frame.y * scale, mipWidth, mipHeight);
            } else {
                const mipWidth = framebuffer.width >> mipLevel, mipHeight = framebuffer.height >> mipLevel;
                this.setViewport(0, 0, mipWidth, mipHeight);
            }
        } else this.current && (this.current = null, gl.bindFramebuffer(gl.FRAMEBUFFER, null)), frame ? this.setViewport(frame.x, frame.y, frame.width, frame.height) : this.setViewport(0, 0, this.renderer.width, this.renderer.height);
    }
    /**
   * Set the WebGLRenderingContext's viewport.
   * @param x - X position of viewport
   * @param y - Y position of viewport
   * @param width - Width of viewport
   * @param height - Height of viewport
   */ setViewport(x, y, width, height) {
        const v = this.viewport;
        x = Math.round(x), y = Math.round(y), width = Math.round(width), height = Math.round(height), (v.width !== width || v.height !== height || v.x !== x || v.y !== y) && (v.x = x, v.y = y, v.width = width, v.height = height, this.gl.viewport(x, y, width, height));
    }
    /**
   * Get the size of the current width and height. Returns object with `width` and `height` values.
   * @readonly
   */ get size() {
        return this.current ? {
            x: 0,
            y: 0,
            width: this.current.width,
            height: this.current.height
        } : {
            x: 0,
            y: 0,
            width: this.renderer.width,
            height: this.renderer.height
        };
    }
    /**
   * Clear the color of the context
   * @param r - Red value from 0 to 1
   * @param g - Green value from 0 to 1
   * @param b - Blue value from 0 to 1
   * @param a - Alpha value from 0 to 1
   * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */ clear(r, g, b, a, mask = (0, $lmRm8.BUFFER_BITS).COLOR | (0, $lmRm8.BUFFER_BITS).DEPTH) {
        const { gl: gl } = this;
        gl.clearColor(r, g, b, a), gl.clear(mask);
    }
    /**
   * Initialize framebuffer for this context
   * @protected
   * @param framebuffer
   * @returns - created GLFramebuffer
   */ initFramebuffer(framebuffer) {
        const { gl: gl } = this, fbo = new (0, $9FWzE.GLFramebuffer)(gl.createFramebuffer());
        return fbo.multisample = this.detectSamples(framebuffer.multisample), framebuffer.glFramebuffers[this.CONTEXT_UID] = fbo, this.managedFramebuffers.push(framebuffer), framebuffer.disposeRunner.add(this), fbo;
    }
    /**
   * Resize the framebuffer
   * @param framebuffer
   * @protected
   */ resizeFramebuffer(framebuffer) {
        const { gl: gl } = this, fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (fbo.stencil) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            let stencilFormat;
            this.renderer.context.webGLVersion === 1 ? stencilFormat = gl.DEPTH_STENCIL : framebuffer.depth && framebuffer.stencil ? stencilFormat = gl.DEPTH24_STENCIL8 : framebuffer.depth ? stencilFormat = gl.DEPTH_COMPONENT24 : stencilFormat = gl.STENCIL_INDEX8, fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, framebuffer.width, framebuffer.height) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, framebuffer.width, framebuffer.height);
        }
        const colorTextures = framebuffer.colorTextures;
        let count = colorTextures.length;
        gl.drawBuffers || (count = Math.min(count, 1));
        for(let i = 0; i < count; i++){
            const texture = colorTextures[i], parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0), i === 0 && fbo.msaaBuffer && (gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer), gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, parentTexture._glTextures[this.CONTEXT_UID].internalFormat, framebuffer.width, framebuffer.height));
        }
        framebuffer.depthTexture && this.writeDepthTexture && this.renderer.texture.bind(framebuffer.depthTexture, 0);
    }
    /**
   * Update the framebuffer
   * @param framebuffer
   * @param mipLevel
   * @protected
   */ updateFramebuffer(framebuffer, mipLevel) {
        const { gl: gl } = this, fbo = framebuffer.glFramebuffers[this.CONTEXT_UID], colorTextures = framebuffer.colorTextures;
        let count = colorTextures.length;
        gl.drawBuffers || (count = Math.min(count, 1)), fbo.multisample > 1 && this.canMultisampleFramebuffer(framebuffer) ? fbo.msaaBuffer = fbo.msaaBuffer || gl.createRenderbuffer() : fbo.msaaBuffer && (gl.deleteRenderbuffer(fbo.msaaBuffer), fbo.msaaBuffer = null, fbo.blitFramebuffer && (fbo.blitFramebuffer.dispose(), fbo.blitFramebuffer = null));
        const activeTextures = [];
        for(let i = 0; i < count; i++){
            const texture = colorTextures[i], parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0), i === 0 && fbo.msaaBuffer ? (gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer), gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, parentTexture._glTextures[this.CONTEXT_UID].internalFormat, framebuffer.width, framebuffer.height), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, fbo.msaaBuffer)) : (gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, texture.target, parentTexture._glTextures[this.CONTEXT_UID].texture, mipLevel), activeTextures.push(gl.COLOR_ATTACHMENT0 + i));
        }
        if (activeTextures.length > 1 && gl.drawBuffers(activeTextures), framebuffer.depthTexture && this.writeDepthTexture) {
            const depthTexture = framebuffer.depthTexture;
            this.renderer.texture.bind(depthTexture, 0), gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, depthTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
        }
        if ((framebuffer.stencil || framebuffer.depth) && !(framebuffer.depthTexture && this.writeDepthTexture)) {
            fbo.stencil = fbo.stencil || gl.createRenderbuffer();
            let stencilAttachment, stencilFormat;
            this.renderer.context.webGLVersion === 1 ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH_STENCIL) : framebuffer.depth && framebuffer.stencil ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH24_STENCIL8) : framebuffer.depth ? (stencilAttachment = gl.DEPTH_ATTACHMENT, stencilFormat = gl.DEPTH_COMPONENT24) : (stencilAttachment = gl.STENCIL_ATTACHMENT, stencilFormat = gl.STENCIL_INDEX8), gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil), fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, framebuffer.width, framebuffer.height) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, framebuffer.width, framebuffer.height), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, stencilAttachment, gl.RENDERBUFFER, fbo.stencil);
        } else fbo.stencil && (gl.deleteRenderbuffer(fbo.stencil), fbo.stencil = null);
    }
    /**
   * Returns true if the frame buffer can be multisampled.
   * @param framebuffer
   */ canMultisampleFramebuffer(framebuffer) {
        return this.renderer.context.webGLVersion !== 1 && framebuffer.colorTextures.length <= 1 && !framebuffer.depthTexture;
    }
    /**
   * Detects number of samples that is not more than a param but as close to it as possible
   * @param samples - number of samples
   * @returns - recommended number of samples
   */ detectSamples(samples) {
        const { msaaSamples: msaaSamples } = this;
        let res = (0, $lmRm8.MSAA_QUALITY).NONE;
        if (samples <= 1 || msaaSamples === null) return res;
        for(let i = 0; i < msaaSamples.length; i++)if (msaaSamples[i] <= samples) {
            res = msaaSamples[i];
            break;
        }
        return res === 1 && (res = (0, $lmRm8.MSAA_QUALITY).NONE), res;
    }
    /**
   * Only works with WebGL2
   *
   * blits framebuffer to another of the same or bigger size
   * after that target framebuffer is bound
   *
   * Fails with WebGL warning if blits multisample framebuffer to different size
   * @param framebuffer - by default it blits "into itself", from renderBuffer to texture.
   * @param sourcePixels - source rectangle in pixels
   * @param destPixels - dest rectangle in pixels, assumed to be the same as sourcePixels
   */ blit(framebuffer, sourcePixels, destPixels) {
        const { current: current, renderer: renderer, gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        if (renderer.context.webGLVersion !== 2 || !current) return;
        const fbo = current.glFramebuffers[CONTEXT_UID];
        if (!fbo) return;
        if (!framebuffer) {
            if (!fbo.msaaBuffer) return;
            const colorTexture = current.colorTextures[0];
            if (!colorTexture) return;
            fbo.blitFramebuffer || (fbo.blitFramebuffer = new (0, $9Tsjp.Framebuffer)(current.width, current.height), fbo.blitFramebuffer.addColorTexture(0, colorTexture)), framebuffer = fbo.blitFramebuffer, framebuffer.colorTextures[0] !== colorTexture && (framebuffer.colorTextures[0] = colorTexture, framebuffer.dirtyId++, framebuffer.dirtyFormat++), (framebuffer.width !== current.width || framebuffer.height !== current.height) && (framebuffer.width = current.width, framebuffer.height = current.height, framebuffer.dirtyId++, framebuffer.dirtySize++);
        }
        sourcePixels || (sourcePixels = $00885252945baa09$var$tempRectangle, sourcePixels.width = current.width, sourcePixels.height = current.height), destPixels || (destPixels = sourcePixels);
        const sameSize = sourcePixels.width === destPixels.width && sourcePixels.height === destPixels.height;
        this.bind(framebuffer), gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fbo.framebuffer), gl.blitFramebuffer(sourcePixels.left, sourcePixels.top, sourcePixels.right, sourcePixels.bottom, destPixels.left, destPixels.top, destPixels.right, destPixels.bottom, gl.COLOR_BUFFER_BIT, sameSize ? gl.NEAREST : gl.LINEAR), gl.bindFramebuffer(gl.READ_FRAMEBUFFER, framebuffer.glFramebuffers[this.CONTEXT_UID].framebuffer);
    }
    /**
   * Disposes framebuffer.
   * @param framebuffer - framebuffer that has to be disposed of
   * @param contextLost - If context was lost, we suppress all delete function calls
   */ disposeFramebuffer(framebuffer, contextLost) {
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID], gl = this.gl;
        if (!fbo) return;
        delete framebuffer.glFramebuffers[this.CONTEXT_UID];
        const index = this.managedFramebuffers.indexOf(framebuffer);
        index >= 0 && this.managedFramebuffers.splice(index, 1), framebuffer.disposeRunner.remove(this), contextLost || (gl.deleteFramebuffer(fbo.framebuffer), fbo.msaaBuffer && gl.deleteRenderbuffer(fbo.msaaBuffer), fbo.stencil && gl.deleteRenderbuffer(fbo.stencil)), fbo.blitFramebuffer && this.disposeFramebuffer(fbo.blitFramebuffer, contextLost);
    }
    /**
   * Disposes all framebuffers, but not textures bound to them.
   * @param [contextLost=false] - If context was lost, we suppress all delete function calls
   */ disposeAll(contextLost) {
        const list = this.managedFramebuffers;
        this.managedFramebuffers = [];
        for(let i = 0; i < list.length; i++)this.disposeFramebuffer(list[i], contextLost);
    }
    /**
   * Forcing creation of stencil buffer for current framebuffer, if it wasn't done before.
   * Used by MaskSystem, when its time to use stencil mask for Graphics element.
   *
   * Its an alternative for public lazy `framebuffer.enableStencil`, in case we need stencil without rebind.
   * @private
   */ forceStencil() {
        const framebuffer = this.current;
        if (!framebuffer) return;
        const fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (!fbo || fbo.stencil && framebuffer.stencil) return;
        framebuffer.stencil = !0;
        const w = framebuffer.width, h = framebuffer.height, gl = this.gl, stencil = fbo.stencil = gl.createRenderbuffer();
        gl.bindRenderbuffer(gl.RENDERBUFFER, stencil);
        let stencilAttachment, stencilFormat;
        this.renderer.context.webGLVersion === 1 ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH_STENCIL) : framebuffer.depth ? (stencilAttachment = gl.DEPTH_STENCIL_ATTACHMENT, stencilFormat = gl.DEPTH24_STENCIL8) : (stencilAttachment = gl.STENCIL_ATTACHMENT, stencilFormat = gl.STENCIL_INDEX8), fbo.msaaBuffer ? gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, stencilFormat, w, h) : gl.renderbufferStorage(gl.RENDERBUFFER, stencilFormat, w, h), gl.framebufferRenderbuffer(gl.FRAMEBUFFER, stencilAttachment, gl.RENDERBUFFER, stencil);
    }
    /** Resets framebuffer stored state, binds screen framebuffer. Should be called before renderTexture reset(). */ reset() {
        this.current = this.unknownFramebuffer, this.viewport = new (0, $kZOeV.Rectangle)();
    }
    destroy() {
        this.renderer = null;
    }
}
$00885252945baa09$export$3f472331251297cd.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "framebuffer"
};
(0, $5RvHb.extensions).add($00885252945baa09$export$3f472331251297cd);

});
parcelRegister("9FWzE", function(module, exports) {

$parcel$export(module.exports, "GLFramebuffer", () => $10597bbb7318c4cd$export$47f6dbf489220e22);

var $lmRm8 = parcelRequire("lmRm8");
class $10597bbb7318c4cd$export$47f6dbf489220e22 {
    constructor(framebuffer){
        this.framebuffer = framebuffer, this.stencil = null, this.dirtyId = -1, this.dirtyFormat = -1, this.dirtySize = -1, this.multisample = (0, $lmRm8.MSAA_QUALITY).NONE, this.msaaBuffer = null, this.blitFramebuffer = null, this.mipLevel = 0;
    }
}

});


parcelRegister("1AXaI", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
const $fcc43430a275f613$var$byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
class $fcc43430a275f613$export$c83da0f390a7459c {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this.canUseUInt32ElementIndex = !1, this.managedGeometries = {};
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0);
        const gl = this.gl = this.renderer.gl, context = this.renderer.context;
        if (this.CONTEXT_UID = this.renderer.CONTEXT_UID, context.webGLVersion !== 2) {
            let nativeVaoExtension = this.renderer.context.extensions.vertexArrayObject;
            (0, $16eqM.settings).PREFER_ENV === (0, $lmRm8.ENV).WEBGL_LEGACY && (nativeVaoExtension = null), nativeVaoExtension ? (gl.createVertexArray = ()=>nativeVaoExtension.createVertexArrayOES(), gl.bindVertexArray = (vao)=>nativeVaoExtension.bindVertexArrayOES(vao), gl.deleteVertexArray = (vao)=>nativeVaoExtension.deleteVertexArrayOES(vao)) : (this.hasVao = !1, gl.createVertexArray = ()=>null, gl.bindVertexArray = ()=>null, gl.deleteVertexArray = ()=>null);
        }
        if (context.webGLVersion !== 2) {
            const instanceExt = gl.getExtension("ANGLE_instanced_arrays");
            instanceExt ? (gl.vertexAttribDivisor = (a, b)=>instanceExt.vertexAttribDivisorANGLE(a, b), gl.drawElementsInstanced = (a, b, c, d, e)=>instanceExt.drawElementsInstancedANGLE(a, b, c, d, e), gl.drawArraysInstanced = (a, b, c, d)=>instanceExt.drawArraysInstancedANGLE(a, b, c, d)) : this.hasInstance = !1;
        }
        this.canUseUInt32ElementIndex = context.webGLVersion === 2 || !!context.extensions.uint32ElementIndex;
    }
    /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param shader - Instance of shader to use vao for.
   */ bind(geometry, shader) {
        shader = shader || this.renderer.shader.shader;
        const { gl: gl } = this;
        let vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID], incRefCount = !1;
        vaos || (this.managedGeometries[geometry.id] = geometry, geometry.disposeRunner.add(this), geometry.glVertexArrayObjects[this.CONTEXT_UID] = vaos = {}, incRefCount = !0);
        const vao = vaos[shader.program.id] || this.initGeometryVao(geometry, shader, incRefCount);
        this._activeGeometry = geometry, this._activeVao !== vao && (this._activeVao = vao, this.hasVao ? gl.bindVertexArray(vao) : this.activateVao(geometry, shader.program)), this.updateBuffers();
    }
    /** Reset and unbind any active VAO and geometry. */ reset() {
        this.unbind();
    }
    /** Update buffers of the currently bound geometry. */ updateBuffers() {
        const geometry = this._activeGeometry, bufferSystem = this.renderer.buffer;
        for(let i = 0; i < geometry.buffers.length; i++){
            const buffer = geometry.buffers[i];
            bufferSystem.update(buffer);
        }
    }
    /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */ checkCompatibility(geometry, program) {
        const geometryAttributes = geometry.attributes, shaderAttributes = program.attributeData;
        for(const j in shaderAttributes)if (!geometryAttributes[j]) throw new Error(`shader and geometry incompatible, geometry missing the "${j}" attribute`);
    }
    /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */ getSignature(geometry, program) {
        const attribs = geometry.attributes, shaderAttributes = program.attributeData, strings = [
            "g",
            geometry.id
        ];
        for(const i in attribs)shaderAttributes[i] && strings.push(i, shaderAttributes[i].location);
        return strings.join("-");
    }
    /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param shader - Instance of the shader.
   * @param incRefCount - Increment refCount of all geometry buffers.
   */ initGeometryVao(geometry, shader, incRefCount = !0) {
        const gl = this.gl, CONTEXT_UID = this.CONTEXT_UID, bufferSystem = this.renderer.buffer, program = shader.program;
        program.glPrograms[CONTEXT_UID] || this.renderer.shader.generateProgram(shader), this.checkCompatibility(geometry, program);
        const signature = this.getSignature(geometry, program), vaoObjectHash = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        let vao = vaoObjectHash[signature];
        if (vao) return vaoObjectHash[program.id] = vao, vao;
        const buffers = geometry.buffers, attributes = geometry.attributes, tempStride = {}, tempStart = {};
        for(const j in buffers)tempStride[j] = 0, tempStart[j] = 0;
        for(const j in attributes)!attributes[j].size && program.attributeData[j] ? attributes[j].size = program.attributeData[j].size : attributes[j].size || console.warn(`PIXI Geometry attribute '${j}' size cannot be determined (likely the bound shader does not have the attribute)`), tempStride[attributes[j].buffer] += attributes[j].size * $fcc43430a275f613$var$byteSizeMap[attributes[j].type];
        for(const j in attributes){
            const attribute = attributes[j], attribSize = attribute.size;
            attribute.stride === void 0 && (tempStride[attribute.buffer] === attribSize * $fcc43430a275f613$var$byteSizeMap[attribute.type] ? attribute.stride = 0 : attribute.stride = tempStride[attribute.buffer]), attribute.start === void 0 && (attribute.start = tempStart[attribute.buffer], tempStart[attribute.buffer] += attribSize * $fcc43430a275f613$var$byteSizeMap[attribute.type]);
        }
        vao = gl.createVertexArray(), gl.bindVertexArray(vao);
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            bufferSystem.bind(buffer), incRefCount && buffer._glBuffers[CONTEXT_UID].refCount++;
        }
        return this.activateVao(geometry, program), vaoObjectHash[program.id] = vao, vaoObjectHash[signature] = vao, gl.bindVertexArray(null), bufferSystem.unbind((0, $lmRm8.BUFFER_TYPE).ARRAY_BUFFER), vao;
    }
    /**
   * Disposes geometry.
   * @param geometry - Geometry with buffers. Only VAO will be disposed
   * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */ disposeGeometry(geometry, contextLost) {
        if (!this.managedGeometries[geometry.id]) return;
        delete this.managedGeometries[geometry.id];
        const vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID], gl = this.gl, buffers = geometry.buffers, bufferSystem = this.renderer?.buffer;
        if (geometry.disposeRunner.remove(this), !!vaos) {
            if (bufferSystem) for(let i = 0; i < buffers.length; i++){
                const buf = buffers[i]._glBuffers[this.CONTEXT_UID];
                buf && (buf.refCount--, buf.refCount === 0 && !contextLost && bufferSystem.dispose(buffers[i], contextLost));
            }
            if (!contextLost) {
                for(const vaoId in vaos)if (vaoId[0] === "g") {
                    const vao = vaos[vaoId];
                    this._activeVao === vao && this.unbind(), gl.deleteVertexArray(vao);
                }
            }
            delete geometry.glVertexArrayObjects[this.CONTEXT_UID];
        }
    }
    /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */ disposeAll(contextLost) {
        const all = Object.keys(this.managedGeometries);
        for(let i = 0; i < all.length; i++)this.disposeGeometry(this.managedGeometries[all[i]], contextLost);
    }
    /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */ activateVao(geometry, program) {
        const gl = this.gl, CONTEXT_UID = this.CONTEXT_UID, bufferSystem = this.renderer.buffer, buffers = geometry.buffers, attributes = geometry.attributes;
        geometry.indexBuffer && bufferSystem.bind(geometry.indexBuffer);
        let lastBuffer = null;
        for(const j in attributes){
            const attribute = attributes[j], buffer = buffers[attribute.buffer], glBuffer = buffer._glBuffers[CONTEXT_UID];
            if (program.attributeData[j]) {
                lastBuffer !== glBuffer && (bufferSystem.bind(buffer), lastBuffer = glBuffer);
                const location = program.attributeData[j].location;
                if (gl.enableVertexAttribArray(location), gl.vertexAttribPointer(location, attribute.size, attribute.type || gl.FLOAT, attribute.normalized, attribute.stride, attribute.start), attribute.instance) {
                    if (this.hasInstance) gl.vertexAttribDivisor(location, attribute.divisor);
                    else throw new Error("geometry error, GPU Instancing is not supported on this device");
                }
            }
        }
    }
    /**
   * Draws the currently bound geometry.
   * @param type - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, all vertices after the
   *  starting vertex will be drawn.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   */ draw(type, size, start, instanceCount) {
        const { gl: gl } = this, geometry = this._activeGeometry;
        if (geometry.indexBuffer) {
            const byteSize = geometry.indexBuffer.data.BYTES_PER_ELEMENT, glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
            byteSize === 2 || byteSize === 4 && this.canUseUInt32ElementIndex ? geometry.instanced ? gl.drawElementsInstanced(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize, instanceCount || 1) : gl.drawElements(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize) : console.warn("unsupported index buffer type: uint32");
        } else geometry.instanced ? gl.drawArraysInstanced(type, start, size || geometry.getSize(), instanceCount || 1) : gl.drawArrays(type, start, size || geometry.getSize());
        return this;
    }
    /** Unbind/reset everything. */ unbind() {
        this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
    }
    destroy() {
        this.renderer = null;
    }
}
$fcc43430a275f613$export$c83da0f390a7459c.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "geometry"
};
(0, $5RvHb.extensions).add($fcc43430a275f613$export$c83da0f390a7459c);

});

parcelRegister("1GdhN", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");

var $bkval = parcelRequire("bkval");

var $giCpI = parcelRequire("giCpI");
class $3c77e5f209e855e8$export$a1fbfb1b9cf60ed0 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.enableScissor = !0, this.alphaMaskPool = [], this.maskDataPool = [], this.maskStack = [], this.alphaMaskIndex = 0;
    }
    /**
   * Changes the mask stack that is used by this System.
   * @param maskStack - The mask stack
   */ setMaskStack(maskStack) {
        this.maskStack = maskStack, this.renderer.scissor.setMaskStack(maskStack), this.renderer.stencil.setMaskStack(maskStack);
    }
    /**
   * Enables the mask and appends it to the current mask stack.
   *
   * NOTE: The batch renderer should be flushed beforehand to prevent pending renders from being masked.
   * @param {PIXI.DisplayObject} target - Display Object to push the mask to
   * @param {PIXI.MaskData|PIXI.Sprite|PIXI.Graphics|PIXI.DisplayObject} maskDataOrTarget - The masking data.
   */ push(target, maskDataOrTarget) {
        let maskData = maskDataOrTarget;
        if (!maskData.isMaskData) {
            const d = this.maskDataPool.pop() || new (0, $giCpI.MaskData)();
            d.pooled = !0, d.maskObject = maskDataOrTarget, maskData = d;
        }
        const maskAbove = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
        if (maskData.copyCountersOrReset(maskAbove), maskData._colorMask = maskAbove ? maskAbove._colorMask : 15, maskData.autoDetect && this.detect(maskData), maskData._target = target, maskData.type !== (0, $lmRm8.MASK_TYPES).SPRITE && this.maskStack.push(maskData), maskData.enabled) switch(maskData.type){
            case (0, $lmRm8.MASK_TYPES).SCISSOR:
                this.renderer.scissor.push(maskData);
                break;
            case (0, $lmRm8.MASK_TYPES).STENCIL:
                this.renderer.stencil.push(maskData);
                break;
            case (0, $lmRm8.MASK_TYPES).SPRITE:
                maskData.copyCountersOrReset(null), this.pushSpriteMask(maskData);
                break;
            case (0, $lmRm8.MASK_TYPES).COLOR:
                this.pushColorMask(maskData);
                break;
            default:
                break;
        }
        maskData.type === (0, $lmRm8.MASK_TYPES).SPRITE && this.maskStack.push(maskData);
    }
    /**
   * Removes the last mask from the mask stack and doesn't return it.
   *
   * NOTE: The batch renderer should be flushed beforehand to render the masked contents before the mask is removed.
   * @param {PIXI.IMaskTarget} target - Display Object to pop the mask from
   */ pop(target) {
        const maskData = this.maskStack.pop();
        if (!(!maskData || maskData._target !== target)) {
            if (maskData.enabled) switch(maskData.type){
                case (0, $lmRm8.MASK_TYPES).SCISSOR:
                    this.renderer.scissor.pop(maskData);
                    break;
                case (0, $lmRm8.MASK_TYPES).STENCIL:
                    this.renderer.stencil.pop(maskData.maskObject);
                    break;
                case (0, $lmRm8.MASK_TYPES).SPRITE:
                    this.popSpriteMask(maskData);
                    break;
                case (0, $lmRm8.MASK_TYPES).COLOR:
                    this.popColorMask(maskData);
                    break;
                default:
                    break;
            }
            if (maskData.reset(), maskData.pooled && this.maskDataPool.push(maskData), this.maskStack.length !== 0) {
                const maskCurrent = this.maskStack[this.maskStack.length - 1];
                maskCurrent.type === (0, $lmRm8.MASK_TYPES).SPRITE && maskCurrent._filters && (maskCurrent._filters[0].maskSprite = maskCurrent.maskObject);
            }
        }
    }
    /**
   * Sets type of MaskData based on its maskObject.
   * @param maskData
   */ detect(maskData) {
        const maskObject = maskData.maskObject;
        maskObject ? maskObject.isSprite ? maskData.type = (0, $lmRm8.MASK_TYPES).SPRITE : this.enableScissor && this.renderer.scissor.testScissor(maskData) ? maskData.type = (0, $lmRm8.MASK_TYPES).SCISSOR : maskData.type = (0, $lmRm8.MASK_TYPES).STENCIL : maskData.type = (0, $lmRm8.MASK_TYPES).COLOR;
    }
    /**
   * Applies the Mask and adds it to the current filter stack.
   * @param maskData - Sprite to be used as the mask.
   */ pushSpriteMask(maskData) {
        const { maskObject: maskObject } = maskData, target = maskData._target;
        let alphaMaskFilter = maskData._filters;
        alphaMaskFilter || (alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex], alphaMaskFilter || (alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [
            new (0, $bkval.SpriteMaskFilter)()
        ])), alphaMaskFilter[0].resolution = maskData.resolution, alphaMaskFilter[0].multisample = maskData.multisample, alphaMaskFilter[0].maskSprite = maskObject;
        const stashFilterArea = target.filterArea;
        target.filterArea = maskObject.getBounds(!0), this.renderer.filter.push(target, alphaMaskFilter), target.filterArea = stashFilterArea, maskData._filters || this.alphaMaskIndex++;
    }
    /**
   * Removes the last filter from the filter stack and doesn't return it.
   * @param maskData - Sprite to be used as the mask.
   */ popSpriteMask(maskData) {
        this.renderer.filter.pop(), maskData._filters ? maskData._filters[0].maskSprite = null : (this.alphaMaskIndex--, this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null);
    }
    /**
   * Pushes the color mask.
   * @param maskData - The mask data
   */ pushColorMask(maskData) {
        const currColorMask = maskData._colorMask, nextColorMask = maskData._colorMask = currColorMask & maskData.colorMask;
        nextColorMask !== currColorMask && this.renderer.gl.colorMask((nextColorMask & 1) !== 0, (nextColorMask & 2) !== 0, (nextColorMask & 4) !== 0, (nextColorMask & 8) !== 0);
    }
    /**
   * Pops the color mask.
   * @param maskData - The mask data
   */ popColorMask(maskData) {
        const currColorMask = maskData._colorMask, nextColorMask = this.maskStack.length > 0 ? this.maskStack[this.maskStack.length - 1]._colorMask : 15;
        nextColorMask !== currColorMask && this.renderer.gl.colorMask((nextColorMask & 1) !== 0, (nextColorMask & 2) !== 0, (nextColorMask & 4) !== 0, (nextColorMask & 8) !== 0);
    }
    destroy() {
        this.renderer = null;
    }
}
$3c77e5f209e855e8$export$a1fbfb1b9cf60ed0.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "mask"
};
(0, $5RvHb.extensions).add($3c77e5f209e855e8$export$a1fbfb1b9cf60ed0);

});
parcelRegister("bkval", function(module, exports) {

$parcel$export(module.exports, "SpriteMaskFilter", () => $771a97de5f15aae9$export$6b66f8c14dea0d0);
parcelRequire("9fnly");
var $6wJoy = parcelRequire("6wJoy");

var $aHJRR = parcelRequire("aHJRR");

var $3x7iq = parcelRequire("3x7iq");

var $lfW0l = parcelRequire("lfW0l");

var $g410k = parcelRequire("g410k");
class $771a97de5f15aae9$export$6b66f8c14dea0d0 extends (0, $3x7iq.Filter) {
    /** @ignore */ constructor(vertexSrc, fragmentSrc, uniforms){
        let sprite = null;
        typeof vertexSrc != "string" && fragmentSrc === void 0 && uniforms === void 0 && (sprite = vertexSrc, vertexSrc = void 0, fragmentSrc = void 0, uniforms = void 0), super(vertexSrc || (0, $g410k.default), fragmentSrc || (0, $lfW0l.default), uniforms), this.maskSprite = sprite, this.maskMatrix = new (0, $6wJoy.Matrix)();
    }
    /**
   * Sprite mask
   * @type {PIXI.DisplayObject}
   */ get maskSprite() {
        return this._maskSprite;
    }
    set maskSprite(value) {
        this._maskSprite = value, this._maskSprite && (this._maskSprite.renderable = !1);
    }
    /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it.
   */ apply(filterManager, input, output, clearMode) {
        const maskSprite = this._maskSprite, tex = maskSprite._texture;
        tex.valid && (tex.uvMatrix || (tex.uvMatrix = new (0, $aHJRR.TextureMatrix)(tex, 0)), tex.uvMatrix.update(), this.uniforms.npmAlpha = tex.baseTexture.alphaMode ? 0 : 1, this.uniforms.mask = tex, this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.uvMatrix.mapCoord), this.uniforms.alpha = maskSprite.worldAlpha, this.uniforms.maskClamp = tex.uvMatrix.uClampFrame, filterManager.applyFilter(this, input, output, clearMode));
    }
}

});
parcelRegister("aHJRR", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $8da561ec6e817bba$export$dbea3135e9da48cb);
parcelRequire("9fnly");
var $6wJoy = parcelRequire("6wJoy");
const $8da561ec6e817bba$var$tempMat = new (0, $6wJoy.Matrix)();
class $8da561ec6e817bba$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this._texture = texture, this.mapCoord = new (0, $6wJoy.Matrix)(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._textureID = -1, this._updateID = 0, this.clampOffset = 0, this.clampMargin = typeof clampMargin > "u" ? 0.5 : clampMargin, this.isSimple = !1;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        this._texture = value, this._textureID = -1;
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        out === void 0 && (out = uvs);
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i], y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx, out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed.
   * @param [forceUpdate=false] - if true, matrices will be updated any case
   * @returns - Whether or not it was updated
   */ update(forceUpdate) {
        const tex = this._texture;
        if (!tex || !tex.valid || !forceUpdate && this._textureID === tex._updateID) return !1;
        this._textureID = tex._updateID, this._updateID++;
        const uvs = tex._uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig, trim = tex.trim;
        trim && ($8da561ec6e817bba$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height), this.mapCoord.append($8da561ec6e817bba$var$tempMat));
        const texBase = tex.baseTexture, frame = this.uClampFrame, margin = this.clampMargin / texBase.resolution, offset = this.clampOffset;
        return frame[0] = (tex._frame.x + margin + offset) / texBase.width, frame[1] = (tex._frame.y + margin + offset) / texBase.height, frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width, frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height, this.uClampOffset[0] = offset / texBase.realWidth, this.uClampOffset[1] = offset / texBase.realHeight, this.isSimple = tex._frame.width === texBase.width && tex._frame.height === texBase.height && tex.rotate === 0, !0;
    }
}

});

parcelRegister("lfW0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $66452d8c943d9456$export$2e2bcd8739ae039);
var $66452d8c943d9456$export$2e2bcd8739ae039 = `varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform sampler2D mask;
uniform float alpha;
uniform float npmAlpha;
uniform vec4 maskClamp;

void main(void)
{
    float clip = step(3.5,
        step(maskClamp.x, vMaskCoord.x) +
        step(maskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, maskClamp.z) +
        step(vMaskCoord.y, maskClamp.w));

    vec4 original = texture2D(uSampler, vTextureCoord);
    vec4 masky = texture2D(mask, vMaskCoord);
    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);

    original *= (alphaMul * masky.r * alpha * clip);

    gl_FragColor = original;
}
`;

});

parcelRegister("g410k", function(module, exports) {

$parcel$export(module.exports, "default", () => $988abae289f434eb$export$2e2bcd8739ae039);
var $988abae289f434eb$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 otherMatrix;

varying vec2 vMaskCoord;
varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;
}
`;

});


parcelRegister("giCpI", function(module, exports) {

$parcel$export(module.exports, "MaskData", () => $ad086241daacc652$export$c75dec3795e98612);

var $lmRm8 = parcelRequire("lmRm8");

var $3x7iq = parcelRequire("3x7iq");
class $ad086241daacc652$export$c75dec3795e98612 {
    /**
   * Create MaskData
   * @param {PIXI.DisplayObject} [maskObject=null] - object that describes the mask
   */ constructor(maskObject = null){
        this.type = (0, $lmRm8.MASK_TYPES).NONE, this.autoDetect = !0, this.maskObject = maskObject || null, this.pooled = !1, this.isMaskData = !0, this.resolution = null, this.multisample = (0, $3x7iq.Filter).defaultMultisample, this.enabled = !0, this.colorMask = 15, this._filters = null, this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null, this._scissorRectLocal = null, this._colorMask = 15, this._target = null;
    }
    /**
   * The sprite mask filter.
   * If set to `null`, the default sprite mask filter is used.
   * @default null
   */ get filter() {
        return this._filters ? this._filters[0] : null;
    }
    set filter(value) {
        value ? this._filters ? this._filters[0] = value : this._filters = [
            value
        ] : this._filters = null;
    }
    /** Resets the mask data after popMask(). */ reset() {
        this.pooled && (this.maskObject = null, this.type = (0, $lmRm8.MASK_TYPES).NONE, this.autoDetect = !0), this._target = null, this._scissorRectLocal = null;
    }
    /**
   * Copies counters from maskData above, called from pushMask().
   * @param maskAbove
   */ copyCountersOrReset(maskAbove) {
        maskAbove ? (this._stencilCounter = maskAbove._stencilCounter, this._scissorCounter = maskAbove._scissorCounter, this._scissorRect = maskAbove._scissorRect) : (this._stencilCounter = 0, this._scissorCounter = 0, this._scissorRect = null);
    }
}

});


parcelRegister("jLQZ8", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9fnly");
var $6wJoy = parcelRequire("6wJoy");
var $kZOeV = parcelRequire("kZOeV");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");

var $aAPqH = parcelRequire("aAPqH");
const $1d5edd4fe0f05794$var$tempMatrix = new (0, $6wJoy.Matrix)(), $1d5edd4fe0f05794$var$rectPool = [], $1d5edd4fe0f05794$var$_ScissorSystem = class _ScissorSystem2 extends (0, $aAPqH.AbstractMaskSystem) {
    /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */ constructor(renderer){
        super(renderer), this.glConst = (0, $16eqM.settings).ADAPTER.getWebGLRenderingContext().SCISSOR_TEST;
    }
    getStackLength() {
        const maskData = this.maskStack[this.maskStack.length - 1];
        return maskData ? maskData._scissorCounter : 0;
    }
    /**
   * evaluates _boundsTransformed, _scissorRect for MaskData
   * @param maskData
   */ calcScissorRect(maskData) {
        if (maskData._scissorRectLocal) return;
        const prevData = maskData._scissorRect, { maskObject: maskObject } = maskData, { renderer: renderer } = this, renderTextureSystem = renderer.renderTexture, rect = maskObject.getBounds(!0, $1d5edd4fe0f05794$var$rectPool.pop() ?? new (0, $kZOeV.Rectangle)());
        this.roundFrameToPixels(rect, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform), prevData && rect.fit(prevData), maskData._scissorRectLocal = rect;
    }
    static isMatrixRotated(matrix) {
        if (!matrix) return !1;
        const { a: a, b: b, c: c, d: d } = matrix;
        return (Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4);
    }
    /**
   * Test, whether the object can be scissor mask with current renderer projection.
   * Calls "calcScissorRect()" if its true.
   * @param maskData - mask data
   * @returns whether Whether the object can be scissor mask
   */ testScissor(maskData) {
        const { maskObject: maskObject } = maskData;
        if (!maskObject.isFastRect || !maskObject.isFastRect() || _ScissorSystem2.isMatrixRotated(maskObject.worldTransform) || _ScissorSystem2.isMatrixRotated(this.renderer.projection.transform)) return !1;
        this.calcScissorRect(maskData);
        const rect = maskData._scissorRectLocal;
        return rect.width > 0 && rect.height > 0;
    }
    roundFrameToPixels(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        _ScissorSystem2.isMatrixRotated(transform) || (transform = transform ? $1d5edd4fe0f05794$var$tempMatrix.copyFrom(transform) : $1d5edd4fe0f05794$var$tempMatrix.identity(), transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y), this.renderer.filter.transformAABB(transform, frame), frame.fit(bindingDestinationFrame), frame.x = Math.round(frame.x * resolution), frame.y = Math.round(frame.y * resolution), frame.width = Math.round(frame.width * resolution), frame.height = Math.round(frame.height * resolution));
    }
    /**
   * Applies the Mask and adds it to the current stencil stack.
   * @author alvin
   * @param maskData - The mask data.
   */ push(maskData) {
        maskData._scissorRectLocal || this.calcScissorRect(maskData);
        const { gl: gl } = this.renderer;
        maskData._scissorRect || gl.enable(gl.SCISSOR_TEST), maskData._scissorCounter++, maskData._scissorRect = maskData._scissorRectLocal, this._useCurrent();
    }
    /**
   * This should be called after a mask is popped off the mask stack. It will rebind the scissor box to be latest with the
   * last mask in the stack.
   *
   * This can also be called when you directly modify the scissor box and want to restore PixiJS state.
   * @param maskData - The mask data.
   */ pop(maskData) {
        const { gl: gl } = this.renderer;
        maskData && $1d5edd4fe0f05794$var$rectPool.push(maskData._scissorRectLocal), this.getStackLength() > 0 ? this._useCurrent() : gl.disable(gl.SCISSOR_TEST);
    }
    /**
   * Setup renderer to use the current scissor data.
   * @private
   */ _useCurrent() {
        const rect = this.maskStack[this.maskStack.length - 1]._scissorRect;
        let y;
        this.renderer.renderTexture.current ? y = rect.y : y = this.renderer.height - rect.height - rect.y, this.renderer.gl.scissor(rect.x, y, rect.width, rect.height);
    }
};
$1d5edd4fe0f05794$var$_ScissorSystem.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "scissor"
};
let $1d5edd4fe0f05794$export$1851870585e6357f = $1d5edd4fe0f05794$var$_ScissorSystem;
(0, $5RvHb.extensions).add($1d5edd4fe0f05794$export$1851870585e6357f);

});
parcelRegister("aAPqH", function(module, exports) {

$parcel$export(module.exports, "AbstractMaskSystem", () => $f09bb6797a33b232$export$c83199503f0366e9);
class $f09bb6797a33b232$export$c83199503f0366e9 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.maskStack = [], this.glConst = 0;
    }
    /** Gets count of masks of certain type. */ getStackLength() {
        return this.maskStack.length;
    }
    /**
   * Changes the mask stack that is used by this System.
   * @param {PIXI.MaskData[]} maskStack - The mask stack
   */ setMaskStack(maskStack) {
        const { gl: gl } = this.renderer, curStackLen = this.getStackLength();
        this.maskStack = maskStack;
        const newStackLen = this.getStackLength();
        newStackLen !== curStackLen && (newStackLen === 0 ? gl.disable(this.glConst) : (gl.enable(this.glConst), this._useCurrent()));
    }
    /**
   * Setup renderer to use the current mask data.
   * @private
   */ _useCurrent() {}
    /** Destroys the mask stack. */ destroy() {
        this.renderer = null, this.maskStack = null;
    }
}

});


parcelRegister("ihQE2", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");

var $aAPqH = parcelRequire("aAPqH");
class $465a5eb10e7d2e5e$export$d3824b839b1639a2 extends (0, $aAPqH.AbstractMaskSystem) {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        super(renderer), this.glConst = (0, $16eqM.settings).ADAPTER.getWebGLRenderingContext().STENCIL_TEST;
    }
    getStackLength() {
        const maskData = this.maskStack[this.maskStack.length - 1];
        return maskData ? maskData._stencilCounter : 0;
    }
    /**
   * Applies the Mask and adds it to the current stencil stack.
   * @param maskData - The mask data
   */ push(maskData) {
        const maskObject = maskData.maskObject, { gl: gl } = this.renderer, prevMaskCount = maskData._stencilCounter;
        prevMaskCount === 0 && (this.renderer.framebuffer.forceStencil(), gl.clearStencil(0), gl.clear(gl.STENCIL_BUFFER_BIT), gl.enable(gl.STENCIL_TEST)), maskData._stencilCounter++;
        const colorMask = maskData._colorMask;
        colorMask !== 0 && (maskData._colorMask = 0, gl.colorMask(!1, !1, !1, !1)), gl.stencilFunc(gl.EQUAL, prevMaskCount, 4294967295), gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR), maskObject.renderable = !0, maskObject.render(this.renderer), this.renderer.batch.flush(), maskObject.renderable = !1, colorMask !== 0 && (maskData._colorMask = colorMask, gl.colorMask((colorMask & 1) !== 0, (colorMask & 2) !== 0, (colorMask & 4) !== 0, (colorMask & 8) !== 0)), this._useCurrent();
    }
    /**
   * Pops stencil mask. MaskData is already removed from stack
   * @param {PIXI.DisplayObject} maskObject - object of popped mask data
   */ pop(maskObject) {
        const gl = this.renderer.gl;
        if (this.getStackLength() === 0) gl.disable(gl.STENCIL_TEST);
        else {
            const maskData = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null, colorMask = maskData ? maskData._colorMask : 15;
            colorMask !== 0 && (maskData._colorMask = 0, gl.colorMask(!1, !1, !1, !1)), gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR), maskObject.renderable = !0, maskObject.render(this.renderer), this.renderer.batch.flush(), maskObject.renderable = !1, colorMask !== 0 && (maskData._colorMask = colorMask, gl.colorMask((colorMask & 1) !== 0, (colorMask & 2) !== 0, (colorMask & 4) !== 0, (colorMask & 8) !== 0)), this._useCurrent();
        }
    }
    /**
   * Setup renderer to use the current stencil data.
   * @private
   */ _useCurrent() {
        const gl = this.renderer.gl;
        gl.stencilFunc(gl.EQUAL, this.getStackLength(), 4294967295), gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    }
}
$465a5eb10e7d2e5e$export$d3824b839b1639a2.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "stencil"
};
(0, $5RvHb.extensions).add($465a5eb10e7d2e5e$export$d3824b839b1639a2);

});

parcelRegister("Hj4cm", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("lFGyw");
var $1Koy5 = parcelRequire("1Koy5");
class $f182bcab91789d6c$export$b037d01b38347d8b {
    constructor(renderer){
        this.renderer = renderer, this.plugins = {}, Object.defineProperties(this.plugins, {
            extract: {
                enumerable: !1,
                get () {
                    return (0, $1Koy5.deprecation)("7.0.0", "renderer.plugins.extract has moved to renderer.extract"), renderer.extract;
                }
            },
            prepare: {
                enumerable: !1,
                get () {
                    return (0, $1Koy5.deprecation)("7.0.0", "renderer.plugins.prepare has moved to renderer.prepare"), renderer.prepare;
                }
            },
            interaction: {
                enumerable: !1,
                get () {
                    return (0, $1Koy5.deprecation)("7.0.0", "renderer.plugins.interaction has been deprecated, use renderer.events"), renderer.events;
                }
            }
        });
    }
    /**
   * Initialize the plugins.
   * @protected
   */ init() {
        const staticMap = this.rendererPlugins;
        for(const o in staticMap)this.plugins[o] = new staticMap[o](this.renderer);
    }
    destroy() {
        for(const o in this.plugins)this.plugins[o].destroy(), this.plugins[o] = null;
    }
}
$f182bcab91789d6c$export$b037d01b38347d8b.extension = {
    type: [
        (0, $5RvHb.ExtensionType).RendererSystem,
        (0, $5RvHb.ExtensionType).CanvasRendererSystem
    ],
    name: "_plugin"
};
(0, $5RvHb.extensions).add($f182bcab91789d6c$export$b037d01b38347d8b);

});

parcelRegister("awCJH", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9fnly");
var $6wJoy = parcelRequire("6wJoy");
class $ff9e21dfc196d981$export$84be2be6fb3066d2 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.destinationFrame = null, this.sourceFrame = null, this.defaultFrame = null, this.projectionMatrix = new (0, $6wJoy.Matrix)(), this.transform = null;
    }
    /**
   * Updates the projection-matrix based on the sourceFrame → destinationFrame mapping provided.
   *
   * NOTE: It is expected you call `renderer.framebuffer.setViewport(destinationFrame)` after this. This is because
   * the framebuffer viewport converts shader vertex output in normalized device coordinates to window coordinates.
   *
   * NOTE-2: {@link PIXI.RenderTextureSystem#bind} updates the projection-matrix when you bind a render-texture.
   * It is expected
   * that you dirty the current bindings when calling this manually.
   * @param destinationFrame - The rectangle in the render-target to render the contents into. If rendering to the canvas,
   *  the origin is on the top-left; if rendering to a render-texture, the origin is on the bottom-left.
   * @param sourceFrame - The rectangle in world space that contains the contents being rendered.
   * @param resolution - The resolution of the render-target, which is the ratio of
   *  world-space (or CSS) pixels to physical pixels.
   * @param root - Whether the render-target is the screen. This is required because rendering to textures
   *  is y-flipped (i.e. upside down relative to the screen).
   */ update(destinationFrame, sourceFrame, resolution, root) {
        this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame, this.sourceFrame = sourceFrame || this.sourceFrame || destinationFrame, this.calculateProjection(this.destinationFrame, this.sourceFrame, resolution, root), this.transform && this.projectionMatrix.append(this.transform);
        const renderer = this.renderer;
        renderer.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix, renderer.globalUniforms.update(), renderer.shader.shader && renderer.shader.syncUniformGroup(renderer.shader.shader.uniforms.globals);
    }
    /**
   * Calculates the `projectionMatrix` to map points inside `sourceFrame` to inside `destinationFrame`.
   * @param _destinationFrame - The destination frame in the render-target.
   * @param sourceFrame - The source frame in world space.
   * @param _resolution - The render-target's resolution, i.e. ratio of CSS to physical pixels.
   * @param root - Whether rendering into the screen. Otherwise, if rendering to a framebuffer, the projection
   *  is y-flipped.
   */ calculateProjection(_destinationFrame, sourceFrame, _resolution, root) {
        const pm = this.projectionMatrix, sign = root ? -1 : 1;
        pm.identity(), pm.a = 1 / sourceFrame.width * 2, pm.d = sign * (1 / sourceFrame.height * 2), pm.tx = -1 - sourceFrame.x * pm.a, pm.ty = -sign - sourceFrame.y * pm.d;
    }
    /**
   * Sets the transform of the active render target to the given matrix.
   * @param _matrix - The transformation matrix
   */ setTransform(_matrix) {}
    destroy() {
        this.renderer = null;
    }
}
$ff9e21dfc196d981$export$84be2be6fb3066d2.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "projection"
};
(0, $5RvHb.extensions).add($ff9e21dfc196d981$export$84be2be6fb3066d2);

});

parcelRegister("8Faf6", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9fnly");
var $6wJoy = parcelRequire("6wJoy");
var $kZOeV = parcelRequire("kZOeV");
var $9jXhN = parcelRequire("9jXhN");

var $4UuR4 = parcelRequire("4UuR4");
const $77b4b0fc4afd1be0$var$tempTransform = new (0, $9jXhN.Transform)(), $77b4b0fc4afd1be0$var$tempRect = new (0, $kZOeV.Rectangle)();
class $77b4b0fc4afd1be0$export$690776504ee197a6 {
    constructor(renderer){
        this.renderer = renderer, this._tempMatrix = new (0, $6wJoy.Matrix)();
    }
    /**
   * A Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns a shiny new texture of the display object passed in
   */ generateTexture(displayObject, options) {
        const { region: manualRegion, ...textureOptions } = options || {}, region = manualRegion?.copyTo($77b4b0fc4afd1be0$var$tempRect) || displayObject.getLocalBounds($77b4b0fc4afd1be0$var$tempRect, !0), resolution = textureOptions.resolution || this.renderer.resolution;
        region.width = Math.max(region.width, 1 / resolution), region.height = Math.max(region.height, 1 / resolution), textureOptions.width = region.width, textureOptions.height = region.height, textureOptions.resolution = resolution, textureOptions.multisample ?? (textureOptions.multisample = this.renderer.multisample);
        const renderTexture = (0, $4UuR4.RenderTexture).create(textureOptions);
        this._tempMatrix.tx = -region.x, this._tempMatrix.ty = -region.y;
        const transform = displayObject.transform;
        return displayObject.transform = $77b4b0fc4afd1be0$var$tempTransform, this.renderer.render(displayObject, {
            renderTexture: renderTexture,
            transform: this._tempMatrix,
            skipUpdateTransform: !!displayObject.parent,
            blit: !0
        }), displayObject.transform = transform, renderTexture;
    }
    destroy() {}
}
$77b4b0fc4afd1be0$export$690776504ee197a6.extension = {
    type: [
        (0, $5RvHb.ExtensionType).RendererSystem,
        (0, $5RvHb.ExtensionType).CanvasRendererSystem
    ],
    name: "textureGenerator"
};
(0, $5RvHb.extensions).add($77b4b0fc4afd1be0$export$690776504ee197a6);

});

parcelRegister("jxrL2", function(module, exports) {
parcelRequire("8HZMw");
var $1PNws = parcelRequire("1PNws");

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9fnly");
var $kZOeV = parcelRequire("kZOeV");
const $79c9affe69f86737$var$tempRect = new (0, $kZOeV.Rectangle)(), $79c9affe69f86737$var$tempRect2 = new (0, $kZOeV.Rectangle)();
class $79c9affe69f86737$export$5fd756363f54136f {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.defaultMaskStack = [], this.current = null, this.sourceFrame = new (0, $kZOeV.Rectangle)(), this.destinationFrame = new (0, $kZOeV.Rectangle)(), this.viewportFrame = new (0, $kZOeV.Rectangle)();
    }
    contextChange() {
        const attributes = this.renderer?.gl.getContextAttributes();
        this._rendererPremultipliedAlpha = !!(attributes && attributes.alpha && attributes.premultipliedAlpha);
    }
    /**
   * Bind the current render texture.
   * @param renderTexture - RenderTexture to bind, by default its `null` - the screen.
   * @param sourceFrame - Part of world that is mapped to the renderTexture.
   * @param destinationFrame - Part of renderTexture, by default it has the same size as sourceFrame.
   */ bind(renderTexture = null, sourceFrame, destinationFrame) {
        const renderer = this.renderer;
        this.current = renderTexture;
        let baseTexture, framebuffer, resolution;
        renderTexture ? (baseTexture = renderTexture.baseTexture, resolution = baseTexture.resolution, sourceFrame || ($79c9affe69f86737$var$tempRect.width = renderTexture.frame.width, $79c9affe69f86737$var$tempRect.height = renderTexture.frame.height, sourceFrame = $79c9affe69f86737$var$tempRect), destinationFrame || ($79c9affe69f86737$var$tempRect2.x = renderTexture.frame.x, $79c9affe69f86737$var$tempRect2.y = renderTexture.frame.y, $79c9affe69f86737$var$tempRect2.width = sourceFrame.width, $79c9affe69f86737$var$tempRect2.height = sourceFrame.height, destinationFrame = $79c9affe69f86737$var$tempRect2), framebuffer = baseTexture.framebuffer) : (resolution = renderer.resolution, sourceFrame || ($79c9affe69f86737$var$tempRect.width = renderer._view.screen.width, $79c9affe69f86737$var$tempRect.height = renderer._view.screen.height, sourceFrame = $79c9affe69f86737$var$tempRect), destinationFrame || (destinationFrame = $79c9affe69f86737$var$tempRect, destinationFrame.width = sourceFrame.width, destinationFrame.height = sourceFrame.height));
        const viewportFrame = this.viewportFrame;
        viewportFrame.x = destinationFrame.x * resolution, viewportFrame.y = destinationFrame.y * resolution, viewportFrame.width = destinationFrame.width * resolution, viewportFrame.height = destinationFrame.height * resolution, renderTexture || (viewportFrame.y = renderer.view.height - (viewportFrame.y + viewportFrame.height)), viewportFrame.ceil(), this.renderer.framebuffer.bind(framebuffer, viewportFrame), this.renderer.projection.update(destinationFrame, sourceFrame, resolution, !framebuffer), renderTexture ? this.renderer.mask.setMaskStack(baseTexture.maskStack) : this.renderer.mask.setMaskStack(this.defaultMaskStack), this.sourceFrame.copyFrom(sourceFrame), this.destinationFrame.copyFrom(destinationFrame);
    }
    /**
   * Erases the render texture and fills the drawing area with a colour.
   * @param clearColor - The color as rgba, default to use the renderer backgroundColor
   * @param [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
   *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
   */ clear(clearColor, mask) {
        const fallbackColor = this.current ? this.current.baseTexture.clear : this.renderer.background.backgroundColor, color = (0, $1PNws.Color).shared.setValue(clearColor || fallbackColor);
        (this.current && this.current.baseTexture.alphaMode > 0 || !this.current && this._rendererPremultipliedAlpha) && color.premultiply(color.alpha);
        const destinationFrame = this.destinationFrame, baseFrame = this.current ? this.current.baseTexture : this.renderer._view.screen, clearMask = destinationFrame.width !== baseFrame.width || destinationFrame.height !== baseFrame.height;
        if (clearMask) {
            let { x: x, y: y, width: width, height: height } = this.viewportFrame;
            x = Math.round(x), y = Math.round(y), width = Math.round(width), height = Math.round(height), this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST), this.renderer.gl.scissor(x, y, width, height);
        }
        this.renderer.framebuffer.clear(color.red, color.green, color.blue, color.alpha, mask), clearMask && this.renderer.scissor.pop();
    }
    resize() {
        this.bind(null);
    }
    /** Resets render-texture state. */ reset() {
        this.bind(null);
    }
    destroy() {
        this.renderer = null;
    }
}
$79c9affe69f86737$export$5fd756363f54136f.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "renderTexture"
};
(0, $5RvHb.extensions).add($79c9affe69f86737$export$5fd756363f54136f);

});

parcelRegister("1JxSm", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("4lsfy");

var $2tsgU = parcelRequire("2tsgU");

var $70kNL = parcelRequire("70kNL");

var $5MhZE = parcelRequire("5MhZE");

var $5pxYo = parcelRequire("5pxYo");
let $42ad742ac3d50c23$var$UID = 0;
const $42ad742ac3d50c23$var$defaultSyncData = {
    textureCount: 0,
    uboCount: 0
};
class $42ad742ac3d50c23$export$d91933f5c44096f4 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.destroyed = !1, this.renderer = renderer, this.systemCheck(), this.gl = null, this.shader = null, this.program = null, this.cache = {}, this._uboCache = {}, this.id = $42ad742ac3d50c23$var$UID++;
    }
    /**
   * Overrideable function by `@pixi/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */ systemCheck() {
        if (!(0, $5MhZE.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
    }
    contextChange(gl) {
        this.gl = gl, this.reset();
    }
    /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param dontSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */ bind(shader, dontSync) {
        shader.disposeRunner.add(this), shader.uniforms.globals = this.renderer.globalUniforms;
        const program = shader.program, glProgram = program.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(shader);
        return this.shader = shader, this.program !== program && (this.program = program, this.gl.useProgram(glProgram.program)), dontSync || ($42ad742ac3d50c23$var$defaultSyncData.textureCount = 0, $42ad742ac3d50c23$var$defaultSyncData.uboCount = 0, this.syncUniformGroup(shader.uniformGroup, $42ad742ac3d50c23$var$defaultSyncData)), glProgram;
    }
    /**
   * Uploads the uniforms values to the currently bound shader.
   * @param uniforms - the uniforms values that be applied to the current shader
   */ setUniforms(uniforms) {
        const shader = this.shader.program, glProgram = shader.glPrograms[this.renderer.CONTEXT_UID];
        shader.syncUniforms(glProgram.uniformData, uniforms, this.renderer);
    }
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
   * Syncs uniforms on the group
   * @param group - the uniform group to sync
   * @param syncData - this is data that is passed to the sync function and any nested sync functions
   */ syncUniformGroup(group, syncData) {
        const glProgram = this.getGlProgram();
        (!group.static || group.dirtyId !== glProgram.uniformDirtyGroups[group.id]) && (glProgram.uniformDirtyGroups[group.id] = group.dirtyId, this.syncUniforms(group, glProgram, syncData));
    }
    /**
   * Overrideable by the @pixi/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param glProgram
   * @param syncData
   */ syncUniforms(group, glProgram, syncData) {
        (group.syncUniforms[this.shader.program.id] || this.createSyncGroups(group))(glProgram.uniformData, group.uniforms, this.renderer, syncData);
    }
    createSyncGroups(group) {
        const id = this.getSignature(group, this.shader.program.uniformData, "u");
        return this.cache[id] || (this.cache[id] = (0, $5pxYo.generateUniformsSync)(group, this.shader.program.uniformData)), group.syncUniforms[this.shader.program.id] = this.cache[id], group.syncUniforms[this.shader.program.id];
    }
    /**
   * Syncs uniform buffers
   * @param group - the uniform buffer group to sync
   * @param name - the name of the uniform buffer
   */ syncUniformBufferGroup(group, name) {
        const glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== 0 || !glProgram.uniformGroups[group.id]) {
            group.dirtyId = 0;
            const syncFunc = glProgram.uniformGroups[group.id] || this.createSyncBufferGroup(group, glProgram, name);
            group.buffer.update(), syncFunc(glProgram.uniformData, group.uniforms, this.renderer, $42ad742ac3d50c23$var$defaultSyncData, group.buffer);
        }
        this.renderer.buffer.bindBufferBase(group.buffer, glProgram.uniformBufferBindings[name]);
    }
    /**
   * Will create a function that uploads a uniform buffer using the STD140 standard.
   * The upload function will then be cached for future calls
   * If a group is manually managed, then a simple upload function is generated
   * @param group - the uniform buffer group to sync
   * @param glProgram - the gl program to attach the uniform bindings to
   * @param name - the name of the uniform buffer (must exist on the shader)
   */ createSyncBufferGroup(group, glProgram, name) {
        const { gl: gl } = this.renderer;
        this.renderer.buffer.bind(group.buffer);
        const uniformBlockIndex = this.gl.getUniformBlockIndex(glProgram.program, name);
        glProgram.uniformBufferBindings[name] = this.shader.uniformBindCount, gl.uniformBlockBinding(glProgram.program, uniformBlockIndex, this.shader.uniformBindCount), this.shader.uniformBindCount++;
        const id = this.getSignature(group, this.shader.program.uniformData, "ubo");
        let uboData = this._uboCache[id];
        if (uboData || (uboData = this._uboCache[id] = (0, $70kNL.generateUniformBufferSync)(group, this.shader.program.uniformData)), group.autoManage) {
            const data = new Float32Array(uboData.size / 4);
            group.buffer.update(data);
        }
        return glProgram.uniformGroups[group.id] = uboData.syncFunc, glProgram.uniformGroups[group.id];
    }
    /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */ getSignature(group, uniformData, preFix) {
        const uniforms = group.uniforms, strings = [
            `${preFix}-`
        ];
        for(const i in uniforms)strings.push(i), uniformData[i] && strings.push(uniformData[i].type);
        return strings.join("-");
    }
    /**
   * Returns the underlying GLShade rof the currently bound shader.
   *
   * This can be handy for when you to have a little more control over the setting of your uniforms.
   * @returns The glProgram for the currently bound Shader for this context
   */ getGlProgram() {
        return this.shader ? this.shader.program.glPrograms[this.renderer.CONTEXT_UID] : null;
    }
    /**
   * Generates a glProgram version of the Shader provided.
   * @param shader - The shader that the glProgram will be based on.
   * @returns A shiny new glProgram!
   */ generateProgram(shader) {
        const gl = this.gl, program = shader.program, glProgram = (0, $2tsgU.generateProgram)(gl, program);
        return program.glPrograms[this.renderer.CONTEXT_UID] = glProgram, glProgram;
    }
    /** Resets ShaderSystem state, does not affect WebGL state. */ reset() {
        this.program = null, this.shader = null;
    }
    /**
   * Disposes shader.
   * If disposing one equals with current shader, set current as null.
   * @param shader - Shader object
   */ disposeShader(shader) {
        this.shader === shader && (this.shader = null);
    }
    /** Destroys this System and removes all its textures. */ destroy() {
        this.renderer = null, this.destroyed = !0;
    }
}
$42ad742ac3d50c23$export$d91933f5c44096f4.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "shader"
};
(0, $5RvHb.extensions).add($42ad742ac3d50c23$export$d91933f5c44096f4);

});
parcelRegister("2tsgU", function(module, exports) {

$parcel$export(module.exports, "generateProgram", () => $d148e901bd50f006$export$44c84e8c8e54bce9);

var $3tYCB = parcelRequire("3tYCB");

var $eisDF = parcelRequire("eisDF");

var $flCZd = parcelRequire("flCZd");

var $fvrzN = parcelRequire("fvrzN");

var $hdEqi = parcelRequire("hdEqi");

var $iqofN = parcelRequire("iqofN");
function $d148e901bd50f006$export$44c84e8c8e54bce9(gl, program) {
    const glVertShader = (0, $eisDF.compileShader)(gl, gl.VERTEX_SHADER, program.vertexSrc), glFragShader = (0, $eisDF.compileShader)(gl, gl.FRAGMENT_SHADER, program.fragmentSrc), webGLProgram = gl.createProgram();
    gl.attachShader(webGLProgram, glVertShader), gl.attachShader(webGLProgram, glFragShader);
    const transformFeedbackVaryings = program.extra?.transformFeedbackVaryings;
    if (transformFeedbackVaryings && (typeof gl.transformFeedbackVaryings != "function" ? console.warn("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : gl.transformFeedbackVaryings(webGLProgram, transformFeedbackVaryings.names, transformFeedbackVaryings.bufferMode === "separate" ? gl.SEPARATE_ATTRIBS : gl.INTERLEAVED_ATTRIBS)), gl.linkProgram(webGLProgram), gl.getProgramParameter(webGLProgram, gl.LINK_STATUS) || (0, $iqofN.logProgramError)(gl, webGLProgram, glVertShader, glFragShader), program.attributeData = (0, $fvrzN.getAttributeData)(webGLProgram, gl), program.uniformData = (0, $hdEqi.getUniformData)(webGLProgram, gl), !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(program.vertexSrc)) {
        const keys = Object.keys(program.attributeData);
        keys.sort((a, b)=>a > b ? 1 : -1);
        for(let i = 0; i < keys.length; i++)program.attributeData[keys[i]].location = i, gl.bindAttribLocation(webGLProgram, i, keys[i]);
        gl.linkProgram(webGLProgram);
    }
    gl.deleteShader(glVertShader), gl.deleteShader(glFragShader);
    const uniformData = {};
    for(const i in program.uniformData){
        const data = program.uniformData[i];
        uniformData[i] = {
            location: gl.getUniformLocation(webGLProgram, i),
            value: (0, $flCZd.defaultValue)(data.type, data.size)
        };
    }
    return new (0, $3tYCB.GLProgram)(webGLProgram, uniformData);
}

});
parcelRegister("3tYCB", function(module, exports) {

$parcel$export(module.exports, "GLProgram", () => $a954c32aab7911f1$export$bf1479c8ce91afd5);
class $a954c32aab7911f1$export$181be621ce68aec5 {
}
class $a954c32aab7911f1$export$bf1479c8ce91afd5 {
    /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */ constructor(program, uniformData){
        this.program = program, this.uniformData = uniformData, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBufferBindings = {};
    }
    /** Destroys this program. */ destroy() {
        this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBufferBindings = null, this.program = null;
    }
}

});

parcelRegister("fvrzN", function(module, exports) {

$parcel$export(module.exports, "getAttributeData", () => $271d5c07039add3c$export$c73f9ceeec70bdfb);

var $kwXhP = parcelRequire("kwXhP");

var $f97nY = parcelRequire("f97nY");
function $271d5c07039add3c$export$c73f9ceeec70bdfb(program, gl) {
    const attributes = {}, totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < totalAttributes; i++){
        const attribData = gl.getActiveAttrib(program, i);
        if (attribData.name.startsWith("gl_")) continue;
        const type = (0, $f97nY.mapType)(gl, attribData.type), data = {
            type: type,
            name: attribData.name,
            size: (0, $kwXhP.mapSize)(type),
            location: gl.getAttribLocation(program, attribData.name)
        };
        attributes[attribData.name] = data;
    }
    return attributes;
}

});

parcelRegister("hdEqi", function(module, exports) {

$parcel$export(module.exports, "getUniformData", () => $97365b23c596420b$export$d38fd6033d9429a5);

var $flCZd = parcelRequire("flCZd");

var $f97nY = parcelRequire("f97nY");
function $97365b23c596420b$export$d38fd6033d9429a5(program, gl) {
    const uniforms = {}, totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for(let i = 0; i < totalUniforms; i++){
        const uniformData = gl.getActiveUniform(program, i), name = uniformData.name.replace(/\[.*?\]$/, ""), isArray = !!uniformData.name.match(/\[.*?\]$/), type = (0, $f97nY.mapType)(gl, uniformData.type);
        uniforms[name] = {
            name: name,
            index: i,
            type: type,
            size: uniformData.size,
            isArray: isArray,
            value: (0, $flCZd.defaultValue)(type, uniformData.size)
        };
    }
    return uniforms;
}

});


parcelRegister("70kNL", function(module, exports) {

$parcel$export(module.exports, "generateUniformBufferSync", () => $bd6ea98358c3af52$export$39fbc1d5b3f112e4);
parcelRequire("4lsfy");

var $d0Qk2 = parcelRequire("d0Qk2");

var $kwXhP = parcelRequire("kwXhP");
function $bd6ea98358c3af52$var$uboUpdate(_ud, _uv, _renderer, _syncData, buffer) {
    _renderer.buffer.update(buffer);
}
const $bd6ea98358c3af52$var$UBO_TO_SINGLE_SETTERS = {
    float: `
        data[offset] = v;
    `,
    vec2: `
        data[offset] = v[0];
        data[offset+1] = v[1];
    `,
    vec3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

    `,
    vec4: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];
        data[offset+3] = v[3];
    `,
    mat2: `
        data[offset] = v[0];
        data[offset+1] = v[1];

        data[offset+4] = v[2];
        data[offset+5] = v[3];
    `,
    mat3: `
        data[offset] = v[0];
        data[offset+1] = v[1];
        data[offset+2] = v[2];

        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];

        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];
    `,
    mat4: `
        for(var i = 0; i < 16; i++)
        {
            data[offset + i] = v[i];
        }
    `
}, $bd6ea98358c3af52$var$GLSL_TO_STD40_SIZE = {
    float: 4,
    vec2: 8,
    vec3: 12,
    vec4: 16,
    int: 4,
    ivec2: 8,
    ivec3: 12,
    ivec4: 16,
    uint: 4,
    uvec2: 8,
    uvec3: 12,
    uvec4: 16,
    bool: 4,
    bvec2: 8,
    bvec3: 12,
    bvec4: 16,
    mat2: 32,
    mat3: 48,
    mat4: 64
};
function $bd6ea98358c3af52$export$3c4fb828fecb3ead(uniformData) {
    const uboElements = uniformData.map((data)=>({
            data: data,
            offset: 0,
            dataLen: 0,
            dirty: 0
        }));
    let size = 0, chunkSize = 0, offset = 0;
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i];
        if (size = $bd6ea98358c3af52$var$GLSL_TO_STD40_SIZE[uboElement.data.type], uboElement.data.size > 1 && (size = Math.max(size, 16) * uboElement.data.size), uboElement.dataLen = size, chunkSize % size !== 0 && chunkSize < 16) {
            const lineUpValue = chunkSize % size % 16;
            chunkSize += lineUpValue, offset += lineUpValue;
        }
        chunkSize + size > 16 ? (offset = Math.ceil(offset / 16) * 16, uboElement.offset = offset, offset += size, chunkSize = size) : (uboElement.offset = offset, chunkSize += size, offset += size);
    }
    return offset = Math.ceil(offset / 16) * 16, {
        uboElements: uboElements,
        size: offset
    };
}
function $bd6ea98358c3af52$export$56f32278ebf30ea0(uniforms, uniformData) {
    const usedUniformDatas = [];
    for(const i in uniforms)uniformData[i] && usedUniformDatas.push(uniformData[i]);
    return usedUniformDatas.sort((a, b)=>a.index - b.index), usedUniformDatas;
}
function $bd6ea98358c3af52$export$39fbc1d5b3f112e4(group, uniformData) {
    if (!group.autoManage) return {
        size: 0,
        syncFunc: $bd6ea98358c3af52$var$uboUpdate
    };
    const usedUniformDatas = $bd6ea98358c3af52$export$56f32278ebf30ea0(group.uniforms, uniformData), { uboElements: uboElements, size: size } = $bd6ea98358c3af52$export$3c4fb828fecb3ead(usedUniformDatas), funcFragments = [
        `
    var v = null;
    var v2 = null;
    var cv = null;
    var t = 0;
    var gl = renderer.gl
    var index = 0;
    var data = buffer.data;
    `
    ];
    for(let i = 0; i < uboElements.length; i++){
        const uboElement = uboElements[i], uniform = group.uniforms[uboElement.data.name], name = uboElement.data.name;
        let parsed = !1;
        for(let j = 0; j < (0, $d0Qk2.uniformParsers).length; j++){
            const uniformParser = (0, $d0Qk2.uniformParsers)[j];
            if (uniformParser.codeUbo && uniformParser.test(uboElement.data, uniform)) {
                funcFragments.push(`offset = ${uboElement.offset / 4};`, (0, $d0Qk2.uniformParsers)[j].codeUbo(uboElement.data.name, uniform)), parsed = !0;
                break;
            }
        }
        if (!parsed) {
            if (uboElement.data.size > 1) {
                const size2 = (0, $kwXhP.mapSize)(uboElement.data.type), rowSize = Math.max($bd6ea98358c3af52$var$GLSL_TO_STD40_SIZE[uboElement.data.type] / 16, 1), elementSize = size2 / rowSize, remainder = (4 - elementSize % 4) % 4;
                funcFragments.push(`
                cv = ud.${name}.value;
                v = uv.${name};
                offset = ${uboElement.offset / 4};

                t = 0;

                for(var i=0; i < ${uboElement.data.size * rowSize}; i++)
                {
                    for(var j = 0; j < ${elementSize}; j++)
                    {
                        data[offset++] = v[t++];
                    }
                    offset += ${remainder};
                }

                `);
            } else {
                const template = $bd6ea98358c3af52$var$UBO_TO_SINGLE_SETTERS[uboElement.data.type];
                funcFragments.push(`
                cv = ud.${name}.value;
                v = uv.${name};
                offset = ${uboElement.offset / 4};
                ${template};
                `);
            }
        }
    }
    return funcFragments.push(`
       renderer.buffer.update(buffer);
    `), {
        size: size,
        // eslint-disable-next-line no-new-func
        syncFunc: new Function("ud", "uv", "renderer", "syncData", "buffer", funcFragments.join(`
`))
    };
}

});


parcelRegister("1rTbL", function(module, exports) {

$parcel$export(module.exports, "StartupSystem", () => $e7a42a553978e370$export$8b298d2bda604a05);

var $5RvHb = parcelRequire("5RvHb");
class $e7a42a553978e370$export$8b298d2bda604a05 {
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */ run(options) {
        const { renderer: renderer } = this;
        renderer.runners.init.emit(renderer.options), options.hello && console.log(`PixiJS 7.4.0 - ${renderer.rendererLogId} - https://pixijs.com`), renderer.resize(renderer.screen.width, renderer.screen.height);
    }
    destroy() {}
}
$e7a42a553978e370$export$8b298d2bda604a05.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.hello}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ hello: !1
}, /** @ignore */ $e7a42a553978e370$export$8b298d2bda604a05.extension = {
    type: [
        (0, $5RvHb.ExtensionType).RendererSystem,
        (0, $5RvHb.ExtensionType).CanvasRendererSystem
    ],
    name: "startup"
};
(0, $5RvHb.extensions).add($e7a42a553978e370$export$8b298d2bda604a05);

});

parcelRegister("jIxy5", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");

var $bUqaG = parcelRequire("bUqaG");

var $5UuhA = parcelRequire("5UuhA");
const $cbce3595b7947a2e$var$BLEND = 0, $cbce3595b7947a2e$var$OFFSET = 1, $cbce3595b7947a2e$var$CULLING = 2, $cbce3595b7947a2e$var$DEPTH_TEST = 3, $cbce3595b7947a2e$var$WINDING = 4, $cbce3595b7947a2e$var$DEPTH_MASK = 5, $cbce3595b7947a2e$var$_StateSystem = class _StateSystem2 {
    constructor(){
        this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = (0, $lmRm8.BLEND_MODES).NONE, this._blendEq = !1, this.map = [], this.map[$cbce3595b7947a2e$var$BLEND] = this.setBlend, this.map[$cbce3595b7947a2e$var$OFFSET] = this.setOffset, this.map[$cbce3595b7947a2e$var$CULLING] = this.setCullFace, this.map[$cbce3595b7947a2e$var$DEPTH_TEST] = this.setDepthTest, this.map[$cbce3595b7947a2e$var$WINDING] = this.setFrontFace, this.map[$cbce3595b7947a2e$var$DEPTH_MASK] = this.setDepthMask, this.checks = [], this.defaultState = new (0, $bUqaG.State)(), this.defaultState.blend = !0;
    }
    contextChange(gl) {
        this.gl = gl, this.blendModes = (0, $5UuhA.mapWebGLBlendModesToPixi)(gl), this.set(this.defaultState), this.reset();
    }
    /**
   * Sets the current state
   * @param {*} state - The state to set.
   */ set(state) {
        if (state = state || this.defaultState, this.stateId !== state.data) {
            let diff = this.stateId ^ state.data, i = 0;
            for(; diff;)diff & 1 && this.map[i].call(this, !!(state.data & 1 << i)), diff = diff >> 1, i++;
            this.stateId = state.data;
        }
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
    }
    /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */ forceState(state) {
        state = state || this.defaultState;
        for(let i = 0; i < this.map.length; i++)this.map[i].call(this, !!(state.data & 1 << i));
        for(let i = 0; i < this.checks.length; i++)this.checks[i](this, state);
        this.stateId = state.data;
    }
    /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */ setBlend(value) {
        this.updateCheck(_StateSystem2.checkBlendMode, value), this.gl[value ? "enable" : "disable"](this.gl.BLEND);
    }
    /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */ setOffset(value) {
        this.updateCheck(_StateSystem2.checkPolygonOffset, value), this.gl[value ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
    }
    /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */ setDepthTest(value) {
        this.gl[value ? "enable" : "disable"](this.gl.DEPTH_TEST);
    }
    /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */ setDepthMask(value) {
        this.gl.depthMask(value);
    }
    /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */ setCullFace(value) {
        this.gl[value ? "enable" : "disable"](this.gl.CULL_FACE);
    }
    /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */ setFrontFace(value) {
        this.gl.frontFace(this.gl[value ? "CW" : "CCW"]);
    }
    /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */ setBlendMode(value) {
        if (value === this.blendMode) return;
        this.blendMode = value;
        const mode = this.blendModes[value], gl = this.gl;
        mode.length === 2 ? gl.blendFunc(mode[0], mode[1]) : gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]), mode.length === 6 ? (this._blendEq = !0, gl.blendEquationSeparate(mode[4], mode[5])) : this._blendEq && (this._blendEq = !1, gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD));
    }
    /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */ setPolygonOffset(value, scale) {
        this.gl.polygonOffset(value, scale);
    }
    // used
    /** Resets all the logic and disables the VAOs. */ reset() {
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = -1, this.setBlendMode(0);
    }
    /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */ updateCheck(func, value) {
        const index = this.checks.indexOf(func);
        value && index === -1 ? this.checks.push(func) : !value && index !== -1 && this.checks.splice(index, 1);
    }
    /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */ static checkBlendMode(system, state) {
        system.setBlendMode(state.blendMode);
    }
    /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */ static checkPolygonOffset(system, state) {
        system.setPolygonOffset(1, state.polygonOffset);
    }
    /**
   * @ignore
   */ destroy() {
        this.gl = null;
    }
};
$cbce3595b7947a2e$var$_StateSystem.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "state"
};
let $cbce3595b7947a2e$export$d47ea6626863db49 = $cbce3595b7947a2e$var$_StateSystem;
(0, $5RvHb.extensions).add($cbce3595b7947a2e$export$d47ea6626863db49);

});
parcelRegister("5UuhA", function(module, exports) {

$parcel$export(module.exports, "mapWebGLBlendModesToPixi", () => $4a5ded39d0179802$export$57ed86928a8d2aa1);

var $lmRm8 = parcelRequire("lmRm8");
function $4a5ded39d0179802$export$57ed86928a8d2aa1(gl, array = []) {
    return array[(0, $lmRm8.BLEND_MODES).NORMAL] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).ADD] = [
        gl.ONE,
        gl.ONE
    ], array[(0, $lmRm8.BLEND_MODES).MULTIPLY] = [
        gl.DST_COLOR,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).SCREEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).OVERLAY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).DARKEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).LIGHTEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).COLOR_DODGE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).COLOR_BURN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).HARD_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).SOFT_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).DIFFERENCE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).EXCLUSION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).HUE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).SATURATION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).COLOR] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).LUMINOSITY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).NONE] = [
        0,
        0
    ], array[(0, $lmRm8.BLEND_MODES).NORMAL_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).ADD_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE,
        gl.ONE,
        gl.ONE
    ], array[(0, $lmRm8.BLEND_MODES).SCREEN_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).SRC_IN] = [
        gl.DST_ALPHA,
        gl.ZERO
    ], array[(0, $lmRm8.BLEND_MODES).SRC_OUT] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ZERO
    ], array[(0, $lmRm8.BLEND_MODES).SRC_ATOP] = [
        gl.DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).DST_OVER] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE
    ], array[(0, $lmRm8.BLEND_MODES).DST_IN] = [
        gl.ZERO,
        gl.SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).DST_OUT] = [
        gl.ZERO,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).DST_ATOP] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).XOR] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ], array[(0, $lmRm8.BLEND_MODES).SUBTRACT] = [
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.FUNC_REVERSE_SUBTRACT,
        gl.FUNC_ADD
    ], array;
}

});


parcelRegister("6BfGe", function(module, exports) {

$parcel$export(module.exports, "SystemManager", () => $64ffa2d81765c4cc$export$a12e67a4b4590901);
parcelRequire("hWIIU");
var $aDHVi = parcelRequire("aDHVi");
parcelRequire("lFGyw");
var $3vRz3 = parcelRequire("3vRz3");
class $64ffa2d81765c4cc$export$a12e67a4b4590901 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(){
        super(...arguments), this.runners = {}, this._systemsHash = {};
    }
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ setup(config) {
        this.addRunners(...config.runners);
        const priority = (config.priority ?? []).filter((key)=>config.systems[key]), orderByPriority = [
            ...priority,
            ...Object.keys(config.systems).filter((key)=>!priority.includes(key))
        ];
        for (const i of orderByPriority)this.addSystem(config.systems[i], i);
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $aDHVi.Runner)(runnerId);
        });
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system, this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    /**
   * A function that will run a runner and call the runners function but pass in different options
   * to each system based on there name.
   *
   * E.g. If you have two systems added called `systemA` and `systemB` you could call do the following:
   *
   * ```js
   * system.emitWithCustomOptions(init, {
   *     systemA: {...optionsForA},
   *     systemB: {...optionsForB},
   * });
   * ```
   *
   * `init` would be called on system A passing `optionsForA` and on system B passing `optionsForB`.
   * @param runner - the runner to target
   * @param options - key value options for each system
   */ emitWithCustomOptions(runner, options) {
        const systemHashKeys = Object.keys(this._systemsHash);
        runner.items.forEach((system)=>{
            const systemName = systemHashKeys.find((systemId)=>this._systemsHash[systemId] === system);
            system[runner.name](options[systemName]);
        });
    }
    /** destroy the all runners and systems. Its apps job to */ destroy() {
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        }), this._systemsHash = {};
    }
}

});

parcelRegister("iDGF3", function(module, exports) {

$parcel$export(module.exports, "TextureGCSystem", () => $e0f99544b0c3a894$export$a47b032752d8e393);

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
const $e0f99544b0c3a894$var$_TextureGCSystem = class _TextureGCSystem2 {
    /** @param renderer - The renderer this System works for. */ constructor(renderer){
        this.renderer = renderer, this.count = 0, this.checkCount = 0, this.maxIdle = _TextureGCSystem2.defaultMaxIdle, this.checkCountMax = _TextureGCSystem2.defaultCheckCountMax, this.mode = _TextureGCSystem2.defaultMode;
    }
    /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */ postrender() {
        this.renderer.objectRenderer.renderingToScreen && (this.count++, this.mode !== (0, $lmRm8.GC_MODES).MANUAL && (this.checkCount++, this.checkCount > this.checkCountMax && (this.checkCount = 0, this.run())));
    }
    /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */ run() {
        const tm = this.renderer.texture, managedTextures = tm.managedTextures;
        let wasRemoved = !1;
        for(let i = 0; i < managedTextures.length; i++){
            const texture = managedTextures[i];
            texture.resource && this.count - texture.touched > this.maxIdle && (tm.destroyTexture(texture, !0), managedTextures[i] = null, wasRemoved = !0);
        }
        if (wasRemoved) {
            let j = 0;
            for(let i = 0; i < managedTextures.length; i++)managedTextures[i] !== null && (managedTextures[j++] = managedTextures[i]);
            managedTextures.length = j;
        }
    }
    /**
   * Removes all the textures within the specified displayObject and its children from the GPU.
   * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
   */ unload(displayObject) {
        const tm = this.renderer.texture, texture = displayObject._texture;
        texture && !texture.framebuffer && tm.destroyTexture(texture);
        for(let i = displayObject.children.length - 1; i >= 0; i--)this.unload(displayObject.children[i]);
    }
    destroy() {
        this.renderer = null;
    }
};
$e0f99544b0c3a894$var$_TextureGCSystem.defaultMode = (0, $lmRm8.GC_MODES).AUTO, /**
* Default maximum idle frames before a texture is destroyed by garbage collection.
* @static
* @default 3600
* @see PIXI.TextureGCSystem#maxIdle
*/ $e0f99544b0c3a894$var$_TextureGCSystem.defaultMaxIdle = 3600, /**
* Default frames between two garbage collections.
* @static
* @default 600
* @see PIXI.TextureGCSystem#checkCountMax
*/ $e0f99544b0c3a894$var$_TextureGCSystem.defaultCheckCountMax = 600, /** @ignore */ $e0f99544b0c3a894$var$_TextureGCSystem.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "textureGC"
};
let $e0f99544b0c3a894$export$a47b032752d8e393 = $e0f99544b0c3a894$var$_TextureGCSystem;
(0, $5RvHb.extensions).add($e0f99544b0c3a894$export$a47b032752d8e393);

});

parcelRegister("dq44e", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("lFGyw");
var $7aCsl = parcelRequire("7aCsl");

var $4oWO8 = parcelRequire("4oWO8");

var $hfBPA = parcelRequire("hfBPA");

var $9NFA7 = parcelRequire("9NFA7");

var $201kX = parcelRequire("201kX");
class $e8141bbe5864ec6f$export$6312da36f198968 {
    /**
   * @param renderer - The renderer this system works for.
   */ constructor(renderer){
        this.renderer = renderer, this.boundTextures = [], this.currentLocation = -1, this.managedTextures = [], this._unknownBoundTextures = !1, this.unknownTexture = new (0, $4oWO8.BaseTexture)(), this.hasIntegerTextures = !1;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        const gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID, this.webGLVersion = this.renderer.context.webGLVersion, this.internalFormats = (0, $201kX.mapTypeAndFormatToInternalFormat)(gl), this.samplerTypes = (0, $9NFA7.mapInternalFormatToSamplerType)(gl);
        const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
        this.boundTextures.length = maxTextures;
        for(let i = 0; i < maxTextures; i++)this.boundTextures[i] = null;
        this.emptyTextures = {};
        const emptyTexture2D = new (0, $hfBPA.GLTexture)(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_2D, emptyTexture2D.texture), gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(4)), this.emptyTextures[gl.TEXTURE_2D] = emptyTexture2D, this.emptyTextures[gl.TEXTURE_CUBE_MAP] = new (0, $hfBPA.GLTexture)(gl.createTexture()), gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.emptyTextures[gl.TEXTURE_CUBE_MAP].texture);
        for(let i = 0; i < 6; i++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR), gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        for(let i = 0; i < this.boundTextures.length; i++)this.bind(null, i);
    }
    /**
   * Bind a texture to a specific location
   *
   * If you want to unbind something, please use `unbind(texture)` instead of `bind(null, textureLocation)`
   * @param texture - Texture to bind
   * @param [location=0] - Location to bind at
   */ bind(texture, location = 0) {
        const { gl: gl } = this;
        if (texture = texture?.castToBaseTexture(), texture?.valid && !texture.parentTextureArray) {
            texture.touched = this.renderer.textureGC.count;
            const glTexture = texture._glTextures[this.CONTEXT_UID] || this.initTexture(texture);
            this.boundTextures[location] !== texture && (this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), gl.bindTexture(texture.target, glTexture.texture)), glTexture.dirtyId !== texture.dirtyId ? (this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), this.updateTexture(texture)) : glTexture.dirtyStyleId !== texture.dirtyStyleId && this.updateTextureStyle(texture), this.boundTextures[location] = texture;
        } else this.currentLocation !== location && (this.currentLocation = location, gl.activeTexture(gl.TEXTURE0 + location)), gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[gl.TEXTURE_2D].texture), this.boundTextures[location] = null;
    }
    /** Resets texture location and bound textures Actual `bind(null, i)` calls will be performed at next `unbind()` call */ reset() {
        this._unknownBoundTextures = !0, this.hasIntegerTextures = !1, this.currentLocation = -1;
        for(let i = 0; i < this.boundTextures.length; i++)this.boundTextures[i] = this.unknownTexture;
    }
    /**
   * Unbind a texture.
   * @param texture - Texture to bind
   */ unbind(texture) {
        const { gl: gl, boundTextures: boundTextures } = this;
        if (this._unknownBoundTextures) {
            this._unknownBoundTextures = !1;
            for(let i = 0; i < boundTextures.length; i++)boundTextures[i] === this.unknownTexture && this.bind(null, i);
        }
        for(let i = 0; i < boundTextures.length; i++)boundTextures[i] === texture && (this.currentLocation !== i && (gl.activeTexture(gl.TEXTURE0 + i), this.currentLocation = i), gl.bindTexture(texture.target, this.emptyTextures[texture.target].texture), boundTextures[i] = null);
    }
    /**
   * Ensures that current boundTextures all have FLOAT sampler type,
   * see {@link PIXI.SAMPLER_TYPES} for explanation.
   * @param maxTextures - number of locations to check
   */ ensureSamplerType(maxTextures) {
        const { boundTextures: boundTextures, hasIntegerTextures: hasIntegerTextures, CONTEXT_UID: CONTEXT_UID } = this;
        if (hasIntegerTextures) for(let i = maxTextures - 1; i >= 0; --i){
            const tex = boundTextures[i];
            tex && tex._glTextures[CONTEXT_UID].samplerType !== (0, $lmRm8.SAMPLER_TYPES).FLOAT && this.renderer.texture.unbind(tex);
        }
    }
    /**
   * Initialize a texture
   * @private
   * @param texture - Texture to initialize
   */ initTexture(texture) {
        const glTexture = new (0, $hfBPA.GLTexture)(this.gl.createTexture());
        return glTexture.dirtyId = -1, texture._glTextures[this.CONTEXT_UID] = glTexture, this.managedTextures.push(texture), texture.on("dispose", this.destroyTexture, this), glTexture;
    }
    initTextureType(texture, glTexture) {
        glTexture.internalFormat = this.internalFormats[texture.type]?.[texture.format] ?? texture.format, glTexture.samplerType = this.samplerTypes[glTexture.internalFormat] ?? (0, $lmRm8.SAMPLER_TYPES).FLOAT, this.webGLVersion === 2 && texture.type === (0, $lmRm8.TYPES).HALF_FLOAT ? glTexture.type = this.gl.HALF_FLOAT : glTexture.type = texture.type;
    }
    /**
   * Update a texture
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to initialize
   */ updateTexture(texture) {
        const glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        const renderer = this.renderer;
        if (this.initTextureType(texture, glTexture), texture.resource?.upload(renderer, texture, glTexture)) glTexture.samplerType !== (0, $lmRm8.SAMPLER_TYPES).FLOAT && (this.hasIntegerTextures = !0);
        else {
            const width = texture.realWidth, height = texture.realHeight, gl = renderer.gl;
            (glTexture.width !== width || glTexture.height !== height || glTexture.dirtyId < 0) && (glTexture.width = width, glTexture.height = height, gl.texImage2D(texture.target, 0, glTexture.internalFormat, width, height, 0, texture.format, glTexture.type, null));
        }
        texture.dirtyStyleId !== glTexture.dirtyStyleId && this.updateTextureStyle(texture), glTexture.dirtyId = texture.dirtyId;
    }
    /**
   * Deletes the texture from WebGL
   * @private
   * @param texture - the texture to destroy
   * @param [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
   */ destroyTexture(texture, skipRemove) {
        const { gl: gl } = this;
        if (texture = texture.castToBaseTexture(), texture._glTextures[this.CONTEXT_UID] && (this.unbind(texture), gl.deleteTexture(texture._glTextures[this.CONTEXT_UID].texture), texture.off("dispose", this.destroyTexture, this), delete texture._glTextures[this.CONTEXT_UID], !skipRemove)) {
            const i = this.managedTextures.indexOf(texture);
            i !== -1 && (0, $7aCsl.removeItems)(this.managedTextures, i, 1);
        }
    }
    /**
   * Update texture style such as mipmap flag
   * @private
   * @param {PIXI.BaseTexture} texture - Texture to update
   */ updateTextureStyle(texture) {
        const glTexture = texture._glTextures[this.CONTEXT_UID];
        glTexture && ((texture.mipmap === (0, $lmRm8.MIPMAP_MODES).POW2 || this.webGLVersion !== 2) && !texture.isPowerOfTwo ? glTexture.mipmap = !1 : glTexture.mipmap = texture.mipmap >= 1, this.webGLVersion !== 2 && !texture.isPowerOfTwo ? glTexture.wrapMode = (0, $lmRm8.WRAP_MODES).CLAMP : glTexture.wrapMode = texture.wrapMode, texture.resource?.style(this.renderer, texture, glTexture) || this.setStyle(texture, glTexture), glTexture.dirtyStyleId = texture.dirtyStyleId);
    }
    /**
   * Set style for texture
   * @private
   * @param texture - Texture to update
   * @param glTexture
   */ setStyle(texture, glTexture) {
        const gl = this.gl;
        if (glTexture.mipmap && texture.mipmap !== (0, $lmRm8.MIPMAP_MODES).ON_MANUAL && gl.generateMipmap(texture.target), gl.texParameteri(texture.target, gl.TEXTURE_WRAP_S, glTexture.wrapMode), gl.texParameteri(texture.target, gl.TEXTURE_WRAP_T, glTexture.wrapMode), glTexture.mipmap) {
            gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $lmRm8.SCALE_MODES).LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
            const anisotropicExt = this.renderer.context.extensions.anisotropicFiltering;
            if (anisotropicExt && texture.anisotropicLevel > 0 && texture.scaleMode === (0, $lmRm8.SCALE_MODES).LINEAR) {
                const level = Math.min(texture.anisotropicLevel, gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
                gl.texParameterf(texture.target, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, level);
            }
        } else gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $lmRm8.SCALE_MODES).LINEAR ? gl.LINEAR : gl.NEAREST);
        gl.texParameteri(texture.target, gl.TEXTURE_MAG_FILTER, texture.scaleMode === (0, $lmRm8.SCALE_MODES).LINEAR ? gl.LINEAR : gl.NEAREST);
    }
    destroy() {
        this.renderer = null;
    }
}
$e8141bbe5864ec6f$export$6312da36f198968.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "texture"
};
(0, $5RvHb.extensions).add($e8141bbe5864ec6f$export$6312da36f198968);

});
parcelRegister("hfBPA", function(module, exports) {

$parcel$export(module.exports, "GLTexture", () => $02f6e5532fa8cd9d$export$6c73c2a4561c07a2);

var $lmRm8 = parcelRequire("lmRm8");
class $02f6e5532fa8cd9d$export$6c73c2a4561c07a2 {
    constructor(texture){
        this.texture = texture, this.width = -1, this.height = -1, this.dirtyId = -1, this.dirtyStyleId = -1, this.mipmap = !1, this.wrapMode = 33071, this.type = (0, $lmRm8.TYPES).UNSIGNED_BYTE, this.internalFormat = (0, $lmRm8.FORMATS).RGBA, this.samplerType = 0;
    }
}

});

parcelRegister("9NFA7", function(module, exports) {

$parcel$export(module.exports, "mapInternalFormatToSamplerType", () => $385a909eec3e48fe$export$4d44a566e4889fac);

var $lmRm8 = parcelRequire("lmRm8");
function $385a909eec3e48fe$export$4d44a566e4889fac(gl) {
    let table;
    return "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext ? table = {
        [gl.RGB]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGBA]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.ALPHA]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.LUMINANCE]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.LUMINANCE_ALPHA]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.R8]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.R8_SNORM]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RG8]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RG8_SNORM]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB8]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB8_SNORM]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB565]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGBA4]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB5_A1]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGBA8]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGBA8_SNORM]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB10_A2]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB10_A2UI]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.SRGB8]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.SRGB8_ALPHA8]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.R16F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RG16F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB16F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGBA16F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.R32F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RG32F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB32F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGBA32F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.R11F_G11F_B10F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGB9_E5]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.R8I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.R8UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.R16I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.R16UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.R32I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.R32UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RG8I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RG8UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RG16I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RG16UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RG32I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RG32UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RGB8I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RGB8UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RGB16I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RGB16UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RGB32I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RGB32UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RGBA8I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RGBA8UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RGBA16I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RGBA16UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.RGBA32I]: (0, $lmRm8.SAMPLER_TYPES).INT,
        [gl.RGBA32UI]: (0, $lmRm8.SAMPLER_TYPES).UINT,
        [gl.DEPTH_COMPONENT16]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.DEPTH_COMPONENT24]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.DEPTH_COMPONENT32F]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.DEPTH_STENCIL]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.DEPTH24_STENCIL8]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.DEPTH32F_STENCIL8]: (0, $lmRm8.SAMPLER_TYPES).FLOAT
    } : table = {
        [gl.RGB]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.RGBA]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.ALPHA]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.LUMINANCE]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.LUMINANCE_ALPHA]: (0, $lmRm8.SAMPLER_TYPES).FLOAT,
        [gl.DEPTH_STENCIL]: (0, $lmRm8.SAMPLER_TYPES).FLOAT
    }, table;
}

});

parcelRegister("201kX", function(module, exports) {

$parcel$export(module.exports, "mapTypeAndFormatToInternalFormat", () => $987f2e0338d2f6f0$export$af038b9b93a51a84);

var $lmRm8 = parcelRequire("lmRm8");
function $987f2e0338d2f6f0$export$af038b9b93a51a84(gl) {
    let table;
    return "WebGL2RenderingContext" in globalThis && gl instanceof globalThis.WebGL2RenderingContext ? table = {
        [(0, $lmRm8.TYPES).UNSIGNED_BYTE]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGBA8,
            [(0, $lmRm8.FORMATS).RGB]: gl.RGB8,
            [(0, $lmRm8.FORMATS).RG]: gl.RG8,
            [(0, $lmRm8.FORMATS).RED]: gl.R8,
            [(0, $lmRm8.FORMATS).RGBA_INTEGER]: gl.RGBA8UI,
            [(0, $lmRm8.FORMATS).RGB_INTEGER]: gl.RGB8UI,
            [(0, $lmRm8.FORMATS).RG_INTEGER]: gl.RG8UI,
            [(0, $lmRm8.FORMATS).RED_INTEGER]: gl.R8UI,
            [(0, $lmRm8.FORMATS).ALPHA]: gl.ALPHA,
            [(0, $lmRm8.FORMATS).LUMINANCE]: gl.LUMINANCE,
            [(0, $lmRm8.FORMATS).LUMINANCE_ALPHA]: gl.LUMINANCE_ALPHA
        },
        [(0, $lmRm8.TYPES).BYTE]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGBA8_SNORM,
            [(0, $lmRm8.FORMATS).RGB]: gl.RGB8_SNORM,
            [(0, $lmRm8.FORMATS).RG]: gl.RG8_SNORM,
            [(0, $lmRm8.FORMATS).RED]: gl.R8_SNORM,
            [(0, $lmRm8.FORMATS).RGBA_INTEGER]: gl.RGBA8I,
            [(0, $lmRm8.FORMATS).RGB_INTEGER]: gl.RGB8I,
            [(0, $lmRm8.FORMATS).RG_INTEGER]: gl.RG8I,
            [(0, $lmRm8.FORMATS).RED_INTEGER]: gl.R8I
        },
        [(0, $lmRm8.TYPES).UNSIGNED_SHORT]: {
            [(0, $lmRm8.FORMATS).RGBA_INTEGER]: gl.RGBA16UI,
            [(0, $lmRm8.FORMATS).RGB_INTEGER]: gl.RGB16UI,
            [(0, $lmRm8.FORMATS).RG_INTEGER]: gl.RG16UI,
            [(0, $lmRm8.FORMATS).RED_INTEGER]: gl.R16UI,
            [(0, $lmRm8.FORMATS).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT16
        },
        [(0, $lmRm8.TYPES).SHORT]: {
            [(0, $lmRm8.FORMATS).RGBA_INTEGER]: gl.RGBA16I,
            [(0, $lmRm8.FORMATS).RGB_INTEGER]: gl.RGB16I,
            [(0, $lmRm8.FORMATS).RG_INTEGER]: gl.RG16I,
            [(0, $lmRm8.FORMATS).RED_INTEGER]: gl.R16I
        },
        [(0, $lmRm8.TYPES).UNSIGNED_INT]: {
            [(0, $lmRm8.FORMATS).RGBA_INTEGER]: gl.RGBA32UI,
            [(0, $lmRm8.FORMATS).RGB_INTEGER]: gl.RGB32UI,
            [(0, $lmRm8.FORMATS).RG_INTEGER]: gl.RG32UI,
            [(0, $lmRm8.FORMATS).RED_INTEGER]: gl.R32UI,
            [(0, $lmRm8.FORMATS).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT24
        },
        [(0, $lmRm8.TYPES).INT]: {
            [(0, $lmRm8.FORMATS).RGBA_INTEGER]: gl.RGBA32I,
            [(0, $lmRm8.FORMATS).RGB_INTEGER]: gl.RGB32I,
            [(0, $lmRm8.FORMATS).RG_INTEGER]: gl.RG32I,
            [(0, $lmRm8.FORMATS).RED_INTEGER]: gl.R32I
        },
        [(0, $lmRm8.TYPES).FLOAT]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGBA32F,
            [(0, $lmRm8.FORMATS).RGB]: gl.RGB32F,
            [(0, $lmRm8.FORMATS).RG]: gl.RG32F,
            [(0, $lmRm8.FORMATS).RED]: gl.R32F,
            [(0, $lmRm8.FORMATS).DEPTH_COMPONENT]: gl.DEPTH_COMPONENT32F
        },
        [(0, $lmRm8.TYPES).HALF_FLOAT]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGBA16F,
            [(0, $lmRm8.FORMATS).RGB]: gl.RGB16F,
            [(0, $lmRm8.FORMATS).RG]: gl.RG16F,
            [(0, $lmRm8.FORMATS).RED]: gl.R16F
        },
        [(0, $lmRm8.TYPES).UNSIGNED_SHORT_5_6_5]: {
            [(0, $lmRm8.FORMATS).RGB]: gl.RGB565
        },
        [(0, $lmRm8.TYPES).UNSIGNED_SHORT_4_4_4_4]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGBA4
        },
        [(0, $lmRm8.TYPES).UNSIGNED_SHORT_5_5_5_1]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGB5_A1
        },
        [(0, $lmRm8.TYPES).UNSIGNED_INT_2_10_10_10_REV]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGB10_A2,
            [(0, $lmRm8.FORMATS).RGBA_INTEGER]: gl.RGB10_A2UI
        },
        [(0, $lmRm8.TYPES).UNSIGNED_INT_10F_11F_11F_REV]: {
            [(0, $lmRm8.FORMATS).RGB]: gl.R11F_G11F_B10F
        },
        [(0, $lmRm8.TYPES).UNSIGNED_INT_5_9_9_9_REV]: {
            [(0, $lmRm8.FORMATS).RGB]: gl.RGB9_E5
        },
        [(0, $lmRm8.TYPES).UNSIGNED_INT_24_8]: {
            [(0, $lmRm8.FORMATS).DEPTH_STENCIL]: gl.DEPTH24_STENCIL8
        },
        [(0, $lmRm8.TYPES).FLOAT_32_UNSIGNED_INT_24_8_REV]: {
            [(0, $lmRm8.FORMATS).DEPTH_STENCIL]: gl.DEPTH32F_STENCIL8
        }
    } : table = {
        [(0, $lmRm8.TYPES).UNSIGNED_BYTE]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGBA,
            [(0, $lmRm8.FORMATS).RGB]: gl.RGB,
            [(0, $lmRm8.FORMATS).ALPHA]: gl.ALPHA,
            [(0, $lmRm8.FORMATS).LUMINANCE]: gl.LUMINANCE,
            [(0, $lmRm8.FORMATS).LUMINANCE_ALPHA]: gl.LUMINANCE_ALPHA
        },
        [(0, $lmRm8.TYPES).UNSIGNED_SHORT_5_6_5]: {
            [(0, $lmRm8.FORMATS).RGB]: gl.RGB
        },
        [(0, $lmRm8.TYPES).UNSIGNED_SHORT_4_4_4_4]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGBA
        },
        [(0, $lmRm8.TYPES).UNSIGNED_SHORT_5_5_5_1]: {
            [(0, $lmRm8.FORMATS).RGBA]: gl.RGBA
        }
    }, table;
}

});


parcelRegister("idUGs", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");
class $c42839d5a3281933$export$82410eeab0646070 {
    /**
   * @param renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
    /**
   * Bind TransformFeedback and buffers
   * @param transformFeedback - TransformFeedback to bind
   */ bind(transformFeedback) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glTransformFeedback = transformFeedback._glTransformFeedbacks[CONTEXT_UID] || this.createGLTransformFeedback(transformFeedback);
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
    }
    /** Unbind TransformFeedback */ unbind() {
        const { gl: gl } = this;
        gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null);
    }
    /**
   * Begin TransformFeedback
   * @param drawMode - DrawMode for TransformFeedback
   * @param shader - A Shader used by TransformFeedback. Current bound shader will be used if not provided.
   */ beginTransformFeedback(drawMode, shader) {
        const { gl: gl, renderer: renderer } = this;
        shader && renderer.shader.bind(shader), gl.beginTransformFeedback(drawMode);
    }
    /** End TransformFeedback */ endTransformFeedback() {
        const { gl: gl } = this;
        gl.endTransformFeedback();
    }
    /**
   * Create TransformFeedback and bind buffers
   * @param tf - TransformFeedback
   * @returns WebGLTransformFeedback
   */ createGLTransformFeedback(tf) {
        const { gl: gl, renderer: renderer, CONTEXT_UID: CONTEXT_UID } = this, glTransformFeedback = gl.createTransformFeedback();
        tf._glTransformFeedbacks[CONTEXT_UID] = glTransformFeedback, gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, glTransformFeedback);
        for(let i = 0; i < tf.buffers.length; i++){
            const buffer = tf.buffers[i];
            buffer && (renderer.buffer.update(buffer), buffer._glBuffers[CONTEXT_UID].refCount++, gl.bindBufferBase(gl.TRANSFORM_FEEDBACK_BUFFER, i, buffer._glBuffers[CONTEXT_UID].buffer || null));
        }
        return gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, null), tf.disposeRunner.add(this), glTransformFeedback;
    }
    /**
   * Disposes TransfromFeedback
   * @param {PIXI.TransformFeedback} tf - TransformFeedback
   * @param {boolean} [contextLost=false] - If context was lost, we suppress delete TransformFeedback
   */ disposeTransformFeedback(tf, contextLost) {
        const glTF = tf._glTransformFeedbacks[this.CONTEXT_UID], gl = this.gl;
        tf.disposeRunner.remove(this);
        const bufferSystem = this.renderer.buffer;
        if (bufferSystem) for(let i = 0; i < tf.buffers.length; i++){
            const buffer = tf.buffers[i];
            if (!buffer) continue;
            const buf = buffer._glBuffers[this.CONTEXT_UID];
            buf && (buf.refCount--, buf.refCount === 0 && !contextLost && bufferSystem.dispose(buffer, contextLost));
        }
        glTF && (contextLost || gl.deleteTransformFeedback(glTF), delete tf._glTransformFeedbacks[this.CONTEXT_UID]);
    }
    destroy() {
        this.renderer = null;
    }
}
$c42839d5a3281933$export$82410eeab0646070.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "transformFeedback"
};
(0, $5RvHb.extensions).add($c42839d5a3281933$export$82410eeab0646070);

});

parcelRegister("h5Bby", function(module, exports) {

$parcel$export(module.exports, "ViewSystem", () => $6755ee9eebd00dbb$export$6f21c3d5af6602af);

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9fnly");
var $kZOeV = parcelRequire("kZOeV");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
class $6755ee9eebd00dbb$export$6f21c3d5af6602af {
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * initiates the view system
   * @param {PIXI.ViewOptions} options - the options for the view
   */ init(options) {
        this.screen = new (0, $kZOeV.Rectangle)(0, 0, options.width, options.height), this.element = options.view || (0, $16eqM.settings).ADAPTER.createCanvas(), this.resolution = options.resolution || (0, $16eqM.settings).RESOLUTION, this.autoDensity = !!options.autoDensity;
    }
    /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   */ resizeView(desiredScreenWidth, desiredScreenHeight) {
        this.element.width = Math.round(desiredScreenWidth * this.resolution), this.element.height = Math.round(desiredScreenHeight * this.resolution);
        const screenWidth = this.element.width / this.resolution, screenHeight = this.element.height / this.resolution;
        this.screen.width = screenWidth, this.screen.height = screenHeight, this.autoDensity && (this.element.style.width = `${screenWidth}px`, this.element.style.height = `${screenHeight}px`), this.renderer.emit("resize", screenWidth, screenHeight), this.renderer.runners.resize.emit(this.screen.width, this.screen.height);
    }
    /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {boolean} [removeView=false] - Whether to remove the canvas from the DOM.
   */ destroy(removeView) {
        removeView && this.element.parentNode?.removeChild(this.element), this.renderer = null, this.element = null, this.screen = null;
    }
}
$6755ee9eebd00dbb$export$6f21c3d5af6602af.defaultOptions = {
    /**
   * {@link PIXI.IRendererOptions.width}
   * @default 800
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ width: 800,
    /**
   * {@link PIXI.IRendererOptions.height}
   * @default 600
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ height: 600,
    /**
   * {@link PIXI.IRendererOptions.resolution}
   * @type {number}
   * @default PIXI.settings.RESOLUTION
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ resolution: void 0,
    /**
   * {@link PIXI.IRendererOptions.autoDensity}
   * @default false
   * @memberof PIXI.settings.RENDER_OPTIONS
   */ autoDensity: !1
}, /** @ignore */ $6755ee9eebd00dbb$export$6f21c3d5af6602af.extension = {
    type: [
        (0, $5RvHb.ExtensionType).RendererSystem,
        (0, $5RvHb.ExtensionType).CanvasRendererSystem
    ],
    name: "_view"
};
(0, $5RvHb.extensions).add($6755ee9eebd00dbb$export$6f21c3d5af6602af);

});



parcelRegister("jje6E", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => (parcelRequire("3J55z")).Ticker);
$parcel$export(module.exports, "UPDATE_PRIORITY", () => (parcelRequire("iaX63")).UPDATE_PRIORITY);
parcelRequire("6QPyJ");

var $iaX63 = parcelRequire("iaX63");

var $3J55z = parcelRequire("3J55z");

var $dcsxa = parcelRequire("dcsxa");

});
parcelRegister("6QPyJ", function(module, exports) {
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
parcelRequire("lFGyw");
var $1Koy5 = parcelRequire("1Koy5");

var $3J55z = parcelRequire("3J55z");
Object.defineProperties((0, $16eqM.settings), {
    /**
   * Target frames per millisecond.
   * @static
   * @name TARGET_FPMS
   * @memberof PIXI.settings
   * @type {number}
   * @deprecated since 7.1.0
   * @see PIXI.Ticker.targetFPMS
   */ TARGET_FPMS: {
        get () {
            return (0, $3J55z.Ticker).targetFPMS;
        },
        set (value) {
            (0, $1Koy5.deprecation)("7.1.0", "settings.TARGET_FPMS is deprecated, use Ticker.targetFPMS"), (0, $3J55z.Ticker).targetFPMS = value;
        }
    }
});

});
parcelRegister("3J55z", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $ad2665272528cf94$export$39c54bcc89dcee11);

var $iaX63 = parcelRequire("iaX63");

var $goUFB = parcelRequire("goUFB");
const $ad2665272528cf94$var$_Ticker = class _Ticker2 {
    constructor(){
        this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new (0, $goUFB.TickerListener)(null, null, 1 / 0), this.deltaMS = 1 / _Ticker2.targetFPMS, this.elapsedMS = 1 / _Ticker2.targetFPMS, this._tick = (time)=>{
            this._requestId = null, this.started && (this.update(time), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */ _requestIfNeeded() {
        this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
    }
    /**
   * Conditionally cancels a pending animation frame.
   * @private
   */ _cancelIfNeeded() {
        this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */ _startIfPossible() {
        this.started ? this._requestIfNeeded() : this.autoStart && this.start();
    }
    /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ add(fn, context, priority = (0, $iaX63.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $goUFB.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ addOnce(fn, context, priority = (0, $iaX63.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $goUFB.TickerListener)(fn, context, priority, !0));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next, previous = this._head;
        if (!current) listener.connect(previous);
        else {
            for(; current;){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current, current = current.next;
            }
            listener.previous || listener.connect(previous);
        }
        return this._startIfPossible(), this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */ remove(fn, context) {
        let listener = this._head.next;
        for(; listener;)listener.match(fn, context) ? listener = listener.destroy() : listener = listener.next;
        return this._head.next || this._cancelIfNeeded(), this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */ get count() {
        if (!this._head) return 0;
        let count = 0, current = this._head;
        for(; current = current.next;)count++;
        return count;
    }
    /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */ start() {
        this.started || (this.started = !0, this._requestIfNeeded());
    }
    /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */ stop() {
        this.started && (this.started = !1, this._cancelIfNeeded());
    }
    /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            for(; listener;)listener = listener.destroy(!0);
            this._head.destroy(), this._head = null;
        }
    }
    /**
   * Triggers an update. An update entails setting the
   * current {@link PIXI.Ticker#elapsedMS},
   * the current {@link PIXI.Ticker#deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link PIXI.Ticker#lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            if (elapsedMS = this.elapsedMS = currentTime - this.lastTime, elapsedMS > this._maxElapsedMS && (elapsedMS = this._maxElapsedMS), elapsedMS *= this.speed, this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS, this.deltaTime = this.deltaMS * _Ticker2.targetFPMS;
            const head = this._head;
            let listener = head.next;
            for(; listener;)listener = listener.emit(this.deltaTime);
            head.next || this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link PIXI.Ticker#speed}, which is specific
   * to scaling {@link PIXI.Ticker#deltaTime}.
   * @member {number}
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This value is used to cap {@link PIXI.Ticker#deltaTime},
   * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps), minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker2.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link PIXI.Ticker#update}.
   * This will effect the measured value of {@link PIXI.Ticker#FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */ get maxFPS() {
        return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
   * {@link PIXI.VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the PIXI.Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {PIXI.Ticker}
   * @static
   */ static get shared() {
        if (!_Ticker2._shared) {
            const shared = _Ticker2._shared = new _Ticker2();
            shared.autoStart = !0, shared._protected = !0;
        }
        return _Ticker2._shared;
    }
    /**
   * The system ticker instance used by {@link PIXI.BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
   * @member {PIXI.Ticker}
   * @static
   */ static get system() {
        if (!_Ticker2._system) {
            const system = _Ticker2._system = new _Ticker2();
            system.autoStart = !0, system._protected = !0;
        }
        return _Ticker2._system;
    }
};
$ad2665272528cf94$var$_Ticker.targetFPMS = 0.06;
let $ad2665272528cf94$export$39c54bcc89dcee11 = $ad2665272528cf94$var$_Ticker;

});
parcelRegister("iaX63", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $bc7ed83ac944008c$export$688aaf132ba9b379);
var $bc7ed83ac944008c$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>(UPDATE_PRIORITY2[UPDATE_PRIORITY2.INTERACTION = 50] = "INTERACTION", UPDATE_PRIORITY2[UPDATE_PRIORITY2.HIGH = 25] = "HIGH", UPDATE_PRIORITY2[UPDATE_PRIORITY2.NORMAL = 0] = "NORMAL", UPDATE_PRIORITY2[UPDATE_PRIORITY2.LOW = -25] = "LOW", UPDATE_PRIORITY2[UPDATE_PRIORITY2.UTILITY = -50] = "UTILITY", UPDATE_PRIORITY2))($bc7ed83ac944008c$export$688aaf132ba9b379 || {});

});

parcelRegister("goUFB", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $fd623a44f80dcf2b$export$579021a5759a260f);
class $fd623a44f80dcf2b$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = !1){
        this.next = null, this.previous = null, this._destroyed = !1, this.fn = fn, this.context = context, this.priority = priority, this.once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this.fn === fn && this.context === context;
    }
    /**
   * Emit by calling the current function.
   * @private
   * @param deltaTime - time since the last emit.
   * @returns Next ticker
   */ emit(deltaTime) {
        this.fn && (this.context ? this.fn.call(this.context, deltaTime) : this.fn(deltaTime));
        const redirect = this.next;
        return this.once && this.destroy(!0), this._destroyed && (this.next = null), redirect;
    }
    /**
   * Connect to the list.
   * @private
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous, previous.next && (previous.next.previous = this), this.next = previous.next, previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @private
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = !1) {
        this._destroyed = !0, this.fn = null, this.context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
        const redirect = this.next;
        return this.next = hard ? null : redirect, this.previous = null, redirect;
    }
}

});



parcelRegister("dcsxa", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");

var $iaX63 = parcelRequire("iaX63");

var $3J55z = parcelRequire("3J55z");
class $32faba04e5b02ede$export$50c361ceb4e2f4f0 {
    /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        options = Object.assign({
            autoStart: !0,
            sharedTicker: !1
        }, options), Object.defineProperty(this, "ticker", {
            set (ticker) {
                this._ticker && this._ticker.remove(this.render, this), this._ticker = ticker, ticker && ticker.add(this.render, this, (0, $iaX63.UPDATE_PRIORITY).LOW);
            },
            get () {
                return this._ticker;
            }
        }), this.stop = ()=>{
            this._ticker.stop();
        }, this.start = ()=>{
            this._ticker.start();
        }, this._ticker = null, this.ticker = options.sharedTicker ? (0, $3J55z.Ticker).shared : new (0, $3J55z.Ticker)(), options.autoStart && this.start();
    }
    /**
   * Clean up the ticker, scoped to application.
   * @static
   * @private
   */ static destroy() {
        if (this._ticker) {
            const oldTicker = this._ticker;
            this.ticker = null, oldTicker.destroy();
        }
    }
}
$32faba04e5b02ede$export$50c361ceb4e2f4f0.extension = (0, $5RvHb.ExtensionType).Application;
(0, $5RvHb.extensions).add($32faba04e5b02ede$export$50c361ceb4e2f4f0);

});


parcelRegister("jZ2Bd", function(module, exports) {

$parcel$export(module.exports, "autoDetectRenderer", () => $562052ee832f105e$export$3583b92ab8150eb6);

var $5RvHb = parcelRequire("5RvHb");
const $562052ee832f105e$var$renderers = [];
(0, $5RvHb.extensions).handleByList((0, $5RvHb.ExtensionType).Renderer, $562052ee832f105e$var$renderers);
function $562052ee832f105e$export$3583b92ab8150eb6(options) {
    for (const RendererType of $562052ee832f105e$var$renderers)if (RendererType.test(options)) return new RendererType(options);
    throw new Error("Unable to auto-detect a suitable renderer.");
}

});

parcelRegister("aGSQK", function(module, exports) {

});

parcelRegister("17owa", function(module, exports) {

$parcel$export(module.exports, "defaultVertex", () => $bf6b256f229604e1$export$4a1a95006fc6b0f1);
$parcel$export(module.exports, "defaultFilterVertex", () => $bf6b256f229604e1$export$198627d10d1d088f);

var $8ms8n = parcelRequire("8ms8n");

var $ANxaJ = parcelRequire("ANxaJ");
const $bf6b256f229604e1$export$4a1a95006fc6b0f1 = (0, $8ms8n.default), $bf6b256f229604e1$export$198627d10d1d088f = (0, $ANxaJ.default);

});
parcelRegister("8ms8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f6cb5d3962331d$export$2e2bcd8739ae039);
var $a1f6cb5d3962331d$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`;

});

parcelRegister("ANxaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c32a97ff8e5957f8$export$2e2bcd8739ae039);
var $c32a97ff8e5957f8$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`;

});


parcelRegister("2bZnA", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
class $daced018becfbfdd$export$714ab7ecf6d70c30 {
    constructor(renderer){
        this.renderer = renderer;
    }
    contextChange(gl) {
        let samples;
        if (this.renderer.context.webGLVersion === 1) {
            const framebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.FRAMEBUFFER, null), samples = gl.getParameter(gl.SAMPLES), gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        } else {
            const framebuffer = gl.getParameter(gl.DRAW_FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null), samples = gl.getParameter(gl.SAMPLES), gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, framebuffer);
        }
        samples >= (0, $lmRm8.MSAA_QUALITY).HIGH ? this.multisample = (0, $lmRm8.MSAA_QUALITY).HIGH : samples >= (0, $lmRm8.MSAA_QUALITY).MEDIUM ? this.multisample = (0, $lmRm8.MSAA_QUALITY).MEDIUM : samples >= (0, $lmRm8.MSAA_QUALITY).LOW ? this.multisample = (0, $lmRm8.MSAA_QUALITY).LOW : this.multisample = (0, $lmRm8.MSAA_QUALITY).NONE;
    }
    destroy() {}
}
$daced018becfbfdd$export$714ab7ecf6d70c30.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "_multisample"
};
(0, $5RvHb.extensions).add($daced018becfbfdd$export$714ab7ecf6d70c30);

});

parcelRegister("cccDW", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");

var $he9wE = parcelRequire("he9wE");
class $e3b730536031b0e1$export$4010e50dab7d72d0 {
    /**
   * @param {PIXI.Renderer} renderer - The renderer this System works for.
   */ constructor(renderer){
        this.renderer = renderer, this.managedBuffers = {}, this.boundBufferBases = {};
    }
    /**
   * @ignore
   */ destroy() {
        this.renderer = null;
    }
    /** Sets up the renderer context and necessary buffers. */ contextChange() {
        this.disposeAll(!0), this.gl = this.renderer.gl, this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    }
    /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */ bind(buffer) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBuffer(buffer.type, glBuffer.buffer);
    }
    unbind(type) {
        const { gl: gl } = this;
        gl.bindBuffer(type, null);
    }
    /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind it to.
   */ bindBufferBase(buffer, index) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        if (this.boundBufferBases[index] !== buffer) {
            const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
            this.boundBufferBases[index] = buffer, gl.bindBufferBase(gl.UNIFORM_BUFFER, index, glBuffer.buffer);
        }
    }
    /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param buffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   */ bindBufferRange(buffer, index, offset) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this;
        offset = offset || 0;
        const glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBufferRange(gl.UNIFORM_BUFFER, index || 0, glBuffer.buffer, offset * 256, 256);
    }
    /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {PIXI.Buffer} buffer - the buffer to update
   */ update(buffer) {
        const { gl: gl, CONTEXT_UID: CONTEXT_UID } = this, glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        if (buffer._updateID !== glBuffer.updateID) {
            if (glBuffer.updateID = buffer._updateID, gl.bindBuffer(buffer.type, glBuffer.buffer), glBuffer.byteLength >= buffer.data.byteLength) gl.bufferSubData(buffer.type, 0, buffer.data);
            else {
                const drawType = buffer.static ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW;
                glBuffer.byteLength = buffer.data.byteLength, gl.bufferData(buffer.type, buffer.data, drawType);
            }
        }
    }
    /**
   * Disposes buffer
   * @param {PIXI.Buffer} buffer - buffer with data
   * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */ dispose(buffer, contextLost) {
        if (!this.managedBuffers[buffer.id]) return;
        delete this.managedBuffers[buffer.id];
        const glBuffer = buffer._glBuffers[this.CONTEXT_UID], gl = this.gl;
        buffer.disposeRunner.remove(this), glBuffer && (contextLost || gl.deleteBuffer(glBuffer.buffer), delete buffer._glBuffers[this.CONTEXT_UID]);
    }
    /**
   * dispose all WebGL resources of all managed buffers
   * @param {boolean} [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */ disposeAll(contextLost) {
        const all = Object.keys(this.managedBuffers);
        for(let i = 0; i < all.length; i++)this.dispose(this.managedBuffers[all[i]], contextLost);
    }
    /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */ createGLBuffer(buffer) {
        const { CONTEXT_UID: CONTEXT_UID, gl: gl } = this;
        return buffer._glBuffers[CONTEXT_UID] = new (0, $he9wE.GLBuffer)(gl.createBuffer()), this.managedBuffers[buffer.id] = buffer, buffer.disposeRunner.add(this), buffer._glBuffers[CONTEXT_UID];
    }
}
$e3b730536031b0e1$export$4010e50dab7d72d0.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "buffer"
};
(0, $5RvHb.extensions).add($e3b730536031b0e1$export$4010e50dab7d72d0);

});
parcelRegister("he9wE", function(module, exports) {

$parcel$export(module.exports, "GLBuffer", () => $43ed1bca3de125db$export$5185dfb57661e267);
class $43ed1bca3de125db$export$5185dfb57661e267 {
    constructor(buffer){
        this.buffer = buffer || null, this.updateID = -1, this.byteLength = -1, this.refCount = 0;
    }
}

});


parcelRegister("bxBZi", function(module, exports) {

});

parcelRegister("1de3N", function(module, exports) {

var $5RvHb = parcelRequire("5RvHb");
class $94f9cba4ce7df9fc$export$50cc3c4d71ad3547 {
    // renderers scene graph!
    constructor(renderer){
        this.renderer = renderer;
    }
    /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param options - the options to be passed to the renderer
   */ render(displayObject, options) {
        const renderer = this.renderer;
        let renderTexture, clear, transform, skipUpdateTransform;
        if (options && (renderTexture = options.renderTexture, clear = options.clear, transform = options.transform, skipUpdateTransform = options.skipUpdateTransform), this.renderingToScreen = !renderTexture, renderer.runners.prerender.emit(), renderer.emit("prerender"), renderer.projection.transform = transform, !renderer.context.isLost) {
            if (renderTexture || (this.lastObjectRendered = displayObject), !skipUpdateTransform) {
                const cacheParent = displayObject.enableTempParent();
                displayObject.updateTransform(), displayObject.disableTempParent(cacheParent);
            }
            renderer.renderTexture.bind(renderTexture), renderer.batch.currentRenderer.start(), (clear ?? renderer.background.clearBeforeRender) && renderer.renderTexture.clear(), displayObject.render(renderer), renderer.batch.currentRenderer.flush(), renderTexture && (options.blit && renderer.framebuffer.blit(), renderTexture.baseTexture.update()), renderer.runners.postrender.emit(), renderer.projection.transform = null, renderer.emit("postrender");
        }
    }
    destroy() {
        this.renderer = null, this.lastObjectRendered = null;
    }
}
$94f9cba4ce7df9fc$export$50cc3c4d71ad3547.extension = {
    type: (0, $5RvHb.ExtensionType).RendererSystem,
    name: "objectRenderer"
};
(0, $5RvHb.extensions).add($94f9cba4ce7df9fc$export$50cc3c4d71ad3547);

});

parcelRegister("hCwyL", function(module, exports) {

var $lmRm8 = parcelRequire("lmRm8");

var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9fnly");
var $6wJoy = parcelRequire("6wJoy");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
parcelRequire("lFGyw");
var $1Koy5 = parcelRequire("1Koy5");
var $3mZWL = parcelRequire("3mZWL");

var $BpNwR = parcelRequire("BpNwR");

var $6BfGe = parcelRequire("6BfGe");
const $985e2622e576b51b$var$_Renderer = class _Renderer2 extends (0, $6BfGe.SystemManager) {
    /**
   * @param {PIXI.IRendererOptions} [options] - See {@link PIXI.settings.RENDER_OPTIONS} for defaults.
   */ constructor(options){
        super(), this.type = (0, $lmRm8.RENDERER_TYPE).WEBGL, options = Object.assign({}, (0, $16eqM.settings).RENDER_OPTIONS, options), this.gl = null, this.CONTEXT_UID = 0, this.globalUniforms = new (0, $BpNwR.UniformGroup)({
            projectionMatrix: new (0, $6wJoy.Matrix)()
        }, !0);
        const systemConfig = {
            runners: [
                "init",
                "destroy",
                "contextChange",
                "resolutionChange",
                "reset",
                "update",
                "postrender",
                "prerender",
                "resize"
            ],
            systems: _Renderer2.__systems,
            priority: [
                "_view",
                "textureGenerator",
                "background",
                "_plugin",
                "startup",
                // low level WebGL systems
                "context",
                "state",
                "texture",
                "buffer",
                "geometry",
                "framebuffer",
                "transformFeedback",
                // high level pixi specific rendering
                "mask",
                "scissor",
                "stencil",
                "projection",
                "textureGC",
                "filter",
                "renderTexture",
                "batch",
                "objectRenderer",
                "_multisample"
            ]
        };
        this.setup(systemConfig), "useContextAlpha" in options && ((0, $1Koy5.deprecation)("7.0.0", "options.useContextAlpha is deprecated, use options.premultipliedAlpha and options.backgroundAlpha instead"), options.premultipliedAlpha = options.useContextAlpha && options.useContextAlpha !== "notMultiplied", options.backgroundAlpha = options.useContextAlpha === !1 ? 1 : options.backgroundAlpha), this._plugin.rendererPlugins = _Renderer2.__plugins, this.options = options, this.startup.run(this.options);
    }
    /**
   * Create renderer if WebGL is available. Overrideable
   * by the **@pixi/canvas-renderer** package to allow fallback.
   * throws error if WebGL is not available.
   * @param options
   * @private
   */ static test(options) {
        return options?.forceCanvas ? !1 : (0, $3mZWL.isWebGLSupported)();
    }
    /**
   * Renders the object to its WebGL view.
   * @param displayObject - The object to be rendered.
   * @param {object} [options] - Object to use for render options.
   * @param {PIXI.RenderTexture} [options.renderTexture] - The render texture to render to.
   * @param {boolean} [options.clear=true] - Should the canvas be cleared before the new render.
   * @param {PIXI.Matrix} [options.transform] - A transform to apply to the render texture before rendering.
   * @param {boolean} [options.skipUpdateTransform=false] - Should we skip the update transform pass?
   */ render(displayObject, options) {
        this.objectRenderer.render(displayObject, options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   */ resize(desiredScreenWidth, desiredScreenHeight) {
        this._view.resizeView(desiredScreenWidth, desiredScreenHeight);
    }
    /**
   * Resets the WebGL state so you can render things however you fancy!
   * @returns Returns itself.
   */ reset() {
        return this.runners.reset.emit(), this;
    }
    /** Clear the frame buffer. */ clear() {
        this.renderTexture.bind(), this.renderTexture.clear();
    }
    /**
   * Removes everything from the renderer (event listeners, spritebatch, etc...)
   * @param [removeView=false] - Removes the Canvas element from the DOM.
   *  See: https://github.com/pixijs/pixijs/issues/2233
   */ destroy(removeView = !1) {
        this.runners.destroy.items.reverse(), this.emitWithCustomOptions(this.runners.destroy, {
            _view: removeView
        }), super.destroy();
    }
    /** Collection of plugins */ get plugins() {
        return this._plugin.plugins;
    }
    /** The number of msaa samples of the canvas. */ get multisample() {
        return this._multisample.multisample;
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */ get width() {
        return this._view.element.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this._view.element.height;
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this._view.resolution;
    }
    set resolution(value) {
        this._view.resolution = value, this.runners.resolutionChange.emit(value);
    }
    /** Whether CSS dimensions of canvas view should be resized to screen dimensions automatically. */ get autoDensity() {
        return this._view.autoDensity;
    }
    /** The canvas element that everything is drawn to.*/ get view() {
        return this._view.element;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   * @member {PIXI.Rectangle}
   */ get screen() {
        return this._view.screen;
    }
    /** the last object rendered by the renderer. Useful for other plugins like interaction managers */ get lastObjectRendered() {
        return this.objectRenderer.lastObjectRendered;
    }
    /** Flag if we are rendering to the screen vs renderTexture */ get renderingToScreen() {
        return this.objectRenderer.renderingToScreen;
    }
    /** When logging Pixi to the console, this is the name we will show */ get rendererLogId() {
        return `WebGL ${this.context.webGLVersion}`;
    }
    /**
   * This sets weather the screen is totally cleared between each frame withthe background color and alpha
   * @deprecated since 7.0.0
   */ get clearBeforeRender() {
        return (0, $1Koy5.deprecation)("7.0.0", "renderer.clearBeforeRender has been deprecated, please use renderer.background.clearBeforeRender instead."), this.background.clearBeforeRender;
    }
    /**
   * Pass-thru setting for the canvas' context `alpha` property. This is typically
   * not something you need to fiddle with. If you want transparency, use `backgroundAlpha`.
   * @deprecated since 7.0.0
   * @member {boolean}
   */ get useContextAlpha() {
        return (0, $1Koy5.deprecation)("7.0.0", "renderer.useContextAlpha has been deprecated, please use renderer.context.premultipliedAlpha instead."), this.context.useContextAlpha;
    }
    /**
   * readonly drawing buffer preservation
   * we can only know this if Pixi created the context
   * @deprecated since 7.0.0
   */ get preserveDrawingBuffer() {
        return (0, $1Koy5.deprecation)("7.0.0", "renderer.preserveDrawingBuffer has been deprecated, we cannot truly know this unless pixi created the context"), this.context.preserveDrawingBuffer;
    }
    /**
   * The background color to fill if not transparent
   * @member {number}
   * @deprecated since 7.0.0
   */ get backgroundColor() {
        return (0, $1Koy5.deprecation)("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color;
    }
    set backgroundColor(value) {
        (0, $1Koy5.deprecation)("7.0.0", "renderer.backgroundColor has been deprecated, use renderer.background.color instead."), this.background.color = value;
    }
    /**
   * The background color alpha. Setting this to 0 will make the canvas transparent.
   * @member {number}
   * @deprecated since 7.0.0
   */ get backgroundAlpha() {
        return (0, $1Koy5.deprecation)("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha;
    }
    /**
   * @deprecated since 7.0.0
   */ set backgroundAlpha(value) {
        (0, $1Koy5.deprecation)("7.0.0", "renderer.backgroundAlpha has been deprecated, use renderer.background.alpha instead."), this.background.alpha = value;
    }
    /**
   * @deprecated since 7.0.0
   */ get powerPreference() {
        return (0, $1Koy5.deprecation)("7.0.0", "renderer.powerPreference has been deprecated, we can only know this if pixi creates the context"), this.context.powerPreference;
    }
    /**
   * Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   * @param displayObject - The displayObject the object will be generated from.
   * @param {IGenerateTextureOptions} options - Generate texture options.
   * @param {PIXI.Rectangle} options.region - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @param {number} [options.resolution] - If not given, the renderer's resolution is used.
   * @param {PIXI.MSAA_QUALITY} [options.multisample] - If not given, the renderer's multisample is used.
   * @returns A texture of the graphics object.
   */ generateTexture(displayObject, options) {
        return this.textureGenerator.generateTexture(displayObject, options);
    }
};
$985e2622e576b51b$var$_Renderer.extension = {
    type: (0, $5RvHb.ExtensionType).Renderer,
    priority: 1
}, /**
* Collection of installed plugins. These are included by default in PIXI, but can be excluded
* by creating a custom build. Consult the README for more information about creating custom
* builds and excluding plugins.
* @private
*/ $985e2622e576b51b$var$_Renderer.__plugins = {}, /**
* The collection of installed systems.
* @private
*/ $985e2622e576b51b$var$_Renderer.__systems = {};
let $985e2622e576b51b$export$88530751e3977073 = $985e2622e576b51b$var$_Renderer;
(0, $5RvHb.extensions).handleByMap((0, $5RvHb.ExtensionType).RendererPlugin, $985e2622e576b51b$export$88530751e3977073.__plugins);
(0, $5RvHb.extensions).handleByMap((0, $5RvHb.ExtensionType).RendererSystem, $985e2622e576b51b$export$88530751e3977073.__systems);
(0, $5RvHb.extensions).add($985e2622e576b51b$export$88530751e3977073);

});

parcelRegister("91EPG", function(module, exports) {

});

parcelRegister("5g4kz", function(module, exports) {

var $e4rs8 = parcelRequire("e4rs8");

var $12R2z = parcelRequire("12R2z");

var $1oZjy = parcelRequire("1oZjy");

var $1rY8B = parcelRequire("1rY8B");

var $hTaGg = parcelRequire("hTaGg");

var $165nJ = parcelRequire("165nJ");

var $9iM43 = parcelRequire("9iM43");

var $h8Rzw = parcelRequire("h8Rzw");

var $hWdIv = parcelRequire("hWdIv");

var $iqQDF = parcelRequire("iqQDF");

var $bmxlM = parcelRequire("bmxlM");

var $fbY8e = parcelRequire("fbY8e");

var $ls824 = parcelRequire("ls824");
(0, $12R2z.INSTALLED).push((0, $165nJ.ImageBitmapResource), (0, $9iM43.ImageResource), (0, $1rY8B.CanvasResource), (0, $iqQDF.VideoResource), (0, $hWdIv.VideoFrameResource), (0, $h8Rzw.SVGResource), (0, $1oZjy.BufferResource), (0, $hTaGg.CubeResource), (0, $e4rs8.ArrayResource));

});
parcelRegister("e4rs8", function(module, exports) {

$parcel$export(module.exports, "ArrayResource", () => $5f43ecabe92b03ae$export$aa0af7255ee278f1);

var $lmRm8 = parcelRequire("lmRm8");

var $ls824 = parcelRequire("ls824");
class $5f43ecabe92b03ae$export$aa0af7255ee278f1 extends (0, $ls824.AbstractMultiResource) {
    /**
   * @param source - Number of items in array or the collection
   *        of image URLs to use. Can also be resources, image elements, canvas, etc.
   * @param options - Options to apply to {@link PIXI.autoDetectResource}
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */ constructor(source, options){
        const { width: width, height: height } = options || {};
        let urls, length;
        Array.isArray(source) ? (urls = source, length = source.length) : length = source, super(length, {
            width: width,
            height: height
        }), urls && this.initFromArray(urls, options);
    }
    /**
   * Set a baseTexture by ID,
   * ArrayResource just takes resource from it, nothing more
   * @param baseTexture
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */ addBaseTextureAt(baseTexture, index) {
        if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
        else throw new Error("ArrayResource does not support RenderTexture");
        return this;
    }
    /**
   * Add binding
   * @param baseTexture
   */ bind(baseTexture) {
        super.bind(baseTexture), baseTexture.target = (0, $lmRm8.TARGETS).TEXTURE_2D_ARRAY;
    }
    /**
   * Upload the resources to the GPU.
   * @param renderer
   * @param texture
   * @param glTexture
   * @returns - whether texture was uploaded
   */ upload(renderer, texture, glTexture) {
        const { length: length, itemDirtyIds: itemDirtyIds, items: items } = this, { gl: gl } = renderer;
        glTexture.dirtyId < 0 && gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, glTexture.internalFormat, this._width, this._height, length, 0, texture.format, glTexture.type, null);
        for(let i = 0; i < length; i++){
            const item = items[i];
            itemDirtyIds[i] < item.dirtyId && (itemDirtyIds[i] = item.dirtyId, item.valid && gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, // xoffset
            0, // yoffset
            i, // zoffset
            item.resource.width, item.resource.height, 1, texture.format, glTexture.type, item.resource.source));
        }
        return !0;
    }
}

});
parcelRegister("ls824", function(module, exports) {

$parcel$export(module.exports, "AbstractMultiResource", () => $d45090b58c98cadf$export$195275694901de82);

var $4oWO8 = parcelRequire("4oWO8");

var $12R2z = parcelRequire("12R2z");

var $fbY8e = parcelRequire("fbY8e");
class $d45090b58c98cadf$export$195275694901de82 extends (0, $fbY8e.Resource) {
    /**
   * @param length
   * @param options - Options to for Resource constructor
   * @param {number} [options.width] - Width of the resource
   * @param {number} [options.height] - Height of the resource
   */ constructor(length, options){
        const { width: width, height: height } = options || {};
        super(width, height), this.items = [], this.itemDirtyIds = [];
        for(let i = 0; i < length; i++){
            const partTexture = new (0, $4oWO8.BaseTexture)();
            this.items.push(partTexture), this.itemDirtyIds.push(-2);
        }
        this.length = length, this._load = null, this.baseTexture = null;
    }
    /**
   * Used from ArrayResource and CubeResource constructors.
   * @param resources - Can be resources, image elements, canvas, etc. ,
   *  length should be same as constructor length
   * @param options - Detect options for resources
   */ initFromArray(resources, options) {
        for(let i = 0; i < this.length; i++)resources[i] && (resources[i].castToBaseTexture ? this.addBaseTextureAt(resources[i].castToBaseTexture(), i) : resources[i] instanceof (0, $fbY8e.Resource) ? this.addResourceAt(resources[i], i) : this.addResourceAt((0, $12R2z.autoDetectResource)(resources[i], options), i));
    }
    /** Destroy this BaseImageResource. */ dispose() {
        for(let i = 0, len = this.length; i < len; i++)this.items[i].destroy();
        this.items = null, this.itemDirtyIds = null, this._load = null;
    }
    /**
   * Set a resource by ID
   * @param resource
   * @param index - Zero-based index of resource to set
   * @returns - Instance for chaining
   */ addResourceAt(resource, index) {
        if (!this.items[index]) throw new Error(`Index ${index} is out of bounds`);
        return resource.valid && !this.valid && this.resize(resource.width, resource.height), this.items[index].setResource(resource), this;
    }
    /**
   * Set the parent base texture.
   * @param baseTexture
   */ bind(baseTexture) {
        if (this.baseTexture !== null) throw new Error("Only one base texture per TextureArray is allowed");
        super.bind(baseTexture);
        for(let i = 0; i < this.length; i++)this.items[i].parentTextureArray = baseTexture, this.items[i].on("update", baseTexture.update, baseTexture);
    }
    /**
   * Unset the parent base texture.
   * @param baseTexture
   */ unbind(baseTexture) {
        super.unbind(baseTexture);
        for(let i = 0; i < this.length; i++)this.items[i].parentTextureArray = null, this.items[i].off("update", baseTexture.update, baseTexture);
    }
    /**
   * Load all the resources simultaneously
   * @returns - When load is resolved
   */ load() {
        if (this._load) return this._load;
        const promises = this.items.map((item)=>item.resource).filter((item)=>item).map((item)=>item.load());
        return this._load = Promise.all(promises).then(()=>{
            const { realWidth: realWidth, realHeight: realHeight } = this.items[0];
            return this.resize(realWidth, realHeight), this.update(), Promise.resolve(this);
        }), this._load;
    }
}

});


parcelRegister("1rY8B", function(module, exports) {

$parcel$export(module.exports, "CanvasResource", () => $26a888edbd80a69d$export$3bea879ce3e5cb51);

var $bmxlM = parcelRequire("bmxlM");
class $26a888edbd80a69d$export$3bea879ce3e5cb51 extends (0, $bmxlM.BaseImageResource) {
    /**
   * @param source - Canvas element to use
   */ // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(source){
        super(source);
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is HTMLCanvasElement or OffscreenCanvas
   */ static test(source) {
        const { OffscreenCanvas: OffscreenCanvas } = globalThis;
        return OffscreenCanvas && source instanceof OffscreenCanvas ? !0 : globalThis.HTMLCanvasElement && source instanceof HTMLCanvasElement;
    }
}

});

parcelRegister("hTaGg", function(module, exports) {

$parcel$export(module.exports, "CubeResource", () => $4679a086338ac699$export$c786bc8247db64cb);

var $lmRm8 = parcelRequire("lmRm8");

var $ls824 = parcelRequire("ls824");
const $4679a086338ac699$var$_CubeResource = class _CubeResource2 extends (0, $ls824.AbstractMultiResource) {
    /**
   * @param {Array<string|PIXI.Resource>} [source] - Collection of URLs or resources
   *        to use as the sides of the cube.
   * @param options - ImageResource options
   * @param {number} [options.width] - Width of resource
   * @param {number} [options.height] - Height of resource
   * @param {number} [options.autoLoad=true] - Whether to auto-load resources
   * @param {number} [options.linkBaseTexture=true] - In case BaseTextures are supplied,
   *   whether to copy them or use
   */ constructor(source, options){
        const { width: width, height: height, autoLoad: autoLoad, linkBaseTexture: linkBaseTexture } = options || {};
        if (source && source.length !== _CubeResource2.SIDES) throw new Error(`Invalid length. Got ${source.length}, expected 6`);
        super(6, {
            width: width,
            height: height
        });
        for(let i = 0; i < _CubeResource2.SIDES; i++)this.items[i].target = (0, $lmRm8.TARGETS).TEXTURE_CUBE_MAP_POSITIVE_X + i;
        this.linkBaseTexture = linkBaseTexture !== !1, source && this.initFromArray(source, options), autoLoad !== !1 && this.load();
    }
    /**
   * Add binding.
   * @param baseTexture - parent base texture
   */ bind(baseTexture) {
        super.bind(baseTexture), baseTexture.target = (0, $lmRm8.TARGETS).TEXTURE_CUBE_MAP;
    }
    addBaseTextureAt(baseTexture, index, linkBaseTexture) {
        if (linkBaseTexture === void 0 && (linkBaseTexture = this.linkBaseTexture), !this.items[index]) throw new Error(`Index ${index} is out of bounds`);
        if (!this.linkBaseTexture || baseTexture.parentTextureArray || Object.keys(baseTexture._glTextures).length > 0) {
            if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
            else throw new Error("CubeResource does not support copying of renderTexture.");
        } else baseTexture.target = (0, $lmRm8.TARGETS).TEXTURE_CUBE_MAP_POSITIVE_X + index, baseTexture.parentTextureArray = this.baseTexture, this.items[index] = baseTexture;
        return baseTexture.valid && !this.valid && this.resize(baseTexture.realWidth, baseTexture.realHeight), this.items[index] = baseTexture, this;
    }
    /**
   * Upload the resource
   * @param renderer
   * @param _baseTexture
   * @param glTexture
   * @returns {boolean} true is success
   */ upload(renderer, _baseTexture, glTexture) {
        const dirty = this.itemDirtyIds;
        for(let i = 0; i < _CubeResource2.SIDES; i++){
            const side = this.items[i];
            (dirty[i] < side.dirtyId || glTexture.dirtyId < _baseTexture.dirtyId) && (side.valid && side.resource ? (side.resource.upload(renderer, side, glTexture), dirty[i] = side.dirtyId) : dirty[i] < -1 && (renderer.gl.texImage2D(side.target, 0, glTexture.internalFormat, _baseTexture.realWidth, _baseTexture.realHeight, 0, _baseTexture.format, glTexture.type, null), dirty[i] = -1));
        }
        return !0;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is an array of 6 elements
   */ static test(source) {
        return Array.isArray(source) && source.length === _CubeResource2.SIDES;
    }
};
$4679a086338ac699$var$_CubeResource.SIDES = 6;
let $4679a086338ac699$export$c786bc8247db64cb = $4679a086338ac699$var$_CubeResource;

});

parcelRegister("165nJ", function(module, exports) {

$parcel$export(module.exports, "ImageBitmapResource", () => $cc1514b15a03e989$export$422084391f3a58a3);

var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");

var $bmxlM = parcelRequire("bmxlM");
class $cc1514b15a03e989$export$422084391f3a58a3 extends (0, $bmxlM.BaseImageResource) {
    /**
   * @param source - ImageBitmap or URL to use.
   * @param options - Options to use.
   */ constructor(source, options){
        options = options || {};
        let baseSource, url, ownsImageBitmap;
        typeof source == "string" ? (baseSource = $cc1514b15a03e989$export$422084391f3a58a3.EMPTY, url = source, ownsImageBitmap = !0) : (baseSource = source, url = null, ownsImageBitmap = !1), super(baseSource), this.url = url, this.crossOrigin = options.crossOrigin ?? !0, this.alphaMode = typeof options.alphaMode == "number" ? options.alphaMode : null, this.ownsImageBitmap = options.ownsImageBitmap ?? ownsImageBitmap, this._load = null, options.autoLoad !== !1 && this.load();
    }
    load() {
        return this._load ? this._load : (this._load = new Promise(async (resolve, reject)=>{
            if (this.url === null) {
                resolve(this);
                return;
            }
            try {
                const response = await (0, $16eqM.settings).ADAPTER.fetch(this.url, {
                    mode: this.crossOrigin ? "cors" : "no-cors"
                });
                if (this.destroyed) return;
                const imageBlob = await response.blob();
                if (this.destroyed) return;
                const imageBitmap = await createImageBitmap(imageBlob, {
                    premultiplyAlpha: this.alphaMode === null || this.alphaMode === (0, $lmRm8.ALPHA_MODES).UNPACK ? "premultiply" : "none"
                });
                if (this.destroyed) {
                    imageBitmap.close();
                    return;
                }
                this.source = imageBitmap, this.update(), resolve(this);
            } catch (e) {
                if (this.destroyed) return;
                reject(e), this.onError.emit(e);
            }
        }), this._load);
    }
    /**
   * Upload the image bitmap resource to GPU.
   * @param renderer - Renderer to upload to
   * @param baseTexture - BaseTexture for this resource
   * @param glTexture - GLTexture to use
   * @returns {boolean} true is success
   */ upload(renderer, baseTexture, glTexture) {
        return this.source instanceof ImageBitmap ? (typeof this.alphaMode == "number" && (baseTexture.alphaMode = this.alphaMode), super.upload(renderer, baseTexture, glTexture)) : (this.load(), !1);
    }
    /** Destroys this resource. */ dispose() {
        this.ownsImageBitmap && this.source instanceof ImageBitmap && this.source.close(), super.dispose(), this._load = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if current environment support ImageBitmap, and source is string or ImageBitmap
   */ static test(source) {
        return !!globalThis.createImageBitmap && typeof ImageBitmap < "u" && (typeof source == "string" || source instanceof ImageBitmap);
    }
    /**
   * ImageBitmap cannot be created synchronously, so a empty placeholder canvas is needed when loading from URLs.
   * Only for internal usage.
   * @returns The cached placeholder canvas.
   */ static get EMPTY() {
        return $cc1514b15a03e989$export$422084391f3a58a3._EMPTY = $cc1514b15a03e989$export$422084391f3a58a3._EMPTY ?? (0, $16eqM.settings).ADAPTER.createCanvas(0, 0), $cc1514b15a03e989$export$422084391f3a58a3._EMPTY;
    }
}

});

parcelRegister("h8Rzw", function(module, exports) {

$parcel$export(module.exports, "SVGResource", () => $e1c52b915095bad3$export$aeb8ac9a3d5d46a0);
parcelRequire("fVntm");
var $16eqM = parcelRequire("16eqM");
parcelRequire("lFGyw");
var $2yb2o = parcelRequire("2yb2o");

var $bmxlM = parcelRequire("bmxlM");
const $e1c52b915095bad3$var$_SVGResource = class _SVGResource2 extends (0, $bmxlM.BaseImageResource) {
    /**
   * @param sourceBase64 - Base64 encoded SVG element or URL for SVG file.
   * @param {object} [options] - Options to use
   * @param {number} [options.scale=1] - Scale to apply to SVG. Overridden by...
   * @param {number} [options.width] - Rasterize SVG this wide. Aspect ratio preserved if height not specified.
   * @param {number} [options.height] - Rasterize SVG this high. Aspect ratio preserved if width not specified.
   * @param {boolean} [options.autoLoad=true] - Start loading right away.
   */ constructor(sourceBase64, options){
        options = options || {}, super((0, $16eqM.settings).ADAPTER.createCanvas()), this._width = 0, this._height = 0, this.svg = sourceBase64, this.scale = options.scale || 1, this._overrideWidth = options.width, this._overrideHeight = options.height, this._resolve = null, this._crossorigin = options.crossorigin, this._load = null, options.autoLoad !== !1 && this.load();
    }
    load() {
        return this._load ? this._load : (this._load = new Promise((resolve)=>{
            if (this._resolve = ()=>{
                this.update(), resolve(this);
            }, _SVGResource2.SVG_XML.test(this.svg.trim())) {
                if (!btoa) throw new Error("Your browser doesn't support base64 conversions.");
                this.svg = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(this.svg)))}`;
            }
            this._loadSvg();
        }), this._load);
    }
    /** Loads an SVG image from `imageUrl` or `data URL`. */ _loadSvg() {
        const tempImage = new Image();
        (0, $bmxlM.BaseImageResource).crossOrigin(tempImage, this.svg, this._crossorigin), tempImage.src = this.svg, tempImage.onerror = (event)=>{
            this._resolve && (tempImage.onerror = null, this.onError.emit(event));
        }, tempImage.onload = ()=>{
            if (!this._resolve) return;
            const svgWidth = tempImage.width, svgHeight = tempImage.height;
            if (!svgWidth || !svgHeight) throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");
            let width = svgWidth * this.scale, height = svgHeight * this.scale;
            (this._overrideWidth || this._overrideHeight) && (width = this._overrideWidth || this._overrideHeight / svgHeight * svgWidth, height = this._overrideHeight || this._overrideWidth / svgWidth * svgHeight), width = Math.round(width), height = Math.round(height);
            const canvas = this.source;
            canvas.width = width, canvas.height = height, canvas._pixiId = `canvas_${(0, $2yb2o.uid)()}`, canvas.getContext("2d").drawImage(tempImage, 0, 0, svgWidth, svgHeight, 0, 0, width, height), this._resolve(), this._resolve = null;
        };
    }
    /**
   * Get size from an svg string using a regular expression.
   * @param svgString - a serialized svg element
   * @returns - image extension
   */ static getSize(svgString) {
        const sizeMatch = _SVGResource2.SVG_SIZE.exec(svgString), size = {};
        return sizeMatch && (size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3])), size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]))), size;
    }
    /** Destroys this texture. */ dispose() {
        super.dispose(), this._resolve = null, this._crossorigin = null;
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} - If the source is a SVG source or data file
   */ static test(source, extension) {
        return extension === "svg" || typeof source == "string" && source.startsWith("data:image/svg+xml") || typeof source == "string" && _SVGResource2.SVG_XML.test(source);
    }
};
$e1c52b915095bad3$var$_SVGResource.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m, /**
* Regular expression for SVG size.
* @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
* @readonly
*/ $e1c52b915095bad3$var$_SVGResource.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i;
let $e1c52b915095bad3$export$aeb8ac9a3d5d46a0 = $e1c52b915095bad3$var$_SVGResource;

});

parcelRegister("hWdIv", function(module, exports) {

$parcel$export(module.exports, "VideoFrameResource", () => $6a2c47c74e186034$export$1773ed6255148cef);

var $bmxlM = parcelRequire("bmxlM");
class $6a2c47c74e186034$export$1773ed6255148cef extends (0, $bmxlM.BaseImageResource) {
    /**
   * @param source - Image element to use
   */ // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(source){
        super(source);
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @returns {boolean} `true` if source is an VideoFrame
   */ static test(source) {
        return !!globalThis.VideoFrame && source instanceof globalThis.VideoFrame;
    }
}

});

parcelRegister("iqQDF", function(module, exports) {

$parcel$export(module.exports, "VideoResource", () => $fad0aab3ecec357f$export$f7dd53bb53e9c0d7);
parcelRequire("jje6E");
var $3J55z = parcelRequire("3J55z");

var $bmxlM = parcelRequire("bmxlM");
const $fad0aab3ecec357f$var$_VideoResource = class _VideoResource2 extends (0, $bmxlM.BaseImageResource) {
    /**
   * @param {HTMLVideoElement|object|string|Array<string|object>} source - Video element to use.
   * @param {object} [options] - Options to use
   * @param {boolean} [options.autoLoad=true] - Start loading the video immediately
   * @param {boolean} [options.autoPlay=true] - Start playing video immediately
   * @param {number} [options.updateFPS=0] - How many times a second to update the texture from the video.
   * If 0, `requestVideoFrameCallback` is used to update the texture.
   * If `requestVideoFrameCallback` is not available, the texture is updated every render.
   * @param {boolean} [options.crossorigin=true] - Load image using cross origin
   * @param {boolean} [options.loop=false] - Loops the video
   * @param {boolean} [options.muted=false] - Mutes the video audio, useful for autoplay
   * @param {boolean} [options.playsinline=true] - Prevents opening the video on mobile devices
   */ constructor(source, options){
        if (options = options || {}, !(source instanceof HTMLVideoElement)) {
            const videoElement = document.createElement("video");
            options.autoLoad !== !1 && videoElement.setAttribute("preload", "auto"), options.playsinline !== !1 && (videoElement.setAttribute("webkit-playsinline", ""), videoElement.setAttribute("playsinline", "")), options.muted === !0 && (videoElement.setAttribute("muted", ""), videoElement.muted = !0), options.loop === !0 && videoElement.setAttribute("loop", ""), options.autoPlay !== !1 && videoElement.setAttribute("autoplay", ""), typeof source == "string" && (source = [
                source
            ]);
            const firstSrc = source[0].src || source[0];
            (0, $bmxlM.BaseImageResource).crossOrigin(videoElement, firstSrc, options.crossorigin);
            for(let i = 0; i < source.length; ++i){
                const sourceElement = document.createElement("source");
                let { src: src, mime: mime } = source[i];
                if (src = src || source[i], src.startsWith("data:")) mime = src.slice(5, src.indexOf(";"));
                else if (!src.startsWith("blob:")) {
                    const baseSrc = src.split("?").shift().toLowerCase(), ext = baseSrc.slice(baseSrc.lastIndexOf(".") + 1);
                    mime = mime || _VideoResource2.MIME_TYPES[ext] || `video/${ext}`;
                }
                sourceElement.src = src, mime && (sourceElement.type = mime), videoElement.appendChild(sourceElement);
            }
            source = videoElement;
        }
        super(source), this.noSubImage = !0, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = options.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = options.autoPlay !== !1, this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), options.autoLoad !== !1 && this.load();
    }
    /**
   * Trigger updating of the texture.
   * @param _deltaTime - time delta since last tick
   */ update(_deltaTime = 0) {
        if (!this.destroyed) {
            if (this._updateFPS) {
                const elapsedMS = (0, $3J55z.Ticker).shared.elapsedMS * this.source.playbackRate;
                this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
            }
            (!this._updateFPS || this._msToNextUpdate <= 0) && (super.update(), this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0);
        }
    }
    _videoFrameRequestCallback() {
        this.update(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<void>} Handle the validate event
   */ load() {
        if (this._load) return this._load;
        const source = this.source;
        return (source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height && (source.complete = !0), source.addEventListener("play", this._onPlayStart), source.addEventListener("pause", this._onPlayStop), source.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._onCanPlay() : (source.addEventListener("canplay", this._onCanPlay), source.addEventListener("canplaythrough", this._onCanPlay), source.addEventListener("error", this._onError, !0)), this._load = new Promise((resolve, reject)=>{
            this.valid ? resolve(this) : (this._resolve = resolve, this._reject = reject, source.load());
        }), this._load;
    }
    /**
   * Handle video error events.
   * @param event
   */ _onError(event) {
        this.source.removeEventListener("error", this._onError, !0), this.onError.emit(event), this._reject && (this._reject(event), this._reject = null, this._resolve = null);
    }
    /**
   * Returns true if the underlying source is playing.
   * @returns - True if playing.
   */ _isSourcePlaying() {
        const source = this.source;
        return !source.paused && !source.ended;
    }
    /**
   * Returns true if the underlying source is ready for playing.
   * @returns - True if ready.
   */ _isSourceReady() {
        return this.source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        this.valid || this._onCanPlay(), this._configureAutoUpdate();
    }
    /** Fired when a pause event is triggered, stops the update loop. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Fired when the video is completed seeking to the current playback position. */ _onSeeked() {
        this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0);
    }
    /** Fired when the video is loaded and ready to play. */ _onCanPlay() {
        const source = this.source;
        source.removeEventListener("canplay", this._onCanPlay), source.removeEventListener("canplaythrough", this._onCanPlay);
        const valid = this.valid;
        this._msToNextUpdate = 0, this.update(), this._msToNextUpdate = 0, !valid && this._resolve && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && source.play();
    }
    /** Destroys this texture. */ dispose() {
        this._configureAutoUpdate();
        const source = this.source;
        source && (source.removeEventListener("play", this._onPlayStart), source.removeEventListener("pause", this._onPlayStop), source.removeEventListener("seeked", this._onSeeked), source.removeEventListener("canplay", this._onCanPlay), source.removeEventListener("canplaythrough", this._onCanPlay), source.removeEventListener("error", this._onError, !0), source.pause(), source.src = "", source.load()), super.dispose();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        value !== this._autoUpdate && (this._autoUpdate = value, this._configureAutoUpdate());
    }
    /**
   * How many times a second to update the texture from the video. If 0, `requestVideoFrameCallback` is used to
   * update the texture. If `requestVideoFrameCallback` is not available, the texture is updated every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        value !== this._updateFPS && (this._updateFPS = value, this._configureAutoUpdate());
    }
    _configureAutoUpdate() {
        this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.source.requestVideoFrameCallback ? (this._isConnectedToTicker && ((0, $3J55z.Ticker).shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.source.requestVideoFrameCallback(this._videoFrameRequestCallback))) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || ((0, $3J55z.Ticker).shared.add(this.update, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.source.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && ((0, $3J55z.Ticker).shared.remove(this.update, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
    }
    /**
   * Used to auto-detect the type of resource.
   * @param {*} source - The source object
   * @param {string} extension - The extension of source, if set
   * @returns {boolean} `true` if video source
   */ static test(source, extension) {
        return globalThis.HTMLVideoElement && source instanceof HTMLVideoElement || _VideoResource2.TYPES.includes(extension);
    }
};
$fad0aab3ecec357f$var$_VideoResource.TYPES = [
    "mp4",
    "m4v",
    "webm",
    "ogg",
    "ogv",
    "h264",
    "avi",
    "mov"
], /**
* Map of video MIME types that can't be directly derived from file extensions.
* @readonly
*/ $fad0aab3ecec357f$var$_VideoResource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $fad0aab3ecec357f$export$f7dd53bb53e9c0d7 = $fad0aab3ecec357f$var$_VideoResource;

});


parcelRegister("9zIzb", function(module, exports) {
parcelRequire("hWIIU");
var $aDHVi = parcelRequire("aDHVi");
class $672d45308dd1e677$export$1f7c70f8d6979c19 {
    constructor(){
        this._glTransformFeedbacks = {}, this.buffers = [], this.disposeRunner = new (0, $aDHVi.Runner)("disposeTransformFeedback");
    }
    /**
   * Bind buffer to TransformFeedback
   * @param index - index to bind
   * @param buffer - buffer to bind
   */ bindBuffer(index, buffer) {
        this.buffers[index] = buffer;
    }
    /** Destroy WebGL resources that are connected to this TransformFeedback. */ destroy() {
        this.disposeRunner.emit(this, !1);
    }
}

});


parcelRegister("gD5uZ", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => (parcelRequire("aMxkH")).Bounds);
$parcel$export(module.exports, "Container", () => (parcelRequire("3IPo5")).Container);
$parcel$export(module.exports, "DisplayObject", () => (parcelRequire("5xkOK")).DisplayObject);
parcelRequire("eY1IY");

var $aMxkH = parcelRequire("aMxkH");

var $3IPo5 = parcelRequire("3IPo5");

var $5xkOK = parcelRequire("5xkOK");

});
parcelRegister("eY1IY", function(module, exports) {
parcelRequire("inflE");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");

var $3IPo5 = parcelRequire("3IPo5");
Object.defineProperties((0, $16eqM.settings), {
    /**
   * Sets the default value for the container property 'sortableChildren'.
   * @static
   * @name SORTABLE_CHILDREN
   * @memberof PIXI.settings
   * @deprecated since 7.1.0
   * @type {boolean}
   * @see PIXI.Container.defaultSortableChildren
   */ SORTABLE_CHILDREN: {
        get () {
            return (0, $3IPo5.Container).defaultSortableChildren;
        },
        set (value) {
            (0, $lFGyw).deprecation("7.1.0", "settings.SORTABLE_CHILDREN is deprecated, use Container.defaultSortableChildren"), (0, $3IPo5.Container).defaultSortableChildren = value;
        }
    }
});

});
parcelRegister("3IPo5", function(module, exports) {

$parcel$export(module.exports, "Container", () => $823fbc2c4ae841df$export$42a852a2b6b56249);
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $6wJoy = parcelRequire("6wJoy");
var $lFGyw = parcelRequire("lFGyw");

var $5xkOK = parcelRequire("5xkOK");
const $823fbc2c4ae841df$var$tempMatrix = new (0, $6wJoy.Matrix)();
function $823fbc2c4ae841df$var$sortChildren(a, b) {
    return a.zIndex === b.zIndex ? a._lastSortedIndex - b._lastSortedIndex : a.zIndex - b.zIndex;
}
const $823fbc2c4ae841df$var$_Container = class _Container2 extends (0, $5xkOK.DisplayObject) {
    constructor(){
        super(), this.children = [], this.sortableChildren = _Container2.defaultSortableChildren, this.sortDirty = !1;
    }
    /**
   * Overridable method that can be used by Container subclasses whenever the children array is modified.
   * @param _length
   */ onChildrenChange(_length) {}
    /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to add to the container
   * @returns {PIXI.DisplayObject} - The first child that was added.
   */ addChild(...children) {
        if (children.length > 1) for(let i = 0; i < children.length; i++)this.addChild(children[i]);
        else {
            const child = children[0];
            child.parent && child.parent.removeChild(child), child.parent = this, this.sortDirty = !0, child.transform._parentID = -1, this.children.push(child), this._boundsID++, this.onChildrenChange(this.children.length - 1), this.emit("childAdded", child, this, this.children.length - 1), child.emit("added", this);
        }
        return children[0];
    }
    /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {PIXI.DisplayObject} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {PIXI.DisplayObject} The child that was added.
   */ addChildAt(child, index) {
        if (index < 0 || index > this.children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${this.children.length}`);
        return child.parent && child.parent.removeChild(child), child.parent = this, this.sortDirty = !0, child.transform._parentID = -1, this.children.splice(index, 0, child), this._boundsID++, this.onChildrenChange(index), child.emit("added", this), this.emit("childAdded", child, this, index), child;
    }
    /**
   * Swaps the position of 2 Display Objects within this container.
   * @param child - First display object to swap
   * @param child2 - Second display object to swap
   */ swapChildren(child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child), index2 = this.getChildIndex(child2);
        this.children[index1] = child2, this.children[index2] = child, this.onChildrenChange(index1 < index2 ? index1 : index2);
    }
    /**
   * Returns the index position of a child DisplayObject instance
   * @param child - The DisplayObject instance to identify
   * @returns - The index position of the child display object to identify
   */ getChildIndex(child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied DisplayObject must be a child of the caller");
        return index;
    }
    /**
   * Changes the position of an existing child in the display object container
   * @param child - The child DisplayObject instance for which you want to change the index number
   * @param index - The resulting index number for the child display object
   */ setChildIndex(child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        const currentIndex = this.getChildIndex(child);
        (0, $lFGyw).removeItems(this.children, currentIndex, 1), this.children.splice(index, 0, child), this.onChildrenChange(index);
    }
    /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   */ getChildAt(index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    }
    /**
   * Removes one or more children from the container.
   * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to remove
   * @returns {PIXI.DisplayObject} The first child that was removed.
   */ removeChild(...children) {
        if (children.length > 1) for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
        else {
            const child = children[0], index = this.children.indexOf(child);
            if (index === -1) return null;
            child.parent = null, child.transform._parentID = -1, (0, $lFGyw).removeItems(this.children, index, 1), this._boundsID++, this.onChildrenChange(index), child.emit("removed", this), this.emit("childRemoved", child, this, index);
        }
        return children[0];
    }
    /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   */ removeChildAt(index) {
        const child = this.getChildAt(index);
        return child.parent = null, child.transform._parentID = -1, (0, $lFGyw).removeItems(this.children, index, 1), this._boundsID++, this.onChildrenChange(index), child.emit("removed", this), this.emit("childRemoved", child, this, index), child;
    }
    /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   */ removeChildren(beginIndex = 0, endIndex = this.children.length) {
        const begin = beginIndex, end = endIndex, range = end - begin;
        let removed;
        if (range > 0 && range <= end) {
            removed = this.children.splice(begin, range);
            for(let i = 0; i < removed.length; ++i)removed[i].parent = null, removed[i].transform && (removed[i].transform._parentID = -1);
            this._boundsID++, this.onChildrenChange(beginIndex);
            for(let i = 0; i < removed.length; ++i)removed[i].emit("removed", this), this.emit("childRemoved", removed[i], this, i);
            return removed;
        } else if (range === 0 && this.children.length === 0) return [];
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    }
    /** Sorts children by zIndex. Previous order is maintained for 2 children with the same zIndex. */ sortChildren() {
        let sortRequired = !1;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child._lastSortedIndex = i, !sortRequired && child.zIndex !== 0 && (sortRequired = !0);
        }
        sortRequired && this.children.length > 1 && this.children.sort($823fbc2c4ae841df$var$sortChildren), this.sortDirty = !1;
    }
    /** Updates the transform on all children of this container for rendering. */ updateTransform() {
        this.sortableChildren && this.sortDirty && this.sortChildren(), this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child.visible && child.updateTransform();
        }
    }
    /**
   * Recalculates the bounds of the container.
   *
   * This implementation will automatically fit the children's bounds into the calculation. Each child's bounds
   * is limited to its mask's bounds or filterArea, if any is applied.
   */ calculateBounds() {
        this._bounds.clear(), this._calculateBounds();
        for(let i = 0; i < this.children.length; i++){
            const child = this.children[i];
            if (!(!child.visible || !child.renderable)) {
                if (child.calculateBounds(), child._mask) {
                    const maskObject = child._mask.isMaskData ? child._mask.maskObject : child._mask;
                    maskObject ? (maskObject.calculateBounds(), this._bounds.addBoundsMask(child._bounds, maskObject._bounds)) : this._bounds.addBounds(child._bounds);
                } else child.filterArea ? this._bounds.addBoundsArea(child._bounds, child.filterArea) : this._bounds.addBounds(child._bounds);
            }
        }
        this._bounds.updateID = this._boundsID;
    }
    /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   *
   * Calling `getLocalBounds` may invalidate the `_bounds` of the whole subtree below. If using it inside a render()
   * call, it is advised to call `getBounds()` immediately after to recalculate the world bounds of the subtree.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @param skipChildrenUpdate - Setting to `true` will stop re-calculation of children transforms,
   *  it was default behaviour of pixi 4.0-5.2 and caused many problems to users.
   * @returns - The rectangular bounding area.
   */ getLocalBounds(rect, skipChildrenUpdate = !1) {
        const result = super.getLocalBounds(rect);
        if (!skipChildrenUpdate) for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i];
            child.visible && child.updateTransform();
        }
        return result;
    }
    /**
   * Recalculates the content bounds of this object. This should be overriden to
   * calculate the bounds of this specific object (not including children).
   * @protected
   */ _calculateBounds() {}
    /**
   * Renders this object and its children with culling.
   * @protected
   * @param {PIXI.Renderer} renderer - The renderer
   */ _renderWithCulling(renderer) {
        const sourceFrame = renderer.renderTexture.sourceFrame;
        if (!(sourceFrame.width > 0 && sourceFrame.height > 0)) return;
        let bounds, transform;
        this.cullArea ? (bounds = this.cullArea, transform = this.worldTransform) : this._render !== _Container2.prototype._render && (bounds = this.getBounds(!0));
        const projectionTransform = renderer.projection.transform;
        if (projectionTransform && (transform ? (transform = $823fbc2c4ae841df$var$tempMatrix.copyFrom(transform), transform.prepend(projectionTransform)) : transform = projectionTransform), bounds && sourceFrame.intersects(bounds, transform)) this._render(renderer);
        else if (this.cullArea) return;
        for(let i = 0, j = this.children.length; i < j; ++i){
            const child = this.children[i], childCullable = child.cullable;
            child.cullable = childCullable || !this.cullArea, child.render(renderer), child.cullable = childCullable;
        }
    }
    /**
   * Renders the object using the WebGL renderer.
   *
   * The [_render]{@link PIXI.Container#_render} method is be overriden for rendering the contents of the
   * container itself. This `render` method will invoke it, and also invoke the `render` methods of all
   * children afterward.
   *
   * If `renderable` or `visible` is false or if `worldAlpha` is not positive or if `cullable` is true and
   * the bounds of this object are out of frame, this implementation will entirely skip rendering.
   * See {@link PIXI.DisplayObject} for choosing between `renderable` or `visible`. Generally,
   * setting alpha to zero is not recommended for purely skipping rendering.
   *
   * When your scene becomes large (especially when it is larger than can be viewed in a single screen), it is
   * advised to employ **culling** to automatically skip rendering objects outside of the current screen.
   * See [cullable]{@link PIXI.DisplayObject#cullable} and [cullArea]{@link PIXI.DisplayObject#cullArea}.
   * Other culling methods might be better suited for a large number static objects; see
   * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} and
   * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull}.
   *
   * The [renderAdvanced]{@link PIXI.Container#renderAdvanced} method is internally used when when masking or
   * filtering is applied on a container. This does, however, break batching and can affect performance when
   * masking and filtering is applied extensively throughout the scene graph.
   * @param renderer - The renderer
   */ render(renderer) {
        if (!(!this.visible || this.worldAlpha <= 0 || !this.renderable)) {
            if (this._mask || this.filters?.length) this.renderAdvanced(renderer);
            else if (this.cullable) this._renderWithCulling(renderer);
            else {
                this._render(renderer);
                for(let i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
            }
        }
    }
    /**
   * Render the object using the WebGL renderer and advanced features.
   * @param renderer - The renderer
   */ renderAdvanced(renderer) {
        const filters = this.filters, mask = this._mask;
        if (filters) {
            this._enabledFilters || (this._enabledFilters = []), this._enabledFilters.length = 0;
            for(let i = 0; i < filters.length; i++)filters[i].enabled && this._enabledFilters.push(filters[i]);
        }
        const flush = filters && this._enabledFilters?.length || mask && (!mask.isMaskData || mask.enabled && (mask.autoDetect || mask.type !== (0, $lmRm8.MASK_TYPES).NONE));
        if (flush && renderer.batch.flush(), filters && this._enabledFilters?.length && renderer.filter.push(this, this._enabledFilters), mask && renderer.mask.push(this, this._mask), this.cullable) this._renderWithCulling(renderer);
        else {
            this._render(renderer);
            for(let i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
        }
        flush && renderer.batch.flush(), mask && renderer.mask.pop(this), filters && this._enabledFilters?.length && renderer.filter.pop();
    }
    /**
   * To be overridden by the subclasses.
   * @param _renderer - The renderer
   */ _render(_renderer) {}
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        super.destroy(), this.sortDirty = !1;
        const destroyChildren = typeof options == "boolean" ? options : options?.children, oldChildren = this.removeChildren(0, this.children.length);
        if (destroyChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
    }
    /** The width of the Container, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this.scale.x * this.getLocalBounds().width;
    }
    set width(value) {
        const width = this.getLocalBounds().width;
        width !== 0 ? this.scale.x = value / width : this.scale.x = 1, this._width = value;
    }
    /** The height of the Container, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this.scale.y * this.getLocalBounds().height;
    }
    set height(value) {
        const height = this.getLocalBounds().height;
        height !== 0 ? this.scale.y = value / height : this.scale.y = 1, this._height = value;
    }
};
$823fbc2c4ae841df$var$_Container.defaultSortableChildren = !1;
let $823fbc2c4ae841df$export$42a852a2b6b56249 = $823fbc2c4ae841df$var$_Container;
$823fbc2c4ae841df$export$42a852a2b6b56249.prototype.containerUpdateTransform = $823fbc2c4ae841df$export$42a852a2b6b56249.prototype.updateTransform;

});
parcelRegister("5xkOK", function(module, exports) {

$parcel$export(module.exports, "DisplayObject", () => $93bf10443ce4ab2c$export$1f679544f90d7d7c);
parcelRequire("inflE");
var $lbGGA = parcelRequire("lbGGA");
var $kZOeV = parcelRequire("kZOeV");
var $9jXhN = parcelRequire("9jXhN");
var $lFGyw = parcelRequire("lFGyw");

var $aMxkH = parcelRequire("aMxkH");
class $93bf10443ce4ab2c$export$1f679544f90d7d7c extends (0, $lFGyw).EventEmitter {
    constructor(){
        super(), this.tempDisplayObjectParent = null, this.transform = new (0, $9jXhN.Transform)(), this.alpha = 1, this.visible = !0, this.renderable = !0, this.cullable = !1, this.cullArea = null, this.parent = null, this.worldAlpha = 1, this._lastSortedIndex = 0, this._zIndex = 0, this.filterArea = null, this.filters = null, this._enabledFilters = null, this._bounds = new (0, $aMxkH.Bounds)(), this._localBounds = null, this._boundsID = 0, this._boundsRect = null, this._localBoundsRect = null, this._mask = null, this._maskRefCount = 0, this._destroyed = !1, this.isSprite = !1, this.isMask = !1;
    }
    /**
   * Mixes all enumerable properties and methods from a source object to DisplayObject.
   * @param source - The source of properties and methods to mix in.
   */ static mixin(source) {
        const keys = Object.keys(source);
        for(let i = 0; i < keys.length; ++i){
            const propertyName = keys[i];
            Object.defineProperty($93bf10443ce4ab2c$export$1f679544f90d7d7c.prototype, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
        }
    }
    /**
   * Fired when this DisplayObject is added to a Container.
   * @instance
   * @event added
   * @param {PIXI.Container} container - The container added to.
   */ /**
   * Fired when this DisplayObject is removed from a Container.
   * @instance
   * @event removed
   * @param {PIXI.Container} container - The container removed from.
   */ /**
   * Fired when this DisplayObject is destroyed. This event is emitted once
   * destroy is finished.
   * @instance
   * @event destroyed
   */ /** Readonly flag for destroyed display objects. */ get destroyed() {
        return this._destroyed;
    }
    /** Recursively updates transform of all objects from the root to this one internal function for toLocal() */ _recursivePostUpdateTransform() {
        this.parent ? (this.parent._recursivePostUpdateTransform(), this.transform.updateTransform(this.parent.transform)) : this.transform.updateTransform(this._tempDisplayObjectParent.transform);
    }
    /** Updates the object transform for rendering. TODO - Optimization pass! */ updateTransform() {
        this._boundsID++, this.transform.updateTransform(this.parent.transform), this.worldAlpha = this.alpha * this.parent.worldAlpha;
    }
    /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link PIXI.Rectangle}.
   *
   * This method is expensive on containers with a large subtree (like the stage). This is because the bounds
   * of a container depend on its children's bounds, which recursively causes all bounds in the subtree to
   * be recalculated. The upside, however, is that calling `getBounds` once on a container will indeed update
   * the bounds of all children (the whole subtree, in fact). This side effect should be exploited by using
   * `displayObject._bounds.getRectangle()` when traversing through all the bounds in a scene graph. Otherwise,
   * calling `getBounds` on each object in a subtree will cause the total cost to increase quadratically as
   * its height increases.
   *
   * The transforms of all objects in a container's **subtree** and of all **ancestors** are updated.
   * The world bounds of all display objects in a container's **subtree** will also be recalculated.
   *
   * The `_bounds` object stores the last calculation of the bounds. You can use to entirely skip bounds
   * calculation if needed.
   *
   * ```js
   * const lastCalculatedBounds = displayObject._bounds.getRectangle(optionalRect);
   * ```
   *
   * Do know that usage of `getLocalBounds` can corrupt the `_bounds` of children (the whole subtree, actually). This
   * is a known issue that has not been solved. See [getLocalBounds]{@link PIXI.DisplayObject#getLocalBounds} for more
   * details.
   *
   * `getBounds` should be called with `skipUpdate` equal to `true` in a render() call. This is because the transforms
   * are guaranteed to be update-to-date. In fact, recalculating inside a render() call may cause corruption in certain
   * cases.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   */ getBounds(skipUpdate, rect) {
        return skipUpdate || (this.parent ? (this._recursivePostUpdateTransform(), this.updateTransform()) : (this.parent = this._tempDisplayObjectParent, this.updateTransform(), this.parent = null)), this._bounds.updateID !== this._boundsID && (this.calculateBounds(), this._bounds.updateID = this._boundsID), rect || (this._boundsRect || (this._boundsRect = new (0, $kZOeV.Rectangle)()), rect = this._boundsRect), this._bounds.getRectangle(rect);
    }
    /**
   * Retrieves the local bounds of the displayObject as a rectangle object.
   * @param rect - Optional rectangle to store the result of the bounds calculation.
   * @returns - The rectangular bounding area.
   */ getLocalBounds(rect) {
        rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $kZOeV.Rectangle)()), rect = this._localBoundsRect), this._localBounds || (this._localBounds = new (0, $aMxkH.Bounds)());
        const transformRef = this.transform, parentRef = this.parent;
        this.parent = null, this._tempDisplayObjectParent.worldAlpha = parentRef?.worldAlpha ?? 1, this.transform = this._tempDisplayObjectParent.transform;
        const worldBounds = this._bounds, worldBoundsID = this._boundsID;
        this._bounds = this._localBounds;
        const bounds = this.getBounds(!1, rect);
        return this.parent = parentRef, this.transform = transformRef, this._bounds = worldBounds, this._bounds.updateID += this._boundsID - worldBoundsID, bounds;
    }
    /**
   * Calculates the global position of the display object.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   */ toGlobal(position, point, skipUpdate = !1) {
        return skipUpdate || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.apply(position, point);
    }
    /**
   * Calculates the local position of the display object relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The DisplayObject to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   */ toLocal(position, from, point, skipUpdate) {
        return from && (position = from.toGlobal(position, point, skipUpdate)), skipUpdate || (this._recursivePostUpdateTransform(), this.parent ? this.displayObjectUpdateTransform() : (this.parent = this._tempDisplayObjectParent, this.displayObjectUpdateTransform(), this.parent = null)), this.worldTransform.applyInverse(position, point);
    }
    /**
   * Set the parent Container of this DisplayObject.
   * @param container - The Container to add this DisplayObject to.
   * @returns - The Container that this DisplayObject was added to.
   */ setParent(container) {
        if (!container || !container.addChild) throw new Error("setParent: Argument must be a Container");
        return container.addChild(this), container;
    }
    /** Remove the DisplayObject from its parent Container. If the DisplayObject has no parent, do nothing. */ removeFromParent() {
        this.parent?.removeChild(this);
    }
    /**
   * Convenience function to set the position, scale, skew and pivot at once.
   * @param x - The X position
   * @param y - The Y position
   * @param scaleX - The X scale value
   * @param scaleY - The Y scale value
   * @param rotation - The rotation
   * @param skewX - The X skew value
   * @param skewY - The Y skew value
   * @param pivotX - The X pivot value
   * @param pivotY - The Y pivot value
   * @returns - The DisplayObject instance
   */ setTransform(x = 0, y = 0, scaleX = 1, scaleY = 1, rotation = 0, skewX = 0, skewY = 0, pivotX = 0, pivotY = 0) {
        return this.position.x = x, this.position.y = y, this.scale.x = scaleX || 1, this.scale.y = scaleY || 1, this.rotation = rotation, this.skew.x = skewX, this.skew.y = skewY, this.pivot.x = pivotX, this.pivot.y = pivotY, this;
    }
    /**
   * Base destroy method for generic display objects. This will automatically
   * remove the display object from its parent Container as well as remove
   * all current event listeners and internal references. Do not use a DisplayObject
   * after calling `destroy()`.
   * @param _options
   */ destroy(_options) {
        this.removeFromParent(), this._destroyed = !0, this.transform = null, this.parent = null, this._bounds = null, this.mask = null, this.cullArea = null, this.filters = null, this.filterArea = null, this.hitArea = null, this.eventMode = "auto", this.interactiveChildren = !1, this.emit("destroyed"), this.removeAllListeners();
    }
    /**
   * @protected
   * @member {PIXI.Container}
   */ get _tempDisplayObjectParent() {
        return this.tempDisplayObjectParent === null && (this.tempDisplayObjectParent = new $93bf10443ce4ab2c$export$a35515d77cade20d()), this.tempDisplayObjectParent;
    }
    /**
   * Used in Renderer, cacheAsBitmap and other places where you call an `updateTransform` on root.
   *
   * ```js
   * const cacheParent = elem.enableTempParent();
   * elem.updateTransform();
   * elem.disableTempParent(cacheParent);
   * ```
   * @returns - Current parent
   */ enableTempParent() {
        const myParent = this.parent;
        return this.parent = this._tempDisplayObjectParent, myParent;
    }
    /**
   * Pair method for `enableTempParent`
   * @param cacheParent - Actual parent of element
   */ disableTempParent(cacheParent) {
        this.parent = cacheParent;
    }
    /**
   * The position of the displayObject on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */ get x() {
        return this.position.x;
    }
    set x(value) {
        this.transform.position.x = value;
    }
    /**
   * The position of the displayObject on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */ get y() {
        return this.position.y;
    }
    set y(value) {
        this.transform.position.y = value;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */ get worldTransform() {
        return this.transform.worldTransform;
    }
    /**
   * Current transform of the object based on local factors: position, scale, other stuff.
   * @readonly
   */ get localTransform() {
        return this.transform.localTransform;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */ get position() {
        return this.transform.position;
    }
    set position(value) {
        this.transform.position.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */ get scale() {
        return this.transform.scale;
    }
    set scale(value) {
        this.transform.scale.copyFrom(value);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */ get pivot() {
        return this.transform.pivot;
    }
    set pivot(value) {
        this.transform.pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */ get skew() {
        return this.transform.skew;
    }
    set skew(value) {
        this.transform.skew.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get rotation() {
        return this.transform.rotation;
    }
    set rotation(value) {
        this.transform.rotation = value;
    }
    /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get angle() {
        return this.transform.rotation * (0, $lbGGA.RAD_TO_DEG);
    }
    set angle(value) {
        this.transform.rotation = value * (0, $lbGGA.DEG_TO_RAD);
    }
    /**
   * The zIndex of the displayObject.
   *
   * If a container has the sortableChildren property set to true, children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see PIXI.Container#sortableChildren
   */ get zIndex() {
        return this._zIndex;
    }
    set zIndex(value) {
        this._zIndex !== value && (this._zIndex = value, this.parent && (this.parent.sortDirty = !0));
    }
    /**
   * Indicates if the object is globally visible.
   * @readonly
   */ get worldVisible() {
        let item = this;
        do {
            if (!item.visible) return !1;
            item = item.parent;
        }while (item);
        return !0;
    }
    /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @todo At the moment, CanvasRenderer doesn't support Sprite as mask.
   */ get mask() {
        return this._mask;
    }
    set mask(value) {
        if (this._mask !== value) {
            if (this._mask) {
                const maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
                maskObject && (maskObject._maskRefCount--, maskObject._maskRefCount === 0 && (maskObject.renderable = !0, maskObject.isMask = !1));
            }
            if (this._mask = value, this._mask) {
                const maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
                maskObject && (maskObject._maskRefCount === 0 && (maskObject.renderable = !1, maskObject.isMask = !0), maskObject._maskRefCount++);
            }
        }
    }
}
class $93bf10443ce4ab2c$export$a35515d77cade20d extends $93bf10443ce4ab2c$export$1f679544f90d7d7c {
    constructor(){
        super(...arguments), this.sortDirty = null;
    }
}
$93bf10443ce4ab2c$export$1f679544f90d7d7c.prototype.displayObjectUpdateTransform = $93bf10443ce4ab2c$export$1f679544f90d7d7c.prototype.updateTransform;

});
parcelRegister("aMxkH", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $51558a611c79ce5a$export$c4e9d269599ab4b4);
parcelRequire("inflE");
var $kZOeV = parcelRequire("kZOeV");
class $51558a611c79ce5a$export$c4e9d269599ab4b4 {
    constructor(){
        this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.rect = null, this.updateID = -1;
    }
    /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /** Clears the bounds and resets. */ clear() {
        this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0;
    }
    /**
   * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
   * It is not guaranteed that it will return tempRect
   * @param rect - Temporary object will be used if AABB is not empty
   * @returns - A rectangle of the bounds
   */ getRectangle(rect) {
        return this.minX > this.maxX || this.minY > this.maxY ? (0, $kZOeV.Rectangle).EMPTY : (rect = rect || new (0, $kZOeV.Rectangle)(0, 0, 1, 1), rect.x = this.minX, rect.y = this.minY, rect.width = this.maxX - this.minX, rect.height = this.maxY - this.minY, rect);
    }
    /**
   * This function should be inlined when its possible.
   * @param point - The point to add.
   */ addPoint(point) {
        this.minX = Math.min(this.minX, point.x), this.maxX = Math.max(this.maxX, point.x), this.minY = Math.min(this.minY, point.y), this.maxY = Math.max(this.maxY, point.y);
    }
    /**
   * Adds a point, after transformed. This should be inlined when its possible.
   * @param matrix
   * @param point
   */ addPointMatrix(matrix, point) {
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix, x = a * point.x + c * point.y + tx, y = b * point.x + d * point.y + ty;
        this.minX = Math.min(this.minX, x), this.maxX = Math.max(this.maxX, x), this.minY = Math.min(this.minY, y), this.maxY = Math.max(this.maxY, y);
    }
    /**
   * Adds a quad, not transformed
   * @param vertices - The verts to add.
   */ addQuad(vertices) {
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY, x = vertices[0], y = vertices[1];
        minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[2], y = vertices[3], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[4], y = vertices[5], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = vertices[6], y = vertices[7], minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds sprite frame, transformed.
   * @param transform - transform to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ addFrame(transform, x0, y0, x1, y1) {
        this.addFrameMatrix(transform.worldTransform, x0, y0, x1, y1);
    }
    /**
   * Adds sprite frame, multiplied by matrix
   * @param matrix - matrix to apply
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ addFrameMatrix(matrix, x0, y0, x1, y1) {
        const a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, tx = matrix.tx, ty = matrix.ty;
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY, x = a * x0 + c * y0 + tx, y = b * x0 + d * y0 + ty;
        minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x1 + c * y0 + tx, y = b * x1 + d * y0 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x0 + c * y1 + tx, y = b * x0 + d * y1 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, x = a * x1 + c * y1 + tx, y = b * x1 + d * y1 + ty, minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY, this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */ addVertexData(vertexData, beginOffset, endOffset) {
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        for(let i = beginOffset; i < endOffset; i += 2){
            const x = vertexData[i], y = vertexData[i + 1];
            minX = x < minX ? x : minX, minY = y < minY ? y : minY, maxX = x > maxX ? x : maxX, maxY = y > maxY ? y : maxY;
        }
        this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Add an array of mesh vertices
   * @param transform - mesh transform
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   */ addVertices(transform, vertices, beginOffset, endOffset) {
        this.addVerticesMatrix(transform.worldTransform, vertices, beginOffset, endOffset);
    }
    /**
   * Add an array of mesh vertices.
   * @param matrix - mesh matrix
   * @param vertices - mesh coordinates in array
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param padX - x padding
   * @param padY - y padding
   */ addVerticesMatrix(matrix, vertices, beginOffset, endOffset, padX = 0, padY = padX) {
        const a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, tx = matrix.tx, ty = matrix.ty;
        let minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        for(let i = beginOffset; i < endOffset; i += 2){
            const rawX = vertices[i], rawY = vertices[i + 1], x = a * rawX + c * rawY + tx, y = d * rawY + b * rawX + ty;
            minX = Math.min(minX, x - padX), maxX = Math.max(maxX, x + padX), minY = Math.min(minY, y - padY), maxY = Math.max(maxY, y + padY);
        }
        this.minX = minX, this.minY = minY, this.maxX = maxX, this.maxY = maxY;
    }
    /**
   * Adds other {@link PIXI.Bounds}.
   * @param bounds - The Bounds to be added
   */ addBounds(bounds) {
        const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
        this.minX = bounds.minX < minX ? bounds.minX : minX, this.minY = bounds.minY < minY ? bounds.minY : minY, this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX, this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
    }
    /**
   * Adds other Bounds, masked with Bounds.
   * @param bounds - The Bounds to be added.
   * @param mask - TODO
   */ addBoundsMask(bounds, mask) {
        const _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX, _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY, _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX, _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
        if (_minX <= _maxX && _minY <= _maxY) {
            const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX, this.minY = _minY < minY ? _minY : minY, this.maxX = _maxX > maxX ? _maxX : maxX, this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    }
    /**
   * Adds other Bounds, multiplied by matrix. Bounds shouldn't be empty.
   * @param bounds - other bounds
   * @param matrix - multiplicator
   */ addBoundsMatrix(bounds, matrix) {
        this.addFrameMatrix(matrix, bounds.minX, bounds.minY, bounds.maxX, bounds.maxY);
    }
    /**
   * Adds other Bounds, masked with Rectangle.
   * @param bounds - TODO
   * @param area - TODO
   */ addBoundsArea(bounds, area) {
        const _minX = bounds.minX > area.x ? bounds.minX : area.x, _minY = bounds.minY > area.y ? bounds.minY : area.y, _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width, _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
        if (_minX <= _maxX && _minY <= _maxY) {
            const minX = this.minX, minY = this.minY, maxX = this.maxX, maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX, this.minY = _minY < minY ? _minY : minY, this.maxX = _maxX > maxX ? _maxX : maxX, this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.isEmpty() || (this.minX -= paddingX, this.maxX += paddingX, this.minY -= paddingY, this.maxY += paddingY);
    }
    /**
   * Adds padded frame. (x0, y0) should be strictly less than (x1, y1)
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param padX - padding X
   * @param padY - padding Y
   */ addFramePad(x0, y0, x1, y1, padX, padY) {
        x0 -= padX, y0 -= padY, x1 += padX, y1 += padY, this.minX = this.minX < x0 ? this.minX : x0, this.maxX = this.maxX > x1 ? this.maxX : x1, this.minY = this.minY < y0 ? this.minY : y0, this.maxY = this.maxY > y1 ? this.maxY : y1;
    }
}

});





parcelRegister("6x1UU", function(module, exports) {

$parcel$export(module.exports, "BitmapText", () => (parcelRequire("30oUb")).BitmapText);

var $bAlM8 = parcelRequire("bAlM8");

var $k1Bg2 = parcelRequire("k1Bg2");

var $30oUb = parcelRequire("30oUb");
parcelRequire("kO4NZ");

var $8HicO = parcelRequire("8HicO");

var $90VnE = parcelRequire("90VnE");

var $46hKQ = parcelRequire("46hKQ");

var $83Oz4 = parcelRequire("83Oz4");

var $9EGm1 = parcelRequire("9EGm1");

});
parcelRegister("bAlM8", function(module, exports) {

$parcel$export(module.exports, "BitmapFont", () => $e993cd57c9c1db6e$export$17957a09927cadc7);
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $4oWO8 = parcelRequire("4oWO8");
var $kZOeV = parcelRequire("kZOeV");
var $16eqM = parcelRequire("16eqM");
var $cWOCu = parcelRequire("cWOCu");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("3xGdr");
var $5FHOg = parcelRequire("5FHOg");
var $f6HC1 = parcelRequire("f6HC1");

var $k1Bg2 = parcelRequire("k1Bg2");

var $8HicO = parcelRequire("8HicO");
parcelRequire("3WxPu");

var $cBecy = parcelRequire("cBecy");

var $amNc1 = parcelRequire("amNc1");

var $3e4fL = parcelRequire("3e4fL");
const $e993cd57c9c1db6e$var$_BitmapFont = class _BitmapFont2 {
    /**
   * @param data
   * @param textures
   * @param ownsTextures - Setting to `true` will destroy page textures
   *        when the font is uninstalled.
   */ constructor(data, textures, ownsTextures){
        const [info] = data.info, [common] = data.common, [page] = data.page, [distanceField] = data.distanceField, res = (0, $lFGyw).getResolutionOfUrl(page.file), pageTextures = {};
        this._ownsTextures = ownsTextures, this.font = info.face, this.size = info.size, this.lineHeight = common.lineHeight / res, this.chars = {}, this.pageTextures = pageTextures;
        for(let i = 0; i < data.page.length; i++){
            const { id: id, file: file } = data.page[i];
            pageTextures[id] = textures instanceof Array ? textures[i] : textures[file], distanceField?.fieldType && distanceField.fieldType !== "none" && (pageTextures[id].baseTexture.alphaMode = (0, $lmRm8.ALPHA_MODES).NO_PREMULTIPLIED_ALPHA, pageTextures[id].baseTexture.mipmap = (0, $lmRm8.MIPMAP_MODES).OFF);
        }
        for(let i = 0; i < data.char.length; i++){
            const { id: id, page: page2 } = data.char[i];
            let { x: x, y: y, width: width, height: height, xoffset: xoffset, yoffset: yoffset, xadvance: xadvance } = data.char[i];
            x /= res, y /= res, width /= res, height /= res, xoffset /= res, yoffset /= res, xadvance /= res;
            const rect = new (0, $kZOeV.Rectangle)(x + pageTextures[page2].frame.x / res, y + pageTextures[page2].frame.y / res, width, height);
            this.chars[id] = {
                xOffset: xoffset,
                yOffset: yoffset,
                xAdvance: xadvance,
                kerning: {},
                texture: new (0, $cWOCu.Texture)(pageTextures[page2].baseTexture, rect),
                page: page2
            };
        }
        for(let i = 0; i < data.kerning.length; i++){
            let { first: first, second: second, amount: amount } = data.kerning[i];
            first /= res, second /= res, amount /= res, this.chars[second] && (this.chars[second].kerning[first] = amount);
        }
        this.distanceFieldRange = distanceField?.distanceRange, this.distanceFieldType = distanceField?.fieldType?.toLowerCase() ?? "none";
    }
    /** Remove references to created glyph textures. */ destroy() {
        for(const id in this.chars)this.chars[id].texture.destroy(), this.chars[id].texture = null;
        for(const id in this.pageTextures)this._ownsTextures && this.pageTextures[id].destroy(!0), this.pageTextures[id] = null;
        this.chars = null, this.pageTextures = null;
    }
    /**
   * Register a new bitmap font.
   * @param data - The
   *        characters map that could be provided as xml or raw string.
   * @param textures - List of textures for each page.
   * @param ownsTextures - Set to `true` to destroy page textures
   *        when the font is uninstalled. By default fonts created with
   *        `BitmapFont.from` or from the `BitmapFontLoader` are `true`.
   * @returns {PIXI.BitmapFont} Result font object with font, size, lineHeight
   *         and char fields.
   */ static install(data, textures, ownsTextures) {
        let fontData;
        if (data instanceof (0, $k1Bg2.BitmapFontData)) fontData = data;
        else {
            const format = (0, $8HicO.autoDetectFormat)(data);
            if (!format) throw new Error("Unrecognized data format for font.");
            fontData = format.parse(data);
        }
        textures instanceof (0, $cWOCu.Texture) && (textures = [
            textures
        ]);
        const font = new _BitmapFont2(fontData, textures, ownsTextures);
        return _BitmapFont2.available[font.font] = font, font;
    }
    /**
   * Remove bitmap font by name.
   * @param name - Name of the font to uninstall.
   */ static uninstall(name) {
        const font = _BitmapFont2.available[name];
        if (!font) throw new Error(`No font found named '${name}'`);
        font.destroy(), delete _BitmapFont2.available[name];
    }
    /**
   * Generates a bitmap-font for the given style and character set. This does not support
   * kernings yet. With `style` properties, only the following non-layout properties are used:
   *
   * - {@link PIXI.TextStyle#dropShadow|dropShadow}
   * - {@link PIXI.TextStyle#dropShadowDistance|dropShadowDistance}
   * - {@link PIXI.TextStyle#dropShadowColor|dropShadowColor}
   * - {@link PIXI.TextStyle#dropShadowBlur|dropShadowBlur}
   * - {@link PIXI.TextStyle#dropShadowAngle|dropShadowAngle}
   * - {@link PIXI.TextStyle#fill|fill}
   * - {@link PIXI.TextStyle#fillGradientStops|fillGradientStops}
   * - {@link PIXI.TextStyle#fillGradientType|fillGradientType}
   * - {@link PIXI.TextStyle#fontFamily|fontFamily}
   * - {@link PIXI.TextStyle#fontSize|fontSize}
   * - {@link PIXI.TextStyle#fontVariant|fontVariant}
   * - {@link PIXI.TextStyle#fontWeight|fontWeight}
   * - {@link PIXI.TextStyle#lineJoin|lineJoin}
   * - {@link PIXI.TextStyle#miterLimit|miterLimit}
   * - {@link PIXI.TextStyle#stroke|stroke}
   * - {@link PIXI.TextStyle#strokeThickness|strokeThickness}
   * - {@link PIXI.TextStyle#textBaseline|textBaseline}
   * @param name - The name of the custom font to use with BitmapText.
   * @param textStyle - Style options to render with BitmapFont.
   * @param options - Setup options for font or name of the font.
   * @returns Font generated by style options.
   * @example
   * import { BitmapFont, BitmapText } from 'pixi.js';
   *
   * BitmapFont.from('TitleFont', {
   *     fontFamily: 'Arial',
   *     fontSize: 12,
   *     strokeThickness: 2,
   *     fill: 'purple',
   * });
   *
   * const title = new BitmapText('This is the title', { fontName: 'TitleFont' });
   */ static from(name, textStyle, options) {
        if (!name) throw new Error("[BitmapFont] Property `name` is required.");
        const { chars: chars, padding: padding, resolution: resolution, textureWidth: textureWidth, textureHeight: textureHeight, ...baseOptions } = Object.assign({}, _BitmapFont2.defaultOptions, options), charsList = (0, $cBecy.resolveCharacters)(chars), style = textStyle instanceof (0, $f6HC1.TextStyle) ? textStyle : new (0, $f6HC1.TextStyle)(textStyle), lineWidth = textureWidth, fontData = new (0, $k1Bg2.BitmapFontData)();
        fontData.info[0] = {
            face: style.fontFamily,
            size: style.fontSize
        }, fontData.common[0] = {
            lineHeight: style.fontSize
        };
        let positionX = 0, positionY = 0, canvas, context, baseTexture, maxCharHeight = 0;
        const baseTextures = [], textures = [];
        for(let i = 0; i < charsList.length; i++){
            canvas || (canvas = (0, $16eqM.settings).ADAPTER.createCanvas(), canvas.width = textureWidth, canvas.height = textureHeight, context = canvas.getContext("2d"), baseTexture = new (0, $4oWO8.BaseTexture)(canvas, {
                resolution: resolution,
                ...baseOptions
            }), baseTextures.push(baseTexture), textures.push(new (0, $cWOCu.Texture)(baseTexture)), fontData.page.push({
                id: textures.length - 1,
                file: ""
            }));
            const character = charsList[i], metrics = (0, $5FHOg.TextMetrics).measureText(character, style, !1, canvas), width = metrics.width, height = Math.ceil(metrics.height), textureGlyphWidth = Math.ceil((style.fontStyle === "italic" ? 2 : 1) * width);
            if (positionY >= textureHeight - height * resolution) {
                if (positionY === 0) throw new Error(`[BitmapFont] textureHeight ${textureHeight}px is too small (fontFamily: '${style.fontFamily}', fontSize: ${style.fontSize}px, char: '${character}')`);
                --i, canvas = null, context = null, baseTexture = null, positionY = 0, positionX = 0, maxCharHeight = 0;
                continue;
            }
            if (maxCharHeight = Math.max(height + metrics.fontProperties.descent, maxCharHeight), textureGlyphWidth * resolution + positionX >= lineWidth) {
                if (positionX === 0) throw new Error(`[BitmapFont] textureWidth ${textureWidth}px is too small (fontFamily: '${style.fontFamily}', fontSize: ${style.fontSize}px, char: '${character}')`);
                --i, positionY += maxCharHeight * resolution, positionY = Math.ceil(positionY), positionX = 0, maxCharHeight = 0;
                continue;
            }
            (0, $amNc1.drawGlyph)(canvas, context, metrics, positionX, positionY, resolution, style);
            const id = (0, $3e4fL.extractCharCode)(metrics.text);
            fontData.char.push({
                id: id,
                page: textures.length - 1,
                x: positionX / resolution,
                y: positionY / resolution,
                width: textureGlyphWidth,
                height: height,
                xoffset: 0,
                yoffset: 0,
                xadvance: width - (style.dropShadow ? style.dropShadowDistance : 0) - (style.stroke ? style.strokeThickness : 0)
            }), positionX += (textureGlyphWidth + 2 * padding) * resolution, positionX = Math.ceil(positionX);
        }
        if (!options?.skipKerning) for(let i = 0, len = charsList.length; i < len; i++){
            const first = charsList[i];
            for(let j = 0; j < len; j++){
                const second = charsList[j], c1 = context.measureText(first).width, c2 = context.measureText(second).width, amount = context.measureText(first + second).width - (c1 + c2);
                amount && fontData.kerning.push({
                    first: (0, $3e4fL.extractCharCode)(first),
                    second: (0, $3e4fL.extractCharCode)(second),
                    amount: amount
                });
            }
        }
        const font = new _BitmapFont2(fontData, textures, !0);
        return _BitmapFont2.available[name] !== void 0 && _BitmapFont2.uninstall(name), _BitmapFont2.available[name] = font, font;
    }
};
$e993cd57c9c1db6e$var$_BitmapFont.ALPHA = [
    [
        "a",
        "z"
    ],
    [
        "A",
        "Z"
    ],
    " "
], /**
* This character set includes all decimal digits (from 0 to 9).
* @type {string[][]}
* @example
* BitmapFont.from('ExampleFont', style, { chars: BitmapFont.NUMERIC })
*/ $e993cd57c9c1db6e$var$_BitmapFont.NUMERIC = [
    [
        "0",
        "9"
    ]
], /**
* This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
* @type {string[][]}
*/ $e993cd57c9c1db6e$var$_BitmapFont.ALPHANUMERIC = [
    [
        "a",
        "z"
    ],
    [
        "A",
        "Z"
    ],
    [
        "0",
        "9"
    ],
    " "
], /**
* This character set consists of all the ASCII table.
* @member {string[][]}
* @see http://www.asciitable.com/
*/ $e993cd57c9c1db6e$var$_BitmapFont.ASCII = [
    [
        " ",
        "~"
    ]
], /**
* Collection of default options when using `BitmapFont.from`.
* @property {number} [resolution=1] -
* @property {number} [textureWidth=512] -
* @property {number} [textureHeight=512] -
* @property {number} [padding=4] -
* @property {string|string[]|string[][]} chars = PIXI.BitmapFont.ALPHANUMERIC
*/ $e993cd57c9c1db6e$var$_BitmapFont.defaultOptions = {
    resolution: 1,
    textureWidth: 512,
    textureHeight: 512,
    padding: 4,
    chars: $e993cd57c9c1db6e$var$_BitmapFont.ALPHANUMERIC
}, /** Collection of available/installed fonts. */ $e993cd57c9c1db6e$var$_BitmapFont.available = {};
let $e993cd57c9c1db6e$export$17957a09927cadc7 = $e993cd57c9c1db6e$var$_BitmapFont;

});
parcelRegister("3xGdr", function(module, exports) {

$parcel$export(module.exports, "TEXT_GRADIENT", () => (parcelRequire("lxqYA")).TEXT_GRADIENT);
$parcel$export(module.exports, "Text", () => (parcelRequire("68KVj")).Text);
$parcel$export(module.exports, "TextMetrics", () => (parcelRequire("5FHOg")).TextMetrics);
$parcel$export(module.exports, "TextStyle", () => (parcelRequire("f6HC1")).TextStyle);

var $lxqYA = parcelRequire("lxqYA");

var $68KVj = parcelRequire("68KVj");

var $5FHOg = parcelRequire("5FHOg");

var $f6HC1 = parcelRequire("f6HC1");

});
parcelRegister("lxqYA", function(module, exports) {

$parcel$export(module.exports, "TEXT_GRADIENT", () => $105b32f38e43c61b$export$131daa784848984);
var $105b32f38e43c61b$export$131daa784848984 = /* @__PURE__ */ ((TEXT_GRADIENT2)=>(TEXT_GRADIENT2[TEXT_GRADIENT2.LINEAR_VERTICAL = 0] = "LINEAR_VERTICAL", TEXT_GRADIENT2[TEXT_GRADIENT2.LINEAR_HORIZONTAL = 1] = "LINEAR_HORIZONTAL", TEXT_GRADIENT2))($105b32f38e43c61b$export$131daa784848984 || {});

});

parcelRegister("68KVj", function(module, exports) {

$parcel$export(module.exports, "Text", () => $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6);
parcelRequire("inflE");
var $1PNws = parcelRequire("1PNws");
var $kZOeV = parcelRequire("kZOeV");
var $16eqM = parcelRequire("16eqM");
var $cWOCu = parcelRequire("cWOCu");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("jW6UI");
var $3uiak = parcelRequire("3uiak");

var $lxqYA = parcelRequire("lxqYA");

var $5FHOg = parcelRequire("5FHOg");

var $f6HC1 = parcelRequire("f6HC1");
const $cd9bcb4d5b9d0264$var$defaultDestroyOptions = {
    texture: !0,
    children: !1,
    baseTexture: !0
}, $cd9bcb4d5b9d0264$var$_Text = class _Text2 extends (0, $3uiak.Sprite) {
    /**
   * @param text - The string that you would like the text to display
   * @param style - The style parameters
   * @param canvas - The canvas element for drawing text
   */ constructor(text, style, canvas){
        let ownCanvas = !1;
        canvas || (canvas = (0, $16eqM.settings).ADAPTER.createCanvas(), ownCanvas = !0), canvas.width = 3, canvas.height = 3;
        const texture = (0, $cWOCu.Texture).from(canvas);
        texture.orig = new (0, $kZOeV.Rectangle)(), texture.trim = new (0, $kZOeV.Rectangle)(), super(texture), this._ownCanvas = ownCanvas, this.canvas = canvas, this.context = canvas.getContext("2d", {
            // required for trimming to work without warnings
            willReadFrequently: !0
        }), this._resolution = _Text2.defaultResolution ?? (0, $16eqM.settings).RESOLUTION, this._autoResolution = _Text2.defaultAutoResolution, this._text = null, this._style = null, this._styleListener = null, this._font = "", this.text = text, this.style = style, this.localStyleID = -1;
    }
    /**
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @deprecated since 7.1.0
   */ static get experimentalLetterSpacing() {
        return (0, $5FHOg.TextMetrics).experimentalLetterSpacing;
    }
    static set experimentalLetterSpacing(value) {
        (0, $lFGyw).deprecation("7.1.0", "Text.experimentalLetterSpacing is deprecated, use TextMetrics.experimentalLetterSpacing"), (0, $5FHOg.TextMetrics).experimentalLetterSpacing = value;
    }
    /**
   * Renders text to its canvas, and updates its texture.
   *
   * By default this is used internally to ensure the texture is correct before rendering,
   * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
   * and then shared across multiple Sprites.
   * @param respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
   */ updateText(respectDirty) {
        const style = this._style;
        if (this.localStyleID !== style.styleID && (this.dirty = !0, this.localStyleID = style.styleID), !this.dirty && respectDirty) return;
        this._font = this._style.toFontString();
        const context = this.context, measured = (0, $5FHOg.TextMetrics).measureText(this._text || " ", this._style, this._style.wordWrap, this.canvas), width = measured.width, height = measured.height, lines = measured.lines, lineHeight = measured.lineHeight, lineWidths = measured.lineWidths, maxLineWidth = measured.maxLineWidth, fontProperties = measured.fontProperties;
        this.canvas.width = Math.ceil(Math.ceil(Math.max(1, width) + style.padding * 2) * this._resolution), this.canvas.height = Math.ceil(Math.ceil(Math.max(1, height) + style.padding * 2) * this._resolution), context.scale(this._resolution, this._resolution), context.clearRect(0, 0, this.canvas.width, this.canvas.height), context.font = this._font, context.lineWidth = style.strokeThickness, context.textBaseline = style.textBaseline, context.lineJoin = style.lineJoin, context.miterLimit = style.miterLimit;
        let linePositionX, linePositionY;
        const passesCount = style.dropShadow ? 2 : 1;
        for(let i = 0; i < passesCount; ++i){
            const isShadowPass = style.dropShadow && i === 0, dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + style.padding * 2) : 0, dsOffsetShadow = dsOffsetText * this._resolution;
            if (isShadowPass) {
                context.fillStyle = "black", context.strokeStyle = "black";
                const dropShadowColor = style.dropShadowColor, dropShadowBlur = style.dropShadowBlur * this._resolution, dropShadowDistance = style.dropShadowDistance * this._resolution;
                context.shadowColor = (0, $1PNws.Color).shared.setValue(dropShadowColor).setAlpha(style.dropShadowAlpha).toRgbaString(), context.shadowBlur = dropShadowBlur, context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance, context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance + dsOffsetShadow;
            } else context.fillStyle = this._generateFillStyle(style, lines, measured), context.strokeStyle = style.stroke, context.shadowColor = "black", context.shadowBlur = 0, context.shadowOffsetX = 0, context.shadowOffsetY = 0;
            let linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
            lineHeight - fontProperties.fontSize < 0 && (linePositionYShift = 0);
            for(let i2 = 0; i2 < lines.length; i2++)linePositionX = style.strokeThickness / 2, linePositionY = style.strokeThickness / 2 + i2 * lineHeight + fontProperties.ascent + linePositionYShift, style.align === "right" ? linePositionX += maxLineWidth - lineWidths[i2] : style.align === "center" && (linePositionX += (maxLineWidth - lineWidths[i2]) / 2), style.stroke && style.strokeThickness && this.drawLetterSpacing(lines[i2], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText, !0), style.fill && this.drawLetterSpacing(lines[i2], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText);
        }
        this.updateTexture();
    }
    /**
   * Render the text with letter-spacing.
   * @param text - The text to draw
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Is this drawing for the outside stroke of the
   *  text? If not, it's for the inside fill
   */ drawLetterSpacing(text, x, y, isStroke = !1) {
        const letterSpacing = this._style.letterSpacing;
        let useExperimentalLetterSpacing = !1;
        if ((0, $5FHOg.TextMetrics).experimentalLetterSpacingSupported && ((0, $5FHOg.TextMetrics).experimentalLetterSpacing ? (this.context.letterSpacing = `${letterSpacing}px`, this.context.textLetterSpacing = `${letterSpacing}px`, useExperimentalLetterSpacing = !0) : (this.context.letterSpacing = "0px", this.context.textLetterSpacing = "0px")), letterSpacing === 0 || useExperimentalLetterSpacing) {
            isStroke ? this.context.strokeText(text, x, y) : this.context.fillText(text, x, y);
            return;
        }
        let currentPosition = x;
        const stringArray = (0, $5FHOg.TextMetrics).graphemeSegmenter(text);
        let previousWidth = this.context.measureText(text).width, currentWidth = 0;
        for(let i = 0; i < stringArray.length; ++i){
            const currentChar = stringArray[i];
            isStroke ? this.context.strokeText(currentChar, currentPosition, y) : this.context.fillText(currentChar, currentPosition, y);
            let textStr = "";
            for(let j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = this.context.measureText(textStr).width, currentPosition += previousWidth - currentWidth + letterSpacing, previousWidth = currentWidth;
        }
    }
    /** Updates texture size based on canvas size. */ updateTexture() {
        const canvas = this.canvas;
        if (this._style.trim) {
            const trimmed = (0, $lFGyw).trimCanvas(canvas);
            trimmed.data && (canvas.width = trimmed.width, canvas.height = trimmed.height, this.context.putImageData(trimmed.data, 0, 0));
        }
        const texture = this._texture, style = this._style, padding = style.trim ? 0 : style.padding, baseTexture = texture.baseTexture;
        texture.trim.width = texture._frame.width = canvas.width / this._resolution, texture.trim.height = texture._frame.height = canvas.height / this._resolution, texture.trim.x = -padding, texture.trim.y = -padding, texture.orig.width = texture._frame.width - padding * 2, texture.orig.height = texture._frame.height - padding * 2, this._onTextureUpdate(), baseTexture.setRealSize(canvas.width, canvas.height, this._resolution), texture.updateUvs(), this.dirty = !1;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._render(renderer);
    }
    /** Updates the transform on all children of this container for rendering. */ updateTransform() {
        this.updateText(!0), super.updateTransform();
    }
    getBounds(skipUpdate, rect) {
        return this.updateText(!0), this._textureID === -1 && (skipUpdate = !1), super.getBounds(skipUpdate, rect);
    }
    /**
   * Gets the local bounds of the text object.
   * @param rect - The output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.updateText(!0), super.getLocalBounds.call(this, rect);
    }
    /** Calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account. */ _calculateBounds() {
        this.calculateVertices(), this._bounds.addQuad(this.vertexData);
    }
    /**
   * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
   * @param style - The style.
   * @param lines - The lines of text.
   * @param metrics
   * @returns The fill style
   */ _generateFillStyle(style, lines, metrics) {
        const fillStyle = style.fill;
        if (Array.isArray(fillStyle)) {
            if (fillStyle.length === 1) return fillStyle[0];
        } else return fillStyle;
        let gradient;
        const dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0, padding = style.padding || 0, width = this.canvas.width / this._resolution - dropShadowCorrection - padding * 2, height = this.canvas.height / this._resolution - dropShadowCorrection - padding * 2, fill = fillStyle.slice(), fillGradientStops = style.fillGradientStops.slice();
        if (!fillGradientStops.length) {
            const lengthPlus1 = fill.length + 1;
            for(let i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
        }
        if (fill.unshift(fillStyle[0]), fillGradientStops.unshift(0), fill.push(fillStyle[fillStyle.length - 1]), fillGradientStops.push(1), style.fillGradientType === (0, $lxqYA.TEXT_GRADIENT).LINEAR_VERTICAL) {
            gradient = this.context.createLinearGradient(width / 2, padding, width / 2, height + padding);
            const textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
            for(let i = 0; i < lines.length; i++){
                const lastLineBottom = metrics.lineHeight * (i - 1) + textHeight, thisLineTop = metrics.lineHeight * i;
                let thisLineGradientStart = thisLineTop;
                i > 0 && lastLineBottom > thisLineTop && (thisLineGradientStart = (thisLineTop + lastLineBottom) / 2);
                const thisLineBottom = thisLineTop + textHeight, nextLineTop = metrics.lineHeight * (i + 1);
                let thisLineGradientEnd = thisLineBottom;
                i + 1 < lines.length && nextLineTop < thisLineBottom && (thisLineGradientEnd = (thisLineBottom + nextLineTop) / 2);
                const gradStopLineHeight = (thisLineGradientEnd - thisLineGradientStart) / height;
                for(let j = 0; j < fill.length; j++){
                    let lineStop = 0;
                    typeof fillGradientStops[j] == "number" ? lineStop = fillGradientStops[j] : lineStop = j / fill.length;
                    let globalStop = Math.min(1, Math.max(0, thisLineGradientStart / height + lineStop * gradStopLineHeight));
                    globalStop = Number(globalStop.toFixed(5)), gradient.addColorStop(globalStop, fill[j]);
                }
            }
        } else {
            gradient = this.context.createLinearGradient(padding, height / 2, width + padding, height / 2);
            const totalIterations = fill.length + 1;
            let currentIteration = 1;
            for(let i = 0; i < fill.length; i++){
                let stop;
                typeof fillGradientStops[i] == "number" ? stop = fillGradientStops[i] : stop = currentIteration / totalIterations, gradient.addColorStop(stop, fill[i]), currentIteration++;
            }
        }
        return gradient;
    }
    /**
   * Destroys this text object.
   *
   * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
   * the majority of the time the texture will not be shared with any other Sprites.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their
   *  destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
   * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        typeof options == "boolean" && (options = {
            children: options
        }), options = Object.assign({}, $cd9bcb4d5b9d0264$var$defaultDestroyOptions, options), super.destroy(options), this._ownCanvas && (this.canvas.height = this.canvas.width = 0), this.context = null, this.canvas = null, this._style = null;
    }
    /** The width of the Text, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this.updateText(!0), Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this.updateText(!0);
        const s = (0, $lFGyw).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._texture.orig.width, this._width = value;
    }
    /** The height of the Text, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this.updateText(!0), Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this.updateText(!0);
        const s = (0, $lFGyw).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._texture.orig.height, this._height = value;
    }
    /**
   * Set the style of the text.
   *
   * Set up an event listener to listen for changes on the style object and mark the text as dirty.
   *
   * If setting the `style` can also be partial {@link PIXI.ITextStyle}.
   */ get style() {
        return this._style;
    }
    set style(style) {
        style = style || {}, style instanceof (0, $f6HC1.TextStyle) ? this._style = style : this._style = new (0, $f6HC1.TextStyle)(style), this.localStyleID = -1, this.dirty = !0;
    }
    /** Set the copy for the text object. To split a line you can use '\n'. */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text ?? ""), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
};
$cd9bcb4d5b9d0264$var$_Text.defaultAutoResolution = !0;
let $cd9bcb4d5b9d0264$export$5f1af8db9871e1d6 = $cd9bcb4d5b9d0264$var$_Text;

});
parcelRegister("jW6UI", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => (parcelRequire("3uiak")).Sprite);

var $3uiak = parcelRequire("3uiak");

});
parcelRegister("3uiak", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $28766cd6a31d5ed8$export$3075603db8e6204c);
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $1PNws = parcelRequire("1PNws");
var $g9ac3 = parcelRequire("g9ac3");
var $gnwPx = parcelRequire("gnwPx");
var $kZOeV = parcelRequire("kZOeV");
var $16eqM = parcelRequire("16eqM");
var $cWOCu = parcelRequire("cWOCu");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("gD5uZ");
var $aMxkH = parcelRequire("aMxkH");
var $3IPo5 = parcelRequire("3IPo5");
const $28766cd6a31d5ed8$var$tempPoint = new (0, $gnwPx.Point)(), $28766cd6a31d5ed8$var$indices = new Uint16Array([
    0,
    1,
    2,
    0,
    2,
    3
]);
class $28766cd6a31d5ed8$export$3075603db8e6204c extends (0, $3IPo5.Container) {
    /** @param texture - The texture for this sprite. */ constructor(texture){
        super(), this._anchor = new (0, $g9ac3.ObservablePoint)(this._onAnchorUpdate, this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0), this._texture = null, this._width = 0, this._height = 0, this._tintColor = new (0, $1PNws.Color)(16777215), this._tintRGB = null, this.tint = 16777215, this.blendMode = (0, $lmRm8.BLEND_MODES).NORMAL, this._cachedTint = 16777215, this.uvs = null, this.texture = texture || (0, $cWOCu.Texture).EMPTY, this.vertexData = new Float32Array(8), this.vertexTrimmedData = null, this._transformID = -1, this._textureID = -1, this._transformTrimmedID = -1, this._textureTrimmedID = -1, this.indices = $28766cd6a31d5ed8$var$indices, this.pluginName = "batch", this.isSprite = !0, this._roundPixels = (0, $16eqM.settings).ROUND_PIXELS;
    }
    /** When the texture is updated, this event will fire to update the scale and frame. */ _onTextureUpdate() {
        this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this._width && (this.scale.x = (0, $lFGyw).sign(this.scale.x) * this._width / this._texture.orig.width), this._height && (this.scale.y = (0, $lFGyw).sign(this.scale.y) * this._height / this._texture.orig.height);
    }
    /** Called when the anchor position updates. */ _onAnchorUpdate() {
        this._transformID = -1, this._transformTrimmedID = -1;
    }
    /** Calculates worldTransform * vertices, store it in vertexData. */ calculateVertices() {
        const texture = this._texture;
        if (this._transformID === this.transform._worldID && this._textureID === texture._updateID) return;
        this._textureID !== texture._updateID && (this.uvs = this._texture._uvs.uvsFloat32), this._transformID = this.transform._worldID, this._textureID = texture._updateID;
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, vertexData = this.vertexData, trim = texture.trim, orig = texture.orig, anchor = this._anchor;
        let w0 = 0, w1 = 0, h0 = 0, h1 = 0;
        if (trim ? (w1 = trim.x - anchor._x * orig.width, w0 = w1 + trim.width, h1 = trim.y - anchor._y * orig.height, h0 = h1 + trim.height) : (w1 = -anchor._x * orig.width, w0 = w1 + orig.width, h1 = -anchor._y * orig.height, h0 = h1 + orig.height), vertexData[0] = a * w1 + c * h1 + tx, vertexData[1] = d * h1 + b * w1 + ty, vertexData[2] = a * w0 + c * h1 + tx, vertexData[3] = d * h1 + b * w0 + ty, vertexData[4] = a * w0 + c * h0 + tx, vertexData[5] = d * h0 + b * w0 + ty, vertexData[6] = a * w1 + c * h0 + tx, vertexData[7] = d * h0 + b * w1 + ty, this._roundPixels) {
            const resolution = (0, $16eqM.settings).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
    }
    /**
   * Calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData.
   *
   * This is used to ensure that the true width and height of a trimmed texture is respected.
   */ calculateTrimmedVertices() {
        if (!this.vertexTrimmedData) this.vertexTrimmedData = new Float32Array(8);
        else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) return;
        this._transformTrimmedID = this.transform._worldID, this._textureTrimmedID = this._texture._updateID;
        const texture = this._texture, vertexData = this.vertexTrimmedData, orig = texture.orig, anchor = this._anchor, wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, w1 = -anchor._x * orig.width, w0 = w1 + orig.width, h1 = -anchor._y * orig.height, h0 = h1 + orig.height;
        if (vertexData[0] = a * w1 + c * h1 + tx, vertexData[1] = d * h1 + b * w1 + ty, vertexData[2] = a * w0 + c * h1 + tx, vertexData[3] = d * h1 + b * w0 + ty, vertexData[4] = a * w0 + c * h0 + tx, vertexData[5] = d * h0 + b * w0 + ty, vertexData[6] = a * w1 + c * h0 + tx, vertexData[7] = d * h0 + b * w1 + ty, this._roundPixels) {
            const resolution = (0, $16eqM.settings).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
    }
    /**
   *
   * Renders the object using the WebGL renderer
   * @param renderer - The webgl renderer to use.
   */ _render(renderer) {
        this.calculateVertices(), renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), renderer.plugins[this.pluginName].render(this);
    }
    /** Updates the bounds of the sprite. */ _calculateBounds() {
        const trim = this._texture.trim, orig = this._texture.orig;
        !trim || trim.width === orig.width && trim.height === orig.height ? (this.calculateVertices(), this._bounds.addQuad(this.vertexData)) : (this.calculateTrimmedVertices(), this._bounds.addQuad(this.vertexTrimmedData));
    }
    /**
   * Gets the local bounds of the sprite object.
   * @param rect - Optional output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.children.length === 0 ? (this._localBounds || (this._localBounds = new (0, $aMxkH.Bounds)()), this._localBounds.minX = this._texture.orig.width * -this._anchor._x, this._localBounds.minY = this._texture.orig.height * -this._anchor._y, this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x), this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y), rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $kZOeV.Rectangle)()), rect = this._localBoundsRect), this._localBounds.getRectangle(rect)) : super.getLocalBounds.call(this, rect);
    }
    /**
   * Tests if a point is inside this sprite
   * @param point - the point to test
   * @returns The result of the test
   */ containsPoint(point) {
        this.worldTransform.applyInverse(point, $28766cd6a31d5ed8$var$tempPoint);
        const width = this._texture.orig.width, height = this._texture.orig.height, x1 = -width * this.anchor.x;
        let y1 = 0;
        return $28766cd6a31d5ed8$var$tempPoint.x >= x1 && $28766cd6a31d5ed8$var$tempPoint.x < x1 + width && (y1 = -height * this.anchor.y, $28766cd6a31d5ed8$var$tempPoint.y >= y1 && $28766cd6a31d5ed8$var$tempPoint.y < y1 + height);
    }
    /**
   * Destroys this sprite and optionally its texture and children.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param [options.children=false] - if set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param [options.texture=false] - Should it destroy the current texture of the sprite as well
   * @param [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        if (super.destroy(options), this._texture.off("update", this._onTextureUpdate, this), this._anchor = null, typeof options == "boolean" ? options : options?.texture) {
            const destroyBaseTexture = typeof options == "boolean" ? options : options?.baseTexture;
            this._texture.destroy(!!destroyBaseTexture);
        }
        this._texture = null;
    }
    // some helper functions..
    /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @param {string|PIXI.Texture|HTMLImageElement|HTMLVideoElement|ImageBitmap|PIXI.ICanvas} source
   *     - Source to create texture from
   * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
   * @returns The newly created sprite
   */ static from(source, options) {
        const texture = source instanceof (0, $cWOCu.Texture) ? source : (0, $cWOCu.Texture).from(source, options);
        return new $28766cd6a31d5ed8$export$3075603db8e6204c(texture);
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   *
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   *
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}.
   * @default false
   */ set roundPixels(value) {
        this._roundPixels !== value && (this._transformID = -1, this._transformTrimmedID = -1), this._roundPixels = value;
    }
    get roundPixels() {
        return this._roundPixels;
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        const s = (0, $lFGyw).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._texture.orig.width, this._width = value;
    }
    /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        const s = (0, $lFGyw).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._texture.orig.height, this._height = value;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(Texture.WHITE);
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        this._anchor.copyFrom(value);
    }
    /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value), this._tintRGB = this._tintColor.toLittleEndianNumber();
    }
    /**
   * Get the tint as a RGB integer.
   * @ignore
   */ get tintValue() {
        return this._tintColor.toNumber();
    }
    /** The texture that the sprite is using. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        this._texture !== value && (this._texture && this._texture.off("update", this._onTextureUpdate, this), this._texture = value || (0, $cWOCu.Texture).EMPTY, this._cachedTint = 16777215, this._textureID = -1, this._textureTrimmedID = -1, value && (value.baseTexture.valid ? this._onTextureUpdate() : value.once("update", this._onTextureUpdate, this)));
    }
}

});


parcelRegister("5FHOg", function(module, exports) {

$parcel$export(module.exports, "TextMetrics", () => $d1d36a3f61276665$export$4c5a129a59e1ef34);
parcelRequire("inflE");
var $16eqM = parcelRequire("16eqM");
const $d1d36a3f61276665$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: !0
}, $d1d36a3f61276665$var$_TextMetrics = class _TextMetrics2 {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see PIXI.TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _TextMetrics2._experimentalLetterSpacingSupported;
        if (result !== void 0) {
            const proto = (0, $16eqM.settings).ADAPTER.getCanvasRenderingContext2D().prototype;
            result = _TextMetrics2._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {PIXI.IFontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties){
        this.text = text, this.style = style, this.width = width, this.height = height, this.lines = lines, this.lineWidths = lineWidths, this.lineHeight = lineHeight, this.maxLineWidth = maxLineWidth, this.fontProperties = fontProperties;
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param wordWrap - Override for if word-wrap should be applied to the text.
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns Measured width and height of the text.
   */ static measureText(text, style, wordWrap, canvas = _TextMetrics2._canvas) {
        wordWrap = wordWrap ?? style.wordWrap;
        const font = style.toFontString(), fontProperties = _TextMetrics2.measureFont(font);
        fontProperties.fontSize === 0 && (fontProperties.fontSize = style.fontSize, fontProperties.ascent = style.fontSize);
        const context = canvas.getContext("2d", $d1d36a3f61276665$var$contextSettings);
        context.font = font;
        const lines = (wordWrap ? _TextMetrics2.wordWrap(text, style, canvas) : text).split(/(?:\r\n|\r|\n)/), lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _TextMetrics2._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth, maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        let width = maxLineWidth + style.strokeThickness;
        style.dropShadow && (width += style.dropShadowDistance);
        const lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
        let height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness * 2) + style.leading + (lines.length - 1) * (lineHeight + style.leading);
        return style.dropShadow && (height += style.dropShadowDistance), new _TextMetrics2(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
    }
    static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = !1;
        _TextMetrics2.experimentalLetterSpacingSupported && (_TextMetrics2.experimentalLetterSpacing ? (context.letterSpacing = `${letterSpacing}px`, context.textLetterSpacing = `${letterSpacing}px`, useExperimentalLetterSpacing = !0) : (context.letterSpacing = "0px", context.textLetterSpacing = "0px"));
        let width = context.measureText(text).width;
        return width > 0 && (useExperimentalLetterSpacing ? width -= letterSpacing : width += (_TextMetrics2.graphemeSegmenter(text).length - 1) * letterSpacing), width;
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static wordWrap(text, style, canvas = _TextMetrics2._canvas) {
        const context = canvas.getContext("2d", $d1d36a3f61276665$var$contextSettings);
        let width = 0, line = "", lines = "";
        const cache = /* @__PURE__ */ Object.create(null), { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style, collapseSpaces = _TextMetrics2.collapseSpaces(whiteSpace), collapseNewlines = _TextMetrics2.collapseNewlines(whiteSpace);
        let canPrependSpaces = !collapseSpaces;
        const wordWrapWidth = style.wordWrapWidth + letterSpacing, tokens = _TextMetrics2.tokenize(text);
        for(let i = 0; i < tokens.length; i++){
            let token = tokens[i];
            if (_TextMetrics2.isNewline(token)) {
                if (!collapseNewlines) {
                    lines += _TextMetrics2.addLine(line), canPrependSpaces = !collapseSpaces, line = "", width = 0;
                    continue;
                }
                token = " ";
            }
            if (collapseSpaces) {
                const currIsBreakingSpace = _TextMetrics2.isBreakingSpace(token), lastIsBreakingSpace = _TextMetrics2.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            const tokenWidth = _TextMetrics2.getFromCache(token, letterSpacing, cache, context);
            if (tokenWidth > wordWrapWidth) {
                if (line !== "" && (lines += _TextMetrics2.addLine(line), line = "", width = 0), _TextMetrics2.canBreakWords(token, style.breakWords)) {
                    const characters = _TextMetrics2.wordWrapSplit(token);
                    for(let j = 0; j < characters.length; j++){
                        let char = characters[j], lastChar = char, k = 1;
                        for(; characters[j + k];){
                            const nextChar = characters[j + k];
                            if (!_TextMetrics2.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) char += nextChar;
                            else break;
                            lastChar = nextChar, k++;
                        }
                        j += k - 1;
                        const characterWidth = _TextMetrics2.getFromCache(char, letterSpacing, cache, context);
                        characterWidth + width > wordWrapWidth && (lines += _TextMetrics2.addLine(line), canPrependSpaces = !1, line = "", width = 0), line += char, width += characterWidth;
                    }
                } else {
                    line.length > 0 && (lines += _TextMetrics2.addLine(line), line = "", width = 0);
                    const isLastToken = i === tokens.length - 1;
                    lines += _TextMetrics2.addLine(token, !isLastToken), canPrependSpaces = !1, line = "", width = 0;
                }
            } else tokenWidth + width > wordWrapWidth && (canPrependSpaces = !1, lines += _TextMetrics2.addLine(line), line = "", width = 0), (line.length > 0 || !_TextMetrics2.isBreakingSpace(token) || canPrependSpaces) && (line += token, width += tokenWidth);
        }
        return lines += _TextMetrics2.addLine(line, !1), lines;
    }
    /**
   * Convienience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */ static addLine(line, newLine = !0) {
        return line = _TextMetrics2.trimRight(line), line = newLine ? `${line}
` : line, line;
    }
    /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */ static getFromCache(key, letterSpacing, cache, context) {
        let width = cache[key];
        return typeof width != "number" && (width = _TextMetrics2._measureText(key, letterSpacing, context) + letterSpacing, cache[key] = width), width;
    }
    /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */ static collapseSpaces(whiteSpace) {
        return whiteSpace === "normal" || whiteSpace === "pre-line";
    }
    /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */ static collapseNewlines(whiteSpace) {
        return whiteSpace === "normal";
    }
    /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */ static trimRight(text) {
        if (typeof text != "string") return "";
        for(let i = text.length - 1; i >= 0; i--){
            const char = text[i];
            if (!_TextMetrics2.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    }
    /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */ static isNewline(char) {
        return typeof char != "string" ? !1 : _TextMetrics2._newlines.includes(char.charCodeAt(0));
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        return typeof char != "string" ? !1 : _TextMetrics2._breakingSpaces.includes(char.charCodeAt(0));
    }
    /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */ static tokenize(text) {
        const tokens = [];
        let token = "";
        if (typeof text != "string") return tokens;
        for(let i = 0; i < text.length; i++){
            const char = text[i], nextChar = text[i + 1];
            if (_TextMetrics2.isBreakingSpace(char, nextChar) || _TextMetrics2.isNewline(char)) {
                token !== "" && (tokens.push(token), token = ""), tokens.push(char);
                continue;
            }
            token += char;
        }
        return token !== "" && tokens.push(token), tokens;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return !0;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see TextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _TextMetrics2.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_TextMetrics2._fonts[font]) return _TextMetrics2._fonts[font];
        const properties = {
            ascent: 0,
            descent: 0,
            fontSize: 0
        }, canvas = _TextMetrics2._canvas, context = _TextMetrics2._context;
        context.font = font;
        const metricsString = _TextMetrics2.METRICS_STRING + _TextMetrics2.BASELINE_SYMBOL, width = Math.ceil(context.measureText(metricsString).width);
        let baseline = Math.ceil(context.measureText(_TextMetrics2.BASELINE_SYMBOL).width);
        const height = Math.ceil(_TextMetrics2.HEIGHT_MULTIPLIER * baseline);
        if (baseline = baseline * _TextMetrics2.BASELINE_MULTIPLIER | 0, width === 0 || height === 0) return _TextMetrics2._fonts[font] = properties, properties;
        canvas.width = width, canvas.height = height, context.fillStyle = "#f00", context.fillRect(0, 0, width, height), context.font = font, context.textBaseline = "alphabetic", context.fillStyle = "#000", context.fillText(metricsString, 0, baseline);
        const imagedata = context.getImageData(0, 0, width, height).data, pixels = imagedata.length, line = width * 4;
        let i = 0, idx = 0, stop = !1;
        for(i = 0; i < baseline; ++i){
            for(let j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = !0;
                break;
            }
            if (!stop) idx += line;
            else break;
        }
        for(properties.ascent = baseline - i, idx = pixels - line, stop = !1, i = height; i > baseline; --i){
            for(let j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = !0;
                break;
            }
            if (!stop) idx -= line;
            else break;
        }
        return properties.descent = i - baseline, properties.fontSize = properties.ascent + properties.descent, _TextMetrics2._fonts[font] = properties, properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        font ? delete _TextMetrics2._fonts[font] : _TextMetrics2._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_TextMetrics2.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                if (c.getContext("2d", $d1d36a3f61276665$var$contextSettings)?.measureText) return _TextMetrics2.__canvas = c, c;
                canvas = (0, $16eqM.settings).ADAPTER.createCanvas();
            } catch  {
                canvas = (0, $16eqM.settings).ADAPTER.createCanvas();
            }
            canvas.width = canvas.height = 10, _TextMetrics2.__canvas = canvas;
        }
        return _TextMetrics2.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        return _TextMetrics2.__context || (_TextMetrics2.__context = _TextMetrics2._canvas.getContext("2d", $d1d36a3f61276665$var$contextSettings)), _TextMetrics2.__context;
    }
};
$d1d36a3f61276665$var$_TextMetrics.METRICS_STRING = "|\xC9q\xC5", /** Baseline symbol for calculate font metrics. */ $d1d36a3f61276665$var$_TextMetrics.BASELINE_SYMBOL = "M", /** Baseline multiplier for calculate font metrics. */ $d1d36a3f61276665$var$_TextMetrics.BASELINE_MULTIPLIER = 1.4, /** Height multiplier for setting height of canvas to calculate font metrics. */ $d1d36a3f61276665$var$_TextMetrics.HEIGHT_MULTIPLIER = 2, /**
* A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
* such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
* or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
* The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
* PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
* If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
* you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
* or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
* relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
*/ $d1d36a3f61276665$var$_TextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter == "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>[
                ...segmenter.segment(s)
            ].map((x)=>x.segment);
    }
    return (s)=>[
            ...s
        ];
})(), /**
* New rendering behavior for letter-spacing which uses Chrome's new native API. This will
* lead to more accurate letter-spacing results because it does not try to manually draw
* each character. However, this Chrome API is experimental and may not serve all cases yet.
* @see PIXI.TextMetrics.experimentalLetterSpacingSupported
*/ $d1d36a3f61276665$var$_TextMetrics.experimentalLetterSpacing = !1, /** Cache of {@see PIXI.TextMetrics.FontMetrics} objects. */ $d1d36a3f61276665$var$_TextMetrics._fonts = {}, /** Cache of new line chars. */ $d1d36a3f61276665$var$_TextMetrics._newlines = [
    10,
    // line feed
    13
], /** Cache of breaking spaces. */ $d1d36a3f61276665$var$_TextMetrics._breakingSpaces = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
let $d1d36a3f61276665$export$4c5a129a59e1ef34 = $d1d36a3f61276665$var$_TextMetrics;

});

parcelRegister("f6HC1", function(module, exports) {

$parcel$export(module.exports, "TextStyle", () => $56d58ce84c72d9ac$export$1df879243bf2e42d);

var $lxqYA = parcelRequire("lxqYA");
parcelRequire("inflE");
var $1PNws = parcelRequire("1PNws");
const $56d58ce84c72d9ac$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
], $56d58ce84c72d9ac$var$_TextStyle = class _TextStyle2 {
    /**
   * @param style - TextStyle properties to be set on the text. See {@link PIXI.TextStyle.defaultStyle}
   *       for the default values.
   */ constructor(style){
        this.styleID = 0, this.reset(), $56d58ce84c72d9ac$var$deepCopyProperties(this, style, style);
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * Note that the only the properties of the object are cloned.
   *
   * @return New cloned TextStyle object
   */ clone() {
        const clonedProperties = {};
        return $56d58ce84c72d9ac$var$deepCopyProperties(clonedProperties, this, _TextStyle2.defaultStyle), new _TextStyle2(clonedProperties);
    }
    /** Resets all properties to the defaults specified in TextStyle.prototype._default */ reset() {
        $56d58ce84c72d9ac$var$deepCopyProperties(this, _TextStyle2.defaultStyle, _TextStyle2.defaultStyle);
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   *
   * @member {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(align) {
        this._align !== align && (this._align = align, this.styleID++);
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(breakWords) {
        this._breakWords !== breakWords && (this._breakWords = breakWords, this.styleID++);
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(dropShadow) {
        this._dropShadow !== dropShadow && (this._dropShadow = dropShadow, this.styleID++);
    }
    /** Set alpha for the drop shadow. */ get dropShadowAlpha() {
        return this._dropShadowAlpha;
    }
    set dropShadowAlpha(dropShadowAlpha) {
        this._dropShadowAlpha !== dropShadowAlpha && (this._dropShadowAlpha = dropShadowAlpha, this.styleID++);
    }
    /** Set a angle of the drop shadow. */ get dropShadowAngle() {
        return this._dropShadowAngle;
    }
    set dropShadowAngle(dropShadowAngle) {
        this._dropShadowAngle !== dropShadowAngle && (this._dropShadowAngle = dropShadowAngle, this.styleID++);
    }
    /** Set a shadow blur radius. */ get dropShadowBlur() {
        return this._dropShadowBlur;
    }
    set dropShadowBlur(dropShadowBlur) {
        this._dropShadowBlur !== dropShadowBlur && (this._dropShadowBlur = dropShadowBlur, this.styleID++);
    }
    /** A fill style to be used on the dropshadow e.g., 'red', '#00FF00'. */ get dropShadowColor() {
        return this._dropShadowColor;
    }
    set dropShadowColor(dropShadowColor) {
        const outputColor = $56d58ce84c72d9ac$var$getColor(dropShadowColor);
        this._dropShadowColor !== outputColor && (this._dropShadowColor = outputColor, this.styleID++);
    }
    /** Set a distance of the drop shadow. */ get dropShadowDistance() {
        return this._dropShadowDistance;
    }
    set dropShadowDistance(dropShadowDistance) {
        this._dropShadowDistance !== dropShadowDistance && (this._dropShadowDistance = dropShadowDistance, this.styleID++);
    }
    /**
   * A canvas fillstyle that will be used on the text e.g., 'red', '#00FF00'.
   *
   * Can be an array to create a gradient e.g., `['#000000','#FFFFFF']`
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
   *
   * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */ get fill() {
        return this._fill;
    }
    set fill(fill) {
        const outputColor = $56d58ce84c72d9ac$var$getColor(fill);
        this._fill !== outputColor && (this._fill = outputColor, this.styleID++);
    }
    /**
   * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
   *
   * @type {PIXI.TEXT_GRADIENT}
   */ get fillGradientType() {
        return this._fillGradientType;
    }
    set fillGradientType(fillGradientType) {
        this._fillGradientType !== fillGradientType && (this._fillGradientType = fillGradientType, this.styleID++);
    }
    /**
   * If fill is an array of colours to create a gradient, this array can set the stop points
   * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
   */ get fillGradientStops() {
        return this._fillGradientStops;
    }
    set fillGradientStops(fillGradientStops) {
        $56d58ce84c72d9ac$var$areArraysEqual(this._fillGradientStops, fillGradientStops) || (this._fillGradientStops = fillGradientStops, this.styleID++);
    }
    /**
   * The font family, can be a single font name, or a list of names where the first
   * is the preferred font.
   */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(fontFamily) {
        this.fontFamily !== fontFamily && (this._fontFamily = fontFamily, this.styleID++);
    }
    /**
   * The font size
   * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
   */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(fontSize) {
        this._fontSize !== fontSize && (this._fontSize = fontSize, this.styleID++);
    }
    /**
   * The font style.
   *
   * @member {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(fontStyle) {
        this._fontStyle !== fontStyle && (this._fontStyle = fontStyle, this.styleID++);
    }
    /**
   * The font variant.
   *
   * @member {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(fontVariant) {
        this._fontVariant !== fontVariant && (this._fontVariant = fontVariant, this.styleID++);
    }
    /**
   * The font weight.
   *
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(fontWeight) {
        this._fontWeight !== fontWeight && (this._fontWeight = fontWeight, this.styleID++);
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(letterSpacing) {
        this._letterSpacing !== letterSpacing && (this._letterSpacing = letterSpacing, this.styleID++);
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(lineHeight) {
        this._lineHeight !== lineHeight && (this._lineHeight = lineHeight, this.styleID++);
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(leading) {
        this._leading !== leading && (this._leading = leading, this.styleID++);
    }
    /**
   * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
   * Default is 'miter' (creates a sharp corner).
   *
   * @member {'miter'|'round'|'bevel'}
   */ get lineJoin() {
        return this._lineJoin;
    }
    set lineJoin(lineJoin) {
        this._lineJoin !== lineJoin && (this._lineJoin = lineJoin, this.styleID++);
    }
    /**
   * The miter limit to use when using the 'miter' lineJoin mode.
   *
   * This can reduce or increase the spikiness of rendered text.
   */ get miterLimit() {
        return this._miterLimit;
    }
    set miterLimit(miterLimit) {
        this._miterLimit !== miterLimit && (this._miterLimit = miterLimit, this.styleID++);
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(padding) {
        this._padding !== padding && (this._padding = padding, this.styleID++);
    }
    /**
   * A canvas fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'
   */ get stroke() {
        return this._stroke;
    }
    set stroke(stroke) {
        const outputColor = $56d58ce84c72d9ac$var$getColor(stroke);
        this._stroke !== outputColor && (this._stroke = outputColor, this.styleID++);
    }
    /**
   * A number that represents the thickness of the stroke.
   *
   * @default 0
   */ get strokeThickness() {
        return this._strokeThickness;
    }
    set strokeThickness(strokeThickness) {
        this._strokeThickness !== strokeThickness && (this._strokeThickness = strokeThickness, this.styleID++);
    }
    /**
   * The baseline of the text that is rendered.
   *
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(textBaseline) {
        this._textBaseline !== textBaseline && (this._textBaseline = textBaseline, this.styleID++);
    }
    /** Trim transparent borders. */ get trim() {
        return this._trim;
    }
    set trim(trim) {
        this._trim !== trim && (this._trim = trim, this.styleID++);
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   *
   * @member {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(whiteSpace) {
        this._whiteSpace !== whiteSpace && (this._whiteSpace = whiteSpace, this.styleID++);
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(wordWrap) {
        this._wordWrap !== wordWrap && (this._wordWrap = wordWrap, this.styleID++);
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(wordWrapWidth) {
        this._wordWrapWidth !== wordWrapWidth && (this._wordWrapWidth = wordWrapWidth, this.styleID++);
    }
    /**
   * Generates a font style string to use for `TextMetrics.measureFont()`.
   *
   * @return Font style string, for passing to `TextMetrics.measureFont()`
   */ toFontString() {
        const fontSizeString = typeof this.fontSize == "number" ? `${this.fontSize}px` : this.fontSize;
        let fontFamilies = this.fontFamily;
        Array.isArray(this.fontFamily) || (fontFamilies = this.fontFamily.split(","));
        for(let i = fontFamilies.length - 1; i >= 0; i--){
            let fontFamily = fontFamilies[i].trim();
            !/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$56d58ce84c72d9ac$var$genericFontFamilies.includes(fontFamily) && (fontFamily = `"${fontFamily}"`), fontFamilies[i] = fontFamily;
        }
        return `${this.fontStyle} ${this.fontVariant} ${this.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
    }
};
$56d58ce84c72d9ac$var$_TextStyle.defaultStyle = {
    /**
   * See {@link PIXI.TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */ align: "left",
    /** See {@link PIXI.TextStyle.breakWords} */ breakWords: !1,
    /** See {@link PIXI.TextStyle.dropShadow} */ dropShadow: !1,
    /** See {@link PIXI.TextStyle.dropShadowAlpha} */ dropShadowAlpha: 1,
    /**
   * See {@link PIXI.TextStyle.dropShadowAngle}
   * @type {number}
   * @default Math.PI / 6
   */ dropShadowAngle: Math.PI / 6,
    /** See {@link PIXI.TextStyle.dropShadowBlur} */ dropShadowBlur: 0,
    /**
   * See {@link PIXI.TextStyle.dropShadowColor}
   * @type {string|number}
   */ dropShadowColor: "black",
    /** See {@link PIXI.TextStyle.dropShadowDistance} */ dropShadowDistance: 5,
    /**
   * See {@link PIXI.TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */ fill: "black",
    /**
   * See {@link PIXI.TextStyle.fillGradientType}
   * @type {PIXI.TEXT_GRADIENT}
   * @default PIXI.TEXT_GRADIENT.LINEAR_VERTICAL
   */ fillGradientType: (0, $lxqYA.TEXT_GRADIENT).LINEAR_VERTICAL,
    /**
   * See {@link PIXI.TextStyle.fillGradientStops}
   * @type {number[]}
   * @default []
   */ fillGradientStops: [],
    /**
   * See {@link PIXI.TextStyle.fontFamily}
   * @type {string|string[]}
   */ fontFamily: "Arial",
    /**
   * See {@link PIXI.TextStyle.fontSize}
   * @type {number|string} 
   */ fontSize: 26,
    /**
   * See {@link PIXI.TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */ fontStyle: "normal",
    /**
   * See {@link PIXI.TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */ fontVariant: "normal",
    /**
   * See {@link PIXI.TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ fontWeight: "normal",
    /** See {@link PIXI.TextStyle.leading} */ leading: 0,
    /** See {@link PIXI.TextStyle.letterSpacing} */ letterSpacing: 0,
    /** See {@link PIXI.TextStyle.lineHeight} */ lineHeight: 0,
    /**
   * See {@link PIXI.TextStyle.lineJoin}
   * @type {'miter'|'round'|'bevel'}
   */ lineJoin: "miter",
    /** See {@link PIXI.TextStyle.miterLimit} */ miterLimit: 10,
    /** See {@link PIXI.TextStyle.padding} */ padding: 0,
    /**
   * See {@link PIXI.TextStyle.stroke}
   * @type {string|number}
   */ stroke: "black",
    /** See {@link PIXI.TextStyle.strokeThickness} */ strokeThickness: 0,
    /**
   * See {@link PIXI.TextStyle.textBaseline} 
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ textBaseline: "alphabetic",
    /** See {@link PIXI.TextStyle.trim} */ trim: !1,
    /**
   * See {@link PIXI.TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */ whiteSpace: "pre",
    /** See {@link PIXI.TextStyle.wordWrap} */ wordWrap: !1,
    /** See {@link PIXI.TextStyle.wordWrapWidth} */ wordWrapWidth: 100
};
let $56d58ce84c72d9ac$export$1df879243bf2e42d = $56d58ce84c72d9ac$var$_TextStyle;
function $56d58ce84c72d9ac$var$getColor(color) {
    const temp = (0, $1PNws.Color).shared, format = (color2)=>{
        const res = temp.setValue(color2);
        return res.alpha === 1 ? res.toHex() : res.toRgbaString();
    };
    return Array.isArray(color) ? color.map(format) : format(color);
}
function $56d58ce84c72d9ac$var$areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2) || array1.length !== array2.length) return !1;
    for(let i = 0; i < array1.length; ++i)if (array1[i] !== array2[i]) return !1;
    return !0;
}
function $56d58ce84c72d9ac$var$deepCopyProperties(target, source, propertyObj) {
    for(const prop in propertyObj)Array.isArray(source[prop]) ? target[prop] = source[prop].slice() : target[prop] = source[prop];
}

});



parcelRegister("k1Bg2", function(module, exports) {

$parcel$export(module.exports, "BitmapFontData", () => $7ab50fe3972ed646$export$2fb2a0e272ba703b);
class $7ab50fe3972ed646$export$2fb2a0e272ba703b {
    constructor(){
        this.info = [], this.common = [], this.page = [], this.char = [], this.kerning = [], this.distanceField = [];
    }
}

});

parcelRegister("8HicO", function(module, exports) {

$parcel$export(module.exports, "autoDetectFormat", () => $23cf94aebde1cdac$export$260d11d424c8eebd);

var $46hKQ = parcelRequire("46hKQ");

var $83Oz4 = parcelRequire("83Oz4");

var $9EGm1 = parcelRequire("9EGm1");
const $23cf94aebde1cdac$var$formats = [
    (0, $46hKQ.TextFormat),
    (0, $83Oz4.XMLFormat),
    (0, $9EGm1.XMLStringFormat)
];
function $23cf94aebde1cdac$export$260d11d424c8eebd(data) {
    for(let i = 0; i < $23cf94aebde1cdac$var$formats.length; i++)if ($23cf94aebde1cdac$var$formats[i].test(data)) return $23cf94aebde1cdac$var$formats[i];
    return null;
}

});
parcelRegister("46hKQ", function(module, exports) {

$parcel$export(module.exports, "TextFormat", () => $880895278b852cc3$export$ff5bf922eba68a09);

var $k1Bg2 = parcelRequire("k1Bg2");
class $880895278b852cc3$export$ff5bf922eba68a09 {
    /**
   * Check if resource refers to txt font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        return typeof data == "string" && data.startsWith("info face=");
    }
    /**
   * Convert text font data to a javascript object.
   * @param txt - Raw string data to be converted
   * @returns - Parsed font data
   */ static parse(txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm), rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0], attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm), itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("="), key = split[0], strValue = split[1].replace(/"/gm, ""), floatValue = parseFloat(strValue), value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = new (0, $k1Bg2.BitmapFontData)();
        return rawData.info.forEach((info)=>font.info.push({
                face: info.face,
                size: parseInt(info.size, 10)
            })), rawData.common.forEach((common)=>font.common.push({
                lineHeight: parseInt(common.lineHeight, 10)
            })), rawData.page.forEach((page)=>font.page.push({
                id: parseInt(page.id, 10),
                file: page.file
            })), rawData.char.forEach((char)=>font.char.push({
                id: parseInt(char.id, 10),
                page: parseInt(char.page, 10),
                x: parseInt(char.x, 10),
                y: parseInt(char.y, 10),
                width: parseInt(char.width, 10),
                height: parseInt(char.height, 10),
                xoffset: parseInt(char.xoffset, 10),
                yoffset: parseInt(char.yoffset, 10),
                xadvance: parseInt(char.xadvance, 10)
            })), rawData.kerning.forEach((kerning)=>font.kerning.push({
                first: parseInt(kerning.first, 10),
                second: parseInt(kerning.second, 10),
                amount: parseInt(kerning.amount, 10)
            })), rawData.distanceField.forEach((df)=>font.distanceField.push({
                distanceRange: parseInt(df.distanceRange, 10),
                fieldType: df.fieldType
            })), font;
    }
}

});

parcelRegister("83Oz4", function(module, exports) {

$parcel$export(module.exports, "XMLFormat", () => $608a1d5fe1df2eb9$export$4e1527335cae8d18);

var $k1Bg2 = parcelRequire("k1Bg2");
class $608a1d5fe1df2eb9$export$4e1527335cae8d18 {
    /**
   * Check if resource refers to xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        const xml = data;
        return typeof data != "string" && "getElementsByTagName" in data && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    }
    /**
   * Convert the XML into BitmapFontData that we can use.
   * @param xml
   * @returns - Data to use for BitmapFont
   */ static parse(xml) {
        const data = new (0, $k1Bg2.BitmapFontData)(), info = xml.getElementsByTagName("info"), common = xml.getElementsByTagName("common"), page = xml.getElementsByTagName("page"), char = xml.getElementsByTagName("char"), kerning = xml.getElementsByTagName("kerning"), distanceField = xml.getElementsByTagName("distanceField");
        for(let i = 0; i < info.length; i++)data.info.push({
            face: info[i].getAttribute("face"),
            size: parseInt(info[i].getAttribute("size"), 10)
        });
        for(let i = 0; i < common.length; i++)data.common.push({
            lineHeight: parseInt(common[i].getAttribute("lineHeight"), 10)
        });
        for(let i = 0; i < page.length; i++)data.page.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        for(let i = 0; i < char.length; i++){
            const letter = char[i];
            data.char.push({
                id: parseInt(letter.getAttribute("id"), 10),
                page: parseInt(letter.getAttribute("page"), 10) || 0,
                x: parseInt(letter.getAttribute("x"), 10),
                y: parseInt(letter.getAttribute("y"), 10),
                width: parseInt(letter.getAttribute("width"), 10),
                height: parseInt(letter.getAttribute("height"), 10),
                xoffset: parseInt(letter.getAttribute("xoffset"), 10),
                yoffset: parseInt(letter.getAttribute("yoffset"), 10),
                xadvance: parseInt(letter.getAttribute("xadvance"), 10)
            });
        }
        for(let i = 0; i < kerning.length; i++)data.kerning.push({
            first: parseInt(kerning[i].getAttribute("first"), 10),
            second: parseInt(kerning[i].getAttribute("second"), 10),
            amount: parseInt(kerning[i].getAttribute("amount"), 10)
        });
        for(let i = 0; i < distanceField.length; i++)data.distanceField.push({
            fieldType: distanceField[i].getAttribute("fieldType"),
            distanceRange: parseInt(distanceField[i].getAttribute("distanceRange"), 10)
        });
        return data;
    }
}

});

parcelRegister("9EGm1", function(module, exports) {

$parcel$export(module.exports, "XMLStringFormat", () => $d0e7dc1b70c5e522$export$9322acbf234f5703);
parcelRequire("inflE");
var $16eqM = parcelRequire("16eqM");

var $83Oz4 = parcelRequire("83Oz4");
class $d0e7dc1b70c5e522$export$9322acbf234f5703 {
    /**
   * Check if resource refers to text xml font data.
   * @param data
   * @returns - True if resource could be treated as font data, false otherwise.
   */ static test(data) {
        return typeof data == "string" && data.includes("<font>") ? (0, $83Oz4.XMLFormat).test((0, $16eqM.settings).ADAPTER.parseXML(data)) : !1;
    }
    /**
   * Convert the text XML into BitmapFontData that we can use.
   * @param xmlTxt
   * @returns - Data to use for BitmapFont
   */ static parse(xmlTxt) {
        return (0, $83Oz4.XMLFormat).parse((0, $16eqM.settings).ADAPTER.parseXML(xmlTxt));
    }
}

});


parcelRegister("3WxPu", function(module, exports) {

var $amNc1 = parcelRequire("amNc1");

var $3e4fL = parcelRequire("3e4fL");

var $3j2OQ = parcelRequire("3j2OQ");

var $cBecy = parcelRequire("cBecy");

var $2c2Rr = parcelRequire("2c2Rr");

});
parcelRegister("amNc1", function(module, exports) {

$parcel$export(module.exports, "drawGlyph", () => $d39e7a070f556cbe$export$d41775f6694ba493);
parcelRequire("inflE");
var $1PNws = parcelRequire("1PNws");

var $3j2OQ = parcelRequire("3j2OQ");
function $d39e7a070f556cbe$export$d41775f6694ba493(canvas, context, metrics, x, y, resolution, style) {
    const char = metrics.text, fontProperties = metrics.fontProperties;
    context.translate(x, y), context.scale(resolution, resolution);
    const tx = style.strokeThickness / 2, ty = -(style.strokeThickness / 2);
    if (context.font = style.toFontString(), context.lineWidth = style.strokeThickness, context.textBaseline = style.textBaseline, context.lineJoin = style.lineJoin, context.miterLimit = style.miterLimit, context.fillStyle = (0, $3j2OQ.generateFillStyle)(canvas, context, style, resolution, [
        char
    ], metrics), context.strokeStyle = style.stroke, style.dropShadow) {
        const dropShadowColor = style.dropShadowColor, dropShadowBlur = style.dropShadowBlur * resolution, dropShadowDistance = style.dropShadowDistance * resolution;
        context.shadowColor = (0, $1PNws.Color).shared.setValue(dropShadowColor).setAlpha(style.dropShadowAlpha).toRgbaString(), context.shadowBlur = dropShadowBlur, context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance, context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance;
    } else context.shadowColor = "black", context.shadowBlur = 0, context.shadowOffsetX = 0, context.shadowOffsetY = 0;
    style.stroke && style.strokeThickness && context.strokeText(char, tx, ty + metrics.lineHeight - fontProperties.descent), style.fill && context.fillText(char, tx, ty + metrics.lineHeight - fontProperties.descent), context.setTransform(1, 0, 0, 1, 0, 0), context.fillStyle = "rgba(0, 0, 0, 0)";
}

});
parcelRegister("3j2OQ", function(module, exports) {

$parcel$export(module.exports, "generateFillStyle", () => $5fdf9fe3771f7673$export$f6a80096f20930c);
parcelRequire("3xGdr");
var $lxqYA = parcelRequire("lxqYA");
function $5fdf9fe3771f7673$export$f6a80096f20930c(canvas, context, style, resolution, lines, metrics) {
    const fillStyle = style.fill;
    if (Array.isArray(fillStyle)) {
        if (fillStyle.length === 1) return fillStyle[0];
    } else return fillStyle;
    let gradient;
    const dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0, padding = style.padding || 0, width = canvas.width / resolution - dropShadowCorrection - padding * 2, height = canvas.height / resolution - dropShadowCorrection - padding * 2, fill = fillStyle.slice(), fillGradientStops = style.fillGradientStops.slice();
    if (!fillGradientStops.length) {
        const lengthPlus1 = fill.length + 1;
        for(let i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
    }
    if (fill.unshift(fillStyle[0]), fillGradientStops.unshift(0), fill.push(fillStyle[fillStyle.length - 1]), fillGradientStops.push(1), style.fillGradientType === (0, $lxqYA.TEXT_GRADIENT).LINEAR_VERTICAL) {
        gradient = context.createLinearGradient(width / 2, padding, width / 2, height + padding);
        let lastIterationStop = 0;
        const gradStopLineHeight = (metrics.fontProperties.fontSize + style.strokeThickness) / height;
        for(let i = 0; i < lines.length; i++){
            const thisLineTop = metrics.lineHeight * i;
            for(let j = 0; j < fill.length; j++){
                let lineStop = 0;
                typeof fillGradientStops[j] == "number" ? lineStop = fillGradientStops[j] : lineStop = j / fill.length;
                const globalStop = thisLineTop / height + lineStop * gradStopLineHeight;
                let clampedStop = Math.max(lastIterationStop, globalStop);
                clampedStop = Math.min(clampedStop, 1), gradient.addColorStop(clampedStop, fill[j]), lastIterationStop = clampedStop;
            }
        }
    } else {
        gradient = context.createLinearGradient(padding, height / 2, width + padding, height / 2);
        const totalIterations = fill.length + 1;
        let currentIteration = 1;
        for(let i = 0; i < fill.length; i++){
            let stop;
            typeof fillGradientStops[i] == "number" ? stop = fillGradientStops[i] : stop = currentIteration / totalIterations, gradient.addColorStop(stop, fill[i]), currentIteration++;
        }
    }
    return gradient;
}

});


parcelRegister("3e4fL", function(module, exports) {

$parcel$export(module.exports, "extractCharCode", () => $a28181c76879c374$export$ee42a04f33018f4b);
function $a28181c76879c374$export$ee42a04f33018f4b(str) {
    return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
}

});

parcelRegister("cBecy", function(module, exports) {

$parcel$export(module.exports, "resolveCharacters", () => $0efb8d895299f556$export$221291e5031b03d8);

var $2c2Rr = parcelRequire("2c2Rr");
function $0efb8d895299f556$export$221291e5031b03d8(chars) {
    typeof chars == "string" && (chars = [
        chars
    ]);
    const result = [];
    for(let i = 0, j = chars.length; i < j; i++){
        const item = chars[i];
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${item.length}.`);
            const startCode = item[0].charCodeAt(0), endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error("[BitmapFont]: Invalid character range.");
            for(let i2 = startCode, j2 = endCode; i2 <= j2; i2++)result.push(String.fromCharCode(i2));
        } else result.push(...(0, $2c2Rr.splitTextToCharacters)(item));
    }
    if (result.length === 0) throw new Error("[BitmapFont]: Empty set when resolving characters.");
    return result;
}

});
parcelRegister("2c2Rr", function(module, exports) {

$parcel$export(module.exports, "splitTextToCharacters", () => $523bc67796b60bc3$export$b2c801ee49e0a334);
function $523bc67796b60bc3$export$b2c801ee49e0a334(text) {
    return Array.from ? Array.from(text) : text.split("");
}

});




parcelRegister("30oUb", function(module, exports) {

$parcel$export(module.exports, "BitmapText", () => $6e64abdaf6d4c15a$export$ae0da96467efdba0);
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $1PNws = parcelRequire("1PNws");
var $g9ac3 = parcelRequire("g9ac3");
var $gnwPx = parcelRequire("gnwPx");
var $k7n3P = parcelRequire("k7n3P");
var $16eqM = parcelRequire("16eqM");
var $cWOCu = parcelRequire("cWOCu");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("gD5uZ");
var $3IPo5 = parcelRequire("3IPo5");
parcelRequire("2m9sJ");
var $jlLhs = parcelRequire("jlLhs");
var $5GlKm = parcelRequire("5GlKm");
var $douVr = parcelRequire("douVr");

var $bAlM8 = parcelRequire("bAlM8");

var $fl5xh = parcelRequire("fl5xh");

var $fJT6l = parcelRequire("fJT6l");
parcelRequire("3WxPu");

var $2c2Rr = parcelRequire("2c2Rr");

var $3e4fL = parcelRequire("3e4fL");
const $6e64abdaf6d4c15a$var$pageMeshDataDefaultPageMeshData = [], $6e64abdaf6d4c15a$var$pageMeshDataMSDFPageMeshData = [], $6e64abdaf6d4c15a$var$charRenderDataPool = [], $6e64abdaf6d4c15a$var$_BitmapText = class _BitmapText2 extends (0, $3IPo5.Container) {
    /**
   * @param text - A string that you would like the text to display.
   * @param style - The style parameters.
   * @param {string} style.fontName - The installed BitmapFont name.
   * @param {number} [style.fontSize] - The size of the font in pixels, e.g. 24. If undefined,
   *.     this will default to the BitmapFont size.
   * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center', 'right' or 'justify'),
   *      does not affect single line text.
   * @param {PIXI.ColorSource} [style.tint=0xFFFFFF] - The tint color.
   * @param {number} [style.letterSpacing=0] - The amount of spacing between letters.
   * @param {number} [style.maxWidth=0] - The max width of the text before line wrapping.
   */ constructor(text, style = {}){
        super();
        const { align: align, tint: tint, maxWidth: maxWidth, letterSpacing: letterSpacing, fontName: fontName, fontSize: fontSize } = Object.assign({}, _BitmapText2.styleDefaults, style);
        if (!(0, $bAlM8.BitmapFont).available[fontName]) throw new Error(`Missing BitmapFont "${fontName}"`);
        this._activePagesMeshData = [], this._textWidth = 0, this._textHeight = 0, this._align = align, this._tintColor = new (0, $1PNws.Color)(tint), this._font = void 0, this._fontName = fontName, this._fontSize = fontSize, this.text = text, this._maxWidth = maxWidth, this._maxLineHeight = 0, this._letterSpacing = letterSpacing, this._anchor = new (0, $g9ac3.ObservablePoint)(()=>{
            this.dirty = !0;
        }, this, 0, 0), this._roundPixels = (0, $16eqM.settings).ROUND_PIXELS, this.dirty = !0, this._resolution = (0, $16eqM.settings).RESOLUTION, this._autoResolution = !0, this._textureCache = {};
    }
    /** Renders text and updates it when needed. This should only be called if the BitmapFont is regenerated. */ updateText() {
        const data = (0, $bAlM8.BitmapFont).available[this._fontName], fontSize = this.fontSize, scale = fontSize / data.size, pos = new (0, $gnwPx.Point)(), chars = [], lineWidths = [], lineSpaces = [], text = this._text.replace(/(?:\r\n|\r)/g, `
`) || " ", charsInput = (0, $2c2Rr.splitTextToCharacters)(text), maxWidth = this._maxWidth * data.size / fontSize, pageMeshDataPool = data.distanceFieldType === "none" ? $6e64abdaf6d4c15a$var$pageMeshDataDefaultPageMeshData : $6e64abdaf6d4c15a$var$pageMeshDataMSDFPageMeshData;
        let prevCharCode = null, lastLineWidth = 0, maxLineWidth = 0, line = 0, lastBreakPos = -1, lastBreakWidth = 0, spacesRemoved = 0, maxLineHeight = 0, spaceCount = 0;
        for(let i = 0; i < charsInput.length; i++){
            const char = charsInput[i], charCode = (0, $3e4fL.extractCharCode)(char);
            if (/(?:\s)/.test(char) && (lastBreakPos = i, lastBreakWidth = lastLineWidth, spaceCount++), char === "\r" || char === `
`) {
                lineWidths.push(lastLineWidth), lineSpaces.push(-1), maxLineWidth = Math.max(maxLineWidth, lastLineWidth), ++line, ++spacesRemoved, pos.x = 0, pos.y += data.lineHeight, prevCharCode = null, spaceCount = 0;
                continue;
            }
            const charData = data.chars[charCode];
            if (!charData) continue;
            prevCharCode && charData.kerning[prevCharCode] && (pos.x += charData.kerning[prevCharCode]);
            const charRenderData = $6e64abdaf6d4c15a$var$charRenderDataPool.pop() || {
                texture: (0, $cWOCu.Texture).EMPTY,
                line: 0,
                charCode: 0,
                prevSpaces: 0,
                position: new (0, $gnwPx.Point)()
            };
            charRenderData.texture = charData.texture, charRenderData.line = line, charRenderData.charCode = charCode, charRenderData.position.x = Math.round(pos.x + charData.xOffset + this._letterSpacing / 2), charRenderData.position.y = Math.round(pos.y + charData.yOffset), charRenderData.prevSpaces = spaceCount, chars.push(charRenderData), lastLineWidth = charRenderData.position.x + Math.max(charData.xAdvance - charData.xOffset, charData.texture.orig.width), pos.x += charData.xAdvance + this._letterSpacing, maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height), prevCharCode = charCode, lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth && (++spacesRemoved, (0, $lFGyw).removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos), i = lastBreakPos, lastBreakPos = -1, lineWidths.push(lastBreakWidth), lineSpaces.push(chars.length > 0 ? chars[chars.length - 1].prevSpaces : 0), maxLineWidth = Math.max(maxLineWidth, lastBreakWidth), line++, pos.x = 0, pos.y += data.lineHeight, prevCharCode = null, spaceCount = 0);
        }
        const lastChar = charsInput[charsInput.length - 1];
        lastChar !== "\r" && lastChar !== `
` && (/(?:\s)/.test(lastChar) && (lastLineWidth = lastBreakWidth), lineWidths.push(lastLineWidth), maxLineWidth = Math.max(maxLineWidth, lastLineWidth), lineSpaces.push(-1));
        const lineAlignOffsets = [];
        for(let i = 0; i <= line; i++){
            let alignOffset = 0;
            this._align === "right" ? alignOffset = maxLineWidth - lineWidths[i] : this._align === "center" ? alignOffset = (maxLineWidth - lineWidths[i]) / 2 : this._align === "justify" && (alignOffset = lineSpaces[i] < 0 ? 0 : (maxLineWidth - lineWidths[i]) / lineSpaces[i]), lineAlignOffsets.push(alignOffset);
        }
        const lenChars = chars.length, pagesMeshData = {}, newPagesMeshData = [], activePagesMeshData = this._activePagesMeshData;
        pageMeshDataPool.push(...activePagesMeshData);
        for(let i = 0; i < lenChars; i++){
            const texture = chars[i].texture, baseTextureUid = texture.baseTexture.uid;
            if (!pagesMeshData[baseTextureUid]) {
                let pageMeshData = pageMeshDataPool.pop();
                if (!pageMeshData) {
                    const geometry = new (0, $5GlKm.MeshGeometry)();
                    let material, meshBlendMode;
                    data.distanceFieldType === "none" ? (material = new (0, $douVr.MeshMaterial)((0, $cWOCu.Texture).EMPTY), meshBlendMode = (0, $lmRm8.BLEND_MODES).NORMAL) : (material = new (0, $douVr.MeshMaterial)((0, $cWOCu.Texture).EMPTY, {
                        program: (0, $k7n3P.Program).from((0, $fJT6l.default), (0, $fl5xh.default)),
                        uniforms: {
                            uFWidth: 0
                        }
                    }), meshBlendMode = (0, $lmRm8.BLEND_MODES).NORMAL_NPM);
                    const mesh = new (0, $jlLhs.Mesh)(geometry, material);
                    mesh.blendMode = meshBlendMode, pageMeshData = {
                        index: 0,
                        indexCount: 0,
                        vertexCount: 0,
                        uvsCount: 0,
                        total: 0,
                        mesh: mesh,
                        vertices: null,
                        uvs: null,
                        indices: null
                    };
                }
                pageMeshData.index = 0, pageMeshData.indexCount = 0, pageMeshData.vertexCount = 0, pageMeshData.uvsCount = 0, pageMeshData.total = 0;
                const { _textureCache: _textureCache } = this;
                _textureCache[baseTextureUid] = _textureCache[baseTextureUid] || new (0, $cWOCu.Texture)(texture.baseTexture), pageMeshData.mesh.texture = _textureCache[baseTextureUid], pageMeshData.mesh.tint = this._tintColor.value, newPagesMeshData.push(pageMeshData), pagesMeshData[baseTextureUid] = pageMeshData;
            }
            pagesMeshData[baseTextureUid].total++;
        }
        for(let i = 0; i < activePagesMeshData.length; i++)newPagesMeshData.includes(activePagesMeshData[i]) || this.removeChild(activePagesMeshData[i].mesh);
        for(let i = 0; i < newPagesMeshData.length; i++)newPagesMeshData[i].mesh.parent !== this && this.addChild(newPagesMeshData[i].mesh);
        this._activePagesMeshData = newPagesMeshData;
        for(const i in pagesMeshData){
            const pageMeshData = pagesMeshData[i], total = pageMeshData.total;
            if (!(pageMeshData.indices?.length > 6 * total) || pageMeshData.vertices.length < (0, $jlLhs.Mesh).BATCHABLE_SIZE * 2) pageMeshData.vertices = new Float32Array(8 * total), pageMeshData.uvs = new Float32Array(8 * total), pageMeshData.indices = new Uint16Array(6 * total);
            else {
                const total2 = pageMeshData.total, vertices = pageMeshData.vertices;
                for(let i2 = total2 * 8; i2 < vertices.length; i2++)vertices[i2] = 0;
            }
            pageMeshData.mesh.size = 6 * total;
        }
        for(let i = 0; i < lenChars; i++){
            const char = chars[i];
            let offset = char.position.x + lineAlignOffsets[char.line] * (this._align === "justify" ? char.prevSpaces : 1);
            this._roundPixels && (offset = Math.round(offset));
            const xPos = offset * scale, yPos = char.position.y * scale, texture = char.texture, pageMesh = pagesMeshData[texture.baseTexture.uid], textureFrame = texture.frame, textureUvs = texture._uvs, index = pageMesh.index++;
            pageMesh.indices[index * 6 + 0] = 0 + index * 4, pageMesh.indices[index * 6 + 1] = 1 + index * 4, pageMesh.indices[index * 6 + 2] = 2 + index * 4, pageMesh.indices[index * 6 + 3] = 0 + index * 4, pageMesh.indices[index * 6 + 4] = 2 + index * 4, pageMesh.indices[index * 6 + 5] = 3 + index * 4, pageMesh.vertices[index * 8 + 0] = xPos, pageMesh.vertices[index * 8 + 1] = yPos, pageMesh.vertices[index * 8 + 2] = xPos + textureFrame.width * scale, pageMesh.vertices[index * 8 + 3] = yPos, pageMesh.vertices[index * 8 + 4] = xPos + textureFrame.width * scale, pageMesh.vertices[index * 8 + 5] = yPos + textureFrame.height * scale, pageMesh.vertices[index * 8 + 6] = xPos, pageMesh.vertices[index * 8 + 7] = yPos + textureFrame.height * scale, pageMesh.uvs[index * 8 + 0] = textureUvs.x0, pageMesh.uvs[index * 8 + 1] = textureUvs.y0, pageMesh.uvs[index * 8 + 2] = textureUvs.x1, pageMesh.uvs[index * 8 + 3] = textureUvs.y1, pageMesh.uvs[index * 8 + 4] = textureUvs.x2, pageMesh.uvs[index * 8 + 5] = textureUvs.y2, pageMesh.uvs[index * 8 + 6] = textureUvs.x3, pageMesh.uvs[index * 8 + 7] = textureUvs.y3;
        }
        this._textWidth = maxLineWidth * scale, this._textHeight = (pos.y + data.lineHeight) * scale;
        for(const i in pagesMeshData){
            const pageMeshData = pagesMeshData[i];
            if (this.anchor.x !== 0 || this.anchor.y !== 0) {
                let vertexCount = 0;
                const anchorOffsetX = this._textWidth * this.anchor.x, anchorOffsetY = this._textHeight * this.anchor.y;
                for(let i2 = 0; i2 < pageMeshData.total; i2++)pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY, pageMeshData.vertices[vertexCount++] -= anchorOffsetX, pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
            }
            this._maxLineHeight = maxLineHeight * scale;
            const vertexBuffer = pageMeshData.mesh.geometry.getBuffer("aVertexPosition"), textureBuffer = pageMeshData.mesh.geometry.getBuffer("aTextureCoord"), indexBuffer = pageMeshData.mesh.geometry.getIndex();
            vertexBuffer.data = pageMeshData.vertices, textureBuffer.data = pageMeshData.uvs, indexBuffer.data = pageMeshData.indices, vertexBuffer.update(), textureBuffer.update(), indexBuffer.update();
        }
        for(let i = 0; i < chars.length; i++)$6e64abdaf6d4c15a$var$charRenderDataPool.push(chars[i]);
        this._font = data, this.dirty = !1;
    }
    updateTransform() {
        this.validate(), this.containerUpdateTransform();
    }
    _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0);
        const { distanceFieldRange: distanceFieldRange, distanceFieldType: distanceFieldType, size: size } = (0, $bAlM8.BitmapFont).available[this._fontName];
        if (distanceFieldType !== "none") {
            const { a: a, b: b, c: c, d: d } = this.worldTransform, dx = Math.sqrt(a * a + b * b), dy = Math.sqrt(c * c + d * d), worldScale = (Math.abs(dx) + Math.abs(dy)) / 2, fontScale = this.fontSize / size, resolution = renderer._view.resolution;
            for (const mesh of this._activePagesMeshData)mesh.mesh.shader.uniforms.uFWidth = worldScale * distanceFieldRange * fontScale * resolution;
        }
        super._render(renderer);
    }
    /**
   * Validates text before calling parent's getLocalBounds
   * @returns - The rectangular bounding area
   */ getLocalBounds() {
        return this.validate(), super.getLocalBounds();
    }
    /**
   * Updates text when needed
   * @private
   */ validate() {
        const font = (0, $bAlM8.BitmapFont).available[this._fontName];
        if (!font) throw new Error(`Missing BitmapFont "${this._fontName}"`);
        this._font !== font && (this.dirty = !0), this.dirty && this.updateText();
    }
    /**
   * The tint of the BitmapText object.
   * @default 0xffffff
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        if (this.tint !== value) {
            this._tintColor.setValue(value);
            for(let i = 0; i < this._activePagesMeshData.length; i++)this._activePagesMeshData[i].mesh.tint = value;
        }
    }
    /**
   * The alignment of the BitmapText object.
   * @member {string}
   * @default 'left'
   */ get align() {
        return this._align;
    }
    set align(value) {
        this._align !== value && (this._align = value, this.dirty = !0);
    }
    /** The name of the BitmapFont. */ get fontName() {
        return this._fontName;
    }
    set fontName(value) {
        if (!(0, $bAlM8.BitmapFont).available[value]) throw new Error(`Missing BitmapFont "${value}"`);
        this._fontName !== value && (this._fontName = value, this.dirty = !0);
    }
    /** The size of the font to display. */ get fontSize() {
        return this._fontSize ?? (0, $bAlM8.BitmapFont).available[this._fontName].size;
    }
    set fontSize(value) {
        this._fontSize !== value && (this._fontSize = value, this.dirty = !0);
    }
    /**
   * The anchor sets the origin point of the text.
   *
   * The default is `(0,0)`, this means the text's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value == "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /** The text of the BitmapText object. */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text ?? ""), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The max width of this bitmap text in pixels. If the text provided is longer than the
   * value provided, line breaks will be automatically inserted in the last whitespace.
   * Disable by setting the value to 0.
   */ get maxWidth() {
        return this._maxWidth;
    }
    set maxWidth(value) {
        this._maxWidth !== value && (this._maxWidth = value, this.dirty = !0);
    }
    /**
   * The max line height. This is useful when trying to use the total height of the Text,
   * i.e. when trying to vertically align.
   * @readonly
   */ get maxLineHeight() {
        return this.validate(), this._maxLineHeight;
    }
    /**
   * The width of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */ get textWidth() {
        return this.validate(), this._textWidth;
    }
    /** Additional space between characters. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        this._letterSpacing !== value && (this._letterSpacing = value, this.dirty = !0);
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default PIXI.settings.ROUND_PIXELS
   */ get roundPixels() {
        return this._roundPixels;
    }
    set roundPixels(value) {
        value !== this._roundPixels && (this._roundPixels = value, this.dirty = !0);
    }
    /**
   * The height of the overall text, different from fontSize,
   * which is defined in the style object.
   * @readonly
   */ get textHeight() {
        return this.validate(), this._textHeight;
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   *
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
    destroy(options) {
        const { _textureCache: _textureCache } = this, pageMeshDataPool = (0, $bAlM8.BitmapFont).available[this._fontName].distanceFieldType === "none" ? $6e64abdaf6d4c15a$var$pageMeshDataDefaultPageMeshData : $6e64abdaf6d4c15a$var$pageMeshDataMSDFPageMeshData;
        pageMeshDataPool.push(...this._activePagesMeshData);
        for (const pageMeshData of this._activePagesMeshData)this.removeChild(pageMeshData.mesh);
        this._activePagesMeshData = [], pageMeshDataPool.filter((page)=>_textureCache[page.mesh.texture.baseTexture.uid]).forEach((page)=>{
            page.mesh.texture = (0, $cWOCu.Texture).EMPTY;
        });
        for(const id in _textureCache)_textureCache[id].destroy(), delete _textureCache[id];
        this._font = null, this._tintColor = null, this._textureCache = null, super.destroy(options);
    }
};
$6e64abdaf6d4c15a$var$_BitmapText.styleDefaults = {
    align: "left",
    tint: 16777215,
    maxWidth: 0,
    letterSpacing: 0
};
let $6e64abdaf6d4c15a$export$ae0da96467efdba0 = $6e64abdaf6d4c15a$var$_BitmapText;

});
parcelRegister("2m9sJ", function(module, exports) {

$parcel$export(module.exports, "Mesh", () => (parcelRequire("jlLhs")).Mesh);
$parcel$export(module.exports, "MeshGeometry", () => (parcelRequire("5GlKm")).MeshGeometry);
$parcel$export(module.exports, "MeshMaterial", () => (parcelRequire("douVr")).MeshMaterial);

var $jlLhs = parcelRequire("jlLhs");

var $3JP9W = parcelRequire("3JP9W");

var $5GlKm = parcelRequire("5GlKm");

var $douVr = parcelRequire("douVr");

});
parcelRegister("jlLhs", function(module, exports) {

$parcel$export(module.exports, "Mesh", () => $568baf8681eacf07$export$e176487c05830cc5);
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $gnwPx = parcelRequire("gnwPx");
var $duPDq = parcelRequire("duPDq");
var $16eqM = parcelRequire("16eqM");
var $bUqaG = parcelRequire("bUqaG");
parcelRequire("gD5uZ");
var $3IPo5 = parcelRequire("3IPo5");

var $3JP9W = parcelRequire("3JP9W");
const $568baf8681eacf07$var$tempPoint = new (0, $gnwPx.Point)(), $568baf8681eacf07$var$tempPolygon = new (0, $duPDq.Polygon)(), $568baf8681eacf07$var$_Mesh = class _Mesh2 extends (0, $3IPo5.Container) {
    /**
   * @param geometry - The geometry the mesh will use.
   * @param {PIXI.MeshMaterial} shader - The shader the mesh will use.
   * @param state - The state that the WebGL context is required to be in to render the mesh
   *        if no state is provided, uses {@link PIXI.State.for2d} to create a 2D state for PixiJS.
   * @param drawMode - The drawMode, can be any of the {@link PIXI.DRAW_MODES} constants.
   */ constructor(geometry, shader, state, drawMode = (0, $lmRm8.DRAW_MODES).TRIANGLES){
        super(), this.geometry = geometry, this.shader = shader, this.state = state || (0, $bUqaG.State).for2d(), this.drawMode = drawMode, this.start = 0, this.size = 0, this.uvs = null, this.indices = null, this.vertexData = new Float32Array(1), this.vertexDirty = -1, this._transformID = -1, this._roundPixels = (0, $16eqM.settings).ROUND_PIXELS, this.batchUvs = null;
    }
    /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh objects.
   */ get geometry() {
        return this._geometry;
    }
    set geometry(value) {
        this._geometry !== value && (this._geometry && (this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose()), this._geometry = value, this._geometry && this._geometry.refCount++, this.vertexDirty = -1);
    }
    /**
   * To change mesh uv's, change its uvBuffer data and increment its _updateID.
   * @readonly
   */ get uvBuffer() {
        return this.geometry.buffers[1];
    }
    /**
   * To change mesh vertices, change its uvBuffer data and increment its _updateID.
   * Incrementing _updateID is optional because most of Mesh objects do it anyway.
   * @readonly
   */ get verticesBuffer() {
        return this.geometry.buffers[0];
    }
    /** Alias for {@link PIXI.Mesh#shader}. */ set material(value) {
        this.shader = value;
    }
    get material() {
        return this.shader;
    }
    /**
   * The blend mode to be applied to the Mesh. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
   * @default PIXI.BLEND_MODES.NORMAL;
   */ set blendMode(value) {
        this.state.blendMode = value;
    }
    get blendMode() {
        return this.state.blendMode;
    }
    /**
   * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
   * Advantages can include sharper image quality (like text) and faster rendering on canvas.
   * The main disadvantage is movement of objects may appear less smooth.
   * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
   * @default false
   */ set roundPixels(value) {
        this._roundPixels !== value && (this._transformID = -1), this._roundPixels = value;
    }
    get roundPixels() {
        return this._roundPixels;
    }
    /**
   * The multiply tint applied to the Mesh. This is a hex value. A value of
   * `0xFFFFFF` will remove any tint effect.
   *
   * Null for non-MeshMaterial shaders
   * @default 0xFFFFFF
   */ get tint() {
        return "tint" in this.shader ? this.shader.tint : null;
    }
    set tint(value) {
        this.shader.tint = value;
    }
    /**
   * The tint color as a RGB integer
   * @ignore
   */ get tintValue() {
        return this.shader.tintValue;
    }
    /** The texture that the Mesh uses. Null for non-MeshMaterial shaders */ get texture() {
        return "texture" in this.shader ? this.shader.texture : null;
    }
    set texture(value) {
        this.shader.texture = value;
    }
    /**
   * Standard renderer draw.
   * @param renderer - Instance to renderer.
   */ _render(renderer) {
        const vertices = this.geometry.buffers[0].data;
        this.shader.batchable && this.drawMode === (0, $lmRm8.DRAW_MODES).TRIANGLES && vertices.length < _Mesh2.BATCHABLE_SIZE * 2 ? this._renderToBatch(renderer) : this._renderDefault(renderer);
    }
    /**
   * Standard non-batching way of rendering.
   * @param renderer - Instance to renderer.
   */ _renderDefault(renderer) {
        const shader = this.shader;
        shader.alpha = this.worldAlpha, shader.update && shader.update(), renderer.batch.flush(), shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(!0), renderer.shader.bind(shader), renderer.state.set(this.state), renderer.geometry.bind(this.geometry, shader), renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
    }
    /**
   * Rendering by using the Batch system.
   * @param renderer - Instance to renderer.
   */ _renderToBatch(renderer) {
        const geometry = this.geometry, shader = this.shader;
        shader.uvMatrix && (shader.uvMatrix.update(), this.calculateUvs()), this.calculateVertices(), this.indices = geometry.indexBuffer.data, this._tintRGB = shader._tintRGB, this._texture = shader.texture;
        const pluginName = this.material.pluginName;
        renderer.batch.setObjectRenderer(renderer.plugins[pluginName]), renderer.plugins[pluginName].render(this);
    }
    /** Updates vertexData field based on transform and vertices. */ calculateVertices() {
        const verticesBuffer = this.geometry.buffers[0], vertices = verticesBuffer.data, vertexDirtyId = verticesBuffer._updateID;
        if (vertexDirtyId === this.vertexDirty && this._transformID === this.transform._worldID) return;
        this._transformID = this.transform._worldID, this.vertexData.length !== vertices.length && (this.vertexData = new Float32Array(vertices.length));
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, vertexData = this.vertexData;
        for(let i = 0; i < vertexData.length / 2; i++){
            const x = vertices[i * 2], y = vertices[i * 2 + 1];
            vertexData[i * 2] = a * x + c * y + tx, vertexData[i * 2 + 1] = b * x + d * y + ty;
        }
        if (this._roundPixels) {
            const resolution = (0, $16eqM.settings).RESOLUTION;
            for(let i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round(vertexData[i] * resolution) / resolution;
        }
        this.vertexDirty = vertexDirtyId;
    }
    /** Updates uv field based on from geometry uv's or batchUvs. */ calculateUvs() {
        const geomUvs = this.geometry.buffers[1], shader = this.shader;
        shader.uvMatrix.isSimple ? this.uvs = geomUvs.data : (this.batchUvs || (this.batchUvs = new (0, $3JP9W.MeshBatchUvs)(geomUvs, shader.uvMatrix)), this.batchUvs.update(), this.uvs = this.batchUvs.data);
    }
    /**
   * Updates the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
   * there must be a aVertexPosition attribute present in the geometry for bounds to be calculated correctly.
   */ _calculateBounds() {
        this.calculateVertices(), this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
    }
    /**
   * Tests if a point is inside this mesh. Works only for PIXI.DRAW_MODES.TRIANGLES.
   * @param point - The point to test.
   * @returns - The result of the test.
   */ containsPoint(point) {
        if (!this.getBounds().contains(point.x, point.y)) return !1;
        this.worldTransform.applyInverse(point, $568baf8681eacf07$var$tempPoint);
        const vertices = this.geometry.getBuffer("aVertexPosition").data, points = $568baf8681eacf07$var$tempPolygon.points, indices = this.geometry.getIndex().data, len = indices.length, step = this.drawMode === 4 ? 3 : 1;
        for(let i = 0; i + 2 < len; i += step){
            const ind0 = indices[i] * 2, ind1 = indices[i + 1] * 2, ind2 = indices[i + 2] * 2;
            if (points[0] = vertices[ind0], points[1] = vertices[ind0 + 1], points[2] = vertices[ind1], points[3] = vertices[ind1 + 1], points[4] = vertices[ind2], points[5] = vertices[ind2 + 1], $568baf8681eacf07$var$tempPolygon.contains($568baf8681eacf07$var$tempPoint.x, $568baf8681eacf07$var$tempPoint.y)) return !0;
        }
        return !1;
    }
    destroy(options) {
        super.destroy(options), this._cachedTexture && (this._cachedTexture.destroy(), this._cachedTexture = null), this.geometry = null, this.shader = null, this.state = null, this.uvs = null, this.indices = null, this.vertexData = null;
    }
};
$568baf8681eacf07$var$_Mesh.BATCHABLE_SIZE = 100;
let $568baf8681eacf07$export$e176487c05830cc5 = $568baf8681eacf07$var$_Mesh;

});
parcelRegister("3JP9W", function(module, exports) {

$parcel$export(module.exports, "MeshBatchUvs", () => $542b7ebdc02069ec$export$49cc356fa6ba0e7b);
class $542b7ebdc02069ec$export$49cc356fa6ba0e7b {
    /**
   * @param uvBuffer - Buffer with normalized uv's
   * @param uvMatrix - Material UV matrix
   */ constructor(uvBuffer, uvMatrix){
        this.uvBuffer = uvBuffer, this.uvMatrix = uvMatrix, this.data = null, this._bufferUpdateId = -1, this._textureUpdateId = -1, this._updateID = 0;
    }
    /**
   * Updates
   * @param forceUpdate - force the update
   */ update(forceUpdate) {
        if (!forceUpdate && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID) return;
        this._bufferUpdateId = this.uvBuffer._updateID, this._textureUpdateId = this.uvMatrix._updateID;
        const data = this.uvBuffer.data;
        (!this.data || this.data.length !== data.length) && (this.data = new Float32Array(data.length)), this.uvMatrix.multiplyUvs(data, this.data), this._updateID++;
    }
}

});


parcelRegister("5GlKm", function(module, exports) {

$parcel$export(module.exports, "MeshGeometry", () => $6a3195e011b88f16$export$8d075a36a73d54bc);
parcelRequire("inflE");
var $3u4Xc = parcelRequire("3u4Xc");
var $5K7Rq = parcelRequire("5K7Rq");
var $lmRm8 = parcelRequire("lmRm8");
class $6a3195e011b88f16$export$8d075a36a73d54bc extends (0, $5K7Rq.Geometry) {
    /**
   * @param {Float32Array|number[]} [vertices] - Positional data on geometry.
   * @param {Float32Array|number[]} [uvs] - Texture UVs.
   * @param {Uint16Array|number[]} [index] - IndexBuffer
   */ constructor(vertices, uvs, index){
        super();
        const verticesBuffer = new (0, $3u4Xc.Buffer)(vertices), uvsBuffer = new (0, $3u4Xc.Buffer)(uvs, !0), indexBuffer = new (0, $3u4Xc.Buffer)(index, !0, !0);
        this.addAttribute("aVertexPosition", verticesBuffer, 2, !1, (0, $lmRm8.TYPES).FLOAT).addAttribute("aTextureCoord", uvsBuffer, 2, !1, (0, $lmRm8.TYPES).FLOAT).addIndex(indexBuffer), this._updateId = -1;
    }
    /**
   * If the vertex position is updated.
   * @readonly
   * @private
   */ get vertexDirtyId() {
        return this.buffers[0]._updateID;
    }
}

});

parcelRegister("douVr", function(module, exports) {

$parcel$export(module.exports, "MeshMaterial", () => $dad6142c5ef6c8cb$export$d552dadfd66cc650);
parcelRequire("inflE");
var $1PNws = parcelRequire("1PNws");
var $6wJoy = parcelRequire("6wJoy");
var $k7n3P = parcelRequire("k7n3P");
var $2cKpP = parcelRequire("2cKpP");
var $aHJRR = parcelRequire("aHJRR");

var $36yLL = parcelRequire("36yLL");

var $kF27N = parcelRequire("kF27N");
class $dad6142c5ef6c8cb$export$d552dadfd66cc650 extends (0, $2cKpP.Shader) {
    /**
   * @param uSampler - Texture that material uses to render.
   * @param options - Additional options
   * @param {number} [options.alpha=1] - Default alpha.
   * @param {PIXI.ColorSource} [options.tint=0xFFFFFF] - Default tint.
   * @param {string} [options.pluginName='batch'] - Renderer plugin for batching.
   * @param {PIXI.Program} [options.program=0xFFFFFF] - Custom program.
   * @param {object} [options.uniforms] - Custom uniforms.
   */ constructor(uSampler, options){
        const uniforms = {
            uSampler: uSampler,
            alpha: 1,
            uTextureMatrix: (0, $6wJoy.Matrix).IDENTITY,
            uColor: new Float32Array([
                1,
                1,
                1,
                1
            ])
        };
        options = Object.assign({
            tint: 16777215,
            alpha: 1,
            pluginName: "batch"
        }, options), options.uniforms && Object.assign(uniforms, options.uniforms), super(options.program || (0, $k7n3P.Program).from((0, $kF27N.default), (0, $36yLL.default)), uniforms), this._colorDirty = !1, this.uvMatrix = new (0, $aHJRR.TextureMatrix)(uSampler), this.batchable = options.program === void 0, this.pluginName = options.pluginName, this._tintColor = new (0, $1PNws.Color)(options.tint), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0, this.alpha = options.alpha;
    }
    /** Reference to the texture being rendered. */ get texture() {
        return this.uniforms.uSampler;
    }
    set texture(value) {
        this.uniforms.uSampler !== value && (!this.uniforms.uSampler.baseTexture.alphaMode != !value.baseTexture.alphaMode && (this._colorDirty = !0), this.uniforms.uSampler = value, this.uvMatrix.texture = value);
    }
    /**
   * This gets automatically set by the object using this.
   * @default 1
   */ set alpha(value) {
        value !== this._alpha && (this._alpha = value, this._colorDirty = !0);
    }
    get alpha() {
        return this._alpha;
    }
    /**
   * Multiply tint for the material.
   * @default 0xFFFFFF
   */ set tint(value) {
        value !== this.tint && (this._tintColor.setValue(value), this._tintRGB = this._tintColor.toLittleEndianNumber(), this._colorDirty = !0);
    }
    get tint() {
        return this._tintColor.value;
    }
    /**
   * Get the internal number from tint color
   * @ignore
   */ get tintValue() {
        return this._tintColor.toNumber();
    }
    /** Gets called automatically by the Mesh. Intended to be overridden for custom {@link PIXI.MeshMaterial} objects. */ update() {
        if (this._colorDirty) {
            this._colorDirty = !1;
            const applyToChannels = this.texture.baseTexture.alphaMode;
            (0, $1PNws.Color).shared.setValue(this._tintColor).premultiply(this._alpha, applyToChannels).toArray(this.uniforms.uColor);
        }
        this.uvMatrix.update() && (this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord);
    }
}

});
parcelRegister("36yLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f34c86fd0bac1c1$export$2e2bcd8739ae039);
var $8f34c86fd0bac1c1$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
uniform vec4 uColor;

uniform sampler2D uSampler;

void main(void)
{
    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;
}
`;

});

parcelRegister("kF27N", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9d0a60543d898dc$export$2e2bcd8739ae039);
var $b9d0a60543d898dc$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTextureMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;
}
`;

});



parcelRegister("fl5xh", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c50cf773517999$export$2e2bcd8739ae039);
var $90c50cf773517999$export$2e2bcd8739ae039 = `// Pixi texture info\r
varying vec2 vTextureCoord;\r
uniform sampler2D uSampler;\r
\r
// Tint\r
uniform vec4 uColor;\r
\r
// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r
uniform float uFWidth;\r
\r
void main(void) {\r
\r
  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r
  vec4 texColor = texture2D(uSampler, vTextureCoord);\r
\r
  // MSDF\r
  float median = texColor.r + texColor.g + texColor.b -\r
                  min(texColor.r, min(texColor.g, texColor.b)) -\r
                  max(texColor.r, max(texColor.g, texColor.b));\r
  // SDF\r
  median = min(median, texColor.a);\r
\r
  float screenPxDistance = uFWidth * (median - 0.5);\r
  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r
  if (median < 0.01) {\r
    alpha = 0.0;\r
  } else if (median > 0.99) {\r
    alpha = 1.0;\r
  }\r
\r
  // Gamma correction for coverage-like alpha\r
  float luma = dot(uColor.rgb, vec3(0.299, 0.587, 0.114));\r
  float gamma = mix(1.0, 1.0 / 2.2, luma);\r
  float coverage = pow(uColor.a * alpha, gamma);  \r
\r
  // NPM Textures, NPM outputs\r
  gl_FragColor = vec4(uColor.rgb, coverage);\r
}\r
`;

});

parcelRegister("fJT6l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69fc031789e656d$export$2e2bcd8739ae039);
var $a69fc031789e656d$export$2e2bcd8739ae039 = `// Mesh material default fragment\r
attribute vec2 aVertexPosition;\r
attribute vec2 aTextureCoord;\r
\r
uniform mat3 projectionMatrix;\r
uniform mat3 translationMatrix;\r
uniform mat3 uTextureMatrix;\r
\r
varying vec2 vTextureCoord;\r
\r
void main(void)\r
{\r
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r
\r
    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r
}\r
`;

});


parcelRegister("kO4NZ", function(module, exports) {

});

parcelRegister("90VnE", function(module, exports) {
parcelRequire("ew1SP");
var $6i6zf = parcelRequire("6i6zf");
var $h0Gbc = parcelRequire("h0Gbc");
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");

var $bAlM8 = parcelRequire("bAlM8");
parcelRequire("8HicO");

var $46hKQ = parcelRequire("46hKQ");

var $9EGm1 = parcelRequire("9EGm1");
const $1d74f06b3531e0d3$var$validExtensions = [
    ".xml",
    ".fnt"
], $1d74f06b3531e0d3$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).Normal
    },
    name: "loadBitmapFont",
    test (url) {
        return $1d74f06b3531e0d3$var$validExtensions.includes((0, $lFGyw).path.extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $46hKQ.TextFormat).test(data) || (0, $9EGm1.XMLStringFormat).test(data);
    },
    async parse (asset, data, loader) {
        const fontData = (0, $46hKQ.TextFormat).test(asset) ? (0, $46hKQ.TextFormat).parse(asset) : (0, $9EGm1.XMLStringFormat).parse(asset), { src: src } = data, { page: pages } = fontData, textureUrls = [];
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $lFGyw).path.join((0, $lFGyw).path.dirname(src), pageFile);
            imagePath = (0, $6i6zf.copySearchParams)(imagePath, src), textureUrls.push(imagePath);
        }
        const loadedTextures = await loader.load(textureUrls), textures = textureUrls.map((url)=>loadedTextures[url]);
        return (0, $bAlM8.BitmapFont).install(fontData, textures, !0);
    },
    async load (url, _options) {
        return (await (0, $16eqM.settings).ADAPTER.fetch(url)).text();
    },
    unload (bitmapFont) {
        bitmapFont.destroy();
    }
};
(0, $5RvHb.extensions).add($1d74f06b3531e0d3$export$402edee29ac8bed4);

});
parcelRegister("ew1SP", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => (parcelRequire("h0Gbc")).LoaderParserPriority);
$parcel$export(module.exports, "checkExtension", () => (parcelRequire("fzibG")).checkExtension);
$parcel$export(module.exports, "copySearchParams", () => (parcelRequire("6i6zf")).copySearchParams);
$parcel$export(module.exports, "createTexture", () => (parcelRequire("8ZIRW")).createTexture);
parcelRequire("hDpkk");

var $i4Ght = parcelRequire("i4Ght");
parcelRequire("6oiva");
parcelRequire("6sBTk");
parcelRequire("eCDTl");
parcelRequire("bYx2s");
parcelRequire("7a41k");
parcelRequire("9ATPb");

var $41Jbo = parcelRequire("41Jbo");

var $iOkDF = parcelRequire("iOkDF");

var $c2Jcb = parcelRequire("c2Jcb");

var $cFAYk = parcelRequire("cFAYk");

var $ieeFl = parcelRequire("ieeFl");

var $bTeVW = parcelRequire("bTeVW");

var $dxOlk = parcelRequire("dxOlk");

var $cLHT9 = parcelRequire("cLHT9");

var $h0Gbc = parcelRequire("h0Gbc");

var $eilHB = parcelRequire("eilHB");

var $80Cqa = parcelRequire("80Cqa");

var $7pjiA = parcelRequire("7pjiA");

var $1lCB6 = parcelRequire("1lCB6");

var $eZn9W = parcelRequire("eZn9W");

var $jnoXR = parcelRequire("jnoXR");

var $8ZIRW = parcelRequire("8ZIRW");

var $kbE9F = parcelRequire("kbE9F");

var $6MbeN = parcelRequire("6MbeN");

var $fzibG = parcelRequire("fzibG");

var $gXnIg = parcelRequire("gXnIg");

var $6i6zf = parcelRequire("6i6zf");

var $2MZtt = parcelRequire("2MZtt");

var $fU0Ub = parcelRequire("fU0Ub");

});
parcelRegister("hDpkk", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
const $aee7f73704b4a19b$var$assetKeyMap = {
    loader: (0, $5RvHb.ExtensionType).LoadParser,
    resolver: (0, $5RvHb.ExtensionType).ResolveParser,
    cache: (0, $5RvHb.ExtensionType).CacheParser,
    detection: (0, $5RvHb.ExtensionType).DetectionParser
};
(0, $5RvHb.extensions).handle((0, $5RvHb.ExtensionType).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($aee7f73704b4a19b$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $5RvHb.extensions).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($aee7f73704b4a19b$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $5RvHb.extensions).remove(ref[key]));
});

});

parcelRegister("i4Ght", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $lFGyw = parcelRequire("lFGyw");

var $7xoRX = parcelRequire("7xoRX");

var $41Jbo = parcelRequire("41Jbo");

var $7CTOO = parcelRequire("7CTOO");
parcelRequire("eGvCE");

var $9vh3f = parcelRequire("9vh3f");

var $gXnIg = parcelRequire("gXnIg");

var $fU0Ub = parcelRequire("fU0Ub");

var $eZn9W = parcelRequire("eZn9W");
class $fff9e028a285d5fa$export$137d4dd907afac85 {
    constructor(){
        this._detections = [], this._initialized = !1, this.resolver = new (0, $9vh3f.Resolver)(), this.loader = new (0, $7CTOO.Loader)(), this.cache = (0, $41Jbo.Cache), this._backgroundLoader = new (0, $7xoRX.BackgroundLoader)(this.loader), this._backgroundLoader.active = !0, this.reset();
    }
    /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Asset class to work, only if you want to set any initial properties
   * @param options - options to initialize the Asset manager with
   */ async init(options = {}) {
        if (this._initialized) {
            console.warn("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
            return;
        }
        if (this._initialized = !0, options.defaultSearchParams && this.resolver.setDefaultSearchParams(options.defaultSearchParams), options.basePath && (this.resolver.basePath = options.basePath), options.bundleIdentifier && this.resolver.setBundleIdentifier(options.bundleIdentifier), options.manifest) {
            let manifest = options.manifest;
            typeof manifest == "string" && (manifest = await this.load(manifest)), this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1, resolution = typeof resolutionPref == "number" ? [
            resolutionPref
        ] : resolutionPref, formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        }), options.preferences && this.setPreferences(options.preferences);
    }
    add(aliases, srcs, data, format, loadParser) {
        this.resolver.add(aliases, srcs, data, format, loadParser);
    }
    async load(urls, onProgress) {
        this._initialized || await this.init();
        const singleAsset = (0, $fU0Ub.isSingleItem)(urls), urlArray = (0, $gXnIg.convertToList)(urls).map((url)=>{
            if (typeof url != "string") {
                const aliases = this.resolver.getAlias(url);
                return aliases.some((alias)=>!this.resolver.hasKey(alias)) && this.add(url), Array.isArray(aliases) ? aliases[0] : aliases;
            }
            return this.resolver.hasKey(url) || this.add({
                alias: url,
                src: url
            }), url;
        }), resolveResults = this.resolver.resolve(urlArray), out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Assets.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */ async loadBundle(bundleIds, onProgress) {
        this._initialized || await this.init();
        let singleAsset = !1;
        typeof bundleIds == "string" && (singleAsset = !0, bundleIds = [
            bundleIds
        ]);
        const resolveResults = this.resolver.resolveBundle(bundleIds), out = {}, keys = Object.keys(resolveResults);
        let count = 0, total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        }, promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            return total += Object.keys(resolveResult).length, this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        return await Promise.all(promises), singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your inital load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */ async backgroundLoad(urls) {
        this._initialized || await this.init(), typeof urls == "string" && (urls = [
            urls
        ]);
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */ async backgroundLoadBundle(bundleIds) {
        this._initialized || await this.init(), typeof bundleIds == "string" && (bundleIds = [
            bundleIds
        ]);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */ reset() {
        this.resolver.reset(), this.loader.reset(), this.cache.reset(), this._initialized = !1;
    }
    get(keys) {
        if (typeof keys == "string") return (0, $41Jbo.Cache).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $41Jbo.Cache).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */ async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = Object.values(resolveResults), resolveKeys = Object.keys(resolveResults);
        this._backgroundLoader.active = !1;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = !0;
        const out = {};
        return resolveArray.forEach((resolveResult, i)=>{
            const asset = loadedAssets[resolveResult.src], keys = [
                resolveResult.src
            ];
            resolveResult.alias && keys.push(...resolveResult.alias), out[resolveKeys[i]] = asset, (0, $41Jbo.Cache).set(keys, asset);
        }), out;
    }
    /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */ async unload(urls) {
        this._initialized || await this.init();
        const urlArray = (0, $gXnIg.convertToList)(urls).map((url)=>typeof url != "string" ? url.src : url), resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */ async unloadBundle(bundleIds) {
        this._initialized || await this.init(), bundleIds = (0, $gXnIg.convertToList)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds), promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $41Jbo.Cache).remove(resolveResult2.src);
        }), await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        options.preferredFormats && (formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ]);
        for (const detection of options.detections)options.skipDetections || await detection.test() ? formats = await detection.add(formats) : options.skipDetections || (formats = await detection.remove(formats));
        return formats = formats.filter((format, index)=>formats.indexOf(format) === index), formats;
    }
    /** All the detection parsers currently added to the Assets class. */ get detections() {
        return this._detections;
    }
    /**
   * @deprecated since 7.2.0
   * @see {@link Assets.setPreferences}
   */ get preferWorkers() {
        return (0, $eZn9W.loadTextures).config.preferWorkers;
    }
    set preferWorkers(value) {
        (0, $lFGyw).deprecation("7.2.0", "Assets.prefersWorkers is deprecated, use Assets.setPreferences({ preferWorkers: true }) instead."), this.setPreferences({
            preferWorkers: value
        });
    }
    /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            parser.config && Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $fff9e028a285d5fa$export$c8eca95e306f7116 = new $fff9e028a285d5fa$export$137d4dd907afac85();
(0, $5RvHb.extensions).handleByList((0, $5RvHb.ExtensionType).LoadParser, $fff9e028a285d5fa$export$c8eca95e306f7116.loader.parsers).handleByList((0, $5RvHb.ExtensionType).ResolveParser, $fff9e028a285d5fa$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $5RvHb.ExtensionType).CacheParser, $fff9e028a285d5fa$export$c8eca95e306f7116.cache.parsers).handleByList((0, $5RvHb.ExtensionType).DetectionParser, $fff9e028a285d5fa$export$c8eca95e306f7116.detections);

});
parcelRegister("7xoRX", function(module, exports) {

$parcel$export(module.exports, "BackgroundLoader", () => $03657013a007ba43$export$1949379a83b843d5);
class $03657013a007ba43$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = !1){
        this._loader = loader, this._assetList = [], this._isLoading = !1, this._maxConcurrent = 1, this.verbose = verbose;
    }
    /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        }), this.verbose && console.log("[BackgroundLoader] assets: ", this._assetList), this._isActive && !this._isLoading && this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = !0;
            const toLoad = [], toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad), this._isLoading = !1, this._next();
        }
    }
    /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        this._isActive !== value && (this._isActive = value, value && !this._isLoading && this._next());
    }
}

});

parcelRegister("41Jbo", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $ebbad49d08847d0d$export$94affb487e701bf2);
parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $cWOCu = parcelRequire("cWOCu");
parcelRequire("9ATPb");

var $gXnIg = parcelRequire("gXnIg");
class $ebbad49d08847d0d$var$CacheClass {
    constructor(){
        this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear(), this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        return result || console.warn(`[Assets] Asset id ${key} was not found in the Cache`), result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $gXnIg.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        cacheableAssets || (cacheableAssets = {}, keys.forEach((key2)=>{
            cacheableAssets[key2] = value;
        }));
        const cacheKeys = Object.keys(cacheableAssets), cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        if (keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        }), cacheKeys.forEach((key2)=>{
            this._cache.has(key2) && this._cache.get(key2) !== value && console.warn("[Cache] already has key:", key2), this._cache.set(key2, cacheableAssets[key2]);
        }), value instanceof (0, $cWOCu.Texture)) {
            const texture = value;
            keys.forEach((key2)=>{
                texture.baseTexture !== (0, $cWOCu.Texture).EMPTY.baseTexture && (0, $4oWO8.BaseTexture).addToCache(texture.baseTexture, key2), (0, $cWOCu.Texture).addToCache(texture, key2);
            });
        }
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            console.warn(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        cacheMap.cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        }), cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /** All loader parsers registered */ get parsers() {
        return this._parsers;
    }
}
const $ebbad49d08847d0d$export$94affb487e701bf2 = new $ebbad49d08847d0d$var$CacheClass();

});
parcelRegister("9ATPb", function(module, exports) {

var $6MbeN = parcelRequire("6MbeN");

var $fzibG = parcelRequire("fzibG");

var $gXnIg = parcelRequire("gXnIg");

var $6i6zf = parcelRequire("6i6zf");

var $2MZtt = parcelRequire("2MZtt");

var $fU0Ub = parcelRequire("fU0Ub");

});
parcelRegister("6MbeN", function(module, exports) {

$parcel$export(module.exports, "checkDataUrl", () => $01f89dbef8de9e38$export$7ff8b059fb914323);
function $01f89dbef8de9e38$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes)if (url.startsWith(`data:${mime}`)) return !0;
        return !1;
    }
    return url.startsWith(`data:${mimes}`);
}

});

parcelRegister("fzibG", function(module, exports) {

$parcel$export(module.exports, "checkExtension", () => $ff6950007d6649ba$export$fd0180357b95b812);
parcelRequire("inflE");
var $lFGyw = parcelRequire("lFGyw");
function $ff6950007d6649ba$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0], ext = (0, $lFGyw).path.extname(tempURL).toLowerCase();
    return Array.isArray(extension) ? extension.includes(ext) : ext === extension;
}

});

parcelRegister("gXnIg", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $b425d552371a586b$export$b01be8e180bf3d9b);
const $b425d552371a586b$export$b01be8e180bf3d9b = (input, transform, forceTransform = !1)=>(Array.isArray(input) || (input = [
        input
    ]), transform ? input.map((item)=>typeof item == "string" || forceTransform ? transform(item) : item) : input);

});

parcelRegister("6i6zf", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $2636f2efcd018458$export$f57b97ef8be10dda);
const $2636f2efcd018458$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    return searchParams && (targetUrl += `?${searchParams}`), targetUrl;
};

});

parcelRegister("2MZtt", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $aa3b11c502ba406c$export$738117acc6638004);
function $aa3b11c502ba406c$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        depth < ids.length - 1 ? $aa3b11c502ba406c$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags) : tags.push(base.replace(result[depth], value));
    }
}
function $aa3b11c502ba406c$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g, result = string.match(regex), tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        }), $aa3b11c502ba406c$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("fU0Ub", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $84f3227467e1a576$export$16a80d27953452d4);
const $84f3227467e1a576$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});



parcelRegister("7CTOO", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $d079125e54a74d6d$export$3b0d6d7590275603);
parcelRequire("inflE");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("9ATPb");

var $fU0Ub = parcelRequire("fU0Ub");

var $gXnIg = parcelRequire("gXnIg");
class $d079125e54a74d6d$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [], this._parsersValidated = !1, this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>(this._parsersValidated = !1, target[key] = value, !0)
        }), this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = !1, this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        return result.promise = (async ()=>{
            let asset = null, parser = null;
            if (data.loadParser && (parser = this._parserHash[data.loadParser], parser || console.warn(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`)), !parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) return console.warn(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`), null;
            }
            asset = await parser.load(url, data, this), result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                parser2.parse && parser2.parse && await parser2.testParse?.(asset, data, this) && (asset = await parser2.parse(asset, data, this) || asset, result.parser = parser2);
            }
            return asset;
        })(), result;
    }
    async load(assetsToLoadIn, onProgress) {
        this._parsersValidated || this._validateParsers();
        let count = 0;
        const assets = {}, singleAsset = (0, $fU0Ub.isSingleItem)(assetsToLoadIn), assetsToLoad = (0, $gXnIg.convertToList)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            })), total = assetsToLoad.length, promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $lFGyw).path.toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                this.promiseCache[url] || (this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset)), assets[asset.src] = await this.promiseCache[url].promise, onProgress && onProgress(++count / total);
            } catch (e) {
                throw delete this.promiseCache[url], delete assets[asset.src], new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        return await Promise.all(promises), singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const promises = (0, $gXnIg.convertToList)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            })).map(async (asset)=>{
            const url = (0, $lFGyw).path.toAbsolute(asset.src), loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url], loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = !0, this._parserHash = this._parsers.filter((parser)=>parser.name).reduce((hash, parser)=>(hash[parser.name] && console.warn(`[Assets] loadParser name conflict "${parser.name}"`), {
                ...hash,
                [parser.name]: parser
            }), {});
    }
}

});

parcelRegister("eGvCE", function(module, exports) {

var $h0Gbc = parcelRequire("h0Gbc");

var $eilHB = parcelRequire("eilHB");

var $80Cqa = parcelRequire("80Cqa");

var $7pjiA = parcelRequire("7pjiA");
parcelRequire("8M8rl");

});
parcelRegister("h0Gbc", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $dc037be75324b6bc$export$820ed6348c4f2750);
var $dc037be75324b6bc$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>(LoaderParserPriority2[LoaderParserPriority2.Low = 0] = "Low", LoaderParserPriority2[LoaderParserPriority2.Normal = 1] = "Normal", LoaderParserPriority2[LoaderParserPriority2.High = 2] = "High", LoaderParserPriority2))($dc037be75324b6bc$export$820ed6348c4f2750 || {});

});

parcelRegister("eilHB", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");

var $6MbeN = parcelRequire("6MbeN");

var $fzibG = parcelRequire("fzibG");

var $h0Gbc = parcelRequire("h0Gbc");
const $f37d43d286635a8a$var$validJSONExtension = ".json", $f37d43d286635a8a$var$validJSONMIME = "application/json", $f37d43d286635a8a$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).Low
    },
    name: "loadJson",
    test (url) {
        return (0, $6MbeN.checkDataUrl)(url, $f37d43d286635a8a$var$validJSONMIME) || (0, $fzibG.checkExtension)(url, $f37d43d286635a8a$var$validJSONExtension);
    },
    async load (url) {
        return await (await (0, $16eqM.settings).ADAPTER.fetch(url)).json();
    }
};
(0, $5RvHb.extensions).add($f37d43d286635a8a$export$e7c8553478f3aac7);

});

parcelRegister("80Cqa", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");

var $6MbeN = parcelRequire("6MbeN");

var $fzibG = parcelRequire("fzibG");

var $h0Gbc = parcelRequire("h0Gbc");
const $26ed7903994a77a8$var$validTXTExtension = ".txt", $26ed7903994a77a8$var$validTXTMIME = "text/plain", $26ed7903994a77a8$export$3835b7ee6dbebde8 = {
    name: "loadTxt",
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).Low
    },
    test (url) {
        return (0, $6MbeN.checkDataUrl)(url, $26ed7903994a77a8$var$validTXTMIME) || (0, $fzibG.checkExtension)(url, $26ed7903994a77a8$var$validTXTExtension);
    },
    async load (url) {
        return await (await (0, $16eqM.settings).ADAPTER.fetch(url)).text();
    }
};
(0, $5RvHb.extensions).add($26ed7903994a77a8$export$3835b7ee6dbebde8);

});

parcelRegister("7pjiA", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");

var $6MbeN = parcelRequire("6MbeN");

var $fzibG = parcelRequire("fzibG");

var $h0Gbc = parcelRequire("h0Gbc");
const $845b8a71df894867$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
], $845b8a71df894867$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
], $845b8a71df894867$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
], $845b8a71df894867$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $845b8a71df894867$export$c461ca8f39d93d9b(url) {
    const ext = (0, $lFGyw).path.extname(url), nameTokens = (0, $lFGyw).path.basename(url, ext).replace(/(-|_)/g, " ").toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($845b8a71df894867$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = !1;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    return valid || (fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`), fontFamilyName;
}
const $845b8a71df894867$var$validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function $845b8a71df894867$var$encodeURIWhenNeeded(uri) {
    return $845b8a71df894867$var$validURICharactersRegex.test(uri) ? uri : encodeURI(uri);
}
const $845b8a71df894867$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).Low
    },
    name: "loadWebFont",
    test (url) {
        return (0, $6MbeN.checkDataUrl)(url, $845b8a71df894867$var$validFontMIMEs) || (0, $fzibG.checkExtension)(url, $845b8a71df894867$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $16eqM.settings).ADAPTER.getFontFaceSet();
        if (fonts) {
            const fontFaces = [], name = options.data?.family ?? $845b8a71df894867$export$c461ca8f39d93d9b(url), weights = options.data?.weights?.filter((weight)=>$845b8a71df894867$var$validWeights.includes(weight)) ?? [
                "normal"
            ], data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i], font = new FontFace(name, `url(${$845b8a71df894867$var$encodeURIWhenNeeded(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load(), fonts.add(font), fontFaces.push(font);
            }
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        return console.warn("[loadWebFont] FontFace API is not supported. Skipping loading font"), null;
    },
    unload (font) {
        (Array.isArray(font) ? font : [
            font
        ]).forEach((t)=>(0, $16eqM.settings).ADAPTER.getFontFaceSet().delete(t));
    }
};
(0, $5RvHb.extensions).add($845b8a71df894867$export$129ed93ad26b0298);

});

parcelRegister("8M8rl", function(module, exports) {

var $1lCB6 = parcelRequire("1lCB6");

var $eZn9W = parcelRequire("eZn9W");

var $jnoXR = parcelRequire("jnoXR");
parcelRequire("8fHyU");

});
parcelRegister("1lCB6", function(module, exports) {
parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $h8Rzw = parcelRequire("h8Rzw");
var $lFGyw = parcelRequire("lFGyw");

var $6MbeN = parcelRequire("6MbeN");

var $fzibG = parcelRequire("fzibG");

var $h0Gbc = parcelRequire("h0Gbc");

var $eZn9W = parcelRequire("eZn9W");

var $8ZIRW = parcelRequire("8ZIRW");
const $194887c81fec4258$var$validSVGExtension = ".svg", $194887c81fec4258$var$validSVGMIME = "image/svg+xml", $194887c81fec4258$export$c32505ea942c7f01 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).High
    },
    name: "loadSVG",
    test (url) {
        return (0, $6MbeN.checkDataUrl)(url, $194887c81fec4258$var$validSVGMIME) || (0, $fzibG.checkExtension)(url, $194887c81fec4258$var$validSVGExtension);
    },
    async testParse (data) {
        return (0, $h8Rzw.SVGResource).test(data);
    },
    async parse (asset, data, loader) {
        const src = new (0, $h8Rzw.SVGResource)(asset, data?.data?.resourceOptions);
        await src.load();
        const base = new (0, $4oWO8.BaseTexture)(src, {
            resolution: (0, $lFGyw).getResolutionOfUrl(asset),
            ...data?.data
        });
        return base.resource.src = data.src, (0, $8ZIRW.createTexture)(base, loader, data.src);
    },
    async load (url, _options) {
        return (await (0, $16eqM.settings).ADAPTER.fetch(url)).text();
    },
    unload: (0, $eZn9W.loadTextures).unload
};
(0, $5RvHb.extensions).add($194887c81fec4258$export$c32505ea942c7f01);

});
parcelRegister("eZn9W", function(module, exports) {

$parcel$export(module.exports, "loadTextures", () => $9a4512606444f5fc$export$897b113ee8307cd0);
parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");

var $6MbeN = parcelRequire("6MbeN");

var $fzibG = parcelRequire("fzibG");

var $h0Gbc = parcelRequire("h0Gbc");

var $imDU3 = parcelRequire("imDU3");

var $8ZIRW = parcelRequire("8ZIRW");
const $9a4512606444f5fc$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
], $9a4512606444f5fc$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $9a4512606444f5fc$export$c614e6247302006d(url) {
    const response = await (0, $16eqM.settings).ADAPTER.fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return await createImageBitmap(imageBlob);
}
const $9a4512606444f5fc$export$897b113ee8307cd0 = {
    name: "loadTextures",
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).High
    },
    config: {
        preferWorkers: !0,
        preferCreateImageBitmap: !0,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $6MbeN.checkDataUrl)(url, $9a4512606444f5fc$var$validImageMIMEs) || (0, $fzibG.checkExtension)(url, $9a4512606444f5fc$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        const useImageBitmap = globalThis.createImageBitmap && this.config.preferCreateImageBitmap;
        let src;
        useImageBitmap ? this.config.preferWorkers && await (0, $imDU3.WorkerManager).isImageBitmapSupported() ? src = await (0, $imDU3.WorkerManager).loadImageBitmap(url) : src = await $9a4512606444f5fc$export$c614e6247302006d(url) : src = await new Promise((resolve, reject)=>{
            const src2 = new Image();
            src2.crossOrigin = this.config.crossOrigin, src2.src = url, src2.complete ? resolve(src2) : (src2.onload = ()=>resolve(src2), src2.onerror = (e)=>reject(e));
        });
        const options = {
            ...asset.data
        };
        options.resolution ?? (options.resolution = (0, $lFGyw).getResolutionOfUrl(url)), useImageBitmap && options.resourceOptions?.ownsImageBitmap === void 0 && (options.resourceOptions = {
            ...options.resourceOptions
        }, options.resourceOptions.ownsImageBitmap = !0);
        const base = new (0, $4oWO8.BaseTexture)(src, options);
        return base.resource.src = url, (0, $8ZIRW.createTexture)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(!0);
    }
};
(0, $5RvHb.extensions).add($9a4512606444f5fc$export$897b113ee8307cd0);

});
parcelRegister("imDU3", function(module, exports) {

$parcel$export(module.exports, "WorkerManager", () => $09980339795616d9$export$bcff6015853c67ce);

var $kQfgp = parcelRequire("kQfgp");

var $jPnAU = parcelRequire("jPnAU");
let $09980339795616d9$var$UUID = 0, $09980339795616d9$var$MAX_WORKERS;
class $09980339795616d9$var$WorkerManagerClass {
    constructor(){
        this._initialized = !1, this._createdWorkers = 0, this.workerPool = [], this.queue = [], this.resolveHash = {};
    }
    isImageBitmapSupported() {
        return this._isImageBitmapSupported !== void 0 ? this._isImageBitmapSupported : (this._isImageBitmapSupported = new Promise((resolve)=>{
            const worker = new (0, $kQfgp.default)();
            worker.addEventListener("message", (event)=>{
                worker.terminate(), (0, $kQfgp.default).revokeObjectURL(), resolve(event.data);
            });
        }), this._isImageBitmapSupported);
    }
    loadImageBitmap(src) {
        return this._run("loadImageBitmap", [
            src
        ]);
    }
    async _initWorkers() {
        this._initialized || (this._initialized = !0);
    }
    getWorker() {
        $09980339795616d9$var$MAX_WORKERS === void 0 && ($09980339795616d9$var$MAX_WORKERS = navigator.hardwareConcurrency || 4);
        let worker = this.workerPool.pop();
        return !worker && this._createdWorkers < $09980339795616d9$var$MAX_WORKERS && (this._createdWorkers++, worker = new (0, $jPnAU.default)(), worker.addEventListener("message", (event)=>{
            this.complete(event.data), this.returnWorker(event.target), this.next();
        })), worker;
    }
    returnWorker(worker) {
        this.workerPool.push(worker);
    }
    complete(data) {
        data.error !== void 0 ? this.resolveHash[data.uuid].reject(data.error) : this.resolveHash[data.uuid].resolve(data.data), this.resolveHash[data.uuid] = null;
    }
    async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this.queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        return this.next(), promise;
    }
    next() {
        if (!this.queue.length) return;
        const worker = this.getWorker();
        if (!worker) return;
        const toDo = this.queue.pop(), id = toDo.id;
        this.resolveHash[$09980339795616d9$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        }, worker.postMessage({
            data: toDo.arguments,
            uuid: $09980339795616d9$var$UUID++,
            id: id
        });
    }
}
const $09980339795616d9$export$bcff6015853c67ce = new $09980339795616d9$var$WorkerManagerClass();

});
parcelRegister("kQfgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc479096c17fdd3f$export$2e2bcd8739ae039);
const $cc479096c17fdd3f$var$WORKER_CODE = `(function() {
  "use strict";
  const WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
  async function checkImageBitmap() {
    try {
      if (typeof createImageBitmap != "function")
        return !1;
      const imageBlob = await (await fetch(WHITE_PNG)).blob(), imageBitmap = await createImageBitmap(imageBlob);
      return imageBitmap.width === 1 && imageBitmap.height === 1;
    } catch {
      return !1;
    }
  }
  checkImageBitmap().then((result) => {
    self.postMessage(result);
  });
})();
`;
let $cc479096c17fdd3f$var$WORKER_URL = null;
class $cc479096c17fdd3f$export$2e2bcd8739ae039 extends Worker {
    constructor(){
        $cc479096c17fdd3f$var$WORKER_URL || ($cc479096c17fdd3f$var$WORKER_URL = URL.createObjectURL(new Blob([
            $cc479096c17fdd3f$var$WORKER_CODE
        ], {
            type: "application/javascript"
        }))), super($cc479096c17fdd3f$var$WORKER_URL);
    }
}
$cc479096c17fdd3f$export$2e2bcd8739ae039.revokeObjectURL = function() {
    $cc479096c17fdd3f$var$WORKER_URL && (URL.revokeObjectURL($cc479096c17fdd3f$var$WORKER_URL), $cc479096c17fdd3f$var$WORKER_URL = null);
};

});

parcelRegister("jPnAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5dac7acba244d56$export$2e2bcd8739ae039);
const $e5dac7acba244d56$var$WORKER_CODE = `(function() {
  "use strict";
  async function loadImageBitmap(url) {
    const response = await fetch(url);
    if (!response.ok)
      throw new Error(\`[WorkerManager.loadImageBitmap] Failed to fetch \${url}: \${response.status} \${response.statusText}\`);
    const imageBlob = await response.blob();
    return await createImageBitmap(imageBlob);
  }
  self.onmessage = async (event) => {
    try {
      const imageBitmap = await loadImageBitmap(event.data.data[0]);
      self.postMessage({
        data: imageBitmap,
        uuid: event.data.uuid,
        id: event.data.id
      }, [imageBitmap]);
    } catch (e) {
      self.postMessage({
        error: e,
        uuid: event.data.uuid,
        id: event.data.id
      });
    }
  };
})();
`;
let $e5dac7acba244d56$var$WORKER_URL = null;
class $e5dac7acba244d56$export$2e2bcd8739ae039 extends Worker {
    constructor(){
        $e5dac7acba244d56$var$WORKER_URL || ($e5dac7acba244d56$var$WORKER_URL = URL.createObjectURL(new Blob([
            $e5dac7acba244d56$var$WORKER_CODE
        ], {
            type: "application/javascript"
        }))), super($e5dac7acba244d56$var$WORKER_URL);
    }
}
$e5dac7acba244d56$export$2e2bcd8739ae039.revokeObjectURL = function() {
    $e5dac7acba244d56$var$WORKER_URL && (URL.revokeObjectURL($e5dac7acba244d56$var$WORKER_URL), $e5dac7acba244d56$var$WORKER_URL = null);
};

});


parcelRegister("8ZIRW", function(module, exports) {

$parcel$export(module.exports, "createTexture", () => $a814436d95267d74$export$37b981a8c575f415);
parcelRequire("inflE");
var $cWOCu = parcelRequire("cWOCu");

var $41Jbo = parcelRequire("41Jbo");
function $a814436d95267d74$export$37b981a8c575f415(base, loader, url) {
    base.resource.internal = !0;
    const texture = new (0, $cWOCu.Texture)(base), unload = ()=>{
        delete loader.promiseCache[url], (0, $41Jbo.Cache).has(url) && (0, $41Jbo.Cache).remove(url);
    };
    return texture.baseTexture.once("destroyed", ()=>{
        url in loader.promiseCache && (console.warn("[Assets] A BaseTexture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the BaseTexture."), unload());
    }), texture.once("destroyed", ()=>{
        base.destroyed || (console.warn("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture."), unload());
    }), texture;
}

});



parcelRegister("jnoXR", function(module, exports) {
parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");
var $iqQDF = parcelRequire("iqQDF");

var $6MbeN = parcelRequire("6MbeN");

var $fzibG = parcelRequire("fzibG");

var $h0Gbc = parcelRequire("h0Gbc");

var $8ZIRW = parcelRequire("8ZIRW");
const $7bf8a279a870d6b9$var$validVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogv"
], $7bf8a279a870d6b9$var$validVideoMIMEs = [
    "video/mp4",
    "video/webm",
    "video/ogg"
], $7bf8a279a870d6b9$export$d2b008984942555e = {
    name: "loadVideo",
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).High
    },
    config: {
        defaultAutoPlay: !0,
        defaultUpdateFPS: 0,
        defaultLoop: !1,
        defaultMuted: !1,
        defaultPlaysinline: !0
    },
    test (url) {
        return (0, $6MbeN.checkDataUrl)(url, $7bf8a279a870d6b9$var$validVideoMIMEs) || (0, $fzibG.checkExtension)(url, $7bf8a279a870d6b9$var$validVideoExtensions);
    },
    async load (url, loadAsset, loader) {
        let texture;
        const blob = await (await (0, $16eqM.settings).ADAPTER.fetch(url)).blob(), blobURL = URL.createObjectURL(blob);
        try {
            const options = {
                autoPlay: this.config.defaultAutoPlay,
                updateFPS: this.config.defaultUpdateFPS,
                loop: this.config.defaultLoop,
                muted: this.config.defaultMuted,
                playsinline: this.config.defaultPlaysinline,
                ...loadAsset?.data?.resourceOptions,
                autoLoad: !0
            }, src = new (0, $iqQDF.VideoResource)(blobURL, options);
            await src.load();
            const base = new (0, $4oWO8.BaseTexture)(src, {
                alphaMode: await (0, $lFGyw).detectVideoAlphaMode(),
                resolution: (0, $lFGyw).getResolutionOfUrl(url),
                ...loadAsset?.data
            });
            base.resource.src = url, texture = (0, $8ZIRW.createTexture)(base, loader, url), texture.baseTexture.once("destroyed", ()=>{
                URL.revokeObjectURL(blobURL);
            });
        } catch (e) {
            throw URL.revokeObjectURL(blobURL), e;
        }
        return texture;
    },
    unload (texture) {
        texture.destroy(!0);
    }
};
(0, $5RvHb.extensions).add($7bf8a279a870d6b9$export$d2b008984942555e);

});

parcelRegister("8fHyU", function(module, exports) {

var $8ZIRW = parcelRequire("8ZIRW");

});



parcelRegister("9vh3f", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $d2913503a1b01b63$export$8b4c839865b08288);
parcelRequire("inflE");
var $lFGyw = parcelRequire("lFGyw");

var $gXnIg = parcelRequire("gXnIg");

var $2MZtt = parcelRequire("2MZtt");

var $fU0Ub = parcelRequire("fU0Ub");
class $d2913503a1b01b63$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        if (this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector, this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId, this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer), prefer.priority || (prefer.priority = Object.keys(prefer.params));
        }), this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(settings.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams == "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, name: name, src: src, srcs: srcs } = asset;
        return (0, $gXnIg.convertToList)(alias || name || src || srcs, (value)=>typeof value == "string" ? value : Array.isArray(value) ? value.map((v)=>v?.src ?? v?.srcs ?? v) : value?.src || value?.srcs ? value.src ?? value.srcs : value, !0);
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        this._manifest && console.warn("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = manifest, manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        Array.isArray(assets) ? assets.forEach((asset)=>{
            const srcs = asset.src ?? asset.srcs, aliases = asset.alias ?? asset.name;
            let ids;
            if (typeof aliases == "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId), ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds), ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        }) : Object.keys(assets).forEach((key)=>{
            const aliases = [
                key,
                this._createBundleAssetId(bundleId, key)
            ];
            if (typeof assets[key] == "string") this.add({
                alias: aliases,
                src: assets[key]
            });
            else if (Array.isArray(assets[key])) this.add({
                alias: aliases,
                src: assets[key]
            });
            else {
                const asset = assets[key], assetSrc = asset.src ?? asset.srcs;
                this.add({
                    ...asset,
                    alias: aliases,
                    src: Array.isArray(assetSrc) ? assetSrc : [
                        assetSrc
                    ]
                });
            }
            assetNames.push(...aliases);
        }), this._bundles[bundleId] = assetNames;
    }
    add(aliases, srcs, data, format, loadParser) {
        const assets = [];
        typeof aliases == "string" || Array.isArray(aliases) && typeof aliases[0] == "string" ? ((0, $lFGyw).deprecation("7.2.0", `Assets.add now uses an object instead of individual parameters.
Please use Assets.add({ alias, src, data, format, loadParser }) instead.`), assets.push({
            alias: aliases,
            src: srcs,
            data: data,
            format: format,
            loadParser: loadParser
        })) : Array.isArray(aliases) ? assets.push(...aliases) : assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            this.hasKey(key) && console.warn(`[Resolver] already has key: ${key} overwriting`);
        }, (0, $gXnIg.convertToList)(assets).forEach((asset)=>{
            const { src: src, srcs: srcs2 } = asset;
            let { data: data2, format: format2, loadParser: loadParser2 } = asset;
            const srcsToUse = (0, $gXnIg.convertToList)(src || srcs2).map((src2)=>typeof src2 == "string" ? (0, $2MZtt.createStringVariations)(src2) : Array.isArray(src2) ? src2 : [
                    src2
                ]), aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            srcsToUse.forEach((srcs3)=>{
                srcs3.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 != "object") {
                        formattedAsset.src = src2;
                        for(let i = 0; i < this._parsers.length; i++){
                            const parser = this._parsers[i];
                            if (parser.test(src2)) {
                                formattedAsset = parser.parse(src2);
                                break;
                            }
                        }
                    } else data2 = src2.data ?? data2, format2 = src2.format ?? format2, loadParser2 = src2.loadParser ?? loadParser2, formattedAsset = {
                        ...formattedAsset,
                        ...src2
                    };
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this.buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data2,
                        format: format2,
                        loadParser: loadParser2
                    }), resolvedAssets.push(formattedAsset);
                });
            }), aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $fU0Ub.isSingleItem)(bundleIds);
        bundleIds = (0, $gXnIg.convertToList)(bundleIds);
        const out = {};
        return bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames), assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        }), singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key != "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $fU0Ub.isSingleItem)(keys);
        keys = (0, $gXnIg.convertToList)(keys);
        const result = {};
        return keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const bestAsset = assets[0], preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>asset[priorityKey] ? asset[priorityKey] === value : !1);
                            filteredAssets.length && (assets = filteredAssets);
                        });
                    }), this._resolverHash[key] = assets[0] ?? bestAsset;
                } else this._resolverHash[key] = this.buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        }), singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[0], preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, format: format } = data;
        return (this._basePath || this._rootPath) && (formattedAsset.src = (0, $lFGyw).path.toAbsolute(formattedAsset.src, this._basePath, this._rootPath)), formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ], formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src), formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        }, formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser, formattedAsset.format = format ?? (0, $lFGyw).path.extname(formattedAsset.src).slice(1), formattedAsset.srcs = formattedAsset.src, formattedAsset.name = formattedAsset.alias, formattedAsset;
    }
}

});


parcelRegister("6oiva", function(module, exports) {

var $41Jbo = parcelRequire("41Jbo");
parcelRequire("lWMuM");
parcelRequire("dNufQ");

});
parcelRegister("lWMuM", function(module, exports) {

});

parcelRegister("dNufQ", function(module, exports) {

var $iOkDF = parcelRequire("iOkDF");

});
parcelRegister("iOkDF", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $cWOCu = parcelRequire("cWOCu");
const $ffd3214dbdb21d7c$export$407b4625a915919d = {
    extension: (0, $5RvHb.ExtensionType).CacheParser,
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $cWOCu.Texture)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        return keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        }), out;
    }
};
(0, $5RvHb.extensions).add($ffd3214dbdb21d7c$export$407b4625a915919d);

});



parcelRegister("6sBTk", function(module, exports) {
parcelRequire("bJHpx");

});
parcelRegister("bJHpx", function(module, exports) {

var $c2Jcb = parcelRequire("c2Jcb");

var $cFAYk = parcelRequire("cFAYk");

var $ieeFl = parcelRequire("ieeFl");

var $bTeVW = parcelRequire("bTeVW");

var $dxOlk = parcelRequire("dxOlk");

var $cLHT9 = parcelRequire("cLHT9");

});
parcelRegister("c2Jcb", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");

var $8jbDa = parcelRequire("8jbDa");
const $4b526ee52401fd1d$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).DetectionParser,
        priority: 1
    },
    test: async ()=>(0, $8jbDa.testImageFormat)(// eslint-disable-next-line max-len
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="),
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};
(0, $5RvHb.extensions).add($4b526ee52401fd1d$export$a60d2d4a3c570783);

});
parcelRegister("8jbDa", function(module, exports) {

$parcel$export(module.exports, "testImageFormat", () => $4d54606b4619358c$export$7c459e568e7cea2c);
async function $4d54606b4619358c$export$7c459e568e7cea2c(imageData) {
    if ("Image" in globalThis) return new Promise((resolve)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(!0);
        }, image.onerror = ()=>{
            resolve(!1);
        }, image.src = imageData;
    });
    if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
        try {
            const blob = await (await fetch(imageData)).blob();
            await createImageBitmap(blob);
        } catch  {
            return !1;
        }
        return !0;
    }
    return !1;
}

});


parcelRegister("cFAYk", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");

var $8jbDa = parcelRequire("8jbDa");
const $b39729af2811f70e$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $8jbDa.testImageFormat)("data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="),
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};
(0, $5RvHb.extensions).add($b39729af2811f70e$export$d19529a9ed9823d4);

});

parcelRegister("ieeFl", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
const $0e08f90975e7958b$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
], $0e08f90975e7958b$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(!0),
    add: async (formats)=>[
            ...formats,
            ...$0e08f90975e7958b$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$0e08f90975e7958b$var$imageFormats.includes(f))
};
(0, $5RvHb.extensions).add($0e08f90975e7958b$export$b106d7c2de3b4d89);

});

parcelRegister("bTeVW", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");

var $coXj6 = parcelRequire("coXj6");
const $47ede861e770e72c$export$a041d698a1896657 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $coXj6.testVideoFormat)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};
(0, $5RvHb.extensions).add($47ede861e770e72c$export$a041d698a1896657);

});
parcelRegister("coXj6", function(module, exports) {

$parcel$export(module.exports, "testVideoFormat", () => $9c37479e1c72266a$export$7a571c147b03abb1);
const $9c37479e1c72266a$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $9c37479e1c72266a$export$7a571c147b03abb1(mimeType) {
    return $9c37479e1c72266a$var$inWorker ? !1 : document.createElement("video").canPlayType(mimeType) !== "";
}

});


parcelRegister("dxOlk", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");

var $coXj6 = parcelRequire("coXj6");
const $16a45b5195786225$export$7726d83fee274e25 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $coXj6.testVideoFormat)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};
(0, $5RvHb.extensions).add($16a45b5195786225$export$7726d83fee274e25);

});

parcelRegister("cLHT9", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");

var $coXj6 = parcelRequire("coXj6");
const $967d74e222bb83aa$export$5a1da481121f806a = {
    extension: {
        type: (0, $5RvHb.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $coXj6.testVideoFormat)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};
(0, $5RvHb.extensions).add($967d74e222bb83aa$export$5a1da481121f806a);

});



parcelRegister("eCDTl", function(module, exports) {
parcelRequire("eGvCE");

});

parcelRegister("bYx2s", function(module, exports) {
parcelRequire("cBcbr");
parcelRequire("5J6bV");

});
parcelRegister("cBcbr", function(module, exports) {

var $kbE9F = parcelRequire("kbE9F");

});
parcelRegister("kbE9F", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("eCDTl");

var $eZn9W = parcelRequire("eZn9W");
const $a86b2a0d6960d0dc$export$cc356fa83de02bea = {
    extension: (0, $5RvHb.ExtensionType).ResolveParser,
    test: (0, $eZn9W.loadTextures).test,
    parse: (value)=>({
            resolution: parseFloat((0, $16eqM.settings).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: (0, $lFGyw).path.extname(value).slice(1),
            src: value
        })
};
(0, $5RvHb.extensions).add($a86b2a0d6960d0dc$export$cc356fa83de02bea);

});


parcelRegister("5J6bV", function(module, exports) {

});


parcelRegister("7a41k", function(module, exports) {

});




parcelRegister("9WNrE", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => (parcelRequire("1FuXs")).Graphics);
$parcel$export(module.exports, "LINE_CAP", () => (parcelRequire("khIUA")).LINE_CAP);
$parcel$export(module.exports, "LINE_JOIN", () => (parcelRequire("khIUA")).LINE_JOIN);

var $ln77Y = parcelRequire("ln77Y");

var $khIUA = parcelRequire("khIUA");

var $1FuXs = parcelRequire("1FuXs");

var $6tEuM = parcelRequire("6tEuM");

var $k5kgH = parcelRequire("k5kgH");

var $5Q1Vs = parcelRequire("5Q1Vs");

var $d8fAV = parcelRequire("d8fAV");

var $iB9oV = parcelRequire("iB9oV");

var $bGcaN = parcelRequire("bGcaN");

var $1Xt6h = parcelRequire("1Xt6h");

var $ekrHJ = parcelRequire("ekrHJ");

var $bAuqa = parcelRequire("bAuqa");

var $f22t2 = parcelRequire("f22t2");

var $3XPH0 = parcelRequire("3XPH0");

var $aryzn = parcelRequire("aryzn");

var $exTB6 = parcelRequire("exTB6");
const $827f57ff8261ea1c$export$efc72ad5bf88689 = {
    buildPoly: $iB9oV.buildPoly,
    buildCircle: $bGcaN.buildCircle,
    buildRectangle: $1Xt6h.buildRectangle,
    buildRoundedRectangle: $ekrHJ.buildRoundedRectangle,
    buildLine: $bAuqa.buildLine,
    ArcUtils: $f22t2.ArcUtils,
    BezierUtils: $3XPH0.BezierUtils,
    QuadraticUtils: $aryzn.QuadraticUtils,
    BatchPart: $exTB6.BatchPart,
    FILL_COMMANDS: $ln77Y.FILL_COMMANDS,
    BATCH_POOL: $ln77Y.BATCH_POOL,
    DRAW_CALL_POOL: $ln77Y.DRAW_CALL_POOL
};

});
parcelRegister("ln77Y", function(module, exports) {

$parcel$export(module.exports, "FILL_COMMANDS", () => $880f99c2e54bc0a5$export$b738057f7c88a634);
$parcel$export(module.exports, "BATCH_POOL", () => $880f99c2e54bc0a5$export$78aca0cfc72b8d6);
$parcel$export(module.exports, "DRAW_CALL_POOL", () => $880f99c2e54bc0a5$export$e520c68c6872beed);
parcelRequire("inflE");
var $lbGGA = parcelRequire("lbGGA");

var $bGcaN = parcelRequire("bGcaN");

var $iB9oV = parcelRequire("iB9oV");

var $1Xt6h = parcelRequire("1Xt6h");

var $ekrHJ = parcelRequire("ekrHJ");

var $f22t2 = parcelRequire("f22t2");

var $exTB6 = parcelRequire("exTB6");

var $3XPH0 = parcelRequire("3XPH0");

var $bAuqa = parcelRequire("bAuqa");

var $aryzn = parcelRequire("aryzn");
const $880f99c2e54bc0a5$export$b738057f7c88a634 = {
    [(0, $lbGGA.SHAPES).POLY]: (0, $iB9oV.buildPoly),
    [(0, $lbGGA.SHAPES).CIRC]: (0, $bGcaN.buildCircle),
    [(0, $lbGGA.SHAPES).ELIP]: (0, $bGcaN.buildCircle),
    [(0, $lbGGA.SHAPES).RECT]: (0, $1Xt6h.buildRectangle),
    [(0, $lbGGA.SHAPES).RREC]: (0, $ekrHJ.buildRoundedRectangle)
}, $880f99c2e54bc0a5$export$78aca0cfc72b8d6 = [], $880f99c2e54bc0a5$export$e520c68c6872beed = [];

});
parcelRegister("bGcaN", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $4c913faac15604fc$export$a3541b2d8ecbfcf2);
parcelRequire("inflE");
var $lbGGA = parcelRequire("lbGGA");
const $4c913faac15604fc$export$a3541b2d8ecbfcf2 = {
    build (graphicsData) {
        const points = graphicsData.points;
        let x, y, dx, dy, rx, ry;
        if (graphicsData.type === (0, $lbGGA.SHAPES).CIRC) {
            const circle = graphicsData.shape;
            x = circle.x, y = circle.y, rx = ry = circle.radius, dx = dy = 0;
        } else if (graphicsData.type === (0, $lbGGA.SHAPES).ELIP) {
            const ellipse = graphicsData.shape;
            x = ellipse.x, y = ellipse.y, rx = ellipse.width, ry = ellipse.height, dx = dy = 0;
        } else {
            const roundedRect = graphicsData.shape, halfWidth = roundedRect.width / 2, halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth, y = roundedRect.y + halfHeight, rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight))), dx = halfWidth - rx, dy = halfHeight - ry;
        }
        if (!(rx >= 0 && ry >= 0 && dx >= 0 && dy >= 0)) {
            points.length = 0;
            return;
        }
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry)), m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (points.length = m, m === 0) return;
        if (n === 0) {
            points.length = 8, points[0] = points[6] = x + dx, points[1] = points[3] = y + dy, points[2] = points[4] = x - dx, points[5] = points[7] = y - dy;
            return;
        }
        let j1 = 0, j2 = n * 4 + (dx ? 2 : 0) + 2, j3 = j2, j4 = m;
        {
            const x0 = dx + rx, y0 = dy, x1 = x + x0, x2 = x - x0, y1 = y + y0;
            if (points[j1++] = x1, points[j1++] = y1, points[--j2] = y1, points[--j2] = x2, dy) {
                const y2 = y - y0;
                points[j3++] = x2, points[j3++] = y2, points[--j4] = y2, points[--j4] = x1;
            }
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n), x0 = dx + Math.cos(a) * rx, y0 = dy + Math.sin(a) * ry, x1 = x + x0, x2 = x - x0, y1 = y + y0, y2 = y - y0;
            points[j1++] = x1, points[j1++] = y1, points[--j2] = y1, points[--j2] = x2, points[j3++] = x2, points[j3++] = y2, points[--j4] = y2, points[--j4] = x1;
        }
        {
            const x0 = dx, y0 = dy + ry, x1 = x + x0, x2 = x - x0, y1 = y + y0, y2 = y - y0;
            points[j1++] = x1, points[j1++] = y1, points[--j4] = y2, points[--j4] = x1, dx && (points[j1++] = x2, points[j1++] = y1, points[--j4] = y2, points[--j4] = x2);
        }
    },
    triangulate (graphicsData, graphicsGeometry) {
        const points = graphicsData.points, verts = graphicsGeometry.points, indices = graphicsGeometry.indices;
        if (points.length === 0) return;
        let vertPos = verts.length / 2;
        const center = vertPos;
        let x, y;
        if (graphicsData.type !== (0, $lbGGA.SHAPES).RREC) {
            const circle = graphicsData.shape;
            x = circle.x, y = circle.y;
        } else {
            const roundedRect = graphicsData.shape;
            x = roundedRect.x + roundedRect.width / 2, y = roundedRect.y + roundedRect.height / 2;
        }
        const matrix = graphicsData.matrix;
        verts.push(graphicsData.matrix ? matrix.a * x + matrix.c * y + matrix.tx : x, graphicsData.matrix ? matrix.b * x + matrix.d * y + matrix.ty : y), vertPos++, verts.push(points[0], points[1]);
        for(let i = 2; i < points.length; i += 2)verts.push(points[i], points[i + 1]), indices.push(vertPos++, center, vertPos);
        indices.push(center + 1, center, vertPos);
    }
};

});

parcelRegister("iB9oV", function(module, exports) {

$parcel$export(module.exports, "buildPoly", () => $cd9134e2b709ce53$export$7de1a57618f21e1f);
parcelRequire("inflE");
var $lFGyw = parcelRequire("lFGyw");
function $cd9134e2b709ce53$var$fixOrientation(points, hole = !1) {
    const m = points.length;
    if (m < 6) return;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i], y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1), x1 = x2, y1 = y2;
    }
    if (!hole && area > 0 || hole && area <= 0) {
        const n = m / 2;
        for(let i = n + n % 2; i < m; i += 2){
            const i1 = m - i - 2, i2 = m - i - 1, i3 = i, i4 = i + 1;
            [points[i1], points[i3]] = [
                points[i3],
                points[i1]
            ], [points[i2], points[i4]] = [
                points[i4],
                points[i2]
            ];
        }
    }
}
const $cd9134e2b709ce53$export$7de1a57618f21e1f = {
    build (graphicsData) {
        graphicsData.points = graphicsData.shape.points.slice();
    },
    triangulate (graphicsData, graphicsGeometry) {
        let points = graphicsData.points;
        const holes = graphicsData.holes, verts = graphicsGeometry.points, indices = graphicsGeometry.indices;
        if (points.length >= 6) {
            $cd9134e2b709ce53$var$fixOrientation(points, !1);
            const holeArray = [];
            for(let i = 0; i < holes.length; i++){
                const hole = holes[i];
                $cd9134e2b709ce53$var$fixOrientation(hole.points, !0), holeArray.push(points.length / 2), points = points.concat(hole.points);
            }
            const triangles = (0, $lFGyw).earcut(points, holeArray, 2);
            if (!triangles) return;
            const vertPos = verts.length / 2;
            for(let i = 0; i < triangles.length; i += 3)indices.push(triangles[i] + vertPos), indices.push(triangles[i + 1] + vertPos), indices.push(triangles[i + 2] + vertPos);
            for(let i = 0; i < points.length; i++)verts.push(points[i]);
        }
    }
};

});

parcelRegister("1Xt6h", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $7ae504b9c1c43240$export$cbe813d11f2192b2);
const $7ae504b9c1c43240$export$cbe813d11f2192b2 = {
    build (graphicsData) {
        const rectData = graphicsData.shape, x = rectData.x, y = rectData.y, width = rectData.width, height = rectData.height, points = graphicsData.points;
        points.length = 0, width >= 0 && height >= 0 && points.push(x, y, x + width, y, x + width, y + height, x, y + height);
    },
    triangulate (graphicsData, graphicsGeometry) {
        const points = graphicsData.points, verts = graphicsGeometry.points;
        if (points.length === 0) return;
        const vertPos = verts.length / 2;
        verts.push(points[0], points[1], points[2], points[3], points[6], points[7], points[4], points[5]), graphicsGeometry.indices.push(vertPos, vertPos + 1, vertPos + 2, vertPos + 1, vertPos + 2, vertPos + 3);
    }
};

});

parcelRegister("ekrHJ", function(module, exports) {

$parcel$export(module.exports, "buildRoundedRectangle", () => $b622a5b3f0138217$export$4b54fce47d2ae7f4);

var $bGcaN = parcelRequire("bGcaN");
const $b622a5b3f0138217$export$4b54fce47d2ae7f4 = {
    build (graphicsData) {
        (0, $bGcaN.buildCircle).build(graphicsData);
    },
    triangulate (graphicsData, graphicsGeometry) {
        (0, $bGcaN.buildCircle).triangulate(graphicsData, graphicsGeometry);
    }
};

});

parcelRegister("f22t2", function(module, exports) {

$parcel$export(module.exports, "ArcUtils", () => $8118a95e17addabb$export$e6c43ec4db262573);
parcelRequire("inflE");
var $lbGGA = parcelRequire("lbGGA");

var $khIUA = parcelRequire("khIUA");
class $8118a95e17addabb$export$e6c43ec4db262573 {
    /**
   * Calculate information of the arc for {@link PIXI.Graphics.arcTo}.
   * @private
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @param points - Collection of points to add to
   * @returns - If the arc length is valid, return center of circle, radius and other info otherwise `null`.
   */ static curveTo(x1, y1, x2, y2, radius, points) {
        const fromX = points[points.length - 2], a1 = points[points.length - 1] - y1, b1 = fromX - x1, a2 = y2 - y1, b2 = x2 - x1, mm = Math.abs(a1 * b2 - b1 * a2);
        if (mm < 1e-8 || radius === 0) return (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) && points.push(x1, y1), null;
        const dd = a1 * a1 + b1 * b1, cc = a2 * a2 + b2 * b2, tt = a1 * a2 + b1 * b2, k1 = radius * Math.sqrt(dd) / mm, k2 = radius * Math.sqrt(cc) / mm, j1 = k1 * tt / dd, j2 = k2 * tt / cc, cx = k1 * b2 + k2 * b1, cy = k1 * a2 + k2 * a1, px = b1 * (k2 + j1), py = a1 * (k2 + j1), qx = b2 * (k1 + j2), qy = a2 * (k1 + j2), startAngle = Math.atan2(py - cy, px - cx), endAngle = Math.atan2(qy - cy, qx - cx);
        return {
            cx: cx + x1,
            cy: cy + y1,
            radius: radius,
            startAngle: startAngle,
            endAngle: endAngle,
            anticlockwise: b1 * a2 > b2 * a1
        };
    }
    /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @private
   * @param _startX - Start x location of arc
   * @param _startY - Start y location of arc
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param _anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @param points - Collection of points to add to
   */ static arc(_startX, _startY, cx, cy, radius, startAngle, endAngle, _anticlockwise, points) {
        const sweep = endAngle - startAngle, n = (0, $khIUA.curves)._segmentsCount(Math.abs(sweep) * radius, Math.ceil(Math.abs(sweep) / (0, $lbGGA.PI_2)) * 40), theta = sweep / (n * 2), theta2 = theta * 2, cTheta = Math.cos(theta), sTheta = Math.sin(theta), segMinus = n - 1, remainder = segMinus % 1 / segMinus;
        for(let i = 0; i <= segMinus; ++i){
            const real = i + remainder * i, angle = theta + startAngle + theta2 * real, c = Math.cos(angle), s = -Math.sin(angle);
            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
        }
    }
}

});
parcelRegister("khIUA", function(module, exports) {

$parcel$export(module.exports, "LINE_JOIN", () => $e40ae4992b898c4e$export$c6a6e344be1302e7);
$parcel$export(module.exports, "LINE_CAP", () => $e40ae4992b898c4e$export$b113e22c48c75d2e);
$parcel$export(module.exports, "curves", () => $e40ae4992b898c4e$export$6894093bf294bea5);
var $e40ae4992b898c4e$export$c6a6e344be1302e7 = /* @__PURE__ */ ((LINE_JOIN2)=>(LINE_JOIN2.MITER = "miter", LINE_JOIN2.BEVEL = "bevel", LINE_JOIN2.ROUND = "round", LINE_JOIN2))($e40ae4992b898c4e$export$c6a6e344be1302e7 || {}), $e40ae4992b898c4e$export$b113e22c48c75d2e = /* @__PURE__ */ ((LINE_CAP2)=>(LINE_CAP2.BUTT = "butt", LINE_CAP2.ROUND = "round", LINE_CAP2.SQUARE = "square", LINE_CAP2))($e40ae4992b898c4e$export$b113e22c48c75d2e || {});
const $e40ae4992b898c4e$export$6894093bf294bea5 = {
    adaptive: !0,
    maxLength: 10,
    minSegments: 8,
    maxSegments: 2048,
    epsilon: 1e-4,
    _segmentsCount (length, defaultSegments = 20) {
        if (!this.adaptive || !length || isNaN(length)) return defaultSegments;
        let result = Math.ceil(length / this.maxLength);
        return result < this.minSegments ? result = this.minSegments : result > this.maxSegments && (result = this.maxSegments), result;
    }
}, $e40ae4992b898c4e$export$8331f8d2be429f2c = $e40ae4992b898c4e$export$6894093bf294bea5;

});


parcelRegister("exTB6", function(module, exports) {

$parcel$export(module.exports, "BatchPart", () => $d744c4657ef5cdc9$export$3abbb88a93faeec2);
class $d744c4657ef5cdc9$export$3abbb88a93faeec2 {
    constructor(){
        this.reset();
    }
    /**
   * Begin batch part.
   * @param style
   * @param startIndex
   * @param attribStart
   */ begin(style, startIndex, attribStart) {
        this.reset(), this.style = style, this.start = startIndex, this.attribStart = attribStart;
    }
    /**
   * End batch part.
   * @param endIndex
   * @param endAttrib
   */ end(endIndex, endAttrib) {
        this.attribSize = endAttrib - this.attribStart, this.size = endIndex - this.start;
    }
    reset() {
        this.style = null, this.size = 0, this.start = 0, this.attribStart = 0, this.attribSize = 0;
    }
}

});

parcelRegister("3XPH0", function(module, exports) {

$parcel$export(module.exports, "BezierUtils", () => $8b8420ad498966ee$export$994e59e1556c01e9);

var $khIUA = parcelRequire("khIUA");
class $8b8420ad498966ee$export$994e59e1556c01e9 {
    /**
   * Calculate length of bezier curve.
   * Analytical solution is impossible, since it involves an integral that does not integrate in general.
   * Therefore numerical solution is used.
   * @private
   * @param fromX - Starting point x
   * @param fromY - Starting point y
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - Length of bezier curve
   */ static curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        let result = 0, t = 0, t2 = 0, t3 = 0, nt = 0, nt2 = 0, nt3 = 0, x = 0, y = 0, dx = 0, dy = 0, prevX = fromX, prevY = fromY;
        for(let i = 1; i <= 10; ++i)t = i / 10, t2 = t * t, t3 = t2 * t, nt = 1 - t, nt2 = nt * nt, nt3 = nt2 * nt, x = nt3 * fromX + 3 * nt2 * t * cpX + 3 * nt * t2 * cpX2 + t3 * toX, y = nt3 * fromY + 3 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY, dx = prevX - x, dy = prevY - y, prevX = x, prevY = y, result += Math.sqrt(dx * dx + dy * dy);
        return result;
    }
    /**
   * Calculate the points for a bezier curve and then draws it.
   *
   * Ignored from docs since it is not directly exposed.
   * @ignore
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Path array to push points into
   */ static curveTo(cpX, cpY, cpX2, cpY2, toX, toY, points) {
        const fromX = points[points.length - 2], fromY = points[points.length - 1];
        points.length -= 2;
        const n = (0, $khIUA.curves)._segmentsCount($8b8420ad498966ee$export$994e59e1556c01e9.curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY));
        let dt = 0, dt2 = 0, dt3 = 0, t2 = 0, t3 = 0;
        points.push(fromX, fromY);
        for(let i = 1, j = 0; i <= n; ++i)j = i / n, dt = 1 - j, dt2 = dt * dt, dt3 = dt2 * dt, t2 = j * j, t3 = t2 * j, points.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
    }
}

});

parcelRegister("bAuqa", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $869154e3d7cd998d$export$45986ccf08e93b0b);
parcelRequire("inflE");
var $gnwPx = parcelRequire("gnwPx");
var $lbGGA = parcelRequire("lbGGA");

var $khIUA = parcelRequire("khIUA");
function $869154e3d7cd998d$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight, iy = y - ny * innerWeight, ox = x + nx * outerWeight, oy = y + ny * outerWeight;
    let exx, eyy;
    clockwise ? (exx = ny, eyy = -nx) : (exx = -ny, eyy = nx);
    const eix = ix + exx, eiy = iy + eyy, eox = ox + exx, eoy = oy + eyy;
    return verts.push(eix, eiy, eox, eoy), 2;
}
function $869154e3d7cd998d$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx, cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y), angle1 = Math.atan2(ex - cx, ey - cy);
    clockwise && angle0 < angle1 ? angle0 += Math.PI * 2 : !clockwise && angle0 > angle1 && (angle1 += Math.PI * 2);
    let startAngle = angle0;
    const angleDiff = angle1 - angle0, absAngleDiff = Math.abs(angleDiff), radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y), segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1, angleInc = angleDiff / segCount;
    if (startAngle += angleInc, clockwise) {
        verts.push(cx, cy, sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc)verts.push(cx, cy, cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        verts.push(cx, cy, ex, ey);
    } else {
        verts.push(sx, sy, cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc)verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius, cx, cy);
        verts.push(ex, ey, cx, cy);
    }
    return segCount * 2;
}
function $869154e3d7cd998d$var$buildNonNativeLine(graphicsData, graphicsGeometry) {
    const shape = graphicsData.shape;
    let points = graphicsData.points || shape.points.slice();
    const eps = graphicsGeometry.closePointEps;
    if (points.length === 0) return;
    const style = graphicsData.lineStyle, firstPoint = new (0, $gnwPx.Point)(points[0], points[1]), lastPoint = new (0, $gnwPx.Point)(points[points.length - 2], points[points.length - 1]), closedShape = shape.type !== (0, $lbGGA.SHAPES).POLY || shape.closeStroke, closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice(), closedPath && (points.pop(), points.pop(), lastPoint.set(points[points.length - 2], points[points.length - 1]));
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5, midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY), points.push(midPointX, midPointY);
    }
    const verts = graphicsGeometry.points, length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2, width = style.width / 2, widthSquared = width * width, miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0], y0 = points[1], x1 = points[2], y1 = points[3], x2 = 0, y2 = 0, perpx = -(y0 - y1), perpy = x0 - x1, perp1x = 0, perp1y = 0, dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist, perpy /= dist, perpx *= width, perpy *= width;
    const ratio = style.alignment, innerWeight = (1 - ratio) * 2, outerWeight = ratio * 2;
    closedShape || (style.cap === (0, $khIUA.LINE_CAP).ROUND ? indexCount += $869154e3d7cd998d$var$round(x0 - perpx * (innerWeight - outerWeight) * 0.5, y0 - perpy * (innerWeight - outerWeight) * 0.5, x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight, verts, !0) + 2 : style.cap === (0, $khIUA.LINE_CAP).SQUARE && (indexCount += $869154e3d7cd998d$var$square(x0, y0, perpx, perpy, innerWeight, outerWeight, !0, verts))), verts.push(x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2], y0 = points[(i - 1) * 2 + 1], x1 = points[i * 2], y1 = points[i * 2 + 1], x2 = points[(i + 1) * 2], y2 = points[(i + 1) * 2 + 1], perpx = -(y0 - y1), perpy = x0 - x1, dist = Math.sqrt(perpx * perpx + perpy * perpy), perpx /= dist, perpy /= dist, perpx *= width, perpy *= width, perp1x = -(y1 - y2), perp1y = x1 - x2, dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y), perp1x /= dist, perp1y /= dist, perp1x *= width, perp1y *= width;
        const dx0 = x1 - x0, dy0 = y0 - y1, dx1 = x1 - x2, dy1 = y2 - y1, dot = dx0 * dx1 + dy0 * dy1, cross = dy0 * dx1 - dy1 * dx0, clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight), dot >= 0 && (style.join === (0, $khIUA.LINE_JOIN).ROUND ? indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 4 : indexCount += 2, verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight, x1 + perp1x * innerWeight, y1 + perp1y * innerWeight));
            continue;
        }
        const c1 = (-perpx + x0) * (-perpy + y1) - (-perpx + x1) * (-perpy + y0), c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2), px = (dx0 * c2 - dx1 * c1) / cross, py = (dy1 * c1 - dy0 * c2) / cross, pdist = (px - x1) * (px - x1) + (py - y1) * (py - y1), imx = x1 + (px - x1) * innerWeight, imy = y1 + (py - y1) * innerWeight, omx = x1 - (px - x1) * outerWeight, omy = y1 - (py - y1) * outerWeight, smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1), insideWeight = clockwise ? innerWeight : outerWeight, smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared, insideMiterOk = pdist <= smallerInsideDiagonalSq;
        let join = style.join;
        if (join === (0, $khIUA.LINE_JOIN).MITER && pdist / widthSquared > miterLimitSquared && (join = (0, $khIUA.LINE_JOIN).BEVEL), insideMiterOk) switch(join){
            case (0, $khIUA.LINE_JOIN).MITER:
                verts.push(imx, imy, omx, omy);
                break;
            case (0, $khIUA.LINE_JOIN).BEVEL:
                clockwise ? verts.push(imx, imy, // inner miter point
                x1 + perpx * outerWeight, y1 + perpy * outerWeight, // first segment's outer vertex
                imx, imy, // inner miter point
                x1 + perp1x * outerWeight, y1 + perp1y * outerWeight) : verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, // first segment's inner vertex
                omx, omy, // outer miter point
                x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, // second segment's outer vertex
                omx, omy), indexCount += 2;
                break;
            case (0, $khIUA.LINE_JOIN).ROUND:
                clockwise ? (verts.push(imx, imy, x1 + perpx * outerWeight, y1 + perpy * outerWeight), indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, !0) + 4, verts.push(imx, imy, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight)) : (verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, omx, omy), indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 4, verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, omx, omy));
                break;
        }
        else {
            switch(verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, // first segment's inner vertex
            x1 + perpx * outerWeight, y1 + perpy * outerWeight), join){
                case (0, $khIUA.LINE_JOIN).MITER:
                    clockwise ? verts.push(omx, omy, // inner miter point
                    omx, omy) : verts.push(imx, imy, // outer miter point
                    imx, imy), indexCount += 2;
                    break;
                case (0, $khIUA.LINE_JOIN).ROUND:
                    clockwise ? indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, !0) + 2 : indexCount += $869154e3d7cd998d$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, !1) + 2;
                    break;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, // second segment's inner vertex
            x1 + perp1x * outerWeight, y1 + perp1y * outerWeight), indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2], y0 = points[(length - 2) * 2 + 1], x1 = points[(length - 1) * 2], y1 = points[(length - 1) * 2 + 1], perpx = -(y0 - y1), perpy = x0 - x1, dist = Math.sqrt(perpx * perpx + perpy * perpy), perpx /= dist, perpy /= dist, perpx *= width, perpy *= width, verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight), closedShape || (style.cap === (0, $khIUA.LINE_CAP).ROUND ? indexCount += $869154e3d7cd998d$var$round(x1 - perpx * (innerWeight - outerWeight) * 0.5, y1 - perpy * (innerWeight - outerWeight) * 0.5, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight, verts, !1) + 2 : style.cap === (0, $khIUA.LINE_CAP).SQUARE && (indexCount += $869154e3d7cd998d$var$square(x1, y1, perpx, perpy, innerWeight, outerWeight, !1, verts)));
    const indices = graphicsGeometry.indices, eps2 = (0, $khIUA.curves).epsilon * (0, $khIUA.curves).epsilon;
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i)x0 = verts[i * 2], y0 = verts[i * 2 + 1], x1 = verts[(i + 1) * 2], y1 = verts[(i + 1) * 2 + 1], x2 = verts[(i + 2) * 2], y2 = verts[(i + 2) * 2 + 1], !(Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) && indices.push(i, i + 1, i + 2);
}
function $869154e3d7cd998d$var$buildNativeLine(graphicsData, graphicsGeometry) {
    let i = 0;
    const shape = graphicsData.shape, points = graphicsData.points || shape.points, closedShape = shape.type !== (0, $lbGGA.SHAPES).POLY || shape.closeStroke;
    if (points.length === 0) return;
    const verts = graphicsGeometry.points, indices = graphicsGeometry.indices, length = points.length / 2, startIndex = verts.length / 2;
    let currentIndex = startIndex;
    for(verts.push(points[0], points[1]), i = 1; i < length; i++)verts.push(points[i * 2], points[i * 2 + 1]), indices.push(currentIndex, currentIndex + 1), currentIndex++;
    closedShape && indices.push(currentIndex, startIndex);
}
function $869154e3d7cd998d$export$45986ccf08e93b0b(graphicsData, graphicsGeometry) {
    graphicsData.lineStyle.native ? $869154e3d7cd998d$var$buildNativeLine(graphicsData, graphicsGeometry) : $869154e3d7cd998d$var$buildNonNativeLine(graphicsData, graphicsGeometry);
}

});

parcelRegister("aryzn", function(module, exports) {

$parcel$export(module.exports, "QuadraticUtils", () => $3eaaf9b529e8eeec$export$616649c7d4fcacf2);

var $khIUA = parcelRequire("khIUA");
class $3eaaf9b529e8eeec$export$616649c7d4fcacf2 {
    /**
   * Calculate length of quadratic curve
   * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
   * for the detailed explanation of math behind this.
   * @private
   * @param fromX - x-coordinate of curve start point
   * @param fromY - y-coordinate of curve start point
   * @param cpX - x-coordinate of curve control point
   * @param cpY - y-coordinate of curve control point
   * @param toX - x-coordinate of curve end point
   * @param toY - y-coordinate of curve end point
   * @returns - Length of quadratic curve
   */ static curveLength(fromX, fromY, cpX, cpY, toX, toY) {
        const ax = fromX - 2 * cpX + toX, ay = fromY - 2 * cpY + toY, bx = 2 * cpX - 2 * fromX, by = 2 * cpY - 2 * fromY, a = 4 * (ax * ax + ay * ay), b = 4 * (ax * bx + ay * by), c = bx * bx + by * by, s = 2 * Math.sqrt(a + b + c), a2 = Math.sqrt(a), a32 = 2 * a * a2, c2 = 2 * Math.sqrt(c), ba = b / a2;
        return (a32 * s + a2 * b * (s - c2) + (4 * c * a - b * b) * Math.log((2 * a2 + ba + s) / (ba + c2))) / (4 * a32);
    }
    /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @private
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @param points - Points to add segments to.
   */ static curveTo(cpX, cpY, toX, toY, points) {
        const fromX = points[points.length - 2], fromY = points[points.length - 1], n = (0, $khIUA.curves)._segmentsCount($3eaaf9b529e8eeec$export$616649c7d4fcacf2.curveLength(fromX, fromY, cpX, cpY, toX, toY));
        let xa = 0, ya = 0;
        for(let i = 1; i <= n; ++i){
            const j = i / n;
            xa = fromX + (cpX - fromX) * j, ya = fromY + (cpY - fromY) * j, points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
        }
    }
}

});


parcelRegister("1FuXs", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $680a5efca7e434a6$export$29d3e417456abdad);
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $8mUry = parcelRequire("8mUry");
var $1PNws = parcelRequire("1PNws");
var $gBsEB = parcelRequire("gBsEB");
var $6wJoy = parcelRequire("6wJoy");
var $lbGGA = parcelRequire("lbGGA");
var $gnwPx = parcelRequire("gnwPx");
var $duPDq = parcelRequire("duPDq");
var $kZOeV = parcelRequire("kZOeV");
var $3qn70 = parcelRequire("3qn70");
var $2cKpP = parcelRequire("2cKpP");
var $bUqaG = parcelRequire("bUqaG");
var $cWOCu = parcelRequire("cWOCu");
var $BpNwR = parcelRequire("BpNwR");
parcelRequire("gD5uZ");
var $3IPo5 = parcelRequire("3IPo5");

var $khIUA = parcelRequire("khIUA");

var $k5kgH = parcelRequire("k5kgH");

var $5Q1Vs = parcelRequire("5Q1Vs");

var $d8fAV = parcelRequire("d8fAV");
parcelRequire("ln77Y");

var $aryzn = parcelRequire("aryzn");

var $3XPH0 = parcelRequire("3XPH0");

var $f22t2 = parcelRequire("f22t2");
const $680a5efca7e434a6$var$DEFAULT_SHADERS = {}, $680a5efca7e434a6$var$_Graphics = class _Graphics2 extends (0, $3IPo5.Container) {
    /**
   * @param geometry - Geometry to use, if omitted will create a new GraphicsGeometry instance.
   */ constructor(geometry = null){
        super(), this.shader = null, this.pluginName = "batch", this.currentPath = null, this.batches = [], this.batchTint = -1, this.batchDirty = -1, this.vertexData = null, this._fillStyle = new (0, $5Q1Vs.FillStyle)(), this._lineStyle = new (0, $d8fAV.LineStyle)(), this._matrix = null, this._holeMode = !1, this.state = (0, $bUqaG.State).for2d(), this._geometry = geometry || new (0, $k5kgH.GraphicsGeometry)(), this._geometry.refCount++, this._transformID = -1, this._tintColor = new (0, $1PNws.Color)(16777215), this.blendMode = (0, $lmRm8.BLEND_MODES).NORMAL;
    }
    /**
   * Includes vertex positions, face indices, normals, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
   * @readonly
   */ get geometry() {
        return this._geometry;
    }
    /**
   * Creates a new Graphics object with the same values as this one.
   * Note that only the geometry of the object is cloned, not its transform (position,scale,etc)
   * @returns - A clone of the graphics object
   */ clone() {
        return this.finishPoly(), new _Graphics2(this._geometry);
    }
    /**
   * The blend mode to be applied to the graphic shape. Apply a value of
   * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.  Note that, since each
   * primitive in the GraphicsGeometry list is rendered sequentially, modes
   * such as `PIXI.BLEND_MODES.ADD` and `PIXI.BLEND_MODES.MULTIPLY` will
   * be applied per-primitive.
   * @default PIXI.BLEND_MODES.NORMAL
   */ set blendMode(value) {
        this.state.blendMode = value;
    }
    get blendMode() {
        return this.state.blendMode;
    }
    /**
   * The tint applied to each graphic shape. This is a hex value. A value of
   * 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value);
    }
    /**
   * The current fill style.
   * @readonly
   */ get fill() {
        return this._fillStyle;
    }
    /**
   * The current line style.
   * @readonly
   */ get line() {
        return this._lineStyle;
    }
    lineStyle(options = null, color = 0, alpha, alignment = 0.5, native = !1) {
        return typeof options == "number" && (options = {
            width: options,
            color: color,
            alpha: alpha,
            alignment: alignment,
            native: native
        }), this.lineTextureStyle(options);
    }
    /**
   * Like line style but support texture for line fill.
   * @param [options] - Collection of options for setting line style.
   * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to use
   * @param {PIXI.ColorSource} [options.color=0x0] - color of the line to draw, will update the objects stored style.
   *  Default 0xFFFFFF if texture present.
   * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
   * @param {PIXI.Matrix} [options.matrix=null] - Texture matrix to transform texture
   * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outer).
   *        WebGL only.
   * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
   * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
   * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
   * @param {number}[options.miterLimit=10] - miter limit ratio
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */ lineTextureStyle(options) {
        const defaultLineStyleOptions = {
            width: 0,
            texture: (0, $cWOCu.Texture).WHITE,
            color: options?.texture ? 16777215 : 0,
            matrix: null,
            alignment: 0.5,
            native: !1,
            cap: (0, $khIUA.LINE_CAP).BUTT,
            join: (0, $khIUA.LINE_JOIN).MITER,
            miterLimit: 10
        };
        options = Object.assign(defaultLineStyleOptions, options), this.normalizeColor(options), this.currentPath && this.startPoly();
        const visible = options.width > 0 && options.alpha > 0;
        return visible ? (options.matrix && (options.matrix = options.matrix.clone(), options.matrix.invert()), Object.assign(this._lineStyle, {
            visible: visible
        }, options)) : this._lineStyle.reset(), this;
    }
    /**
   * Start a polygon object internally.
   * @protected
   */ startPoly() {
        if (this.currentPath) {
            const points = this.currentPath.points, len = this.currentPath.points.length;
            len > 2 && (this.drawShape(this.currentPath), this.currentPath = new (0, $duPDq.Polygon)(), this.currentPath.closeStroke = !1, this.currentPath.points.push(points[len - 2], points[len - 1]));
        } else this.currentPath = new (0, $duPDq.Polygon)(), this.currentPath.closeStroke = !1;
    }
    /**
   * Finish the polygon object.
   * @protected
   */ finishPoly() {
        this.currentPath && (this.currentPath.points.length > 2 ? (this.drawShape(this.currentPath), this.currentPath = null) : this.currentPath.points.length = 0);
    }
    /**
   * Moves the current drawing position to x, y.
   * @param x - the X coordinate to move to
   * @param y - the Y coordinate to move to
   * @returns - This Graphics object. Good for chaining method calls
   */ moveTo(x, y) {
        return this.startPoly(), this.currentPath.points[0] = x, this.currentPath.points[1] = y, this;
    }
    /**
   * Draws a line using the current line style from the current drawing position to (x, y);
   * The current drawing position is then set to (x, y).
   * @param x - the X coordinate to draw to
   * @param y - the Y coordinate to draw to
   * @returns - This Graphics object. Good for chaining method calls
   */ lineTo(x, y) {
        this.currentPath || this.moveTo(0, 0);
        const points = this.currentPath.points, fromX = points[points.length - 2], fromY = points[points.length - 1];
        return (fromX !== x || fromY !== y) && points.push(x, y), this;
    }
    /**
   * Initialize the curve
   * @param x
   * @param y
   */ _initCurve(x = 0, y = 0) {
        this.currentPath ? this.currentPath.points.length === 0 && (this.currentPath.points = [
            x,
            y
        ]) : this.moveTo(x, y);
    }
    /**
   * Calculate the points for a quadratic bezier curve and then draws it.
   * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns - This Graphics object. Good for chaining method calls
   */ quadraticCurveTo(cpX, cpY, toX, toY) {
        this._initCurve();
        const points = this.currentPath.points;
        return points.length === 0 && this.moveTo(0, 0), (0, $aryzn.QuadraticUtils).curveTo(cpX, cpY, toX, toY, points), this;
    }
    /**
   * Calculate the points for a bezier curve and then draws it.
   * @param cpX - Control point x
   * @param cpY - Control point y
   * @param cpX2 - Second Control point x
   * @param cpY2 - Second Control point y
   * @param toX - Destination point x
   * @param toY - Destination point y
   * @returns This Graphics object. Good for chaining method calls
   */ bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
        return this._initCurve(), (0, $3XPH0.BezierUtils).curveTo(cpX, cpY, cpX2, cpY2, toX, toY, this.currentPath.points), this;
    }
    /**
   * The `arcTo` method creates an arc/curve between two tangents on the canvas.
   * The first tangent is from the start point to the first control point,
   * and the second tangent is from the first control point to the second control point.
   * Note that the second control point is not necessarily the end point of the arc.
   *
   * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
   * @param x1 - The x-coordinate of the first control point of the arc
   * @param y1 - The y-coordinate of the first control point of the arc
   * @param x2 - The x-coordinate of the second control point of the arc
   * @param y2 - The y-coordinate of the second control point of the arc
   * @param radius - The radius of the arc
   * @returns - This Graphics object. Good for chaining method calls
   */ arcTo(x1, y1, x2, y2, radius) {
        this._initCurve(x1, y1);
        const points = this.currentPath.points, result = (0, $f22t2.ArcUtils).curveTo(x1, y1, x2, y2, radius, points);
        if (result) {
            const { cx: cx, cy: cy, radius: radius2, startAngle: startAngle, endAngle: endAngle, anticlockwise: anticlockwise } = result;
            this.arc(cx, cy, radius2, startAngle, endAngle, anticlockwise);
        }
        return this;
    }
    /**
   * The arc method creates an arc/curve (used to create circles, or parts of circles).
   * @param cx - The x-coordinate of the center of the circle
   * @param cy - The y-coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @param startAngle - The starting angle, in radians (0 is at the 3 o'clock position
   *  of the arc's circle)
   * @param endAngle - The ending angle, in radians
   * @param anticlockwise - Specifies whether the drawing should be
   *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
   *  indicates counter-clockwise.
   * @returns - This Graphics object. Good for chaining method calls
   */ arc(cx, cy, radius, startAngle, endAngle, anticlockwise = !1) {
        if (startAngle === endAngle) return this;
        if (!anticlockwise && endAngle <= startAngle ? endAngle += (0, $lbGGA.PI_2) : anticlockwise && startAngle <= endAngle && (startAngle += (0, $lbGGA.PI_2)), endAngle - startAngle === 0) return this;
        const startX = cx + Math.cos(startAngle) * radius, startY = cy + Math.sin(startAngle) * radius, eps = this._geometry.closePointEps;
        let points = this.currentPath ? this.currentPath.points : null;
        if (points) {
            const xDiff = Math.abs(points[points.length - 2] - startX), yDiff = Math.abs(points[points.length - 1] - startY);
            xDiff < eps && yDiff < eps || points.push(startX, startY);
        } else this.moveTo(startX, startY), points = this.currentPath.points;
        return (0, $f22t2.ArcUtils).arc(startX, startY, cx, cy, radius, startAngle, endAngle, anticlockwise, points), this;
    }
    /**
   * Specifies a simple one-color fill that subsequent calls to other Graphics methods
   * (such as lineTo() or drawCircle()) use when drawing.
   * @param {PIXI.ColorSource} color - the color of the fill
   * @param alpha - the alpha of the fill, will override the color's alpha
   * @returns - This Graphics object. Suitable for chaining method calls
   */ beginFill(color = 0, alpha) {
        return this.beginTextureFill({
            texture: (0, $cWOCu.Texture).WHITE,
            color: color,
            alpha: alpha
        });
    }
    /**
   * Normalize the color input from options for line style or fill
   * @param {PIXI.IFillStyleOptions} options - Fill style object.
   */ normalizeColor(options) {
        const temp = (0, $1PNws.Color).shared.setValue(options.color ?? 0);
        options.color = temp.toNumber(), options.alpha ?? (options.alpha = temp.alpha);
    }
    /**
   * Begin the texture fill.
   * Note: The wrap mode of the texture is forced to REPEAT on render.
   * @param options - Fill style object.
   * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to fill
   * @param {PIXI.ColorSource} [options.color=0xffffff] - Background to fill behind texture
   * @param {number} [options.alpha] - Alpha of fill, overrides the color's alpha
   * @param {PIXI.Matrix} [options.matrix=null] - Transform matrix
   * @returns {PIXI.Graphics} This Graphics object. Good for chaining method calls
   */ beginTextureFill(options) {
        const defaultOptions = {
            texture: (0, $cWOCu.Texture).WHITE,
            color: 16777215,
            matrix: null
        };
        options = Object.assign(defaultOptions, options), this.normalizeColor(options), this.currentPath && this.startPoly();
        const visible = options.alpha > 0;
        return visible ? (options.matrix && (options.matrix = options.matrix.clone(), options.matrix.invert()), Object.assign(this._fillStyle, {
            visible: visible
        }, options)) : this._fillStyle.reset(), this;
    }
    /**
   * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
   * @returns - This Graphics object. Good for chaining method calls
   */ endFill() {
        return this.finishPoly(), this._fillStyle.reset(), this;
    }
    /**
   * Draws a rectangle shape.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @returns - This Graphics object. Good for chaining method calls
   */ drawRect(x, y, width, height) {
        return this.drawShape(new (0, $kZOeV.Rectangle)(x, y, width, height));
    }
    /**
   * Draw a rectangle shape with rounded/beveled corners.
   * @param x - The X coord of the top-left of the rectangle
   * @param y - The Y coord of the top-left of the rectangle
   * @param width - The width of the rectangle
   * @param height - The height of the rectangle
   * @param radius - Radius of the rectangle corners
   * @returns - This Graphics object. Good for chaining method calls
   */ drawRoundedRect(x, y, width, height, radius) {
        return this.drawShape(new (0, $3qn70.RoundedRectangle)(x, y, width, height, radius));
    }
    /**
   * Draws a circle.
   * @param x - The X coordinate of the center of the circle
   * @param y - The Y coordinate of the center of the circle
   * @param radius - The radius of the circle
   * @returns - This Graphics object. Good for chaining method calls
   */ drawCircle(x, y, radius) {
        return this.drawShape(new (0, $8mUry.Circle)(x, y, radius));
    }
    /**
   * Draws an ellipse.
   * @param x - The X coordinate of the center of the ellipse
   * @param y - The Y coordinate of the center of the ellipse
   * @param width - The half width of the ellipse
   * @param height - The half height of the ellipse
   * @returns - This Graphics object. Good for chaining method calls
   */ drawEllipse(x, y, width, height) {
        return this.drawShape(new (0, $gBsEB.Ellipse)(x, y, width, height));
    }
    /**
   * Draws a polygon using the given path.
   * @param {number[]|PIXI.IPointData[]|PIXI.Polygon} path - The path data used to construct the polygon.
   * @returns - This Graphics object. Good for chaining method calls
   */ drawPolygon(...path) {
        let points, closeStroke = !0;
        const poly = path[0];
        poly.points ? (closeStroke = poly.closeStroke, points = poly.points) : Array.isArray(path[0]) ? points = path[0] : points = path;
        const shape = new (0, $duPDq.Polygon)(points);
        return shape.closeStroke = closeStroke, this.drawShape(shape), this;
    }
    /**
   * Draw any shape.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - Shape to draw
   * @returns - This Graphics object. Good for chaining method calls
   */ drawShape(shape) {
        return this._holeMode ? this._geometry.drawHole(shape, this._matrix) : this._geometry.drawShape(shape, this._fillStyle.clone(), this._lineStyle.clone(), this._matrix), this;
    }
    /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This Graphics object. Good for chaining method calls
   */ clear() {
        return this._geometry.clear(), this._lineStyle.reset(), this._fillStyle.reset(), this._boundsID++, this._matrix = null, this._holeMode = !1, this.currentPath = null, this;
    }
    /**
   * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
   * masked with gl.scissor.
   * @returns - True if only 1 rect.
   */ isFastRect() {
        const data = this._geometry.graphicsData;
        return data.length === 1 && data[0].shape.type === (0, $lbGGA.SHAPES).RECT && !data[0].matrix && !data[0].holes.length && !(data[0].lineStyle.visible && data[0].lineStyle.width);
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        this.finishPoly();
        const geometry = this._geometry;
        geometry.updateBatches(), geometry.batchable ? (this.batchDirty !== geometry.batchDirty && this._populateBatches(), this._renderBatched(renderer)) : (renderer.batch.flush(), this._renderDirect(renderer));
    }
    /** Populating batches for rendering. */ _populateBatches() {
        const geometry = this._geometry, blendMode = this.blendMode, len = geometry.batches.length;
        this.batchTint = -1, this._transformID = -1, this.batchDirty = geometry.batchDirty, this.batches.length = len, this.vertexData = new Float32Array(geometry.points);
        for(let i = 0; i < len; i++){
            const gI = geometry.batches[i], color = gI.style.color, vertexData = new Float32Array(this.vertexData.buffer, gI.attribStart * 8, gI.attribSize * 2), uvs = new Float32Array(geometry.uvsFloat32.buffer, gI.attribStart * 8, gI.attribSize * 2), indices = new Uint16Array(geometry.indicesUint16.buffer, gI.start * 2, gI.size), batch = {
                vertexData: vertexData,
                blendMode: blendMode,
                indices: indices,
                uvs: uvs,
                _batchRGB: (0, $1PNws.Color).shared.setValue(color).toRgbArray(),
                _tintRGB: color,
                _texture: gI.style.texture,
                alpha: gI.style.alpha,
                worldAlpha: 1
            };
            this.batches[i] = batch;
        }
    }
    /**
   * Renders the batches using the BathedRenderer plugin
   * @param renderer - The renderer
   */ _renderBatched(renderer) {
        if (this.batches.length) {
            renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), this.calculateVertices(), this.calculateTints();
            for(let i = 0, l = this.batches.length; i < l; i++){
                const batch = this.batches[i];
                batch.worldAlpha = this.worldAlpha * batch.alpha, renderer.plugins[this.pluginName].render(batch);
            }
        }
    }
    /**
   * Renders the graphics direct
   * @param renderer - The renderer
   */ _renderDirect(renderer) {
        const shader = this._resolveDirectShader(renderer), geometry = this._geometry, worldAlpha = this.worldAlpha, uniforms = shader.uniforms, drawCalls = geometry.drawCalls;
        uniforms.translationMatrix = this.transform.worldTransform, (0, $1PNws.Color).shared.setValue(this._tintColor).premultiply(worldAlpha).toArray(uniforms.tint), renderer.shader.bind(shader), renderer.geometry.bind(geometry, shader), renderer.state.set(this.state);
        for(let i = 0, l = drawCalls.length; i < l; i++)this._renderDrawCallDirect(renderer, geometry.drawCalls[i]);
    }
    /**
   * Renders specific DrawCall
   * @param renderer
   * @param drawCall
   */ _renderDrawCallDirect(renderer, drawCall) {
        const { texArray: texArray, type: type, size: size, start: start } = drawCall, groupTextureCount = texArray.count;
        for(let j = 0; j < groupTextureCount; j++)renderer.texture.bind(texArray.elements[j], j);
        renderer.geometry.draw(type, size, start);
    }
    /**
   * Resolves shader for direct rendering
   * @param renderer - The renderer
   */ _resolveDirectShader(renderer) {
        let shader = this.shader;
        const pluginName = this.pluginName;
        if (!shader) {
            if (!$680a5efca7e434a6$var$DEFAULT_SHADERS[pluginName]) {
                const { maxTextures: maxTextures } = renderer.plugins[pluginName], sampleValues = new Int32Array(maxTextures);
                for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
                const uniforms = {
                    tint: new Float32Array([
                        1,
                        1,
                        1,
                        1
                    ]),
                    translationMatrix: new (0, $6wJoy.Matrix)(),
                    default: (0, $BpNwR.UniformGroup).from({
                        uSamplers: sampleValues
                    }, !0)
                }, program = renderer.plugins[pluginName]._shader.program;
                $680a5efca7e434a6$var$DEFAULT_SHADERS[pluginName] = new (0, $2cKpP.Shader)(program, uniforms);
            }
            shader = $680a5efca7e434a6$var$DEFAULT_SHADERS[pluginName];
        }
        return shader;
    }
    /**
   * Retrieves the bounds of the graphic shape as a rectangle object.
   * @see PIXI.GraphicsGeometry#bounds
   */ _calculateBounds() {
        this.finishPoly();
        const geometry = this._geometry;
        if (!geometry.graphicsData.length) return;
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = geometry.bounds;
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    /**
   * Tests if a point is inside this graphics object
   * @param point - the point to test
   * @returns - the result of the test
   */ containsPoint(point) {
        return this.worldTransform.applyInverse(point, _Graphics2._TEMP_POINT), this._geometry.containsPoint(_Graphics2._TEMP_POINT);
    }
    /** Recalculate the tint by applying tint to batches using Graphics tint. */ calculateTints() {
        if (this.batchTint !== this.tint) {
            this.batchTint = this._tintColor.toNumber();
            for(let i = 0; i < this.batches.length; i++){
                const batch = this.batches[i];
                batch._tintRGB = (0, $1PNws.Color).shared.setValue(this._tintColor).multiply(batch._batchRGB).toLittleEndianNumber();
            }
        }
    }
    /** If there's a transform update or a change to the shape of the geometry, recalculate the vertices. */ calculateVertices() {
        const wtID = this.transform._worldID;
        if (this._transformID === wtID) return;
        this._transformID = wtID;
        const wt = this.transform.worldTransform, a = wt.a, b = wt.b, c = wt.c, d = wt.d, tx = wt.tx, ty = wt.ty, data = this._geometry.points, vertexData = this.vertexData;
        let count = 0;
        for(let i = 0; i < data.length; i += 2){
            const x = data[i], y = data[i + 1];
            vertexData[count++] = a * x + c * y + tx, vertexData[count++] = d * y + b * x + ty;
        }
    }
    /**
   * Closes the current path.
   * @returns - Returns itself.
   */ closePath() {
        const currentPath = this.currentPath;
        return currentPath && (currentPath.closeStroke = !0, this.finishPoly()), this;
    }
    /**
   * Apply a matrix to the positional data.
   * @param matrix - Matrix to use for transform current shape.
   * @returns - Returns itself.
   */ setMatrix(matrix) {
        return this._matrix = matrix, this;
    }
    /**
   * Begin adding holes to the last draw shape
   * IMPORTANT: holes must be fully inside a shape to work
   * Also weirdness ensues if holes overlap!
   * Ellipses, Circles, Rectangles and Rounded Rectangles cannot be holes or host for holes in CanvasRenderer,
   * please use `moveTo` `lineTo`, `quadraticCurveTo` if you rely on pixi-legacy bundle.
   * @returns - Returns itself.
   */ beginHole() {
        return this.finishPoly(), this._holeMode = !0, this;
    }
    /**
   * End adding holes to the last draw shape.
   * @returns - Returns itself.
   */ endHole() {
        return this.finishPoly(), this._holeMode = !1, this;
    }
    /**
   * Destroys the Graphics object.
   * @param options - Options parameter. A boolean will act as if all
   *  options have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have
   *  their destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        this._geometry.refCount--, this._geometry.refCount === 0 && this._geometry.dispose(), this._matrix = null, this.currentPath = null, this._lineStyle.destroy(), this._lineStyle = null, this._fillStyle.destroy(), this._fillStyle = null, this._geometry = null, this.shader = null, this.vertexData = null, this.batches.length = 0, this.batches = null, super.destroy(options);
    }
};
$680a5efca7e434a6$var$_Graphics.curves = (0, $khIUA.curves), /**
* Temporary point to use for containsPoint.
* @private
*/ $680a5efca7e434a6$var$_Graphics._TEMP_POINT = new (0, $gnwPx.Point)();
let $680a5efca7e434a6$export$29d3e417456abdad = $680a5efca7e434a6$var$_Graphics;

});
parcelRegister("k5kgH", function(module, exports) {

$parcel$export(module.exports, "GraphicsGeometry", () => $62d06b90af230081$export$c707987b44ce3a12);
parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $6qB4i = parcelRequire("6qB4i");
var $7Gazv = parcelRequire("7Gazv");
var $ajAp7 = parcelRequire("ajAp7");
var $1PNws = parcelRequire("1PNws");
var $lmRm8 = parcelRequire("lmRm8");
var $gnwPx = parcelRequire("gnwPx");
parcelRequire("gD5uZ");
var $aMxkH = parcelRequire("aMxkH");

var $6tEuM = parcelRequire("6tEuM");

var $ln77Y = parcelRequire("ln77Y");

var $exTB6 = parcelRequire("exTB6");

var $iB9oV = parcelRequire("iB9oV");

var $bAuqa = parcelRequire("bAuqa");
const $62d06b90af230081$var$tmpPoint = new (0, $gnwPx.Point)(), $62d06b90af230081$var$_GraphicsGeometry = class _GraphicsGeometry2 extends (0, $7Gazv.BatchGeometry) {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(){
        super(), this.closePointEps = 1e-4, this.boundsPadding = 0, this.uvsFloat32 = null, this.indicesUint16 = null, this.batchable = !1, this.points = [], this.colors = [], this.uvs = [], this.indices = [], this.textureIds = [], this.graphicsData = [], this.drawCalls = [], this.batchDirty = -1, this.batches = [], this.dirty = 0, this.cacheDirty = -1, this.clearDirty = 0, this.shapeIndex = 0, this._bounds = new (0, $aMxkH.Bounds)(), this.boundsDirty = -1;
    }
    /**
   * Get the current bounds of the graphic geometry.
   *
   * Since 6.5.0, bounds of the graphics geometry are calculated based on the vertices of generated geometry.
   * Since shapes or strokes with full transparency (`alpha: 0`) will not generate geometry, they are not considered
   * when calculating bounds for the graphics geometry. See PR [#8343]{@link https://github.com/pixijs/pixijs/pull/8343}
   * and issue [#8623]{@link https://github.com/pixijs/pixijs/pull/8623}.
   * @readonly
   */ get bounds() {
        return this.updateBatches(), this.boundsDirty !== this.dirty && (this.boundsDirty = this.dirty, this.calculateBounds()), this._bounds;
    }
    /** Call if you changed graphicsData manually. Empties all batch buffers. */ invalidate() {
        this.boundsDirty = -1, this.dirty++, this.batchDirty++, this.shapeIndex = 0, this.points.length = 0, this.colors.length = 0, this.uvs.length = 0, this.indices.length = 0, this.textureIds.length = 0;
        for(let i = 0; i < this.drawCalls.length; i++)this.drawCalls[i].texArray.clear(), (0, $ln77Y.DRAW_CALL_POOL).push(this.drawCalls[i]);
        this.drawCalls.length = 0;
        for(let i = 0; i < this.batches.length; i++){
            const batchPart = this.batches[i];
            batchPart.reset(), (0, $ln77Y.BATCH_POOL).push(batchPart);
        }
        this.batches.length = 0;
    }
    /**
   * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
   * @returns - This GraphicsGeometry object. Good for chaining method calls
   */ clear() {
        return this.graphicsData.length > 0 && (this.invalidate(), this.clearDirty++, this.graphicsData.length = 0), this;
    }
    /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - Defines style of the fill.
   * @param lineStyle - Defines style of the lines.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */ drawShape(shape, fillStyle = null, lineStyle = null, matrix = null) {
        const data = new (0, $6tEuM.GraphicsData)(shape, fillStyle, lineStyle, matrix);
        return this.graphicsData.push(data), this.dirty++, this;
    }
    /**
   * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param matrix - Transform applied to the points of the shape.
   * @returns - Returns geometry for chaining.
   */ drawHole(shape, matrix = null) {
        if (!this.graphicsData.length) return null;
        const data = new (0, $6tEuM.GraphicsData)(shape, null, null, matrix), lastShape = this.graphicsData[this.graphicsData.length - 1];
        return data.lineStyle = lastShape.lineStyle, lastShape.holes.push(data), this.dirty++, this;
    }
    /** Destroys the GraphicsGeometry object. */ destroy() {
        super.destroy();
        for(let i = 0; i < this.graphicsData.length; ++i)this.graphicsData[i].destroy();
        this.points.length = 0, this.points = null, this.colors.length = 0, this.colors = null, this.uvs.length = 0, this.uvs = null, this.indices.length = 0, this.indices = null, this.indexBuffer.destroy(), this.indexBuffer = null, this.graphicsData.length = 0, this.graphicsData = null, this.drawCalls.length = 0, this.drawCalls = null, this.batches.length = 0, this.batches = null, this._bounds = null;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        const graphicsData = this.graphicsData;
        for(let i = 0; i < graphicsData.length; ++i){
            const data = graphicsData[i];
            if (data.fillStyle.visible && data.shape && (data.matrix ? data.matrix.applyInverse(point, $62d06b90af230081$var$tmpPoint) : $62d06b90af230081$var$tmpPoint.copyFrom(point), data.shape.contains($62d06b90af230081$var$tmpPoint.x, $62d06b90af230081$var$tmpPoint.y))) {
                let hitHole = !1;
                if (data.holes) {
                    for(let i2 = 0; i2 < data.holes.length; i2++)if (data.holes[i2].shape.contains($62d06b90af230081$var$tmpPoint.x, $62d06b90af230081$var$tmpPoint.y)) {
                        hitHole = !0;
                        break;
                    }
                }
                if (!hitHole) return !0;
            }
        }
        return !1;
    }
    /**
   * Generates intermediate batch data. Either gets converted to drawCalls
   * or used to convert to batch objects directly by the Graphics object.
   */ updateBatches() {
        if (!this.graphicsData.length) {
            this.batchable = !0;
            return;
        }
        if (!this.validateBatching()) return;
        this.cacheDirty = this.dirty;
        const uvs = this.uvs, graphicsData = this.graphicsData;
        let batchPart = null, currentStyle = null;
        this.batches.length > 0 && (batchPart = this.batches[this.batches.length - 1], currentStyle = batchPart.style);
        for(let i = this.shapeIndex; i < graphicsData.length; i++){
            this.shapeIndex++;
            const data = graphicsData[i], fillStyle = data.fillStyle, lineStyle = data.lineStyle;
            (0, $ln77Y.FILL_COMMANDS)[data.type].build(data), data.matrix && this.transformPoints(data.points, data.matrix), (fillStyle.visible || lineStyle.visible) && this.processHoles(data.holes);
            for(let j = 0; j < 2; j++){
                const style = j === 0 ? fillStyle : lineStyle;
                if (!style.visible) continue;
                const nextTexture = style.texture.baseTexture, index2 = this.indices.length, attribIndex = this.points.length / 2;
                nextTexture.wrapMode = (0, $lmRm8.WRAP_MODES).REPEAT, j === 0 ? this.processFill(data) : this.processLine(data);
                const size = this.points.length / 2 - attribIndex;
                size !== 0 && (batchPart && !this._compareStyles(currentStyle, style) && (batchPart.end(index2, attribIndex), batchPart = null), batchPart || (batchPart = (0, $ln77Y.BATCH_POOL).pop() || new (0, $exTB6.BatchPart)(), batchPart.begin(style, index2, attribIndex), this.batches.push(batchPart), currentStyle = style), this.addUvs(this.points, uvs, style.texture, attribIndex, size, style.matrix));
            }
        }
        const index = this.indices.length, attrib = this.points.length / 2;
        if (batchPart && batchPart.end(index, attrib), this.batches.length === 0) {
            this.batchable = !0;
            return;
        }
        const need32 = attrib > 65535;
        this.indicesUint16 && this.indices.length === this.indicesUint16.length && need32 === this.indicesUint16.BYTES_PER_ELEMENT > 2 ? this.indicesUint16.set(this.indices) : this.indicesUint16 = need32 ? new Uint32Array(this.indices) : new Uint16Array(this.indices), this.batchable = this.isBatchable(), this.batchable ? this.packBatches() : this.buildDrawCalls();
    }
    /**
   * Affinity check
   * @param styleA
   * @param styleB
   */ _compareStyles(styleA, styleB) {
        return !(!styleA || !styleB || styleA.texture.baseTexture !== styleB.texture.baseTexture || styleA.color + styleA.alpha !== styleB.color + styleB.alpha || !!styleA.native != !!styleB.native);
    }
    /** Test geometry for batching process. */ validateBatching() {
        if (this.dirty === this.cacheDirty || !this.graphicsData.length) return !1;
        for(let i = 0, l = this.graphicsData.length; i < l; i++){
            const data = this.graphicsData[i], fill = data.fillStyle, line = data.lineStyle;
            if (fill && !fill.texture.baseTexture.valid || line && !line.texture.baseTexture.valid) return !1;
        }
        return !0;
    }
    /** Offset the indices so that it works with the batcher. */ packBatches() {
        this.batchDirty++, this.uvsFloat32 = new Float32Array(this.uvs);
        const batches = this.batches;
        for(let i = 0, l = batches.length; i < l; i++){
            const batch = batches[i];
            for(let j = 0; j < batch.size; j++){
                const index = batch.start + j;
                this.indicesUint16[index] = this.indicesUint16[index] - batch.attribStart;
            }
        }
    }
    /**
   * Checks to see if this graphics geometry can be batched.
   * Currently it needs to be small enough and not contain any native lines.
   */ isBatchable() {
        if (this.points.length > 131070) return !1;
        const batches = this.batches;
        for(let i = 0; i < batches.length; i++)if (batches[i].style.native) return !1;
        return this.points.length < _GraphicsGeometry2.BATCHABLE_SIZE * 2;
    }
    /** Converts intermediate batches data to drawCalls. */ buildDrawCalls() {
        let TICK = ++(0, $4oWO8.BaseTexture)._globalBatch;
        for(let i = 0; i < this.drawCalls.length; i++)this.drawCalls[i].texArray.clear(), (0, $ln77Y.DRAW_CALL_POOL).push(this.drawCalls[i]);
        this.drawCalls.length = 0;
        const colors = this.colors, textureIds = this.textureIds;
        let currentGroup = (0, $ln77Y.DRAW_CALL_POOL).pop();
        currentGroup || (currentGroup = new (0, $6qB4i.BatchDrawCall)(), currentGroup.texArray = new (0, $ajAp7.BatchTextureArray)()), currentGroup.texArray.count = 0, currentGroup.start = 0, currentGroup.size = 0, currentGroup.type = (0, $lmRm8.DRAW_MODES).TRIANGLES;
        let textureCount = 0, currentTexture = null, textureId = 0, native = !1, drawMode = (0, $lmRm8.DRAW_MODES).TRIANGLES, index = 0;
        this.drawCalls.push(currentGroup);
        for(let i = 0; i < this.batches.length; i++){
            const data = this.batches[i], maxTextures = 8, style = data.style, nextTexture = style.texture.baseTexture;
            native !== !!style.native && (native = !!style.native, drawMode = native ? (0, $lmRm8.DRAW_MODES).LINES : (0, $lmRm8.DRAW_MODES).TRIANGLES, currentTexture = null, textureCount = maxTextures, TICK++), currentTexture !== nextTexture && (currentTexture = nextTexture, nextTexture._batchEnabled !== TICK && (textureCount === maxTextures && (TICK++, textureCount = 0, currentGroup.size > 0 && (currentGroup = (0, $ln77Y.DRAW_CALL_POOL).pop(), currentGroup || (currentGroup = new (0, $6qB4i.BatchDrawCall)(), currentGroup.texArray = new (0, $ajAp7.BatchTextureArray)()), this.drawCalls.push(currentGroup)), currentGroup.start = index, currentGroup.size = 0, currentGroup.texArray.count = 0, currentGroup.type = drawMode), nextTexture.touched = 1, nextTexture._batchEnabled = TICK, nextTexture._batchLocation = textureCount, nextTexture.wrapMode = (0, $lmRm8.WRAP_MODES).REPEAT, currentGroup.texArray.elements[currentGroup.texArray.count++] = nextTexture, textureCount++)), currentGroup.size += data.size, index += data.size, textureId = nextTexture._batchLocation, this.addColors(colors, style.color, style.alpha, data.attribSize, data.attribStart), this.addTextureIds(textureIds, textureId, data.attribSize, data.attribStart);
        }
        (0, $4oWO8.BaseTexture)._globalBatch = TICK, this.packAttributes();
    }
    /** Packs attributes to single buffer. */ packAttributes() {
        const verts = this.points, uvs = this.uvs, colors = this.colors, textureIds = this.textureIds, glPoints = new ArrayBuffer(verts.length * 12), f32 = new Float32Array(glPoints), u32 = new Uint32Array(glPoints);
        let p = 0;
        for(let i = 0; i < verts.length / 2; i++)f32[p++] = verts[i * 2], f32[p++] = verts[i * 2 + 1], f32[p++] = uvs[i * 2], f32[p++] = uvs[i * 2 + 1], u32[p++] = colors[i], f32[p++] = textureIds[i];
        this._buffer.update(glPoints), this._indexBuffer.update(this.indicesUint16);
    }
    /**
   * Process fill part of Graphics.
   * @param data
   */ processFill(data) {
        data.holes.length ? (0, $iB9oV.buildPoly).triangulate(data, this) : (0, $ln77Y.FILL_COMMANDS)[data.type].triangulate(data, this);
    }
    /**
   * Process line part of Graphics.
   * @param data
   */ processLine(data) {
        (0, $bAuqa.buildLine)(data, this);
        for(let i = 0; i < data.holes.length; i++)(0, $bAuqa.buildLine)(data.holes[i], this);
    }
    /**
   * Process the holes data.
   * @param holes
   */ processHoles(holes) {
        for(let i = 0; i < holes.length; i++){
            const hole = holes[i];
            (0, $ln77Y.FILL_COMMANDS)[hole.type].build(hole), hole.matrix && this.transformPoints(hole.points, hole.matrix);
        }
    }
    /** Update the local bounds of the object. Expensive to use performance-wise. */ calculateBounds() {
        const bounds = this._bounds;
        bounds.clear(), bounds.addVertexData(this.points, 0, this.points.length), bounds.pad(this.boundsPadding, this.boundsPadding);
    }
    /**
   * Transform points using matrix.
   * @param points - Points to transform
   * @param matrix - Transform matrix
   */ transformPoints(points, matrix) {
        for(let i = 0; i < points.length / 2; i++){
            const x = points[i * 2], y = points[i * 2 + 1];
            points[i * 2] = matrix.a * x + matrix.c * y + matrix.tx, points[i * 2 + 1] = matrix.b * x + matrix.d * y + matrix.ty;
        }
    }
    /**
   * Add colors.
   * @param colors - List of colors to add to
   * @param color - Color to add
   * @param alpha - Alpha to use
   * @param size - Number of colors to add
   * @param offset
   */ addColors(colors, color, alpha, size, offset = 0) {
        const bgr = (0, $1PNws.Color).shared.setValue(color).toLittleEndianNumber(), result = (0, $1PNws.Color).shared.setValue(bgr).toPremultiplied(alpha);
        colors.length = Math.max(colors.length, offset + size);
        for(let i = 0; i < size; i++)colors[offset + i] = result;
    }
    /**
   * Add texture id that the shader/fragment wants to use.
   * @param textureIds
   * @param id
   * @param size
   * @param offset
   */ addTextureIds(textureIds, id, size, offset = 0) {
        textureIds.length = Math.max(textureIds.length, offset + size);
        for(let i = 0; i < size; i++)textureIds[offset + i] = id;
    }
    /**
   * Generates the UVs for a shape.
   * @param verts - Vertices
   * @param uvs - UVs
   * @param texture - Reference to Texture
   * @param start - Index buffer start index.
   * @param size - The size/length for index buffer.
   * @param matrix - Optional transform for all points.
   */ addUvs(verts, uvs, texture, start, size, matrix = null) {
        let index = 0;
        const uvsStart = uvs.length, frame = texture.frame;
        for(; index < size;){
            let x = verts[(start + index) * 2], y = verts[(start + index) * 2 + 1];
            if (matrix) {
                const nx = matrix.a * x + matrix.c * y + matrix.tx;
                y = matrix.b * x + matrix.d * y + matrix.ty, x = nx;
            }
            index++, uvs.push(x / frame.width, y / frame.height);
        }
        const baseTexture = texture.baseTexture;
        (frame.width < baseTexture.width || frame.height < baseTexture.height) && this.adjustUvs(uvs, texture, uvsStart, size);
    }
    /**
   * Modify uvs array according to position of texture region
   * Does not work with rotated or trimmed textures
   * @param uvs - array
   * @param texture - region
   * @param start - starting index for uvs
   * @param size - how many points to adjust
   */ adjustUvs(uvs, texture, start, size) {
        const baseTexture = texture.baseTexture, eps = 1e-6, finish = start + size * 2, frame = texture.frame, scaleX = frame.width / baseTexture.width, scaleY = frame.height / baseTexture.height;
        let offsetX = frame.x / frame.width, offsetY = frame.y / frame.height, minX = Math.floor(uvs[start] + eps), minY = Math.floor(uvs[start + 1] + eps);
        for(let i = start + 2; i < finish; i += 2)minX = Math.min(minX, Math.floor(uvs[i] + eps)), minY = Math.min(minY, Math.floor(uvs[i + 1] + eps));
        offsetX -= minX, offsetY -= minY;
        for(let i = start; i < finish; i += 2)uvs[i] = (uvs[i] + offsetX) * scaleX, uvs[i + 1] = (uvs[i + 1] + offsetY) * scaleY;
    }
};
$62d06b90af230081$var$_GraphicsGeometry.BATCHABLE_SIZE = 100;
let $62d06b90af230081$export$c707987b44ce3a12 = $62d06b90af230081$var$_GraphicsGeometry;

});
parcelRegister("6tEuM", function(module, exports) {

$parcel$export(module.exports, "GraphicsData", () => $77ac160306b47509$export$94accce0eb494446);
class $77ac160306b47509$export$94accce0eb494446 {
    /**
   * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
   * @param fillStyle - the width of the line to draw
   * @param lineStyle - the color of the line to draw
   * @param matrix - Transform matrix
   */ constructor(shape, fillStyle = null, lineStyle = null, matrix = null){
        this.points = [], this.holes = [], this.shape = shape, this.lineStyle = lineStyle, this.fillStyle = fillStyle, this.matrix = matrix, this.type = shape.type;
    }
    /**
   * Creates a new GraphicsData object with the same values as this one.
   * @returns - Cloned GraphicsData object
   */ clone() {
        return new $77ac160306b47509$export$94accce0eb494446(this.shape, this.fillStyle, this.lineStyle, this.matrix);
    }
    /** Destroys the Graphics data. */ destroy() {
        this.shape = null, this.holes.length = 0, this.holes = null, this.points.length = 0, this.points = null, this.lineStyle = null, this.fillStyle = null;
    }
}

});


parcelRegister("5Q1Vs", function(module, exports) {

$parcel$export(module.exports, "FillStyle", () => $077009b4f19b9a33$export$c42b166860ccdbd8);
parcelRequire("inflE");
var $cWOCu = parcelRequire("cWOCu");
class $077009b4f19b9a33$export$c42b166860ccdbd8 {
    constructor(){
        this.color = 16777215, this.alpha = 1, this.texture = (0, $cWOCu.Texture).WHITE, this.matrix = null, this.visible = !1, this.reset();
    }
    /** Clones the object */ clone() {
        const obj = new $077009b4f19b9a33$export$c42b166860ccdbd8();
        return obj.color = this.color, obj.alpha = this.alpha, obj.texture = this.texture, obj.matrix = this.matrix, obj.visible = this.visible, obj;
    }
    /** Reset */ reset() {
        this.color = 16777215, this.alpha = 1, this.texture = (0, $cWOCu.Texture).WHITE, this.matrix = null, this.visible = !1;
    }
    /** Destroy and don't use after this. */ destroy() {
        this.texture = null, this.matrix = null;
    }
}

});

parcelRegister("d8fAV", function(module, exports) {

$parcel$export(module.exports, "LineStyle", () => $be79a60131aa6380$export$5d24e00cfde59887);

var $khIUA = parcelRequire("khIUA");

var $5Q1Vs = parcelRequire("5Q1Vs");
class $be79a60131aa6380$export$5d24e00cfde59887 extends (0, $5Q1Vs.FillStyle) {
    constructor(){
        super(...arguments), this.width = 0, this.alignment = 0.5, this.native = !1, this.cap = (0, $khIUA.LINE_CAP).BUTT, this.join = (0, $khIUA.LINE_JOIN).MITER, this.miterLimit = 10;
    }
    /** Clones the object. */ clone() {
        const obj = new $be79a60131aa6380$export$5d24e00cfde59887();
        return obj.color = this.color, obj.alpha = this.alpha, obj.texture = this.texture, obj.matrix = this.matrix, obj.visible = this.visible, obj.width = this.width, obj.alignment = this.alignment, obj.native = this.native, obj.cap = this.cap, obj.join = this.join, obj.miterLimit = this.miterLimit, obj;
    }
    /** Reset the line style to default. */ reset() {
        super.reset(), this.color = 0, this.alignment = 0.5, this.width = 0, this.native = !1, this.cap = (0, $khIUA.LINE_CAP).BUTT, this.join = (0, $khIUA.LINE_JOIN).MITER, this.miterLimit = 10;
    }
}

});



parcelRegister("4hxmX", function(module, exports) {

$parcel$export(module.exports, "NineSlicePlane", () => (parcelRequire("j4bZM")).NineSlicePlane);
$parcel$export(module.exports, "SimpleMesh", () => (parcelRequire("8C3Kt")).SimpleMesh);
$parcel$export(module.exports, "SimpleRope", () => (parcelRequire("dFgHQ")).SimpleRope);

var $9ypa7 = parcelRequire("9ypa7");

var $6BOQY = parcelRequire("6BOQY");

var $j4bZM = parcelRequire("j4bZM");

var $8C3Kt = parcelRequire("8C3Kt");

var $86xVt = parcelRequire("86xVt");

var $dFgHQ = parcelRequire("dFgHQ");

});
parcelRegister("9ypa7", function(module, exports) {

$parcel$export(module.exports, "PlaneGeometry", () => $9a4f9bc03d69f278$export$967d831af31f69ce);
parcelRequire("2m9sJ");
var $5GlKm = parcelRequire("5GlKm");
class $9a4f9bc03d69f278$export$967d831af31f69ce extends (0, $5GlKm.MeshGeometry) {
    /**
   * @param width - The width of the plane.
   * @param height - The height of the plane.
   * @param segWidth - Number of horizontal segments.
   * @param segHeight - Number of vertical segments.
   */ constructor(width = 100, height = 100, segWidth = 10, segHeight = 10){
        super(), this.segWidth = segWidth, this.segHeight = segHeight, this.width = width, this.height = height, this.build();
    }
    /**
   * Refreshes plane coordinates
   * @private
   */ build() {
        const total = this.segWidth * this.segHeight, verts = [], uvs = [], indices = [], segmentsX = this.segWidth - 1, segmentsY = this.segHeight - 1, sizeX = this.width / segmentsX, sizeY = this.height / segmentsY;
        for(let i = 0; i < total; i++){
            const x = i % this.segWidth, y = i / this.segWidth | 0;
            verts.push(x * sizeX, y * sizeY), uvs.push(x / segmentsX, y / segmentsY);
        }
        const totalSub = segmentsX * segmentsY;
        for(let i = 0; i < totalSub; i++){
            const xpos = i % segmentsX, ypos = i / segmentsX | 0, value = ypos * this.segWidth + xpos, value2 = ypos * this.segWidth + xpos + 1, value3 = (ypos + 1) * this.segWidth + xpos, value4 = (ypos + 1) * this.segWidth + xpos + 1;
            indices.push(value, value2, value3, value2, value4, value3);
        }
        this.buffers[0].data = new Float32Array(verts), this.buffers[1].data = new Float32Array(uvs), this.indexBuffer.data = new Uint16Array(indices), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
    }
}

});

parcelRegister("6BOQY", function(module, exports) {

$parcel$export(module.exports, "RopeGeometry", () => $b196529af8f08f50$export$6a9827483976bf64);
parcelRequire("2m9sJ");
var $5GlKm = parcelRequire("5GlKm");
class $b196529af8f08f50$export$6a9827483976bf64 extends (0, $5GlKm.MeshGeometry) {
    /**
   * @param width - The width (i.e., thickness) of the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param textureScale - By default the rope texture will be stretched to match
   *     rope length. If textureScale is positive this value will be treated as a scaling
   *     factor and the texture will preserve its aspect ratio instead. To create a tiling rope
   *     set baseTexture.wrapMode to {@link PIXI.WRAP_MODES.REPEAT} and use a power of two texture,
   *     then set textureScale=1 to keep the original texture pixel size.
   *     In order to reduce alpha channel artifacts provide a larger texture and downsample -
   *     i.e. set textureScale=0.5 to scale it down twice.
   */ constructor(width = 200, points, textureScale = 0){
        super(new Float32Array(points.length * 4), new Float32Array(points.length * 4), new Uint16Array((points.length - 1) * 6)), this.points = points, this._width = width, this.textureScale = textureScale, this.build();
    }
    /**
   * The width (i.e., thickness) of the rope.
   * @readonly
   */ get width() {
        return this._width;
    }
    /** Refreshes Rope indices and uvs */ build() {
        const points = this.points;
        if (!points) return;
        const vertexBuffer = this.getBuffer("aVertexPosition"), uvBuffer = this.getBuffer("aTextureCoord"), indexBuffer = this.getIndex();
        if (points.length < 1) return;
        vertexBuffer.data.length / 4 !== points.length && (vertexBuffer.data = new Float32Array(points.length * 4), uvBuffer.data = new Float32Array(points.length * 4), indexBuffer.data = new Uint16Array((points.length - 1) * 6));
        const uvs = uvBuffer.data, indices = indexBuffer.data;
        uvs[0] = 0, uvs[1] = 0, uvs[2] = 0, uvs[3] = 1;
        let amount = 0, prev = points[0];
        const textureWidth = this._width * this.textureScale, total = points.length;
        for(let i = 0; i < total; i++){
            const index = i * 4;
            if (this.textureScale > 0) {
                const dx = prev.x - points[i].x, dy = prev.y - points[i].y, distance = Math.sqrt(dx * dx + dy * dy);
                prev = points[i], amount += distance / textureWidth;
            } else amount = i / (total - 1);
            uvs[index] = amount, uvs[index + 1] = 0, uvs[index + 2] = amount, uvs[index + 3] = 1;
        }
        let indexCount = 0;
        for(let i = 0; i < total - 1; i++){
            const index = i * 2;
            indices[indexCount++] = index, indices[indexCount++] = index + 1, indices[indexCount++] = index + 2, indices[indexCount++] = index + 2, indices[indexCount++] = index + 1, indices[indexCount++] = index + 3;
        }
        uvBuffer.update(), indexBuffer.update(), this.updateVertices();
    }
    /** refreshes vertices of Rope mesh */ updateVertices() {
        const points = this.points;
        if (points.length < 1) return;
        let lastPoint = points[0], nextPoint, perpX = 0, perpY = 0;
        const vertices = this.buffers[0].data, total = points.length, halfWidth = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
        for(let i = 0; i < total; i++){
            const point = points[i], index = i * 4;
            i < points.length - 1 ? nextPoint = points[i + 1] : nextPoint = point, perpY = -(nextPoint.x - lastPoint.x), perpX = nextPoint.y - lastPoint.y;
            let ratio = (1 - i / (total - 1)) * 10;
            ratio > 1 && (ratio = 1);
            const perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            perpLength < 1e-6 ? (perpX = 0, perpY = 0) : (perpX /= perpLength, perpY /= perpLength, perpX *= halfWidth, perpY *= halfWidth), vertices[index] = point.x + perpX, vertices[index + 1] = point.y + perpY, vertices[index + 2] = point.x - perpX, vertices[index + 3] = point.y - perpY, lastPoint = point;
        }
        this.buffers[0].update();
    }
    update() {
        this.textureScale > 0 ? this.build() : this.updateVertices();
    }
}

});

parcelRegister("j4bZM", function(module, exports) {

$parcel$export(module.exports, "NineSlicePlane", () => $88c2e82640367c08$export$acdf4cb3f489544e);
parcelRequire("inflE");
var $cWOCu = parcelRequire("cWOCu");

var $86xVt = parcelRequire("86xVt");
const $88c2e82640367c08$var$DEFAULT_BORDER_SIZE = 10;
class $88c2e82640367c08$export$acdf4cb3f489544e extends (0, $86xVt.SimplePlane) {
    /**
   * @param texture - The texture to use on the NineSlicePlane.
   * @param {number} [leftWidth=10] - size of the left vertical bar (A)
   * @param {number} [topHeight=10] - size of the top horizontal bar (C)
   * @param {number} [rightWidth=10] - size of the right vertical bar (B)
   * @param {number} [bottomHeight=10] - size of the bottom horizontal bar (D)
   */ constructor(texture, leftWidth, topHeight, rightWidth, bottomHeight){
        super((0, $cWOCu.Texture).WHITE, 4, 4), this._origWidth = texture.orig.width, this._origHeight = texture.orig.height, this._width = this._origWidth, this._height = this._origHeight, this._leftWidth = leftWidth ?? texture.defaultBorders?.left ?? $88c2e82640367c08$var$DEFAULT_BORDER_SIZE, this._rightWidth = rightWidth ?? texture.defaultBorders?.right ?? $88c2e82640367c08$var$DEFAULT_BORDER_SIZE, this._topHeight = topHeight ?? texture.defaultBorders?.top ?? $88c2e82640367c08$var$DEFAULT_BORDER_SIZE, this._bottomHeight = bottomHeight ?? texture.defaultBorders?.bottom ?? $88c2e82640367c08$var$DEFAULT_BORDER_SIZE, this.texture = texture;
    }
    textureUpdated() {
        this._textureID = this.shader.texture._updateID, this._refresh();
    }
    get vertices() {
        return this.geometry.getBuffer("aVertexPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aVertexPosition").data = value;
    }
    /** Updates the horizontal vertices. */ updateHorizontalVertices() {
        const vertices = this.vertices, scale = this._getMinScale();
        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale, vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale, vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
    }
    /** Updates the vertical vertices. */ updateVerticalVertices() {
        const vertices = this.vertices, scale = this._getMinScale();
        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale, vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale, vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
    }
    /**
   * Returns the smaller of a set of vertical and horizontal scale of nine slice corners.
   * @returns Smaller number of vertical and horizontal scale.
   */ _getMinScale() {
        const w = this._leftWidth + this._rightWidth, scaleW = this._width > w ? 1 : this._width / w, h = this._topHeight + this._bottomHeight, scaleH = this._height > h ? 1 : this._height / h;
        return Math.min(scaleW, scaleH);
    }
    /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value, this._refresh();
    }
    /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value, this._refresh();
    }
    /** The width of the left column. */ get leftWidth() {
        return this._leftWidth;
    }
    set leftWidth(value) {
        this._leftWidth = value, this._refresh();
    }
    /** The width of the right column. */ get rightWidth() {
        return this._rightWidth;
    }
    set rightWidth(value) {
        this._rightWidth = value, this._refresh();
    }
    /** The height of the top row. */ get topHeight() {
        return this._topHeight;
    }
    set topHeight(value) {
        this._topHeight = value, this._refresh();
    }
    /** The height of the bottom row. */ get bottomHeight() {
        return this._bottomHeight;
    }
    set bottomHeight(value) {
        this._bottomHeight = value, this._refresh();
    }
    /** Refreshes NineSlicePlane coords. All of them. */ _refresh() {
        const texture = this.texture, uvs = this.geometry.buffers[1].data;
        this._origWidth = texture.orig.width, this._origHeight = texture.orig.height;
        const _uvw = 1 / this._origWidth, _uvh = 1 / this._origHeight;
        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0, uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0, uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1, uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1, uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth, uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth, uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight, uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight, this.updateHorizontalVertices(), this.updateVerticalVertices(), this.geometry.buffers[0].update(), this.geometry.buffers[1].update();
    }
}

});
parcelRegister("86xVt", function(module, exports) {

$parcel$export(module.exports, "SimplePlane", () => $e8a1fdf736ff3b7e$export$d47c1aa7111669b9);
parcelRequire("inflE");
var $cWOCu = parcelRequire("cWOCu");
parcelRequire("2m9sJ");
var $jlLhs = parcelRequire("jlLhs");
var $douVr = parcelRequire("douVr");

var $9ypa7 = parcelRequire("9ypa7");
class $e8a1fdf736ff3b7e$export$d47c1aa7111669b9 extends (0, $jlLhs.Mesh) {
    /**
   * @param texture - The texture to use on the SimplePlane.
   * @param verticesX - The number of vertices in the x-axis
   * @param verticesY - The number of vertices in the y-axis
   */ constructor(texture, verticesX, verticesY){
        const planeGeometry = new (0, $9ypa7.PlaneGeometry)(texture.width, texture.height, verticesX, verticesY), meshMaterial = new (0, $douVr.MeshMaterial)((0, $cWOCu.Texture).WHITE);
        super(planeGeometry, meshMaterial), this.texture = texture, this.autoResize = !0;
    }
    /**
   * Method used for overrides, to do something in case texture frame was changed.
   * Meshes based on plane can override it and change more details based on texture.
   */ textureUpdated() {
        this._textureID = this.shader.texture._updateID;
        const geometry = this.geometry, { width: width, height: height } = this.shader.texture;
        this.autoResize && (geometry.width !== width || geometry.height !== height) && (geometry.width = this.shader.texture.width, geometry.height = this.shader.texture.height, geometry.build());
    }
    set texture(value) {
        this.shader.texture !== value && (this.shader.texture = value, this._textureID = -1, value.baseTexture.valid ? this.textureUpdated() : value.once("update", this.textureUpdated, this));
    }
    get texture() {
        return this.shader.texture;
    }
    _render(renderer) {
        this._textureID !== this.shader.texture._updateID && this.textureUpdated(), super._render(renderer);
    }
    destroy(options) {
        this.shader.texture.off("update", this.textureUpdated, this), super.destroy(options);
    }
}

});


parcelRegister("8C3Kt", function(module, exports) {

$parcel$export(module.exports, "SimpleMesh", () => $5d2a721396597310$export$81b9e78682e7feca);
parcelRequire("inflE");
var $cWOCu = parcelRequire("cWOCu");
parcelRequire("2m9sJ");
var $jlLhs = parcelRequire("jlLhs");
var $5GlKm = parcelRequire("5GlKm");
var $douVr = parcelRequire("douVr");
class $5d2a721396597310$export$81b9e78682e7feca extends (0, $jlLhs.Mesh) {
    /**
   * @param texture - The texture to use
   * @param {Float32Array} [vertices] - if you want to specify the vertices
   * @param {Float32Array} [uvs] - if you want to specify the uvs
   * @param {Uint16Array} [indices] - if you want to specify the indices
   * @param drawMode - the drawMode, can be any of the Mesh.DRAW_MODES consts
   */ constructor(texture = (0, $cWOCu.Texture).EMPTY, vertices, uvs, indices, drawMode){
        const geometry = new (0, $5GlKm.MeshGeometry)(vertices, uvs, indices);
        geometry.getBuffer("aVertexPosition").static = !1;
        const meshMaterial = new (0, $douVr.MeshMaterial)(texture);
        super(geometry, meshMaterial, null, drawMode), this.autoUpdate = !0;
    }
    /**
   * Collection of vertices data.
   * @type {Float32Array}
   */ get vertices() {
        return this.geometry.getBuffer("aVertexPosition").data;
    }
    set vertices(value) {
        this.geometry.getBuffer("aVertexPosition").data = value;
    }
    _render(renderer) {
        this.autoUpdate && this.geometry.getBuffer("aVertexPosition").update(), super._render(renderer);
    }
}

});

parcelRegister("dFgHQ", function(module, exports) {

$parcel$export(module.exports, "SimpleRope", () => $5e2c2c0f9415086c$export$f009a14c3f00879e);
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
parcelRequire("2m9sJ");
var $jlLhs = parcelRequire("jlLhs");
var $douVr = parcelRequire("douVr");

var $6BOQY = parcelRequire("6BOQY");
class $5e2c2c0f9415086c$export$f009a14c3f00879e extends (0, $jlLhs.Mesh) {
    /**
   * Note: The wrap mode of the texture is set to REPEAT if `textureScale` is positive.
   * @param texture - The texture to use on the rope.
   * @param points - An array of {@link PIXI.Point} objects to construct this rope.
   * @param {number} textureScale - Optional. Positive values scale rope texture
   * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
   * and downsampling here. If set to zero, texture will be stretched instead.
   */ constructor(texture, points, textureScale = 0){
        const ropeGeometry = new (0, $6BOQY.RopeGeometry)(texture.height, points, textureScale), meshMaterial = new (0, $douVr.MeshMaterial)(texture);
        textureScale > 0 && (texture.baseTexture.wrapMode = (0, $lmRm8.WRAP_MODES).REPEAT), super(ropeGeometry, meshMaterial), this.autoUpdate = !0;
    }
    _render(renderer) {
        const geometry = this.geometry;
        (this.autoUpdate || geometry._width !== this.shader.texture.height) && (geometry._width = this.shader.texture.height, geometry.update()), super._render(renderer);
    }
}

});


parcelRegister("2oNag", function(module, exports) {

$parcel$export(module.exports, "ParticleContainer", () => (parcelRequire("aQlRF")).ParticleContainer);

var $aQlRF = parcelRequire("aQlRF");

var $9FuK9 = parcelRequire("9FuK9");

});
parcelRegister("aQlRF", function(module, exports) {

$parcel$export(module.exports, "ParticleContainer", () => $1c7533c0d731277b$export$e63bf72b2cfda112);
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $1PNws = parcelRequire("1PNws");
parcelRequire("gD5uZ");
var $3IPo5 = parcelRequire("3IPo5");
class $1c7533c0d731277b$export$e63bf72b2cfda112 extends (0, $3IPo5.Container) {
    /**
   * @param maxSize - The maximum number of particles that can be rendered by the container.
   *  Affects size of allocated buffers.
   * @param properties - The properties of children that should be uploaded to the gpu and applied.
   * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
   *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
   * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
   * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
   * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
   * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
   * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
   * @param {boolean} [autoResize=false] - If true, container allocates more batches in case
   *  there are more than `maxSize` particles.
   */ constructor(maxSize = 1500, properties, batchSize = 16384, autoResize = !1){
        super();
        const maxBatchSize = 16384;
        batchSize > maxBatchSize && (batchSize = maxBatchSize), this._properties = [
            !1,
            !0,
            !1,
            !1,
            !1
        ], this._maxSize = maxSize, this._batchSize = batchSize, this._buffers = null, this._bufferUpdateIDs = [], this._updateID = 0, this.interactiveChildren = !1, this.blendMode = (0, $lmRm8.BLEND_MODES).NORMAL, this.autoResize = autoResize, this.roundPixels = !0, this.baseTexture = null, this.setProperties(properties), this._tintColor = new (0, $1PNws.Color)(0), this.tintRgb = new Float32Array(3), this.tint = 16777215;
    }
    /**
   * Sets the private properties array to dynamic / static based on the passed properties object
   * @param properties - The properties to be uploaded
   */ setProperties(properties) {
        properties && (this._properties[0] = "vertices" in properties || "scale" in properties ? !!properties.vertices || !!properties.scale : this._properties[0], this._properties[1] = "position" in properties ? !!properties.position : this._properties[1], this._properties[2] = "rotation" in properties ? !!properties.rotation : this._properties[2], this._properties[3] = "uvs" in properties ? !!properties.uvs : this._properties[3], this._properties[4] = "tint" in properties || "alpha" in properties ? !!properties.tint || !!properties.alpha : this._properties[4]);
    }
    updateTransform() {
        this.displayObjectUpdateTransform();
    }
    /**
   * The tint applied to the container. This is a hex value.
   * A value of 0xFFFFFF will remove any tint effect.
   * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
   * @default 0xFFFFFF
   */ get tint() {
        return this._tintColor.value;
    }
    set tint(value) {
        this._tintColor.setValue(value), this._tintColor.toRgbArray(this.tintRgb);
    }
    /**
   * Renders the container using the WebGL renderer.
   * @param renderer - The WebGL renderer.
   */ render(renderer) {
        !this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable || (this.baseTexture || (this.baseTexture = this.children[0]._texture.baseTexture, this.baseTexture.valid || this.baseTexture.once("update", ()=>this.onChildrenChange(0))), renderer.batch.setObjectRenderer(renderer.plugins.particle), renderer.plugins.particle.render(this));
    }
    /**
   * Set the flag that static data should be updated to true
   * @param smallestChildIndex - The smallest child index.
   */ onChildrenChange(smallestChildIndex) {
        const bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
        for(; this._bufferUpdateIDs.length < bufferIndex;)this._bufferUpdateIDs.push(0);
        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
    }
    dispose() {
        if (this._buffers) {
            for(let i = 0; i < this._buffers.length; ++i)this._buffers[i].destroy();
            this._buffers = null;
        }
    }
    /**
   * Destroys the container
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their
   *  destroy method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the texture of the child sprite
   * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
   *  Should it destroy the base texture of the child sprite
   */ destroy(options) {
        super.destroy(options), this.dispose(), this._properties = null, this._buffers = null, this._bufferUpdateIDs = null;
    }
}

});

parcelRegister("9FuK9", function(module, exports) {
parcelRequire("inflE");
var $1PNws = parcelRequire("1PNws");
var $5RvHb = parcelRequire("5RvHb");
var $6wJoy = parcelRequire("6wJoy");
var $hDOsC = parcelRequire("hDOsC");
var $2cKpP = parcelRequire("2cKpP");
var $bUqaG = parcelRequire("bUqaG");
var $lmRm8 = parcelRequire("lmRm8");
var $lFGyw = parcelRequire("lFGyw");

var $jeqaa = parcelRequire("jeqaa");

var $346aa = parcelRequire("346aa");

var $a0pxt = parcelRequire("a0pxt");
class $e973c60d525888ad$export$42cbb08a275c7ff9 extends (0, $hDOsC.ObjectRenderer) {
    /**
   * @param renderer - The renderer this sprite batch works for.
   */ constructor(renderer){
        super(renderer), this.shader = null, this.properties = null, this.tempMatrix = new (0, $6wJoy.Matrix)(), this.properties = [
            // verticesData
            {
                attributeName: "aVertexPosition",
                size: 2,
                uploadFunction: this.uploadVertices,
                offset: 0
            },
            // positionData
            {
                attributeName: "aPositionCoord",
                size: 2,
                uploadFunction: this.uploadPosition,
                offset: 0
            },
            // rotationData
            {
                attributeName: "aRotation",
                size: 1,
                uploadFunction: this.uploadRotation,
                offset: 0
            },
            // uvsData
            {
                attributeName: "aTextureCoord",
                size: 2,
                uploadFunction: this.uploadUvs,
                offset: 0
            },
            // tintData
            {
                attributeName: "aColor",
                size: 1,
                type: (0, $lmRm8.TYPES).UNSIGNED_BYTE,
                uploadFunction: this.uploadTint,
                offset: 0
            }
        ], this.shader = (0, $2cKpP.Shader).from((0, $a0pxt.default), (0, $346aa.default), {}), this.state = (0, $bUqaG.State).for2d();
    }
    /**
   * Renders the particle container object.
   * @param container - The container to render using this ParticleRenderer.
   */ render(container) {
        const children = container.children, maxSize = container._maxSize, batchSize = container._batchSize, renderer = this.renderer;
        let totalChildren = children.length;
        if (totalChildren === 0) return;
        totalChildren > maxSize && !container.autoResize && (totalChildren = maxSize);
        let buffers = container._buffers;
        buffers || (buffers = container._buffers = this.generateBuffers(container));
        const baseTexture = children[0]._texture.baseTexture, premultiplied = baseTexture.alphaMode > 0;
        this.state.blendMode = (0, $lFGyw).correctBlendMode(container.blendMode, premultiplied), renderer.state.set(this.state);
        const gl = renderer.gl, m = container.worldTransform.copyTo(this.tempMatrix);
        m.prepend(renderer.globalUniforms.uniforms.projectionMatrix), this.shader.uniforms.translationMatrix = m.toArray(!0), this.shader.uniforms.uColor = (0, $1PNws.Color).shared.setValue(container.tintRgb).premultiply(container.worldAlpha, premultiplied).toArray(this.shader.uniforms.uColor), this.shader.uniforms.uSampler = baseTexture, this.renderer.shader.bind(this.shader);
        let updateStatic = !1;
        for(let i = 0, j = 0; i < totalChildren; i += batchSize, j += 1){
            let amount = totalChildren - i;
            amount > batchSize && (amount = batchSize), j >= buffers.length && buffers.push(this._generateOneMoreBuffer(container));
            const buffer = buffers[j];
            buffer.uploadDynamic(children, i, amount);
            const bid = container._bufferUpdateIDs[j] || 0;
            updateStatic = updateStatic || buffer._updateID < bid, updateStatic && (buffer._updateID = container._updateID, buffer.uploadStatic(children, i, amount)), renderer.geometry.bind(buffer.geometry), gl.drawElements(gl.TRIANGLES, amount * 6, gl.UNSIGNED_SHORT, 0);
        }
    }
    /**
   * Creates one particle buffer for each child in the container we want to render and updates internal properties.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The buffers
   */ generateBuffers(container) {
        const buffers = [], size = container._maxSize, batchSize = container._batchSize, dynamicPropertyFlags = container._properties;
        for(let i = 0; i < size; i += batchSize)buffers.push(new (0, $jeqaa.ParticleBuffer)(this.properties, dynamicPropertyFlags, batchSize));
        return buffers;
    }
    /**
   * Creates one more particle buffer, because container has autoResize feature.
   * @param container - The container to render using this ParticleRenderer
   * @returns - The generated buffer
   */ _generateOneMoreBuffer(container) {
        const batchSize = container._batchSize, dynamicPropertyFlags = container._properties;
        return new (0, $jeqaa.ParticleBuffer)(this.properties, dynamicPropertyFlags, batchSize);
    }
    /**
   * Uploads the vertices.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their vertices uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadVertices(children, startIndex, amount, array, stride, offset) {
        let w0 = 0, w1 = 0, h0 = 0, h1 = 0;
        for(let i = 0; i < amount; ++i){
            const sprite = children[startIndex + i], texture = sprite._texture, sx = sprite.scale.x, sy = sprite.scale.y, trim = texture.trim, orig = texture.orig;
            trim ? (w1 = trim.x - sprite.anchor.x * orig.width, w0 = w1 + trim.width, h1 = trim.y - sprite.anchor.y * orig.height, h0 = h1 + trim.height) : (w0 = orig.width * (1 - sprite.anchor.x), w1 = orig.width * -sprite.anchor.x, h0 = orig.height * (1 - sprite.anchor.y), h1 = orig.height * -sprite.anchor.y), array[offset] = w1 * sx, array[offset + 1] = h1 * sy, array[offset + stride] = w0 * sx, array[offset + stride + 1] = h1 * sy, array[offset + stride * 2] = w0 * sx, array[offset + stride * 2 + 1] = h0 * sy, array[offset + stride * 3] = w1 * sx, array[offset + stride * 3 + 1] = h0 * sy, offset += stride * 4;
        }
    }
    /**
   * Uploads the position.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their positions uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadPosition(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; i++){
            const spritePosition = children[startIndex + i].position;
            array[offset] = spritePosition.x, array[offset + 1] = spritePosition.y, array[offset + stride] = spritePosition.x, array[offset + stride + 1] = spritePosition.y, array[offset + stride * 2] = spritePosition.x, array[offset + stride * 2 + 1] = spritePosition.y, array[offset + stride * 3] = spritePosition.x, array[offset + stride * 3 + 1] = spritePosition.y, offset += stride * 4;
        }
    }
    /**
   * Uploads the rotation.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadRotation(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; i++){
            const spriteRotation = children[startIndex + i].rotation;
            array[offset] = spriteRotation, array[offset + stride] = spriteRotation, array[offset + stride * 2] = spriteRotation, array[offset + stride * 3] = spriteRotation, offset += stride * 4;
        }
    }
    /**
   * Uploads the UVs.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadUvs(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; ++i){
            const textureUvs = children[startIndex + i]._texture._uvs;
            textureUvs ? (array[offset] = textureUvs.x0, array[offset + 1] = textureUvs.y0, array[offset + stride] = textureUvs.x1, array[offset + stride + 1] = textureUvs.y1, array[offset + stride * 2] = textureUvs.x2, array[offset + stride * 2 + 1] = textureUvs.y2, array[offset + stride * 3] = textureUvs.x3, array[offset + stride * 3 + 1] = textureUvs.y3, offset += stride * 4) : (array[offset] = 0, array[offset + 1] = 0, array[offset + stride] = 0, array[offset + stride + 1] = 0, array[offset + stride * 2] = 0, array[offset + stride * 2 + 1] = 0, array[offset + stride * 3] = 0, array[offset + stride * 3 + 1] = 0, offset += stride * 4);
        }
    }
    /**
   * Uploads the tint.
   * @param children - the array of sprites to render
   * @param startIndex - the index to start from in the children array
   * @param amount - the amount of children that will have their rotation uploaded
   * @param array - The vertices to upload.
   * @param stride - Stride to use for iteration.
   * @param offset - Offset to start at.
   */ uploadTint(children, startIndex, amount, array, stride, offset) {
        for(let i = 0; i < amount; ++i){
            const sprite = children[startIndex + i], result = (0, $1PNws.Color).shared.setValue(sprite._tintRGB).toPremultiplied(sprite.alpha, sprite.texture.baseTexture.alphaMode > 0);
            array[offset] = result, array[offset + stride] = result, array[offset + stride * 2] = result, array[offset + stride * 3] = result, offset += stride * 4;
        }
    }
    /** Destroys the ParticleRenderer. */ destroy() {
        super.destroy(), this.shader && (this.shader.destroy(), this.shader = null), this.tempMatrix = null;
    }
}
$e973c60d525888ad$export$42cbb08a275c7ff9.extension = {
    name: "particle",
    type: (0, $5RvHb.ExtensionType).RendererPlugin
};
(0, $5RvHb.extensions).add($e973c60d525888ad$export$42cbb08a275c7ff9);

});
parcelRegister("jeqaa", function(module, exports) {

$parcel$export(module.exports, "ParticleBuffer", () => $c64915fffe94164d$export$ef6bb3c375ab2229);
parcelRequire("inflE");
var $3u4Xc = parcelRequire("3u4Xc");
var $5K7Rq = parcelRequire("5K7Rq");
var $lmRm8 = parcelRequire("lmRm8");
var $lFGyw = parcelRequire("lFGyw");
class $c64915fffe94164d$export$ef6bb3c375ab2229 {
    /**
   * @param {object} properties - The properties to upload.
   * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
   * @param {number} size - The size of the batch.
   */ constructor(properties, dynamicPropertyFlags, size){
        this.geometry = new (0, $5K7Rq.Geometry)(), this.indexBuffer = null, this.size = size, this.dynamicProperties = [], this.staticProperties = [];
        for(let i = 0; i < properties.length; ++i){
            let property = properties[i];
            property = {
                attributeName: property.attributeName,
                size: property.size,
                uploadFunction: property.uploadFunction,
                type: property.type || (0, $lmRm8.TYPES).FLOAT,
                offset: property.offset
            }, dynamicPropertyFlags[i] ? this.dynamicProperties.push(property) : this.staticProperties.push(property);
        }
        this.staticStride = 0, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.dynamicStride = 0, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this._updateID = 0, this.initBuffers();
    }
    /** Sets up the renderer context and necessary buffers. */ initBuffers() {
        const geometry = this.geometry;
        let dynamicOffset = 0;
        this.indexBuffer = new (0, $3u4Xc.Buffer)((0, $lFGyw).createIndicesForQuads(this.size), !0, !0), geometry.addIndex(this.indexBuffer), this.dynamicStride = 0;
        for(let i = 0; i < this.dynamicProperties.length; ++i){
            const property = this.dynamicProperties[i];
            property.offset = dynamicOffset, dynamicOffset += property.size, this.dynamicStride += property.size;
        }
        const dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 16);
        this.dynamicData = new Float32Array(dynBuffer), this.dynamicDataUint32 = new Uint32Array(dynBuffer), this.dynamicBuffer = new (0, $3u4Xc.Buffer)(this.dynamicData, !1, !1);
        let staticOffset = 0;
        this.staticStride = 0;
        for(let i = 0; i < this.staticProperties.length; ++i){
            const property = this.staticProperties[i];
            property.offset = staticOffset, staticOffset += property.size, this.staticStride += property.size;
        }
        const statBuffer = new ArrayBuffer(this.size * this.staticStride * 16);
        this.staticData = new Float32Array(statBuffer), this.staticDataUint32 = new Uint32Array(statBuffer), this.staticBuffer = new (0, $3u4Xc.Buffer)(this.staticData, !0, !1);
        for(let i = 0; i < this.dynamicProperties.length; ++i){
            const property = this.dynamicProperties[i];
            geometry.addAttribute(property.attributeName, this.dynamicBuffer, 0, property.type === (0, $lmRm8.TYPES).UNSIGNED_BYTE, property.type, this.dynamicStride * 4, property.offset * 4);
        }
        for(let i = 0; i < this.staticProperties.length; ++i){
            const property = this.staticProperties[i];
            geometry.addAttribute(property.attributeName, this.staticBuffer, 0, property.type === (0, $lmRm8.TYPES).UNSIGNED_BYTE, property.type, this.staticStride * 4, property.offset * 4);
        }
    }
    /**
   * Uploads the dynamic properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */ uploadDynamic(children, startIndex, amount) {
        for(let i = 0; i < this.dynamicProperties.length; i++){
            const property = this.dynamicProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $lmRm8.TYPES).UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
        }
        this.dynamicBuffer._updateID++;
    }
    /**
   * Uploads the static properties.
   * @param children - The children to upload.
   * @param startIndex - The index to start at.
   * @param amount - The number to upload.
   */ uploadStatic(children, startIndex, amount) {
        for(let i = 0; i < this.staticProperties.length; i++){
            const property = this.staticProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $lmRm8.TYPES).UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
        }
        this.staticBuffer._updateID++;
    }
    /** Destroys the ParticleBuffer. */ destroy() {
        this.indexBuffer = null, this.dynamicProperties = null, this.dynamicBuffer = null, this.dynamicData = null, this.dynamicDataUint32 = null, this.staticProperties = null, this.staticBuffer = null, this.staticData = null, this.staticDataUint32 = null, this.geometry.destroy();
    }
}

});

parcelRegister("346aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee56cc569f56d3c4$export$2e2bcd8739ae039);
var $ee56cc569f56d3c4$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
varying vec4 vColor;

uniform sampler2D uSampler;

void main(void){
    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;
    gl_FragColor = color;
}`;

});

parcelRegister("a0pxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f2ecef795102e41$export$2e2bcd8739ae039);
var $8f2ecef795102e41$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aColor;

attribute vec2 aPositionCoord;
attribute float aRotation;

uniform mat3 translationMatrix;
uniform vec4 uColor;

varying vec2 vTextureCoord;
varying vec4 vColor;

void main(void){
    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);
    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);

    vec2 v = vec2(x, y);
    v = v + aPositionCoord;

    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = aTextureCoord;
    vColor = aColor * uColor;
}
`;

});



parcelRegister("XZ4uF", function(module, exports) {

$parcel$export(module.exports, "AnimatedSprite", () => (parcelRequire("4URvW")).AnimatedSprite);

var $4URvW = parcelRequire("4URvW");

});
parcelRegister("4URvW", function(module, exports) {

$parcel$export(module.exports, "AnimatedSprite", () => $bef80d21b8b0b6b2$export$dae599798687ad3c);
parcelRequire("inflE");
var $cWOCu = parcelRequire("cWOCu");
var $3J55z = parcelRequire("3J55z");
var $iaX63 = parcelRequire("iaX63");
parcelRequire("jW6UI");
var $3uiak = parcelRequire("3uiak");
class $bef80d21b8b0b6b2$export$dae599798687ad3c extends (0, $3uiak.Sprite) {
    /**
   * @param textures - An array of {@link PIXI.Texture} or frame
   *  objects that make up the animation.
   * @param {boolean} [autoUpdate=true] - Whether to use Ticker.shared to auto update animation time.
   */ constructor(textures, autoUpdate = !0){
        super(textures[0] instanceof (0, $cWOCu.Texture) ? textures[0] : textures[0].texture), this._textures = null, this._durations = null, this._autoUpdate = autoUpdate, this._isConnectedToTicker = !1, this.animationSpeed = 1, this.loop = !0, this.updateAnchor = !1, this.onComplete = null, this.onFrameChange = null, this.onLoop = null, this._currentTime = 0, this._playing = !1, this._previousFrame = null, this.textures = textures;
    }
    /** Stops the AnimatedSprite. */ stop() {
        this._playing && (this._playing = !1, this._autoUpdate && this._isConnectedToTicker && ((0, $3J55z.Ticker).shared.remove(this.update, this), this._isConnectedToTicker = !1));
    }
    /** Plays the AnimatedSprite. */ play() {
        this._playing || (this._playing = !0, this._autoUpdate && !this._isConnectedToTicker && ((0, $3J55z.Ticker).shared.add(this.update, this, (0, $iaX63.UPDATE_PRIORITY).HIGH), this._isConnectedToTicker = !0));
    }
    /**
   * Stops the AnimatedSprite and goes to a specific frame.
   * @param frameNumber - Frame index to stop at.
   */ gotoAndStop(frameNumber) {
        this.stop(), this.currentFrame = frameNumber;
    }
    /**
   * Goes to a specific frame and begins playing the AnimatedSprite.
   * @param frameNumber - Frame index to start at.
   */ gotoAndPlay(frameNumber) {
        this.currentFrame = frameNumber, this.play();
    }
    /**
   * Updates the object transform for rendering.
   * @param deltaTime - Time since last tick.
   */ update(deltaTime) {
        if (!this._playing) return;
        const elapsed = this.animationSpeed * deltaTime, previousFrame = this.currentFrame;
        if (this._durations !== null) {
            let lag = this._currentTime % 1 * this._durations[this.currentFrame];
            for(lag += elapsed / 60 * 1e3; lag < 0;)this._currentTime--, lag += this._durations[this.currentFrame];
            const sign = Math.sign(this.animationSpeed * deltaTime);
            for(this._currentTime = Math.floor(this._currentTime); lag >= this._durations[this.currentFrame];)lag -= this._durations[this.currentFrame] * sign, this._currentTime += sign;
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        this._currentTime < 0 && !this.loop ? (this.gotoAndStop(0), this.onComplete && this.onComplete()) : this._currentTime >= this._textures.length && !this.loop ? (this.gotoAndStop(this._textures.length - 1), this.onComplete && this.onComplete()) : previousFrame !== this.currentFrame && (this.loop && this.onLoop && (this.animationSpeed > 0 && this.currentFrame < previousFrame || this.animationSpeed < 0 && this.currentFrame > previousFrame) && this.onLoop(), this.updateTexture());
    }
    /** Updates the displayed texture to match the current frame index. */ updateTexture() {
        const currentFrame = this.currentFrame;
        this._previousFrame !== currentFrame && (this._previousFrame = currentFrame, this._texture = this._textures[currentFrame], this._textureID = -1, this._textureTrimmedID = -1, this._cachedTint = 16777215, this.uvs = this._texture._uvs.uvsFloat32, this.updateAnchor && this._anchor.copyFrom(this._texture.defaultAnchor), this.onFrameChange && this.onFrameChange(this.currentFrame));
    }
    /**
   * Stops the AnimatedSprite and destroys it.
   * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
   *  have been set to that value.
   * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well.
   * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well.
   */ destroy(options) {
        this.stop(), super.destroy(options), this.onComplete = null, this.onFrameChange = null, this.onLoop = null;
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of frame ids.
   * @param frames - The array of frames ids the AnimatedSprite will use as its texture frames.
   * @returns - The new animated sprite with the specified frames.
   */ static fromFrames(frames) {
        const textures = [];
        for(let i = 0; i < frames.length; ++i)textures.push((0, $cWOCu.Texture).from(frames[i]));
        return new $bef80d21b8b0b6b2$export$dae599798687ad3c(textures);
    }
    /**
   * A short hand way of creating an AnimatedSprite from an array of image ids.
   * @param images - The array of image urls the AnimatedSprite will use as its texture frames.
   * @returns The new animate sprite with the specified images as frames.
   */ static fromImages(images) {
        const textures = [];
        for(let i = 0; i < images.length; ++i)textures.push((0, $cWOCu.Texture).from(images[i]));
        return new $bef80d21b8b0b6b2$export$dae599798687ad3c(textures);
    }
    /**
   * The total number of frames in the AnimatedSprite. This is the same as number of textures
   * assigned to the AnimatedSprite.
   * @readonly
   * @default 0
   */ get totalFrames() {
        return this._textures.length;
    }
    /** The array of textures used for this AnimatedSprite. */ get textures() {
        return this._textures;
    }
    set textures(value) {
        if (value[0] instanceof (0, $cWOCu.Texture)) this._textures = value, this._durations = null;
        else {
            this._textures = [], this._durations = [];
            for(let i = 0; i < value.length; i++)this._textures.push(value[i].texture), this._durations.push(value[i].time);
        }
        this._previousFrame = null, this.gotoAndStop(0), this.updateTexture();
    }
    /** The AnimatedSprite's current frame index. */ get currentFrame() {
        let currentFrame = Math.floor(this._currentTime) % this._textures.length;
        return currentFrame < 0 && (currentFrame += this._textures.length), currentFrame;
    }
    set currentFrame(value) {
        if (value < 0 || value > this.totalFrames - 1) throw new Error(`[AnimatedSprite]: Invalid frame index value ${value}, expected to be between 0 and totalFrames ${this.totalFrames}.`);
        const previousFrame = this.currentFrame;
        this._currentTime = value, previousFrame !== this.currentFrame && this.updateTexture();
    }
    /**
   * Indicates if the AnimatedSprite is currently playing.
   * @readonly
   */ get playing() {
        return this._playing;
    }
    /** Whether to use Ticker.shared to auto update animation time. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        value !== this._autoUpdate && (this._autoUpdate = value, !this._autoUpdate && this._isConnectedToTicker ? ((0, $3J55z.Ticker).shared.remove(this.update, this), this._isConnectedToTicker = !1) : this._autoUpdate && !this._isConnectedToTicker && this._playing && ((0, $3J55z.Ticker).shared.add(this.update, this), this._isConnectedToTicker = !0));
    }
}

});


parcelRegister("b6saP", function(module, exports) {

$parcel$export(module.exports, "TilingSprite", () => (parcelRequire("jiPZB")).TilingSprite);

var $jiPZB = parcelRequire("jiPZB");

var $iV6ME = parcelRequire("iV6ME");

});
parcelRegister("jiPZB", function(module, exports) {

$parcel$export(module.exports, "TilingSprite", () => $8bf7721c1d1425f3$export$db8370cd1ebcc819);
parcelRequire("inflE");
var $gnwPx = parcelRequire("gnwPx");
var $kZOeV = parcelRequire("kZOeV");
var $cWOCu = parcelRequire("cWOCu");
var $aHJRR = parcelRequire("aHJRR");
var $9jXhN = parcelRequire("9jXhN");
parcelRequire("jW6UI");
var $3uiak = parcelRequire("3uiak");
const $8bf7721c1d1425f3$var$tempPoint = new (0, $gnwPx.Point)();
class $8bf7721c1d1425f3$export$db8370cd1ebcc819 extends (0, $3uiak.Sprite) {
    /**
   * Note: The wrap mode of the texture is forced to REPEAT on render if the size of the texture
   * is a power of two, the texture's wrap mode is CLAMP, and the texture hasn't been bound yet.
   * @param texture - The texture of the tiling sprite.
   * @param width - The width of the tiling sprite.
   * @param height - The height of the tiling sprite.
   */ constructor(texture, width = 100, height = 100){
        super(texture), this.tileTransform = new (0, $9jXhN.Transform)(), this._width = width, this._height = height, this.uvMatrix = this.texture.uvMatrix || new (0, $aHJRR.TextureMatrix)(texture), this.pluginName = "tilingSprite", this.uvRespectAnchor = !1;
    }
    /**
   * Changes frame clamping in corresponding textureTransform, shortcut
   * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
   * @default 0.5
   * @member {number}
   */ get clampMargin() {
        return this.uvMatrix.clampMargin;
    }
    set clampMargin(value) {
        this.uvMatrix.clampMargin = value, this.uvMatrix.update(!0);
    }
    /** The scaling of the image that is being tiled. */ get tileScale() {
        return this.tileTransform.scale;
    }
    set tileScale(value) {
        this.tileTransform.scale.copyFrom(value);
    }
    /** The offset of the image that is being tiled. */ get tilePosition() {
        return this.tileTransform.position;
    }
    set tilePosition(value) {
        this.tileTransform.position.copyFrom(value);
    }
    /**
   * @protected
   */ _onTextureUpdate() {
        this.uvMatrix && (this.uvMatrix.texture = this._texture), this._cachedTint = 16777215;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param renderer - The renderer
   */ _render(renderer) {
        const texture = this._texture;
        !texture || !texture.valid || (this.tileTransform.updateLocalTransform(), this.uvMatrix.update(), renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]), renderer.plugins[this.pluginName].render(this));
    }
    /** Updates the bounds of the tiling sprite. */ _calculateBounds() {
        const minX = this._width * -this._anchor._x, minY = this._height * -this._anchor._y, maxX = this._width * (1 - this._anchor._x), maxY = this._height * (1 - this._anchor._y);
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    /**
   * Gets the local bounds of the sprite object.
   * @param rect - Optional output rectangle.
   * @returns The bounds.
   */ getLocalBounds(rect) {
        return this.children.length === 0 ? (this._bounds.minX = this._width * -this._anchor._x, this._bounds.minY = this._height * -this._anchor._y, this._bounds.maxX = this._width * (1 - this._anchor._x), this._bounds.maxY = this._height * (1 - this._anchor._y), rect || (this._localBoundsRect || (this._localBoundsRect = new (0, $kZOeV.Rectangle)()), rect = this._localBoundsRect), this._bounds.getRectangle(rect)) : super.getLocalBounds.call(this, rect);
    }
    /**
   * Checks if a point is inside this tiling sprite.
   * @param point - The point to check.
   * @returns Whether or not the sprite contains the point.
   */ containsPoint(point) {
        this.worldTransform.applyInverse(point, $8bf7721c1d1425f3$var$tempPoint);
        const width = this._width, height = this._height, x1 = -width * this.anchor._x;
        if ($8bf7721c1d1425f3$var$tempPoint.x >= x1 && $8bf7721c1d1425f3$var$tempPoint.x < x1 + width) {
            const y1 = -height * this.anchor._y;
            if ($8bf7721c1d1425f3$var$tempPoint.y >= y1 && $8bf7721c1d1425f3$var$tempPoint.y < y1 + height) return !0;
        }
        return !1;
    }
    /**
   * Destroys this sprite and optionally its texture and children
   * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *      method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
   * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
   */ destroy(options) {
        super.destroy(options), this.tileTransform = null, this.uvMatrix = null;
    }
    /**
   * Helper function that creates a new tiling sprite based on the source you provide.
   * The source can be - frame id, image url, video url, canvas element, video element, base texture
   * @static
   * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
   * @param {object} options - See {@link PIXI.BaseTexture}'s constructor for options.
   * @param {number} options.width - required width of the tiling sprite
   * @param {number} options.height - required height of the tiling sprite
   * @returns {PIXI.TilingSprite} The newly created texture
   */ static from(source, options) {
        const texture = source instanceof (0, $cWOCu.Texture) ? source : (0, $cWOCu.Texture).from(source, options);
        return new $8bf7721c1d1425f3$export$db8370cd1ebcc819(texture, options.width, options.height);
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return this._width;
    }
    set width(value) {
        this._width = value;
    }
    /** The height of the TilingSprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return this._height;
    }
    set height(value) {
        this._height = value;
    }
}

});

parcelRegister("iV6ME", function(module, exports) {
parcelRequire("inflE");
var $1PNws = parcelRequire("1PNws");
var $5RvHb = parcelRequire("5RvHb");
var $6wJoy = parcelRequire("6wJoy");
var $hDOsC = parcelRequire("hDOsC");
var $eVEcT = parcelRequire("eVEcT");
var $2cKpP = parcelRequire("2cKpP");
var $bUqaG = parcelRequire("bUqaG");
var $lFGyw = parcelRequire("lFGyw");
var $lmRm8 = parcelRequire("lmRm8");

var $1P8SW = parcelRequire("1P8SW");

var $6ZpMT = parcelRequire("6ZpMT");

var $6IVb3 = parcelRequire("6IVb3");

var $hkut5 = parcelRequire("hkut5");

var $8wRTU = parcelRequire("8wRTU");
const $f9ed358e281ad51c$var$tempMat = new (0, $6wJoy.Matrix)();
class $f9ed358e281ad51c$export$8b7f6ad84090f14c extends (0, $hDOsC.ObjectRenderer) {
    /**
   * constructor for renderer
   * @param {PIXI.Renderer} renderer - The renderer this tiling awesomeness works for.
   */ constructor(renderer){
        super(renderer), renderer.runners.contextChange.add(this), this.quad = new (0, $eVEcT.QuadUv)(), this.state = (0, $bUqaG.State).for2d();
    }
    /** Creates shaders when context is initialized. */ contextChange() {
        const renderer = this.renderer, uniforms = {
            globals: renderer.globalUniforms
        };
        this.simpleShader = (0, $2cKpP.Shader).from((0, $hkut5.default), (0, $8wRTU.default), uniforms), this.shader = renderer.context.webGLVersion > 1 ? (0, $2cKpP.Shader).from((0, $6ZpMT.default), (0, $1P8SW.default), uniforms) : (0, $2cKpP.Shader).from((0, $hkut5.default), (0, $6IVb3.default), uniforms);
    }
    /**
   * @param {PIXI.TilingSprite} ts - tilingSprite to be rendered
   */ render(ts) {
        const renderer = this.renderer, quad = this.quad;
        let vertices = quad.vertices;
        vertices[0] = vertices[6] = ts._width * -ts.anchor.x, vertices[1] = vertices[3] = ts._height * -ts.anchor.y, vertices[2] = vertices[4] = ts._width * (1 - ts.anchor.x), vertices[5] = vertices[7] = ts._height * (1 - ts.anchor.y);
        const anchorX = ts.uvRespectAnchor ? ts.anchor.x : 0, anchorY = ts.uvRespectAnchor ? ts.anchor.y : 0;
        vertices = quad.uvs, vertices[0] = vertices[6] = -anchorX, vertices[1] = vertices[3] = -anchorY, vertices[2] = vertices[4] = 1 - anchorX, vertices[5] = vertices[7] = 1 - anchorY, quad.invalidate();
        const tex = ts._texture, baseTex = tex.baseTexture, premultiplied = baseTex.alphaMode > 0, lt = ts.tileTransform.localTransform, uv = ts.uvMatrix;
        let isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
        isSimple && (baseTex._glTextures[renderer.CONTEXT_UID] ? isSimple = baseTex.wrapMode !== (0, $lmRm8.WRAP_MODES).CLAMP : baseTex.wrapMode === (0, $lmRm8.WRAP_MODES).CLAMP && (baseTex.wrapMode = (0, $lmRm8.WRAP_MODES).REPEAT));
        const shader = isSimple ? this.simpleShader : this.shader, w = tex.width, h = tex.height, W = ts._width, H = ts._height;
        $f9ed358e281ad51c$var$tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H), $f9ed358e281ad51c$var$tempMat.invert(), isSimple ? $f9ed358e281ad51c$var$tempMat.prepend(uv.mapCoord) : (shader.uniforms.uMapCoord = uv.mapCoord.toArray(!0), shader.uniforms.uClampFrame = uv.uClampFrame, shader.uniforms.uClampOffset = uv.uClampOffset), shader.uniforms.uTransform = $f9ed358e281ad51c$var$tempMat.toArray(!0), shader.uniforms.uColor = (0, $1PNws.Color).shared.setValue(ts.tint).premultiply(ts.worldAlpha, premultiplied).toArray(shader.uniforms.uColor), shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(!0), shader.uniforms.uSampler = tex, renderer.shader.bind(shader), renderer.geometry.bind(quad), this.state.blendMode = (0, $lFGyw).correctBlendMode(ts.blendMode, premultiplied), renderer.state.set(this.state), renderer.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
    }
}
$f9ed358e281ad51c$export$8b7f6ad84090f14c.extension = {
    name: "tilingSprite",
    type: (0, $5RvHb.ExtensionType).RendererPlugin
};
(0, $5RvHb.extensions).add($f9ed358e281ad51c$export$8b7f6ad84090f14c);

});
parcelRegister("1P8SW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8b0ec49586ccd1$export$2e2bcd8739ae039);
var $ff8b0ec49586ccd1$export$2e2bcd8739ae039 = `#version 300 es
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

in vec2 vTextureCoord;

out vec4 fragmentColor;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0

    fragmentColor = texSample * uColor;
}
`;

});

parcelRegister("6ZpMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $15276d79a028246d$export$2e2bcd8739ae039);
var $15276d79a028246d$export$2e2bcd8739ae039 = `#version 300 es
#define SHADER_NAME Tiling-Sprite-300

precision lowp float;

in vec2 aVertexPosition;
in vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

out vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`;

});

parcelRegister("6IVb3", function(module, exports) {

$parcel$export(module.exports, "default", () => $154ec10bceea3f50$export$2e2bcd8739ae039);
var $154ec10bceea3f50$export$2e2bcd8739ae039 = `#version 100
#ifdef GL_EXT_shader_texture_lod
    #extension GL_EXT_shader_texture_lod : enable
#endif
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;
uniform mat3 uMapCoord;
uniform vec4 uClampFrame;
uniform vec2 uClampOffset;

void main(void)
{
    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);
    coord = (uMapCoord * vec3(coord, 1.0)).xy;
    vec2 unclamped = coord;
    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);

    #ifdef GL_EXT_shader_texture_lod
        vec4 texSample = unclamped == coord
            ? texture2D(uSampler, coord) 
            : texture2DLodEXT(uSampler, coord, 0);
    #else
        vec4 texSample = texture2D(uSampler, coord);
    #endif

    gl_FragColor = texSample * uColor;
}
`;

});

parcelRegister("hkut5", function(module, exports) {

$parcel$export(module.exports, "default", () => $de3a9e8995e6db4f$export$2e2bcd8739ae039);
var $de3a9e8995e6db4f$export$2e2bcd8739ae039 = `#version 100
#define SHADER_NAME Tiling-Sprite-100

precision lowp float;

attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
uniform mat3 uTransform;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);

    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;
}
`;

});

parcelRegister("8wRTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e4cff5dc4b85d75$export$2e2bcd8739ae039);
var $7e4cff5dc4b85d75$export$2e2bcd8739ae039 = `#version 100
#define SHADER_NAME Tiling-Sprite-Simple-100

precision lowp float;

varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform vec4 uColor;

void main(void)
{
    vec4 texSample = texture2D(uSampler, vTextureCoord);
    gl_FragColor = texSample * uColor;
}
`;

});



parcelRegister("gbrJV", function(module, exports) {

$parcel$export(module.exports, "Application", () => (parcelRequire("12K8P")).Application);

var $12K8P = parcelRequire("12K8P");

var $bScKZ = parcelRequire("bScKZ");

});
parcelRegister("12K8P", function(module, exports) {

$parcel$export(module.exports, "Application", () => $1495858258e0a7a4$export$16975c34e60e1e61);
parcelRequire("inflE");
var $jZ2Bd = parcelRequire("jZ2Bd");
var $5RvHb = parcelRequire("5RvHb");
parcelRequire("gD5uZ");
var $3IPo5 = parcelRequire("3IPo5");
const $1495858258e0a7a4$var$_Application = class _Application2 {
    /**
   * @param options - The optional application and renderer parameters.
   */ constructor(options){
        this.stage = new (0, $3IPo5.Container)(), options = Object.assign({
            forceCanvas: !1
        }, options), this.renderer = (0, $jZ2Bd.autoDetectRenderer)(options), _Application2._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /** Render the current stage. */ render() {
        this.renderer.render(this.stage);
    }
    /**
   * Reference to the renderer's canvas element.
   * @member {PIXI.ICanvas}
   * @readonly
   */ get view() {
        return this.renderer?.view;
    }
    /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @member {PIXI.Rectangle}
   * @readonly
   */ get screen() {
        return this.renderer?.screen;
    }
    /**
   * Destroy and don't use after this.
   * @param {boolean} [removeView=false] - Automatically remove canvas from DOM.
   * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'stageOptions' will be passed on to those calls.
   * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the texture of the child sprite
   * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
   *  to true. Should it destroy the base texture of the child sprite
   */ destroy(removeView, stageOptions) {
        const plugins = _Application2._plugins.slice(0);
        plugins.reverse(), plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        }), this.stage.destroy(stageOptions), this.stage = null, this.renderer.destroy(removeView), this.renderer = null;
    }
};
$1495858258e0a7a4$var$_Application._plugins = [];
let $1495858258e0a7a4$export$16975c34e60e1e61 = $1495858258e0a7a4$var$_Application;
(0, $5RvHb.extensions).handleByList((0, $5RvHb.ExtensionType).Application, $1495858258e0a7a4$export$16975c34e60e1e61._plugins);

});

parcelRegister("bScKZ", function(module, exports) {
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
class $57d95d4aa6d373bc$export$6453cd852defe94a {
    /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        Object.defineProperty(this, "resizeTo", /**
       * The HTML element or window to automatically resize the
       * renderer's view element to match width and height.
       * @member {Window|HTMLElement}
       * @name resizeTo
       * @memberof PIXI.Application#
       */ {
            set (dom) {
                globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = dom, dom && (globalThis.addEventListener("resize", this.queueResize), this.resize());
            },
            get () {
                return this._resizeTo;
            }
        }), this.queueResize = ()=>{
            this._resizeTo && (this.cancelResize(), this._resizeId = requestAnimationFrame(()=>this.resize()));
        }, this.cancelResize = ()=>{
            this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
        }, this.resize = ()=>{
            if (!this._resizeTo) return;
            this.cancelResize();
            let width, height;
            if (this._resizeTo === globalThis.window) width = globalThis.innerWidth, height = globalThis.innerHeight;
            else {
                const { clientWidth: clientWidth, clientHeight: clientHeight } = this._resizeTo;
                width = clientWidth, height = clientHeight;
            }
            this.renderer.resize(width, height), this.render();
        }, this._resizeId = null, this._resizeTo = null, this.resizeTo = options.resizeTo || null;
    }
    /**
   * Clean up the ticker, scoped to application
   * @static
   * @private
   */ static destroy() {
        globalThis.removeEventListener("resize", this.queueResize), this.cancelResize(), this.cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
    }
}
$57d95d4aa6d373bc$export$6453cd852defe94a.extension = (0, $5RvHb.ExtensionType).Application;
(0, $5RvHb.extensions).add($57d95d4aa6d373bc$export$6453cd852defe94a);

});


parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});




var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}



var $acw62 = parcelRequire("acw62");

function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $acw62 = parcelRequire("acw62");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$fb3356a19a5676fa$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $acw62.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $acw62.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $45e038b71f97d914$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $45e038b71f97d914$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $acw62.Children).toArray(children);
    const slottable = childrenArray.find($cf381de56a25bc52$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $acw62.Children).count(newElement) > 1) return (0, $acw62.Children).only(null);
                return /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $acw62.createElement)($cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? /*#__PURE__*/ (0, $acw62.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $acw62.createElement)($cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$cf381de56a25bc52$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(children)) return /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ...$cf381de56a25bc52$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $fb3356a19a5676fa$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $acw62.Children).count(children) > 1 ? (0, $acw62.Children).only(null) : null;
});
$cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $cf381de56a25bc52$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(child) && child.type === $cf381de56a25bc52$export$d9f1ccf0bdb05d45;
}
function $cf381de56a25bc52$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $cf381de56a25bc52$export$be92b6f5f03c0fe9 = $cf381de56a25bc52$export$8c6ed5c666ac1360;


// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + 'CollectionProvider';
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + 'CollectionSlot';
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf381de56a25bc52$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + 'CollectionItemSlot';
    const ITEM_DATA_ATTR = 'data-radix-collection-item';
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf381de56a25bc52$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: '',
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + 'CollectionConsumer', scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $dc7d5df3de21cdcb$var$$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'form',
    'h2',
    'h3',
    'img',
    'input',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $cf381de56a25bc52$export$8c6ed5c666ac1360) : node;
        (0, $acw62.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0, $acw62.createElement)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $11492dca620dcaa5$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $dc7d5df3de21cdcb$export$be92b6f5f03c0fe9 = $dc7d5df3de21cdcb$export$250ffa63cdc0d034;




var $acw62 = parcelRequire("acw62");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $acw62.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $acw62 = parcelRequire("acw62");

/**
 * Listens for when the escape key is down
 */ function $322b9f9e9e453dd6$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener('keydown', handleKeyDown);
        return ()=>ownerDocument.removeEventListener('keydown', handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $30a399657994b369$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = 'DismissableLayer';
const $30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = 'dismissableLayer.update';
const $30a399657994b369$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const $30a399657994b369$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
let $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $acw62.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $30a399657994b369$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $acw62.useContext)($30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $acw62.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $acw62.useState)({});
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $30a399657994b369$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $30a399657994b369$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $322b9f9e9e453dd6$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $acw62.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = 'none';
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? 'auto' : 'none' : undefined,
            ...props.style
        },
        onFocusCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($30a399657994b369$export$177fb62ff3ec1f22, {
    displayName: $30a399657994b369$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $30a399657994b369$var$$5cb92bef7577960e$var$BRANCH_NAME = 'DismissableLayerBranch';
const $30a399657994b369$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = (0, $acw62.useContext)($30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($30a399657994b369$export$4d5eb2109db14228, {
    displayName: $30a399657994b369$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $30a399657994b369$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $acw62.useRef)(false);
    const handleClickRef = (0, $acw62.useRef)(()=>{});
    (0, $acw62.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === 'touch') {
                    ownerDocument.removeEventListener('click', handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener('click', handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener('click', handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener('pointerdown', handlePointerDown);
            ownerDocument.removeEventListener('click', handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $30a399657994b369$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener('focusin', handleFocus);
        return ()=>ownerDocument.removeEventListener('focusin', handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $dc7d5df3de21cdcb$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $30a399657994b369$export$be92b6f5f03c0fe9 = $30a399657994b369$export$177fb62ff3ec1f22;
const $30a399657994b369$export$aecb2ddcb55c95be = $30a399657994b369$export$4d5eb2109db14228;




var $acw62 = parcelRequire("acw62");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $95d053caea9c023a$var$$f1701beae083dbae$var$PORTAL_NAME = 'Portal';
const $95d053caea9c023a$export$602eac185826482c = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($95d053caea9c023a$export$602eac185826482c, {
    displayName: $95d053caea9c023a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $95d053caea9c023a$export$be92b6f5f03c0fe9 = $95d053caea9c023a$export$602eac185826482c;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $b68d88740313b08e$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : ()=>{};


function $3207c0aa9f229d8f$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $acw62.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : (0, $acw62.Children).only(children);
    const ref = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
        ref: ref
    }) : null;
};
$3207c0aa9f229d8f$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $acw62.useState)();
    const stylesRef = (0, $acw62.useRef)({});
    const prevPresentRef = (0, $acw62.useRef)(present);
    const prevAnimationNameRef = (0, $acw62.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $3207c0aa9f229d8f$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0, $acw62.useEffect)(()=>{
        const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $11492dca620dcaa5$exports.flushSync)(()=>send('ANIMATION_END'));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0, $acw62.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}





var $acw62 = parcelRequire("acw62");

function $aef12de5508fd46e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $aef12de5508fd46e$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $acw62.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $aef12de5508fd46e$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $acw62.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $acw62.useRef)(value);
    const handleChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onChange);
    (0, $acw62.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $8d51f093cc1b6735$var$$ea1ef594cf570d83$var$NAME = 'VisuallyHidden';
const $8d51f093cc1b6735$export$439d29a4e110a164 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: 'absolute',
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($8d51f093cc1b6735$export$439d29a4e110a164, {
    displayName: $8d51f093cc1b6735$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $8d51f093cc1b6735$export$be92b6f5f03c0fe9 = $8d51f093cc1b6735$export$439d29a4e110a164;


/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$PROVIDER_NAME = 'ToastProvider';
const [$39e058e35b3b85b5$var$$054eb8030ebde76e$var$Collection, $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useCollection, $39e058e35b3b85b5$var$$054eb8030ebde76e$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)('Toast');
const [$39e058e35b3b85b5$var$$054eb8030ebde76e$var$createToastContext, $39e058e35b3b85b5$export$8a359da18fbc9073] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)('Toast', [
    $39e058e35b3b85b5$var$$054eb8030ebde76e$var$createCollectionScope
]);
const [$39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastProviderProvider, $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext] = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$createToastContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$PROVIDER_NAME);
const $39e058e35b3b85b5$export$f5d03d415824e0e = (props)=>{
    const { __scopeToast: __scopeToast, label: label = 'Notification', duration: duration = 5000, swipeDirection: swipeDirection = 'right', swipeThreshold: swipeThreshold = 50, children: children } = props;
    const [viewport, setViewport] = (0, $acw62.useState)(null);
    const [toastCount, setToastCount] = (0, $acw62.useState)(0);
    const isFocusedToastEscapeKeyDownRef = (0, $acw62.useRef)(false);
    const isClosePausedRef = (0, $acw62.useRef)(false);
    return /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0, $acw62.useCallback)(()=>setToastCount((prevCount)=>prevCount + 1), []),
        onToastRemove: (0, $acw62.useCallback)(()=>setToastCount((prevCount)=>prevCount - 1), []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$39e058e35b3b85b5$export$f5d03d415824e0e.propTypes = {
    label (props) {
        if (props.label && typeof props.label === 'string' && !props.label.trim()) {
            const error = `Invalid prop \`label\` supplied to \`${$39e058e35b3b85b5$var$$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$f5d03d415824e0e, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_NAME = 'ToastViewport';
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    'F8'
];
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE = 'toast.viewportPause';
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_RESUME = 'toast.viewportResume';
const $39e058e35b3b85b5$export$6192c2425ecfd989 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, hotkey: hotkey = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY, label: label = 'Notifications ({hotkey})', ...viewportProps } = props;
    const context = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    const getItems = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useCollection(__scopeToast);
    const wrapperRef = (0, $acw62.useRef)(null);
    const headFocusProxyRef = (0, $acw62.useRef)(null);
    const tailFocusProxyRef = (0, $acw62.useRef)(null);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join('+').replace(/Key/g, '').replace(/Digit/g, '');
    const hasToasts = context.toastCount > 0;
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key);
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, [
        hotkey
    ]);
    (0, $acw62.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        const viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            const handlePause = ()=>{
                if (!context.isClosePausedRef.current) {
                    const pauseEvent = new CustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            const handleResume = ()=>{
                if (context.isClosePausedRef.current) {
                    const resumeEvent = new CustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            const handleFocusOutResume = (event)=>{
                const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            const handlePointerLeaveResume = ()=>{
                const isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener('focusin', handlePause);
            wrapper.addEventListener('focusout', handleFocusOutResume);
            wrapper.addEventListener('pointermove', handlePause);
            wrapper.addEventListener('pointerleave', handlePointerLeaveResume);
            window.addEventListener('blur', handlePause);
            window.addEventListener('focus', handleResume);
            return ()=>{
                wrapper.removeEventListener('focusin', handlePause);
                wrapper.removeEventListener('focusout', handleFocusOutResume);
                wrapper.removeEventListener('pointermove', handlePause);
                wrapper.removeEventListener('pointerleave', handlePointerLeaveResume);
                window.removeEventListener('blur', handlePause);
                window.removeEventListener('focus', handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    const getSortedTabbableCandidates = (0, $acw62.useCallback)(({ tabbingDirection: tabbingDirection })=>{
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem)=>{
            const toastNode = toastItem.ref.current;
            const toastTabbableCandidates = [
                toastNode,
                ...$39e058e35b3b85b5$var$$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
            ];
            return tabbingDirection === 'forwards' ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === 'forwards' ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0, $acw62.useEffect)(()=>{
        const viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            const handleKeyDown = (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === 'Tab' && !isMetaKey;
                if (isTabKey) {
                    const focusedElement = document.activeElement;
                    const isTabbingBackwards = event.shiftKey;
                    const targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    const tabbingDirection = isTabbingBackwards ? 'backwards' : 'forwards';
                    const sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    const index = sortedCandidates.findIndex((candidate)=>candidate === focusedElement);
                    if ($39e058e35b3b85b5$var$$054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener('keydown', handleKeyDown);
            return ()=>viewport.removeEventListener('keydown', handleKeyDown);
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $30a399657994b369$export$aecb2ddcb55c95be), {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace('{hotkey}', hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : 'none'
        }
    }, hasToasts && /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: 'forwards'
            });
            $39e058e35b3b85b5$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).ol, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: 'backwards'
            });
            $39e058e35b3b85b5$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$6192c2425ecfd989, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME = 'ToastFocusProxy';
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, onFocusFromOutsideViewport: onFocusFromOutsideViewport, ...proxyProps } = props;
    const context = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $8d51f093cc1b6735$export$439d29a4e110a164), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: 'fixed'
        },
        onFocus: (event)=>{
            var _context$viewport;
            const prevFocusedElement = event.relatedTarget;
            const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$var$$054eb8030ebde76e$var$FocusProxy, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME = 'Toast';
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_START = 'toast.swipeStart';
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE = 'toast.swipeMove';
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = 'toast.swipeCancel';
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_END = 'toast.swipeEnd';
const $39e058e35b3b85b5$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, ...toastProps } = props;
    const [open = true, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: ()=>setOpen(false),
        onPause: (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(props.onPause),
        onResume: (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(props.onResume),
        onSwipeStart: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onSwipeStart, (event)=>{
            event.currentTarget.setAttribute('data-swipe', 'start');
        }),
        onSwipeMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onSwipeMove, (event)=>{
            const { x: x, y: y } = event.detail.delta;
            event.currentTarget.setAttribute('data-swipe', 'move');
            event.currentTarget.style.setProperty('--radix-toast-swipe-move-x', `${x}px`);
            event.currentTarget.style.setProperty('--radix-toast-swipe-move-y', `${y}px`);
        }),
        onSwipeCancel: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onSwipeCancel, (event)=>{
            event.currentTarget.setAttribute('data-swipe', 'cancel');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-y');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-end-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-end-y');
        }),
        onSwipeEnd: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onSwipeEnd, (event)=>{
            const { x: x, y: y } = event.detail.delta;
            event.currentTarget.setAttribute('data-swipe', 'end');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-x');
            event.currentTarget.style.removeProperty('--radix-toast-swipe-move-y');
            event.currentTarget.style.setProperty('--radix-toast-swipe-end-x', `${x}px`);
            event.currentTarget.style.setProperty('--radix-toast-swipe-end-y', `${y}px`);
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$8d8dc7d5f743331b, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastInteractiveProvider, $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastInteractiveContext] = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$createToastContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME, {
    onClose () {}
});
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, type: type = 'foreground', duration: durationProp, open: open, onClose: onClose, onEscapeKeyDown: onEscapeKeyDown, onPause: onPause, onResume: onResume, onSwipeStart: onSwipeStart, onSwipeMove: onSwipeMove, onSwipeCancel: onSwipeCancel, onSwipeEnd: onSwipeEnd, ...toastProps } = props;
    const context = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [node1, setNode] = (0, $acw62.useState)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const pointerStartRef = (0, $acw62.useRef)(null);
    const swipeDeltaRef = (0, $acw62.useRef)(null);
    const duration1 = durationProp || context.duration;
    const closeTimerStartTimeRef = (0, $acw62.useRef)(0);
    const closeTimerRemainingTimeRef = (0, $acw62.useRef)(duration1);
    const closeTimerRef = (0, $acw62.useRef)(0);
    const { onToastAdd: onToastAdd, onToastRemove: onToastRemove } = context;
    const handleClose = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(()=>{
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    const startTimer = (0, $acw62.useCallback)((duration)=>{
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0, $acw62.useEffect)(()=>{
        const viewport = context.viewport;
        if (viewport) {
            const handleResume = ()=>{
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            const handlePause = ()=>{
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return ()=>{
                viewport.removeEventListener($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($39e058e35b3b85b5$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0, $acw62.useEffect)(()=>{
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0, $acw62.useEffect)(()=>{
        onToastAdd();
        return ()=>onToastRemove();
    }, [
        onToastAdd,
        onToastRemove
    ]);
    const announceTextContent = (0, $acw62.useMemo)(()=>{
        return node1 ? $39e058e35b3b85b5$var$$054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, announceTextContent && /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === 'foreground' ? 'assertive' : 'polite',
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $30a399657994b369$export$be92b6f5f03c0fe9), {
        asChild: true,
        onEscapeKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onEscapeKeyDown, ()=>{
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).li, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? 'open' : 'closed',
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: {
            userSelect: 'none',
            touchAction: 'none',
            ...props.style
        },
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key !== 'Escape') return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (!pointerStartRef.current) return;
            const x = event.clientX - pointerStartRef.current.x;
            const y = event.clientY - pointerStartRef.current.y;
            const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            const isHorizontalSwipe = [
                'left',
                'right'
            ].includes(context.swipeDirection);
            const clamp = [
                'left',
                'up'
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            const clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            const clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            const moveStartBuffer = event.pointerType === 'touch' ? 10 : 2;
            const delta = {
                x: clampedX,
                y: clampedY
            };
            const eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($39e058e35b3b85b5$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerUp, (event1)=>{
            const delta = swipeDeltaRef.current;
            const target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                const toast = event1.currentTarget;
                const eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($39e058e35b3b85b5$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener('click', (event)=>event.preventDefault(), {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type (props) {
        if (props.type && ![
            'foreground',
            'background'
        ].includes(props.type)) {
            const error = `Invalid prop \`type\` supplied to \`${$39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounce = (props)=>{
    const { __scopeToast: __scopeToast, children: children, ...announceProps } = props;
    const context = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastProviderContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [renderAnnounceText, setRenderAnnounceText] = (0, $acw62.useState)(false);
    const [isAnnounced, setIsAnnounced] = (0, $acw62.useState)(false); // render text content in the next frame to ensure toast is announced in NVDA
    $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useNextFrame(()=>setRenderAnnounceText(true)); // cleanup after announcing
    (0, $acw62.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsAnnounced(true), 1000);
        return ()=>window.clearTimeout(timer);
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $95d053caea9c023a$export$602eac185826482c), {
        asChild: true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $8d51f093cc1b6735$export$439d29a4e110a164), announceProps, renderAnnounceText && /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TITLE_NAME = 'ToastTitle';
const $39e058e35b3b85b5$export$16d42d7c29b95a4 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...titleProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$16d42d7c29b95a4, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$DESCRIPTION_NAME = 'ToastDescription';
const $39e058e35b3b85b5$export$ecddd96c53621d9a = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...descriptionProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$ecddd96c53621d9a, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ACTION_NAME = 'ToastAction';
const $39e058e35b3b85b5$export$3019feecfda683d2 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { altText: altText, ...actionProps } = props;
    if (!altText) return null;
    return /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$export$811e70f61c205839, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, actionProps, {
        ref: forwardedRef
    })));
});
$39e058e35b3b85b5$export$3019feecfda683d2.propTypes = {
    altText (props) {
        if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$39e058e35b3b85b5$var$$054eb8030ebde76e$var$ACTION_NAME}\``);
        return null;
    }
};
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$3019feecfda683d2, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$CLOSE_NAME = 'ToastClose';
const $39e058e35b3b85b5$export$811e70f61c205839 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...closeProps } = props;
    const interactiveContext = $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useToastInteractiveContext($39e058e35b3b85b5$var$$054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $acw62.createElement)($39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($39e058e35b3b85b5$export$811e70f61c205839, {
    displayName: $39e058e35b3b85b5$var$$054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, altText: altText, ...announceExcludeProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$getAnnounceTextContent(container) {
    const textContent = [];
    const childNodes = Array.from(container.childNodes);
    childNodes.forEach((node)=>{
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($39e058e35b3b85b5$var$$054eb8030ebde76e$var$isHTMLElement(node)) {
            const isHidden = node.ariaHidden || node.hidden || node.style.display === 'none';
            const isExcluded = node.dataset.radixToastAnnounceExclude === '';
            if (!isHidden) {
                if (isExcluded) {
                    const altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else textContent.push(...$39e058e35b3b85b5$var$$054eb8030ebde76e$var$getAnnounceTextContent(node));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const currentTarget = detail.originalEvent.currentTarget;
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $dc7d5df3de21cdcb$export$6d1a0317bde7de7f)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
const $39e058e35b3b85b5$var$$054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0)=>{
    const deltaX = Math.abs(delta.x);
    const deltaY = Math.abs(delta.y);
    const isDeltaX = deltaX > deltaY;
    if (direction === 'left' || direction === 'right') return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$useNextFrame(callback = ()=>{}) {
    const fn = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(callback);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        let raf1 = 0;
        let raf2 = 0;
        raf1 = window.requestAnimationFrame(()=>raf2 = window.requestAnimationFrame(fn));
        return ()=>{
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $39e058e35b3b85b5$var$$054eb8030ebde76e$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
const $39e058e35b3b85b5$export$2881499e37b75b9a = $39e058e35b3b85b5$export$f5d03d415824e0e;
const $39e058e35b3b85b5$export$d5c6c08dc2d3ca7 = $39e058e35b3b85b5$export$6192c2425ecfd989;
const $39e058e35b3b85b5$export$be92b6f5f03c0fe9 = $39e058e35b3b85b5$export$8d8dc7d5f743331b;
const $39e058e35b3b85b5$export$f99233281efd08a0 = $39e058e35b3b85b5$export$16d42d7c29b95a4;
const $39e058e35b3b85b5$export$393edc798c47379d = $39e058e35b3b85b5$export$ecddd96c53621d9a;
const $39e058e35b3b85b5$export$e19cd5f9376f8cee = $39e058e35b3b85b5$export$3019feecfda683d2;
const $39e058e35b3b85b5$export$f39c2d165cd861fe = $39e058e35b3b85b5$export$811e70f61c205839;


var $c0db4aef7ce5b3a1$exports = {};

$parcel$export($c0db4aef7ce5b3a1$exports, "closeButton", () => $c0db4aef7ce5b3a1$export$efe229eab43a9869, (v) => $c0db4aef7ce5b3a1$export$efe229eab43a9869 = v);
$parcel$export($c0db4aef7ce5b3a1$exports, "toast", () => $c0db4aef7ce5b3a1$export$b410431fab84fa58, (v) => $c0db4aef7ce5b3a1$export$b410431fab84fa58 = v);
$parcel$export($c0db4aef7ce5b3a1$exports, "viewport", () => $c0db4aef7ce5b3a1$export$d7b7311ec04a3e8f, (v) => $c0db4aef7ce5b3a1$export$d7b7311ec04a3e8f = v);
var $c0db4aef7ce5b3a1$export$efe229eab43a9869;
var $c0db4aef7ce5b3a1$export$b410431fab84fa58;
var $c0db4aef7ce5b3a1$export$d7b7311ec04a3e8f;
$c0db4aef7ce5b3a1$export$efe229eab43a9869 = `tqfRCW_closeButton`;
$c0db4aef7ce5b3a1$export$b410431fab84fa58 = `tqfRCW_toast`;
$c0db4aef7ce5b3a1$export$d7b7311ec04a3e8f = `tqfRCW_viewport`;



var $acw62 = parcelRequire("acw62");
const $83c3827d0c2b2403$var$context = /*#__PURE__*/ (0, $acw62.createContext)({
    show: ()=>{
        throw new Error("Toaster is not provided");
    }
});
function $83c3827d0c2b2403$export$f46171b59bb094f9() {
    return (0, $acw62.useContext)($83c3827d0c2b2403$var$context);
}
const $83c3827d0c2b2403$export$fb98e3a2a4cd92d7 = (props)=>{
    const [toasts, setToasts] = (0, $acw62.useState)([]);
    const contextValue = (0, $acw62.useMemo)(()=>{
        return {
            show: (message, duration)=>{
                setToasts((prev)=>[
                        {
                            id: crypto.randomUUID(),
                            description: message,
                            duration: duration
                        },
                        ...prev
                    ]);
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83c3827d0c2b2403$var$context.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($39e058e35b3b85b5$export$2881499e37b75b9a, {
            duration: 3000,
            children: [
                props.children,
                toasts.map((toast)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($39e058e35b3b85b5$export$be92b6f5f03c0fe9, {
                        duration: toast.duration,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c0db4aef7ce5b3a1$exports))).toast,
                        children: [
                            toast.title !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$f99233281efd08a0, {
                                children: toast.title
                            }),
                            toast.description !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$393edc798c47379d, {
                                children: toast.description
                            }),
                            toast.action !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$e19cd5f9376f8cee, {
                                altText: toast.action.altText,
                                onClick: toast.action.callback,
                                children: toast.action.label
                            }),
                            toast.closable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$f39c2d165cd861fe, {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c0db4aef7ce5b3a1$exports))).closeButton,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($83c3827d0c2b2403$var$CloseIcon, {})
                            })
                        ]
                    }, toast.id)),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39e058e35b3b85b5$export$d5c6c08dc2d3ca7, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c0db4aef7ce5b3a1$exports))).viewport
                })
            ]
        })
    });
};
const $83c3827d0c2b2403$var$CloseIcon = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_62_32",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "25",
                height: "25",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "0.591064",
                    y: "0.367188",
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_62_32)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6.99106 19.3672L5.59106 17.9672L11.1911 12.3672L5.59106 6.76719L6.99106 5.36719L12.5911 10.9672L18.1911 5.36719L19.5911 6.76719L13.9911 12.3672L19.5911 17.9672L18.1911 19.3672L12.5911 13.7672L6.99106 19.3672Z",
                    fill: "white"
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $a60be4e6fbee351d$exports = {};

$parcel$export($a60be4e6fbee351d$exports, "container", () => $a60be4e6fbee351d$export$34e0f9847d4c02dd, (v) => $a60be4e6fbee351d$export$34e0f9847d4c02dd = v);
var $a60be4e6fbee351d$export$34e0f9847d4c02dd;
$a60be4e6fbee351d$export$34e0f9847d4c02dd = `_8V6FsW_container`;



var $acw62 = parcelRequire("acw62");
parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $6wJoy = parcelRequire("6wJoy");
var $kZOeV = parcelRequire("kZOeV");
var $4UuR4 = parcelRequire("4UuR4");
var $cWOCu = parcelRequire("cWOCu");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("gD5uZ");
var $5xkOK = parcelRequire("5xkOK");
parcelRequire("jW6UI");
var $3uiak = parcelRequire("3uiak");
const $7d41d0b4ce1f40f2$var$_tempMatrix = new (0, $6wJoy.Matrix)();
(0, $5xkOK.DisplayObject).prototype._cacheAsBitmap = !1;
(0, $5xkOK.DisplayObject).prototype._cacheData = null;
(0, $5xkOK.DisplayObject).prototype._cacheAsBitmapResolution = null;
(0, $5xkOK.DisplayObject).prototype._cacheAsBitmapMultisample = null;
class $7d41d0b4ce1f40f2$export$3e19bdfd927f283c {
    constructor(){
        this.textureCacheId = null, this.originalRender = null, this.originalRenderCanvas = null, this.originalCalculateBounds = null, this.originalGetLocalBounds = null, this.originalUpdateTransform = null, this.originalDestroy = null, this.originalMask = null, this.originalFilterArea = null, this.originalContainsPoint = null, this.sprite = null;
    }
}
Object.defineProperties((0, $5xkOK.DisplayObject).prototype, {
    /**
   * The resolution to use for cacheAsBitmap. By default this will use the renderer's resolution
   * but can be overriden for performance. Lower values will reduce memory usage at the expense
   * of render quality. A falsey value of `null` or `0` will default to the renderer's resolution.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new resolution.
   * @member {number|null} cacheAsBitmapResolution
   * @memberof PIXI.DisplayObject#
   * @default null
   */ cacheAsBitmapResolution: {
        get () {
            return this._cacheAsBitmapResolution;
        },
        set (resolution) {
            resolution !== this._cacheAsBitmapResolution && (this._cacheAsBitmapResolution = resolution, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
        }
    },
    /**
   * The number of samples to use for cacheAsBitmap. If set to `null`, the renderer's
   * sample count is used.
   * If `cacheAsBitmap` is set to `true`, this will re-render with the new number of samples.
   * @member {number|null} cacheAsBitmapMultisample
   * @memberof PIXI.DisplayObject#
   * @default null
   */ cacheAsBitmapMultisample: {
        get () {
            return this._cacheAsBitmapMultisample;
        },
        set (multisample) {
            multisample !== this._cacheAsBitmapMultisample && (this._cacheAsBitmapMultisample = multisample, this.cacheAsBitmap && (this.cacheAsBitmap = !1, this.cacheAsBitmap = !0));
        }
    },
    /**
   * Set this to true if you want this display object to be cached as a bitmap.
   * This basically takes a snapshot of the display object as it is at that moment. It can
   * provide a performance benefit for complex static displayObjects.
   * To remove simply set this property to `false`
   *
   * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
   * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */ cacheAsBitmap: {
        get () {
            return this._cacheAsBitmap;
        },
        set (value) {
            if (this._cacheAsBitmap === value) return;
            this._cacheAsBitmap = value;
            let data;
            value ? (this._cacheData || (this._cacheData = new $7d41d0b4ce1f40f2$export$3e19bdfd927f283c()), data = this._cacheData, data.originalRender = this.render, data.originalRenderCanvas = this.renderCanvas, data.originalUpdateTransform = this.updateTransform, data.originalCalculateBounds = this.calculateBounds, data.originalGetLocalBounds = this.getLocalBounds, data.originalDestroy = this.destroy, data.originalContainsPoint = this.containsPoint, data.originalMask = this._mask, data.originalFilterArea = this.filterArea, this.render = this._renderCached, this.renderCanvas = this._renderCachedCanvas, this.destroy = this._cacheAsBitmapDestroy) : (data = this._cacheData, data.sprite && this._destroyCachedDisplayObject(), this.render = data.originalRender, this.renderCanvas = data.originalRenderCanvas, this.calculateBounds = data.originalCalculateBounds, this.getLocalBounds = data.originalGetLocalBounds, this.destroy = data.originalDestroy, this.updateTransform = data.originalUpdateTransform, this.containsPoint = data.originalContainsPoint, this._mask = data.originalMask, this.filterArea = data.originalFilterArea);
        }
    }
});
(0, $5xkOK.DisplayObject).prototype._renderCached = function(renderer) {
    !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObject(renderer), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._render(renderer));
};
(0, $5xkOK.DisplayObject).prototype._initCachedDisplayObject = function(renderer) {
    if (this._cacheData?.sprite) return;
    const cacheAlpha = this.alpha;
    this.alpha = 1, renderer.batch.flush();
    const bounds = this.getLocalBounds(new (0, $kZOeV.Rectangle)(), !0);
    if (this.filters?.length) {
        const padding = this.filters[0].padding;
        bounds.pad(padding);
    }
    const resolution = this.cacheAsBitmapResolution || renderer.resolution;
    bounds.ceil(resolution), bounds.width = Math.max(bounds.width, 1 / resolution), bounds.height = Math.max(bounds.height, 1 / resolution);
    const cachedRenderTexture = renderer.renderTexture.current, cachedSourceFrame = renderer.renderTexture.sourceFrame.clone(), cachedDestinationFrame = renderer.renderTexture.destinationFrame.clone(), cachedProjectionTransform = renderer.projection.transform, renderTexture = (0, $4UuR4.RenderTexture).create({
        width: bounds.width,
        height: bounds.height,
        resolution: resolution,
        multisample: this.cacheAsBitmapMultisample ?? renderer.multisample
    }), textureCacheId = `cacheAsBitmap_${(0, $lFGyw).uid()}`;
    this._cacheData.textureCacheId = textureCacheId, (0, $4oWO8.BaseTexture).addToCache(renderTexture.baseTexture, textureCacheId), (0, $cWOCu.Texture).addToCache(renderTexture, textureCacheId);
    const m = this.transform.localTransform.copyTo($7d41d0b4ce1f40f2$var$_tempMatrix).invert().translate(-bounds.x, -bounds.y);
    this.render = this._cacheData.originalRender, renderer.render(this, {
        renderTexture: renderTexture,
        clear: !0,
        transform: m,
        skipUpdateTransform: !1
    }), renderer.framebuffer.blit(), renderer.projection.transform = cachedProjectionTransform, renderer.renderTexture.bind(cachedRenderTexture, cachedSourceFrame, cachedDestinationFrame), this.render = this._renderCached, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = cacheAlpha;
    const cachedSprite = new (0, $3uiak.Sprite)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform, cachedSprite.anchor.x = -(bounds.x / bounds.width), cachedSprite.anchor.y = -(bounds.y / bounds.height), cachedSprite.alpha = cacheAlpha, cachedSprite._bounds = this._bounds, this._cacheData.sprite = cachedSprite, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.enableTempParent(), this.updateTransform(), this.disableTempParent(null)), this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
(0, $5xkOK.DisplayObject).prototype._renderCachedCanvas = function(renderer) {
    !this.visible || this.worldAlpha <= 0 || !this.renderable || (this._initCachedDisplayObjectCanvas(renderer), this._cacheData.sprite.worldAlpha = this.worldAlpha, this._cacheData.sprite._renderCanvas(renderer));
};
(0, $5xkOK.DisplayObject).prototype._initCachedDisplayObjectCanvas = function(renderer) {
    if (this._cacheData?.sprite) return;
    const bounds = this.getLocalBounds(new (0, $kZOeV.Rectangle)(), !0), cacheAlpha = this.alpha;
    this.alpha = 1;
    const cachedRenderTarget = renderer.canvasContext.activeContext, cachedProjectionTransform = renderer._projTransform, resolution = this.cacheAsBitmapResolution || renderer.resolution;
    bounds.ceil(resolution), bounds.width = Math.max(bounds.width, 1 / resolution), bounds.height = Math.max(bounds.height, 1 / resolution);
    const renderTexture = (0, $4UuR4.RenderTexture).create({
        width: bounds.width,
        height: bounds.height,
        resolution: resolution
    }), textureCacheId = `cacheAsBitmap_${(0, $lFGyw).uid()}`;
    this._cacheData.textureCacheId = textureCacheId, (0, $4oWO8.BaseTexture).addToCache(renderTexture.baseTexture, textureCacheId), (0, $cWOCu.Texture).addToCache(renderTexture, textureCacheId);
    const m = $7d41d0b4ce1f40f2$var$_tempMatrix;
    this.transform.localTransform.copyTo(m), m.invert(), m.tx -= bounds.x, m.ty -= bounds.y, this.renderCanvas = this._cacheData.originalRenderCanvas, renderer.render(this, {
        renderTexture: renderTexture,
        clear: !0,
        transform: m,
        skipUpdateTransform: !1
    }), renderer.canvasContext.activeContext = cachedRenderTarget, renderer._projTransform = cachedProjectionTransform, this.renderCanvas = this._renderCachedCanvas, this.updateTransform = this.displayObjectUpdateTransform, this.calculateBounds = this._calculateCachedBounds, this.getLocalBounds = this._getCachedLocalBounds, this._mask = null, this.filterArea = null, this.alpha = cacheAlpha;
    const cachedSprite = new (0, $3uiak.Sprite)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform, cachedSprite.anchor.x = -(bounds.x / bounds.width), cachedSprite.anchor.y = -(bounds.y / bounds.height), cachedSprite.alpha = cacheAlpha, cachedSprite._bounds = this._bounds, this._cacheData.sprite = cachedSprite, this.transform._parentID = -1, this.parent ? this.updateTransform() : (this.parent = renderer._tempDisplayObjectParent, this.updateTransform(), this.parent = null), this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
(0, $5xkOK.DisplayObject).prototype._calculateCachedBounds = function() {
    this._bounds.clear(), this._cacheData.sprite.transform._worldID = this.transform._worldID, this._cacheData.sprite._calculateBounds(), this._bounds.updateID = this._boundsID;
};
(0, $5xkOK.DisplayObject).prototype._getCachedLocalBounds = function() {
    return this._cacheData.sprite.getLocalBounds(null);
};
(0, $5xkOK.DisplayObject).prototype._destroyCachedDisplayObject = function() {
    this._cacheData.sprite._texture.destroy(!0), this._cacheData.sprite = null, (0, $4oWO8.BaseTexture).removeFromCache(this._cacheData.textureCacheId), (0, $cWOCu.Texture).removeFromCache(this._cacheData.textureCacheId), this._cacheData.textureCacheId = null;
};
(0, $5xkOK.DisplayObject).prototype._cacheAsBitmapDestroy = function(options) {
    this.cacheAsBitmap = !1, this.destroy(options);
};


parcelRequire("gD5uZ");
var $3IPo5 = parcelRequire("3IPo5");
var $5xkOK = parcelRequire("5xkOK");
(0, $5xkOK.DisplayObject).prototype.name = null;
(0, $3IPo5.Container).prototype.getChildByName = function(name, deep) {
    for(let i = 0, j = this.children.length; i < j; i++)if (this.children[i].name === name) return this.children[i];
    if (deep) for(let i = 0, j = this.children.length; i < j; i++){
        const child = this.children[i];
        if (!child.getChildByName) continue;
        const target = child.getChildByName(name, !0);
        if (target) return target;
    }
    return null;
};


parcelRequire("inflE");
var $gnwPx = parcelRequire("gnwPx");
parcelRequire("gD5uZ");
var $5xkOK = parcelRequire("5xkOK");
(0, $5xkOK.DisplayObject).prototype.getGlobalPosition = function(point = new (0, $gnwPx.Point)(), skipUpdate = !1) {
    return this.parent ? this.parent.toGlobal(this.position, point, skipUpdate) : (point.x = this.position.x, point.y = this.position.y), point;
};


parcelRequire("inflE");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("inflE");
var $17owa = parcelRequire("17owa");
var $3x7iq = parcelRequire("3x7iq");
var $ad6577ea8584468e$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;

uniform sampler2D uSampler;
uniform float uAlpha;

void main(void)
{
   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;
}
`;


class $eb46baeaa5184069$export$adbaa0de008b0d7a extends (0, $3x7iq.Filter) {
    /**
   * @param alpha - Amount of alpha from 0 to 1, where 0 is transparent
   */ constructor(alpha = 1){
        super((0, $17owa.defaultVertex), (0, $ad6577ea8584468e$export$2e2bcd8739ae039), {
            uAlpha: 1
        }), this.alpha = alpha;
    }
    /**
   * Coefficient for alpha multiplication
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
}




parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $3x7iq = parcelRequire("3x7iq");
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $3x7iq = parcelRequire("3x7iq");
const $1bd88149b4277eef$var$GAUSSIAN_VALUES = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        93e-4,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        2406e-6,
        9255e-6,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        489e-6,
        2403e-6,
        9246e-6,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
}, $1bd88149b4277eef$var$fragTemplate = [
    "varying vec2 vBlurTexCoords[%size%];",
    "uniform sampler2D uSampler;",
    "void main(void)",
    "{",
    "    gl_FragColor = vec4(0.0);",
    "    %blur%",
    "}"
].join(`
`);
function $1bd88149b4277eef$export$1b0dcf101eb6a1c9(kernelSize) {
    const kernel = $1bd88149b4277eef$var$GAUSSIAN_VALUES[kernelSize], halfLength = kernel.length;
    let fragSource = $1bd88149b4277eef$var$fragTemplate, blurLoop = "";
    const template = "gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;";
    let value;
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        value = i, i >= halfLength && (value = kernelSize - i - 1), blur = blur.replace("%value%", kernel[value].toString()), blurLoop += blur, blurLoop += `
`;
    }
    return fragSource = fragSource.replace("%blur%", blurLoop), fragSource = fragSource.replace("%size%", kernelSize.toString()), fragSource;
}


const $47d860a0465411a8$var$vertTemplate = `
    attribute vec2 aVertexPosition;

    uniform mat3 projectionMatrix;

    uniform float strength;

    varying vec2 vBlurTexCoords[%size%];

    uniform vec4 inputSize;
    uniform vec4 outputFrame;

    vec4 filterVertexPosition( void )
    {
        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    }

    vec2 filterTextureCoord( void )
    {
        return aVertexPosition * (outputFrame.zw * inputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function $47d860a0465411a8$export$7a7fb9d9d09c33af(kernelSize, x) {
    const halfLength = Math.ceil(kernelSize / 2);
    let vertSource = $47d860a0465411a8$var$vertTemplate, blurLoop = "", template;
    x ? template = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);" : template = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);";
    for(let i = 0; i < kernelSize; i++){
        let blur = template.replace("%index%", i.toString());
        blur = blur.replace("%sampleIndex%", `${i - (halfLength - 1)}.0`), blurLoop += blur, blurLoop += `
`;
    }
    return vertSource = vertSource.replace("%blur%", blurLoop), vertSource = vertSource.replace("%size%", kernelSize.toString()), vertSource;
}


class $e02eb7d1be82cd90$export$b100a8e8116621cf extends (0, $3x7iq.Filter) {
    /**
   * @param horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */ constructor(horizontal, strength = 8, quality = 4, resolution = (0, $3x7iq.Filter).defaultResolution, kernelSize = 5){
        const vertSrc = (0, $47d860a0465411a8$export$7a7fb9d9d09c33af)(kernelSize, horizontal), fragSrc = (0, $1bd88149b4277eef$export$1b0dcf101eb6a1c9)(kernelSize);
        super(// vertex shader
        vertSrc, // fragment shader
        fragSrc), this.horizontal = horizontal, this.resolution = resolution, this._quality = 0, this.quality = quality, this.blur = strength;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        if (output ? this.horizontal ? this.uniforms.strength = 1 / output.width * (output.width / input.width) : this.uniforms.strength = 1 / output.height * (output.height / input.height) : this.horizontal ? this.uniforms.strength = 1 / filterManager.renderer.width * (filterManager.renderer.width / input.width) : this.uniforms.strength = 1 / filterManager.renderer.height * (filterManager.renderer.height / input.height), this.uniforms.strength *= this.strength, this.uniforms.strength /= this.passes, this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            const renderTarget = filterManager.getFilterTexture(), renderer = filterManager.renderer;
            let flip = input, flop = renderTarget;
            this.state.blend = !1, filterManager.applyFilter(this, flip, flop, (0, $lmRm8.CLEAR_MODES).CLEAR);
            for(let i = 1; i < this.passes - 1; i++){
                filterManager.bindAndClear(flip, (0, $lmRm8.CLEAR_MODES).BLIT), this.uniforms.uSampler = flop;
                const temp = flop;
                flop = flip, flip = temp, renderer.shader.bind(this), renderer.geometry.draw(5);
            }
            this.state.blend = !0, filterManager.applyFilter(this, flop, output, clearMode), filterManager.returnFilterTexture(renderTarget);
        }
    }
    /**
   * Sets the strength of both the blur.
   * @default 16
   */ get blur() {
        return this.strength;
    }
    set blur(value) {
        this.padding = 1 + Math.abs(value) * 2, this.strength = value;
    }
    /**
   * Sets the quality of the blur by modifying the number of passes. More passes means higher
   * quality bluring but the lower the performance.
   * @default 4
   */ get quality() {
        return this._quality;
    }
    set quality(value) {
        this._quality = value, this.passes = value;
    }
}


class $d646b7e94dfd28fa$export$424348d09d827f49 extends (0, $3x7iq.Filter) {
    /**
   * @param strength - The strength of the blur filter.
   * @param quality - The quality of the blur filter.
   * @param {number|null} [resolution=PIXI.Filter.defaultResolution] - The resolution of the blur filter.
   * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */ constructor(strength = 8, quality = 4, resolution = (0, $3x7iq.Filter).defaultResolution, kernelSize = 5){
        super(), this._repeatEdgePixels = !1, this.blurXFilter = new (0, $e02eb7d1be82cd90$export$b100a8e8116621cf)(!0, strength, quality, resolution, kernelSize), this.blurYFilter = new (0, $e02eb7d1be82cd90$export$b100a8e8116621cf)(!1, strength, quality, resolution, kernelSize), this.resolution = resolution, this.quality = quality, this.blur = strength, this.repeatEdgePixels = !1;
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */ apply(filterManager, input, output, clearMode) {
        const xStrength = Math.abs(this.blurXFilter.strength), yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            const renderTarget = filterManager.getFilterTexture();
            this.blurXFilter.apply(filterManager, input, renderTarget, (0, $lmRm8.CLEAR_MODES).CLEAR), this.blurYFilter.apply(filterManager, renderTarget, output, clearMode), filterManager.returnFilterTexture(renderTarget);
        } else yStrength ? this.blurYFilter.apply(filterManager, input, output, clearMode) : this.blurXFilter.apply(filterManager, input, output, clearMode);
    }
    updatePadding() {
        this._repeatEdgePixels ? this.padding = 0 : this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
    }
    /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   */ get blur() {
        return this.blurXFilter.blur;
    }
    set blur(value) {
        this.blurXFilter.blur = this.blurYFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the number of passes for blur. More passes means higher quality bluring.
   * @default 1
   */ get quality() {
        return this.blurXFilter.quality;
    }
    set quality(value) {
        this.blurXFilter.quality = this.blurYFilter.quality = value;
    }
    /**
   * Sets the strength of the blurX property
   * @default 2
   */ get blurX() {
        return this.blurXFilter.blur;
    }
    set blurX(value) {
        this.blurXFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the strength of the blurY property
   * @default 2
   */ get blurY() {
        return this.blurYFilter.blur;
    }
    set blurY(value) {
        this.blurYFilter.blur = value, this.updatePadding();
    }
    /**
   * Sets the blendmode of the filter
   * @default PIXI.BLEND_MODES.NORMAL
   */ get blendMode() {
        return this.blurYFilter.blendMode;
    }
    set blendMode(value) {
        this.blurYFilter.blendMode = value;
    }
    /**
   * If set to true the edge of the target will be clamped
   * @default false
   */ get repeatEdgePixels() {
        return this._repeatEdgePixels;
    }
    set repeatEdgePixels(value) {
        this._repeatEdgePixels = value, this.updatePadding();
    }
}





parcelRequire("inflE");
var $1PNws = parcelRequire("1PNws");
var $17owa = parcelRequire("17owa");
var $3x7iq = parcelRequire("3x7iq");
var $4f99f223a818225a$export$2e2bcd8739ae039 = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float m[20];
uniform float uAlpha;

void main(void)
{
    vec4 c = texture2D(uSampler, vTextureCoord);

    if (uAlpha == 0.0) {
        gl_FragColor = c;
        return;
    }

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (c.a > 0.0) {
      c.rgb /= c.a;
    }

    vec4 result;

    result.r = (m[0] * c.r);
        result.r += (m[1] * c.g);
        result.r += (m[2] * c.b);
        result.r += (m[3] * c.a);
        result.r += m[4];

    result.g = (m[5] * c.r);
        result.g += (m[6] * c.g);
        result.g += (m[7] * c.b);
        result.g += (m[8] * c.a);
        result.g += m[9];

    result.b = (m[10] * c.r);
       result.b += (m[11] * c.g);
       result.b += (m[12] * c.b);
       result.b += (m[13] * c.a);
       result.b += m[14];

    result.a = (m[15] * c.r);
       result.a += (m[16] * c.g);
       result.a += (m[17] * c.b);
       result.a += (m[18] * c.a);
       result.a += m[19];

    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);

    // Premultiply alpha again.
    rgb *= result.a;

    gl_FragColor = vec4(rgb, result.a);
}
`;


class $9783b70fe428f333$export$6547db23997fcec5 extends (0, $3x7iq.Filter) {
    constructor(){
        const uniforms = {
            m: new Float32Array([
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]),
            uAlpha: 1
        };
        super((0, $17owa.defaultFilterVertex), (0, $4f99f223a818225a$export$2e2bcd8739ae039), uniforms), this.alpha = 1;
    }
    /**
   * Transforms current matrix and set the new one
   * @param {number[]} matrix - 5x4 matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ _loadMatrix(matrix, multiply = !1) {
        let newMatrix = matrix;
        multiply && (this._multiply(newMatrix, this.uniforms.m, matrix), newMatrix = this._colorMatrix(newMatrix)), this.uniforms.m = newMatrix;
    }
    /**
   * Multiplies two mat5's
   * @private
   * @param out - 5x4 matrix the receiving matrix
   * @param a - 5x4 matrix the first operand
   * @param b - 5x4 matrix the second operand
   * @returns {number[]} 5x4 matrix
   */ _multiply(out, a, b) {
        return out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15], out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16], out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17], out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18], out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4], out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15], out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16], out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17], out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18], out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9], out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15], out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16], out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17], out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18], out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14], out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15], out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16], out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17], out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18], out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19], out;
    }
    /**
   * Create a Float32 Array and normalize the offset component to 0-1
   * @param {number[]} matrix - 5x4 matrix
   * @returns {number[]} 5x4 matrix with all values between 0-1
   */ _colorMatrix(matrix) {
        const m = new Float32Array(matrix);
        return m[4] /= 255, m[9] /= 255, m[14] /= 255, m[19] /= 255, m;
    }
    /**
   * Adjusts brightness
   * @param b - value of the brigthness (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ brightness(b, multiply) {
        const matrix = [
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Sets each channel on the diagonal of the color matrix.
   * This can be used to achieve a tinting effect on Containers similar to the tint field of some
   * display objects like Sprite, Text, Graphics, and Mesh.
   * @param color - Color of the tint. This is a hex value.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ tint(color, multiply) {
        const [r, g, b] = (0, $1PNws.Color).shared.setValue(color).toArray(), matrix = [
            r,
            0,
            0,
            0,
            0,
            0,
            g,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the matrices in grey scales
   * @param scale - value of the grey (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ greyscale(scale, multiply) {
        const matrix = [
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the black and white matrice.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ blackAndWhite(multiply) {
        const matrix = [
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the hue property of the color
   * @param rotation - in degrees
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ hue(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;
        const cosR = Math.cos(rotation), sinR = Math.sin(rotation), sqrt = Math.sqrt, w = 1 / 3, sqrW = sqrt(w), a00 = cosR + (1 - cosR) * w, a01 = w * (1 - cosR) - sqrW * sinR, a02 = w * (1 - cosR) + sqrW * sinR, a10 = w * (1 - cosR) + sqrW * sinR, a11 = cosR + w * (1 - cosR), a12 = w * (1 - cosR) - sqrW * sinR, a20 = w * (1 - cosR) - sqrW * sinR, a21 = w * (1 - cosR) + sqrW * sinR, a22 = cosR + w * (1 - cosR), matrix = [
            a00,
            a01,
            a02,
            0,
            0,
            a10,
            a11,
            a12,
            0,
            0,
            a20,
            a21,
            a22,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the contrast matrix, increase the separation between dark and bright
   * Increase contrast : shadows darker and highlights brighter
   * Decrease contrast : bring the shadows up and the highlights down
   * @param amount - value of the contrast (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ contrast(amount, multiply) {
        const v = (amount || 0) + 1, o = -0.5 * (v - 1), matrix = [
            v,
            0,
            0,
            0,
            o,
            0,
            v,
            0,
            0,
            o,
            0,
            0,
            v,
            0,
            o,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Set the saturation matrix, increase the separation between colors
   * Increase saturation : increase contrast, brightness, and sharpness
   * @param amount - The saturation amount (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ saturate(amount = 0, multiply) {
        const x = amount * 2 / 3 + 1, y = (x - 1) * -0.5, matrix = [
            x,
            y,
            y,
            0,
            0,
            y,
            x,
            y,
            0,
            0,
            y,
            y,
            x,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /** Desaturate image (remove color) Call the saturate function */ desaturate() {
        this.saturate(-1);
    }
    /**
   * Negative image (inverse of classic rgb matrix)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ negative(multiply) {
        const matrix = [
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Sepia image
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ sepia(multiply) {
        const matrix = [
            0.393,
            0.7689999,
            0.18899999,
            0,
            0,
            0.349,
            0.6859999,
            0.16799999,
            0,
            0,
            0.272,
            0.5339999,
            0.13099999,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ technicolor(multiply) {
        const matrix = [
            1.9125277891456083,
            -0.8545344976951645,
            -0.09155508482755585,
            0,
            11.793603434377337,
            -0.3087833385928097,
            1.7658908555458428,
            -0.10601743074722245,
            0,
            -70.35205161461398,
            -0.231103377548616,
            -0.7501899197440212,
            1.847597816108189,
            0,
            30.950940869491138,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Polaroid filter
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ polaroid(multiply) {
        const matrix = [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Filter who transforms : Red -> Blue and Blue -> Red
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ toBGR(multiply) {
        const matrix = [
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ kodachrome(multiply) {
        const matrix = [
            1.1285582396593525,
            -0.3967382283601348,
            -0.03992559172921793,
            0,
            63.72958762196502,
            -0.16404339962244616,
            1.0835251566291304,
            -0.05498805115633132,
            0,
            24.732407896706203,
            -0.16786010706155763,
            -0.5603416277695248,
            1.6014850761964943,
            0,
            35.62982807460946,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Brown delicious browni filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ browni(multiply) {
        const matrix = [
            0.5997023498159715,
            0.34553243048391263,
            -0.2708298674538042,
            0,
            47.43192855600873,
            -0.037703249837783157,
            0.8609577587992641,
            0.15059552388459913,
            0,
            -36.96841498319127,
            0.24113635128153335,
            -0.07441037908422492,
            0.44972182064877153,
            0,
            -7.562075277591283,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Vintage filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ vintage(multiply) {
        const matrix = [
            0.6279345635605994,
            0.3202183420819367,
            -0.03965408211312453,
            0,
            9.651285835294123,
            0.02578397704808868,
            0.6441188644374771,
            0.03259127616149294,
            0,
            7.462829176470591,
            0.0466055556782719,
            -0.0851232987247891,
            0.5241648018700465,
            0,
            5.159190588235296,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * We don't know exactly what it does, kind of gradient map, but funny to play with!
   * @param desaturation - Tone values.
   * @param toned - Tone values.
   * @param lightColor - Tone values, example: `0xFFE580`
   * @param darkColor - Tone values, example: `0xFFE580`
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ colorTone(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation = desaturation || 0.2, toned = toned || 0.15, lightColor = lightColor || 16770432, darkColor = darkColor || 3375104;
        const temp = (0, $1PNws.Color).shared, [lR, lG, lB] = temp.setValue(lightColor).toArray(), [dR, dG, dB] = temp.setValue(darkColor).toArray(), matrix = [
            0.3,
            0.59,
            0.11,
            0,
            0,
            lR,
            lG,
            lB,
            desaturation,
            0,
            dR,
            dG,
            dB,
            toned,
            0,
            lR - dR,
            lG - dG,
            lB - dB,
            0,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Night effect
   * @param intensity - The intensity of the night effect.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ night(intensity, multiply) {
        intensity = intensity || 0.1;
        const matrix = [
            intensity * -2,
            -intensity,
            0,
            0,
            0,
            -intensity,
            0,
            intensity,
            0,
            0,
            0,
            intensity,
            intensity * 2,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * Predator effect
   *
   * Erase the current matrix by setting a new indepent one
   * @param amount - how much the predator feels his future victim
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ predator(amount, multiply) {
        const matrix = [
            // row 1
            11.224130630493164 * amount,
            -4.794486999511719 * amount,
            -2.8746118545532227 * amount,
            0 * amount,
            0.40342438220977783 * amount,
            // row 2
            -3.6330697536468506 * amount,
            9.193157196044922 * amount,
            -2.951810836791992 * amount,
            0 * amount,
            -1.316135048866272 * amount,
            // row 3
            -3.2184197902679443 * amount,
            -4.2375030517578125 * amount,
            7.476448059082031 * amount,
            0 * amount,
            0.8044459223747253 * amount,
            // row 4
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /**
   * LSD effect
   *
   * Multiply the current matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */ lsd(multiply) {
        const matrix = [
            2,
            -0.4,
            0.5,
            0,
            0,
            -0.5,
            2,
            -0.4,
            0,
            0,
            -0.4,
            -0.5,
            3,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    }
    /** Erase the current matrix by setting the default one. */ reset() {
        const matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, !1);
    }
    /**
   * The matrix of the color matrix filter
   * @member {number[]}
   * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
   */ get matrix() {
        return this.uniforms.m;
    }
    set matrix(value) {
        this.uniforms.m = value;
    }
    /**
   * The opacity value to use when mixing the original and resultant colors.
   *
   * When the value is 0, the original color is used without modification.
   * When the value is 1, the result color is used.
   * When in the range (0, 1) the color is interpolated between the original and result by this amount.
   * @default 1
   */ get alpha() {
        return this.uniforms.uAlpha;
    }
    set alpha(value) {
        this.uniforms.uAlpha = value;
    }
}
$9783b70fe428f333$export$6547db23997fcec5.prototype.grayscale = $9783b70fe428f333$export$6547db23997fcec5.prototype.greyscale;




parcelRequire("inflE");
var $3x7iq = parcelRequire("3x7iq");
var $6wJoy = parcelRequire("6wJoy");
var $gnwPx = parcelRequire("gnwPx");
var $f64ee2411c60d2d5$export$2e2bcd8739ae039 = `varying vec2 vFilterCoord;
varying vec2 vTextureCoord;

uniform vec2 scale;
uniform mat2 rotation;
uniform sampler2D uSampler;
uniform sampler2D mapSampler;

uniform highp vec4 inputSize;
uniform vec4 inputClamp;

void main(void)
{
  vec4 map =  texture2D(mapSampler, vFilterCoord);

  map -= 0.5;
  map.xy = scale * inputSize.zw * (rotation * map.xy);

  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));
}
`;


var $e7f7783bdbdba7d3$export$2e2bcd8739ae039 = `attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;
uniform mat3 filterMatrix;

varying vec2 vTextureCoord;
varying vec2 vFilterCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aVertexPosition * (outputFrame.zw * inputSize.zw);
}

void main(void)
{
	gl_Position = filterVertexPosition();
	vTextureCoord = filterTextureCoord();
	vFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;
}
`;


class $4065793d8789428d$export$8ebf3229158e2895 extends (0, $3x7iq.Filter) {
    /**
   * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
   * @param scale - The scale of the displacement
   */ constructor(sprite, scale){
        const maskMatrix = new (0, $6wJoy.Matrix)();
        sprite.renderable = !1, super((0, $e7f7783bdbdba7d3$export$2e2bcd8739ae039), (0, $f64ee2411c60d2d5$export$2e2bcd8739ae039), {
            mapSampler: sprite._texture,
            filterMatrix: maskMatrix,
            scale: {
                x: 1,
                y: 1
            },
            rotation: new Float32Array([
                1,
                0,
                0,
                1
            ])
        }), this.maskSprite = sprite, this.maskMatrix = maskMatrix, scale == null && (scale = 20), this.scale = new (0, $gnwPx.Point)(scale, scale);
    }
    /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - clearMode.
   */ apply(filterManager, input, output, clearMode) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite), this.uniforms.scale.x = this.scale.x, this.uniforms.scale.y = this.scale.y;
        const wt = this.maskSprite.worldTransform, lenX = Math.sqrt(wt.a * wt.a + wt.b * wt.b), lenY = Math.sqrt(wt.c * wt.c + wt.d * wt.d);
        lenX !== 0 && lenY !== 0 && (this.uniforms.rotation[0] = wt.a / lenX, this.uniforms.rotation[1] = wt.b / lenX, this.uniforms.rotation[2] = wt.c / lenY, this.uniforms.rotation[3] = wt.d / lenY), filterManager.applyFilter(this, input, output, clearMode);
    }
    /** The texture used for the displacement map. Must be power of 2 sized texture. */ get map() {
        return this.uniforms.mapSampler;
    }
    set map(value) {
        this.uniforms.mapSampler = value;
    }
}




parcelRequire("inflE");
var $3x7iq = parcelRequire("3x7iq");
var $742a7f735009a980$export$2e2bcd8739ae039 = `varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;
uniform sampler2D uSampler;
uniform highp vec4 inputSize;


/**
 Basic FXAA implementation based on the code on geeks3d.com with the
 modification that the texture2DLod stuff was removed since it's
 unsupported by WebGL.

 --

 From:
 https://github.com/mitsuhiko/webgl-meincraft

 Copyright (c) 2011 by Armin Ronacher.

 Some rights reserved.

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions are
 met:

 * Redistributions of source code must retain the above copyright
 notice, this list of conditions and the following disclaimer.

 * Redistributions in binary form must reproduce the above
 copyright notice, this list of conditions and the following
 disclaimer in the documentation and/or other materials provided
 with the distribution.

 * The names of the contributors may not be used to endorse or
 promote products derived from this software without specific
 prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

#ifndef FXAA_REDUCE_MIN
#define FXAA_REDUCE_MIN   (1.0/ 128.0)
#endif
#ifndef FXAA_REDUCE_MUL
#define FXAA_REDUCE_MUL   (1.0 / 8.0)
#endif
#ifndef FXAA_SPAN_MAX
#define FXAA_SPAN_MAX     8.0
#endif

//optimized version for mobile, where dependent
//texture reads can be a bottleneck
vec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,
          vec2 v_rgbNW, vec2 v_rgbNE,
          vec2 v_rgbSW, vec2 v_rgbSE,
          vec2 v_rgbM) {
    vec4 color;
    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;
    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;
    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;
    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;
    vec4 texColor = texture2D(tex, v_rgbM);
    vec3 rgbM  = texColor.xyz;
    vec3 luma = vec3(0.299, 0.587, 0.114);
    float lumaNW = dot(rgbNW, luma);
    float lumaNE = dot(rgbNE, luma);
    float lumaSW = dot(rgbSW, luma);
    float lumaSE = dot(rgbSE, luma);
    float lumaM  = dot(rgbM,  luma);
    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));
    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));

    mediump vec2 dir;
    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));
    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));

    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *
                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);

    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);
    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),
              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),
                  dir * rcpDirMin)) * inverseVP;

    vec3 rgbA = 0.5 * (
                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +
                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);
    vec3 rgbB = rgbA * 0.5 + 0.25 * (
                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +
                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);

    float lumaB = dot(rgbB, luma);
    if ((lumaB < lumaMin) || (lumaB > lumaMax))
        color = vec4(rgbA, texColor.a);
    else
        color = vec4(rgbB, texColor.a);
    return color;
}

void main() {

      vec4 color;

      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);

      gl_FragColor = color;
}
`;


var $7413345871bcbcb3$export$2e2bcd8739ae039 = `
attribute vec2 aVertexPosition;

uniform mat3 projectionMatrix;

varying vec2 v_rgbNW;
varying vec2 v_rgbNE;
varying vec2 v_rgbSW;
varying vec2 v_rgbSE;
varying vec2 v_rgbM;

varying vec2 vFragCoord;

uniform vec4 inputSize;
uniform vec4 outputFrame;

vec4 filterVertexPosition( void )
{
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;

    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}

void texcoords(vec2 fragCoord, vec2 inverseVP,
               out vec2 v_rgbNW, out vec2 v_rgbNE,
               out vec2 v_rgbSW, out vec2 v_rgbSE,
               out vec2 v_rgbM) {
    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;
    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;
    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;
    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;
    v_rgbM = vec2(fragCoord * inverseVP);
}

void main(void) {

   gl_Position = filterVertexPosition();

   vFragCoord = aVertexPosition * outputFrame.zw;

   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);
}
`;


class $a543331795166beb$export$86086ddb5389b795 extends (0, $3x7iq.Filter) {
    constructor(){
        super((0, $7413345871bcbcb3$export$2e2bcd8739ae039), (0, $742a7f735009a980$export$2e2bcd8739ae039));
    }
}




parcelRequire("inflE");
var $17owa = parcelRequire("17owa");
var $3x7iq = parcelRequire("3x7iq");
var $0a025ed607c39bac$export$2e2bcd8739ae039 = `precision highp float;

varying vec2 vTextureCoord;
varying vec4 vColor;

uniform float uNoise;
uniform float uSeed;
uniform sampler2D uSampler;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture2D(uSampler, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * uSeed);
    float diff = (randomValue - 0.5) * uNoise;

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    color.r += diff;
    color.g += diff;
    color.b += diff;

    // Premultiply alpha again.
    color.rgb *= color.a;

    gl_FragColor = color;
}
`;


class $f5d4fea5824ab477$export$2d7a5b72233a5183 extends (0, $3x7iq.Filter) {
    /**
   * @param {number} [noise=0.5] - The noise intensity, should be a normalized value in the range [0, 1].
   * @param {number} [seed] - A random seed for the noise generation. Default is `Math.random()`.
   */ constructor(noise = 0.5, seed = Math.random()){
        super((0, $17owa.defaultFilterVertex), (0, $0a025ed607c39bac$export$2e2bcd8739ae039), {
            uNoise: 0,
            uSeed: 0
        }), this.noise = noise, this.seed = seed;
    }
    /**
   * The amount of noise to apply, this value should be in the range (0, 1].
   * @default 0.5
   */ get noise() {
        return this.uniforms.uNoise;
    }
    set noise(value) {
        this.uniforms.uNoise = value;
    }
    /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */ get seed() {
        return this.uniforms.uSeed;
    }
    set seed(value) {
        this.uniforms.uSeed = value;
    }
}




const $1df130f681e90bc6$export$82462a21aead86ed = {
    AlphaFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.AlphaFilter
   */ $eb46baeaa5184069$export$adbaa0de008b0d7a,
    BlurFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilter
   */ $d646b7e94dfd28fa$export$424348d09d827f49,
    BlurFilterPass: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.BlurFilterPass
   */ $e02eb7d1be82cd90$export$b100a8e8116621cf,
    ColorMatrixFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.ColorMatrixFilter
   */ $9783b70fe428f333$export$6547db23997fcec5,
    DisplacementFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.DisplacementFilter
   */ $4065793d8789428d$export$8ebf3229158e2895,
    FXAAFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.FXAAFilter
   */ $a543331795166beb$export$86086ddb5389b795,
    NoiseFilter: /**
   * @class
   * @memberof PIXI.filters
   * @deprecated since 7.1.0
   * @see PIXI.NoiseFilter
   */ $f5d4fea5824ab477$export$2d7a5b72233a5183
};
Object.entries($1df130f681e90bc6$export$82462a21aead86ed).forEach(([key, FilterClass])=>{
    Object.defineProperty($1df130f681e90bc6$export$82462a21aead86ed, key, {
        get () {
            return (0, $lFGyw).deprecation("7.1.0", `filters.${key} has moved to ${key}`), FilterClass;
        }
    });
});


parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("gD5uZ");
var $5xkOK = parcelRequire("5xkOK");
parcelRequire("inflE");
var $gnwPx = parcelRequire("gnwPx");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("inflE");
var $3J55z = parcelRequire("3J55z");
var $iaX63 = parcelRequire("iaX63");
class $81dd01f9e812b7d3$var$EventsTickerClass {
    constructor(){
        this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
    }
    /**
   * Initializes the event ticker.
   * @param events - The event system.
   */ init(events) {
        this.removeTickerListener(), this.events = events, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this.tickerAdded = !1, this._pauseUpdate = !0;
    }
    /** Whether to pause the update checks or not. */ get pauseUpdate() {
        return this._pauseUpdate;
    }
    set pauseUpdate(paused) {
        this._pauseUpdate = paused;
    }
    /** Adds the ticker listener. */ addTickerListener() {
        this.tickerAdded || !this.domElement || ((0, $3J55z.Ticker).system.add(this.tickerUpdate, this, (0, $iaX63.UPDATE_PRIORITY).INTERACTION), this.tickerAdded = !0);
    }
    /** Removes the ticker listener. */ removeTickerListener() {
        this.tickerAdded && ((0, $3J55z.Ticker).system.remove(this.tickerUpdate, this), this.tickerAdded = !1);
    }
    /** Sets flag to not fire extra events when the user has already moved there mouse */ pointerMoved() {
        this._didMove = !0;
    }
    /** Updates the state of interactive objects. */ update() {
        if (!this.domElement || this._pauseUpdate) return;
        if (this._didMove) {
            this._didMove = !1;
            return;
        }
        const rootPointerEvent = this.events.rootPointerEvent;
        this.events.supportsTouchEvents && rootPointerEvent.pointerType === "touch" || globalThis.document.dispatchEvent(new PointerEvent("pointermove", {
            clientX: rootPointerEvent.clientX,
            clientY: rootPointerEvent.clientY
        }));
    }
    /**
   * Updates the state of interactive objects if at least {@link PIXI.EventsTicker#interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link PIXI.Ticker.system}.
   * @param deltaTime - time delta since the last call
   */ tickerUpdate(deltaTime) {
        this._deltaTime += deltaTime, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this.update());
    }
}
const $81dd01f9e812b7d3$export$57a493ed609e53ea = new $81dd01f9e812b7d3$var$EventsTickerClass();


parcelRequire("inflE");
var $gnwPx = parcelRequire("gnwPx");
parcelRequire("inflE");
var $gnwPx = parcelRequire("gnwPx");
class $26b8e1b052f7f249$export$5d10db92bb959d8a {
    /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */ constructor(manager){
        this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = $26b8e1b052f7f249$export$5d10db92bb959d8a.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new (0, $gnwPx.Point)(), this.page = new (0, $gnwPx.Point)(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = manager;
    }
    /** @readonly */ get layerX() {
        return this.layer.x;
    }
    /** @readonly */ get layerY() {
        return this.layer.y;
    }
    /** @readonly */ get pageX() {
        return this.page.x;
    }
    /** @readonly */ get pageY() {
        return this.page.y;
    }
    /**
   * Fallback for the deprecated @code{PIXI.InteractionEvent.data}.
   * @deprecated since 7.0.0
   */ get data() {
        return this;
    }
    /** The propagation path for this event. Alias for {@link PIXI.EventBoundary.propagationPath}. */ composedPath() {
        return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
    }
    /**
   * Unimplemented method included for implementing the DOM interface {@code Event}. It will throw an {@code Error}.
   * @deprecated
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */ initEvent(_type, _bubbles, _cancelable) {
        throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    /**
   * Unimplemented method included for implementing the DOM interface {@code UIEvent}. It will throw an {@code Error}.
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */ initUIEvent(_typeArg, _bubblesArg, _cancelableArg, _viewArg, _detailArg) {
        throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
    }
    /** Prevent default behavior of PixiJS and the user agent. */ preventDefault() {
        this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
    }
    /**
   * Stop this event from propagating to any addition listeners, including on the
   * {@link PIXI.FederatedEventTarget.currentTarget currentTarget} and also the following
   * event targets on the propagation path.
   */ stopImmediatePropagation() {
        this.propagationImmediatelyStopped = !0;
    }
    /**
   * Stop this event from propagating to the next {@link PIXI.FederatedEventTarget}. The rest of the listeners
   * on the {@link PIXI.FederatedEventTarget.currentTarget currentTarget} will still be notified.
   */ stopPropagation() {
        this.propagationStopped = !0;
    }
}


class $d3ec2a7353cfb785$export$aeb79caab92d155a extends (0, $26b8e1b052f7f249$export$5d10db92bb959d8a) {
    constructor(){
        super(...arguments), this.client = new (0, $gnwPx.Point)(), this.movement = new (0, $gnwPx.Point)(), this.offset = new (0, $gnwPx.Point)(), this.global = new (0, $gnwPx.Point)(), this.screen = new (0, $gnwPx.Point)();
    }
    /** @readonly */ get clientX() {
        return this.client.x;
    }
    /** @readonly */ get clientY() {
        return this.client.y;
    }
    /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */ get x() {
        return this.clientX;
    }
    /**
   * Alias for {@link PIXI.FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */ get y() {
        return this.clientY;
    }
    /** @readonly */ get movementX() {
        return this.movement.x;
    }
    /** @readonly */ get movementY() {
        return this.movement.y;
    }
    /** @readonly */ get offsetX() {
        return this.offset.x;
    }
    /** @readonly */ get offsetY() {
        return this.offset.y;
    }
    /** @readonly */ get globalX() {
        return this.global.x;
    }
    /** @readonly */ get globalY() {
        return this.global.y;
    }
    /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.x}.
   * @readonly
   */ get screenX() {
        return this.screen.x;
    }
    /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.y}.
   * @readonly
   */ get screenY() {
        return this.screen.y;
    }
    /**
   * This will return the local coordinates of the specified displayObject for this InteractionData
   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
   *  coords off
   * @param {PIXI.IPointData} point - A Point object in which to store the value, optional (otherwise
   *  will create a new point)
   * @param {PIXI.IPointData} globalPos - A Point object containing your custom global coords, optional
   *  (otherwise will use the current global coords)
   * @returns - A point containing the coordinates of the InteractionData position relative
   *  to the DisplayObject
   */ getLocalPosition(displayObject, point, globalPos) {
        return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
    }
    /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */ getModifierState(key) {
        return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(key);
    }
    /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   */ // eslint-disable-next-line max-params
    initMouseEvent(_typeArg, _canBubbleArg, _cancelableArg, _viewArg, _detailArg, _screenXArg, _screenYArg, _clientXArg, _clientYArg, _ctrlKeyArg, _altKeyArg, _shiftKeyArg, _metaKeyArg, _buttonArg, _relatedTargetArg) {
        throw new Error("Method not implemented.");
    }
}



class $52ba6cd103d3e195$export$44ac16aa0ab81db6 extends (0, $d3ec2a7353cfb785$export$aeb79caab92d155a) {
    constructor(){
        super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1;
    }
    // Only included for completeness for now
    getCoalescedEvents() {
        return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [
            this
        ] : [];
    }
    // Only included for completeness for now
    getPredictedEvents() {
        throw new Error("getPredictedEvents is not supported!");
    }
}



class $7893cac0982b7958$export$1fd8b94eb532974d extends (0, $d3ec2a7353cfb785$export$aeb79caab92d155a) {
    constructor(){
        super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
    }
}
$7893cac0982b7958$export$1fd8b94eb532974d.DOM_DELTA_PIXEL = 0, /** Units specified in lines. */ $7893cac0982b7958$export$1fd8b94eb532974d.DOM_DELTA_LINE = 1, /** Units specified in pages. */ $7893cac0982b7958$export$1fd8b94eb532974d.DOM_DELTA_PAGE = 2;


const $9fbf6b8539eddb2c$var$PROPAGATION_LIMIT = 2048, $9fbf6b8539eddb2c$var$tempHitLocation = new (0, $gnwPx.Point)(), $9fbf6b8539eddb2c$var$tempLocalMapping = new (0, $gnwPx.Point)();
class $9fbf6b8539eddb2c$export$532e8c243078d2cd {
    /**
   * @param rootTarget - The holder of the event boundary.
   */ constructor(rootTarget){
        this.dispatch = new (0, $lFGyw).EventEmitter(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
            trackingData: {}
        }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = rootTarget, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel);
    }
    /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link PIXI.EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link PIXI.EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */ addEventMapping(type, fn) {
        this.mappingTable[type] || (this.mappingTable[type] = []), this.mappingTable[type].push({
            fn: fn,
            priority: 0
        }), this.mappingTable[type].sort((a, b)=>a.priority - b.priority);
    }
    /**
   * Dispatches the given event
   * @param e
   * @param type
   */ dispatchEvent(e, type) {
        e.propagationStopped = !1, e.propagationImmediatelyStopped = !1, this.propagate(e, type), this.dispatch.emit(type || e.type, e);
    }
    /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e
   */ mapEvent(e) {
        if (!this.rootTarget) return;
        const mappers = this.mappingTable[e.type];
        if (mappers) for(let i = 0, j = mappers.length; i < j; i++)mappers[i].fn(e);
        else console.warn(`[EventBoundary]: Event mapping not defined for ${e.type}`);
    }
    /**
   * Finds the DisplayObject that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x
   * @param y
   */ hitTest(x, y) {
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).pauseUpdate = !0;
        const fn = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", invertedPath = this[fn](this.rootTarget, this.rootTarget.eventMode, $9fbf6b8539eddb2c$var$tempHitLocation.set(x, y), this.hitTestFn, this.hitPruneFn);
        return invertedPath && invertedPath[0];
    }
    /**
   * Propagate the passed event from from {@link PIXI.EventBoundary.rootTarget this.rootTarget} to its
   * target {@code e.target}.
   * @param e - The event to propagate.
   * @param type
   */ propagate(e, type) {
        if (!e.target) return;
        const composedPath = e.composedPath();
        e.eventPhase = e.CAPTURING_PHASE;
        for(let i = 0, j = composedPath.length - 1; i < j; i++)if (e.currentTarget = composedPath[i], this.notifyTarget(e, type), e.propagationStopped || e.propagationImmediatelyStopped) return;
        if (e.eventPhase = e.AT_TARGET, e.currentTarget = e.target, this.notifyTarget(e, type), !(e.propagationStopped || e.propagationImmediatelyStopped)) {
            e.eventPhase = e.BUBBLING_PHASE;
            for(let i = composedPath.length - 2; i >= 0; i--)if (e.currentTarget = composedPath[i], this.notifyTarget(e, type), e.propagationStopped || e.propagationImmediatelyStopped) return;
        }
    }
    /**
   * Emits the event {@code e} to all interactive display objects. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */ all(e, type, targets = this._allInteractiveElements) {
        if (targets.length === 0) return;
        e.eventPhase = e.BUBBLING_PHASE;
        const events = Array.isArray(type) ? type : [
            type
        ];
        for(let i = targets.length - 1; i >= 0; i--)events.forEach((event)=>{
            e.currentTarget = targets[i], this.notifyTarget(e, event);
        });
    }
    /**
   * Finds the propagation path from {@link PIXI.EventBoundary.rootTarget rootTarget} to the passed
   * {@code target}. The last element in the path is {@code target}.
   * @param target
   */ propagationPath(target) {
        const propagationPath = [
            target
        ];
        for(let i = 0; i < $9fbf6b8539eddb2c$var$PROPAGATION_LIMIT && target !== this.rootTarget; i++){
            if (!target.parent) throw new Error("Cannot find propagation path to disconnected target");
            propagationPath.push(target.parent), target = target.parent;
        }
        return propagationPath.reverse(), propagationPath;
    }
    hitTestMoveRecursive(currentTarget, eventMode, location, testFn, pruneFn, ignore = !1) {
        let shouldReturn = !1;
        if (this._interactivePrune(currentTarget)) return null;
        if ((currentTarget.eventMode === "dynamic" || eventMode === "dynamic") && ((0, $81dd01f9e812b7d3$export$57a493ed609e53ea).pauseUpdate = !1), currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i], nestedHit = this.hitTestMoveRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn, ignore || pruneFn(currentTarget, location));
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    (nestedHit.length > 0 || isInteractive) && (isInteractive && this._allInteractiveElements.push(currentTarget), nestedHit.push(currentTarget)), this._hitElements.length === 0 && (this._hitElements = nestedHit), shouldReturn = !0;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode), isInteractiveTarget = currentTarget.isInteractive();
        return isInteractiveMode && isInteractiveTarget && this._allInteractiveElements.push(currentTarget), ignore || this._hitElements.length > 0 ? null : shouldReturn ? this._hitElements : isInteractiveMode && !pruneFn(currentTarget, location) && testFn(currentTarget, location) ? isInteractiveTarget ? [
            currentTarget
        ] : [] : null;
    }
    /**
   * Recursive implementation for {@link PIXI.EventBoundary.hitTest hitTest}.
   * @param currentTarget - The DisplayObject that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the display object.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link PIXI.EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */ hitTestRecursive(currentTarget, eventMode, location, testFn, pruneFn) {
        if (this._interactivePrune(currentTarget) || pruneFn(currentTarget, location)) return null;
        if ((currentTarget.eventMode === "dynamic" || eventMode === "dynamic") && ((0, $81dd01f9e812b7d3$export$57a493ed609e53ea).pauseUpdate = !1), currentTarget.interactiveChildren && currentTarget.children) {
            const children = currentTarget.children;
            for(let i = children.length - 1; i >= 0; i--){
                const child = children[i], nestedHit = this.hitTestRecursive(child, this._isInteractive(eventMode) ? eventMode : child.eventMode, location, testFn, pruneFn);
                if (nestedHit) {
                    if (nestedHit.length > 0 && !nestedHit[nestedHit.length - 1].parent) continue;
                    const isInteractive = currentTarget.isInteractive();
                    return (nestedHit.length > 0 || isInteractive) && nestedHit.push(currentTarget), nestedHit;
                }
            }
        }
        const isInteractiveMode = this._isInteractive(eventMode), isInteractiveTarget = currentTarget.isInteractive();
        return isInteractiveMode && testFn(currentTarget, location) ? isInteractiveTarget ? [
            currentTarget
        ] : [] : null;
    }
    _isInteractive(int) {
        return int === "static" || int === "dynamic";
    }
    _interactivePrune(displayObject) {
        return !!(!displayObject || displayObject.isMask || !displayObject.visible || !displayObject.renderable || displayObject.eventMode === "none" || displayObject.eventMode === "passive" && !displayObject.interactiveChildren || displayObject.isMask);
    }
    /**
   * Checks whether the display object or any of its children cannot pass the hit test at all.
   *
   * {@link PIXI.EventBoundary}'s implementation uses the {@link PIXI.DisplayObject.hitArea hitArea}
   * and {@link PIXI.DisplayObject._mask} for pruning.
   * @param displayObject
   * @param location
   */ hitPruneFn(displayObject, location) {
        if (displayObject.hitArea && (displayObject.worldTransform.applyInverse(location, $9fbf6b8539eddb2c$var$tempLocalMapping), !displayObject.hitArea.contains($9fbf6b8539eddb2c$var$tempLocalMapping.x, $9fbf6b8539eddb2c$var$tempLocalMapping.y))) return !0;
        if (displayObject._mask) {
            const maskObject = displayObject._mask.isMaskData ? displayObject._mask.maskObject : displayObject._mask;
            if (maskObject && !maskObject.containsPoint?.(location)) return !0;
        }
        return !1;
    }
    /**
   * Checks whether the display object passes hit testing for the given location.
   * @param displayObject
   * @param location
   * @returns - Whether `displayObject` passes hit testing for `location`.
   */ hitTestFn(displayObject, location) {
        return displayObject.eventMode === "passive" ? !1 : displayObject.hitArea ? !0 : displayObject.containsPoint ? displayObject.containsPoint(location) : !1;
    }
    /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type
   */ notifyTarget(e, type) {
        type = type ?? e.type;
        const handlerKey = `on${type}`;
        e.currentTarget[handlerKey]?.(e);
        const key = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${type}capture` : type;
        this.notifyListeners(e, key), e.eventPhase === e.AT_TARGET && this.notifyListeners(e, type);
    }
    /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from
   */ mapPointerDown(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const e = this.createPointerEvent(from);
        if (this.dispatchEvent(e, "pointerdown"), e.pointerType === "touch") this.dispatchEvent(e, "touchstart");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightdown" : "mousedown");
        }
        const trackingData = this.trackingData(from.pointerId);
        trackingData.pressTargetsByButton[from.button] = e.composedPath(), this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */ mapPointerMove(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
        const e = this.createPointerEvent(from);
        this._isPointerMoveEvent = !1;
        const isMouse = e.pointerType === "mouse" || e.pointerType === "pen", trackingData = this.trackingData(from.pointerId), outTarget = this.findMountedTarget(trackingData.overTargets);
        if (trackingData.overTargets?.length > 0 && outTarget !== e.target) {
            const outType = from.type === "mousemove" ? "mouseout" : "pointerout", outEvent = this.createPointerEvent(from, outType, outTarget);
            if (this.dispatchEvent(outEvent, "pointerout"), isMouse && this.dispatchEvent(outEvent, "mouseout"), !e.composedPath().includes(outTarget)) {
                const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
                for(leaveEvent.eventPhase = leaveEvent.AT_TARGET; leaveEvent.target && !e.composedPath().includes(leaveEvent.target);)leaveEvent.currentTarget = leaveEvent.target, this.notifyTarget(leaveEvent), isMouse && this.notifyTarget(leaveEvent, "mouseleave"), leaveEvent.target = leaveEvent.target.parent;
                this.freeEvent(leaveEvent);
            }
            this.freeEvent(outEvent);
        }
        if (outTarget !== e.target) {
            const overType = from.type === "mousemove" ? "mouseover" : "pointerover", overEvent = this.clonePointerEvent(e, overType);
            this.dispatchEvent(overEvent, "pointerover"), isMouse && this.dispatchEvent(overEvent, "mouseover");
            let overTargetAncestor = outTarget?.parent;
            for(; overTargetAncestor && overTargetAncestor !== this.rootTarget.parent && overTargetAncestor !== e.target;)overTargetAncestor = overTargetAncestor.parent;
            if (!overTargetAncestor || overTargetAncestor === this.rootTarget.parent) {
                const enterEvent = this.clonePointerEvent(e, "pointerenter");
                for(enterEvent.eventPhase = enterEvent.AT_TARGET; enterEvent.target && enterEvent.target !== outTarget && enterEvent.target !== this.rootTarget.parent;)enterEvent.currentTarget = enterEvent.target, this.notifyTarget(enterEvent), isMouse && this.notifyTarget(enterEvent, "mouseenter"), enterEvent.target = enterEvent.target.parent;
                this.freeEvent(enterEvent);
            }
            this.freeEvent(overEvent);
        }
        const allMethods = [], allowGlobalPointerEvents = this.enableGlobalMoveEvents ?? !0;
        this.moveOnAll ? allMethods.push("pointermove") : this.dispatchEvent(e, "pointermove"), allowGlobalPointerEvents && allMethods.push("globalpointermove"), e.pointerType === "touch" && (this.moveOnAll ? allMethods.splice(1, 0, "touchmove") : this.dispatchEvent(e, "touchmove"), allowGlobalPointerEvents && allMethods.push("globaltouchmove")), isMouse && (this.moveOnAll ? allMethods.splice(1, 0, "mousemove") : this.dispatchEvent(e, "mousemove"), allowGlobalPointerEvents && allMethods.push("globalmousemove"), this.cursor = e.target?.cursor), allMethods.length > 0 && this.all(e, allMethods), this._allInteractiveElements.length = 0, this._hitElements.length = 0, trackingData.overTargets = e.composedPath(), this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */ mapPointerOver(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId), e = this.createPointerEvent(from), isMouse = e.pointerType === "mouse" || e.pointerType === "pen";
        this.dispatchEvent(e, "pointerover"), isMouse && this.dispatchEvent(e, "mouseover"), e.pointerType === "mouse" && (this.cursor = e.target?.cursor);
        const enterEvent = this.clonePointerEvent(e, "pointerenter");
        for(enterEvent.eventPhase = enterEvent.AT_TARGET; enterEvent.target && enterEvent.target !== this.rootTarget.parent;)enterEvent.currentTarget = enterEvent.target, this.notifyTarget(enterEvent), isMouse && this.notifyTarget(enterEvent, "mouseenter"), enterEvent.target = enterEvent.target.parent;
        trackingData.overTargets = e.composedPath(), this.freeEvent(e), this.freeEvent(enterEvent);
    }
    /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */ mapPointerOut(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId);
        if (trackingData.overTargets) {
            const isMouse = from.pointerType === "mouse" || from.pointerType === "pen", outTarget = this.findMountedTarget(trackingData.overTargets), outEvent = this.createPointerEvent(from, "pointerout", outTarget);
            this.dispatchEvent(outEvent), isMouse && this.dispatchEvent(outEvent, "mouseout");
            const leaveEvent = this.createPointerEvent(from, "pointerleave", outTarget);
            for(leaveEvent.eventPhase = leaveEvent.AT_TARGET; leaveEvent.target && leaveEvent.target !== this.rootTarget.parent;)leaveEvent.currentTarget = leaveEvent.target, this.notifyTarget(leaveEvent), isMouse && this.notifyTarget(leaveEvent, "mouseleave"), leaveEvent.target = leaveEvent.target.parent;
            trackingData.overTargets = null, this.freeEvent(outEvent), this.freeEvent(leaveEvent);
        }
        this.cursor = null;
    }
    /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */ mapPointerUp(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const now = performance.now(), e = this.createPointerEvent(from);
        if (this.dispatchEvent(e, "pointerup"), e.pointerType === "touch") this.dispatchEvent(e, "touchend");
        else if (e.pointerType === "mouse" || e.pointerType === "pen") {
            const isRightButton = e.button === 2;
            this.dispatchEvent(e, isRightButton ? "rightup" : "mouseup");
        }
        const trackingData = this.trackingData(from.pointerId), pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
        let clickTarget = pressTarget;
        if (pressTarget && !e.composedPath().includes(pressTarget)) {
            let currentTarget = pressTarget;
            for(; currentTarget && !e.composedPath().includes(currentTarget);){
                if (e.currentTarget = currentTarget, this.notifyTarget(e, "pointerupoutside"), e.pointerType === "touch") this.notifyTarget(e, "touchendoutside");
                else if (e.pointerType === "mouse" || e.pointerType === "pen") {
                    const isRightButton = e.button === 2;
                    this.notifyTarget(e, isRightButton ? "rightupoutside" : "mouseupoutside");
                }
                currentTarget = currentTarget.parent;
            }
            delete trackingData.pressTargetsByButton[from.button], clickTarget = currentTarget;
        }
        if (clickTarget) {
            const clickEvent = this.clonePointerEvent(e, "click");
            clickEvent.target = clickTarget, clickEvent.path = null, trackingData.clicksByButton[from.button] || (trackingData.clicksByButton[from.button] = {
                clickCount: 0,
                target: clickEvent.target,
                timeStamp: now
            });
            const clickHistory = trackingData.clicksByButton[from.button];
            if (clickHistory.target === clickEvent.target && now - clickHistory.timeStamp < 200 ? ++clickHistory.clickCount : clickHistory.clickCount = 1, clickHistory.target = clickEvent.target, clickHistory.timeStamp = now, clickEvent.detail = clickHistory.clickCount, clickEvent.pointerType === "mouse") {
                const isRightButton = clickEvent.button === 2;
                this.dispatchEvent(clickEvent, isRightButton ? "rightclick" : "click");
            } else clickEvent.pointerType === "touch" && this.dispatchEvent(clickEvent, "tap");
            this.dispatchEvent(clickEvent, "pointertap"), this.freeEvent(clickEvent);
        }
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link PIXI.EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */ mapPointerUpOutside(from) {
        if (!(from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6))) {
            console.warn("EventBoundary cannot map a non-pointer event as a pointer event");
            return;
        }
        const trackingData = this.trackingData(from.pointerId), pressTarget = this.findMountedTarget(trackingData.pressTargetsByButton[from.button]), e = this.createPointerEvent(from);
        if (pressTarget) {
            let currentTarget = pressTarget;
            for(; currentTarget;)e.currentTarget = currentTarget, this.notifyTarget(e, "pointerupoutside"), e.pointerType === "touch" ? this.notifyTarget(e, "touchendoutside") : (e.pointerType === "mouse" || e.pointerType === "pen") && this.notifyTarget(e, e.button === 2 ? "rightupoutside" : "mouseupoutside"), currentTarget = currentTarget.parent;
            delete trackingData.pressTargetsByButton[from.button];
        }
        this.freeEvent(e);
    }
    /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */ mapWheel(from) {
        if (!(from instanceof (0, $7893cac0982b7958$export$1fd8b94eb532974d))) {
            console.warn("EventBoundary cannot map a non-wheel event as a wheel event");
            return;
        }
        const wheelEvent = this.createWheelEvent(from);
        this.dispatchEvent(wheelEvent), this.freeEvent(wheelEvent);
    }
    /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */ findMountedTarget(propagationPath) {
        if (!propagationPath) return null;
        let currentTarget = propagationPath[0];
        for(let i = 1; i < propagationPath.length && propagationPath[i].parent === currentTarget; i++)currentTarget = propagationPath[i];
        return currentTarget;
    }
    /**
   * Creates an event whose {@code originalEvent} is {@code from}, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The {@code originalEvent} for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */ createPointerEvent(from, type, target) {
        const event = this.allocateEvent((0, $52ba6cd103d3e195$export$44ac16aa0ab81db6));
        return this.copyPointerData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.nativeEvent = from.nativeEvent, event.originalEvent = from, event.target = target ?? this.hitTest(event.global.x, event.global.y) ?? this._hitElements[0], typeof type == "string" && (event.type = type), event;
    }
    /**
   * Creates a wheel event whose {@code originalEvent} is {@code from}.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */ createWheelEvent(from) {
        const event = this.allocateEvent((0, $7893cac0982b7958$export$1fd8b94eb532974d));
        return this.copyWheelData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.nativeEvent = from.nativeEvent, event.originalEvent = from, event.target = this.hitTest(event.global.x, event.global.y), event;
    }
    /**
   * Clones the event {@code from}, with an optional {@code type} override.
   *
   * The event is allocated using {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */ clonePointerEvent(from, type) {
        const event = this.allocateEvent((0, $52ba6cd103d3e195$export$44ac16aa0ab81db6));
        return event.nativeEvent = from.nativeEvent, event.originalEvent = from.originalEvent, this.copyPointerData(from, event), this.copyMouseData(from, event), this.copyData(from, event), event.target = from.target, event.path = from.composedPath().slice(), event.type = type ?? event.type, event;
    }
    /**
   * Copies wheel {@link PIXI.FederatedWheelEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from
   * @param to
   */ copyWheelData(from, to) {
        to.deltaMode = from.deltaMode, to.deltaX = from.deltaX, to.deltaY = from.deltaY, to.deltaZ = from.deltaZ;
    }
    /**
   * Copies pointer {@link PIXI.FederatedPointerEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from
   * @param to
   */ copyPointerData(from, to) {
        from instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6) && to instanceof (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6) && (to.pointerId = from.pointerId, to.width = from.width, to.height = from.height, to.isPrimary = from.isPrimary, to.pointerType = from.pointerType, to.pressure = from.pressure, to.tangentialPressure = from.tangentialPressure, to.tiltX = from.tiltX, to.tiltY = from.tiltY, to.twist = from.twist);
    }
    /**
   * Copies mouse {@link PIXI.FederatedMouseEvent} data from {@code from} to {@code to}.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from
   * @param to
   */ copyMouseData(from, to) {
        from instanceof (0, $d3ec2a7353cfb785$export$aeb79caab92d155a) && to instanceof (0, $d3ec2a7353cfb785$export$aeb79caab92d155a) && (to.altKey = from.altKey, to.button = from.button, to.buttons = from.buttons, to.client.copyFrom(from.client), to.ctrlKey = from.ctrlKey, to.metaKey = from.metaKey, to.movement.copyFrom(from.movement), to.screen.copyFrom(from.screen), to.shiftKey = from.shiftKey, to.global.copyFrom(from.global));
    }
    /**
   * Copies base {@link PIXI.FederatedEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */ copyData(from, to) {
        to.isTrusted = from.isTrusted, to.srcElement = from.srcElement, to.timeStamp = performance.now(), to.type = from.type, to.detail = from.detail, to.view = from.view, to.which = from.which, to.layer.copyFrom(from.layer), to.page.copyFrom(from.page);
    }
    /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */ trackingData(id) {
        return this.mappingState.trackingData[id] || (this.mappingState.trackingData[id] = {
            pressTargetsByButton: {},
            clicksByButton: {},
            overTarget: null
        }), this.mappingState.trackingData[id];
    }
    /**
   * Allocate a specific type of event from {@link PIXI.EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   */ allocateEvent(constructor) {
        this.eventPool.has(constructor) || this.eventPool.set(constructor, []);
        const event = this.eventPool.get(constructor).pop() || new constructor(this);
        return event.eventPhase = event.NONE, event.currentTarget = null, event.path = null, event.target = null, event;
    }
    /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link PIXI.EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */ freeEvent(event) {
        if (event.manager !== this) throw new Error("It is illegal to free an event not managed by this EventBoundary!");
        const constructor = event.constructor;
        this.eventPool.has(constructor) || this.eventPool.set(constructor, []), this.eventPool.get(constructor).push(event);
    }
    /**
   * Similar to {@link PIXI.EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */ notifyListeners(e, type) {
        const listeners = e.currentTarget._events[type];
        if (listeners && e.currentTarget.isInteractive()) {
            if ("fn" in listeners) listeners.once && e.currentTarget.removeListener(type, listeners.fn, void 0, !0), listeners.fn.call(listeners.context, e);
            else for(let i = 0, j = listeners.length; i < j && !e.propagationImmediatelyStopped; i++)listeners[i].once && e.currentTarget.removeListener(type, listeners[i].fn, void 0, !0), listeners[i].fn.call(listeners[i].context, e);
        }
    }
}


parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");




const $8e6543b2c08741df$var$MOUSE_POINTER_ID = 1, $8e6543b2c08741df$var$TOUCH_TO_POINTER = {
    touchstart: "pointerdown",
    touchend: "pointerup",
    touchendoutside: "pointerupoutside",
    touchmove: "pointermove",
    touchcancel: "pointercancel"
}, $8e6543b2c08741df$var$_EventSystem = class _EventSystem2 {
    /**
   * @param {PIXI.Renderer} renderer
   */ constructor(renderer){
        this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = renderer, this.rootBoundary = new (0, $9fbf6b8539eddb2c$export$532e8c243078d2cd)(null), (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).init(this), this.autoPreventDefault = !0, this.eventsAdded = !1, this.rootPointerEvent = new (0, $52ba6cd103d3e195$export$44ac16aa0ab81db6)(null), this.rootWheelEvent = new (0, $7893cac0982b7958$export$1fd8b94eb532974d)(null), this.cursorStyles = {
            default: "inherit",
            pointer: "pointer"
        }, this.features = new Proxy({
            ..._EventSystem2.defaultEventFeatures
        }, {
            set: (target, key, value)=>(key === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = value), target[key] = value, !0)
        }), this.onPointerDown = this.onPointerDown.bind(this), this.onPointerMove = this.onPointerMove.bind(this), this.onPointerUp = this.onPointerUp.bind(this), this.onPointerOverOut = this.onPointerOverOut.bind(this), this.onWheel = this.onWheel.bind(this);
    }
    /**
   * The default interaction mode for all display objects.
   * @see PIXI.DisplayObject.eventMode
   * @type {PIXI.EventMode}
   * @readonly
   * @since 7.2.0
   */ static get defaultEventMode() {
        return this._defaultEventMode;
    }
    /**
   * Runner init called, view is available at this point.
   * @ignore
   */ init(options) {
        const { view: view, resolution: resolution } = this.renderer;
        this.setTargetElement(view), this.resolution = resolution, _EventSystem2._defaultEventMode = options.eventMode ?? "auto", Object.assign(this.features, options.eventFeatures ?? {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
    }
    /**
   * Handle changing resolution.
   * @ignore
   */ resolutionChange(resolution) {
        this.resolution = resolution;
    }
    /** Destroys all event listeners and detaches the renderer. */ destroy() {
        this.setTargetElement(null), this.renderer = null;
    }
    /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * @param mode - cursor mode, a key from the cursorStyles dictionary
   */ setCursor(mode) {
        mode = mode || "default";
        let applyStyles = !0;
        if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (applyStyles = !1), this.currentCursor === mode) return;
        this.currentCursor = mode;
        const style = this.cursorStyles[mode];
        if (style) switch(typeof style){
            case "string":
                applyStyles && (this.domElement.style.cursor = style);
                break;
            case "function":
                style(mode);
                break;
            case "object":
                applyStyles && Object.assign(this.domElement.style, style);
                break;
        }
        else applyStyles && typeof mode == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode) && (this.domElement.style.cursor = mode);
    }
    /**
   * The global pointer event.
   * Useful for getting the pointer position without listening to events.
   * @since 7.2.0
   */ get pointer() {
        return this.rootPointerEvent;
    }
    /**
   * Event handler for pointer down events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerDown(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        const events = this.normalizeToPointerData(nativeEvent);
        this.autoPreventDefault && events[0].isNormalized && (nativeEvent.cancelable || !("cancelable" in nativeEvent)) && nativeEvent.preventDefault();
        for(let i = 0, j = events.length; i < j; i++){
            const nativeEvent2 = events[i], federatedEvent = this.bootstrapEvent(this.rootPointerEvent, nativeEvent2);
            this.rootBoundary.mapEvent(federatedEvent);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer move events on on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */ onPointerMove(nativeEvent) {
        if (!this.features.move) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).pointerMoved();
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer up events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerUp(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        let target = nativeEvent.target;
        nativeEvent.composedPath && nativeEvent.composedPath().length > 0 && (target = nativeEvent.composedPath()[0]);
        const outside = target !== this.domElement ? "outside" : "", normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            event.type += outside, this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Event handler for pointer over & out events on {@link PIXI.EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */ onPointerOverOut(nativeEvent) {
        if (!this.features.click) return;
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
        const normalizedEvents = this.normalizeToPointerData(nativeEvent);
        for(let i = 0, j = normalizedEvents.length; i < j; i++){
            const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvents[i]);
            this.rootBoundary.mapEvent(event);
        }
        this.setCursor(this.rootBoundary.cursor);
    }
    /**
   * Passive handler for `wheel` events on {@link PIXI.EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */ onWheel(nativeEvent) {
        if (!this.features.wheel) return;
        const wheelEvent = this.normalizeWheelEvent(nativeEvent);
        this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(wheelEvent);
    }
    /**
   * Sets the {@link PIXI.EventSystem#domElement domElement} and binds event listeners.
   *
   * To deregister the current DOM element without setting a new one, pass {@code null}.
   * @param element - The new DOM element.
   */ setTargetElement(element) {
        this.removeEvents(), this.domElement = element, (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).domElement = element, this.addEvents();
    }
    /** Register event listeners on {@link PIXI.Renderer#domElement this.domElement}. */ addEvents() {
        if (this.eventsAdded || !this.domElement) return;
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).addTickerListener();
        const style = this.domElement.style;
        style && (globalThis.navigator.msPointerEnabled ? (style.msContentZooming = "none", style.msTouchAction = "none") : this.supportsPointerEvents && (style.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this.onPointerMove, !0), this.domElement.addEventListener("pointerdown", this.onPointerDown, !0), this.domElement.addEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this.onPointerOverOut, !0), globalThis.addEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this.onPointerMove, !0), this.domElement.addEventListener("mousedown", this.onPointerDown, !0), this.domElement.addEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this.onPointerOverOut, !0), globalThis.addEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this.onPointerDown, !0), this.domElement.addEventListener("touchend", this.onPointerUp, !0), this.domElement.addEventListener("touchmove", this.onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
            passive: !0,
            capture: !0
        }), this.eventsAdded = !0;
    }
    /** Unregister event listeners on {@link PIXI.EventSystem#domElement this.domElement}. */ removeEvents() {
        if (!this.eventsAdded || !this.domElement) return;
        (0, $81dd01f9e812b7d3$export$57a493ed609e53ea).removeTickerListener();
        const style = this.domElement.style;
        globalThis.navigator.msPointerEnabled ? (style.msContentZooming = "", style.msTouchAction = "") : this.supportsPointerEvents && (style.touchAction = ""), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this.onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this.onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this.onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this.onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this.onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this.onPointerMove, !0), this.domElement.removeEventListener("mousedown", this.onPointerDown, !0), this.domElement.removeEventListener("mouseout", this.onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this.onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this.onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this.onPointerDown, !0), this.domElement.removeEventListener("touchend", this.onPointerUp, !0), this.domElement.removeEventListener("touchmove", this.onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement = null, this.eventsAdded = !1;
    }
    /**
   * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
   * resulting value is stored in the point. This takes into account the fact that the DOM
   * element could be scaled and positioned anywhere on the screen.
   * @param  {PIXI.IPointData} point - the point that the result will be stored in
   * @param  {number} x - the x coord of the position to map
   * @param  {number} y - the y coord of the position to map
   */ mapPositionToPoint(point, x, y) {
        const rect = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
            x: 0,
            y: 0,
            width: this.domElement.width,
            height: this.domElement.height,
            left: 0,
            top: 0
        }, resolutionMultiplier = 1 / this.resolution;
        point.x = (x - rect.left) * (this.domElement.width / rect.width) * resolutionMultiplier, point.y = (y - rect.top) * (this.domElement.height / rect.height) * resolutionMultiplier;
    }
    /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */ normalizeToPointerData(event) {
        const normalizedEvents = [];
        if (this.supportsTouchEvents && event instanceof TouchEvent) for(let i = 0, li = event.changedTouches.length; i < li; i++){
            const touch = event.changedTouches[i];
            typeof touch.button > "u" && (touch.button = 0), typeof touch.buttons > "u" && (touch.buttons = 1), typeof touch.isPrimary > "u" && (touch.isPrimary = event.touches.length === 1 && event.type === "touchstart"), typeof touch.width > "u" && (touch.width = touch.radiusX || 1), typeof touch.height > "u" && (touch.height = touch.radiusY || 1), typeof touch.tiltX > "u" && (touch.tiltX = 0), typeof touch.tiltY > "u" && (touch.tiltY = 0), typeof touch.pointerType > "u" && (touch.pointerType = "touch"), typeof touch.pointerId > "u" && (touch.pointerId = touch.identifier || 0), typeof touch.pressure > "u" && (touch.pressure = touch.force || 0.5), typeof touch.twist > "u" && (touch.twist = 0), typeof touch.tangentialPressure > "u" && (touch.tangentialPressure = 0), typeof touch.layerX > "u" && (touch.layerX = touch.offsetX = touch.clientX), typeof touch.layerY > "u" && (touch.layerY = touch.offsetY = touch.clientY), touch.isNormalized = !0, touch.type = event.type, normalizedEvents.push(touch);
        }
        else if (!globalThis.MouseEvent || event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof globalThis.PointerEvent))) {
            const tempEvent = event;
            typeof tempEvent.isPrimary > "u" && (tempEvent.isPrimary = !0), typeof tempEvent.width > "u" && (tempEvent.width = 1), typeof tempEvent.height > "u" && (tempEvent.height = 1), typeof tempEvent.tiltX > "u" && (tempEvent.tiltX = 0), typeof tempEvent.tiltY > "u" && (tempEvent.tiltY = 0), typeof tempEvent.pointerType > "u" && (tempEvent.pointerType = "mouse"), typeof tempEvent.pointerId > "u" && (tempEvent.pointerId = $8e6543b2c08741df$var$MOUSE_POINTER_ID), typeof tempEvent.pressure > "u" && (tempEvent.pressure = 0.5), typeof tempEvent.twist > "u" && (tempEvent.twist = 0), typeof tempEvent.tangentialPressure > "u" && (tempEvent.tangentialPressure = 0), tempEvent.isNormalized = !0, normalizedEvents.push(tempEvent);
        } else normalizedEvents.push(event);
        return normalizedEvents;
    }
    /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link PIXI.FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */ normalizeWheelEvent(nativeEvent) {
        const event = this.rootWheelEvent;
        return this.transferMouseData(event, nativeEvent), event.deltaX = nativeEvent.deltaX, event.deltaY = nativeEvent.deltaY, event.deltaZ = nativeEvent.deltaZ, event.deltaMode = nativeEvent.deltaMode, this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY), event.global.copyFrom(event.screen), event.offset.copyFrom(event.screen), event.nativeEvent = nativeEvent, event.type = nativeEvent.type, event;
    }
    /**
   * Normalizes the `nativeEvent` into a federateed {@link PIXI.FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */ bootstrapEvent(event, nativeEvent) {
        return event.originalEvent = null, event.nativeEvent = nativeEvent, event.pointerId = nativeEvent.pointerId, event.width = nativeEvent.width, event.height = nativeEvent.height, event.isPrimary = nativeEvent.isPrimary, event.pointerType = nativeEvent.pointerType, event.pressure = nativeEvent.pressure, event.tangentialPressure = nativeEvent.tangentialPressure, event.tiltX = nativeEvent.tiltX, event.tiltY = nativeEvent.tiltY, event.twist = nativeEvent.twist, this.transferMouseData(event, nativeEvent), this.mapPositionToPoint(event.screen, nativeEvent.clientX, nativeEvent.clientY), event.global.copyFrom(event.screen), event.offset.copyFrom(event.screen), event.isTrusted = nativeEvent.isTrusted, event.type === "pointerleave" && (event.type = "pointerout"), event.type.startsWith("mouse") && (event.type = event.type.replace("mouse", "pointer")), event.type.startsWith("touch") && (event.type = $8e6543b2c08741df$var$TOUCH_TO_POINTER[event.type] || event.type), event;
    }
    /**
   * Transfers base & mouse event data from the {@code nativeEvent} to the federated event.
   * @param event
   * @param nativeEvent
   */ transferMouseData(event, nativeEvent) {
        event.isTrusted = nativeEvent.isTrusted, event.srcElement = nativeEvent.srcElement, event.timeStamp = performance.now(), event.type = nativeEvent.type, event.altKey = nativeEvent.altKey, event.button = nativeEvent.button, event.buttons = nativeEvent.buttons, event.client.x = nativeEvent.clientX, event.client.y = nativeEvent.clientY, event.ctrlKey = nativeEvent.ctrlKey, event.metaKey = nativeEvent.metaKey, event.movement.x = nativeEvent.movementX, event.movement.y = nativeEvent.movementY, event.page.x = nativeEvent.pageX, event.page.y = nativeEvent.pageY, event.relatedTarget = null, event.shiftKey = nativeEvent.shiftKey;
    }
};
$8e6543b2c08741df$var$_EventSystem.extension = {
    name: "events",
    type: [
        (0, $5RvHb.ExtensionType).RendererSystem,
        (0, $5RvHb.ExtensionType).CanvasRendererSystem
    ]
}, /**
* The event features that are enabled by the EventSystem
* This option only is available when using **@pixi/events** package
* (included in the **pixi.js** and **pixi.js-legacy** bundle), otherwise it will be ignored.
* @since 7.2.0
*/ $8e6543b2c08741df$var$_EventSystem.defaultEventFeatures = {
    move: !0,
    globalMove: !0,
    click: !0,
    wheel: !0
};
let $8e6543b2c08741df$export$bf477d624b56bf15 = $8e6543b2c08741df$var$_EventSystem;
(0, $5RvHb.extensions).add($8e6543b2c08741df$export$bf477d624b56bf15);





parcelRequire("inflE");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("gD5uZ");
var $5xkOK = parcelRequire("5xkOK");


function $603ddb200f76e809$var$convertEventModeToInteractiveMode(mode) {
    return mode === "dynamic" || mode === "static";
}
const $603ddb200f76e809$export$6a5b99a7f30af1d9 = {
    /**
   * Property-based event handler for the `click` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onclick = (event) => {
   *  //some function here that happens on click
   * }
   */ onclick: null,
    /**
   * Property-based event handler for the `mousedown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousedown = (event) => {
   *  //some function here that happens on mousedown
   * }
   */ onmousedown: null,
    /**
   * Property-based event handler for the `mouseenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseenter = (event) => {
   *  //some function here that happens on mouseenter
   * }
   */ onmouseenter: null,
    /**
   * Property-based event handler for the `mouseleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseleave = (event) => {
   *  //some function here that happens on mouseleave
   * }
   */ onmouseleave: null,
    /**
   * Property-based event handler for the `mousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmousemove = (event) => {
   *  //some function here that happens on mousemove
   * }
   */ onmousemove: null,
    /**
   * Property-based event handler for the `globalmousemove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalmousemove = (event) => {
   *  //some function here that happens on globalmousemove
   * }
   */ onglobalmousemove: null,
    /**
   * Property-based event handler for the `mouseout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseout = (event) => {
   *  //some function here that happens on mouseout
   * }
   */ onmouseout: null,
    /**
   * Property-based event handler for the `mouseover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseover = (event) => {
   *  //some function here that happens on mouseover
   * }
   */ onmouseover: null,
    /**
   * Property-based event handler for the `mouseup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseup = (event) => {
   *  //some function here that happens on mouseup
   * }
   */ onmouseup: null,
    /**
   * Property-based event handler for the `mouseupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onmouseupoutside = (event) => {
   *  //some function here that happens on mouseupoutside
   * }
   */ onmouseupoutside: null,
    /**
   * Property-based event handler for the `pointercancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointercancel = (event) => {
   *  //some function here that happens on pointercancel
   * }
   */ onpointercancel: null,
    /**
   * Property-based event handler for the `pointerdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerdown = (event) => {
   *  //some function here that happens on pointerdown
   * }
   */ onpointerdown: null,
    /**
   * Property-based event handler for the `pointerenter` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerenter = (event) => {
   *  //some function here that happens on pointerenter
   * }
   */ onpointerenter: null,
    /**
   * Property-based event handler for the `pointerleave` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerleave = (event) => {
   *  //some function here that happens on pointerleave
   * }
   */ onpointerleave: null,
    /**
   * Property-based event handler for the `pointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointermove = (event) => {
   *  //some function here that happens on pointermove
   * }
   */ onpointermove: null,
    /**
   * Property-based event handler for the `globalpointermove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobalpointermove = (event) => {
   *  //some function here that happens on globalpointermove
   * }
   */ onglobalpointermove: null,
    /**
   * Property-based event handler for the `pointerout` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerout = (event) => {
   *  //some function here that happens on pointerout
   * }
   */ onpointerout: null,
    /**
   * Property-based event handler for the `pointerover` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerover = (event) => {
   *  //some function here that happens on pointerover
   * }
   */ onpointerover: null,
    /**
   * Property-based event handler for the `pointertap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointertap = (event) => {
   *  //some function here that happens on pointertap
   * }
   */ onpointertap: null,
    /**
   * Property-based event handler for the `pointerup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerup = (event) => {
   *  //some function here that happens on pointerup
   * }
   */ onpointerup: null,
    /**
   * Property-based event handler for the `pointerupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onpointerupoutside = (event) => {
   *  //some function here that happens on pointerupoutside
   * }
   */ onpointerupoutside: null,
    /**
   * Property-based event handler for the `rightclick` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightclick = (event) => {
   *  //some function here that happens on rightclick
   * }
   */ onrightclick: null,
    /**
   * Property-based event handler for the `rightdown` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightdown = (event) => {
   *  //some function here that happens on rightdown
   * }
   */ onrightdown: null,
    /**
   * Property-based event handler for the `rightup` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightup = (event) => {
   *  //some function here that happens on rightup
   * }
   */ onrightup: null,
    /**
   * Property-based event handler for the `rightupoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onrightupoutside = (event) => {
   *  //some function here that happens on rightupoutside
   * }
   */ onrightupoutside: null,
    /**
   * Property-based event handler for the `tap` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontap = (event) => {
   *  //some function here that happens on tap
   * }
   */ ontap: null,
    /**
   * Property-based event handler for the `touchcancel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchcancel = (event) => {
   *  //some function here that happens on touchcancel
   * }
   */ ontouchcancel: null,
    /**
   * Property-based event handler for the `touchend` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchend = (event) => {
   *  //some function here that happens on touchend
   * }
   */ ontouchend: null,
    /**
   * Property-based event handler for the `touchendoutside` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchendoutside = (event) => {
   *  //some function here that happens on touchendoutside
   * }
   */ ontouchendoutside: null,
    /**
   * Property-based event handler for the `touchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchmove = (event) => {
   *  //some function here that happens on touchmove
   * }
   */ ontouchmove: null,
    /**
   * Property-based event handler for the `globaltouchmove` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onglobaltouchmove = (event) => {
   *  //some function here that happens on globaltouchmove
   * }
   */ onglobaltouchmove: null,
    /**
   * Property-based event handler for the `touchstart` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.ontouchstart = (event) => {
   *  //some function here that happens on touchstart
   * }
   */ ontouchstart: null,
    /**
   * Property-based event handler for the `wheel` event.
   * @memberof PIXI.DisplayObject#
   * @default null
   * @example
   * this.onwheel = (event) => {
   *  //some function here that happens on wheel
   * }
   */ onwheel: null,
    /**
   * @ignore
   */ _internalInteractive: void 0,
    /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
   * @memberof PIXI.DisplayObject#
   */ get interactive () {
        return this._internalInteractive ?? $603ddb200f76e809$var$convertEventModeToInteractiveMode((0, $8e6543b2c08741df$export$bf477d624b56bf15).defaultEventMode);
    },
    set interactive (value){
        (0, $lFGyw).deprecation("7.2.0", // eslint-disable-next-line max-len
        "Setting interactive is deprecated, use eventMode = 'none'/'passive'/'auto'/'static'/'dynamic' instead."), this._internalInteractive = value, this.eventMode = value ? "static" : "auto";
    },
    /**
   * @ignore
   */ _internalEventMode: void 0,
    /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse.
   * This now replaces the `interactive` property.
   * There are 5 types of interaction settings:
   * - `'none'`: Ignores all interaction events, even on its children.
   * - `'passive'`: Does not emit events and ignores all hit testing on itself and non-interactive children.
   * Interactive children will still emit events.
   * - `'auto'`: Does not emit events but is hit tested if parent is interactive. Same as `interactive = false` in v7
   * - `'static'`: Emit events and is hit tested. Same as `interaction = true` in v7
   * - `'dynamic'`: Emits events and is hit tested but will also receive mock interaction events fired from a ticker to
   * allow for interaction when the mouse isn't moving
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.on('tap', (event) => {
   *     // Handle event
   * });
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   */ get eventMode () {
        return this._internalEventMode ?? (0, $8e6543b2c08741df$export$bf477d624b56bf15).defaultEventMode;
    },
    set eventMode (value){
        this._internalInteractive = $603ddb200f76e809$var$convertEventModeToInteractiveMode(value), this._internalEventMode = value;
    },
    /**
   * Determines if the displayObject is interactive or not
   * @returns {boolean} Whether the displayObject is interactive or not
   * @memberof PIXI.DisplayObject#
   * @since 7.2.0
   * @example
   * import { Sprite } from 'pixi.js';
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'dynamic';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'none';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'passive';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'auto';
   * sprite.isInteractive(); // false
   */ isInteractive () {
        return this.eventMode === "static" || this.eventMode === "dynamic";
    },
    /**
   * Determines if the children to the displayObject can be clicked/touched
   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
   * @memberof PIXI.Container#
   */ interactiveChildren: !0,
    /**
   * Interaction shape. Children will be hit first, then this shape will be checked.
   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
   * @example
   * import { Rectangle, Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.interactive = true;
   * sprite.hitArea = new Rectangle(0, 0, 100, 100);
   * @member {PIXI.IHitArea}
   * @memberof PIXI.DisplayObject#
   */ hitArea: null,
    /**
   * Unlike `on` or `addListener` which are methods from EventEmitter, `addEventListener`
   * seeks to be compatible with the DOM's `addEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event to listen to.
   * @param listener - The listener callback or object.
   * @param options - Listener options, used for capture phase.
   * @example
   * // Tell the user whether they did a single, double, triple, or nth click.
   * button.addEventListener('click', {
   *     handleEvent(e): {
   *         let prefix;
   *
   *         switch (e.detail) {
   *             case 1: prefix = 'single'; break;
   *             case 2: prefix = 'double'; break;
   *             case 3: prefix = 'triple'; break;
   *             default: prefix = e.detail + 'th'; break;
   *         }
   *
   *         console.log('That was a ' + prefix + 'click');
   *     }
   * });
   *
   * // But skip the first click!
   * button.parent.addEventListener('click', function blockClickOnce(e) {
   *     e.stopImmediatePropagation();
   *     button.parent.removeEventListener('click', blockClickOnce, true);
   * }, {
   *     capture: true,
   * });
   */ addEventListener (type, listener, options) {
        const capture = typeof options == "boolean" && options || typeof options == "object" && options.capture, signal = typeof options == "object" ? options.signal : void 0, once = typeof options == "object" ? options.once === !0 : !1, context = typeof listener == "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type;
        const listenerFn = typeof listener == "function" ? listener : listener.handleEvent, emitter = this;
        signal && signal.addEventListener("abort", ()=>{
            emitter.off(type, listenerFn, context);
        }), once ? emitter.once(type, listenerFn, context) : emitter.on(type, listenerFn, context);
    },
    /**
   * Unlike `off` or `removeListener` which are methods from EventEmitter, `removeEventListener`
   * seeks to be compatible with the DOM's `removeEventListener` with support for options.
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param type - The type of event the listener is bound to.
   * @param listener - The listener callback or object.
   * @param options - The original listener options. This is required to deregister a capture phase listener.
   */ removeEventListener (type, listener, options) {
        const capture = typeof options == "boolean" && options || typeof options == "object" && options.capture, context = typeof listener == "function" ? void 0 : listener;
        type = capture ? `${type}capture` : type, listener = typeof listener == "function" ? listener : listener.handleEvent, this.off(type, listener, context);
    },
    /**
   * Dispatch the event on this {@link PIXI.DisplayObject} using the event's {@link PIXI.EventBoundary}.
   *
   * The target of the event is set to `this` and the `defaultPrevented` flag is cleared before dispatch.
   *
   * **IMPORTANT:** _Only_ available if using the `@pixi/events` package.
   * @memberof PIXI.DisplayObject
   * @param e - The event to dispatch.
   * @returns Whether the {@link PIXI.FederatedEvent.preventDefault preventDefault}() method was not invoked.
   * @example
   * // Reuse a click event!
   * button.dispatchEvent(clickEvent);
   */ dispatchEvent (e) {
        if (!(e instanceof (0, $26b8e1b052f7f249$export$5d10db92bb959d8a))) throw new Error("DisplayObject cannot propagate events outside of the Federated Events API");
        return e.defaultPrevented = !1, e.path = null, e.target = this, e.manager.dispatchEvent(e), !e.defaultPrevented;
    }
};
(0, $5xkOK.DisplayObject).mixin($603ddb200f76e809$export$6a5b99a7f30af1d9);







const $3164dd00f6aa85db$export$2c6c5fc5694bba8e = {
    /**
   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
   *   shadow div with attributes set
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */ accessible: !1,
    /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
   * @member {?string}
   * @memberof PIXI.DisplayObject#
   */ accessibleTitle: null,
    /**
   * Sets the aria-label attribute of the shadow div
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */ accessibleHint: null,
    /**
   * @member {number}
   * @memberof PIXI.DisplayObject#
   * @private
   * @todo Needs docs.
   */ tabIndex: 0,
    /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */ _accessibleActive: !1,
    /**
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @todo Needs docs.
   */ _accessibleDiv: null,
    /**
   * Specify the type of div the accessible layer is. Screen readers treat the element differently
   * depending on this type. Defaults to button.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'button'
   */ accessibleType: "button",
    /**
   * Specify the pointer-events the accessible div will use
   * Defaults to auto.
   * @member {string}
   * @memberof PIXI.DisplayObject#
   * @default 'auto'
   */ accessiblePointerEvents: "auto",
    /**
   * Setting to false will prevent any children inside this container to
   * be accessible. Defaults to true.
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   * @default true
   */ accessibleChildren: !0,
    renderId: -1
};


(0, $5xkOK.DisplayObject).mixin((0, $3164dd00f6aa85db$export$2c6c5fc5694bba8e));
const $cd5971328eee02ab$var$KEY_CODE_TAB = 9, $cd5971328eee02ab$var$DIV_TOUCH_SIZE = 100, $cd5971328eee02ab$var$DIV_TOUCH_POS_X = 0, $cd5971328eee02ab$var$DIV_TOUCH_POS_Y = 0, $cd5971328eee02ab$var$DIV_TOUCH_ZINDEX = 2, $cd5971328eee02ab$var$DIV_HOOK_SIZE = 1, $cd5971328eee02ab$var$DIV_HOOK_POS_X = -1000, $cd5971328eee02ab$var$DIV_HOOK_POS_Y = -1000, $cd5971328eee02ab$var$DIV_HOOK_ZINDEX = 2;
class $cd5971328eee02ab$export$a2c2de1efa8671eb {
    // 2fps
    /**
   * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        this.debug = !1, this._isActive = !1, this._isMobileAccessibility = !1, this.pool = [], this.renderId = 0, this.children = [], this.androidUpdateCount = 0, this.androidUpdateFrequency = 500, this._hookDiv = null, ((0, $lFGyw).isMobile.tablet || (0, $lFGyw).isMobile.phone) && this.createTouchHook();
        const div = document.createElement("div");
        div.style.width = `${$cd5971328eee02ab$var$DIV_TOUCH_SIZE}px`, div.style.height = `${$cd5971328eee02ab$var$DIV_TOUCH_SIZE}px`, div.style.position = "absolute", div.style.top = `${$cd5971328eee02ab$var$DIV_TOUCH_POS_X}px`, div.style.left = `${$cd5971328eee02ab$var$DIV_TOUCH_POS_Y}px`, div.style.zIndex = $cd5971328eee02ab$var$DIV_TOUCH_ZINDEX.toString(), this.div = div, this.renderer = renderer, this._onKeyDown = this._onKeyDown.bind(this), this._onMouseMove = this._onMouseMove.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1);
    }
    /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @member {boolean}
   * @readonly
   */ get isActive() {
        return this._isActive;
    }
    /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @member {boolean}
   * @readonly
   */ get isMobileAccessibility() {
        return this._isMobileAccessibility;
    }
    /**
   * Creates the touch hooks.
   * @private
   */ createTouchHook() {
        const hookDiv = document.createElement("button");
        hookDiv.style.width = `${$cd5971328eee02ab$var$DIV_HOOK_SIZE}px`, hookDiv.style.height = `${$cd5971328eee02ab$var$DIV_HOOK_SIZE}px`, hookDiv.style.position = "absolute", hookDiv.style.top = `${$cd5971328eee02ab$var$DIV_HOOK_POS_X}px`, hookDiv.style.left = `${$cd5971328eee02ab$var$DIV_HOOK_POS_Y}px`, hookDiv.style.zIndex = $cd5971328eee02ab$var$DIV_HOOK_ZINDEX.toString(), hookDiv.style.backgroundColor = "#FF0000", hookDiv.title = "select to enable accessibility for this content", hookDiv.addEventListener("focus", ()=>{
            this._isMobileAccessibility = !0, this.activate(), this.destroyTouchHook();
        }), document.body.appendChild(hookDiv), this._hookDiv = hookDiv;
    }
    /**
   * Destroys the touch hooks.
   * @private
   */ destroyTouchHook() {
        this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
    }
    /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */ activate() {
        this._isActive || (this._isActive = !0, globalThis.document.addEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown, !1), this.renderer.on("postrender", this.update, this), this.renderer.view.parentNode?.appendChild(this.div));
    }
    /**
   * Deactivating will cause the Accessibility layer to be hidden.
   * This is called when a user moves the mouse.
   * @private
   */ deactivate() {
        !this._isActive || this._isMobileAccessibility || (this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.addEventListener("keydown", this._onKeyDown, !1), this.renderer.off("postrender", this.update), this.div.parentNode?.removeChild(this.div));
    }
    /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {PIXI.Container} displayObject - The DisplayObject to check.
   */ updateAccessibleObjects(displayObject) {
        if (!displayObject.visible || !displayObject.accessibleChildren) return;
        displayObject.accessible && displayObject.isInteractive() && (displayObject._accessibleActive || this.addChild(displayObject), displayObject.renderId = this.renderId);
        const children = displayObject.children;
        if (children) for(let i = 0; i < children.length; i++)this.updateAccessibleObjects(children[i]);
    }
    /**
   * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
   * @private
   */ update() {
        const now = performance.now();
        if ((0, $lFGyw).isMobile.android.device && now < this.androidUpdateCount || (this.androidUpdateCount = now + this.androidUpdateFrequency, !this.renderer.renderingToScreen)) return;
        this.renderer.lastObjectRendered && this.updateAccessibleObjects(this.renderer.lastObjectRendered);
        const { x: x, y: y, width: width, height: height } = this.renderer.view.getBoundingClientRect(), { width: viewWidth, height: viewHeight, resolution: resolution } = this.renderer, sx = width / viewWidth * resolution, sy = height / viewHeight * resolution;
        let div = this.div;
        div.style.left = `${x}px`, div.style.top = `${y}px`, div.style.width = `${viewWidth}px`, div.style.height = `${viewHeight}px`;
        for(let i = 0; i < this.children.length; i++){
            const child = this.children[i];
            if (child.renderId !== this.renderId) child._accessibleActive = !1, (0, $lFGyw).removeItems(this.children, i, 1), this.div.removeChild(child._accessibleDiv), this.pool.push(child._accessibleDiv), child._accessibleDiv = null, i--;
            else {
                div = child._accessibleDiv;
                let hitArea = child.hitArea;
                const wt = child.worldTransform;
                child.hitArea ? (div.style.left = `${(wt.tx + hitArea.x * wt.a) * sx}px`, div.style.top = `${(wt.ty + hitArea.y * wt.d) * sy}px`, div.style.width = `${hitArea.width * wt.a * sx}px`, div.style.height = `${hitArea.height * wt.d * sy}px`) : (hitArea = child.getBounds(), this.capHitArea(hitArea), div.style.left = `${hitArea.x * sx}px`, div.style.top = `${hitArea.y * sy}px`, div.style.width = `${hitArea.width * sx}px`, div.style.height = `${hitArea.height * sy}px`, div.title !== child.accessibleTitle && child.accessibleTitle !== null && (div.title = child.accessibleTitle), div.getAttribute("aria-label") !== child.accessibleHint && child.accessibleHint !== null && div.setAttribute("aria-label", child.accessibleHint)), (child.accessibleTitle !== div.title || child.tabIndex !== div.tabIndex) && (div.title = child.accessibleTitle, div.tabIndex = child.tabIndex, this.debug && this.updateDebugHTML(div));
            }
        }
        this.renderId++;
    }
    /**
   * private function that will visually add the information to the
   * accessability div
   * @param {HTMLElement} div -
   */ updateDebugHTML(div) {
        div.innerHTML = `type: ${div.type}</br> title : ${div.title}</br> tabIndex: ${div.tabIndex}`;
    }
    /**
   * Adjust the hit area based on the bounds of a display object
   * @param {PIXI.Rectangle} hitArea - Bounds of the child
   */ capHitArea(hitArea) {
        hitArea.x < 0 && (hitArea.width += hitArea.x, hitArea.x = 0), hitArea.y < 0 && (hitArea.height += hitArea.y, hitArea.y = 0);
        const { width: viewWidth, height: viewHeight } = this.renderer;
        hitArea.x + hitArea.width > viewWidth && (hitArea.width = viewWidth - hitArea.x), hitArea.y + hitArea.height > viewHeight && (hitArea.height = viewHeight - hitArea.y);
    }
    /**
   * Adds a DisplayObject to the accessibility manager
   * @private
   * @param {PIXI.DisplayObject} displayObject - The child to make accessible.
   */ addChild(displayObject) {
        let div = this.pool.pop();
        div || (div = document.createElement("button"), div.style.width = `${$cd5971328eee02ab$var$DIV_TOUCH_SIZE}px`, div.style.height = `${$cd5971328eee02ab$var$DIV_TOUCH_SIZE}px`, div.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", div.style.position = "absolute", div.style.zIndex = $cd5971328eee02ab$var$DIV_TOUCH_ZINDEX.toString(), div.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? div.setAttribute("aria-live", "off") : div.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? div.setAttribute("aria-relevant", "additions") : div.setAttribute("aria-relevant", "text"), div.addEventListener("click", this._onClick.bind(this)), div.addEventListener("focus", this._onFocus.bind(this)), div.addEventListener("focusout", this._onFocusOut.bind(this))), div.style.pointerEvents = displayObject.accessiblePointerEvents, div.type = displayObject.accessibleType, displayObject.accessibleTitle && displayObject.accessibleTitle !== null ? div.title = displayObject.accessibleTitle : (!displayObject.accessibleHint || displayObject.accessibleHint === null) && (div.title = `displayObject ${displayObject.tabIndex}`), displayObject.accessibleHint && displayObject.accessibleHint !== null && div.setAttribute("aria-label", displayObject.accessibleHint), this.debug && this.updateDebugHTML(div), displayObject._accessibleActive = !0, displayObject._accessibleDiv = div, div.displayObject = displayObject, this.children.push(displayObject), this.div.appendChild(displayObject._accessibleDiv), displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
    }
    /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */ _dispatchEvent(e, type) {
        const { displayObject: target } = e.target, boundry = this.renderer.events.rootBoundary, event = Object.assign(new (0, $26b8e1b052f7f249$export$5d10db92bb959d8a)(boundry), {
            target: target
        });
        boundry.rootTarget = this.renderer.lastObjectRendered, type.forEach((type2)=>boundry.dispatchEvent(event, type2));
    }
    /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */ _onClick(e) {
        this._dispatchEvent(e, [
            "click",
            "pointertap",
            "tap"
        ]);
    }
    /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */ _onFocus(e) {
        e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(e, [
            "mouseover"
        ]);
    }
    /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */ _onFocusOut(e) {
        e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "polite"), this._dispatchEvent(e, [
            "mouseout"
        ]);
    }
    /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */ _onKeyDown(e) {
        e.keyCode === $cd5971328eee02ab$var$KEY_CODE_TAB && this.activate();
    }
    /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */ _onMouseMove(e) {
        e.movementX === 0 && e.movementY === 0 || this.deactivate();
    }
    /** Destroys the accessibility manager */ destroy() {
        this.destroyTouchHook(), this.div = null, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), globalThis.removeEventListener("keydown", this._onKeyDown), this.pool = null, this.children = null, this.renderer = null;
    }
}
$cd5971328eee02ab$export$a2c2de1efa8671eb.extension = {
    name: "accessibility",
    type: [
        (0, $5RvHb.ExtensionType).RendererPlugin,
        (0, $5RvHb.ExtensionType).CanvasRendererPlugin
    ]
};
(0, $5RvHb.extensions).add($cd5971328eee02ab$export$a2c2de1efa8671eb);





parcelRequire("gbrJV");
parcelRequire("ew1SP");
var $53c3f918f15a2feb$export$9a3c57b95f3e5f5d = /* @__PURE__ */ ((INTERNAL_FORMATS2)=>(INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_S3TC_DXT1_EXT = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_R11_EAC = 37488] = "COMPRESSED_R11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SIGNED_R11_EAC = 37489] = "COMPRESSED_SIGNED_R11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RG11_EAC = 37490] = "COMPRESSED_RG11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SIGNED_RG11_EAC = 37491] = "COMPRESSED_SIGNED_RG11_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB8_ETC2 = 37492] = "COMPRESSED_RGB8_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA8_ETC2_EAC = 37496] = "COMPRESSED_RGBA8_ETC2_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_ETC2 = 37493] = "COMPRESSED_SRGB8_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_ETC1_WEBGL = 36196] = "COMPRESSED_RGB_ETC1_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_ATC_WEBGL = 35986] = "COMPRESSED_RGB_ATC_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 35987] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_ASTC_4x4_KHR = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGBA_BPTC_UNORM_EXT = 36492] = "COMPRESSED_RGBA_BPTC_UNORM_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT = 36493] = "COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT = 36494] = "COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT", INTERNAL_FORMATS2[INTERNAL_FORMATS2.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT = 36495] = "COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT", INTERNAL_FORMATS2))($53c3f918f15a2feb$export$9a3c57b95f3e5f5d || {});
const $53c3f918f15a2feb$export$fb888e587c979eee = {
    // WEBGL_compressed_texture_s3tc
    33776: 0.5,
    33777: 0.5,
    33778: 1,
    33779: 1,
    // WEBGL_compressed_texture_s3tc
    35916: 0.5,
    35917: 0.5,
    35918: 1,
    35919: 1,
    // WEBGL_compressed_texture_etc
    37488: 0.5,
    37489: 0.5,
    37490: 1,
    37491: 1,
    37492: 0.5,
    37496: 1,
    37493: 0.5,
    37497: 1,
    37494: 0.5,
    // ~~
    37495: 0.5,
    // ~~
    // WEBGL_compressed_texture_pvrtc
    35840: 0.5,
    35842: 0.5,
    35841: 0.25,
    35843: 0.25,
    // WEBGL_compressed_texture_etc1
    36196: 0.5,
    // @see https://www.khronos.org/registry/OpenGL/extensions/AMD/AMD_compressed_ATC_texture.txt
    // WEBGL_compressed_texture_atc
    35986: 0.5,
    35987: 1,
    34798: 1,
    // @see https://registry.khronos.org/OpenGL/extensions/KHR/KHR_texture_compression_astc_hdr.txt
    // WEBGL_compressed_texture_astc
    /* eslint-disable-next-line camelcase */ 37808: 1,
    // @see https://registry.khronos.org/OpenGL/extensions/EXT/EXT_texture_compression_bptc.txt
    // EXT_texture_compression_bptc
    36492: 1,
    36493: 1,
    36494: 1,
    36495: 1
};




parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
let $03749dee05caaa30$var$storedGl, $03749dee05caaa30$var$extensions;
function $03749dee05caaa30$var$getCompressedTextureExtensions() {
    $03749dee05caaa30$var$extensions = {
        s3tc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_s3tc"),
        s3tc_sRGB: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
        /* eslint-disable-line camelcase */ etc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_etc"),
        etc1: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_etc1"),
        pvrtc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_pvrtc") || $03749dee05caaa30$var$storedGl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
        atc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_atc"),
        astc: $03749dee05caaa30$var$storedGl.getExtension("WEBGL_compressed_texture_astc"),
        bptc: $03749dee05caaa30$var$storedGl.getExtension("EXT_texture_compression_bptc")
    };
}
const $03749dee05caaa30$export$82cf9629b7380430 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).DetectionParser,
        priority: 2
    },
    test: async ()=>{
        const gl = (0, $16eqM.settings).ADAPTER.createCanvas().getContext("webgl");
        return gl ? ($03749dee05caaa30$var$storedGl = gl, !0) : (console.warn("WebGL not available for compressed textures."), !1);
    },
    add: async (formats)=>{
        $03749dee05caaa30$var$extensions || $03749dee05caaa30$var$getCompressedTextureExtensions();
        const textureFormats = [];
        for(const extensionName in $03749dee05caaa30$var$extensions)$03749dee05caaa30$var$extensions[extensionName] && textureFormats.push(extensionName);
        return [
            ...textureFormats,
            ...formats
        ];
    },
    remove: async (formats)=>($03749dee05caaa30$var$extensions || $03749dee05caaa30$var$getCompressedTextureExtensions(), formats.filter((f)=>!(f in $03749dee05caaa30$var$extensions)))
};
(0, $5RvHb.extensions).add($03749dee05caaa30$export$82cf9629b7380430);


parcelRequire("ew1SP");
var $fzibG = parcelRequire("fzibG");
var $8ZIRW = parcelRequire("8ZIRW");
var $h0Gbc = parcelRequire("h0Gbc");
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $4oWO8 = parcelRequire("4oWO8");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");

parcelRequire("inflE");
var $1oZjy = parcelRequire("1oZjy");
var $kZVXo = parcelRequire("kZVXo");
class $420f108efb900a3c$export$f257f839012584a2 extends (0, $1oZjy.BufferResource) {
    /**
   * @param source - The buffer/URL of the texture file.
   * @param {PIXI.IBlobResourceOptions} [options]
   * @param {boolean} [options.autoLoad=false] - Whether to fetch the data immediately;
   *  you can fetch it later via {@link PIXI.BlobResource#load}.
   * @param {number} [options.width=1] - The width in pixels.
   * @param {number} [options.height=1] - The height in pixels.
   * @param {1|2|4|8} [options.unpackAlignment=4] - The alignment of the pixel rows.
   */ constructor(source, options = {
        width: 1,
        height: 1,
        autoLoad: !0
    }){
        let origin, data;
        typeof source == "string" ? (origin = source, data = new Uint8Array()) : (origin = null, data = source), super(data, options), this.origin = origin, this.buffer = data ? new (0, $kZVXo.ViewableBuffer)(data) : null, this._load = null, this.loaded = !1, this.origin !== null && options.autoLoad !== !1 && this.load(), this.origin === null && this.buffer && (this._load = Promise.resolve(this), this.loaded = !0, this.onBlobLoaded(this.buffer.rawBinaryData));
    }
    onBlobLoaded(_data) {}
    /** Loads the blob */ load() {
        return this._load ? this._load : (this._load = fetch(this.origin).then((response)=>response.blob()).then((blob)=>blob.arrayBuffer()).then((arrayBuffer)=>(this.data = new Uint32Array(arrayBuffer), this.buffer = new (0, $kZVXo.ViewableBuffer)(arrayBuffer), this.loaded = !0, this.onBlobLoaded(arrayBuffer), this.update(), this)), this._load);
    }
}




class $fa0cb104b4c002be$export$1982af6892f05657 extends (0, $420f108efb900a3c$export$f257f839012584a2) {
    /**
   * @param source - the buffer/URL holding the compressed texture data
   * @param options
   * @param {PIXI.INTERNAL_FORMATS} options.format - the compression format
   * @param {number} options.width - the image width in pixels.
   * @param {number} options.height - the image height in pixels.
   * @param {number} [options.level=1] - the mipmap levels stored in the compressed texture, including level 0.
   * @param {number} [options.levelBuffers] - the buffers for each mipmap level. `CompressedTextureResource` can allows you
   *      to pass `null` for `source`, for cases where each level is stored in non-contiguous memory.
   */ constructor(source, options){
        super(source, options), this.format = options.format, this.levels = options.levels || 1, this._width = options.width, this._height = options.height, this._extension = $fa0cb104b4c002be$export$1982af6892f05657._formatToExtension(this.format), (options.levelBuffers || this.buffer) && (this._levelBuffers = options.levelBuffers || $fa0cb104b4c002be$export$1982af6892f05657._createLevelBuffers(source instanceof Uint8Array ? source : this.buffer.uint8View, this.format, this.levels, 4, 4, // PVRTC has 8x4 blocks in 2bpp mode
        this.width, this.height));
    }
    /**
   * @override
   * @param renderer - A reference to the current renderer
   * @param _texture - the texture
   * @param _glTexture - texture instance for this webgl context
   */ upload(renderer, _texture, _glTexture) {
        const gl = renderer.gl;
        if (!renderer.context.extensions[this._extension]) throw new Error(`${this._extension} textures are not supported on the current machine`);
        if (!this._levelBuffers) return !1;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, 4);
        for(let i = 0, j = this.levels; i < j; i++){
            const { levelID: levelID, levelWidth: levelWidth, levelHeight: levelHeight, levelBuffer: levelBuffer } = this._levelBuffers[i];
            gl.compressedTexImage2D(gl.TEXTURE_2D, levelID, this.format, levelWidth, levelHeight, 0, levelBuffer);
        }
        return !0;
    }
    /** @protected */ onBlobLoaded() {
        this._levelBuffers = $fa0cb104b4c002be$export$1982af6892f05657._createLevelBuffers(this.buffer.uint8View, this.format, this.levels, 4, 4, // PVRTC has 8x4 blocks in 2bpp mode
        this.width, this.height);
    }
    /**
   * Returns the key (to ContextSystem#extensions) for the WebGL extension supporting the compression format
   * @private
   * @param format - the compression format to get the extension for.
   */ static _formatToExtension(format) {
        if (format >= 33776 && format <= 33779) return "s3tc";
        if (format >= 35916 && format <= 35919) return "s3tc_sRGB";
        if (format >= 37488 && format <= 37497) return "etc";
        if (format >= 35840 && format <= 35843) return "pvrtc";
        if (format === 36196) return "etc1";
        if (format === 35986 || format === 35987 || format === 34798) return "atc";
        if (format >= 36492 && format <= 36495) return "bptc";
        if (format === 37808) return "astc";
        throw new Error(`Invalid (compressed) texture format given: ${format}`);
    }
    /**
   * Pre-creates buffer views for each mipmap level
   * @private
   * @param buffer -
   * @param format - compression formats
   * @param levels - mipmap levels
   * @param blockWidth -
   * @param blockHeight -
   * @param imageWidth - width of the image in pixels
   * @param imageHeight - height of the image in pixels
   */ static _createLevelBuffers(buffer, format, levels, blockWidth, blockHeight, imageWidth, imageHeight) {
        const buffers = new Array(levels);
        let offset = buffer.byteOffset, levelWidth = imageWidth, levelHeight = imageHeight, alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1), alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1), levelSize = alignedLevelWidth * alignedLevelHeight * (0, $53c3f918f15a2feb$export$fb888e587c979eee)[format];
        for(let i = 0; i < levels; i++)buffers[i] = {
            levelID: i,
            levelWidth: levels > 1 ? levelWidth : alignedLevelWidth,
            levelHeight: levels > 1 ? levelHeight : alignedLevelHeight,
            levelBuffer: new Uint8Array(buffer.buffer, offset, levelSize)
        }, offset += levelSize, levelWidth = levelWidth >> 1 || 1, levelHeight = levelHeight >> 1 || 1, alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1), alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1), levelSize = alignedLevelWidth * alignedLevelHeight * (0, $53c3f918f15a2feb$export$fb888e587c979eee)[format];
        return buffers;
    }
}





const $9d3d2e1a107c7be2$var$DDS_MAGIC_SIZE = 4, $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE = 124, $9d3d2e1a107c7be2$var$DDS_HEADER_PF_SIZE = 32, $9d3d2e1a107c7be2$var$DDS_HEADER_DX10_SIZE = 20, $9d3d2e1a107c7be2$var$DDS_MAGIC = 542327876, $9d3d2e1a107c7be2$var$DDS_FIELDS = {
    SIZE: 1,
    FLAGS: 2,
    HEIGHT: 3,
    WIDTH: 4,
    MIPMAP_COUNT: 7,
    PIXEL_FORMAT: 19
}, $9d3d2e1a107c7be2$var$DDS_PF_FIELDS = {
    SIZE: 0,
    FLAGS: 1,
    FOURCC: 2,
    RGB_BITCOUNT: 3,
    R_BIT_MASK: 4,
    G_BIT_MASK: 5,
    B_BIT_MASK: 6,
    A_BIT_MASK: 7
}, $9d3d2e1a107c7be2$var$DDS_DX10_FIELDS = {
    DXGI_FORMAT: 0,
    RESOURCE_DIMENSION: 1,
    MISC_FLAG: 2,
    ARRAY_SIZE: 3,
    MISC_FLAGS2: 4
}, $9d3d2e1a107c7be2$var$PF_FLAGS = 1, $9d3d2e1a107c7be2$var$DDPF_ALPHA = 2, $9d3d2e1a107c7be2$var$DDPF_FOURCC = 4, $9d3d2e1a107c7be2$var$DDPF_RGB = 64, $9d3d2e1a107c7be2$var$DDPF_YUV = 512, $9d3d2e1a107c7be2$var$DDPF_LUMINANCE = 131072, $9d3d2e1a107c7be2$var$FOURCC_DXT1 = 827611204, $9d3d2e1a107c7be2$var$FOURCC_DXT3 = 861165636, $9d3d2e1a107c7be2$var$FOURCC_DXT5 = 894720068, $9d3d2e1a107c7be2$var$FOURCC_DX10 = 808540228, $9d3d2e1a107c7be2$var$DDS_RESOURCE_MISC_TEXTURECUBE = 4, $9d3d2e1a107c7be2$var$FOURCC_TO_FORMAT = {
    [$9d3d2e1a107c7be2$var$FOURCC_DXT1]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    [$9d3d2e1a107c7be2$var$FOURCC_DXT3]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    [$9d3d2e1a107c7be2$var$FOURCC_DXT5]: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT
}, $9d3d2e1a107c7be2$var$DXGI_TO_FORMAT = {
    // WEBGL_compressed_texture_s3tc
    70: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    71: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT1_EXT,
    73: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    74: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT3_EXT,
    76: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT,
    77: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_S3TC_DXT5_EXT,
    // WEBGL_compressed_texture_s3tc_srgb
    72: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
    75: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
    78: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT,
    // EXT_texture_compression_bptc
    // BC6H
    96: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT,
    95: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT,
    // BC7
    98: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_RGBA_BPTC_UNORM_EXT,
    99: (0, $53c3f918f15a2feb$export$9a3c57b95f3e5f5d).COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
};
function $9d3d2e1a107c7be2$export$cddc4925efe88ac(arrayBuffer) {
    const data = new Uint32Array(arrayBuffer);
    if (data[0] !== $9d3d2e1a107c7be2$var$DDS_MAGIC) throw new Error("Invalid DDS file magic word");
    const header = new Uint32Array(arrayBuffer, 0, $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE / Uint32Array.BYTES_PER_ELEMENT), height = header[$9d3d2e1a107c7be2$var$DDS_FIELDS.HEIGHT], width = header[$9d3d2e1a107c7be2$var$DDS_FIELDS.WIDTH], mipmapCount = header[$9d3d2e1a107c7be2$var$DDS_FIELDS.MIPMAP_COUNT], pixelFormat = new Uint32Array(arrayBuffer, $9d3d2e1a107c7be2$var$DDS_FIELDS.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT, $9d3d2e1a107c7be2$var$DDS_HEADER_PF_SIZE / Uint32Array.BYTES_PER_ELEMENT), formatFlags = pixelFormat[$9d3d2e1a107c7be2$var$PF_FLAGS];
    if (formatFlags & $9d3d2e1a107c7be2$var$DDPF_FOURCC) {
        const fourCC = pixelFormat[$9d3d2e1a107c7be2$var$DDS_PF_FIELDS.FOURCC];
        if (fourCC !== $9d3d2e1a107c7be2$var$FOURCC_DX10) {
            const internalFormat2 = $9d3d2e1a107c7be2$var$FOURCC_TO_FORMAT[fourCC], dataOffset2 = $9d3d2e1a107c7be2$var$DDS_MAGIC_SIZE + $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE, texData = new Uint8Array(arrayBuffer, dataOffset2);
            return [
                new (0, $fa0cb104b4c002be$export$1982af6892f05657)(texData, {
                    format: internalFormat2,
                    width: width,
                    height: height,
                    levels: mipmapCount
                })
            ];
        }
        const dx10Offset = $9d3d2e1a107c7be2$var$DDS_MAGIC_SIZE + $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE, dx10Header = new Uint32Array(data.buffer, dx10Offset, $9d3d2e1a107c7be2$var$DDS_HEADER_DX10_SIZE / Uint32Array.BYTES_PER_ELEMENT), dxgiFormat = dx10Header[$9d3d2e1a107c7be2$var$DDS_DX10_FIELDS.DXGI_FORMAT], resourceDimension = dx10Header[$9d3d2e1a107c7be2$var$DDS_DX10_FIELDS.RESOURCE_DIMENSION], miscFlag = dx10Header[$9d3d2e1a107c7be2$var$DDS_DX10_FIELDS.MISC_FLAG], arraySize = dx10Header[$9d3d2e1a107c7be2$var$DDS_DX10_FIELDS.ARRAY_SIZE], internalFormat = $9d3d2e1a107c7be2$var$DXGI_TO_FORMAT[dxgiFormat];
        if (internalFormat === void 0) throw new Error(`DDSParser cannot parse texture data with DXGI format ${dxgiFormat}`);
        if (miscFlag === $9d3d2e1a107c7be2$var$DDS_RESOURCE_MISC_TEXTURECUBE) throw new Error("DDSParser does not support cubemap textures");
        if (resourceDimension === 6) throw new Error("DDSParser does not supported 3D texture data");
        const imageBuffers = new Array(), dataOffset = $9d3d2e1a107c7be2$var$DDS_MAGIC_SIZE + $9d3d2e1a107c7be2$var$DDS_HEADER_SIZE + $9d3d2e1a107c7be2$var$DDS_HEADER_DX10_SIZE;
        if (arraySize === 1) imageBuffers.push(new Uint8Array(arrayBuffer, dataOffset));
        else {
            const pixelSize = (0, $53c3f918f15a2feb$export$fb888e587c979eee)[internalFormat];
            let imageSize = 0, levelWidth = width, levelHeight = height;
            for(let i = 0; i < mipmapCount; i++){
                const alignedLevelWidth = Math.max(1, levelWidth + 3 & -4), alignedLevelHeight = Math.max(1, levelHeight + 3 & -4), levelSize = alignedLevelWidth * alignedLevelHeight * pixelSize;
                imageSize += levelSize, levelWidth = levelWidth >>> 1, levelHeight = levelHeight >>> 1;
            }
            let imageOffset = dataOffset;
            for(let i = 0; i < arraySize; i++)imageBuffers.push(new Uint8Array(arrayBuffer, imageOffset, imageSize)), imageOffset += imageSize;
        }
        return imageBuffers.map((buffer)=>new (0, $fa0cb104b4c002be$export$1982af6892f05657)(buffer, {
                format: internalFormat,
                width: width,
                height: height,
                levels: mipmapCount
            }));
    }
    throw formatFlags & $9d3d2e1a107c7be2$var$DDPF_RGB ? new Error("DDSParser does not support uncompressed texture data.") : formatFlags & $9d3d2e1a107c7be2$var$DDPF_YUV ? new Error("DDSParser does not supported YUV uncompressed texture data.") : formatFlags & $9d3d2e1a107c7be2$var$DDPF_LUMINANCE ? new Error("DDSParser does not support single-channel (lumninance) texture data!") : formatFlags & $9d3d2e1a107c7be2$var$DDPF_ALPHA ? new Error("DDSParser does not support single-channel (alpha) texture data!") : new Error("DDSParser failed to load a texture file due to an unknown reason!");
}


parcelRequire("inflE");
var $1oZjy = parcelRequire("1oZjy");
var $lmRm8 = parcelRequire("lmRm8");



const $40970c6d4881ef4f$var$FILE_IDENTIFIER = [
    171,
    75,
    84,
    88,
    32,
    49,
    49,
    187,
    13,
    10,
    26,
    10
], $40970c6d4881ef4f$var$ENDIANNESS = 67305985, $40970c6d4881ef4f$var$KTX_FIELDS = {
    FILE_IDENTIFIER: 0,
    ENDIANNESS: 12,
    GL_TYPE: 16,
    GL_TYPE_SIZE: 20,
    GL_FORMAT: 24,
    GL_INTERNAL_FORMAT: 28,
    GL_BASE_INTERNAL_FORMAT: 32,
    PIXEL_WIDTH: 36,
    PIXEL_HEIGHT: 40,
    PIXEL_DEPTH: 44,
    NUMBER_OF_ARRAY_ELEMENTS: 48,
    NUMBER_OF_FACES: 52,
    NUMBER_OF_MIPMAP_LEVELS: 56,
    BYTES_OF_KEY_VALUE_DATA: 60
}, $40970c6d4881ef4f$var$FILE_HEADER_SIZE = 64, $40970c6d4881ef4f$export$96c88eb9c7372a0b = {
    [(0, $lmRm8.TYPES).UNSIGNED_BYTE]: 1,
    [(0, $lmRm8.TYPES).UNSIGNED_SHORT]: 2,
    [(0, $lmRm8.TYPES).INT]: 4,
    [(0, $lmRm8.TYPES).UNSIGNED_INT]: 4,
    [(0, $lmRm8.TYPES).FLOAT]: 4,
    [(0, $lmRm8.TYPES).HALF_FLOAT]: 8
}, $40970c6d4881ef4f$export$ace48b1390b9b0c2 = {
    [(0, $lmRm8.FORMATS).RGBA]: 4,
    [(0, $lmRm8.FORMATS).RGB]: 3,
    [(0, $lmRm8.FORMATS).RG]: 2,
    [(0, $lmRm8.FORMATS).RED]: 1,
    [(0, $lmRm8.FORMATS).LUMINANCE]: 1,
    [(0, $lmRm8.FORMATS).LUMINANCE_ALPHA]: 2,
    [(0, $lmRm8.FORMATS).ALPHA]: 1
}, $40970c6d4881ef4f$export$2ca26443044e8798 = {
    [(0, $lmRm8.TYPES).UNSIGNED_SHORT_4_4_4_4]: 2,
    [(0, $lmRm8.TYPES).UNSIGNED_SHORT_5_5_5_1]: 2,
    [(0, $lmRm8.TYPES).UNSIGNED_SHORT_5_6_5]: 2
};
function $40970c6d4881ef4f$export$58a6abed7fd55190(url, arrayBuffer, loadKeyValueData = !1) {
    const dataView = new DataView(arrayBuffer);
    if (!$40970c6d4881ef4f$var$validate(url, dataView)) return null;
    const littleEndian = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.ENDIANNESS, !0) === $40970c6d4881ef4f$var$ENDIANNESS, glType = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.GL_TYPE, littleEndian), glFormat = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.GL_FORMAT, littleEndian), glInternalFormat = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.GL_INTERNAL_FORMAT, littleEndian), pixelWidth = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.PIXEL_WIDTH, littleEndian), pixelHeight = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.PIXEL_HEIGHT, littleEndian) || 1, pixelDepth = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.PIXEL_DEPTH, littleEndian) || 1, numberOfArrayElements = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.NUMBER_OF_ARRAY_ELEMENTS, littleEndian) || 1, numberOfFaces = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.NUMBER_OF_FACES, littleEndian), numberOfMipmapLevels = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.NUMBER_OF_MIPMAP_LEVELS, littleEndian), bytesOfKeyValueData = dataView.getUint32($40970c6d4881ef4f$var$KTX_FIELDS.BYTES_OF_KEY_VALUE_DATA, littleEndian);
    if (pixelHeight === 0 || pixelDepth !== 1) throw new Error("Only 2D textures are supported");
    if (numberOfFaces !== 1) throw new Error("CubeTextures are not supported by KTXLoader yet!");
    if (numberOfArrayElements !== 1) throw new Error("WebGL does not support array textures");
    const blockWidth = 4, blockHeight = 4, alignedWidth = pixelWidth + 3 & -4, alignedHeight = pixelHeight + 3 & -4, imageBuffers = new Array(numberOfArrayElements);
    let imagePixels = pixelWidth * pixelHeight;
    glType === 0 && (imagePixels = alignedWidth * alignedHeight);
    let imagePixelByteSize;
    if (glType !== 0 ? $40970c6d4881ef4f$export$96c88eb9c7372a0b[glType] ? imagePixelByteSize = $40970c6d4881ef4f$export$96c88eb9c7372a0b[glType] * $40970c6d4881ef4f$export$ace48b1390b9b0c2[glFormat] : imagePixelByteSize = $40970c6d4881ef4f$export$2ca26443044e8798[glType] : imagePixelByteSize = (0, $53c3f918f15a2feb$export$fb888e587c979eee)[glInternalFormat], imagePixelByteSize === void 0) throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
    const kvData = loadKeyValueData ? $40970c6d4881ef4f$var$parseKvData(dataView, bytesOfKeyValueData, littleEndian) : null;
    let mipByteSize = imagePixels * imagePixelByteSize, mipWidth = pixelWidth, mipHeight = pixelHeight, alignedMipWidth = alignedWidth, alignedMipHeight = alignedHeight, imageOffset = $40970c6d4881ef4f$var$FILE_HEADER_SIZE + bytesOfKeyValueData;
    for(let mipmapLevel = 0; mipmapLevel < numberOfMipmapLevels; mipmapLevel++){
        const imageSize = dataView.getUint32(imageOffset, littleEndian);
        let elementOffset = imageOffset + 4;
        for(let arrayElement = 0; arrayElement < numberOfArrayElements; arrayElement++){
            let mips = imageBuffers[arrayElement];
            mips || (mips = imageBuffers[arrayElement] = new Array(numberOfMipmapLevels)), mips[mipmapLevel] = {
                levelID: mipmapLevel,
                // don't align mipWidth when texture not compressed! (glType not zero)
                levelWidth: numberOfMipmapLevels > 1 || glType !== 0 ? mipWidth : alignedMipWidth,
                levelHeight: numberOfMipmapLevels > 1 || glType !== 0 ? mipHeight : alignedMipHeight,
                levelBuffer: new Uint8Array(arrayBuffer, elementOffset, mipByteSize)
            }, elementOffset += mipByteSize;
        }
        imageOffset += imageSize + 4, imageOffset = imageOffset % 4 !== 0 ? imageOffset + 4 - imageOffset % 4 : imageOffset, mipWidth = mipWidth >> 1 || 1, mipHeight = mipHeight >> 1 || 1, alignedMipWidth = mipWidth + blockWidth - 1 & ~(blockWidth - 1), alignedMipHeight = mipHeight + blockHeight - 1 & ~(blockHeight - 1), mipByteSize = alignedMipWidth * alignedMipHeight * imagePixelByteSize;
    }
    return glType !== 0 ? {
        uncompressed: imageBuffers.map((levelBuffers)=>{
            let buffer = levelBuffers[0].levelBuffer, convertToInt = !1;
            return glType === (0, $lmRm8.TYPES).FLOAT ? buffer = new Float32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4) : glType === (0, $lmRm8.TYPES).UNSIGNED_INT ? (convertToInt = !0, buffer = new Uint32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4)) : glType === (0, $lmRm8.TYPES).INT && (convertToInt = !0, buffer = new Int32Array(levelBuffers[0].levelBuffer.buffer, levelBuffers[0].levelBuffer.byteOffset, levelBuffers[0].levelBuffer.byteLength / 4)), {
                resource: new (0, $1oZjy.BufferResource)(buffer, {
                    width: levelBuffers[0].levelWidth,
                    height: levelBuffers[0].levelHeight
                }),
                type: glType,
                format: convertToInt ? $40970c6d4881ef4f$var$convertFormatToInteger(glFormat) : glFormat
            };
        }),
        kvData: kvData
    } : {
        compressed: imageBuffers.map((levelBuffers)=>new (0, $fa0cb104b4c002be$export$1982af6892f05657)(null, {
                format: glInternalFormat,
                width: pixelWidth,
                height: pixelHeight,
                levels: numberOfMipmapLevels,
                levelBuffers: levelBuffers
            })),
        kvData: kvData
    };
}
function $40970c6d4881ef4f$var$validate(url, dataView) {
    for(let i = 0; i < $40970c6d4881ef4f$var$FILE_IDENTIFIER.length; i++)if (dataView.getUint8(i) !== $40970c6d4881ef4f$var$FILE_IDENTIFIER[i]) return console.error(`${url} is not a valid *.ktx file!`), !1;
    return !0;
}
function $40970c6d4881ef4f$var$convertFormatToInteger(format) {
    switch(format){
        case (0, $lmRm8.FORMATS).RGBA:
            return (0, $lmRm8.FORMATS).RGBA_INTEGER;
        case (0, $lmRm8.FORMATS).RGB:
            return (0, $lmRm8.FORMATS).RGB_INTEGER;
        case (0, $lmRm8.FORMATS).RG:
            return (0, $lmRm8.FORMATS).RG_INTEGER;
        case (0, $lmRm8.FORMATS).RED:
            return (0, $lmRm8.FORMATS).RED_INTEGER;
        default:
            return format;
    }
}
function $40970c6d4881ef4f$var$parseKvData(dataView, bytesOfKeyValueData, littleEndian) {
    const kvData = /* @__PURE__ */ new Map();
    let bytesIntoKeyValueData = 0;
    for(; bytesIntoKeyValueData < bytesOfKeyValueData;){
        const keyAndValueByteSize = dataView.getUint32($40970c6d4881ef4f$var$FILE_HEADER_SIZE + bytesIntoKeyValueData, littleEndian), keyAndValueByteOffset = $40970c6d4881ef4f$var$FILE_HEADER_SIZE + bytesIntoKeyValueData + 4, valuePadding = 3 - (keyAndValueByteSize + 3) % 4;
        if (keyAndValueByteSize === 0 || keyAndValueByteSize > bytesOfKeyValueData - bytesIntoKeyValueData) {
            console.error("KTXLoader: keyAndValueByteSize out of bounds");
            break;
        }
        let keyNulByte = 0;
        for(; keyNulByte < keyAndValueByteSize && dataView.getUint8(keyAndValueByteOffset + keyNulByte) !== 0; keyNulByte++);
        if (keyNulByte === -1) {
            console.error("KTXLoader: Failed to find null byte terminating kvData key");
            break;
        }
        const key = new TextDecoder().decode(new Uint8Array(dataView.buffer, keyAndValueByteOffset, keyNulByte)), value = new DataView(dataView.buffer, keyAndValueByteOffset + keyNulByte + 1, keyAndValueByteSize - keyNulByte - 1);
        kvData.set(key, value), bytesIntoKeyValueData += 4 + keyAndValueByteSize + valuePadding;
    }
    return kvData;
}





const $2e30c16540495b19$export$20ea358dd867fe3e = {
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).High
    },
    name: "loadDDS",
    test (url) {
        return (0, $fzibG.checkExtension)(url, ".dds");
    },
    async load (url, asset, loader) {
        const arrayBuffer = await (await (0, $16eqM.settings).ADAPTER.fetch(url)).arrayBuffer(), textures = (0, $9d3d2e1a107c7be2$export$cddc4925efe88ac)(arrayBuffer).map((resource)=>{
            const base = new (0, $4oWO8.BaseTexture)(resource, {
                mipmap: (0, $lmRm8.MIPMAP_MODES).OFF,
                alphaMode: (0, $lmRm8.ALPHA_MODES).NO_PREMULTIPLIED_ALPHA,
                resolution: (0, $lFGyw).getResolutionOfUrl(url),
                ...asset.data
            });
            return (0, $8ZIRW.createTexture)(base, loader, url);
        });
        return textures.length === 1 ? textures[0] : textures;
    },
    unload (texture) {
        Array.isArray(texture) ? texture.forEach((t)=>t.destroy(!0)) : texture.destroy(!0);
    }
};
(0, $5RvHb.extensions).add($2e30c16540495b19$export$20ea358dd867fe3e);


parcelRequire("ew1SP");
var $fzibG = parcelRequire("fzibG");
var $8ZIRW = parcelRequire("8ZIRW");
var $h0Gbc = parcelRequire("h0Gbc");
parcelRequire("inflE");
var $lmRm8 = parcelRequire("lmRm8");
var $4oWO8 = parcelRequire("4oWO8");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");


const $b0cbe9b13f3b8229$export$e59f5413434dd0e3 = {
    extension: {
        type: (0, $5RvHb.ExtensionType).LoadParser,
        priority: (0, $h0Gbc.LoaderParserPriority).High
    },
    name: "loadKTX",
    test (url) {
        return (0, $fzibG.checkExtension)(url, ".ktx");
    },
    async load (url, asset, loader) {
        const arrayBuffer = await (await (0, $16eqM.settings).ADAPTER.fetch(url)).arrayBuffer(), { compressed: compressed, uncompressed: uncompressed, kvData: kvData } = (0, $40970c6d4881ef4f$export$58a6abed7fd55190)(url, arrayBuffer), resources = compressed ?? uncompressed, options = {
            mipmap: (0, $lmRm8.MIPMAP_MODES).OFF,
            alphaMode: (0, $lmRm8.ALPHA_MODES).NO_PREMULTIPLIED_ALPHA,
            resolution: (0, $lFGyw).getResolutionOfUrl(url),
            ...asset.data
        }, textures = resources.map((resource)=>{
            resources === uncompressed && Object.assign(options, {
                type: resource.type,
                format: resource.format
            });
            const res = resource.resource ?? resource, base = new (0, $4oWO8.BaseTexture)(res, options);
            return base.ktxKeyValueData = kvData, (0, $8ZIRW.createTexture)(base, loader, url);
        });
        return textures.length === 1 ? textures[0] : textures;
    },
    unload (texture) {
        Array.isArray(texture) ? texture.forEach((t)=>t.destroy(!0)) : texture.destroy(!0);
    }
};
(0, $5RvHb.extensions).add($b0cbe9b13f3b8229$export$e59f5413434dd0e3);


parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");
const $fcae4a18c6a3896e$export$513de45dc484f3ba = {
    extension: (0, $5RvHb.ExtensionType).ResolveParser,
    test: (value)=>{
        const extension = (0, $lFGyw).path.extname(value).slice(1);
        return [
            "basis",
            "ktx",
            "dds"
        ].includes(extension);
    },
    parse: (value)=>{
        const extension = (0, $lFGyw).path.extname(value).slice(1);
        if (extension === "ktx") {
            const extensions2 = [
                ".s3tc.ktx",
                ".s3tc_sRGB.ktx",
                ".etc.ktx",
                ".etc1.ktx",
                ".pvrt.ktx",
                ".atc.ktx",
                ".astc.ktx",
                ".bptc.ktx"
            ];
            if (extensions2.some((ext)=>value.endsWith(ext))) return {
                resolution: parseFloat((0, $16eqM.settings).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: extensions2.find((ext)=>value.endsWith(ext)),
                src: value
            };
        }
        return {
            resolution: parseFloat((0, $16eqM.settings).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: extension,
            src: value
        };
    }
};
(0, $5RvHb.extensions).add($fcae4a18c6a3896e$export$513de45dc484f3ba);
















parcelRequire("inflE");
parcelRequire("gD5uZ");

parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $lmRm8 = parcelRequire("lmRm8");
var $kZOeV = parcelRequire("kZOeV");
var $4UuR4 = parcelRequire("4UuR4");
var $lFGyw = parcelRequire("lFGyw");
const $96f2638534891602$var$TEMP_RECT = new (0, $kZOeV.Rectangle)(), $96f2638534891602$var$BYTES_PER_PIXEL = 4, $96f2638534891602$var$_Extract = class _Extract2 {
    /**
   * @param renderer - A reference to the current renderer
   */ constructor(renderer){
        this.renderer = renderer, this._rendererPremultipliedAlpha = !1;
    }
    contextChange() {
        const attributes = this.renderer?.gl.getContextAttributes();
        this._rendererPremultipliedAlpha = !!(attributes && attributes.alpha && attributes.premultipliedAlpha);
    }
    /**
   * Will return a HTML Image of the target
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - HTML Image of the target
   */ async image(target, format, quality, frame) {
        const image = new Image();
        return image.src = await this.base64(target, format, quality, frame), image;
    }
    /**
   * Will return a base64 encoded string of this target. It works by calling
   *  `Extract.canvas` and then running toDataURL on that.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param format - Image format, e.g. "image/jpeg" or "image/webp".
   * @param quality - JPEG or Webp compression from 0 to 1. Default is 0.92.
   * @param frame - The frame the extraction is restricted to.
   * @returns - A base64 encoded string of the texture.
   */ async base64(target, format, quality, frame) {
        const canvas = this.canvas(target, frame);
        if (canvas.toBlob !== void 0) return new Promise((resolve, reject)=>{
            canvas.toBlob((blob)=>{
                if (!blob) {
                    reject(new Error("ICanvas.toBlob failed!"));
                    return;
                }
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result), reader.onerror = reject, reader.readAsDataURL(blob);
            }, format, quality);
        });
        if (canvas.toDataURL !== void 0) return canvas.toDataURL(format, quality);
        if (canvas.convertToBlob !== void 0) {
            const blob = await canvas.convertToBlob({
                type: format,
                quality: quality
            });
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result), reader.onerror = reject, reader.readAsDataURL(blob);
            });
        }
        throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
    }
    /**
   * Creates a Canvas element, renders this target to it and then returns it.
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - A Canvas element with the texture rendered on.
   */ canvas(target, frame) {
        const { pixels: pixels, width: width, height: height, flipY: flipY, premultipliedAlpha: premultipliedAlpha } = this._rawPixels(target, frame);
        flipY && _Extract2._flipY(pixels, width, height), premultipliedAlpha && _Extract2._unpremultiplyAlpha(pixels);
        const canvasBuffer = new (0, $lFGyw).CanvasRenderTarget(width, height, 1), imageData = new ImageData(new Uint8ClampedArray(pixels.buffer), width, height);
        return canvasBuffer.context.putImageData(imageData, 0, 0), canvasBuffer.canvas;
    }
    /**
   * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
   * order, with integer values between 0 and 255 (included).
   * @param target - A displayObject or renderTexture
   *  to convert. If left empty will use the main renderer
   * @param frame - The frame the extraction is restricted to.
   * @returns - One-dimensional array containing the pixel data of the entire texture
   */ pixels(target, frame) {
        const { pixels: pixels, width: width, height: height, flipY: flipY, premultipliedAlpha: premultipliedAlpha } = this._rawPixels(target, frame);
        return flipY && _Extract2._flipY(pixels, width, height), premultipliedAlpha && _Extract2._unpremultiplyAlpha(pixels), pixels;
    }
    _rawPixels(target, frame) {
        const renderer = this.renderer;
        if (!renderer) throw new Error("The Extract has already been destroyed");
        let resolution, flipY = !1, premultipliedAlpha = !1, renderTexture, generated = !1;
        target && (target instanceof (0, $4UuR4.RenderTexture) ? renderTexture = target : (renderTexture = renderer.generateTexture(target, {
            region: frame,
            resolution: renderer.resolution,
            multisample: renderer.multisample
        }), generated = !0, frame && ($96f2638534891602$var$TEMP_RECT.width = frame.width, $96f2638534891602$var$TEMP_RECT.height = frame.height, frame = $96f2638534891602$var$TEMP_RECT)));
        const gl = renderer.gl;
        if (renderTexture) {
            if (resolution = renderTexture.baseTexture.resolution, frame = frame ?? renderTexture.frame, flipY = !1, premultipliedAlpha = renderTexture.baseTexture.alphaMode > 0 && renderTexture.baseTexture.format === (0, $lmRm8.FORMATS).RGBA, !generated) {
                renderer.renderTexture.bind(renderTexture);
                const fbo = renderTexture.framebuffer.glFramebuffers[renderer.CONTEXT_UID];
                fbo.blitFramebuffer && renderer.framebuffer.bind(fbo.blitFramebuffer);
            }
        } else resolution = renderer.resolution, frame || (frame = $96f2638534891602$var$TEMP_RECT, frame.width = renderer.width / resolution, frame.height = renderer.height / resolution), flipY = !0, premultipliedAlpha = this._rendererPremultipliedAlpha, renderer.renderTexture.bind();
        const width = Math.max(Math.round(frame.width * resolution), 1), height = Math.max(Math.round(frame.height * resolution), 1), pixels = new Uint8Array($96f2638534891602$var$BYTES_PER_PIXEL * width * height);
        return gl.readPixels(Math.round(frame.x * resolution), Math.round(frame.y * resolution), width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels), generated && renderTexture?.destroy(!0), {
            pixels: pixels,
            width: width,
            height: height,
            flipY: flipY,
            premultipliedAlpha: premultipliedAlpha
        };
    }
    /** Destroys the extract. */ destroy() {
        this.renderer = null;
    }
    static _flipY(pixels, width, height) {
        const w = width << 2, h = height >> 1, temp = new Uint8Array(w);
        for(let y = 0; y < h; y++){
            const t = y * w, b = (height - y - 1) * w;
            temp.set(pixels.subarray(t, t + w)), pixels.copyWithin(t, b, b + w), pixels.set(temp, b);
        }
    }
    static _unpremultiplyAlpha(pixels) {
        pixels instanceof Uint8ClampedArray && (pixels = new Uint8Array(pixels.buffer));
        const n = pixels.length;
        for(let i = 0; i < n; i += 4){
            const alpha = pixels[i + 3];
            if (alpha !== 0) {
                const a = 255.001 / alpha;
                pixels[i] = pixels[i] * a + 0.5, pixels[i + 1] = pixels[i + 1] * a + 0.5, pixels[i + 2] = pixels[i + 2] * a + 0.5;
            }
        }
    }
};
$96f2638534891602$var$_Extract.extension = {
    name: "extract",
    type: (0, $5RvHb.ExtensionType).RendererSystem
};
let $96f2638534891602$export$296daa4fd2384194 = $96f2638534891602$var$_Extract;
(0, $5RvHb.extensions).add($96f2638534891602$export$296daa4fd2384194);










parcelRequire("9WNrE");
parcelRequire("2m9sJ");
parcelRequire("4hxmX");
parcelRequire("2oNag");
parcelRequire("inflE");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $cWOCu = parcelRequire("cWOCu");
var $3J55z = parcelRequire("3J55z");
var $iaX63 = parcelRequire("iaX63");
parcelRequire("gD5uZ");
var $3IPo5 = parcelRequire("3IPo5");
parcelRequire("3xGdr");
var $68KVj = parcelRequire("68KVj");
var $5FHOg = parcelRequire("5FHOg");
var $f6HC1 = parcelRequire("f6HC1");
class $b161dc9bc0b15cb6$export$29966907153718d8 {
    /**
   * @param maxItemsPerFrame - The maximum number of items that can be prepared each frame.
   */ constructor(maxItemsPerFrame){
        this.maxItemsPerFrame = maxItemsPerFrame, this.itemsLeft = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ beginFrame() {
        this.itemsLeft = this.maxItemsPerFrame;
    }
    /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @returns If the item is allowed to be uploaded.
   */ allowedToUpload() {
        return this.itemsLeft-- > 0;
    }
}


function $4944834e6b82ba49$var$findMultipleBaseTextures(item, queue) {
    let result = !1;
    if (item?._textures?.length) {
        for(let i = 0; i < item._textures.length; i++)if (item._textures[i] instanceof (0, $cWOCu.Texture)) {
            const baseTexture = item._textures[i].baseTexture;
            queue.includes(baseTexture) || (queue.push(baseTexture), result = !0);
        }
    }
    return result;
}
function $4944834e6b82ba49$var$findBaseTexture(item, queue) {
    if (item.baseTexture instanceof (0, $4oWO8.BaseTexture)) {
        const texture = item.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $4944834e6b82ba49$var$findTexture(item, queue) {
    if (item._texture && item._texture instanceof (0, $cWOCu.Texture)) {
        const texture = item._texture.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $4944834e6b82ba49$var$drawText(_helper, item) {
    return item instanceof (0, $68KVj.Text) ? (item.updateText(!0), !0) : !1;
}
function $4944834e6b82ba49$var$calculateTextStyle(_helper, item) {
    if (item instanceof (0, $f6HC1.TextStyle)) {
        const font = item.toFontString();
        return (0, $5FHOg.TextMetrics).measureFont(font), !0;
    }
    return !1;
}
function $4944834e6b82ba49$var$findText(item, queue) {
    if (item instanceof (0, $68KVj.Text)) {
        queue.includes(item.style) || queue.push(item.style), queue.includes(item) || queue.push(item);
        const texture = item._texture.baseTexture;
        return queue.includes(texture) || queue.push(texture), !0;
    }
    return !1;
}
function $4944834e6b82ba49$var$findTextStyle(item, queue) {
    return item instanceof (0, $f6HC1.TextStyle) ? (queue.includes(item) || queue.push(item), !0) : !1;
}
const $4944834e6b82ba49$var$_BasePrepare = class _BasePrepare2 {
    /**
   * @param {PIXI.IRenderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        this.limiter = new (0, $b161dc9bc0b15cb6$export$29966907153718d8)(_BasePrepare2.uploadsPerFrame), this.renderer = renderer, this.uploadHookHelper = null, this.queue = [], this.addHooks = [], this.uploadHooks = [], this.completes = [], this.ticking = !1, this.delayedTick = ()=>{
            this.queue && this.prepareItems();
        }, this.registerFindHook($4944834e6b82ba49$var$findText), this.registerFindHook($4944834e6b82ba49$var$findTextStyle), this.registerFindHook($4944834e6b82ba49$var$findMultipleBaseTextures), this.registerFindHook($4944834e6b82ba49$var$findBaseTexture), this.registerFindHook($4944834e6b82ba49$var$findTexture), this.registerUploadHook($4944834e6b82ba49$var$drawText), this.registerUploadHook($4944834e6b82ba49$var$calculateTextStyle);
    }
    /**
   * Upload all the textures and graphics to the GPU.
   * @method PIXI.BasePrepare#upload
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} [item] -
   *        Container or display object to search for items to upload or the items to upload themselves,
   *        or optionally ommitted, if items have been added using {@link PIXI.BasePrepare#add `prepare.add`}.
   */ upload(item) {
        return new Promise((resolve)=>{
            item && this.add(item), this.queue.length ? (this.completes.push(resolve), this.ticking || (this.ticking = !0, (0, $3J55z.Ticker).system.addOnce(this.tick, this, (0, $iaX63.UPDATE_PRIORITY).UTILITY))) : resolve();
        });
    }
    /**
   * Handle tick update
   * @private
   */ tick() {
        setTimeout(this.delayedTick, 0);
    }
    /**
   * Actually prepare items. This is handled outside of the tick because it will take a while
   * and we do NOT want to block the current animation frame from rendering.
   * @private
   */ prepareItems() {
        for(this.limiter.beginFrame(); this.queue.length && this.limiter.allowedToUpload();){
            const item = this.queue[0];
            let uploaded = !1;
            if (item && !item._destroyed) {
                for(let i = 0, len = this.uploadHooks.length; i < len; i++)if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                    this.queue.shift(), uploaded = !0;
                    break;
                }
            }
            uploaded || this.queue.shift();
        }
        if (this.queue.length) (0, $3J55z.Ticker).system.addOnce(this.tick, this, (0, $iaX63.UPDATE_PRIORITY).UTILITY);
        else {
            this.ticking = !1;
            const completes = this.completes.slice(0);
            this.completes.length = 0;
            for(let i = 0, len = completes.length; i < len; i++)completes[i]();
        }
    }
    /**
   * Adds hooks for finding items.
   * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
   *          function must return `true` if it was able to add item to the queue.
   * @returns Instance of plugin for chaining.
   */ registerFindHook(addHook) {
        return addHook && this.addHooks.push(addHook), this;
    }
    /**
   * Adds hooks for uploading items.
   * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
   *          function must return `true` if it was able to handle upload of item.
   * @returns Instance of plugin for chaining.
   */ registerUploadHook(uploadHook) {
        return uploadHook && this.uploadHooks.push(uploadHook), this;
    }
    /**
   * Manually add an item to the uploading queue.
   * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
   *        add to the queue
   * @returns Instance of plugin for chaining.
   */ add(item) {
        for(let i = 0, len = this.addHooks.length; i < len && !this.addHooks[i](item, this.queue); i++);
        if (item instanceof (0, $3IPo5.Container)) for(let i = item.children.length - 1; i >= 0; i--)this.add(item.children[i]);
        return this;
    }
    /** Destroys the plugin, don't use after this. */ destroy() {
        this.ticking && (0, $3J55z.Ticker).system.remove(this.tick, this), this.ticking = !1, this.addHooks = null, this.uploadHooks = null, this.renderer = null, this.completes = null, this.queue = null, this.limiter = null, this.uploadHookHelper = null;
    }
};
$4944834e6b82ba49$var$_BasePrepare.uploadsPerFrame = 4;
let $4944834e6b82ba49$export$189fb89547161769 = $4944834e6b82ba49$var$_BasePrepare;


Object.defineProperties((0, $16eqM.settings), {
    /**
   * Default number of uploads per frame using prepare plugin.
   * @static
   * @memberof PIXI.settings
   * @name UPLOADS_PER_FRAME
   * @deprecated since 7.1.0
   * @see PIXI.BasePrepare.uploadsPerFrame
   * @type {number}
   */ UPLOADS_PER_FRAME: {
        get () {
            return (0, $4944834e6b82ba49$export$189fb89547161769).uploadsPerFrame;
        },
        set (value) {
            (0, $lFGyw).deprecation("7.1.0", "settings.UPLOADS_PER_FRAME is deprecated, use prepare.BasePrepare.uploadsPerFrame"), (0, $4944834e6b82ba49$export$189fb89547161769).uploadsPerFrame = value;
        }
    }
});




parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $5RvHb = parcelRequire("5RvHb");
parcelRequire("9WNrE");
var $1FuXs = parcelRequire("1FuXs");

function $579cb64853a88e92$var$uploadBaseTextures(renderer, item) {
    return item instanceof (0, $4oWO8.BaseTexture) ? (item._glTextures[renderer.CONTEXT_UID] || renderer.texture.bind(item), !0) : !1;
}
function $579cb64853a88e92$var$uploadGraphics(renderer, item) {
    if (!(item instanceof (0, $1FuXs.Graphics))) return !1;
    const { geometry: geometry } = item;
    item.finishPoly(), geometry.updateBatches();
    const { batches: batches } = geometry;
    for(let i = 0; i < batches.length; i++){
        const { texture: texture } = batches[i].style;
        texture && $579cb64853a88e92$var$uploadBaseTextures(renderer, texture.baseTexture);
    }
    return geometry.batchable || renderer.geometry.bind(geometry, item._resolveDirectShader(renderer)), !0;
}
function $579cb64853a88e92$var$findGraphics(item, queue) {
    return item instanceof (0, $1FuXs.Graphics) ? (queue.push(item), !0) : !1;
}
class $579cb64853a88e92$export$6475b8f46e7e39d6 extends (0, $4944834e6b82ba49$export$189fb89547161769) {
    /**
   * @param {PIXI.Renderer} renderer - A reference to the current renderer
   */ constructor(renderer){
        super(renderer), this.uploadHookHelper = this.renderer, this.registerFindHook($579cb64853a88e92$var$findGraphics), this.registerUploadHook($579cb64853a88e92$var$uploadBaseTextures), this.registerUploadHook($579cb64853a88e92$var$uploadGraphics);
    }
}
$579cb64853a88e92$export$6475b8f46e7e39d6.extension = {
    name: "prepare",
    type: (0, $5RvHb.ExtensionType).RendererSystem
};
(0, $5RvHb.extensions).add($579cb64853a88e92$export$6475b8f46e7e39d6);


class $d076eb8502ef5e66$export$82e43921ff85c600 {
    /** @param maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame. */ constructor(maxMilliseconds){
        this.maxMilliseconds = maxMilliseconds, this.frameStart = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ beginFrame() {
        this.frameStart = Date.now();
    }
    /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @returns - If the item is allowed to be uploaded.
   */ allowedToUpload() {
        return Date.now() - this.frameStart < this.maxMilliseconds;
    }
}




parcelRequire("jW6UI");
parcelRequire("XZ4uF");
parcelRequire("b6saP");
parcelRequire("inflE");
var $4oWO8 = parcelRequire("4oWO8");
var $kZOeV = parcelRequire("kZOeV");
var $cWOCu = parcelRequire("cWOCu");
var $lFGyw = parcelRequire("lFGyw");
const $97057afd52e3cedd$var$_Spritesheet = class _Spritesheet2 {
    /** @ignore */ constructor(optionsOrTexture, arg1, arg2){
        this.linkedSheets = [], (optionsOrTexture instanceof (0, $4oWO8.BaseTexture) || optionsOrTexture instanceof (0, $cWOCu.Texture)) && (optionsOrTexture = {
            texture: optionsOrTexture,
            data: arg1,
            resolutionFilename: arg2
        });
        const { texture: texture, data: data, resolutionFilename: resolutionFilename = null, cachePrefix: cachePrefix = "" } = optionsOrTexture;
        this.cachePrefix = cachePrefix, this._texture = texture instanceof (0, $cWOCu.Texture) ? texture : null, this.baseTexture = texture instanceof (0, $4oWO8.BaseTexture) ? texture : this._texture.baseTexture, this.textures = {}, this.animations = {}, this.data = data;
        const resource = this.baseTexture.resource;
        this.resolution = this._updateResolution(resolutionFilename || (resource ? resource.url : null)), this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
    }
    /**
   * Generate the resolution from the filename or fallback
   * to the meta.scale field of the JSON data.
   * @param resolutionFilename - The filename to use for resolving
   *        the default resolution.
   * @returns Resolution to use for spritesheet.
   */ _updateResolution(resolutionFilename = null) {
        const { scale: scale } = this.data.meta;
        let resolution = (0, $lFGyw).getResolutionOfUrl(resolutionFilename, null);
        return resolution === null && (resolution = typeof scale == "number" ? scale : parseFloat(scale ?? "1")), resolution !== 1 && this.baseTexture.setResolution(resolution), resolution;
    }
    /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   * @method PIXI.Spritesheet#parse
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve, this._batchIndex = 0, this._frameKeys.length <= _Spritesheet2.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
        });
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */ _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = _Spritesheet2.BATCH_SIZE;
        for(; frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length;){
            const i = this._frameKeys[frameIndex], data = this._frames[i], rect = data.frame;
            if (rect) {
                let frame = null, trim = null;
                const sourceSize = data.trimmed !== !1 && data.sourceSize ? data.sourceSize : data.frame, orig = new (0, $kZOeV.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                data.rotated ? frame = new (0, $kZOeV.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution) : frame = new (0, $kZOeV.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution), data.trimmed !== !1 && data.spriteSourceSize && (trim = new (0, $kZOeV.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution)), this.textures[i] = new (0, $cWOCu.Texture)(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor, data.borders), (0, $cWOCu.Texture).addToCache(this.textures[i], this.cachePrefix + i.toString());
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null, this._batchIndex = 0, callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet2.BATCH_SIZE), this._batchIndex++, setTimeout(()=>{
            this._batchIndex * _Spritesheet2.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = !1) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, destroyBase && (this._texture?.destroy(), this.baseTexture.destroy()), this._texture = null, this.baseTexture = null, this.linkedSheets = [];
    }
};
$97057afd52e3cedd$var$_Spritesheet.BATCH_SIZE = 1e3;
let $97057afd52e3cedd$export$674d2eb4debbef0c = $97057afd52e3cedd$var$_Spritesheet;


parcelRequire("ew1SP");
var $6i6zf = parcelRequire("6i6zf");
var $h0Gbc = parcelRequire("h0Gbc");
parcelRequire("inflE");
var $5RvHb = parcelRequire("5RvHb");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");

const $d8b4dd1dcb929507$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp"
];
function $d8b4dd1dcb929507$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    if (keys.forEach((key)=>{
        out[key] = asset;
    }), Object.keys(asset.textures).forEach((key)=>{
        out[`${asset.cachePrefix}${key}`] = asset.textures[key];
    }), !ignoreMultiPack) {
        const basePath = (0, $lFGyw).path.dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            Object.assign(out, $d8b4dd1dcb929507$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, !0));
        });
    }
    return out;
}
const $d8b4dd1dcb929507$export$46dcda4f1cdd80fe = {
    extension: (0, $5RvHb.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $97057afd52e3cedd$export$674d2eb4debbef0c),
        getCacheableAssets: (keys, asset)=>$d8b4dd1dcb929507$var$getCacheableAssets(keys, asset, !1)
    },
    /** Resolve the the resolution of the asset. */ resolver: {
        test: (value)=>{
            const split = value.split("?")[0].split("."), extension = split.pop(), format = split.pop();
            return extension === "json" && $d8b4dd1dcb929507$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $16eqM.settings).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into PIXI.Spritesheet
   * All textures in the sprite sheet are then added to the cache
   * @ignore
   */ loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $5RvHb.ExtensionType).LoadParser,
            priority: (0, $h0Gbc.LoaderParserPriority).Normal
        },
        async testParse (asset, options) {
            return (0, $lFGyw).path.extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename, cachePrefix: // if user need to use custom filename (not from jsonFile.meta.image)
            cachePrefix } = options?.data ?? {};
            let basePath = (0, $lFGyw).path.dirname(options.src);
            basePath && basePath.lastIndexOf("/") !== basePath.length - 1 && (basePath += "/");
            let texture;
            if (imageTexture && imageTexture.baseTexture) texture = imageTexture;
            else {
                const imagePath = (0, $6i6zf.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                texture = (await loader.load([
                    imagePath
                ]))[imagePath];
            }
            const spritesheet = new (0, $97057afd52e3cedd$export$674d2eb4debbef0c)({
                texture: texture.baseTexture,
                data: asset,
                resolutionFilename: options.src,
                cachePrefix: cachePrefix
            });
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item != "string") continue;
                    let itemUrl = basePath + item;
                    options.data?.ignoreMultiPack || (itemUrl = (0, $6i6zf.copySearchParams)(itemUrl, options.src), promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            ignoreMultiPack: !0
                        }
                    })));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res, res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        unload (spritesheet) {
            spritesheet.destroy(!0);
        }
    }
};
(0, $5RvHb.extensions).add($d8b4dd1dcb929507$export$46dcda4f1cdd80fe);




parcelRequire("3xGdr");
parcelRequire("6x1UU");
parcelRequire("inflE");
var $kZOeV = parcelRequire("kZOeV");
var $16eqM = parcelRequire("16eqM");
var $cWOCu = parcelRequire("cWOCu");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("jW6UI");
var $3uiak = parcelRequire("3uiak");
parcelRequire("3xGdr");
var $f6HC1 = parcelRequire("f6HC1");
parcelRequire("inflE");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");
parcelRequire("3xGdr");
var $f6HC1 = parcelRequire("f6HC1");
const $22c9c55821653bbc$var$_HTMLTextStyle = class _HTMLTextStyle2 extends (0, $f6HC1.TextStyle) {
    constructor(){
        super(...arguments), this._fonts = [], this._overrides = [], this._stylesheet = "", this.fontsDirty = !1;
    }
    /**
   * Convert a TextStyle to HTMLTextStyle
   * @param originalStyle
   * @example
   * import {TextStyle } from 'pixi.js';
   * import {HTMLTextStyle} from '@pixi/text-html';
   * const style = new TextStyle();
   * const htmlStyle = HTMLTextStyle.from(style);
   */ static from(originalStyle) {
        return new _HTMLTextStyle2(Object.keys(_HTMLTextStyle2.defaultOptions).reduce((obj, prop)=>({
                ...obj,
                [prop]: originalStyle[prop]
            }), {}));
    }
    /** Clear the current font */ cleanFonts() {
        this._fonts.length > 0 && (this._fonts.forEach((font)=>{
            URL.revokeObjectURL(font.src), font.refs--, font.refs === 0 && (font.fontFace && document.fonts.delete(font.fontFace), delete _HTMLTextStyle2.availableFonts[font.originalUrl]);
        }), this.fontFamily = "Arial", this._fonts.length = 0, this.styleID++, this.fontsDirty = !0);
    }
    /**
   * Because of how HTMLText renders, fonts need to be imported
   * @param url
   * @param options
   */ loadFont(url, options = {}) {
        const { availableFonts: availableFonts } = _HTMLTextStyle2;
        if (availableFonts[url]) {
            const font = availableFonts[url];
            return this._fonts.push(font), font.refs++, this.styleID++, this.fontsDirty = !0, Promise.resolve();
        }
        return (0, $16eqM.settings).ADAPTER.fetch(url).then((response)=>response.blob()).then(async (blob)=>new Promise((resolve, reject)=>{
                const src = URL.createObjectURL(blob), reader = new FileReader();
                reader.onload = ()=>resolve([
                        src,
                        reader.result
                    ]), reader.onerror = reject, reader.readAsDataURL(blob);
            })).then(async ([src, dataSrc])=>{
            const font = Object.assign({
                family: (0, $lFGyw).path.basename(url, (0, $lFGyw).path.extname(url)),
                weight: "normal",
                style: "normal",
                display: "auto",
                src: src,
                dataSrc: dataSrc,
                refs: 1,
                originalUrl: url,
                fontFace: null
            }, options);
            availableFonts[url] = font, this._fonts.push(font), this.styleID++;
            const fontFace = new FontFace(font.family, `url(${font.src})`, {
                weight: font.weight,
                style: font.style,
                display: font.display
            });
            font.fontFace = fontFace, await fontFace.load(), document.fonts.add(fontFace), await document.fonts.ready, this.styleID++, this.fontsDirty = !0;
        });
    }
    /**
   * Add a style override, this can be any CSS property
   * it will override any built-in style. This is the
   * property and the value as a string (e.g., `color: red`).
   * This will override any other internal style.
   * @param {string} value - CSS style(s) to add.
   * @example
   * style.addOverride('background-color: red');
   */ addOverride(...value) {
        const toAdd = value.filter((v)=>!this._overrides.includes(v));
        toAdd.length > 0 && (this._overrides.push(...toAdd), this.styleID++);
    }
    /**
   * Remove any overrides that match the value.
   * @param {string} value - CSS style to remove.
   * @example
   * style.removeOverride('background-color: red');
   */ removeOverride(...value) {
        const toRemove = value.filter((v)=>this._overrides.includes(v));
        toRemove.length > 0 && (this._overrides = this._overrides.filter((v)=>!toRemove.includes(v)), this.styleID++);
    }
    /**
   * Internally converts all of the style properties into CSS equivalents.
   * @param scale
   * @returns The CSS style string, for setting `style` property of root HTMLElement.
   */ toCSS(scale) {
        return [
            `transform: scale(${scale})`,
            "transform-origin: top left",
            "display: inline-block",
            `color: ${this.normalizeColor(this.fill)}`,
            `font-size: ${this.fontSize}px`,
            `font-family: ${this.fontFamily}`,
            `font-weight: ${this.fontWeight}`,
            `font-style: ${this.fontStyle}`,
            `font-variant: ${this.fontVariant}`,
            `letter-spacing: ${this.letterSpacing}px`,
            `text-align: ${this.align}`,
            `padding: ${this.padding}px`,
            `white-space: ${this.whiteSpace}`,
            ...this.lineHeight ? [
                `line-height: ${this.lineHeight}px`
            ] : [],
            ...this.wordWrap ? [
                `word-wrap: ${this.breakWords ? "break-all" : "break-word"}`,
                `max-width: ${this.wordWrapWidth}px`
            ] : [],
            ...this.strokeThickness ? [
                `-webkit-text-stroke-width: ${this.strokeThickness}px`,
                `-webkit-text-stroke-color: ${this.normalizeColor(this.stroke)}`,
                `text-stroke-width: ${this.strokeThickness}px`,
                `text-stroke-color: ${this.normalizeColor(this.stroke)}`,
                "paint-order: stroke"
            ] : [],
            ...this.dropShadow ? [
                this.dropShadowToCSS()
            ] : [],
            ...this._overrides
        ].join(";");
    }
    /** Get the font CSS styles from the loaded font, If available. */ toGlobalCSS() {
        return this._fonts.reduce((result, font)=>`${result}
            @font-face {
                font-family: "${font.family}";
                src: url('${font.dataSrc}');
                font-weight: ${font.weight};
                font-style: ${font.style};
                font-display: ${font.display};
            }`, this._stylesheet);
    }
    /** Internal stylesheet contents, useful for creating rules for rendering */ get stylesheet() {
        return this._stylesheet;
    }
    set stylesheet(value) {
        this._stylesheet !== value && (this._stylesheet = value, this.styleID++);
    }
    /**
   * Convert numerical colors into hex-strings
   * @param color
   */ normalizeColor(color) {
        return Array.isArray(color) && (color = (0, $lFGyw).rgb2hex(color)), typeof color == "number" ? (0, $lFGyw).hex2string(color) : color;
    }
    /** Convert the internal drop-shadow settings to CSS text-shadow */ dropShadowToCSS() {
        let color = this.normalizeColor(this.dropShadowColor);
        const alpha = this.dropShadowAlpha, x = Math.round(Math.cos(this.dropShadowAngle) * this.dropShadowDistance), y = Math.round(Math.sin(this.dropShadowAngle) * this.dropShadowDistance);
        color.startsWith("#") && alpha < 1 && (color += (alpha * 255 | 0).toString(16).padStart(2, "0"));
        const position = `${x}px ${y}px`;
        return this.dropShadowBlur > 0 ? `text-shadow: ${position} ${this.dropShadowBlur}px ${color}` : `text-shadow: ${position} ${color}`;
    }
    /** Resets all properties to the defaults specified in TextStyle.prototype._default */ reset() {
        Object.assign(this, _HTMLTextStyle2.defaultOptions);
    }
    /**
   * Called after the image is loaded but before drawing to the canvas.
   * Mostly used to handle Safari's font loading bug.
   * @ignore
   */ onBeforeDraw() {
        const { fontsDirty: prevFontsDirty } = this;
        return this.fontsDirty = !1, this.isSafari && this._fonts.length > 0 && prevFontsDirty ? new Promise((resolve)=>setTimeout(resolve, 100)) : Promise.resolve();
    }
    /**
   * Proving that Safari is the new IE
   * @ignore
   */ get isSafari() {
        const { userAgent: userAgent } = (0, $16eqM.settings).ADAPTER.getNavigator();
        return /^((?!chrome|android).)*safari/i.test(userAgent);
    }
    set fillGradientStops(_value) {
        console.warn("[HTMLTextStyle] fillGradientStops is not supported by HTMLText");
    }
    get fillGradientStops() {
        return super.fillGradientStops;
    }
    set fillGradientType(_value) {
        console.warn("[HTMLTextStyle] fillGradientType is not supported by HTMLText");
    }
    get fillGradientType() {
        return super.fillGradientType;
    }
    set miterLimit(_value) {
        console.warn("[HTMLTextStyle] miterLimit is not supported by HTMLText");
    }
    get miterLimit() {
        return super.miterLimit;
    }
    set trim(_value) {
        console.warn("[HTMLTextStyle] trim is not supported by HTMLText");
    }
    get trim() {
        return super.trim;
    }
    set textBaseline(_value) {
        console.warn("[HTMLTextStyle] textBaseline is not supported by HTMLText");
    }
    get textBaseline() {
        return super.textBaseline;
    }
    set leading(_value) {
        console.warn("[HTMLTextStyle] leading is not supported by HTMLText");
    }
    get leading() {
        return super.leading;
    }
    set lineJoin(_value) {
        console.warn("[HTMLTextStyle] lineJoin is not supported by HTMLText");
    }
    get lineJoin() {
        return super.lineJoin;
    }
};
$22c9c55821653bbc$var$_HTMLTextStyle.availableFonts = {}, /**
* List of default options, these are largely the same as TextStyle,
* with the exception of whiteSpace, which is set to 'normal' by default.
*/ $22c9c55821653bbc$var$_HTMLTextStyle.defaultOptions = {
    /** Align */ align: "left",
    /** Break words */ breakWords: !1,
    /** Drop shadow */ dropShadow: !1,
    /** Drop shadow alpha */ dropShadowAlpha: 1,
    /**
   * Drop shadow angle
   * @type {number}
   * @default Math.PI / 6
   */ dropShadowAngle: Math.PI / 6,
    /** Drop shadow blur */ dropShadowBlur: 0,
    /** Drop shadow color */ dropShadowColor: "black",
    /** Drop shadow distance */ dropShadowDistance: 5,
    /** Fill */ fill: "black",
    /** Font family */ fontFamily: "Arial",
    /** Font size */ fontSize: 26,
    /** Font style */ fontStyle: "normal",
    /** Font variant */ fontVariant: "normal",
    /** Font weight */ fontWeight: "normal",
    /** Letter spacing */ letterSpacing: 0,
    /** Line height */ lineHeight: 0,
    /** Padding */ padding: 0,
    /** Stroke */ stroke: "black",
    /** Stroke thickness */ strokeThickness: 0,
    /** White space */ whiteSpace: "normal",
    /** Word wrap */ wordWrap: !1,
    /** Word wrap width */ wordWrapWidth: 100
};
let $22c9c55821653bbc$export$a2664b42ece43c6c = $22c9c55821653bbc$var$_HTMLTextStyle;


const $cbb5421a0d904a7e$var$_HTMLText = class _HTMLText2 extends (0, $3uiak.Sprite) {
    /**
   * @param {string} [text] - Text contents
   * @param {PIXI.HTMLTextStyle|PIXI.TextStyle|PIXI.ITextStyle} [style] - Style setting to use.
   *        Strongly recommend using an HTMLTextStyle object. Providing a PIXI.TextStyle
   *        will convert the TextStyle to an HTMLTextStyle and will no longer be linked.
   */ constructor(text = "", style = {}){
        super((0, $cWOCu.Texture).EMPTY), this._text = null, this._style = null, this._autoResolution = !0, this.localStyleID = -1, this.dirty = !1, this._updateID = 0, this.ownsStyle = !1;
        const image = new Image(), texture = (0, $cWOCu.Texture).from(image, {
            scaleMode: (0, $16eqM.settings).SCALE_MODE,
            resourceOptions: {
                autoLoad: !1
            }
        });
        texture.orig = new (0, $kZOeV.Rectangle)(), texture.trim = new (0, $kZOeV.Rectangle)(), this.texture = texture;
        const nssvg = "http://www.w3.org/2000/svg", nsxhtml = "http://www.w3.org/1999/xhtml", svgRoot = document.createElementNS(nssvg, "svg"), foreignObject = document.createElementNS(nssvg, "foreignObject"), domElement = document.createElementNS(nsxhtml, "div"), styleElement = document.createElementNS(nsxhtml, "style");
        foreignObject.setAttribute("width", "10000"), foreignObject.setAttribute("height", "10000"), foreignObject.style.overflow = "hidden", svgRoot.appendChild(foreignObject), this.maxWidth = _HTMLText2.defaultMaxWidth, this.maxHeight = _HTMLText2.defaultMaxHeight, this._domElement = domElement, this._styleElement = styleElement, this._svgRoot = svgRoot, this._foreignObject = foreignObject, this._foreignObject.appendChild(styleElement), this._foreignObject.appendChild(domElement), this._image = image, this._loadImage = new Image(), this._autoResolution = _HTMLText2.defaultAutoResolution, this._resolution = _HTMLText2.defaultResolution ?? (0, $16eqM.settings).RESOLUTION, this.text = text, this.style = style;
    }
    /**
   * Calculate the size of the output text without actually drawing it.
   * This includes the `padding` in the `style` object.
   * This can be used as a fast-pass to do things like text-fitting.
   * @param {object} [overrides] - Overrides for the text, style, and resolution.
   * @param {string} [overrides.text] - The text to measure, if not specified, the current text is used.
   * @param {PIXI.HTMLTextStyle} [overrides.style] - The style to measure, if not specified, the current style is used.
   * @param {number} [overrides.resolution] - The resolution to measure, if not specified, the current resolution is used.
   * @returns {PIXI.ISize} Width and height of the measured text.
   */ measureText(overrides) {
        const { text: text, style: style, resolution: resolution } = Object.assign({
            text: this._text,
            style: this._style,
            resolution: this._resolution
        }, overrides);
        Object.assign(this._domElement, {
            innerHTML: text,
            style: style.toCSS(resolution)
        }), this._styleElement.textContent = style.toGlobalCSS(), document.body.appendChild(this._svgRoot);
        const contentBounds = this._domElement.getBoundingClientRect();
        this._svgRoot.remove();
        const { width: width, height: height } = contentBounds;
        (width > this.maxWidth || height > this.maxHeight) && console.warn("[HTMLText] Large expanse of text, increase HTMLText.maxWidth or HTMLText.maxHeight property.");
        const contentWidth = Math.min(this.maxWidth, Math.ceil(width)), contentHeight = Math.min(this.maxHeight, Math.ceil(height));
        return this._svgRoot.setAttribute("width", contentWidth.toString()), this._svgRoot.setAttribute("height", contentHeight.toString()), text !== this._text && (this._domElement.innerHTML = this._text), style !== this._style && (Object.assign(this._domElement, {
            style: this._style?.toCSS(resolution)
        }), this._styleElement.textContent = this._style?.toGlobalCSS()), {
            width: contentWidth + style.padding * 2,
            height: contentHeight + style.padding * 2
        };
    }
    /**
   * Manually refresh the text.
   * @public
   * @param {boolean} respectDirty - Whether to abort updating the
   *        text if the Text isn't dirty and the function is called.
   */ async updateText(respectDirty = !0) {
        const { style: style, _image: image, _loadImage: loadImage } = this;
        if (this.localStyleID !== style.styleID && (this.dirty = !0, this.localStyleID = style.styleID), !this.dirty && respectDirty) return;
        const { width: width, height: height } = this.measureText();
        image.width = loadImage.width = Math.ceil(Math.max(1, width)), image.height = loadImage.height = Math.ceil(Math.max(1, height)), this._updateID++;
        const updateID = this._updateID;
        await new Promise((resolve)=>{
            loadImage.onload = async ()=>{
                if (updateID < this._updateID) {
                    resolve();
                    return;
                }
                await style.onBeforeDraw(), image.src = loadImage.src, loadImage.onload = null, loadImage.src = "", this.updateTexture(), resolve();
            };
            const svgURL = new XMLSerializer().serializeToString(this._svgRoot);
            loadImage.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(svgURL)}`;
        });
    }
    /** The raw image element that is rendered under-the-hood. */ get source() {
        return this._image;
    }
    /**
   * Update the texture resource.
   * @private
   */ updateTexture() {
        const { style: style, texture: texture, _image: image, resolution: resolution } = this, { padding: padding } = style, { baseTexture: baseTexture } = texture;
        texture.trim.width = texture._frame.width = image.width / resolution, texture.trim.height = texture._frame.height = image.height / resolution, texture.trim.x = -padding, texture.trim.y = -padding, texture.orig.width = texture._frame.width - padding * 2, texture.orig.height = texture._frame.height - padding * 2, this._onTextureUpdate(), baseTexture.setRealSize(image.width, image.height, resolution), this.dirty = !1;
    }
    /**
   * Renders the object using the WebGL renderer
   * @param {PIXI.Renderer} renderer - The renderer
   * @private
   */ _render(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._render(renderer);
    }
    /**
   * Renders the object using the Canvas Renderer.
   * @private
   * @param {PIXI.CanvasRenderer} renderer - The renderer
   */ _renderCanvas(renderer) {
        this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), super._renderCanvas(renderer);
    }
    /**
   * Get the local bounds.
   * @param {PIXI.Rectangle} rect - Input rectangle.
   * @returns {PIXI.Rectangle} Local bounds
   */ getLocalBounds(rect) {
        return this.updateText(!0), super.getLocalBounds(rect);
    }
    _calculateBounds() {
        this.updateText(!0), this.calculateVertices(), this._bounds.addQuad(this.vertexData);
    }
    /**
   * Handle dirty style changes
   * @private
   */ _onStyleChange() {
        this.dirty = !0;
    }
    /**
   * Destroy this Text object. Don't use after calling.
   * @param {boolean|object} options - Same as Sprite destroy options.
   */ destroy(options) {
        typeof options == "boolean" && (options = {
            children: options
        }), options = Object.assign({}, _HTMLText2.defaultDestroyOptions, options), super.destroy(options);
        const forceClear = null;
        this.ownsStyle && this._style?.cleanFonts(), this._style = forceClear, this._svgRoot?.remove(), this._svgRoot = forceClear, this._domElement?.remove(), this._domElement = forceClear, this._foreignObject?.remove(), this._foreignObject = forceClear, this._styleElement?.remove(), this._styleElement = forceClear, this._loadImage.src = "", this._loadImage.onload = null, this._loadImage = forceClear, this._image.src = "", this._image = forceClear;
    }
    /**
   * Get the width in pixels.
   * @member {number}
   */ get width() {
        return this.updateText(!0), Math.abs(this.scale.x) * this._image.width / this.resolution;
    }
    set width(value) {
        this.updateText(!0);
        const s = (0, $lFGyw).sign(this.scale.x) || 1;
        this.scale.x = s * value / this._image.width / this.resolution, this._width = value;
    }
    /**
   * Get the height in pixels.
   * @member {number}
   */ get height() {
        return this.updateText(!0), Math.abs(this.scale.y) * this._image.height / this.resolution;
    }
    set height(value) {
        this.updateText(!0);
        const s = (0, $lFGyw).sign(this.scale.y) || 1;
        this.scale.y = s * value / this._image.height / this.resolution, this._height = value;
    }
    /** The base style to render with text. */ get style() {
        return this._style;
    }
    set style(style) {
        this._style !== style && (style = style || {}, style instanceof (0, $22c9c55821653bbc$export$a2664b42ece43c6c) ? (this.ownsStyle = !1, this._style = style) : style instanceof (0, $f6HC1.TextStyle) ? (console.warn("[HTMLText] Cloning TextStyle, if this is not what you want, use HTMLTextStyle"), this.ownsStyle = !0, this._style = (0, $22c9c55821653bbc$export$a2664b42ece43c6c).from(style)) : (this.ownsStyle = !0, this._style = new (0, $22c9c55821653bbc$export$a2664b42ece43c6c)(style)), this.localStyleID = -1, this.dirty = !0);
    }
    /**
   * Contents of text. This can be HTML text and include tags.
   * @example
   * const text = new HTMLText('This is a <em>styled</em> text!');
   * @member {string}
   */ get text() {
        return this._text;
    }
    set text(text) {
        text = String(text === "" || text === null || text === void 0 ? " " : text), text = this.sanitiseText(text), this._text !== text && (this._text = text, this.dirty = !0);
    }
    /**
   * The resolution / device pixel ratio of the canvas.
   * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
   * @member {number}
   * @default 1
   */ get resolution() {
        return this._resolution;
    }
    set resolution(value) {
        this._autoResolution = !1, this._resolution !== value && (this._resolution = value, this.dirty = !0);
    }
    /**
   * Sanitise text - replace `<br>` with `<br/>`, `&nbsp;` with `&#160;`
   * @param text
   * @see https://www.sitepoint.com/community/t/xhtml-1-0-transitional-xml-parsing-error-entity-nbsp-not-defined/3392/3
   */ sanitiseText(text) {
        return text.replace(/<br>/gi, "<br/>").replace(/<hr>/gi, "<hr/>").replace(/&nbsp;/gi, "&#160;");
    }
};
$cbb5421a0d904a7e$var$_HTMLText.defaultDestroyOptions = {
    texture: !0,
    children: !1,
    baseTexture: !0
}, /** Default maxWidth, set at construction */ $cbb5421a0d904a7e$var$_HTMLText.defaultMaxWidth = 2024, /** Default maxHeight, set at construction */ $cbb5421a0d904a7e$var$_HTMLText.defaultMaxHeight = 2024, /** Default autoResolution for all HTMLText objects */ $cbb5421a0d904a7e$var$_HTMLText.defaultAutoResolution = !0;
let $cbb5421a0d904a7e$export$4b42bbc5a42896a1 = $cbb5421a0d904a7e$var$_HTMLText;







var $lmRm8 = parcelRequire("lmRm8");
var $3IPo5 = parcelRequire("3IPo5");
var $1FuXs = parcelRequire("1FuXs");
var $khIUA = parcelRequire("khIUA");
var $6wJoy = parcelRequire("6wJoy");
var $4UuR4 = parcelRequire("4UuR4");
var $3uiak = parcelRequire("3uiak");
var $f6HC1 = parcelRequire("f6HC1");
var $cWOCu = parcelRequire("cWOCu");
var $91bc9451ada945a4$exports = {};
/* eslint-disable global-require */ 
$91bc9451ada945a4$exports = (parcelRequire("aLuzK"));


/*!
 * @pixi/filter-pixelate - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-pixelate is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ parcelRequire("inflE");
var $3x7iq = parcelRequire("3x7iq");
var $fcfe2b721c82698e$var$e = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $fcfe2b721c82698e$var$n = `precision mediump float;

varying vec2 vTextureCoord;

uniform vec2 size;
uniform sampler2D uSampler;

uniform vec4 filterArea;

vec2 mapCoord( vec2 coord )
{
    coord *= filterArea.xy;
    coord += filterArea.zw;

    return coord;
}

vec2 unmapCoord( vec2 coord )
{
    coord -= filterArea.zw;
    coord /= filterArea.xy;

    return coord;
}

vec2 pixelate(vec2 coord, vec2 size)
{
	return floor( coord / size ) * size;
}

void main(void)
{
    vec2 coord = mapCoord(vTextureCoord);

    coord = pixelate(coord, size);

    coord = unmapCoord(coord);

    gl_FragColor = texture2D(uSampler, coord);
}
`;
class $fcfe2b721c82698e$export$8ec99043c41c044 extends (0, $3x7iq.Filter) {
    constructor(r = 10){
        super($fcfe2b721c82698e$var$e, $fcfe2b721c82698e$var$n), this.size = r;
    }
    get size() {
        return this.uniforms.size;
    }
    set size(r) {
        typeof r == "number" && (r = [
            r,
            r
        ]), this.uniforms.size = r;
    }
}


var $40b0ed8255973f00$exports = {};
/*! crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $40b0ed8255973f00$var$CRC32;
(function(factory) {
    /*jshint ignore:start */ /*eslint-disable */ if (typeof DO_NOT_EXPORT_CRC === 'undefined') factory($40b0ed8255973f00$exports);
    else factory($40b0ed8255973f00$var$CRC32 = {});
/*eslint-enable */ /*jshint ignore:end */ })(function(CRC32) {
    CRC32.version = '1.2.2';
    /*global Int32Array */ function signed_crc_table() {
        var c = 0, table = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr, seed) {
        var C = seed ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B, seed) {
        var C = seed ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str, seed) {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    // $FlowIgnore
    CRC32.bstr = crc32_bstr;
    // $FlowIgnore
    CRC32.buf = crc32_buf;
    // $FlowIgnore
    CRC32.str = crc32_str;
});


function $516ef8e471c65448$export$61fcd4753fbb6425(data) {
    if (!$516ef8e471c65448$var$isPng(data)) return undefined;
    let offset = 8;
    while(offset < data.byteLength){
        const chunk = $516ef8e471c65448$var$readChunk(data, offset);
        if (chunk === undefined) return undefined;
        console.log(chunk);
        offset = chunk.end;
    }
}
function $516ef8e471c65448$export$f790c636e73721c6(data) {
    if (!$516ef8e471c65448$var$isPng(data)) return undefined;
    let offset = 8;
    while(offset < data.byteLength){
        const chunk = $516ef8e471c65448$var$readChunk(data, offset);
        if (chunk === undefined) return undefined;
        if (chunk.type === "pHYs") {
            const phys = $516ef8e471c65448$var$parsePhysChunk(chunk.data);
            if (phys === undefined) return undefined;
            if (phys.unit !== "metre") return undefined;
            return {
                x: Math.round(phys.x / 39.3701),
                y: Math.round(phys.y / 39.3701)
            };
        }
        offset = chunk.end;
    }
    return undefined;
}
function $516ef8e471c65448$export$bba19d6e26274f9e(data, dpi) {
    if (!$516ef8e471c65448$var$isPng(data)) return data;
    let offset = 8;
    let ihdrChunk = undefined;
    let physChunk = undefined;
    while(offset < data.byteLength){
        const chunk = $516ef8e471c65448$var$readChunk(data, offset);
        if (chunk === undefined) return data;
        if (chunk.type === "IHDR") ihdrChunk = chunk;
        if (chunk.type === "pHYs") {
            physChunk = chunk;
            break;
        }
        offset = chunk.end;
    }
    const newPhysChunk = $516ef8e471c65448$var$createPhysChunk(Math.round(dpi.x * 39.3701), Math.round(dpi.y * 39.3701), "metre");
    if (physChunk !== undefined) {
        const head = data.slice(0, physChunk.start);
        const tail = data.slice(physChunk.end);
        return $516ef8e471c65448$var$concat(head, newPhysChunk, tail);
    }
    if (ihdrChunk === undefined) // IHDR chunk is required
    return data;
    const head = data.slice(0, ihdrChunk.end);
    const tail = data.slice(ihdrChunk.end);
    return $516ef8e471c65448$var$concat(head, newPhysChunk, tail);
}
function $516ef8e471c65448$var$isPng(data) {
    // https://www.w3.org/TR/2003/REC-PNG-20031110/#5PNG-file-signature
    const array = new Uint8Array(data);
    return array[0] === 137 && array[1] === 80 && array[2] === 78 && array[3] === 71 && array[4] === 13 && array[5] === 10 && array[6] === 26 && array[7] === 10;
}
function $516ef8e471c65448$var$readChunk(data, offset) {
    // https://www.w3.org/TR/2003/REC-PNG-20031110/#5Chunk-layout
    const length = new DataView(data).getUint32(offset);
    const type = $516ef8e471c65448$var$parseChunkType(data.slice(offset + 4, offset + 8));
    if (type === undefined) return undefined;
    const chunkData = data.slice(offset + 8, offset + 8 + length);
    return {
        type: type,
        data: chunkData,
        start: offset,
        end: offset + 12 + length
    };
}
function $516ef8e471c65448$var$parseChunkType(data) {
    const array = new Uint8Array(data);
    if (array.length !== 4 || !array.every((it)=>it >= 65 && it <= 90 || it >= 97 && it <= 122)) return undefined;
    return String.fromCharCode(...array);
}
function $516ef8e471c65448$var$parsePhysChunk(data) {
    const array = new Uint8Array(data);
    if (array.length !== 9) return undefined;
    return {
        x: new DataView(data).getUint32(0),
        y: new DataView(data).getUint32(4),
        unit: array[8] === 1 ? "metre" : undefined
    };
}
function $516ef8e471c65448$var$createPhysChunk(x, y, unit) {
    const array = new Uint8Array(21);
    const view = new DataView(array.buffer);
    view.setUint32(0, 9);
    array[4] = 112;
    array[5] = 72;
    array[6] = 89;
    array[7] = 115;
    view.setUint32(8, x);
    view.setUint32(12, y);
    array[16] = unit === "metre" ? 1 : 0;
    view.setUint32(17, $40b0ed8255973f00$exports.buf(array.subarray(4, 17)));
    return array.buffer;
}
function $516ef8e471c65448$var$concat(...buffers) {
    const length = buffers.reduce((acc, it)=>acc + it.byteLength, 0);
    const array = new Uint8Array(length);
    let offset = 0;
    for (const buf of buffers){
        array.set(new Uint8Array(buf), offset);
        offset += buf.byteLength;
    }
    return array.buffer;
}



var $5FHOg = parcelRequire("5FHOg");
var $f6HC1 = parcelRequire("f6HC1");
const $18d6f960c772a57f$var$ratio = {
    xxs: 1 / 1.4 ** 3,
    xs: 1 / 1.4 ** 2,
    s: 1 / 1.4,
    m: 1,
    l: 1.4,
    xl: 1.4 ** 2,
    xxl: 1.4 ** 3
};
function $18d6f960c772a57f$export$eeb6b3a559cdc0d9(x, size) {
    return x * $18d6f960c772a57f$var$ratio[size];
}


function $c555d3b6b65c69d0$export$9dfc1b5378126f88(style, pos) {
    return {
        type: "text",
        kind: "drawing",
        style: style,
        text: "",
        align: "left",
        x: pos.x,
        y: pos.y
    };
}
function $c555d3b6b65c69d0$export$4f82176fd240be1e(ink, pos) {
    return {
        ...ink,
        width: pos.x - ink.x
    };
}
function $c555d3b6b65c69d0$export$1a1628e41e592a64(ink) {
    if (ink.text === "") return undefined;
    const normalized = $c555d3b6b65c69d0$var$normalize(ink);
    return {
        ...normalized,
        width: normalized.width !== undefined && normalized.width < 10 ? undefined : normalized.width
    };
}
function $c555d3b6b65c69d0$export$1c955e5aed284a35(ink) {
    const metrics = $c555d3b6b65c69d0$export$fef6eeb5bd6c2897(ink);
    return {
        x: ink.x,
        y: ink.y,
        width: ink.width ?? metrics.width,
        height: metrics.height
    };
}
function $c555d3b6b65c69d0$export$8ed02be6902f15a4(ink, offset) {
    return {
        ...ink,
        x: ink.x + offset.deltaX,
        y: ink.y + offset.deltaY
    };
}
function $c555d3b6b65c69d0$export$f585374aef3acb00(ink, offset) {
    const matrix = $c555d3b6b65c69d0$export$fef6eeb5bd6c2897(ink);
    return $c555d3b6b65c69d0$var$normalize({
        ...ink,
        width: (ink.width ?? matrix.width) + offset.deltaX
    });
}
function $c555d3b6b65c69d0$export$d201aaa29f1979b5(ink, offset) {
    const matrix = $c555d3b6b65c69d0$export$fef6eeb5bd6c2897(ink);
    return $c555d3b6b65c69d0$var$normalize({
        ...ink,
        x: ink.x + offset.deltaX,
        width: (ink.width ?? matrix.width) - offset.deltaX
    });
}
function $c555d3b6b65c69d0$var$normalize(ink) {
    if (ink.width !== undefined && ink.width < 0) return {
        ...ink,
        x: ink.x + ink.width,
        width: Math.abs(ink.width)
    };
    return ink;
}
// 本来は Pixi 側で管理すべきだけど textStyleForPixi に書いたのと同じ理由でここに書かざるを得ない
const $c555d3b6b65c69d0$var$fontSizes = 32;
function $c555d3b6b65c69d0$export$c6cdea5e4523850d(ink) {
    const fontSize = (0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($c555d3b6b65c69d0$var$fontSizes, ink.style.size);
    return new (0, $f6HC1.TextStyle)({
        fontFamily: [
            "Noto Sans",
            "sans-serif"
        ],
        fontSize: fontSize,
        fontWeight: "bold",
        lineHeight: fontSize,
        align: ink.align,
        stroke: 0xffffff,
        strokeThickness: fontSize / 4,
        padding: fontSize,
        dropShadow: true,
        dropShadowAlpha: 0.2,
        dropShadowBlur: 10,
        dropShadowDistance: 0,
        lineJoin: "round",
        wordWrap: ink.width !== undefined,
        wordWrapWidth: ink.width !== undefined ? Math.abs(ink.width) : undefined,
        breakWords: ink.width !== undefined
    });
}
function $c555d3b6b65c69d0$export$fef6eeb5bd6c2897(ink) {
    return (0, $5FHOg.TextMetrics).measureText(ink.text, $c555d3b6b65c69d0$export$c6cdea5e4523850d(ink));
}


function $189e06d909ce30c1$export$38f006db0a1c0a54(pos1, pos2) {
    return {
        x: Math.min(pos1.x, pos2.x),
        y: Math.min(pos1.y, pos2.y),
        width: Math.abs(pos2.x - pos1.x),
        height: Math.abs(pos2.y - pos1.y)
    };
}
function $189e06d909ce30c1$export$e1942d4b7c93f2ed(box) {
    return {
        x: Math.min(box.x, box.x + box.width),
        y: Math.min(box.y, box.y + box.height),
        width: Math.abs(box.width),
        height: Math.abs(box.height)
    };
}
function $189e06d909ce30c1$export$b4a1b9f3ac8e743a(box, offset, keepRatio = false) {
    const normalized = $189e06d909ce30c1$export$e1942d4b7c93f2ed(box);
    const newBox = {
        x: normalized.x + offset.deltaX,
        y: normalized.y + offset.deltaY,
        width: normalized.width - offset.deltaX,
        height: normalized.height - offset.deltaY
    };
    if (keepRatio) {
        const ratio = normalized.width / normalized.height;
        const newRatio = Math.abs(newBox.width / newBox.height);
        if (newRatio > ratio) {
            const newHeight = Math.abs(newBox.width) / ratio * Math.sign(newBox.height);
            newBox.y = newBox.y + (newBox.height - newHeight);
            newBox.height = newHeight;
        } else {
            const newWidth = Math.abs(newBox.height) * ratio * Math.sign(newBox.width);
            newBox.x = newBox.x + newBox.width - newWidth;
            newBox.width = newWidth;
        }
    }
    return newBox;
}
function $189e06d909ce30c1$export$6418a6aa616e5736(box, offset, keepRatio = false) {
    const normalized = $189e06d909ce30c1$export$e1942d4b7c93f2ed(box);
    const newBox = {
        x: normalized.x,
        y: normalized.y + offset.deltaY,
        width: normalized.width + offset.deltaX,
        height: normalized.height - offset.deltaY
    };
    if (keepRatio) {
        const ratio = normalized.width / normalized.height;
        const newRatio = Math.abs(newBox.width / newBox.height);
        if (newRatio > ratio) {
            const newHeight = Math.abs(newBox.width) / ratio * Math.sign(newBox.height);
            newBox.y = newBox.y + (newBox.height - newHeight);
            newBox.height = newHeight;
        } else newBox.width = Math.abs(newBox.height) * ratio * Math.sign(newBox.width);
    }
    return newBox;
}
function $189e06d909ce30c1$export$7f18ffd57ddd7712(box, offset, keepRatio = false) {
    const normalized = $189e06d909ce30c1$export$e1942d4b7c93f2ed(box);
    const newBox = {
        x: normalized.x,
        y: normalized.y,
        width: normalized.width + offset.deltaX,
        height: normalized.height + offset.deltaY
    };
    if (keepRatio) {
        const ratio = normalized.width / normalized.height;
        const newRatio = Math.abs(newBox.width / newBox.height);
        if (newRatio > ratio) newBox.height = Math.abs(newBox.width) / ratio * Math.sign(newBox.height);
        else newBox.width = Math.abs(newBox.height) * ratio * Math.sign(newBox.width);
    }
    return newBox;
}
function $189e06d909ce30c1$export$35cc5799fed2ec5d(box, offset, keepRatio = false) {
    const normalized = $189e06d909ce30c1$export$e1942d4b7c93f2ed(box);
    const newBox = {
        x: normalized.x + offset.deltaX,
        y: normalized.y,
        width: normalized.width - offset.deltaX,
        height: normalized.height + offset.deltaY
    };
    if (keepRatio) {
        const ratio = normalized.width / normalized.height;
        const newRatio = Math.abs(newBox.width / newBox.height);
        if (newRatio > ratio) newBox.height = Math.abs(newBox.width) / ratio * Math.sign(newBox.height);
        else {
            const newWidth = Math.abs(newBox.height) * ratio * Math.sign(newBox.width);
            newBox.x = newBox.x + (newBox.width - newWidth);
            newBox.width = newWidth;
        }
    }
    return newBox;
}
function $189e06d909ce30c1$export$51b01ef1c2fcf9da(box, offset) {
    const normalized = $189e06d909ce30c1$export$e1942d4b7c93f2ed(box);
    return {
        x: normalized.x,
        y: normalized.y + offset.deltaY,
        width: normalized.width,
        height: normalized.height - offset.deltaY
    };
}
function $189e06d909ce30c1$export$cec0905c18e2ea27(box, offset) {
    const normalized = $189e06d909ce30c1$export$e1942d4b7c93f2ed(box);
    return {
        x: normalized.x,
        y: normalized.y,
        width: normalized.width + offset.deltaX,
        height: normalized.height
    };
}
function $189e06d909ce30c1$export$4c176a8e4692afe8(box, offset) {
    const normalized = $189e06d909ce30c1$export$e1942d4b7c93f2ed(box);
    return {
        x: normalized.x,
        y: normalized.y,
        width: normalized.width,
        height: normalized.height + offset.deltaY
    };
}
function $189e06d909ce30c1$export$a790604461e199b1(box, offset) {
    const normalized = $189e06d909ce30c1$export$e1942d4b7c93f2ed(box);
    return {
        x: normalized.x + offset.deltaX,
        y: normalized.y,
        width: normalized.width - offset.deltaX,
        height: normalized.height
    };
}
function $189e06d909ce30c1$export$b6ce2f0a0062931d(box) {
    return box.width === 0 && box.height === 0;
}
function $189e06d909ce30c1$export$c961dc362da894e1(box1, box2) {
    return box1.x < box2.x + box2.width && box2.x < box1.x + box1.width && box1.y < box2.y + box2.height && box2.y < box1.y + box1.height;
}
function $189e06d909ce30c1$export$88e2d5deb5dd5467(pos1, pos2) {
    return {
        viewportX: Math.min(pos1.viewportX, pos2.viewportX),
        viewportY: Math.min(pos1.viewportY, pos2.viewportY),
        viewportWidth: Math.abs(pos2.viewportX - pos1.viewportX),
        viewportHeight: Math.abs(pos2.viewportY - pos1.viewportY)
    };
}
function $189e06d909ce30c1$export$8bac34977fac9c96(box) {
    return {
        viewportX: Math.min(box.viewportX, box.viewportX + box.viewportWidth),
        viewportY: Math.min(box.viewportY, box.viewportY + box.viewportHeight),
        viewportWidth: Math.abs(box.viewportWidth),
        viewportHeight: Math.abs(box.viewportHeight)
    };
}
function $189e06d909ce30c1$export$979103305a6a55a0(box, pan, zoom) {
    return {
        viewportX: (box.x - pan.deltaX) * zoom,
        viewportY: (box.y - pan.deltaY) * zoom,
        viewportWidth: box.width * zoom,
        viewportHeight: box.height * zoom
    };
}
function $189e06d909ce30c1$export$9b14637080ce9a85(box, pan, zoom) {
    return {
        x: box.viewportX / zoom + pan.deltaX,
        y: box.viewportY / zoom + pan.deltaY,
        width: box.viewportWidth / zoom,
        height: box.viewportHeight / zoom
    };
}
function $189e06d909ce30c1$export$914b8cfe4ecdb4ea(box, origin) {
    return {
        x: origin.x + box.localX,
        y: origin.y + box.localY,
        width: box.width,
        height: box.height
    };
}


function $80dcf17a2beee8f0$export$89bca424b24dda89(style, pos) {
    return {
        type: "rect",
        kind: "drawing",
        style: style,
        x: pos.x,
        y: pos.y,
        width: 0,
        height: 0
    };
}
function $80dcf17a2beee8f0$export$fc98bfcaecc32011(ink, pos) {
    return {
        ...ink,
        x: ink.x,
        y: ink.y,
        width: pos.x - ink.x,
        height: pos.y - ink.y
    };
}
function $80dcf17a2beee8f0$export$1995826abd613bee(ink) {
    if (ink.width === 0 && ink.height === 0) return undefined;
    return ink;
}
function $80dcf17a2beee8f0$export$b673993d4f1a6576(ink) {
    return {
        x: ink.x,
        y: ink.y,
        width: ink.width,
        height: ink.height
    };
}
function $80dcf17a2beee8f0$export$f5829602e41ca4d6(ink, offset) {
    return {
        ...ink,
        x: ink.x + offset.deltaX,
        y: ink.y + offset.deltaY
    };
}
function $80dcf17a2beee8f0$export$975e17ec41bb5e0c(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$b4a1b9f3ac8e743a)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $80dcf17a2beee8f0$export$9f38204495ba8bd8(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$6418a6aa616e5736)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $80dcf17a2beee8f0$export$91ca2d2f98318195(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$7f18ffd57ddd7712)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $80dcf17a2beee8f0$export$4948a210352679f1(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$35cc5799fed2ec5d)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $80dcf17a2beee8f0$export$f93b3ee0f49492f6(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$51b01ef1c2fcf9da)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $80dcf17a2beee8f0$export$fcdbee1caa981465(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$cec0905c18e2ea27)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $80dcf17a2beee8f0$export$9cf01ce061f2bbd7(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$4c176a8e4692afe8)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $80dcf17a2beee8f0$export$367ff58ac29d6775(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$a790604461e199b1)(ink, offset);
    return {
        ...ink,
        ...box
    };
}


function $c68e5267cadbcc45$export$cbadc5a7223772a8(x) {
    throw new Error("Unexpected object: " + x);
}



function $ebf28d92b6229f56$export$d2ff61685afcdd8d(pos, png) {
    const width = png.bitmap.width / png.density;
    const height = png.bitmap.height / png.density;
    return {
        type: "image",
        kind: "image",
        bitmap: png.bitmap,
        density: png.density,
        x: pos.x - width / 2,
        y: pos.y - height / 2,
        width: width,
        height: height
    };
}
function $ebf28d92b6229f56$export$2897821d30fb9667(ink, pos) {
    return {
        ...ink,
        x: pos.x - ink.width / 2,
        y: pos.y - ink.height / 2
    };
}
function $ebf28d92b6229f56$export$ca4a7157dbffaf01(ink) {
    return ink;
}
function $ebf28d92b6229f56$export$5902d77a329d6ce3(ink) {
    return {
        x: ink.x,
        y: ink.y,
        width: ink.width,
        height: ink.height
    };
}
function $ebf28d92b6229f56$export$1f655a7536a8049f(ink, offset) {
    return {
        ...ink,
        x: ink.x + offset.deltaX,
        y: ink.y + offset.deltaY
    };
}
function $ebf28d92b6229f56$export$87195ecc5d4af4bd(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$b4a1b9f3ac8e743a)(ink, offset, true);
    return {
        ...ink,
        ...box
    };
}
function $ebf28d92b6229f56$export$fe1c5a42c9d838ec(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$6418a6aa616e5736)(ink, offset, true);
    return {
        ...ink,
        ...box
    };
}
function $ebf28d92b6229f56$export$5542862c5d63062d(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$7f18ffd57ddd7712)(ink, offset, true);
    return {
        ...ink,
        ...box
    };
}
function $ebf28d92b6229f56$export$f05fd951a2c6cb41(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$35cc5799fed2ec5d)(ink, offset, true);
    return {
        ...ink,
        ...box
    };
}



function $f5a06b5bcdfe432f$export$7457b6b8bf482fe5(size, pos) {
    return {
        type: "blur",
        kind: "filter",
        size: size,
        x: pos.x,
        y: pos.y,
        width: 0,
        height: 0
    };
}
function $f5a06b5bcdfe432f$export$3ef6ad0742d7dd48(ink, pos) {
    return {
        ...ink,
        width: pos.x - ink.x,
        height: pos.y - ink.y
    };
}
function $f5a06b5bcdfe432f$export$fd4c273ef3c5f898(ink) {
    return ink;
}
function $f5a06b5bcdfe432f$export$ad0eb2b5873ac293(ink) {
    return {
        x: ink.x,
        y: ink.y,
        width: ink.width,
        height: ink.height
    };
}
function $f5a06b5bcdfe432f$export$ef7db43b1956576b(ink, offset) {
    return {
        ...ink,
        x: ink.x + offset.deltaX,
        y: ink.y + offset.deltaY
    };
}
function $f5a06b5bcdfe432f$export$9d62931ffa1ccee(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$b4a1b9f3ac8e743a)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $f5a06b5bcdfe432f$export$74fe098fa9e05854(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$6418a6aa616e5736)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $f5a06b5bcdfe432f$export$67722def53ce0035(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$7f18ffd57ddd7712)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $f5a06b5bcdfe432f$export$ab1792ea5b9e4ae2(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$35cc5799fed2ec5d)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $f5a06b5bcdfe432f$export$e8c13e484bd53c82(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$51b01ef1c2fcf9da)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $f5a06b5bcdfe432f$export$a1b250cbf2e0a633(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$cec0905c18e2ea27)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $f5a06b5bcdfe432f$export$35759e8a112b8755(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$4c176a8e4692afe8)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $f5a06b5bcdfe432f$export$b5682991096303c(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$a790604461e199b1)(ink, offset);
    return {
        ...ink,
        ...box
    };
}




function $8071ceaf67484368$export$a39d6cf92ab7f89e(size, pos) {
    return {
        type: "pixelate",
        kind: "filter",
        size: size,
        x: pos.x,
        y: pos.y,
        width: 0,
        height: 0
    };
}
function $8071ceaf67484368$export$1d341a756bbbc864(ink, pos) {
    return {
        ...ink,
        width: pos.x - ink.x,
        height: pos.y - ink.y
    };
}
function $8071ceaf67484368$export$3320ec2f8699da89(ink) {
    return ink;
}
function $8071ceaf67484368$export$1a4dc51a53d60bf1(ink) {
    return {
        x: ink.x,
        y: ink.y,
        width: ink.width,
        height: ink.height
    };
}
function $8071ceaf67484368$export$251553127513d8f7(ink, offset) {
    return {
        ...ink,
        x: ink.x + offset.deltaX,
        y: ink.y + offset.deltaY
    };
}
function $8071ceaf67484368$export$38e8be81ef723df3(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$b4a1b9f3ac8e743a)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $8071ceaf67484368$export$bef44d630a61e521(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$6418a6aa616e5736)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $8071ceaf67484368$export$97c4f6dd04bc4a69(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$7f18ffd57ddd7712)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $8071ceaf67484368$export$e7a74b46cf5cd44c(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$35cc5799fed2ec5d)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $8071ceaf67484368$export$dcafbeaa63c2ac27(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$51b01ef1c2fcf9da)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $8071ceaf67484368$export$7cb5362de47d5d9f(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$cec0905c18e2ea27)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $8071ceaf67484368$export$7bc2ff4821620609(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$4c176a8e4692afe8)(ink, offset);
    return {
        ...ink,
        ...box
    };
}
function $8071ceaf67484368$export$9d306a8e57f45060(ink, offset) {
    const box = (0, $189e06d909ce30c1$export$a790604461e199b1)(ink, offset);
    return {
        ...ink,
        ...box
    };
}


function $490a55307ea505bd$export$49a851a6b4d84ded(pos, offset) {
    return {
        x: pos.x + offset.deltaX,
        y: pos.y + offset.deltaY
    };
}
function $490a55307ea505bd$export$bde7edbee85c023b(pos, pan, zoom) {
    return {
        viewportX: (pos.x - pan.deltaX) * zoom,
        viewportY: (pos.y - pan.deltaY) * zoom
    };
}
function $490a55307ea505bd$export$a6663a2df30dcc74(pos, pan, zoom) {
    return {
        x: pos.viewportX / zoom + pan.deltaX,
        y: pos.viewportY / zoom + pan.deltaY
    };
}


function $b82449888acec1e3$export$76a7ee6cceec72d5(style, pos) {
    return {
        type: "pen",
        kind: "drawing",
        style: style,
        points: [
            pos
        ]
    };
}
function $b82449888acec1e3$export$a5164086c8f24576(ink, pos) {
    return {
        ...ink,
        points: [
            ...ink.points,
            pos
        ]
    };
}
function $b82449888acec1e3$export$6038c6f10656916(ink) {
    return ink;
// return { ...ink, points: douglasPeucker(ink.points) };
}
function $b82449888acec1e3$var$douglasPeucker(points, epsilon = 0) {
    if (points.length === 2) return points;
    let dmax = 0;
    let index = 0;
    for(let i = 1; i < points.length - 1; i++){
        const d = $b82449888acec1e3$var$perpendicularDistance(points[0], points[points.length - 1], points[i]);
        if (d > dmax) {
            index = i;
            dmax = d;
        }
    }
    if (dmax <= epsilon) return [
        points[0],
        points[points.length - 1]
    ];
    return [
        ...$b82449888acec1e3$var$douglasPeucker(points.slice(0, index), epsilon),
        ...$b82449888acec1e3$var$douglasPeucker(points.slice(index + 1), epsilon).slice(1)
    ];
}
function $b82449888acec1e3$var$perpendicularDistance(start, end, point) {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    return Math.abs(dy * point.x - dx * point.y + end.x * start.y - end.y * start.x) / Math.sqrt(dx * dx + dy * dy);
}
function $b82449888acec1e3$export$2e4d925d07cbfdc(ink) {
    const [start, ...rest] = ink.points;
    if (start === undefined) return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };
    let minX = start.x;
    let minY = start.y;
    let maxX = start.x;
    let maxY = start.y;
    for (const point of rest){
        minX = Math.min(minX, point.x);
        minY = Math.min(minY, point.y);
        maxX = Math.max(maxX, point.x);
        maxY = Math.max(maxY, point.y);
    }
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $b82449888acec1e3$export$15b53ad6ca23609b(ink, offset) {
    return {
        ...ink,
        points: ink.points.map((it)=>(0, $490a55307ea505bd$export$49a851a6b4d84ded)(it, offset))
    };
}




function $b2b9a792bd78c26f$export$4164adcc87af1c6f(style, pos) {
    return {
        type: "arrow",
        kind: "drawing",
        style: style,
        from: pos,
        to: pos
    };
}
function $b2b9a792bd78c26f$export$c163a812a562ba37(ink, pos) {
    return {
        ...ink,
        to: pos
    };
}
function $b2b9a792bd78c26f$export$777bf51118118ec1(ink) {
    return ink;
}
function $b2b9a792bd78c26f$export$9fe85f8270a5de02(ink) {
    return (0, $189e06d909ce30c1$export$38f006db0a1c0a54)(ink.from, ink.to);
}
function $b2b9a792bd78c26f$export$bbbf82b849b74097(ink, offset) {
    return {
        ...ink,
        from: (0, $490a55307ea505bd$export$49a851a6b4d84ded)(ink.from, offset),
        to: (0, $490a55307ea505bd$export$49a851a6b4d84ded)(ink.to, offset)
    };
}
function $b2b9a792bd78c26f$export$f84bfdd9ff03c447(ink, offset) {
    return {
        ...ink,
        from: (0, $490a55307ea505bd$export$49a851a6b4d84ded)(ink.from, offset)
    };
}
function $b2b9a792bd78c26f$export$d711ae35cab56ac9(ink, offset) {
    return {
        ...ink,
        to: (0, $490a55307ea505bd$export$49a851a6b4d84ded)(ink.to, offset)
    };
}




const $882d0e345520754a$export$fc3abcb6606c9723 = 20;
function $882d0e345520754a$export$8a0c16f7c77de2ce(style, pos) {
    return {
        type: "number",
        kind: "drawing",
        style: style,
        pos: pos,
        ts: Date.now()
    };
}
function $882d0e345520754a$export$3ab33eb15abf843e(ink, pos) {
    return {
        ...ink,
        pos: pos
    };
}
function $882d0e345520754a$export$ded90268ee80d499(ink) {
    return ink;
}
function $882d0e345520754a$export$a14c785fbd1074d5(ink) {
    const size = (0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($882d0e345520754a$export$fc3abcb6606c9723, ink.style.size) * 1.6;
    return {
        x: ink.pos.x - size / 2,
        y: ink.pos.y - size / 2,
        width: size,
        height: size
    };
}
function $882d0e345520754a$export$2267ba54903b182c(ink, offset) {
    return {
        ...ink,
        pos: (0, $490a55307ea505bd$export$49a851a6b4d84ded)(ink.pos, offset)
    };
}



function $b22dcebef2fd1cbb$export$748b35fcbc6e3ec9(size, pos) {
    return {
        type: "redact",
        kind: "filter",
        size: size,
        x: pos.x,
        y: pos.y,
        width: 0,
        height: 0
    };
}
function $b22dcebef2fd1cbb$export$5b88481ab0fb14fe(ink, pos) {
    return {
        ...ink,
        width: pos.x - ink.x,
        height: pos.y - ink.y
    };
}
function $b22dcebef2fd1cbb$export$97b6fe02d39e6872(ink) {
    return ink;
}
function $b22dcebef2fd1cbb$export$1ae33028c4757e58(ink) {
    return {
        x: ink.x,
        y: ink.y,
        width: ink.width,
        height: ink.height
    };
}
function $b22dcebef2fd1cbb$export$2e0431b329122c16(ink, offset) {
    return {
        ...ink,
        x: ink.x + offset.deltaX,
        y: ink.y + offset.deltaY
    };
}
function $b22dcebef2fd1cbb$export$eb4f7537c9825084(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$b4a1b9f3ac8e743a)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $b22dcebef2fd1cbb$export$f1a7cad759b4da4d(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$6418a6aa616e5736)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $b22dcebef2fd1cbb$export$a952def1cabdb7da(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$7f18ffd57ddd7712)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $b22dcebef2fd1cbb$export$5221f3fb0c6f5f19(ink, offset, keepRatio) {
    const box = (0, $189e06d909ce30c1$export$35cc5799fed2ec5d)(ink, offset, keepRatio);
    return {
        ...ink,
        ...box
    };
}
function $b22dcebef2fd1cbb$export$b74ebbce02349990(ink, offset) {
    return {
        ...ink,
        y: ink.y + offset.deltaY,
        height: ink.height - offset.deltaY
    };
}
function $b22dcebef2fd1cbb$export$2fd327c6682504fb(ink, offset) {
    return {
        ...ink,
        width: ink.width + offset.deltaX
    };
}
function $b22dcebef2fd1cbb$export$744f1c78affeae80(ink, offset) {
    return {
        ...ink,
        height: ink.height + offset.deltaY
    };
}
function $b22dcebef2fd1cbb$export$4493d1b52d442dc2(ink, offset) {
    return {
        ...ink,
        x: ink.x + offset.deltaX,
        width: ink.width - offset.deltaX
    };
}


function $1345f3e3159b23e9$export$52239b0468db5694(ink, color) {
    if (ink.kind === "drawing") return {
        ...ink,
        style: {
            ...ink.style,
            color: color
        }
    };
    return ink;
}
function $1345f3e3159b23e9$export$216a43761424912e(ink, size) {
    if (ink.kind === "drawing") return {
        ...ink,
        style: {
            ...ink.style,
            size: size
        }
    };
    if (ink.kind === "filter") return {
        ...ink,
        size: size
    };
    return ink;
}
function $1345f3e3159b23e9$export$f0e3f80f78769eaf(tool, style, pos) {
    if (tool === "rect") return (0, $80dcf17a2beee8f0$export$89bca424b24dda89)(style, pos);
    if (tool === "blur") return (0, $f5a06b5bcdfe432f$export$7457b6b8bf482fe5)(style.size, pos);
    if (tool === "text") return (0, $c555d3b6b65c69d0$export$9dfc1b5378126f88)(style, pos);
    if (tool === "pixelate") return (0, $8071ceaf67484368$export$a39d6cf92ab7f89e)(style.size, pos);
    if (tool === "pen") return (0, $b82449888acec1e3$export$76a7ee6cceec72d5)(style, pos);
    if (tool === "arrow") return (0, $b2b9a792bd78c26f$export$4164adcc87af1c6f)(style, pos);
    if (tool === "number") return (0, $882d0e345520754a$export$8a0c16f7c77de2ce)(style, pos);
    if (tool === "redact") return (0, $b22dcebef2fd1cbb$export$748b35fcbc6e3ec9)(style.size, pos);
    (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(tool);
}
function $1345f3e3159b23e9$export$9cf47addb252f0c3(ink, pos) {
    if (ink.type === "rect") return (0, $80dcf17a2beee8f0$export$fc98bfcaecc32011)(ink, pos);
    if (ink.type === "image") return (0, $ebf28d92b6229f56$export$2897821d30fb9667)(ink, pos);
    if (ink.type === "blur") return (0, $f5a06b5bcdfe432f$export$3ef6ad0742d7dd48)(ink, pos);
    if (ink.type === "text") return (0, $c555d3b6b65c69d0$export$4f82176fd240be1e)(ink, pos);
    if (ink.type === "pixelate") return (0, $8071ceaf67484368$export$1d341a756bbbc864)(ink, pos);
    if (ink.type === "pen") return (0, $b82449888acec1e3$export$a5164086c8f24576)(ink, pos);
    if (ink.type === "arrow") return (0, $b2b9a792bd78c26f$export$c163a812a562ba37)(ink, pos);
    if (ink.type === "number") return (0, $882d0e345520754a$export$3ab33eb15abf843e)(ink, pos);
    if (ink.type === "redact") return (0, $b22dcebef2fd1cbb$export$5b88481ab0fb14fe)(ink, pos);
    (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(ink);
}
function $1345f3e3159b23e9$export$d82b1c8b01edf336(ink) {
    if (ink.type === "rect") return (0, $80dcf17a2beee8f0$export$1995826abd613bee)(ink);
    if (ink.type === "image") return (0, $ebf28d92b6229f56$export$ca4a7157dbffaf01)(ink);
    if (ink.type === "blur") return (0, $f5a06b5bcdfe432f$export$fd4c273ef3c5f898)(ink);
    if (ink.type === "text") return (0, $c555d3b6b65c69d0$export$1a1628e41e592a64)(ink);
    if (ink.type === "pixelate") return (0, $8071ceaf67484368$export$3320ec2f8699da89)(ink);
    if (ink.type === "pen") return (0, $b82449888acec1e3$export$6038c6f10656916)(ink);
    if (ink.type === "arrow") return (0, $b2b9a792bd78c26f$export$777bf51118118ec1)(ink);
    if (ink.type === "number") return (0, $882d0e345520754a$export$ded90268ee80d499)(ink);
    if (ink.type === "redact") return (0, $b22dcebef2fd1cbb$export$97b6fe02d39e6872)(ink);
    (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(ink);
}
function $1345f3e3159b23e9$export$4bb6209356900d5e(ink) {
    if (ink.type === "rect") return (0, $80dcf17a2beee8f0$export$b673993d4f1a6576)(ink);
    if (ink.type === "image") return (0, $ebf28d92b6229f56$export$5902d77a329d6ce3)(ink);
    if (ink.type === "blur") return (0, $f5a06b5bcdfe432f$export$ad0eb2b5873ac293)(ink);
    if (ink.type === "text") return (0, $c555d3b6b65c69d0$export$1c955e5aed284a35)(ink);
    if (ink.type === "pixelate") return (0, $8071ceaf67484368$export$1a4dc51a53d60bf1)(ink);
    if (ink.type === "pen") return (0, $b82449888acec1e3$export$2e4d925d07cbfdc)(ink);
    if (ink.type === "arrow") return (0, $b2b9a792bd78c26f$export$9fe85f8270a5de02)(ink);
    if (ink.type === "number") return (0, $882d0e345520754a$export$a14c785fbd1074d5)(ink);
    if (ink.type === "redact") return (0, $b22dcebef2fd1cbb$export$1ae33028c4757e58)(ink);
    (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(ink);
}
function $1345f3e3159b23e9$export$191039ca16d612e5(ink, offset) {
    if (ink.type === "rect") return (0, $80dcf17a2beee8f0$export$f5829602e41ca4d6)(ink, offset);
    if (ink.type === "image") return (0, $ebf28d92b6229f56$export$1f655a7536a8049f)(ink, offset);
    if (ink.type === "blur") return (0, $f5a06b5bcdfe432f$export$ef7db43b1956576b)(ink, offset);
    if (ink.type === "text") return (0, $c555d3b6b65c69d0$export$8ed02be6902f15a4)(ink, offset);
    if (ink.type === "pixelate") return (0, $8071ceaf67484368$export$251553127513d8f7)(ink, offset);
    if (ink.type === "pen") return (0, $b82449888acec1e3$export$15b53ad6ca23609b)(ink, offset);
    if (ink.type === "arrow") return (0, $b2b9a792bd78c26f$export$bbbf82b849b74097)(ink, offset);
    if (ink.type === "number") return (0, $882d0e345520754a$export$2267ba54903b182c)(ink, offset);
    if (ink.type === "redact") return (0, $b22dcebef2fd1cbb$export$2e0431b329122c16)(ink, offset);
    (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(ink);
}



/*!
 * @pixi/filter-drop-shadow - v5.2.0
 * Compiled Tue, 28 Feb 2023 14:24:35 UTC
 *
 * @pixi/filter-drop-shadow is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /*!
 * @pixi/filter-kawase-blur - v5.1.1
 * Compiled Wed, 11 Jan 2023 23:10:33 UTC
 *
 * @pixi/filter-kawase-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ parcelRequire("inflE");
var $3x7iq = parcelRequire("3x7iq");
var $gnwPx = parcelRequire("gnwPx");
var $950238d694024b6e$var$c = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $950238d694024b6e$var$v = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform vec2 uOffset;

void main(void)
{
    vec4 color = vec4(0.0);

    // Sample top left pixel
    color += texture2D(uSampler, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y));

    // Sample top right pixel
    color += texture2D(uSampler, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y));

    // Sample bottom right pixel
    color += texture2D(uSampler, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y));

    // Sample bottom left pixel
    color += texture2D(uSampler, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y));

    // Average
    color *= 0.25;

    gl_FragColor = color;
}`, $950238d694024b6e$var$y = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform vec2 uOffset;
uniform vec4 filterClamp;

void main(void)
{
    vec4 color = vec4(0.0);

    // Sample top left pixel
    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y), filterClamp.xy, filterClamp.zw));

    // Sample top right pixel
    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y), filterClamp.xy, filterClamp.zw));

    // Sample bottom right pixel
    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y), filterClamp.xy, filterClamp.zw));

    // Sample bottom left pixel
    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y), filterClamp.xy, filterClamp.zw));

    // Average
    color *= 0.25;

    gl_FragColor = color;
}
`;
class $950238d694024b6e$export$31164edf0fb20199 extends (0, $3x7iq.Filter) {
    constructor(e = 4, t = 3, i = !1){
        super($950238d694024b6e$var$c, i ? $950238d694024b6e$var$y : $950238d694024b6e$var$v), this._kernels = [], this._blur = 4, this._quality = 3, this.uniforms.uOffset = new Float32Array(2), this._pixelSize = new (0, $gnwPx.Point), this.pixelSize = 1, this._clamp = i, Array.isArray(e) ? this.kernels = e : (this._blur = e, this.quality = t);
    }
    apply(e, t, i, o) {
        const n = this._pixelSize.x / t._frame.width, l = this._pixelSize.y / t._frame.height;
        let r;
        if (this._quality === 1 || this._blur === 0) r = this._kernels[0] + .5, this.uniforms.uOffset[0] = r * n, this.uniforms.uOffset[1] = r * l, e.applyFilter(this, t, i, o);
        else {
            const x = e.getFilterTexture();
            let s = t, u = x, f;
            const p = this._quality - 1;
            for(let a = 0; a < p; a++)r = this._kernels[a] + .5, this.uniforms.uOffset[0] = r * n, this.uniforms.uOffset[1] = r * l, e.applyFilter(this, s, u, 1), f = s, s = u, u = f;
            r = this._kernels[p] + .5, this.uniforms.uOffset[0] = r * n, this.uniforms.uOffset[1] = r * l, e.applyFilter(this, s, i, o), e.returnFilterTexture(x);
        }
    }
    _updatePadding() {
        this.padding = Math.ceil(this._kernels.reduce((e, t)=>e + t + .5, 0));
    }
    _generateKernels() {
        const e = this._blur, t = this._quality, i = [
            e
        ];
        if (e > 0) {
            let o = e;
            const n = e / t;
            for(let l = 1; l < t; l++)o -= n, i.push(o);
        }
        this._kernels = i, this._updatePadding();
    }
    get kernels() {
        return this._kernels;
    }
    set kernels(e) {
        Array.isArray(e) && e.length > 0 ? (this._kernels = e, this._quality = e.length, this._blur = Math.max(...e)) : (this._kernels = [
            0
        ], this._quality = 1);
    }
    get clamp() {
        return this._clamp;
    }
    set pixelSize(e) {
        typeof e == "number" ? (this._pixelSize.x = e, this._pixelSize.y = e) : Array.isArray(e) ? (this._pixelSize.x = e[0], this._pixelSize.y = e[1]) : e instanceof (0, $gnwPx.Point) ? (this._pixelSize.x = e.x, this._pixelSize.y = e.y) : (this._pixelSize.x = 1, this._pixelSize.y = 1);
    }
    get pixelSize() {
        return this._pixelSize;
    }
    get quality() {
        return this._quality;
    }
    set quality(e) {
        this._quality = Math.max(1, Math.round(e)), this._generateKernels();
    }
    get blur() {
        return this._blur;
    }
    set blur(e) {
        this._blur = e, this._generateKernels();
    }
}


parcelRequire("inflE");
var $lbGGA = parcelRequire("lbGGA");
var $3x7iq = parcelRequire("3x7iq");
var $g9ac3 = parcelRequire("g9ac3");
var $16eqM = parcelRequire("16eqM");
var $lFGyw = parcelRequire("lFGyw");
var $e7e176903757e210$var$w = `attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;

uniform mat3 projectionMatrix;

varying vec2 vTextureCoord;

void main(void)
{
    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`, $e7e176903757e210$var$O = `varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform float alpha;
uniform vec3 color;

uniform vec2 shift;
uniform vec4 inputSize;

void main(void){
    vec4 sample = texture2D(uSampler, vTextureCoord - shift * inputSize.zw);

    // Premultiply alpha
    sample.rgb = color.rgb * sample.a;

    // alpha user alpha
    sample *= alpha;

    gl_FragColor = sample;
}`, $e7e176903757e210$var$P = Object.defineProperty, $e7e176903757e210$var$c = Object.getOwnPropertySymbols, $e7e176903757e210$var$T = Object.prototype.hasOwnProperty, $e7e176903757e210$var$z = Object.prototype.propertyIsEnumerable, $e7e176903757e210$var$_ = (t, e, i)=>e in t ? $e7e176903757e210$var$P(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : t[e] = i, $e7e176903757e210$var$b = (t, e)=>{
    for(var i in e || (e = {}))$e7e176903757e210$var$T.call(e, i) && $e7e176903757e210$var$_(t, i, e[i]);
    if ($e7e176903757e210$var$c) for (var i of $e7e176903757e210$var$c(e))$e7e176903757e210$var$z.call(e, i) && $e7e176903757e210$var$_(t, i, e[i]);
    return t;
};
const $e7e176903757e210$var$o = class extends (0, $3x7iq.Filter) {
    constructor(t){
        super(), this.angle = 45, this._distance = 5, this._resolution = (0, $16eqM.settings).FILTER_RESOLUTION;
        const e = t ? $e7e176903757e210$var$b($e7e176903757e210$var$b({}, $e7e176903757e210$var$o.defaults), t) : $e7e176903757e210$var$o.defaults, { kernels: i, blur: l, quality: r, pixelSize: g, resolution: n } = e;
        this._offset = new (0, $g9ac3.ObservablePoint)(this._updatePadding, this), this._tintFilter = new (0, $3x7iq.Filter)($e7e176903757e210$var$w, $e7e176903757e210$var$O), this._tintFilter.uniforms.color = new Float32Array(4), this._tintFilter.uniforms.shift = this._offset, this._tintFilter.resolution = n, this._blurFilter = i ? new (0, $950238d694024b6e$export$31164edf0fb20199)(i) : new (0, $950238d694024b6e$export$31164edf0fb20199)(l, r), this.pixelSize = g, this.resolution = n;
        const { shadowOnly: m, rotation: a, distance: u, offset: v, alpha: y, color: x } = e;
        this.shadowOnly = m, a !== void 0 && u !== void 0 ? (this.rotation = a, this.distance = u) : this.offset = v, this.alpha = y, this.color = x;
    }
    apply(t, e, i, l) {
        const r = t.getFilterTexture();
        this._tintFilter.apply(t, e, r, 1), this._blurFilter.apply(t, r, i, l), this.shadowOnly !== !0 && t.applyFilter(this, e, i, 0), t.returnFilterTexture(r);
    }
    _updatePadding() {
        const t = Math.max(Math.abs(this._offset.x), Math.abs(this._offset.y));
        this.padding = t + this.blur * 2;
    }
    _updateShift() {
        this._tintFilter.uniforms.shift.set(this.distance * Math.cos(this.angle), this.distance * Math.sin(this.angle));
    }
    set offset(t) {
        this._offset.copyFrom(t), this._updatePadding();
    }
    get offset() {
        return this._offset;
    }
    get resolution() {
        return this._resolution;
    }
    set resolution(t) {
        this._resolution = t, this._tintFilter && (this._tintFilter.resolution = t), this._blurFilter && (this._blurFilter.resolution = t);
    }
    get distance() {
        return this._distance;
    }
    set distance(t) {
        (0, $lFGyw).deprecation("5.3.0", "DropShadowFilter distance is deprecated, use offset"), this._distance = t, this._updatePadding(), this._updateShift();
    }
    get rotation() {
        return this.angle / (0, $lbGGA.DEG_TO_RAD);
    }
    set rotation(t) {
        (0, $lFGyw).deprecation("5.3.0", "DropShadowFilter rotation is deprecated, use offset"), this.angle = t * (0, $lbGGA.DEG_TO_RAD), this._updateShift();
    }
    get alpha() {
        return this._tintFilter.uniforms.alpha;
    }
    set alpha(t) {
        this._tintFilter.uniforms.alpha = t;
    }
    get color() {
        return (0, $lFGyw).rgb2hex(this._tintFilter.uniforms.color);
    }
    set color(t) {
        (0, $lFGyw).hex2rgb(t, this._tintFilter.uniforms.color);
    }
    get kernels() {
        return this._blurFilter.kernels;
    }
    set kernels(t) {
        this._blurFilter.kernels = t;
    }
    get blur() {
        return this._blurFilter.blur;
    }
    set blur(t) {
        this._blurFilter.blur = t, this._updatePadding();
    }
    get quality() {
        return this._blurFilter.quality;
    }
    set quality(t) {
        this._blurFilter.quality = t;
    }
    get pixelSize() {
        return this._blurFilter.pixelSize;
    }
    set pixelSize(t) {
        this._blurFilter.pixelSize = t;
    }
};
let $e7e176903757e210$export$57214e398098d4e3 = $e7e176903757e210$var$o;
$e7e176903757e210$export$57214e398098d4e3.defaults = {
    offset: {
        x: 4,
        y: 4
    },
    color: 0,
    alpha: .5,
    shadowOnly: !1,
    kernels: null,
    blur: 2,
    quality: 3,
    pixelSize: 1,
    resolution: (0, $16eqM.settings).FILTER_RESOLUTION
};




const $a8ee2ef5ebacaefc$export$1fb5379e7a082abb = /*#__PURE__*/ (0, $acw62.forwardRef)(function PixiCanvas(props, ref) {
    const divRef = (0, $acw62.useRef)(null);
    const containerRef = (0, $acw62.useRef)(null);
    const [app, setApp] = (0, $acw62.useState)();
    const [width, setWidth] = (0, $acw62.useState)(0);
    const [height, setHeight] = (0, $acw62.useState)(0);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            exportPng: async ()=>{
                const container = containerRef.current;
                if (app === undefined || container === null) throw new Error("Pixi app is not ready");
                return await $a8ee2ef5ebacaefc$var$exportPng(app, container);
            }
        }), [
        app
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const div = divRef.current;
        if (div === null) return;
        const observer = new ResizeObserver((e)=>{
            const rect = e[0].target.getBoundingClientRect();
            setWidth(rect.width);
            setHeight(rect.height);
        });
        observer.observe(div);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: divRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a60be4e6fbee351d$exports))).container,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Stage), {
            raf: false,
            width: width,
            height: height,
            options: {
                backgroundAlpha: 0
            },
            onMount: setApp,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Container), {
                ref: containerRef,
                name: "main",
                x: -props.pan.deltaX * props.zoom,
                y: -props.pan.deltaY * props.zoom,
                scale: props.zoom,
                children: props.items.map((item)=>item.ink.type === "image" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a8ee2ef5ebacaefc$var$ImagePixi, {
                        ink: item.ink,
                        itemId: item.id,
                        allItems: props.items
                    }, item.id) : item.ink.type === "rect" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a8ee2ef5ebacaefc$var$RectPixi, {
                        ink: item.ink
                    }, item.id) : item.ink.type === "text" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a8ee2ef5ebacaefc$var$TextPixi, {
                        ink: item.ink
                    }, item.id) : item.ink.type === "pen" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a8ee2ef5ebacaefc$var$PenPixi, {
                        ink: item.ink
                    }, item.id) : item.ink.type === "arrow" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a8ee2ef5ebacaefc$var$ArrowPixi, {
                        ink: item.ink
                    }, item.id) : item.ink.type === "number" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a8ee2ef5ebacaefc$var$NumberPixi, {
                        items: props.items,
                        ink: item.ink
                    }, item.id) : null)
            })
        })
    });
});
const $a8ee2ef5ebacaefc$var$colors = {
    pink: "#ff00ff",
    red: "#ff0066",
    orange: "#ffcc00",
    green: "#00ff00",
    cyan: "#00ccff",
    purple: "#6600ff",
    white: "#ffffff",
    black: "#000000"
};
const $a8ee2ef5ebacaefc$var$textColors = {
    pink: "#ff00ff",
    red: "#ff0066",
    orange: "#ffcc00",
    green: "#00cc00",
    cyan: "#00ccff",
    purple: "#6600ff",
    white: "#000000",
    black: "#000000"
};
async function $a8ee2ef5ebacaefc$var$exportPng(app, container) {
    return new Promise((resolve, reject)=>{
        const canvas = app.renderer.extract.canvas(container);
        if (canvas.toBlob === undefined) {
            reject("Failed to export PNG: toBlob is undefined");
            return;
        }
        canvas.toBlob(async (blob)=>{
            if (blob === null) {
                reject("Failed to export PNG: blob is null");
                return;
            }
            // Google Chrome では PNG 画像をクリップボードにコピーする際にサニタイズによってメタデータが
            // 削除されるため、pHYs チャンクはコピー時に失われる。
            // https://issues.chromium.org/issues/40853606
            const pngWithPhys = (0, $516ef8e471c65448$export$bba19d6e26274f9e)(await blob.arrayBuffer(), {
                x: 72 * window.devicePixelRatio,
                y: 72 * window.devicePixelRatio
            });
            resolve(new Blob([
                pngWithPhys
            ], {
                type: "image/png"
            }));
        });
    });
}
// TODO: 個別に blur, pixelate を適用する関数を書いてもいいかも。
// そして Image は Blur と Pixelate に強く依存するのだから、同じモジュールにしてもいいかも
// Blur は Image が存在しないと意味ないし、Image は Blur の存在を仮定するので
const $a8ee2ef5ebacaefc$var$ImagePixi = (props)=>{
    const app = (0, $91bc9451ada945a4$exports.useApp)();
    const overlayFilterInks = (0, $acw62.useMemo)(()=>{
        const index = props.allItems.findIndex((it)=>it.id === props.itemId);
        if (index < 0) return [];
        return props.allItems.slice(index + 1).map((it)=>it.ink).filter((it)=>it.kind === "filter");
    }, [
        props.allItems,
        props.itemId
    ]);
    const texture = (0, $acw62.useMemo)(()=>{
        const original = (0, $3uiak.Sprite).from(props.ink.bitmap);
        const container = new (0, $3IPo5.Container)();
        container.addChild(original);
        overlayFilterInks.forEach((ink)=>{
            const filtered = $a8ee2ef5ebacaefc$var$getFilteredSprite(props.ink.bitmap, ink);
            if (filtered === undefined) return;
            const maskBox = (0, $189e06d909ce30c1$export$e1942d4b7c93f2ed)((0, $1345f3e3159b23e9$export$4bb6209356900d5e)(ink));
            const mask = new (0, $1FuXs.Graphics)();
            const imageScaleX = props.ink.width / props.ink.bitmap.width;
            const imageScaleY = props.ink.height / props.ink.bitmap.height;
            mask.beginFill(0x000000);
            mask.drawRect(Math.round((maskBox.x - props.ink.x) / imageScaleX), Math.round((maskBox.y - props.ink.y) / imageScaleY), Math.round(maskBox.width / imageScaleX), Math.round(maskBox.height / imageScaleY));
            mask.endFill();
            const filteredContainer = new (0, $3IPo5.Container)();
            filteredContainer.addChild(filtered);
            filteredContainer.mask = mask;
            const eraser = mask.clone();
            eraser.blendMode = (0, $lmRm8.BLEND_MODES).ERASE;
            container.addChild(eraser);
            container.addChild(filteredContainer);
        });
        const rt = (0, $4UuR4.RenderTexture).create({
            width: props.ink.bitmap.width,
            height: props.ink.bitmap.height,
            scaleMode: (0, $lmRm8.SCALE_MODES).NEAREST
        });
        app.renderer.render(container, {
            renderTexture: rt
        });
        return rt;
    }, [
        props.ink,
        overlayFilterInks
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Sprite), {
        x: props.ink.x,
        y: props.ink.y,
        width: props.ink.width,
        height: props.ink.height,
        texture: texture
    });
};
const $a8ee2ef5ebacaefc$var$blurSize = 16;
const $a8ee2ef5ebacaefc$var$pixelateSize = 10;
function $a8ee2ef5ebacaefc$var$getFilteredSprite(bitmap, ink) {
    if (ink.type === "blur") {
        const filter = new (0, $d646b7e94dfd28fa$export$424348d09d827f49)((0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($a8ee2ef5ebacaefc$var$blurSize, ink.size), (0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($a8ee2ef5ebacaefc$var$blurSize, ink.size) / 2);
        const filtered = (0, $3uiak.Sprite).from(bitmap);
        filtered.filters = [
            filter
        ];
        return filtered;
    }
    if (ink.type === "pixelate") {
        const filter = new (0, $fcfe2b721c82698e$export$8ec99043c41c044)((0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($a8ee2ef5ebacaefc$var$pixelateSize, ink.size));
        const filtered = (0, $3uiak.Sprite).from(bitmap);
        filtered.filters = [
            filter
        ];
        return filtered;
    }
    if (ink.type === "redact") {
        const data = new Uint8Array(0);
        const texture = (0, $cWOCu.Texture).fromBuffer(data, bitmap.width, bitmap.height);
        return (0, $3uiak.Sprite).from(texture);
    }
    return undefined;
}
const $a8ee2ef5ebacaefc$var$rectThickness = 6;
const $a8ee2ef5ebacaefc$var$RectPixi = (props)=>{
    const app = (0, $91bc9451ada945a4$exports.useApp)();
    const sprite = (0, $acw62.useMemo)(()=>{
        const box = (0, $189e06d909ce30c1$export$e1942d4b7c93f2ed)(props.ink);
        return $a8ee2ef5ebacaefc$var$renderGraphics(app.renderer, (g)=>{
            g.lineStyle((0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($a8ee2ef5ebacaefc$var$rectThickness, props.ink.style.size), $a8ee2ef5ebacaefc$var$colors[props.ink.style.color]);
            g.drawRoundedRect(box.x, box.y, box.width, box.height, 1);
        });
    }, [
        app,
        props.ink
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Sprite), {
        x: sprite.x,
        y: sprite.y,
        texture: sprite.texture
    });
};
const $a8ee2ef5ebacaefc$var$TextPixi = (props)=>{
    const offset = (0, $acw62.useMemo)(()=>{
        if (props.ink.width === undefined) return 0;
        const matrix = (0, $c555d3b6b65c69d0$export$fef6eeb5bd6c2897)(props.ink);
        switch(props.ink.align){
            case "left":
                return 0;
            case "center":
                return (props.ink.width - matrix.width) / 2;
            case "right":
                return props.ink.width - matrix.width;
        }
    }, [
        props.ink
    ]);
    const textStyle = (0, $acw62.useMemo)(()=>{
        const style = (0, $c555d3b6b65c69d0$export$c6cdea5e4523850d)(props.ink);
        style.fill = $a8ee2ef5ebacaefc$var$textColors[props.ink.style.color];
        return style;
    }, [
        props.ink
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Text), {
        x: props.ink.x + offset,
        y: props.ink.y,
        text: props.ink.text,
        style: textStyle
    });
};
const $a8ee2ef5ebacaefc$var$penThickness = 8;
const $a8ee2ef5ebacaefc$var$PenPixi = (props)=>{
    const app = (0, $91bc9451ada945a4$exports.useApp)();
    const sprite = (0, $acw62.useMemo)(()=>{
        return $a8ee2ef5ebacaefc$var$renderGraphics(app.renderer, (g)=>{
            const points = props.ink.points;
            if (points.length < 2) {
                if (points.length === 1) {
                    g.beginFill($a8ee2ef5ebacaefc$var$colors[props.ink.style.color]);
                    g.drawCircle(points[0].x, points[0].y, (0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($a8ee2ef5ebacaefc$var$penThickness, props.ink.style.size) / 2);
                    g.endFill();
                }
                return g;
            }
            g.lineStyle({
                width: (0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($a8ee2ef5ebacaefc$var$penThickness, props.ink.style.size),
                color: $a8ee2ef5ebacaefc$var$colors[props.ink.style.color],
                cap: (0, $khIUA.LINE_CAP).ROUND,
                join: (0, $khIUA.LINE_JOIN).ROUND
            });
            g.moveTo(points[0].x, points[0].y);
            for(let i = 1; i < points.length - 2; i++){
                const cpX = (points[i].x + points[i + 1].x) / 2;
                const cpY = (points[i].y + points[i + 1].y) / 2;
                g.quadraticCurveTo(points[i].x, points[i].y, cpX, cpY);
            }
            // 最後の2点で曲線を終える
            const last = points.length - 1;
            g.quadraticCurveTo(points[last - 1].x, points[last - 1].y, points[last].x, points[last].y);
        });
    }, [
        app,
        props.ink
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Sprite), {
        x: sprite.x,
        y: sprite.y,
        texture: sprite.texture
    });
};
const $a8ee2ef5ebacaefc$var$arrowThicknesses = 16;
const $a8ee2ef5ebacaefc$var$ArrowPixi = (props)=>{
    const app = (0, $91bc9451ada945a4$exports.useApp)();
    const texture = (0, $acw62.useMemo)(()=>{
        const dx = props.ink.to.x - props.ink.from.x;
        const dy = props.ink.to.y - props.ink.from.y;
        const length = Math.sqrt(dx * dx + dy * dy);
        let thickness = (0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)($a8ee2ef5ebacaefc$var$arrowThicknesses, props.ink.style.size);
        const threshold = thickness * 6; // triangleSize * 2
        if (length < threshold) thickness *= length / threshold;
        const triangleSize = thickness * 3;
        const triangleHeight = triangleSize * Math.sin(Math.PI / 3);
        // Graphics の rotation などでは graphics.getLocalBounds に影響を与えられないので、
        // Texture にレンダーする際に見切れてしまう。そのため頂点座標そのものを移動させる。
        const matrix = new (0, $6wJoy.Matrix)().rotate(Math.atan2(dy, dx)).translate(props.ink.from.x, props.ink.from.y);
        return $a8ee2ef5ebacaefc$var$renderGraphics(app.renderer, (g)=>{
            g.beginFill($a8ee2ef5ebacaefc$var$colors[props.ink.style.color]);
            g.drawPolygon([
                matrix.apply({
                    x: 0,
                    y: -1
                }),
                matrix.apply({
                    x: length - triangleHeight,
                    y: -thickness / 2
                }),
                matrix.apply({
                    x: length - triangleHeight,
                    y: -triangleSize / 2
                }),
                matrix.apply({
                    x: length,
                    y: 0
                }),
                matrix.apply({
                    x: length - triangleHeight,
                    y: triangleSize / 2
                }),
                matrix.apply({
                    x: length - triangleHeight,
                    y: thickness / 2
                }),
                matrix.apply({
                    x: 0,
                    y: 1
                })
            ]);
            g.endFill();
        });
    }, [
        props.ink,
        app
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Sprite), {
        x: texture.x,
        y: texture.y,
        texture: texture.texture
    });
};
const $a8ee2ef5ebacaefc$var$NumberPixi = (props)=>{
    const app = (0, $91bc9451ada945a4$exports.useApp)();
    const n = (0, $acw62.useMemo)(()=>{
        return props.items.filter((it)=>it.ink.type === "number" && it.ink.ts < props.ink.ts).length + 1;
    }, [
        props.items,
        props.ink
    ]);
    const textStyle = (0, $acw62.useMemo)(()=>{
        const fontSize = (0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)((0, $882d0e345520754a$export$fc3abcb6606c9723), props.ink.style.size);
        return new (0, $f6HC1.TextStyle)({
            fontSize: fontSize,
            fill: 0xffffff,
            fontWeight: "bold",
            dropShadow: true,
            dropShadowAlpha: 0.2,
            dropShadowBlur: 10,
            dropShadowDistance: 0,
            lineHeight: fontSize * 1.6,
            padding: fontSize / 2,
            lineJoin: "round"
        });
    }, [
        props.ink.style.size
    ]);
    const sprite = (0, $acw62.useMemo)(()=>{
        return $a8ee2ef5ebacaefc$var$renderGraphics(app.renderer, (g)=>{
            g.lineStyle((0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)((0, $882d0e345520754a$export$fc3abcb6606c9723), props.ink.style.size) * 0.15, 0xffffff);
            g.beginFill($a8ee2ef5ebacaefc$var$textColors[props.ink.style.color]);
            g.drawCircle(props.ink.pos.x, props.ink.pos.y, (0, $18d6f960c772a57f$export$eeb6b3a559cdc0d9)((0, $882d0e345520754a$export$fc3abcb6606c9723), props.ink.style.size) * 0.8);
            g.endFill();
        });
    }, [
        props.ink.style.color,
        props.ink.style.size,
        props.ink.pos
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91bc9451ada945a4$exports.Container), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Sprite), {
                x: sprite.x,
                y: sprite.y,
                texture: sprite.texture
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91bc9451ada945a4$exports.Text), {
                x: props.ink.pos.x,
                y: props.ink.pos.y,
                anchor: 0.5,
                text: n.toString(),
                style: textStyle
            })
        ]
    });
};
function $a8ee2ef5ebacaefc$var$renderGraphics(renderer, render) {
    const g = new (0, $1FuXs.Graphics)();
    render(g);
    const { width: width, height: height, x: x, y: y } = g.getLocalBounds();
    const renderTexture = (0, $4UuR4.RenderTexture).create({
        width: Math.max(1, width),
        height: Math.max(1, height),
        multisample: (0, $lmRm8.MSAA_QUALITY).HIGH,
        resolution: window.devicePixelRatio
    });
    renderer.render(g, {
        renderTexture: renderTexture,
        transform: new (0, $6wJoy.Matrix)().translate(-x, -y)
    });
    // Required for MSAA, WebGL 2 only
    renderer.framebuffer.blit();
    g.destroy(true);
    const sprite = (0, $3uiak.Sprite).from(renderTexture);
    sprite.x = x;
    sprite.y = y;
    try {
        return $a8ee2ef5ebacaefc$var$renderDropShadow(renderer, sprite);
    } finally{
        sprite.destroy(true);
    }
}
function $a8ee2ef5ebacaefc$var$renderDropShadow(renderer, container) {
    const padding = 10;
    const renderTexture = (0, $4UuR4.RenderTexture).create({
        width: Math.max(1, container.width + padding * 2),
        height: Math.max(1, container.height + padding * 2),
        multisample: (0, $lmRm8.MSAA_QUALITY).HIGH,
        resolution: window.devicePixelRatio
    });
    const filter = new (0, $e7e176903757e210$export$57214e398098d4e3)({
        color: 0x000000,
        alpha: 0.1,
        offset: {
            x: 0,
            y: 0
        },
        blur: 1,
        quality: 8,
        resolution: window.devicePixelRatio
    });
    filter.padding = padding;
    container.filters = [
        filter
    ];
    renderer.render(container, {
        renderTexture: renderTexture,
        transform: new (0, $6wJoy.Matrix)().translate(-container.x + padding, -container.y + padding)
    });
    // Required for MSAA, WebGL 2 only
    renderer.framebuffer.blit();
    const sprite = (0, $3uiak.Sprite).from(renderTexture);
    sprite.x = container.x - padding;
    sprite.y = container.y - padding;
    return sprite;
}






function $0a2b0b5969e29723$export$b5c67a6be7b92c23(pos1, pos2) {
    return {
        deltaX: pos2.x - pos1.x,
        deltaY: pos2.y - pos1.y
    };
}
function $0a2b0b5969e29723$export$a59aa03203e9f00c(offset) {
    return {
        deltaX: -offset.deltaX,
        deltaY: -offset.deltaY
    };
}
function $0a2b0b5969e29723$export$82e05f0987eca85a(offset1, offset2) {
    return {
        deltaX: offset1.deltaX + offset2.deltaX,
        deltaY: offset1.deltaY + offset2.deltaY
    };
}
function $0a2b0b5969e29723$export$fb08849af550a826(offset, zoom) {
    return {
        deltaX: offset.deltaX * zoom,
        deltaY: offset.deltaY * zoom
    };
}
function $0a2b0b5969e29723$export$d639492015f7092e(pos1, pos2) {
    return {
        viewportDeltaX: pos2.viewportX - pos1.viewportX,
        viewportDeltaY: pos2.viewportY - pos1.viewportY
    };
}
function $0a2b0b5969e29723$export$dbd442ab0564e9dc(offset, zoom) {
    return {
        deltaX: offset.viewportDeltaX / zoom,
        deltaY: offset.viewportDeltaY / zoom
    };
}


var $7396131ab649a5ba$exports = {};

$parcel$export($7396131ab649a5ba$exports, "canvas", () => $7396131ab649a5ba$export$67ea982130081db, (v) => $7396131ab649a5ba$export$67ea982130081db = v);
$parcel$export($7396131ab649a5ba$exports, "info", () => $7396131ab649a5ba$export$a80b3bd66acc52ff, (v) => $7396131ab649a5ba$export$a80b3bd66acc52ff = v);
$parcel$export($7396131ab649a5ba$exports, "infoWrapper", () => $7396131ab649a5ba$export$7fffd76db8c31048, (v) => $7396131ab649a5ba$export$7fffd76db8c31048 = v);
$parcel$export($7396131ab649a5ba$exports, "logoWrapper", () => $7396131ab649a5ba$export$3fca35e0a6eb1bfc, (v) => $7396131ab649a5ba$export$3fca35e0a6eb1bfc = v);
$parcel$export($7396131ab649a5ba$exports, "menuBarWrapper", () => $7396131ab649a5ba$export$4e81c89bf1e3fa65, (v) => $7396131ab649a5ba$export$4e81c89bf1e3fa65 = v);
$parcel$export($7396131ab649a5ba$exports, "textModal", () => $7396131ab649a5ba$export$19f1ca93472e803a, (v) => $7396131ab649a5ba$export$19f1ca93472e803a = v);
$parcel$export($7396131ab649a5ba$exports, "toolBarWrapper", () => $7396131ab649a5ba$export$4431eee85eabff9d, (v) => $7396131ab649a5ba$export$4431eee85eabff9d = v);
$parcel$export($7396131ab649a5ba$exports, "welcomeWrapper", () => $7396131ab649a5ba$export$111750d01bac12a7, (v) => $7396131ab649a5ba$export$111750d01bac12a7 = v);
var $7396131ab649a5ba$export$67ea982130081db;
var $7396131ab649a5ba$export$a80b3bd66acc52ff;
var $7396131ab649a5ba$export$7fffd76db8c31048;
var $7396131ab649a5ba$export$3fca35e0a6eb1bfc;
var $7396131ab649a5ba$export$4e81c89bf1e3fa65;
var $7396131ab649a5ba$export$19f1ca93472e803a;
var $7396131ab649a5ba$export$4431eee85eabff9d;
var $7396131ab649a5ba$export$111750d01bac12a7;
$7396131ab649a5ba$export$67ea982130081db = `D774-q_canvas`;
$7396131ab649a5ba$export$a80b3bd66acc52ff = `D774-q_info`;
$7396131ab649a5ba$export$7fffd76db8c31048 = `D774-q_infoWrapper`;
$7396131ab649a5ba$export$3fca35e0a6eb1bfc = `D774-q_logoWrapper`;
$7396131ab649a5ba$export$4e81c89bf1e3fa65 = `D774-q_menuBarWrapper`;
$7396131ab649a5ba$export$19f1ca93472e803a = `D774-q_textModal`;
$7396131ab649a5ba$export$4431eee85eabff9d = `D774-q_toolBarWrapper`;
$7396131ab649a5ba$export$111750d01bac12a7 = `D774-q_welcomeWrapper`;




var $acw62 = parcelRequire("acw62");
var $20d7b5a00fdfc392$exports = {};

$parcel$export($20d7b5a00fdfc392$exports, "container", () => $20d7b5a00fdfc392$export$34e0f9847d4c02dd, (v) => $20d7b5a00fdfc392$export$34e0f9847d4c02dd = v);
var $20d7b5a00fdfc392$export$34e0f9847d4c02dd;
$20d7b5a00fdfc392$export$34e0f9847d4c02dd = `_2G4Rsa_container`;


const $6909c5c697445ce4$export$d5c6c08dc2d3ca7 = (props)=>{
    const { onPan: onPan, onZoom: onZoom } = props;
    const ref = (0, $acw62.useRef)(null);
    // WheelEvent を preventDefault するには passive: false でイベントリスナを登録する必要があるが、
    // React の onWheel では passive: false にできないため useEffect でリスナを追加する。
    // https://github.com/facebook/react/issues/22794
    (0, $acw62.useEffect)(()=>{
        if (ref.current === null) return;
        const div = ref.current;
        const handler = (e)=>{
            e.preventDefault();
            requestAnimationFrame(()=>{
                if (e.metaKey || e.ctrlKey) {
                    const rect = div.getBoundingClientRect();
                    onZoom({
                        viewportX: e.pageX - (rect.x + window.scrollX),
                        viewportY: e.pageY - (rect.y + window.scrollY)
                    }, -e.deltaY / (e.metaKey ? 200 : 50) + 1);
                } else onPan({
                    deltaX: e.deltaX / props.zoom * 1.5,
                    deltaY: e.deltaY / props.zoom * 1.5
                });
            });
        };
        div.addEventListener("wheel", handler, {
            passive: false
        });
        return ()=>{
            div.removeEventListener("wheel", handler);
        };
    }, [
        onZoom,
        onPan,
        props.zoom
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($20d7b5a00fdfc392$exports))).container,
        children: props.children
    });
};




var $acw62 = parcelRequire("acw62");
var $c6b96e47ba1f66a1$exports = {};

$parcel$export($c6b96e47ba1f66a1$exports, "container", () => $c6b96e47ba1f66a1$export$34e0f9847d4c02dd, (v) => $c6b96e47ba1f66a1$export$34e0f9847d4c02dd = v);
$parcel$export($c6b96e47ba1f66a1$exports, "previewBox", () => $c6b96e47ba1f66a1$export$a69cc1b2d889630d, (v) => $c6b96e47ba1f66a1$export$a69cc1b2d889630d = v);
var $c6b96e47ba1f66a1$export$34e0f9847d4c02dd;
var $c6b96e47ba1f66a1$export$a69cc1b2d889630d;
$c6b96e47ba1f66a1$export$34e0f9847d4c02dd = `_1mgBVG_container`;
$c6b96e47ba1f66a1$export$a69cc1b2d889630d = `_1mgBVG_previewBox`;



async function $dbfd69960405e39c$export$73d0a139caca1fee(event) {
    const { name: name, ...props } = event;
    if (typeof umami !== "undefined") await umami.track(name, props);
}


const $897df39b26075d44$export$7cda8d932e2f33c0 = (props)=>{
    const { onDraw: onDraw, onDrawEnd: onDrawEnd, onSelectArea: onSelectArea } = props;
    const ref = (0, $acw62.useRef)(null);
    const drawingRef = (0, $acw62.useRef)(false);
    const { selectionBox: selectionBox, startSelection: startSelection, updateSelection: updateSelection, endSelection: endSelection } = $897df39b26075d44$var$useSelectionBox();
    const handleMouseDown = (0, $acw62.useCallback)(async (e)=>{
        if (e.button !== 0) return;
        if (ref.current === null) return;
        const offset = $897df39b26075d44$var$elementOffsetOf(ref.current);
        const viewportPos = {
            viewportX: e.pageX - offset.deltaX,
            viewportY: e.pageY - offset.deltaY
        };
        if (props.tool === undefined) startSelection(viewportPos);
        else {
            drawingRef.current = true;
            onDraw(viewportPos);
            await (0, $dbfd69960405e39c$export$73d0a139caca1fee)({
                name: "draw",
                tool: props.tool
            });
        }
    }, [
        props.tool,
        onDraw
    ]);
    const lastMovedAtRef = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        const handler = (e)=>{
            const now = Date.now();
            if (now - lastMovedAtRef.current < 20) return;
            lastMovedAtRef.current = now;
            requestAnimationFrame(()=>{
                if (ref.current === null) return;
                const offset = $897df39b26075d44$var$elementOffsetOf(ref.current);
                const viewportPos = {
                    viewportX: e.pageX - offset.deltaX,
                    viewportY: e.pageY - offset.deltaY
                };
                if (drawingRef.current) onDraw(viewportPos);
                else updateSelection(viewportPos);
            });
        };
        window.addEventListener("mousemove", handler);
        return ()=>{
            window.removeEventListener("mousemove", handler);
        };
    }, [
        onDraw,
        updateSelection
    ]);
    (0, $acw62.useEffect)(()=>{
        const handler = (e)=>{
            // Preview Finalization
            if (drawingRef.current) {
                drawingRef.current = false;
                onDrawEnd();
            }
            // Selection
            if (selectionBox !== undefined) {
                onSelectArea(selectionBox, e.shiftKey);
                endSelection();
            }
        };
        window.addEventListener("mouseup", handler);
        return ()=>{
            window.removeEventListener("mouseup", handler);
        };
    }, [
        selectionBox,
        endSelection,
        onDrawEnd
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: ref,
        "data-tool": props.tool,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c6b96e47ba1f66a1$exports))).container,
        onMouseDown: handleMouseDown,
        children: selectionBox !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                top: selectionBox.viewportY,
                left: selectionBox.viewportX,
                width: selectionBox.viewportWidth,
                height: selectionBox.viewportHeight
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c6b96e47ba1f66a1$exports))).previewBox
        })
    });
};
function $897df39b26075d44$var$useSelectionBox() {
    const selectionStartPosRef = (0, $acw62.useRef)();
    const [selectionBox, setSelectionBox] = (0, $acw62.useState)();
    const start = (0, $acw62.useCallback)((pos)=>{
        selectionStartPosRef.current = pos;
        setSelectionBox({
            ...pos,
            viewportWidth: 0,
            viewportHeight: 0
        });
    }, []);
    const update = (0, $acw62.useCallback)((pos)=>{
        if (selectionStartPosRef.current !== undefined) setSelectionBox((0, $189e06d909ce30c1$export$88e2d5deb5dd5467)(selectionStartPosRef.current, pos));
    }, []);
    const end = (0, $acw62.useCallback)(()=>{
        selectionStartPosRef.current = undefined;
        setSelectionBox(undefined);
    }, []);
    return {
        selectionBox: selectionBox,
        startSelection: start,
        updateSelection: update,
        endSelection: end
    };
}
function $897df39b26075d44$var$elementOffsetOf(element) {
    const boundingRect = element.getBoundingClientRect();
    return {
        deltaX: boundingRect.x + window.scrollX,
        deltaY: boundingRect.y + window.scrollY
    };
}
function $897df39b26075d44$var$toggleItemId(ids, id) {
    return ids.includes(id) ? ids.filter((it)=>it !== id) : [
        ...ids,
        id
    ];
}



const $8a274207f4b4b8a3$export$e6ff31bff12b7ff4 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "160",
        height: "56",
        viewBox: "0 0 160 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 14C16.6863 14 14 16.6863 14 20V24H12V20C12 15.5817 15.5817 12 20 12H24V14H20Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 36C14 39.3137 16.6863 42 20 42H24V44H20C15.5817 44 12 40.4183 12 36V32H14V36Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M36 42C39.3137 42 42 39.3137 42 36V32H44V36C44 40.4183 40.4183 44 36 44H32V42H36Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M42 20C42 16.6863 39.3137 14 36 14H32V12H36C40.4183 12 44 15.5817 44 20V24H42V20Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.6598 34.2673C22.8484 34.4237 23.0711 34.5587 23.3243 34.6713C24.052 34.9946 24.9978 35.1126 25.967 34.9986C27.1485 34.8596 28.2728 34.395 29.0507 33.6361C28.8325 33.657 28.5935 33.6675 28.3336 33.6675C27.5526 33.6675 26.8889 33.5503 26.3422 33.3161C25.7956 33.0662 25.327 32.7226 24.9366 32.2853C24.6086 31.926 24.2728 31.6996 23.9292 31.6059C23.6012 31.4965 23.2342 31.559 22.8281 31.7933C22.4064 32.0276 22.1409 32.3243 22.0316 32.6835C21.9379 33.0427 22.0394 33.4332 22.3361 33.8549C22.4409 33.9983 22.5487 34.1358 22.6598 34.2673ZM25.0682 36.0147C26.0461 36.3866 27.0955 36.5725 28.2164 36.5725C30.0594 36.5725 31.5197 36.1508 32.5974 35.3074C33.6906 34.4484 34.2373 33.2145 34.2373 31.6059C34.2373 30.3408 33.8234 29.2787 32.9956 28.4197C32.1835 27.5451 30.8637 26.8891 29.0364 26.4518C27.9587 26.1863 27.17 25.9286 26.6702 25.6787C26.186 25.4288 25.8737 25.1789 25.7331 24.929C25.6082 24.6635 25.5457 24.4058 25.5457 24.1559C25.5457 23.8059 25.6134 23.5071 25.7487 23.2598C25.913 22.7406 26.2688 22.2673 26.6948 21.8715C27.3452 21.2672 28.2399 20.7627 29.1925 20.4398C29.8616 20.213 30.5775 20.0696 31.2769 20.0513L31.2386 20.0327C30.3483 19.5954 29.2941 19.3767 28.0759 19.3767C26.9201 19.3767 25.9127 19.5876 25.0537 20.0093C24.2103 20.4153 23.5544 20.9854 23.0858 21.7195C22.6173 22.4535 22.383 23.3125 22.383 24.2965C22.383 25.4835 22.7422 26.4752 23.4606 27.2718C24.1791 28.0683 25.2958 28.6462 26.8108 29.0054C28.0602 29.3022 28.9817 29.5833 29.5752 29.8488C30.1843 30.0987 30.5748 30.3642 30.7466 30.6453C30.934 30.9265 31.0277 31.2623 31.0277 31.6527C31.0277 31.7383 31.0242 31.8215 31.0171 31.9025L31.0201 31.903C31.0179 31.9166 31.0155 31.9301 31.0132 31.9437C30.989 32.1769 30.9349 32.3906 30.8507 32.5847C30.1593 34.6437 28.0554 35.7358 26.081 35.968C25.7434 36.0078 25.4036 36.0236 25.0682 36.0147ZM32.015 21.065C32.6418 21.1534 33.1721 21.3888 33.5591 21.7948C33.7997 22.1289 33.8852 22.463 33.8156 22.7971C33.7375 23.1563 33.5032 23.4843 33.1128 23.7811C32.7223 24.0778 32.3553 24.195 32.0117 24.1325C31.6681 24.0544 31.3245 23.8435 30.9809 23.4999C30.6373 23.1563 30.2312 22.8674 29.7626 22.6331C29.2941 22.3989 28.7162 22.2817 28.029 22.2817C27.9206 22.2817 27.8151 22.2851 27.7125 22.2919C28.2073 21.9191 28.8314 21.5929 29.5058 21.3643C30.3534 21.077 31.2433 20.9562 32.015 21.065Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M139.36 37.4914C138.564 37.4914 138.167 37.0937 138.167 36.2982V19.2135C138.167 18.4361 138.564 18.0474 139.36 18.0474H139.414C140.209 18.0474 140.607 18.4361 140.607 19.2135V29.844L145.19 25.1524C145.425 24.8632 145.669 24.6553 145.922 24.5287C146.194 24.4022 146.447 24.3389 146.682 24.3389C147.134 24.3389 147.459 24.5197 147.658 24.8813C147.857 25.2428 147.721 25.6858 147.251 26.2101L142.966 30.3592L147.983 36.0541C148.291 36.4519 148.336 36.8135 148.119 37.1389C147.92 37.4462 147.613 37.5999 147.197 37.5999C146.817 37.5999 146.519 37.5547 146.302 37.4643C146.085 37.3558 145.904 37.1931 145.76 36.9762L140.607 30.9016V36.2982C140.607 37.0937 140.209 37.4914 139.414 37.4914H139.36Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M125.007 37.4913C124.193 37.4913 123.786 37.0574 123.786 36.1896V25.7489C123.786 24.8992 124.157 24.4744 124.898 24.4744C125.657 24.4744 126.046 24.6913 126.064 25.1252L126.118 26.1557C126.498 25.6133 127.004 25.1433 127.637 24.7455C128.288 24.3478 129.029 24.1489 129.861 24.1489C131.235 24.1489 132.347 24.5919 133.196 25.4777C134.064 26.3455 134.498 27.6111 134.498 29.2743V36.1896C134.498 37.0574 134.091 37.4913 133.278 37.4913C132.482 37.4913 132.084 37.0574 132.084 36.1896V29.7896C132.084 28.6506 131.831 27.8009 131.325 27.2405C130.819 26.6619 130.159 26.3727 129.346 26.3727C128.423 26.3727 127.673 26.68 127.095 27.2947C126.516 27.8913 126.227 28.6958 126.227 29.7082V36.1896C126.227 37.0574 125.82 37.4913 125.007 37.4913Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M118.63 37.4914C117.817 37.4914 117.41 37.0575 117.41 36.1897V19.81C117.41 18.9422 117.817 18.5083 118.63 18.5083C119.462 18.5083 119.878 18.9422 119.878 19.81V36.1897C119.878 37.0575 119.462 37.4914 118.63 37.4914Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M102.973 42.9693C102.159 42.9693 101.752 42.5354 101.752 41.6676V25.7489C101.752 24.8992 102.114 24.4744 102.837 24.4744C103.56 24.4744 103.931 24.6642 103.949 25.0438L104.003 26.3184C104.473 25.6314 105.052 25.0981 105.739 24.7184C106.426 24.3388 107.194 24.1489 108.044 24.1489C109.237 24.1489 110.295 24.4292 111.217 24.9896C112.139 25.532 112.862 26.3184 113.386 27.3489C113.929 28.3614 114.2 29.5636 114.2 30.9557C114.2 32.3478 113.929 33.5591 113.386 34.5896C112.862 35.6201 112.139 36.4156 111.217 36.976C110.295 37.5184 109.237 37.7896 108.044 37.7896C107.23 37.7896 106.498 37.6179 105.847 37.2743C105.196 36.9128 104.645 36.4246 104.193 35.8099V41.6676C104.193 42.5354 103.786 42.9693 102.973 42.9693ZM107.962 35.5659C109.065 35.5659 109.978 35.1591 110.701 34.3455C111.425 33.5139 111.786 32.384 111.786 30.9557C111.786 29.5275 111.425 28.4066 110.701 27.593C109.978 26.7794 109.065 26.3727 107.962 26.3727C106.86 26.3727 105.947 26.7794 105.223 27.593C104.518 28.4066 104.166 29.5275 104.166 30.9557C104.166 32.384 104.518 33.5139 105.223 34.3455C105.947 35.1591 106.86 35.5659 107.962 35.5659Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M91.1447 37.7082C89.8249 37.7444 88.7311 37.4461 87.8633 36.8133C87.0136 36.1625 86.5887 35.2314 86.5887 34.0201C86.5887 33.1342 86.869 32.3659 87.4294 31.715C88.0079 31.0642 88.7401 30.558 89.626 30.1964C90.53 29.8167 91.461 29.6269 92.4192 29.6269C92.9797 29.5907 93.4949 29.645 93.965 29.7896C94.4351 29.9162 94.8418 30.106 95.1853 30.3591V28.732C95.1853 27.7195 94.9684 27.0597 94.5345 26.7523C94.1187 26.445 93.4678 26.2913 92.5819 26.2913C92.0215 26.2913 91.4249 26.3727 90.7921 26.5354C90.1774 26.68 89.5989 26.8789 89.0565 27.132C88.6769 27.2766 88.3514 27.3308 88.0803 27.2947C87.8091 27.2405 87.5831 27.0687 87.4023 26.7794C87.2215 26.4721 87.1763 26.1828 87.2667 25.9116C87.3752 25.6224 87.6192 25.3964 87.9989 25.2337C88.6678 24.9082 89.4 24.6461 90.1955 24.4472C91.0091 24.2484 91.8045 24.1489 92.5819 24.1489C94.2452 24.1489 95.4836 24.4834 96.2972 25.1523C97.1108 25.8032 97.5175 26.9964 97.5175 28.732V35.2676C97.5175 35.5568 97.5356 35.7467 97.5718 35.8371C97.626 35.9094 97.7435 35.9727 97.9243 36.0269C98.1413 36.0992 98.3763 36.1625 98.6294 36.2167C98.8825 36.2529 99.0091 36.3433 99.0091 36.4879C99.0091 37.0845 98.7017 37.4461 98.087 37.5727C97.6893 37.6631 97.3277 37.7082 97.0023 37.7082C96.4238 37.7082 96.0079 37.5998 95.7548 37.3828C95.5017 37.1659 95.33 36.7772 95.2396 36.2167C94.7514 36.7049 94.1368 37.0664 93.3955 37.3015C92.6543 37.5365 91.904 37.6721 91.1447 37.7082ZM91.1718 35.5659C91.9311 35.5478 92.6181 35.4393 93.2328 35.2405C93.8656 35.0235 94.3627 34.7252 94.7243 34.3455C95.0859 33.9478 95.2486 33.4777 95.2125 32.9354C95.1763 32.4292 94.9142 32.0676 94.426 31.8506C93.956 31.6337 93.3503 31.5433 92.6091 31.5794C91.9401 31.5975 91.3255 31.7241 90.765 31.9591C90.2045 32.176 89.7526 32.4653 89.4091 32.8269C89.0836 33.1885 88.9209 33.5953 88.9209 34.0472C88.939 34.5534 89.1469 34.9421 89.5447 35.2133C89.9424 35.4664 90.4848 35.584 91.1718 35.5659Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M74.0796 37.4913C73.2661 37.4913 72.8593 37.0574 72.8593 36.1896V25.7489C72.8593 24.8992 73.2299 24.4744 73.9711 24.4744C74.7305 24.4744 75.1192 24.6913 75.1372 25.1252L75.1915 26.1557C75.5711 25.6133 76.0774 25.1433 76.7101 24.7455C77.361 24.3478 78.1022 24.1489 78.9339 24.1489C80.3079 24.1489 81.4197 24.5919 82.2695 25.4777C83.1373 26.3455 83.5711 27.6111 83.5711 29.2743V36.1896C83.5711 37.0574 83.1644 37.4913 82.3508 37.4913C81.5553 37.4913 81.1576 37.0574 81.1576 36.1896V29.7896C81.1576 28.6506 80.9045 27.8009 80.3983 27.2405C79.8921 26.6619 79.2322 26.3727 78.4186 26.3727C77.4966 26.3727 76.7463 26.68 76.1678 27.2947C75.5892 27.8913 75.3 28.6958 75.3 29.7082V36.1896C75.3 37.0574 74.8932 37.4913 74.0796 37.4913Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M62.9559 37.844C61.6361 37.844 60.4068 37.627 59.2678 37.1931C58.1469 36.7592 57.1796 36.0541 56.3661 35.0779C56.113 34.7344 56.0135 34.418 56.0678 34.1287C56.1401 33.8214 56.348 33.5683 56.6915 33.3694C57.0169 33.1705 57.3152 33.1073 57.5864 33.1796C57.8757 33.2338 58.165 33.4146 58.4542 33.7219C58.9966 34.2824 59.6474 34.7163 60.4068 35.0236C61.1661 35.3129 62.0429 35.4575 63.0373 35.4575C64.3028 35.4575 65.2881 35.2044 65.9932 34.6982C66.6983 34.192 67.0508 33.4508 67.0508 32.4745C67.0508 31.896 66.9243 31.3988 66.6712 30.983C66.4181 30.5491 65.9118 30.1604 65.1525 29.8169C64.3932 29.4734 63.2452 29.1479 61.7085 28.8406C58.2192 28.0813 56.4746 26.3005 56.4746 23.4982C56.4746 22.4135 56.7367 21.4643 57.261 20.6508C57.7853 19.8372 58.5175 19.2044 59.4576 18.7524C60.3977 18.2824 61.4915 18.0474 62.739 18.0474C63.9683 18.0474 65.0712 18.2643 66.0474 18.6982C67.0237 19.114 67.8825 19.6654 68.6237 20.3524C68.8949 20.6417 69.0124 20.94 68.9763 21.2474C68.9401 21.5547 68.7683 21.8349 68.461 22.088C68.1356 22.3411 67.8282 22.4496 67.539 22.4135C67.2678 22.3773 66.9785 22.2146 66.6712 21.9253C66.1288 21.4734 65.5412 21.1208 64.9085 20.8677C64.2757 20.5965 63.5435 20.4609 62.7118 20.4609C61.6633 20.4609 60.7864 20.714 60.0813 21.2202C59.3943 21.7084 59.0508 22.4315 59.0508 23.3897C59.0508 23.896 59.1593 24.357 59.3763 24.7728C59.6113 25.1705 60.0361 25.5231 60.6508 25.8304C61.2655 26.1378 62.1604 26.418 63.3356 26.6711C65.5774 27.1411 67.1864 27.8462 68.1627 28.7863C69.157 29.7265 69.6542 30.9468 69.6542 32.4474C69.6542 33.6044 69.365 34.5897 68.7864 35.4033C68.226 36.1988 67.4395 36.8044 66.4271 37.2202C65.4328 37.6361 64.2757 37.844 62.9559 37.844Z",
                fill: "#ffffff"
            })
        ]
    });
};



var $b5060ee6f843df16$exports = {};

$parcel$export($b5060ee6f843df16$exports, "button", () => $b5060ee6f843df16$export$2ba01fb71ed41cb6, (v) => $b5060ee6f843df16$export$2ba01fb71ed41cb6 = v);
$parcel$export($b5060ee6f843df16$exports, "buttons", () => $b5060ee6f843df16$export$bbea856fdb3e3c5f, (v) => $b5060ee6f843df16$export$bbea856fdb3e3c5f = v);
$parcel$export($b5060ee6f843df16$exports, "container", () => $b5060ee6f843df16$export$34e0f9847d4c02dd, (v) => $b5060ee6f843df16$export$34e0f9847d4c02dd = v);
$parcel$export($b5060ee6f843df16$exports, "divider", () => $b5060ee6f843df16$export$e8c9778bf415dd08, (v) => $b5060ee6f843df16$export$e8c9778bf415dd08 = v);
var $b5060ee6f843df16$export$2ba01fb71ed41cb6;
var $b5060ee6f843df16$export$bbea856fdb3e3c5f;
var $b5060ee6f843df16$export$34e0f9847d4c02dd;
var $b5060ee6f843df16$export$e8c9778bf415dd08;
$b5060ee6f843df16$export$2ba01fb71ed41cb6 = `YXHMgW_button`;
$b5060ee6f843df16$export$bbea856fdb3e3c5f = `YXHMgW_buttons`;
$b5060ee6f843df16$export$34e0f9847d4c02dd = `YXHMgW_container`;
$b5060ee6f843df16$export$e8c9778bf415dd08 = `YXHMgW_divider`;



const $140f6cffec511506$export$750134880a51a661 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_289_149",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "25",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "0.5",
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_289_149)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5.88626 19.3386C5.41376 19.3386 5.0116 19.1726 4.67976 18.8406C4.34776 18.5088 4.18176 18.1059 4.18176 17.6319V6.36837C4.18176 5.89437 4.34776 5.49145 4.67976 5.15962C5.0116 4.82762 5.41376 4.66162 5.88626 4.66162H19.1138C19.5863 4.66162 19.9884 4.82762 20.3203 5.15962C20.6523 5.49145 20.8183 5.89437 20.8183 6.36837V17.6319C20.8183 18.1059 20.6523 18.5088 20.3203 18.8406C19.9884 19.1726 19.5863 19.3386 19.1138 19.3386H5.88626ZM5.88851 17.9396H19.1115C19.1885 17.9396 19.259 17.9075 19.323 17.8434C19.3872 17.7792 19.4193 17.7087 19.4193 17.6319V6.36837C19.4193 6.29154 19.3872 6.22104 19.323 6.15687C19.259 6.0927 19.1885 6.06062 19.1115 6.06062H5.88851C5.81151 6.06062 5.74101 6.0927 5.67701 6.15687C5.61285 6.22104 5.58076 6.29154 5.58076 6.36837V17.6319C5.58076 17.7087 5.61285 17.7792 5.67701 17.8434C5.74101 17.9075 5.81151 17.9396 5.88851 17.9396Z",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};



const $6e4cb90fe614acf7$export$cf6b3df9a088a692 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_289_153",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "25",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "0.5",
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_289_153)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M11.523 19.298V6.6652H6.21149V4.68945H18.798V6.6652H13.4865V19.298H11.523Z",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};



const $52830e1917b9f0ca$export$cf9b56e4032a149f = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_264_177",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                mask: "url(#mask0_264_177)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                        id: "mask1_264_177",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "24",
                        height: "24",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "#D9D9D9"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                        mask: "url(#mask1_264_177)",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M4.59802 20.4614C4.28019 20.5319 4.00652 20.4524 3.77702 20.2229C3.54752 19.9934 3.46802 19.7197 3.53852 19.4019L4.37502 15.3864L8.61352 19.6249L4.59802 20.4614ZM8.61352 19.6249L4.37502 15.3864L15.5943 4.16715C15.9391 3.82232 16.366 3.6499 16.875 3.6499C17.384 3.6499 17.8109 3.82232 18.1558 4.16715L19.8328 5.84415C20.1776 6.18899 20.35 6.6159 20.35 7.1249C20.35 7.6339 20.1776 8.06082 19.8328 8.40565L8.61352 19.6249ZM16.6635 5.22115L6.43852 15.4364L8.56352 17.5614L18.7788 7.3364C18.8364 7.27874 18.8653 7.20665 18.8653 7.12015C18.8653 7.03349 18.8364 6.96132 18.7788 6.90365L17.0963 5.22115C17.0386 5.16349 16.9664 5.13465 16.8798 5.13465C16.7933 5.13465 16.7212 5.16349 16.6635 5.22115Z",
                            fill: "#A3A3A3"
                        })
                    })
                ]
            })
        ]
    });
};



const $1085830bdb421514$export$4c2ba81155d7eb6f = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_264_183",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_264_183)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5.7146 18.2979V8.8989H7.1136V15.9134L18.3173 4.7019L19.2981 5.68265L8.09435 16.8989H15.1136V18.2979H5.7146Z",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};



const $b95fc45607bce483$export$37653ff4fb6d58d2 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_264_186",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_264_186)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12.0022 21.2979C10.7163 21.2979 9.50749 21.0536 8.37565 20.5649C7.24365 20.0761 6.25899 19.4127 5.42165 18.5749C4.58449 17.7371 3.9219 16.7533 3.4339 15.6237C2.9459 14.4938 2.7019 13.2867 2.7019 12.0022C2.7019 10.7163 2.94624 9.50749 3.4349 8.37565C3.92374 7.24365 4.58707 6.25899 5.4249 5.42165C6.26274 4.58449 7.24649 3.9219 8.37615 3.4339C9.50599 2.9459 10.7132 2.7019 11.9977 2.7019C13.2835 2.7019 14.4923 2.94624 15.6242 3.4349C16.7562 3.92374 17.7408 4.58707 18.5782 5.4249C19.4153 6.26274 20.0779 7.24649 20.5659 8.37615C21.0539 9.50599 21.2979 10.7132 21.2979 11.9977C21.2979 13.2835 21.0536 14.4923 20.5649 15.6242C20.0761 16.7562 19.4127 17.7408 18.5749 18.5782C17.7371 19.4153 16.7533 20.0779 15.6237 20.5659C14.4938 21.0539 13.2867 21.2979 12.0022 21.2979ZM11.9997 19.8989C14.1978 19.8989 16.0639 19.1321 17.5979 17.5984C19.1319 16.0646 19.8989 14.1985 19.8989 12.0002C19.8989 9.80199 19.1321 7.9359 17.5984 6.4019C16.0646 4.8679 14.1985 4.1009 12.0002 4.1009C9.80199 4.1009 7.9359 4.86774 6.4019 6.4014C4.8679 7.93524 4.1009 9.80132 4.1009 11.9997C4.1009 14.1978 4.86774 16.0639 6.4014 17.5979C7.93524 19.1319 9.80132 19.8989 11.9997 19.8989ZM11.7904 16.6489H13.1894V7.3509H9.81041V8.7499H11.7904V16.6489Z",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};



const $87936ff1a2c5d539$export$d57a6b1113c4c4d0 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_264_187",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_264_187)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12.2463 18.8461C12.4207 18.8295 12.5642 18.7642 12.6771 18.6504C12.7899 18.5366 12.8463 18.3993 12.8463 18.2386C12.8463 18.0513 12.7848 17.9028 12.6618 17.7931C12.5388 17.6835 12.3817 17.637 12.1906 17.6536C11.5072 17.7036 10.763 17.5034 9.95782 17.0529C9.15266 16.6022 8.65007 15.8186 8.45007 14.7019C8.41674 14.5314 8.34524 14.3974 8.23557 14.2999C8.12607 14.2024 7.99566 14.1536 7.84432 14.1536C7.66232 14.1536 7.51282 14.222 7.39582 14.3586C7.27882 14.4951 7.23791 14.6704 7.27307 14.8844C7.54357 16.3371 8.19749 17.3756 9.23482 17.9999C10.272 18.6242 11.2758 18.9063 12.2463 18.8461ZM11.9983 21.3989C9.89249 21.3989 8.13316 20.6726 6.72032 19.2201C5.30749 17.7676 4.60107 15.9609 4.60107 13.7999C4.60107 12.2756 5.21982 10.5887 6.45732 8.73939C7.69482 6.89006 9.54241 4.89514 12.0001 2.75464C14.4577 4.89514 16.3053 6.89006 17.5428 8.73939C18.7803 10.5887 19.3991 12.2756 19.3991 13.7999C19.3991 15.9609 18.6921 17.7676 17.2781 19.2201C15.8641 20.6726 14.1042 21.3989 11.9983 21.3989ZM12.0001 19.9999C13.7334 19.9999 15.1667 19.4124 16.3001 18.2374C17.4334 17.0624 18.0001 15.5832 18.0001 13.7999C18.0001 12.5832 17.4959 11.2082 16.4876 9.67489C15.4792 8.14156 13.9834 6.46656 12.0001 4.64989C10.0167 6.46656 8.52091 8.14156 7.51257 9.67489C6.50424 11.2082 6.00007 12.5832 6.00007 13.7999C6.00007 15.5832 6.56674 17.0624 7.70007 18.2374C8.83341 19.4124 10.2667 19.9999 12.0001 19.9999Z",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};



const $1e19bdd639104192$export$39f5b3d9bf1a7e6d = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "8",
                y: "4",
                width: "4",
                height: "4",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4",
                y: "8",
                width: "4",
                height: "4",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "8",
                y: "12",
                width: "4",
                height: "4",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4",
                y: "16",
                width: "4",
                height: "4",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "12",
                y: "16",
                width: "4",
                height: "4",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "12",
                y: "8",
                width: "4",
                height: "4",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "16",
                y: "4",
                width: "4",
                height: "4",
                fill: "#A3A3A3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "16",
                y: "12",
                width: "4",
                height: "4",
                fill: "#A3A3A3"
            })
        ]
    });
};



const $82ffb759530075e0$export$bfdbcf2db3e1bfd1 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_264_188",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_264_188)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: "4",
                    y: "5",
                    width: "16",
                    height: "14",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");

function $b488a2b318a95c87$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}







var $acw62 = parcelRequire("acw62");
const $f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $f9ad7d2f57cc5bec$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)($f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $acw62.useContext)($f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || 'ltr';
}
const $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;




var $acw62 = parcelRequire("acw62");
/** Number of components which have requested interest to have focus guards */ let $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count = 0;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    (0, $acw62.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll('[data-radix-focus-guard]');
        document.body.insertAdjacentElement('afterbegin', (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement('beforeend', (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll('[data-radix-focus-guard]').forEach((node)=>node.remove());
            $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement('span');
    element.setAttribute('data-radix-focus-guard', '');
    element.tabIndex = 0;
    element.style.cssText = 'outline: none; opacity: 0; position: fixed; pointer-events: none';
    return element;
}
const $264faec0fdf8876a$export$be92b6f5f03c0fe9 = $264faec0fdf8876a$export$ac5b58043b79449b;




var $acw62 = parcelRequire("acw62");



const $03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = 'focusScope.autoFocusOnMount';
const $03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = 'focusScope.autoFocusOnUnmount';
const $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $03c48a27777929a8$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = 'FocusScope';
const $03c48a27777929a8$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $acw62.useState)(null);
    const onMountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $acw62.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $acw62.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener('focusin', handleFocusIn);
            document.addEventListener('focusout', handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener('focusin', handleFocusIn);
                document.removeEventListener('focusout', handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $acw62.useEffect)(()=>{
        if (container1) {
            $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusFirst($03c48a27777929a8$var$$d3863c46a17e8a28$var$removeLinks($03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($03c48a27777929a8$export$20e40289641fbbb6, {
    displayName: $03c48a27777929a8$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$03c48a27777929a8$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === 'hidden') return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === 'none') return true;
        node = node.parentElement;
    }
    return false;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && 'select' in element;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== 'A');
}
const $03c48a27777929a8$export$be92b6f5f03c0fe9 = $03c48a27777929a8$export$20e40289641fbbb6;



var $acw62 = parcelRequire("acw62");

const $11885ec535b13ccc$var$$1746a345f3d73bb7$var$useReactId = $acw62['useId'.toString()] || (()=>undefined);
let $11885ec535b13ccc$var$$1746a345f3d73bb7$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($11885ec535b13ccc$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : '');
}




var $acw62 = parcelRequire("acw62");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $10310cf078d13212$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $10310cf078d13212$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$d6c4e8150c35fed1(element) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $461947879dcdbcd4$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $461947879dcdbcd4$var$isTopLayer(element) {
    return $461947879dcdbcd4$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? $461947879dcdbcd4$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? $461947879dcdbcd4$var$isTopLayer(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ($461947879dcdbcd4$var$isTopLayer(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $238ac70369f38756$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");

var $23a8f689f1d4c3be$var$index = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23a8f689f1d4c3be$var$roundByDPR(element, value) {
    const dpr = $23a8f689f1d4c3be$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $11492dca620dcaa5$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23a8f689f1d4c3be$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.x);
        const y = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23a8f689f1d4c3be$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $461947879dcdbcd4$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $461947879dcdbcd4$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $23a8f689f1d4c3be$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $23a8f689f1d4c3be$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $23a8f689f1d4c3be$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $23a8f689f1d4c3be$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $23a8f689f1d4c3be$export$346677f925de839c = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $23a8f689f1d4c3be$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $23a8f689f1d4c3be$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $23a8f689f1d4c3be$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $461947879dcdbcd4$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$23a8f689f1d4c3be$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });




var $acw62 = parcelRequire("acw62");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $1002b17d420264b2$var$$7e8f5cd07187803e$var$NAME = 'Arrow';
const $1002b17d420264b2$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).svg, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $acw62.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($1002b17d420264b2$export$21b07c8f274aebd5, {
    displayName: $1002b17d420264b2$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $1002b17d420264b2$export$be92b6f5f03c0fe9 = $1002b17d420264b2$export$21b07c8f274aebd5;








var $acw62 = parcelRequire("acw62");

function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $acw62.useState)(undefined);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ('borderBoxSize' in entry) {
                    const borderSizeEntry = entry['borderBoxSize']; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize['inlineSize'];
                    height = borderSize['blockSize'];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: 'border-box'
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $a0ac11a1da65e329$export$36f0086da09c4b9f = [
    'top',
    'right',
    'bottom',
    'left'
];
const $a0ac11a1da65e329$export$3671ffab7b302fc9 = [
    'start',
    'center',
    'end'
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = 'Popper';
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext, $a0ac11a1da65e329$export$722aac194ae923] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperProvider, $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $a0ac11a1da65e329$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $acw62.createElement)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$badac9ada3a0bdf9, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = 'PopperAnchor';
const $a0ac11a1da65e329$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$ecd4e1ccab6ed6d, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = 'PopperContent';
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$useContentContext] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $a0ac11a1da65e329$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper, side: side = 'bottom', sideOffset: sideOffset = 0, align: align = 'center', alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = 'partial', hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = 'optimized', onPlaced: onPlaced, ...contentProps } = props;
    const context = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $acw62.useState)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $acw62.useState)(null);
    const arrowSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== 'center' ? '-' + align : '');
    const collisionPadding = typeof collisionPaddingProp === 'number' ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $23a8f689f1d4c3be$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: 'fixed',
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $461947879dcdbcd4$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === 'always'
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $23a8f689f1d4c3be$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $23a8f689f1d4c3be$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === 'partial' ? (0, $23a8f689f1d4c3be$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $23a8f689f1d4c3be$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $23a8f689f1d4c3be$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty('--radix-popper-available-width', `${availableWidth}px`);
                    contentStyle.setProperty('--radix-popper-available-height', `${availableHeight}px`);
                    contentStyle.setProperty('--radix-popper-anchor-width', `${anchorWidth}px`);
                    contentStyle.setProperty('--radix-popper-anchor-height', `${anchorHeight}px`);
                }
            }),
            arrow && (0, $23a8f689f1d4c3be$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $23a8f689f1d4c3be$export$fe8985bb6374093c)({
                strategy: 'referenceHidden',
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPlaced);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $acw62.useState)();
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : 'translate(0, -200%)',
            // keep off the page when measuring
            minWidth: 'max-content',
            zIndex: contentZIndex,
            ['--radix-popper-transform-origin']: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(' ')
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $acw62.createElement)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? 'none' : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$bc4ae5855d3c4fc, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = 'PopperArrow';
const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
};
const $a0ac11a1da65e329$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $acw62.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$useContentContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $acw62.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: 'absolute',
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: '',
                right: '0 0',
                bottom: 'center 0',
                left: '100% 0'
            }[contentContext.placedSide],
            transform: {
                top: 'translateY(100%)',
                right: 'translateY(50%) rotate(90deg) translateX(-50%)',
                bottom: `rotate(180deg)`,
                left: 'translateY(50%) rotate(-90deg) translateX(50%)'
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? 'hidden' : undefined
        }
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $1002b17d420264b2$export$be92b6f5f03c0fe9), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: 'block'
        }
    }))));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$79d62cd4e10a3fd0, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: 'transformOrigin',
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: '0%',
                center: '50%',
                end: '100%'
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = '';
            let y = '';
            if (placedSide === 'bottom') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === 'top') {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === 'right') {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === 'left') {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = 'center'] = placement.split('-');
    return [
        side,
        align
    ];
}
const $a0ac11a1da65e329$export$be92b6f5f03c0fe9 = $a0ac11a1da65e329$export$badac9ada3a0bdf9;
const $a0ac11a1da65e329$export$b688253958b8dfe7 = $a0ac11a1da65e329$export$ecd4e1ccab6ed6d;
const $a0ac11a1da65e329$export$7c6e2c02157bb7d2 = $a0ac11a1da65e329$export$bc4ae5855d3c4fc;
const $a0ac11a1da65e329$export$21b07c8f274aebd5 = $a0ac11a1da65e329$export$79d62cd4e10a3fd0;









var $acw62 = parcelRequire("acw62");
function $44b714300f6a50aa$export$5cae361ad82dce8b(value) {
    const ref = (0, $acw62.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0, $acw62.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}



var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState(function() {
        return (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;


const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$OPEN_KEYS = [
    ' ',
    'Enter',
    'ArrowUp',
    'ArrowDown'
];
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SELECTION_KEYS = [
    ' ',
    'Enter'
];
/* -------------------------------------------------------------------------------------------------
 * Select
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SELECT_NAME = 'Select';
const [$a53039b89a0365f7$var$$cc7e05a45900e73f$var$Collection, $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useCollection, $a53039b89a0365f7$var$$cc7e05a45900e73f$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$a53039b89a0365f7$var$$cc7e05a45900e73f$var$createSelectContext, $a53039b89a0365f7$export$286727a75dc039bd] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SELECT_NAME, [
    $a53039b89a0365f7$var$$cc7e05a45900e73f$var$createCollectionScope,
    (0, $a0ac11a1da65e329$export$722aac194ae923)
]);
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$usePopperScope = (0, $a0ac11a1da65e329$export$722aac194ae923)();
const [$a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectProvider, $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext] = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$createSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SELECT_NAME);
const [$a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$createSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SELECT_NAME);
const $a53039b89a0365f7$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required } = props;
    const popperScope = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = (0, $acw62.useState)(null);
    const [valueNode, setValueNode] = (0, $acw62.useState)(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = (0, $acw62.useState)(false);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [open = false, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = (0, $acw62.useRef)(null); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = trigger ? Boolean(trigger.closest('form')) : true;
    const [nativeOptionsSet, setNativeOptionsSet] = (0, $acw62.useState)(new Set()); // The native `select` only associates the correct default value if the corresponding
    // `option` is rendered as a child **at the same time** as itself.
    // Because it might take a few renders for our items to gather the information to build
    // the native `option`(s), we generate a key on the `select` to make sure React re-builds it
    // each time the options change.
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(';');
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectProvider, {
        required: required,
        scope: __scopeSelect,
        trigger: trigger,
        onTriggerChange: setTrigger,
        valueNode: valueNode,
        onValueNodeChange: setValueNode,
        valueNodeHasChildren: valueNodeHasChildren,
        onValueNodeHasChildrenChange: setValueNodeHasChildren,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        open: open,
        onOpenChange: setOpen,
        dir: direction,
        triggerPointerDownPosRef: triggerPointerDownPosRef,
        disabled: disabled
    }, /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$Collection.Provider, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
        scope: props.__scopeSelect,
        onNativeOptionAdd: (0, $acw62.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>new Set(prev).add(option));
        }, []),
        onNativeOptionRemove: (0, $acw62.useCallback)((option)=>{
            setNativeOptionsSet((prev)=>{
                const optionsSet = new Set(prev);
                optionsSet.delete(option);
                return optionsSet;
            });
        }, [])
    }, children)), isFormControl ? /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$BubbleSelect, {
        key: nativeSelectKey,
        "aria-hidden": true,
        required: required,
        tabIndex: -1,
        name: name,
        autoComplete: autoComplete,
        value: value // enable form autofill
        ,
        onChange: (event)=>setValue(event.target.value),
        disabled: disabled
    }, value === undefined ? /*#__PURE__*/ (0, $acw62.createElement)("option", {
        value: ""
    }) : null, Array.from(nativeOptionsSet)) : null));
};
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$ef9b1a59e592288f, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SELECT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$TRIGGER_NAME = 'SelectTrigger';
const $a53039b89a0365f7$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== undefined) context.onValueChange(nextItem.value);
    });
    const handleOpen = ()=>{
        if (!isDisabled) {
            context.onOpenChange(true); // reset typeahead when we open
            resetTypeahead();
        }
    };
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$b688253958b8dfe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        role: "combobox",
        "aria-controls": context.contentId,
        "aria-expanded": context.open,
        "aria-required": context.required,
        "aria-autocomplete": "none",
        dir: context.dir,
        "data-state": context.open ? 'open' : 'closed',
        disabled: isDisabled,
        "data-disabled": isDisabled ? '' : undefined,
        "data-placeholder": $a53039b89a0365f7$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? '' : undefined
    }, triggerProps, {
        ref: composedRefs // Enable compatibility with native label or custom `Label` "click" for Safari:
        ,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
            // Whilst browsers generally have no issue focusing the trigger when clicking
            // on a label, Safari seems to struggle with the fact that there's no `onClick`.
            // We force `focus` in this case. Note: this doesn't create any other side-effect
            // because we are preventing default in `onPointerDown` so effectively
            // this only runs for a label "click"
            event.currentTarget.focus();
        }),
        onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
            // prevent implicit pointer capture
            // https://www.w3.org/TR/pointerevents3/#implicit-pointer-capture
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (event.button === 0 && event.ctrlKey === false) {
                handleOpen();
                context.triggerPointerDownPosRef.current = {
                    x: Math.round(event.pageX),
                    y: Math.round(event.pageY)
                }; // prevent trigger from stealing focus from the active item after opening.
                event.preventDefault();
            }
        }),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
            const isTypingAhead = searchRef.current !== '';
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if (isTypingAhead && event.key === ' ') return;
            if ($a53039b89a0365f7$var$$cc7e05a45900e73f$var$OPEN_KEYS.includes(event.key)) {
                handleOpen();
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$3ac1e88a1c0b9f1, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectValue
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$VALUE_NAME = 'SelectValue';
const $a53039b89a0365f7$export$e288731fd71264f0 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = '', ...valueProps } = props;
    const context = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== undefined;
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, valueProps, {
        ref: composedRefs // we don't want events from the portalled `SelectValue` children to bubble
        ,
        style: {
            pointerEvents: 'none'
        }
    }), $a53039b89a0365f7$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(context.value) ? /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, placeholder) : children);
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$e288731fd71264f0, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$VALUE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectIcon
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ICON_NAME = 'SelectIcon';
const $a53039b89a0365f7$export$99b400cabb58c515 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, iconProps, {
        ref: forwardedRef
    }), children || "\u25BC");
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$99b400cabb58c515, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ICON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPortal
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$PORTAL_NAME = 'SelectPortal';
const $a53039b89a0365f7$export$b2af6c9944296213 = (props)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $95d053caea9c023a$export$602eac185826482c), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        asChild: true
    }, props));
};
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$b2af6c9944296213, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContent
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_NAME = 'SelectContent';
const $a53039b89a0365f7$export$c973a4b3cb86a03d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = (0, $acw62.useState)(); // setting the fragment in `useLayoutEffect` as `DocumentFragment` doesn't exist on the server
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectContentProvider, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$Collection.Slot, {
            scope: props.__scopeSelect
        }, /*#__PURE__*/ (0, $acw62.createElement)("div", null, props.children))), frag) : null;
    }
    return /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$c973a4b3cb86a03d, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectContentImpl
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN = 10;
const [$a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectContentProvider, $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext] = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$createSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_NAME);
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME = 'SelectContentImpl';
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = 'item-aligned', onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, ...contentProps } = props;
    const context = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = (0, $acw62.useState)(null);
    const [viewport, setViewport] = (0, $acw62.useState)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = (0, $acw62.useState)(null);
    const [selectedItemText, setSelectedItemText] = (0, $acw62.useState)(null);
    const getItems = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = (0, $acw62.useState)(false);
    const firstValidItemFoundRef = (0, $acw62.useRef)(false); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $acw62.useEffect)(()=>{
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, [
        content
    ]); // Make sure the whole tree has focus guards as our `Select` may be
    // the last element in the DOM (because of the `Portal`)
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    const focusFirst = (0, $acw62.useCallback)((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            // if focus is already where we want to go, we don't want to keep going through the candidates
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate === null || candidate === void 0 || candidate.scrollIntoView({
                block: 'nearest'
            }); // viewport might have padding so scroll to its edges when focusing first/last items.
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate === null || candidate === void 0 || candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = (0, $acw62.useCallback)(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]); // Since this is not dependent on layout, we want to ensure this runs at the same time as
    // other effects across components. Hence why we don't call `focusSelectedItem` inside `position`.
    (0, $acw62.useEffect)(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]); // prevent selecting items on `pointerup` in some cases after opening from `pointerdown`
    // and close on `pointerup` outside.
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    (0, $acw62.useEffect)(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
                    y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
                };
            };
            const handlePointerUp = (event)=>{
                // If the pointer hasn't moved by a certain threshold then we prevent selecting item on `pointerup`.
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener('pointermove', handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener('pointermove', handlePointerMove);
                document.addEventListener('pointerup', handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener('pointermove', handlePointerMove);
                document.removeEventListener('pointerup', handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener('blur', close);
        window.addEventListener('resize', close);
        return ()=>{
            window.removeEventListener('blur', close);
            window.removeEventListener('resize', close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = (0, $acw62.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = (0, $acw62.useCallback)(()=>content === null || content === void 0 ? void 0 : content.focus(), [
        content
    ]);
    const itemTextRefCallback = (0, $acw62.useCallback)((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== undefined && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === 'popper' ? $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectPopperPosition : $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition; // Silently ignore props that are not supported by `SelectItemAlignedPosition`
    const popperContentProps = SelectPosition === $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        as: (0, $cf381de56a25bc52$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
        asChild: true // we make sure we're not trapping once it's been closed
        ,
        trapped: context.open,
        onMountAutoFocus: (event)=>{
            // we prevent open autofocus because we manually focus the selected item
            event.preventDefault();
        },
        onUnmountAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
            var _context$trigger;
            (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
                preventScroll: true
            });
            event.preventDefault();
        })
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: true,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside // When focus is trapped, a focusout event may still happen.
        ,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: ()=>context.onOpenChange(false)
    }, /*#__PURE__*/ (0, $acw62.createElement)(SelectPosition, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "listbox",
        id: context.contentId,
        "data-state": context.open ? 'open' : 'closed',
        dir: context.dir,
        onContextMenu: (event)=>event.preventDefault()
    }, contentProps, popperContentProps, {
        onPlaced: ()=>setIsPositioned(true),
        ref: composedRefs,
        style: {
            // flex layout so we can place the scroll buttons properly
            display: 'flex',
            flexDirection: 'column',
            // reset the outline by default as the content MAY get focused
            outline: 'none',
            ...contentProps.style
        },
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey; // select should not be navigated using tab key so we prevent it
            if (event.key === 'Tab') event.preventDefault();
            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
            if ([
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End'
            ].includes(event.key)) {
                const items = getItems().filter((item)=>!item.disabled);
                let candidateNodes = items.map((item)=>item.ref.current);
                if ([
                    'ArrowUp',
                    'End'
                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                if ([
                    'ArrowUp',
                    'ArrowDown'
                ].includes(event.key)) {
                    const currentElement = event.target;
                    const currentIndex = candidateNodes.indexOf(currentElement);
                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>focusFirst(candidateNodes));
                event.preventDefault();
            }
        })
    }))))));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectContentImpl, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_IMPL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemAlignedPosition
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME = 'SelectItemAlignedPosition';
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = (0, $acw62.useState)(null);
    const [content, setContent] = (0, $acw62.useState)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = (0, $acw62.useRef)(false);
    const shouldRepositionRef = (0, $acw62.useRef)(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = (0, $acw62.useCallback)(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect(); // -----------------------------------------------------------------------------------------
            //  Horizontal positioning
            // -----------------------------------------------------------------------------------------
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== 'rtl') {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedLeft = (0, $b488a2b318a95c87$export$7d15b64cf5a3a4c4)(left, [
                    $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    rightEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + 'px';
                contentWrapper.style.left = clampedLeft + 'px';
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
                const clampedRight = (0, $b488a2b318a95c87$export$7d15b64cf5a3a4c4)(right, [
                    $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN,
                    leftEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + 'px';
                contentWrapper.style.right = clampedRight + 'px';
            } // -----------------------------------------------------------------------------------------
            // Vertical positioning
            // -----------------------------------------------------------------------------------------
            const items = getItems();
            const availableHeight = window.innerHeight - $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth; // prettier-ignore
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + 'px';
            } else {
                const isFirstItem = selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + 'px';
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + 'px';
            contentWrapper.style.maxHeight = availableHeight + 'px'; // -----------------------------------------------------------------------------------------
            onPlaced === null || onPlaced === void 0 || onPlaced(); // we don't want the initial scroll position adjustment to trigger "expand on scroll"
            // so we explicitly turn it on only after they've registered.
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]); // copy z-index from content to wrapper
    const [contentZIndex, setContentZIndex] = (0, $acw62.useState)();
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]); // When the viewport becomes scrollable at the top, the scroll up button will mount.
    // Because it is part of the normal flow, it will push down the viewport, thus throwing our
    // trigger => selectedItem alignment off by the amount the viewport was pushed down.
    // We wait for this to happen and then re-run the positining logic one more time to account for it.
    const handleScrollButtonChange = (0, $acw62.useCallback)((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem === null || focusSelectedItem === void 0 || focusSelectedItem();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange
    }, /*#__PURE__*/ (0, $acw62.createElement)("div", {
        ref: setContentWrapper,
        style: {
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            zIndex: contentZIndex
        }
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperProps, {
        ref: composedRefs,
        style: {
            // When we get the height of the content, it includes borders. If we were to set
            // the height without having `boxSizing: 'border-box'` it would be too big.
            boxSizing: 'border-box',
            // We need to ensure the content doesn't get taller than the wrapper
            maxHeight: '100%',
            ...popperProps.style
        }
    }))));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectItemAlignedPosition, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_ALIGNED_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectPopperPosition
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME = 'SelectPopperPosition';
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectPopperPosition = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = 'start', collisionPadding: collisionPadding = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$7c6e2c02157bb7d2), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, popperProps, {
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: 'border-box',
            ...popperProps.style,
            '--radix-select-content-transform-origin': 'var(--radix-popper-transform-origin)',
            '--radix-select-content-available-width': 'var(--radix-popper-available-width)',
            '--radix-select-content-available-height': 'var(--radix-popper-available-height)',
            '--radix-select-trigger-width': 'var(--radix-popper-anchor-width)',
            '--radix-select-trigger-height': 'var(--radix-popper-anchor-height)'
        }
    }));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectPopperPosition, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$POPPER_POSITION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectViewport
 * -----------------------------------------------------------------------------------------------*/ const [$a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectViewportProvider, $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectViewportContext] = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$createSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_NAME, {});
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$VIEWPORT_NAME = 'SelectViewport';
const $a53039b89a0365f7$export$9ed6e7b40248d36d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...viewportProps } = props;
    const contentContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectViewportContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = (0, $acw62.useRef)(0);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$Collection.Slot, {
        scope: __scopeSelect
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-radix-select-viewport": "",
        role: "presentation"
    }, viewportProps, {
        ref: composedRefs,
        style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: 'relative',
            flex: 1,
            overflow: 'auto',
            ...viewportProps.style
        },
        onScroll: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
            const viewport = event.currentTarget;
            const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
            if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
                const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                if (scrolledBy > 0) {
                    const availableHeight = window.innerHeight - $a53039b89a0365f7$var$$cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
                    const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                    const cssHeight = parseFloat(contentWrapper.style.height);
                    const prevHeight = Math.max(cssMinHeight, cssHeight);
                    if (prevHeight < availableHeight) {
                        const nextHeight = prevHeight + scrolledBy;
                        const clampedNextHeight = Math.min(availableHeight, nextHeight);
                        const heightDiff = nextHeight - clampedNextHeight;
                        contentWrapper.style.height = clampedNextHeight + 'px';
                        if (contentWrapper.style.bottom === '0px') {
                            viewport.scrollTop = heightDiff > 0 ? heightDiff : 0; // ensure the content stays pinned to the bottom
                            contentWrapper.style.justifyContent = 'flex-end';
                        }
                    }
                }
            }
            prevScrollTopRef.current = viewport.scrollTop;
        })
    }))));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$9ed6e7b40248d36d, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectGroup
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$GROUP_NAME = 'SelectGroup';
const [$a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectGroupContext] = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$createSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$GROUP_NAME);
const $a53039b89a0365f7$export$ee25a334c55de1f4 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "group",
        "aria-labelledby": groupId
    }, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$ee25a334c55de1f4, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectLabel
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$LABEL_NAME = 'SelectLabel';
const $a53039b89a0365f7$export$f67338d29bd972f8 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectGroupContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$LABEL_NAME, __scopeSelect);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: groupContext.id
    }, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$f67338d29bd972f8, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItem
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_NAME = 'SelectItem';
const [$a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectItemContextProvider, $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectItemContext] = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$createSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_NAME);
const $a53039b89a0365f7$export$13ef48a934230896 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const contentContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = (0, $acw62.useState)(textValueProp !== null && textValueProp !== void 0 ? textValueProp : '');
    const [isFocused, setIsFocused] = (0, $acw62.useState)(false);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>{
        var _contentContext$itemR;
        return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node, value, disabled);
    });
    const textId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === '') throw new Error('A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.');
    return /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: (0, $acw62.useCallback)((node)=>{
            setTextValue((prevTextValue)=>{
                var _node$textContent;
                return prevTextValue || ((_node$textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : '').trim();
            });
        }, [])
    }, /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$Collection.ItemSlot, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textValue: textValue
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "option",
        "aria-labelledby": textId,
        "data-highlighted": isFocused ? '' : undefined // `isFocused` caveat fixes stuttering in VoiceOver
        ,
        "aria-selected": isSelected && isFocused,
        "data-state": isSelected ? 'checked' : 'unchecked',
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? '' : undefined,
        tabIndex: disabled ? undefined : -1
    }, itemProps, {
        ref: composedRefs,
        onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
        onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
        onPointerUp: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onPointerUp, handleSelect),
        onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
            if (disabled) {
                var _contentContext$onIte;
                (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
            } else // as it only means it might scroll a few pixels when using the pointer.
            event.currentTarget.focus({
                preventScroll: true
            });
        }),
        onPointerLeave: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
            if (event.currentTarget === document.activeElement) {
                var _contentContext$onIte2;
                (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
            }
        }),
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
            var _contentContext$searc;
            const isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== '';
            if (isTypingAhead && event.key === ' ') return;
            if ($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SELECTION_KEYS.includes(event.key)) handleSelect(); // prevent page scroll if using the space key to select an item
            if (event.key === ' ') event.preventDefault();
        })
    }))));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$13ef48a934230896, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemText
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME = 'SelectItemText';
const $a53039b89a0365f7$export$3572fb0fb821ff49 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    // We ignore `className` and `style` as this part shouldn't be styled.
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectItemContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectNativeOptionsContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = (0, $acw62.useState)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>{
        var _contentContext$itemT;
        return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node, itemContext.value, itemContext.disabled);
    });
    const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
    const nativeOption = (0, $acw62.useMemo)(()=>/*#__PURE__*/ (0, $acw62.createElement)("option", {
            key: itemContext.value,
            value: itemContext.value,
            disabled: itemContext.disabled
        }, textContent), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: itemContext.textId
    }, itemTextProps, {
        ref: composedRefs
    })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(itemTextProps.children, context.valueNode) : null);
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$3572fb0fb821ff49, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_TEXT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME = 'SelectItemIndicator';
const $a53039b89a0365f7$export$6b9198de19accfe6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectItemContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, itemIndicatorProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$6b9198de19accfe6, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollUpButton
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME = 'SelectScrollUpButton';
const $a53039b89a0365f7$export$d8117927658af6d7 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const contentContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectViewportContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp1, setCanScrollUp] = (0, $acw62.useState)(false);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const canScrollUp = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp);
            }
            handleScroll();
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp1 ? /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$d8117927658af6d7, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectScrollDownButton
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME = 'SelectScrollDownButton';
const $a53039b89a0365f7$export$ff951e476c12189 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const contentContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectViewportContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown1, setCanScrollDown] = (0, $acw62.useState)(false);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            const viewport = contentContext.viewport;
            function handleScroll() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight; // we use Math.ceil here because if the UI is zoomed-in
                // `scrollTop` is not always reported as an integer
                const canScrollDown = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown);
            }
            handleScroll();
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown1 ? /*#__PURE__*/ (0, $acw62.createElement)($a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    })) : null;
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$ff951e476c12189, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME
});
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SelectScrollButtonImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext('SelectScrollButton', __scopeSelect);
    const autoScrollTimerRef = (0, $acw62.useRef)(null);
    const getItems = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = (0, $acw62.useCallback)(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]); // When the viewport becomes scrollable on either side, the relevant scroll button will mount.
    // Because it is part of the normal flow, it will push down (top button) or shrink (bottom button)
    // the viewport, potentially causing the active item to now be partially out of view.
    // We re-run the `scrollIntoView` logic to make sure it stays within the viewport.
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        var _activeItem$ref$curre;
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem === null || activeItem === void 0 || (_activeItem$ref$curre = activeItem.ref.current) === null || _activeItem$ref$curre === void 0 || _activeItem$ref$curre.scrollIntoView({
            block: 'nearest'
        });
    }, [
        getItems
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, scrollIndicatorProps, {
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            var _contentContext$onIte3;
            (_contentContext$onIte3 = contentContext.onItemLeave) === null || _contentContext$onIte3 === void 0 || _contentContext$onIte3.call(contentContext);
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    }));
});
/* -------------------------------------------------------------------------------------------------
 * SelectSeparator
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SEPARATOR_NAME = 'SelectSeparator';
const $a53039b89a0365f7$export$eba4b1df07cb1d3 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": true
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$eba4b1df07cb1d3, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SelectArrow
 * -----------------------------------------------------------------------------------------------*/ const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ARROW_NAME = 'SelectArrow';
const $a53039b89a0365f7$export$314f4cb8f8099628 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
    const context = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    const contentContext = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useSelectContentContext($a53039b89a0365f7$var$$cc7e05a45900e73f$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === 'popper' ? /*#__PURE__*/ (0, $acw62.createElement)((0, $a0ac11a1da65e329$export$21b07c8f274aebd5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($a53039b89a0365f7$export$314f4cb8f8099628, {
    displayName: $a53039b89a0365f7$var$$cc7e05a45900e73f$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $a53039b89a0365f7$var$$cc7e05a45900e73f$var$shouldShowPlaceholder(value) {
    return value === '' || value === undefined;
}
const $a53039b89a0365f7$var$$cc7e05a45900e73f$var$BubbleSelect = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { value: value, ...selectProps } = props;
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $44b714300f6a50aa$export$5cae361ad82dce8b)(value); // Bubble value change to parents (e.g form change event)
    (0, $acw62.useEffect)(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, 'value');
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event('change', {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    /**
   * We purposefully use a `select` here to support form autofill as much
   * as possible.
   *
   * We purposefully do not add the `value` attribute here to allow the value
   * to be set programatically and bubble to any parent form `onChange` event.
   * Adding the `value` will cause React to consider the programatic
   * dispatch a duplicate and it will get swallowed.
   *
   * We use `VisuallyHidden` rather than `display: "none"` because Safari autofill
   * won't work otherwise.
   */ return /*#__PURE__*/ (0, $acw62.createElement)((0, $8d51f093cc1b6735$export$439d29a4e110a164), {
        asChild: true
    }, /*#__PURE__*/ (0, $acw62.createElement)("select", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, selectProps, {
        ref: composedRefs,
        defaultValue: value
    })));
});
$a53039b89a0365f7$var$$cc7e05a45900e73f$var$BubbleSelect.displayName = 'BubbleSelect';
function $a53039b89a0365f7$var$$cc7e05a45900e73f$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = (0, $acw62.useRef)('');
    const timerRef = (0, $acw62.useRef)(0);
    const handleTypeaheadSearch = (0, $acw62.useCallback)((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current); // Reset `searchRef` 1 second after it was last updated
            if (value !== '') timerRef.current = window.setTimeout(()=>updateSearch(''), 1000);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = (0, $acw62.useCallback)(()=>{
        searchRef.current = '';
        window.clearTimeout(timerRef.current);
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in a list of items,
 * the search and the current item, and returns the next item (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through items starting with that character)
 *
 * We also reorder the items by wrapping the array around the current item.
 * This is so we always look forward from the current item, and picking the first
 * item will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current item from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current item still matches.
 */ function $a53039b89a0365f7$var$$cc7e05a45900e73f$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $a53039b89a0365f7$var$$cc7e05a45900e73f$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : undefined;
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $a53039b89a0365f7$var$$cc7e05a45900e73f$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $a53039b89a0365f7$export$be92b6f5f03c0fe9 = $a53039b89a0365f7$export$ef9b1a59e592288f;
const $a53039b89a0365f7$export$41fb9f06171c75f4 = $a53039b89a0365f7$export$3ac1e88a1c0b9f1;
const $a53039b89a0365f7$export$4c8d1a57a761ef94 = $a53039b89a0365f7$export$e288731fd71264f0;
const $a53039b89a0365f7$export$f04a61298a47a40f = $a53039b89a0365f7$export$99b400cabb58c515;
const $a53039b89a0365f7$export$602eac185826482c = $a53039b89a0365f7$export$b2af6c9944296213;
const $a53039b89a0365f7$export$7c6e2c02157bb7d2 = $a53039b89a0365f7$export$c973a4b3cb86a03d;
const $a53039b89a0365f7$export$d5c6c08dc2d3ca7 = $a53039b89a0365f7$export$9ed6e7b40248d36d;
const $a53039b89a0365f7$export$eb2fcfdbd7ba97d4 = $a53039b89a0365f7$export$ee25a334c55de1f4;
const $a53039b89a0365f7$export$b04be29aa201d4f5 = $a53039b89a0365f7$export$f67338d29bd972f8;
const $a53039b89a0365f7$export$6d08773d2e66f8f2 = $a53039b89a0365f7$export$13ef48a934230896;
const $a53039b89a0365f7$export$d6e5bf9c43ea9319 = $a53039b89a0365f7$export$3572fb0fb821ff49;
const $a53039b89a0365f7$export$c3468e2714d175fa = $a53039b89a0365f7$export$6b9198de19accfe6;
const $a53039b89a0365f7$export$2f60d3ec9ad468f2 = $a53039b89a0365f7$export$d8117927658af6d7;
const $a53039b89a0365f7$export$bf1aedc3039c8d63 = $a53039b89a0365f7$export$ff951e476c12189;
const $a53039b89a0365f7$export$1ff3c3f08ae963c0 = $a53039b89a0365f7$export$eba4b1df07cb1d3;
const $a53039b89a0365f7$export$21b07c8f274aebd5 = $a53039b89a0365f7$export$314f4cb8f8099628;


var $db919f6269360e53$exports = {};

$parcel$export($db919f6269360e53$exports, "circle", () => $db919f6269360e53$export$e1d786d2f707b414, (v) => $db919f6269360e53$export$e1d786d2f707b414 = v);
$parcel$export($db919f6269360e53$exports, "content", () => $db919f6269360e53$export$a7db06668cad9adb, (v) => $db919f6269360e53$export$a7db06668cad9adb = v);
$parcel$export($db919f6269360e53$exports, "item", () => $db919f6269360e53$export$7061c75fc5af8b7e, (v) => $db919f6269360e53$export$7061c75fc5af8b7e = v);
$parcel$export($db919f6269360e53$exports, "items", () => $db919f6269360e53$export$17a1664ed1fb5d6f, (v) => $db919f6269360e53$export$17a1664ed1fb5d6f = v);
$parcel$export($db919f6269360e53$exports, "trigger", () => $db919f6269360e53$export$e614dc9140f7ae71, (v) => $db919f6269360e53$export$e614dc9140f7ae71 = v);
var $db919f6269360e53$export$e1d786d2f707b414;
var $db919f6269360e53$export$a7db06668cad9adb;
var $db919f6269360e53$export$7061c75fc5af8b7e;
var $db919f6269360e53$export$17a1664ed1fb5d6f;
var $db919f6269360e53$export$e614dc9140f7ae71;
$db919f6269360e53$export$e1d786d2f707b414 = `VJpQWW_circle`;
$db919f6269360e53$export$a7db06668cad9adb = `VJpQWW_content`;
$db919f6269360e53$export$7061c75fc5af8b7e = `VJpQWW_item`;
$db919f6269360e53$export$17a1664ed1fb5d6f = `VJpQWW_items`;
$db919f6269360e53$export$e614dc9140f7ae71 = `VJpQWW_trigger`;


const $99f7af2f53b86eaa$export$ac58b777a02d288e = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$be92b6f5f03c0fe9, {
        value: props.color,
        disabled: props.disabled,
        onValueChange: props.onChange,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$41fb9f06171c75f4, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).trigger,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-size": props.size,
                    "data-black": props.color === "black",
                    style: {
                        backgroundColor: `var(--color-${props.color})`
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$7c6e2c02157bb7d2, {
                    position: "popper",
                    side: "bottom",
                    align: "center",
                    sideOffset: 16,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).content,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$21b07c8f274aebd5, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$d5c6c08dc2d3ca7, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).items,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "pink",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).item,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            backgroundColor: "var(--color-pink)"
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "red",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).item,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            backgroundColor: "var(--color-red)"
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "orange",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).item,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            backgroundColor: "var(--color-orange)"
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "green",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).item,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            backgroundColor: "var(--color-green)"
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "cyan",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).item,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            backgroundColor: "var(--color-cyan)"
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "purple",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).item,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            backgroundColor: "var(--color-purple)"
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "white",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).item,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            backgroundColor: "var(--color-white)"
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "black",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).item,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        "data-black": true,
                                        style: {
                                            backgroundColor: "var(--color-black)"
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($db919f6269360e53$exports))).circle
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};




var $8315d2960f609c43$exports = {};

$parcel$export($8315d2960f609c43$exports, "circle", () => $8315d2960f609c43$export$e1d786d2f707b414, (v) => $8315d2960f609c43$export$e1d786d2f707b414 = v);
$parcel$export($8315d2960f609c43$exports, "content", () => $8315d2960f609c43$export$a7db06668cad9adb, (v) => $8315d2960f609c43$export$a7db06668cad9adb = v);
$parcel$export($8315d2960f609c43$exports, "item", () => $8315d2960f609c43$export$7061c75fc5af8b7e, (v) => $8315d2960f609c43$export$7061c75fc5af8b7e = v);
$parcel$export($8315d2960f609c43$exports, "items", () => $8315d2960f609c43$export$17a1664ed1fb5d6f, (v) => $8315d2960f609c43$export$17a1664ed1fb5d6f = v);
$parcel$export($8315d2960f609c43$exports, "trigger", () => $8315d2960f609c43$export$e614dc9140f7ae71, (v) => $8315d2960f609c43$export$e614dc9140f7ae71 = v);
var $8315d2960f609c43$export$e1d786d2f707b414;
var $8315d2960f609c43$export$a7db06668cad9adb;
var $8315d2960f609c43$export$7061c75fc5af8b7e;
var $8315d2960f609c43$export$17a1664ed1fb5d6f;
var $8315d2960f609c43$export$e614dc9140f7ae71;
$8315d2960f609c43$export$e1d786d2f707b414 = `BPs-lq_circle`;
$8315d2960f609c43$export$a7db06668cad9adb = `BPs-lq_content`;
$8315d2960f609c43$export$7061c75fc5af8b7e = `BPs-lq_item`;
$8315d2960f609c43$export$17a1664ed1fb5d6f = `BPs-lq_items`;
$8315d2960f609c43$export$e614dc9140f7ae71 = `BPs-lq_trigger`;



const $92c5458c1b152a55$export$1bea1ce1f953f2e5 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "30",
        height: "24",
        viewBox: "0 0 30 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M24.979 18.1878C24.2003 18.1878 23.475 18.0543 22.803 17.7871C22.1416 17.52 21.571 17.0859 21.091 16.4849C20.9416 16.2734 20.883 16.0786 20.915 15.9005C20.9576 15.7113 21.0803 15.5555 21.283 15.433C21.475 15.3106 21.651 15.2717 21.811 15.3162C21.9816 15.3496 22.1523 15.4609 22.323 15.6501C22.643 15.9951 23.027 16.2623 23.475 16.4515C23.923 16.6296 24.4403 16.7186 25.027 16.7186C25.7736 16.7186 26.355 16.5628 26.771 16.2511C27.187 15.9395 27.395 15.4831 27.395 14.8821C27.395 14.5259 27.3203 14.2198 27.171 13.9638C27.0216 13.6967 26.723 13.4574 26.275 13.2459C25.827 13.0344 25.1496 12.8341 24.243 12.6449C22.1843 12.1774 21.155 11.081 21.155 9.35583C21.155 8.688 21.3096 8.10365 21.619 7.60278C21.9283 7.10191 22.3603 6.71235 22.915 6.43409C23.4696 6.1447 24.115 6 24.851 6C25.5763 6 26.227 6.13357 26.803 6.4007C27.379 6.6567 27.8856 6.99617 28.323 7.41913C28.483 7.59722 28.5523 7.78087 28.531 7.97009C28.5096 8.1593 28.4083 8.33183 28.227 8.48765C28.035 8.64348 27.8536 8.71026 27.683 8.688C27.523 8.66574 27.3523 8.56557 27.171 8.38748C26.851 8.10922 26.5043 7.89217 26.131 7.73635C25.7576 7.56939 25.3256 7.48591 24.835 7.48591C24.2163 7.48591 23.699 7.64174 23.283 7.95339C22.8776 8.25391 22.675 8.69913 22.675 9.28904C22.675 9.6007 22.739 9.88452 22.867 10.1405C23.0056 10.3854 23.2563 10.6024 23.619 10.7917C23.9816 10.9809 24.5096 11.1534 25.203 11.3092C26.5256 11.5986 27.475 12.0327 28.051 12.6115C28.6376 13.1903 28.931 13.9416 28.931 14.8654C28.931 15.5777 28.7603 16.1843 28.419 16.6852C28.0883 17.175 27.6243 17.5478 27.027 17.8038C26.4403 18.0598 25.7576 18.1878 24.979 18.1878Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.5824 17.9709C11.209 17.9709 10.985 17.8707 10.9104 17.6704C10.8357 17.47 10.873 17.2474 11.0224 17.0025L14.1744 11.8436L11.3424 7.25228C11.129 6.9295 11.0757 6.6902 11.1824 6.53437C11.289 6.36741 11.5237 6.28394 11.8864 6.28394C12.2917 6.28394 12.5957 6.46202 12.7984 6.8182L14.9744 10.4578L17.1344 6.8182C17.337 6.46202 17.641 6.28394 18.0464 6.28394C18.761 6.28394 18.9424 6.60672 18.5904 7.25228L15.7744 11.8436L18.9264 17.0025C19.097 17.2808 19.1344 17.5145 19.0384 17.7038C18.953 17.8818 18.7237 17.9709 18.3504 17.9709C17.945 17.9709 17.641 17.7928 17.4384 17.4366L14.9744 13.246L12.4944 17.4366C12.2917 17.7928 11.9877 17.9709 11.5824 17.9709Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M1.76988 17.9709C1.39655 17.9709 1.17255 17.8707 1.09788 17.6704C1.02321 17.47 1.06055 17.2474 1.20988 17.0025L4.36188 11.8436L1.52988 7.25228C1.31655 6.9295 1.26321 6.6902 1.36988 6.53437C1.47655 6.36741 1.71121 6.28394 2.07388 6.28394C2.47921 6.28394 2.78321 6.46202 2.98588 6.8182L5.16188 10.4578L7.32188 6.8182C7.52455 6.46202 7.82855 6.28394 8.23388 6.28394C8.94855 6.28394 9.12988 6.60672 8.77788 7.25228L5.96188 11.8436L9.11388 17.0025C9.28455 17.2808 9.32188 17.5145 9.22588 17.7038C9.14055 17.8818 8.91121 17.9709 8.53788 17.9709C8.13255 17.9709 7.82855 17.7928 7.62588 17.4366L5.16188 13.246L2.68188 17.4366C2.47921 17.7928 2.17521 17.9709 1.76988 17.9709Z",
                fill: "#ffffff"
            })
        ]
    });
};



const $c37abf5fb3df3cbd$export$4d263e43cf890d18 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "30",
        height: "24",
        viewBox: "0 0 30 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20.0727 18.1878C19.294 18.1878 18.5687 18.0543 17.8967 17.7871C17.2354 17.52 16.6647 17.0859 16.1847 16.4849C16.0354 16.2734 15.9767 16.0786 16.0087 15.9005C16.0514 15.7113 16.174 15.5555 16.3767 15.433C16.5687 15.3106 16.7447 15.2717 16.9047 15.3162C17.0754 15.3496 17.246 15.4609 17.4167 15.6501C17.7367 15.9951 18.1207 16.2623 18.5687 16.4515C19.0167 16.6296 19.534 16.7186 20.1207 16.7186C20.8674 16.7186 21.4487 16.5628 21.8647 16.2511C22.2807 15.9395 22.4887 15.4831 22.4887 14.8821C22.4887 14.5259 22.414 14.2198 22.2647 13.9638C22.1154 13.6967 21.8167 13.4574 21.3687 13.2459C20.9207 13.0344 20.2434 12.8341 19.3367 12.6449C17.278 12.1774 16.2487 11.081 16.2487 9.35583C16.2487 8.688 16.4034 8.10365 16.7127 7.60278C17.022 7.10191 17.454 6.71235 18.0087 6.43409C18.5634 6.1447 19.2087 6 19.9447 6C20.67 6 21.3207 6.13357 21.8967 6.4007C22.4727 6.6567 22.9794 6.99617 23.4167 7.41913C23.5767 7.59722 23.646 7.78087 23.6247 7.97009C23.6034 8.1593 23.502 8.33183 23.3207 8.48765C23.1287 8.64348 22.9474 8.71026 22.7767 8.688C22.6167 8.66574 22.446 8.56557 22.2647 8.38748C21.9447 8.10922 21.598 7.89217 21.2247 7.73635C20.8514 7.56939 20.4194 7.48591 19.9287 7.48591C19.31 7.48591 18.7927 7.64174 18.3767 7.95339C17.9714 8.25391 17.7687 8.69913 17.7687 9.28904C17.7687 9.6007 17.8327 9.88452 17.9607 10.1405C18.0994 10.3854 18.35 10.6024 18.7127 10.7917C19.0754 10.9809 19.6034 11.1534 20.2967 11.3092C21.6194 11.5986 22.5687 12.0327 23.1447 12.6115C23.7314 13.1903 24.0247 13.9416 24.0247 14.8654C24.0247 15.5777 23.854 16.1843 23.5127 16.6852C23.182 17.175 22.718 17.5478 22.1207 17.8038C21.534 18.0598 20.8514 18.1878 20.0727 18.1878Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.67613 17.9709C6.3028 17.9709 6.0788 17.8707 6.00413 17.6704C5.92946 17.47 5.9668 17.2474 6.11613 17.0025L9.26813 11.8436L6.43613 7.25228C6.2228 6.9295 6.16946 6.6902 6.27613 6.53437C6.3828 6.36741 6.61746 6.28394 6.98013 6.28394C7.38546 6.28394 7.68946 6.46202 7.89213 6.8182L10.0681 10.4578L12.2281 6.8182C12.4308 6.46202 12.7348 6.28394 13.1401 6.28394C13.8548 6.28394 14.0361 6.60672 13.6841 7.25228L10.8681 11.8436L14.0201 17.0025C14.1908 17.2808 14.2281 17.5145 14.1321 17.7038C14.0468 17.8818 13.8175 17.9709 13.4441 17.9709C13.0388 17.9709 12.7348 17.7928 12.5321 17.4366L10.0681 13.246L7.58813 17.4366C7.38546 17.7928 7.08146 17.9709 6.67613 17.9709Z",
                fill: "#ffffff"
            })
        ]
    });
};



const $509c5a4c72f89786$export$851929eef26cf223 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "30",
        height: "24",
        viewBox: "0 0 30 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.1665 18.1878C14.3878 18.1878 13.6625 18.0543 12.9905 17.7871C12.3291 17.52 11.7585 17.0859 11.2785 16.4849C11.1291 16.2734 11.0705 16.0786 11.1025 15.9005C11.1451 15.7113 11.2678 15.5555 11.4705 15.433C11.6625 15.3106 11.8385 15.2717 11.9985 15.3162C12.1691 15.3496 12.3398 15.4609 12.5105 15.6501C12.8305 15.9951 13.2145 16.2623 13.6625 16.4515C14.1105 16.6296 14.6278 16.7186 15.2145 16.7186C15.9611 16.7186 16.5425 16.5628 16.9585 16.2511C17.3745 15.9395 17.5825 15.4831 17.5825 14.8821C17.5825 14.5259 17.5078 14.2198 17.3585 13.9638C17.2091 13.6967 16.9105 13.4574 16.4625 13.2459C16.0145 13.0344 15.3371 12.8341 14.4305 12.6449C12.3718 12.1774 11.3425 11.081 11.3425 9.35583C11.3425 8.688 11.4971 8.10365 11.8065 7.60278C12.1158 7.10191 12.5478 6.71235 13.1025 6.43409C13.6571 6.1447 14.3025 6 15.0385 6C15.7638 6 16.4145 6.13357 16.9905 6.4007C17.5665 6.6567 18.0731 6.99617 18.5105 7.41913C18.6705 7.59722 18.7398 7.78087 18.7185 7.97009C18.6971 8.1593 18.5958 8.33183 18.4145 8.48765C18.2225 8.64348 18.0411 8.71026 17.8705 8.688C17.7105 8.66574 17.5398 8.56557 17.3585 8.38748C17.0385 8.10922 16.6918 7.89217 16.3185 7.73635C15.9451 7.56939 15.5131 7.48591 15.0225 7.48591C14.4038 7.48591 13.8865 7.64174 13.4705 7.95339C13.0651 8.25391 12.8625 8.69913 12.8625 9.28904C12.8625 9.6007 12.9265 9.88452 13.0545 10.1405C13.1931 10.3854 13.4438 10.6024 13.8065 10.7917C14.1691 10.9809 14.6971 11.1534 15.3905 11.3092C16.7131 11.5986 17.6625 12.0327 18.2385 12.6115C18.8251 13.1903 19.1185 13.9416 19.1185 14.8654C19.1185 15.5777 18.9478 16.1843 18.6065 16.6852C18.2758 17.175 17.8118 17.5478 17.2145 17.8038C16.6278 18.0598 15.9451 18.1878 15.1665 18.1878Z",
            fill: "#ffffff"
        })
    });
};



const $839e02a56bf09a37$export$d84ffeaa631bf7d2 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "30",
        height: "24",
        viewBox: "0 0 30 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.7882 17.687C10.2976 17.687 10.0522 17.4198 10.0522 16.8856V6.80139C10.0522 6.50087 10.1216 6.29496 10.2602 6.18365C10.4096 6.06122 10.6282 6 10.9162 6C11.3109 6 11.6096 6.17809 11.8122 6.53426L14.9962 11.7934L18.1482 6.55096C18.2656 6.32835 18.4042 6.18365 18.5642 6.11687C18.7349 6.03896 18.9429 6 19.1882 6C19.7002 6 19.9562 6.26713 19.9562 6.80139V16.8856C19.9562 17.4198 19.7056 17.687 19.2042 17.687C18.7029 17.687 18.4522 17.4198 18.4522 16.8856V8.65461L15.7162 13.2626C15.5349 13.6188 15.2949 13.7969 14.9962 13.7969C14.7082 13.7969 14.4629 13.6188 14.2602 13.2626L11.5242 8.65461V16.8856C11.5242 17.4198 11.2789 17.687 10.7882 17.687Z",
            fill: "#ffffff"
        })
    });
};



const $cceb788e4bfcf3fa$export$bdb28ad671d0d4f3 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "30",
        height: "24",
        viewBox: "0 0 30 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.4527 17.687C11.9514 17.687 11.7007 17.4198 11.7007 16.8856V6.80139C11.7007 6.26713 11.9407 6 12.4207 6C12.9113 6 13.1567 6.26713 13.1567 6.80139V16.2511H18.3887C18.9007 16.2511 19.1567 16.4904 19.1567 16.969C19.1567 17.4477 18.9007 17.687 18.3887 17.687H12.4527Z",
            fill: "#ffffff"
        })
    });
};



const $4a647ae2f8d5db13$export$e39b7378496006f8 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "30",
        height: "24",
        viewBox: "0 0 30 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M17.3589 17.687C16.8576 17.687 16.6069 17.4198 16.6069 16.8856V6.80139C16.6069 6.26713 16.8469 6 17.3269 6C17.8176 6 18.0629 6.26713 18.0629 6.80139V16.2511H23.2949C23.8069 16.2511 24.0629 16.4904 24.0629 16.969C24.0629 17.4477 23.8069 17.687 23.2949 17.687H17.3589Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.08238 17.687C6.70905 17.687 6.48505 17.5868 6.41038 17.3864C6.33571 17.1861 6.37305 16.9635 6.52238 16.7186L9.67438 11.5597L6.84238 6.96835C6.62905 6.64557 6.57571 6.40626 6.68238 6.25043C6.78905 6.08348 7.02371 6 7.38638 6C7.79171 6 8.09571 6.17809 8.29838 6.53426L10.4744 10.1739L12.6344 6.53426C12.837 6.17809 13.141 6 13.5464 6C14.261 6 14.4424 6.32278 14.0904 6.96835L11.2744 11.5597L14.4264 16.7186C14.597 16.9969 14.6344 17.2306 14.5384 17.4198C14.453 17.5979 14.2237 17.687 13.8504 17.687C13.445 17.687 13.141 17.5089 12.9384 17.1527L10.4744 12.9621L7.99438 17.1527C7.79171 17.5089 7.48771 17.687 7.08238 17.687Z",
                fill: "#ffffff"
            })
        ]
    });
};



const $83eff81d30692e25$export$52ec02c980a1dc63 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "30",
        height: "24",
        viewBox: "0 0 30 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22.2652 17.687C21.7638 17.687 21.5132 17.4198 21.5132 16.8856V6.80139C21.5132 6.26713 21.7532 6 22.2332 6C22.7238 6 22.9692 6.26713 22.9692 6.80139V16.2511H28.2012C28.7132 16.2511 28.9692 16.4904 28.9692 16.969C28.9692 17.4477 28.7132 17.687 28.2012 17.687H22.2652Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.9886 17.687C11.6153 17.687 11.3913 17.5868 11.3166 17.3864C11.242 17.1861 11.2793 16.9635 11.4286 16.7186L14.5806 11.5597L11.7486 6.96835C11.5353 6.64557 11.482 6.40626 11.5886 6.25043C11.6953 6.08348 11.93 6 12.2926 6C12.698 6 13.002 6.17809 13.2046 6.53426L15.3806 10.1739L17.5406 6.53426C17.7433 6.17809 18.0473 6 18.4526 6C19.1673 6 19.3486 6.32278 18.9966 6.96835L16.1806 11.5597L19.3326 16.7186C19.5033 16.9969 19.5406 17.2306 19.4446 17.4198C19.3593 17.5979 19.13 17.687 18.7566 17.687C18.3513 17.687 18.0473 17.5089 17.8446 17.1527L15.3806 12.9621L12.9006 17.1527C12.698 17.5089 12.394 17.687 11.9886 17.687Z",
                fill: "#ffffff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2.17613 17.687C1.8028 17.687 1.5788 17.5868 1.50413 17.3864C1.42946 17.1861 1.4668 16.9635 1.61613 16.7186L4.76813 11.5597L1.93613 6.96835C1.7228 6.64557 1.66946 6.40626 1.77613 6.25043C1.8828 6.08348 2.11746 6 2.48013 6C2.88546 6 3.18946 6.17809 3.39213 6.53426L5.56813 10.1739L7.72813 6.53426C7.9308 6.17809 8.2348 6 8.64013 6C9.3548 6 9.53613 6.32278 9.18413 6.96835L6.36813 11.5597L9.52013 16.7186C9.6908 16.9969 9.72813 17.2306 9.63213 17.4198C9.5468 17.5979 9.31746 17.687 8.94413 17.687C8.5388 17.687 8.2348 17.5089 8.03213 17.1527L5.56813 12.9621L3.08813 17.1527C2.88546 17.5089 2.58146 17.687 2.17613 17.687Z",
                fill: "#ffffff"
            })
        ]
    });
};



const $2b63db6ffa0205c8$export$6ac67942725de328 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$be92b6f5f03c0fe9, {
        value: props.size,
        disabled: props.disabled,
        onValueChange: props.onChange,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$41fb9f06171c75f4, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).trigger,
                children: props.size === "xxs" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92c5458c1b152a55$export$1bea1ce1f953f2e5), {}) : props.size === "xs" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c37abf5fb3df3cbd$export$4d263e43cf890d18), {}) : props.size === "s" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $509c5a4c72f89786$export$851929eef26cf223), {}) : props.size === "m" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839e02a56bf09a37$export$d84ffeaa631bf7d2), {}) : props.size === "l" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cceb788e4bfcf3fa$export$bdb28ad671d0d4f3), {}) : props.size === "xl" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a647ae2f8d5db13$export$e39b7378496006f8), {}) : props.size === "xxl" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83eff81d30692e25$export$52ec02c980a1dc63), {}) : (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(props.size)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$7c6e2c02157bb7d2, {
                    position: "popper",
                    side: "bottom",
                    align: "center",
                    sideOffset: 16,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).content,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a53039b89a0365f7$export$21b07c8f274aebd5, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$d5c6c08dc2d3ca7, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).items,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "xxs",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).item,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "data-size": "xxs",
                                            style: {
                                                backgroundColor: `var(--color-${props.color})`
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).circle
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92c5458c1b152a55$export$1bea1ce1f953f2e5), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "xs",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).item,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "data-size": "xs",
                                            style: {
                                                backgroundColor: `var(--color-${props.color})`
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).circle
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c37abf5fb3df3cbd$export$4d263e43cf890d18), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "s",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).item,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "data-size": "s",
                                            style: {
                                                backgroundColor: `var(--color-${props.color})`
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).circle
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $509c5a4c72f89786$export$851929eef26cf223), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "m",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).item,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "data-size": "m",
                                            style: {
                                                backgroundColor: `var(--color-${props.color})`
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).circle
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839e02a56bf09a37$export$d84ffeaa631bf7d2), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "l",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).item,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "data-size": "l",
                                            style: {
                                                backgroundColor: `var(--color-${props.color})`
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).circle
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cceb788e4bfcf3fa$export$bdb28ad671d0d4f3), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "xl",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).item,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "data-size": "xl",
                                            style: {
                                                backgroundColor: `var(--color-${props.color})`
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).circle
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a647ae2f8d5db13$export$e39b7378496006f8), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a53039b89a0365f7$export$6d08773d2e66f8f2, {
                                    value: "xxl",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).item,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "data-size": "xxl",
                                            style: {
                                                backgroundColor: `var(--color-${props.color})`
                                            },
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8315d2960f609c43$exports))).circle
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83eff81d30692e25$export$52ec02c980a1dc63), {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $14cbf222c2b76d82$exports = {};

$parcel$export($14cbf222c2b76d82$exports, "content", () => $14cbf222c2b76d82$export$a7db06668cad9adb, (v) => $14cbf222c2b76d82$export$a7db06668cad9adb = v);
$parcel$export($14cbf222c2b76d82$exports, "shortcut", () => $14cbf222c2b76d82$export$ec0409edb5e28490, (v) => $14cbf222c2b76d82$export$ec0409edb5e28490 = v);
var $14cbf222c2b76d82$export$a7db06668cad9adb;
var $14cbf222c2b76d82$export$ec0409edb5e28490;
$14cbf222c2b76d82$export$a7db06668cad9adb = `WBjuMG_content`;
$14cbf222c2b76d82$export$ec0409edb5e28490 = `WBjuMG_shortcut`;



var $acw62 = parcelRequire("acw62");
// packages/core/primitive/src/primitive.tsx
function $58245b29e19b2b51$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $484a8a8d895e606e$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $484a8a8d895e606e$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$484a8a8d895e606e$var$setRef(ref, node));
}
function $484a8a8d895e606e$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($484a8a8d895e606e$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $acw62 = parcelRequire("acw62");

function $604ad36f30a88545$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $604ad36f30a88545$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $604ad36f30a88545$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $604ad36f30a88545$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



var $acw62 = parcelRequire("acw62");

// packages/react/primitive/src/Primitive.tsx

var $acw62 = parcelRequire("acw62");

// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");


var $9c21d6a8a74cf628$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($9c21d6a8a74cf628$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9c21d6a8a74cf628$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9c21d6a8a74cf628$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$9c21d6a8a74cf628$export$8c6ed5c666ac1360.displayName = "Slot";
var $9c21d6a8a74cf628$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $9c21d6a8a74cf628$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$9c21d6a8a74cf628$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $484a8a8d895e606e$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$9c21d6a8a74cf628$var$SlotClone.displayName = "SlotClone";
var $9c21d6a8a74cf628$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $9c21d6a8a74cf628$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $9c21d6a8a74cf628$export$d9f1ccf0bdb05d45;
}
function $9c21d6a8a74cf628$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $9c21d6a8a74cf628$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $9c21d6a8a74cf628$export$be92b6f5f03c0fe9 = $9c21d6a8a74cf628$export$8c6ed5c666ac1360;



var $a7518daafddc6d54$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $a7518daafddc6d54$export$250ffa63cdc0d034 = $a7518daafddc6d54$var$NODES.reduce((primitive, node)=>{
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $9c21d6a8a74cf628$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $a7518daafddc6d54$export$6d1a0317bde7de7f(target, event) {
    if (target) $11492dca620dcaa5$exports.flushSync(()=>target.dispatchEvent(event));
}
var $a7518daafddc6d54$export$be92b6f5f03c0fe9 = $a7518daafddc6d54$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $acw62 = parcelRequire("acw62");
function $d24d4a7daae9b449$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $acw62 = parcelRequire("acw62");

function $fd0f1c0a6020f840$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $d24d4a7daae9b449$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $acw62.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $e3648ecbc57173f6$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $e3648ecbc57173f6$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $e3648ecbc57173f6$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $e3648ecbc57173f6$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $e3648ecbc57173f6$var$originalBodyPointerEvents;
var $e3648ecbc57173f6$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $e3648ecbc57173f6$export$177fb62ff3ec1f22 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($e3648ecbc57173f6$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $484a8a8d895e606e$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $e3648ecbc57173f6$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $e3648ecbc57173f6$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $fd0f1c0a6020f840$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $e3648ecbc57173f6$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $e3648ecbc57173f6$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $e3648ecbc57173f6$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $e3648ecbc57173f6$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($e3648ecbc57173f6$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($e3648ecbc57173f6$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7518daafddc6d54$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$e3648ecbc57173f6$export$177fb62ff3ec1f22.displayName = $e3648ecbc57173f6$var$DISMISSABLE_LAYER_NAME;
var $e3648ecbc57173f6$var$BRANCH_NAME = "DismissableLayerBranch";
var $e3648ecbc57173f6$export$4d5eb2109db14228 = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $acw62.useContext($e3648ecbc57173f6$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $484a8a8d895e606e$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7518daafddc6d54$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$e3648ecbc57173f6$export$4d5eb2109db14228.displayName = $e3648ecbc57173f6$var$BRANCH_NAME;
function $e3648ecbc57173f6$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $d24d4a7daae9b449$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $e3648ecbc57173f6$var$handleAndDispatchCustomEvent($e3648ecbc57173f6$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $e3648ecbc57173f6$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $d24d4a7daae9b449$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $e3648ecbc57173f6$var$handleAndDispatchCustomEvent($e3648ecbc57173f6$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $e3648ecbc57173f6$var$dispatchUpdate() {
    const event = new CustomEvent($e3648ecbc57173f6$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $e3648ecbc57173f6$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $a7518daafddc6d54$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $e3648ecbc57173f6$export$be92b6f5f03c0fe9 = $e3648ecbc57173f6$export$177fb62ff3ec1f22;
var $e3648ecbc57173f6$export$aecb2ddcb55c95be = $e3648ecbc57173f6$export$4d5eb2109db14228;


// packages/react/id/src/id.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $acw62 = parcelRequire("acw62");
var $e937e9875ed92bf3$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $acw62.useLayoutEffect : ()=>{};


var $e9caa37128205ed4$var$useReactId = $acw62["useId".toString()] || (()=>void 0);
var $e9caa37128205ed4$var$count = 0;
function $e9caa37128205ed4$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($e9caa37128205ed4$var$useReactId());
    (0, $e937e9875ed92bf3$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($e9caa37128205ed4$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $acw62 = parcelRequire("acw62");

// packages/react/arrow/src/Arrow.tsx

var $acw62 = parcelRequire("acw62");


var $cf2e0e275028305e$var$NAME = "Arrow";
var $cf2e0e275028305e$export$21b07c8f274aebd5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7518daafddc6d54$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$cf2e0e275028305e$export$21b07c8f274aebd5.displayName = $cf2e0e275028305e$var$NAME;
var $cf2e0e275028305e$export$be92b6f5f03c0fe9 = $cf2e0e275028305e$export$21b07c8f274aebd5;







// packages/react/use-size/src/useSize.tsx

var $acw62 = parcelRequire("acw62");

function $8b41d75306d85382$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $acw62.useState(void 0);
    (0, $e937e9875ed92bf3$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



"use client";
var $df28cfa64b5039b6$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $df28cfa64b5039b6$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $df28cfa64b5039b6$var$POPPER_NAME = "Popper";
var [$df28cfa64b5039b6$var$createPopperContext, $df28cfa64b5039b6$export$722aac194ae923] = (0, $604ad36f30a88545$export$50c7b4e9d9f19c1)($df28cfa64b5039b6$var$POPPER_NAME);
var [$df28cfa64b5039b6$var$PopperProvider, $df28cfa64b5039b6$var$usePopperContext] = $df28cfa64b5039b6$var$createPopperContext($df28cfa64b5039b6$var$POPPER_NAME);
var $df28cfa64b5039b6$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $acw62.useState(null);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df28cfa64b5039b6$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$df28cfa64b5039b6$export$badac9ada3a0bdf9.displayName = $df28cfa64b5039b6$var$POPPER_NAME;
var $df28cfa64b5039b6$var$ANCHOR_NAME = "PopperAnchor";
var $df28cfa64b5039b6$export$ecd4e1ccab6ed6d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $df28cfa64b5039b6$var$usePopperContext($df28cfa64b5039b6$var$ANCHOR_NAME, __scopePopper);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $484a8a8d895e606e$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        context.onAnchorChange(virtualRef?.current || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7518daafddc6d54$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$df28cfa64b5039b6$export$ecd4e1ccab6ed6d.displayName = $df28cfa64b5039b6$var$ANCHOR_NAME;
var $df28cfa64b5039b6$var$CONTENT_NAME = "PopperContent";
var [$df28cfa64b5039b6$var$PopperContentProvider, $df28cfa64b5039b6$var$useContentContext] = $df28cfa64b5039b6$var$createPopperContext($df28cfa64b5039b6$var$CONTENT_NAME);
var $df28cfa64b5039b6$export$bc4ae5855d3c4fc = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $df28cfa64b5039b6$var$usePopperContext($df28cfa64b5039b6$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $acw62.useState(null);
    const composedRefs = (0, $484a8a8d895e606e$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $acw62.useState(null);
    const arrowSize = (0, $8b41d75306d85382$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($df28cfa64b5039b6$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $23a8f689f1d4c3be$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $461947879dcdbcd4$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $23a8f689f1d4c3be$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $23a8f689f1d4c3be$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $23a8f689f1d4c3be$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $23a8f689f1d4c3be$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $23a8f689f1d4c3be$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $23a8f689f1d4c3be$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $df28cfa64b5039b6$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $23a8f689f1d4c3be$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $df28cfa64b5039b6$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $d24d4a7daae9b449$export$25bec8c6f54ee79a)(onPlaced);
    (0, $e937e9875ed92bf3$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $acw62.useState();
    (0, $e937e9875ed92bf3$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df28cfa64b5039b6$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7518daafddc6d54$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$df28cfa64b5039b6$export$bc4ae5855d3c4fc.displayName = $df28cfa64b5039b6$var$CONTENT_NAME;
var $df28cfa64b5039b6$var$ARROW_NAME = "PopperArrow";
var $df28cfa64b5039b6$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $df28cfa64b5039b6$export$79d62cd4e10a3fd0 = $acw62.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $df28cfa64b5039b6$var$useContentContext($df28cfa64b5039b6$var$ARROW_NAME, __scopePopper);
    const baseSide = $df28cfa64b5039b6$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($cf2e0e275028305e$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$df28cfa64b5039b6$export$79d62cd4e10a3fd0.displayName = $df28cfa64b5039b6$var$ARROW_NAME;
function $df28cfa64b5039b6$var$isNotNull(value) {
    return value !== null;
}
var $df28cfa64b5039b6$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $df28cfa64b5039b6$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $df28cfa64b5039b6$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $df28cfa64b5039b6$export$be92b6f5f03c0fe9 = $df28cfa64b5039b6$export$badac9ada3a0bdf9;
var $df28cfa64b5039b6$export$b688253958b8dfe7 = $df28cfa64b5039b6$export$ecd4e1ccab6ed6d;
var $df28cfa64b5039b6$export$7c6e2c02157bb7d2 = $df28cfa64b5039b6$export$bc4ae5855d3c4fc;
var $df28cfa64b5039b6$export$21b07c8f274aebd5 = $df28cfa64b5039b6$export$79d62cd4e10a3fd0;



var $acw62 = parcelRequire("acw62");




"use client";
var $2eba9c779b93f126$var$PORTAL_NAME = "Portal";
var $2eba9c779b93f126$export$602eac185826482c = $acw62.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $e937e9875ed92bf3$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7518daafddc6d54$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$2eba9c779b93f126$export$602eac185826482c.displayName = $2eba9c779b93f126$var$PORTAL_NAME;
var $2eba9c779b93f126$export$be92b6f5f03c0fe9 = $2eba9c779b93f126$export$602eac185826482c;



var $acw62 = parcelRequire("acw62");



"use client";
function $7c697b8901f94c4a$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $7c697b8901f94c4a$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $7c697b8901f94c4a$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = (0, $484a8a8d895e606e$export$c7b2cbe3552a0d05)(presence.ref, $7c697b8901f94c4a$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
};
$7c697b8901f94c4a$export$99c2b779aa4e8b8b.displayName = "Presence";
function $7c697b8901f94c4a$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef({});
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $7c697b8901f94c4a$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        const currentAnimationName = $7c697b8901f94c4a$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $e937e9875ed92bf3$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $7c697b8901f94c4a$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $e937e9875ed92bf3$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $7c697b8901f94c4a$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) $11492dca620dcaa5$exports.flushSync(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $7c697b8901f94c4a$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $7c697b8901f94c4a$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $7c697b8901f94c4a$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




// packages/react/use-controllable-state/src/useControllableState.tsx

var $acw62 = parcelRequire("acw62");

function $a7052f10ccb58dc6$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $a7052f10ccb58dc6$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $d24d4a7daae9b449$export$25bec8c6f54ee79a)(onChange);
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $a7052f10ccb58dc6$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $acw62.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $acw62.useRef(value);
    const handleChange = (0, $d24d4a7daae9b449$export$25bec8c6f54ee79a)(onChange);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/visually-hidden/src/VisuallyHidden.tsx

var $acw62 = parcelRequire("acw62");


var $efe6b8a55537ad93$var$NAME = "VisuallyHidden";
var $efe6b8a55537ad93$export$439d29a4e110a164 = $acw62.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7518daafddc6d54$export$250ffa63cdc0d034).span, {
        ...props,
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    });
});
$efe6b8a55537ad93$export$439d29a4e110a164.displayName = $efe6b8a55537ad93$var$NAME;
var $efe6b8a55537ad93$export$be92b6f5f03c0fe9 = $efe6b8a55537ad93$export$439d29a4e110a164;



"use client";
var [$68beda14d3b7350e$var$createTooltipContext, $68beda14d3b7350e$export$1c540a2224f0d865] = (0, $604ad36f30a88545$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $df28cfa64b5039b6$export$722aac194ae923)
]);
var $68beda14d3b7350e$var$usePopperScope = (0, $df28cfa64b5039b6$export$722aac194ae923)();
var $68beda14d3b7350e$var$PROVIDER_NAME = "TooltipProvider";
var $68beda14d3b7350e$var$DEFAULT_DELAY_DURATION = 700;
var $68beda14d3b7350e$var$TOOLTIP_OPEN = "tooltip.open";
var [$68beda14d3b7350e$var$TooltipProviderContextProvider, $68beda14d3b7350e$var$useTooltipProviderContext] = $68beda14d3b7350e$var$createTooltipContext($68beda14d3b7350e$var$PROVIDER_NAME);
var $68beda14d3b7350e$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $68beda14d3b7350e$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = $acw62.useState(true);
    const isPointerInTransitRef = $acw62.useRef(false);
    const skipDelayTimerRef = $acw62.useRef(0);
    $acw62.useEffect(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: $acw62.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: $acw62.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: $acw62.useCallback((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent,
        children: children
    });
};
$68beda14d3b7350e$export$f78649fb9ca566b8.displayName = $68beda14d3b7350e$var$PROVIDER_NAME;
var $68beda14d3b7350e$var$TOOLTIP_NAME = "Tooltip";
var [$68beda14d3b7350e$var$TooltipContextProvider, $68beda14d3b7350e$var$useTooltipContext] = $68beda14d3b7350e$var$createTooltipContext($68beda14d3b7350e$var$TOOLTIP_NAME);
var $68beda14d3b7350e$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $68beda14d3b7350e$var$useTooltipProviderContext($68beda14d3b7350e$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $68beda14d3b7350e$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = $acw62.useState(null);
    const contentId = (0, $e9caa37128205ed4$export$f680877a34711e37)();
    const openTimerRef = $acw62.useRef(0);
    const disableHoverableContent = disableHoverableContentProp ?? providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp ?? providerContext.delayDuration;
    const wasOpenDelayedRef = $acw62.useRef(false);
    const [open = false, setOpen] = (0, $a7052f10ccb58dc6$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open2)=>{
            if (open2) {
                providerContext.onOpen();
                document.dispatchEvent(new CustomEvent($68beda14d3b7350e$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange?.(open2);
        }
    });
    const stateAttribute = $acw62.useMemo(()=>{
        return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open
    ]);
    const handleOpen = $acw62.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = $acw62.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = $acw62.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    $acw62.useEffect(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df28cfa64b5039b6$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$var$TooltipContextProvider, {
            scope: __scopeTooltip,
            contentId: contentId,
            open: open,
            stateAttribute: stateAttribute,
            trigger: trigger,
            onTriggerChange: setTrigger,
            onTriggerEnter: $acw62.useCallback(()=>{
                if (providerContext.isOpenDelayed) handleDelayedOpen();
                else handleOpen();
            }, [
                providerContext.isOpenDelayed,
                handleDelayedOpen,
                handleOpen
            ]),
            onTriggerLeave: $acw62.useCallback(()=>{
                if (disableHoverableContent) handleClose();
                else window.clearTimeout(openTimerRef.current);
            }, [
                handleClose,
                disableHoverableContent
            ]),
            onOpen: handleOpen,
            onClose: handleClose,
            disableHoverableContent: disableHoverableContent,
            children: children
        })
    });
};
$68beda14d3b7350e$export$28c660c63b792dea.displayName = $68beda14d3b7350e$var$TOOLTIP_NAME;
var $68beda14d3b7350e$var$TRIGGER_NAME = "TooltipTrigger";
var $68beda14d3b7350e$export$8c610744efcf8a1d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $68beda14d3b7350e$var$useTooltipContext($68beda14d3b7350e$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $68beda14d3b7350e$var$useTooltipProviderContext($68beda14d3b7350e$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $68beda14d3b7350e$var$usePopperScope(__scopeTooltip);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $484a8a8d895e606e$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = $acw62.useRef(false);
    const hasPointerMoveOpenedRef = $acw62.useRef(false);
    const handlePointerUp = $acw62.useCallback(()=>isPointerDownRef.current = false, []);
    $acw62.useEffect(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df28cfa64b5039b6$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7518daafddc6d54$export$250ffa63cdc0d034).button, {
            "aria-describedby": context.open ? context.contentId : void 0,
            "data-state": context.stateAttribute,
            ...triggerProps,
            ref: composedRefs,
            onPointerMove: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
                if (event.pointerType === "touch") return;
                if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                    context.onTriggerEnter();
                    hasPointerMoveOpenedRef.current = true;
                }
            }),
            onPointerLeave: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
                context.onTriggerLeave();
                hasPointerMoveOpenedRef.current = false;
            }),
            onPointerDown: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
                isPointerDownRef.current = true;
                document.addEventListener("pointerup", handlePointerUp, {
                    once: true
                });
            }),
            onFocus: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                if (!isPointerDownRef.current) context.onOpen();
            }),
            onBlur: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
            onClick: (0, $58245b29e19b2b51$export$b9ecd428b558ff10)(props.onClick, context.onClose)
        })
    });
});
$68beda14d3b7350e$export$8c610744efcf8a1d.displayName = $68beda14d3b7350e$var$TRIGGER_NAME;
var $68beda14d3b7350e$var$PORTAL_NAME = "TooltipPortal";
var [$68beda14d3b7350e$var$PortalProvider, $68beda14d3b7350e$var$usePortalContext] = $68beda14d3b7350e$var$createTooltipContext($68beda14d3b7350e$var$PORTAL_NAME, {
    forceMount: void 0
});
var $68beda14d3b7350e$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $68beda14d3b7350e$var$useTooltipContext($68beda14d3b7350e$var$PORTAL_NAME, __scopeTooltip);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7c697b8901f94c4a$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2eba9c779b93f126$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$68beda14d3b7350e$export$7b36b8f925ab7497.displayName = $68beda14d3b7350e$var$PORTAL_NAME;
var $68beda14d3b7350e$var$CONTENT_NAME = "TooltipContent";
var $68beda14d3b7350e$export$e9003e2be37ec060 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $68beda14d3b7350e$var$usePortalContext($68beda14d3b7350e$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $68beda14d3b7350e$var$useTooltipContext($68beda14d3b7350e$var$CONTENT_NAME, props.__scopeTooltip);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7c697b8901f94c4a$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.disableHoverableContent ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$var$TooltipContentImpl, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$var$TooltipContentHoverable, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        })
    });
});
var $68beda14d3b7350e$var$TooltipContentHoverable = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $68beda14d3b7350e$var$useTooltipContext($68beda14d3b7350e$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $68beda14d3b7350e$var$useTooltipProviderContext($68beda14d3b7350e$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $484a8a8d895e606e$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = $acw62.useState(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = $acw62.useCallback(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = $acw62.useCallback((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $68beda14d3b7350e$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $68beda14d3b7350e$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $68beda14d3b7350e$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $68beda14d3b7350e$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    $acw62.useEffect(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    $acw62.useEffect(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    $acw62.useEffect(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = trigger?.contains(target) || content?.contains(target);
                const isPointerOutsideGraceArea = !$68beda14d3b7350e$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$var$TooltipContentImpl, {
        ...props,
        ref: composedRefs
    });
});
var [$68beda14d3b7350e$var$VisuallyHiddenContentContextProvider, $68beda14d3b7350e$var$useVisuallyHiddenContentContext] = $68beda14d3b7350e$var$createTooltipContext($68beda14d3b7350e$var$TOOLTIP_NAME, {
    isInside: false
});
var $68beda14d3b7350e$var$TooltipContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $68beda14d3b7350e$var$useTooltipContext($68beda14d3b7350e$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $68beda14d3b7350e$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context;
    $acw62.useEffect(()=>{
        document.addEventListener($68beda14d3b7350e$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($68beda14d3b7350e$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]);
    $acw62.useEffect(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target?.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e3648ecbc57173f6$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($df28cfa64b5039b6$export$7c6e2c02157bb7d2, {
            "data-state": context.stateAttribute,
            ...popperScope,
            ...contentProps,
            ref: forwardedRef,
            style: {
                ...contentProps.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9c21d6a8a74cf628$export$d9f1ccf0bdb05d45), {
                    children: children
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$var$VisuallyHiddenContentContextProvider, {
                    scope: __scopeTooltip,
                    isInside: true,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($efe6b8a55537ad93$export$be92b6f5f03c0fe9, {
                        id: context.contentId,
                        role: "tooltip",
                        children: ariaLabel || children
                    })
                })
            ]
        })
    });
});
$68beda14d3b7350e$export$e9003e2be37ec060.displayName = $68beda14d3b7350e$var$CONTENT_NAME;
var $68beda14d3b7350e$var$ARROW_NAME = "TooltipArrow";
var $68beda14d3b7350e$export$c27ee0ad710f7559 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $68beda14d3b7350e$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $68beda14d3b7350e$var$useVisuallyHiddenContentContext($68beda14d3b7350e$var$ARROW_NAME, __scopeTooltip);
    return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($df28cfa64b5039b6$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$68beda14d3b7350e$export$c27ee0ad710f7559.displayName = $68beda14d3b7350e$var$ARROW_NAME;
function $68beda14d3b7350e$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $68beda14d3b7350e$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $68beda14d3b7350e$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
}
function $68beda14d3b7350e$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $68beda14d3b7350e$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $68beda14d3b7350e$var$getHullPresorted(newPoints);
}
function $68beda14d3b7350e$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i = points.length - 1; i >= 0; i--){
        const p = points[i];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
var $68beda14d3b7350e$export$2881499e37b75b9a = $68beda14d3b7350e$export$f78649fb9ca566b8;
var $68beda14d3b7350e$export$be92b6f5f03c0fe9 = $68beda14d3b7350e$export$28c660c63b792dea;
var $68beda14d3b7350e$export$41fb9f06171c75f4 = $68beda14d3b7350e$export$8c610744efcf8a1d;
var $68beda14d3b7350e$export$602eac185826482c = $68beda14d3b7350e$export$7b36b8f925ab7497;
var $68beda14d3b7350e$export$7c6e2c02157bb7d2 = $68beda14d3b7350e$export$e9003e2be37ec060;
var $68beda14d3b7350e$export$21b07c8f274aebd5 = $68beda14d3b7350e$export$c27ee0ad710f7559;


const $0273e7dadee8ce4c$export$28c660c63b792dea = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($68beda14d3b7350e$export$be92b6f5f03c0fe9, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$export$41fb9f06171c75f4, {
                asChild: true,
                children: props.children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($68beda14d3b7350e$export$7c6e2c02157bb7d2, {
                    side: props.side,
                    sideOffset: props.sideOffset,
                    align: props.align,
                    alignOffset: props.alignOffset,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($14cbf222c2b76d82$exports))).content,
                    children: [
                        props.label,
                        props.shortcut !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($14cbf222c2b76d82$exports))).shortcut,
                            children: props.shortcut
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$export$21b07c8f274aebd5, {})
                    ]
                })
            })
        ]
    });
};
const $0273e7dadee8ce4c$export$f78649fb9ca566b8 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($68beda14d3b7350e$export$f78649fb9ca566b8, {
        delayDuration: 500,
        skipDelayDuration: 300,
        children: props.children
    });
};




var $acw62 = parcelRequire("acw62");
const $c17f85d6c45c40da$var$context = /*#__PURE__*/ (0, $acw62.createContext)("en");
const $c17f85d6c45c40da$export$2ac87225e978ab39 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c17f85d6c45c40da$var$context.Provider, {
        value: props.lang,
        children: props.children
    });
};
function $c17f85d6c45c40da$export$2ecf1baeef3275cf(map) {
    const lang = (0, $acw62.useContext)($c17f85d6c45c40da$var$context);
    return $c17f85d6c45c40da$var$getTexts(map, lang);
}
function $c17f85d6c45c40da$var$getTexts(textMap, lang) {
    // @ts-ignore
    const map = {};
    for (const key of Object.keys(textMap))map[key] = textMap[key][lang] ?? textMap[key].en;
    return map;
}
function $c17f85d6c45c40da$export$95672295c50ede1f(text, ...args) {
    const res = [];
    let s = 0;
    let f = false;
    let argIndex = 0;
    for(let i = 0; i < text.length; i++){
        if (f && text[i] === "s") {
            res.push(text.slice(s, i - 1), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Fragment), {
                children: args.shift()
            }, `arg${argIndex}`));
            s = i + 1;
            f = false;
            argIndex += 1;
        }
        if (text[i] === "%") {
            if (f) {
                res.push(text.slice(s, i));
                s = i + 1;
                f = false;
            } else f = true;
        }
    }
    res.push(text.slice(s));
    return res;
}


const $94a8de0c3414f61b$var$textMap = {
    rectangle: {
        en: "Rectangle",
        ja: "\u9577\u65B9\u5F62"
    },
    text: {
        en: "Text",
        ja: "\u30C6\u30AD\u30B9\u30C8"
    },
    pen: {
        en: "Pen",
        ja: "\u30DA\u30F3"
    },
    arrow: {
        en: "Arrow",
        ja: "\u77E2\u5370"
    },
    number: {
        en: "Number",
        ja: "\u6570\u5B57"
    },
    blur: {
        en: "Blur",
        ja: "\u307C\u304B\u3057"
    },
    pixelate: {
        en: "Pixelate",
        ja: "\u30E2\u30B6\u30A4\u30AF"
    },
    redact: {
        en: "Redact",
        ja: "\u58A8\u5857\u308A"
    }
};
const $94a8de0c3414f61b$export$bfbece8a621a006f = (props)=>{
    const texts = (0, $c17f85d6c45c40da$export$2ecf1baeef3275cf)($94a8de0c3414f61b$var$textMap);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).buttons,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99f7af2f53b86eaa$export$ac58b777a02d288e), {
                        color: props.style.color,
                        size: props.style.size,
                        disabled: props.disabled,
                        onChange: props.onColorChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b63db6ffa0205c8$export$6ac67942725de328), {
                        size: props.style.size,
                        color: props.style.color,
                        disabled: props.disabled,
                        onChange: props.onSizeChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).divider
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).buttons,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                            label: texts.rectangle,
                            shortcut: "R",
                            sideOffset: 16,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: props.disabled,
                                "data-active": props.tool === "rect",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).button,
                                onClick: ()=>props.onToolChange("rect"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $140f6cffec511506$export$750134880a51a661), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                            label: texts.text,
                            shortcut: "T",
                            sideOffset: 16,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: props.disabled,
                                "data-active": props.tool === "text",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).button,
                                onClick: ()=>props.onToolChange("text"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e4cb90fe614acf7$export$cf6b3df9a088a692), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                            label: texts.pen,
                            shortcut: "P",
                            sideOffset: 16,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: props.disabled,
                                "data-active": props.tool === "pen",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).button,
                                onClick: ()=>props.onToolChange("pen"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52830e1917b9f0ca$export$cf9b56e4032a149f), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                            label: texts.arrow,
                            shortcut: "A",
                            sideOffset: 16,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: props.disabled,
                                "data-active": props.tool === "arrow",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).button,
                                onClick: ()=>props.onToolChange("arrow"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1085830bdb421514$export$4c2ba81155d7eb6f), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                            label: texts.number,
                            shortcut: "N",
                            sideOffset: 16,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: props.disabled,
                                "data-active": props.tool === "number",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).button,
                                onClick: ()=>props.onToolChange("number"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b95fc45607bce483$export$37653ff4fb6d58d2), {})
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).divider
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).buttons,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                            label: texts.blur,
                            shortcut: "B",
                            sideOffset: 16,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: props.disabled,
                                "data-active": props.tool === "blur",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).button,
                                onClick: ()=>props.onToolChange("blur"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87936ff1a2c5d539$export$d57a6b1113c4c4d0), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                            label: texts.pixelate,
                            shortcut: "X",
                            sideOffset: 16,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: props.disabled,
                                "data-active": props.tool === "pixelate",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).button,
                                onClick: ()=>props.onToolChange("pixelate"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e19bdd639104192$export$39f5b3d9bf1a7e6d), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                            label: texts.redact,
                            shortcut: "D",
                            sideOffset: 16,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                disabled: props.disabled,
                                "data-active": props.tool === "redact",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b5060ee6f843df16$exports))).button,
                                onClick: ()=>props.onToolChange("redact"),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82ffb759530075e0$export$bfdbcf2db3e1bfd1), {})
                            })
                        })
                    })
                ]
            })
        ]
    });
};



var $ec64125824bb00fd$exports = {};

$parcel$export($ec64125824bb00fd$exports, "button", () => $ec64125824bb00fd$export$2ba01fb71ed41cb6, (v) => $ec64125824bb00fd$export$2ba01fb71ed41cb6 = v);
$parcel$export($ec64125824bb00fd$exports, "container", () => $ec64125824bb00fd$export$34e0f9847d4c02dd, (v) => $ec64125824bb00fd$export$34e0f9847d4c02dd = v);
$parcel$export($ec64125824bb00fd$exports, "historyButtons", () => $ec64125824bb00fd$export$3d4a9408d8e2dd0f, (v) => $ec64125824bb00fd$export$3d4a9408d8e2dd0f = v);
$parcel$export($ec64125824bb00fd$exports, "menu", () => $ec64125824bb00fd$export$b1e5508a851be14d, (v) => $ec64125824bb00fd$export$b1e5508a851be14d = v);
$parcel$export($ec64125824bb00fd$exports, "menuWrapper", () => $ec64125824bb00fd$export$48cd86ad23d8997d, (v) => $ec64125824bb00fd$export$48cd86ad23d8997d = v);
$parcel$export($ec64125824bb00fd$exports, "redo", () => $ec64125824bb00fd$export$1688e416fee0a49e, (v) => $ec64125824bb00fd$export$1688e416fee0a49e = v);
$parcel$export($ec64125824bb00fd$exports, "undo", () => $ec64125824bb00fd$export$21f930c44940fd98, (v) => $ec64125824bb00fd$export$21f930c44940fd98 = v);
var $ec64125824bb00fd$export$2ba01fb71ed41cb6;
var $ec64125824bb00fd$export$34e0f9847d4c02dd;
var $ec64125824bb00fd$export$3d4a9408d8e2dd0f;
var $ec64125824bb00fd$export$b1e5508a851be14d;
var $ec64125824bb00fd$export$48cd86ad23d8997d;
var $ec64125824bb00fd$export$1688e416fee0a49e;
var $ec64125824bb00fd$export$21f930c44940fd98;
$ec64125824bb00fd$export$2ba01fb71ed41cb6 = `vDGz1G_button`;
$ec64125824bb00fd$export$34e0f9847d4c02dd = `vDGz1G_container`;
$ec64125824bb00fd$export$3d4a9408d8e2dd0f = `vDGz1G_historyButtons`;
$ec64125824bb00fd$export$b1e5508a851be14d = `vDGz1G_menu`;
$ec64125824bb00fd$export$48cd86ad23d8997d = `vDGz1G_menuWrapper`;
$ec64125824bb00fd$export$1688e416fee0a49e = `vDGz1G_redo`;
$ec64125824bb00fd$export$21f930c44940fd98 = `vDGz1G_undo`;


var $70ca71161747feb3$exports = {};

$parcel$export($70ca71161747feb3$exports, "content", () => $70ca71161747feb3$export$a7db06668cad9adb, (v) => $70ca71161747feb3$export$a7db06668cad9adb = v);
$parcel$export($70ca71161747feb3$exports, "item", () => $70ca71161747feb3$export$7061c75fc5af8b7e, (v) => $70ca71161747feb3$export$7061c75fc5af8b7e = v);
$parcel$export($70ca71161747feb3$exports, "separator", () => $70ca71161747feb3$export$3e523c77c1f23f8c, (v) => $70ca71161747feb3$export$3e523c77c1f23f8c = v);
$parcel$export($70ca71161747feb3$exports, "shortcut", () => $70ca71161747feb3$export$ec0409edb5e28490, (v) => $70ca71161747feb3$export$ec0409edb5e28490 = v);
var $70ca71161747feb3$export$a7db06668cad9adb;
var $70ca71161747feb3$export$7061c75fc5af8b7e;
var $70ca71161747feb3$export$3e523c77c1f23f8c;
var $70ca71161747feb3$export$ec0409edb5e28490;
$70ca71161747feb3$export$a7db06668cad9adb = `h8IyEq_content`;
$70ca71161747feb3$export$7061c75fc5af8b7e = `h8IyEq_item`;
$70ca71161747feb3$export$3e523c77c1f23f8c = `h8IyEq_separator`;
$70ca71161747feb3$export$ec0409edb5e28490 = `h8IyEq_shortcut`;



var $acw62 = parcelRequire("acw62");
// packages/core/primitive/src/primitive.tsx
function $639c769a9ab8b7ad$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $dd9035981542232d$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $dd9035981542232d$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$dd9035981542232d$var$setRef(ref, node));
}
function $dd9035981542232d$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($dd9035981542232d$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $acw62 = parcelRequire("acw62");

function $bd30d951836c8e03$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $bd30d951836c8e03$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $bd30d951836c8e03$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $bd30d951836c8e03$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $acw62 = parcelRequire("acw62");
function $9c676ed9bde07321$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $b5cf47ad6bad92ad$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $b5cf47ad6bad92ad$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $9c676ed9bde07321$export$25bec8c6f54ee79a)(onChange);
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $b5cf47ad6bad92ad$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $acw62.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $acw62.useRef(value);
    const handleChange = (0, $9c676ed9bde07321$export$25bec8c6f54ee79a)(onChange);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/primitive/src/Primitive.tsx

var $acw62 = parcelRequire("acw62");

// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");


var $2c0cd4ca056c78b6$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($2c0cd4ca056c78b6$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2c0cd4ca056c78b6$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2c0cd4ca056c78b6$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$2c0cd4ca056c78b6$export$8c6ed5c666ac1360.displayName = "Slot";
var $2c0cd4ca056c78b6$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $2c0cd4ca056c78b6$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$2c0cd4ca056c78b6$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $dd9035981542232d$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$2c0cd4ca056c78b6$var$SlotClone.displayName = "SlotClone";
var $2c0cd4ca056c78b6$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $2c0cd4ca056c78b6$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $2c0cd4ca056c78b6$export$d9f1ccf0bdb05d45;
}
function $2c0cd4ca056c78b6$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $2c0cd4ca056c78b6$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $2c0cd4ca056c78b6$export$be92b6f5f03c0fe9 = $2c0cd4ca056c78b6$export$8c6ed5c666ac1360;



var $03b33fdb9adb443d$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $03b33fdb9adb443d$export$250ffa63cdc0d034 = $03b33fdb9adb443d$var$NODES.reduce((primitive, node)=>{
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $2c0cd4ca056c78b6$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $03b33fdb9adb443d$export$6d1a0317bde7de7f(target, event) {
    if (target) $11492dca620dcaa5$exports.flushSync(()=>target.dispatchEvent(event));
}
var $03b33fdb9adb443d$export$be92b6f5f03c0fe9 = $03b33fdb9adb443d$export$250ffa63cdc0d034;



var $acw62 = parcelRequire("acw62");
// packages/core/primitive/src/primitive.tsx
function $05e3357d1fc31649$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}



var $acw62 = parcelRequire("acw62");
// packages/react/context/src/createContext.tsx

var $acw62 = parcelRequire("acw62");

function $734c31b1f2793eab$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $734c31b1f2793eab$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $734c31b1f2793eab$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $734c31b1f2793eab$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $57e2e2154cec12ed$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $57e2e2154cec12ed$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$57e2e2154cec12ed$var$setRef(ref, node));
}
function $57e2e2154cec12ed$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($57e2e2154cec12ed$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");


var $144b43512ff6b0e2$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($144b43512ff6b0e2$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($144b43512ff6b0e2$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($144b43512ff6b0e2$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$144b43512ff6b0e2$export$8c6ed5c666ac1360.displayName = "Slot";
var $144b43512ff6b0e2$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $144b43512ff6b0e2$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$144b43512ff6b0e2$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $57e2e2154cec12ed$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$144b43512ff6b0e2$var$SlotClone.displayName = "SlotClone";
var $144b43512ff6b0e2$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $144b43512ff6b0e2$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $144b43512ff6b0e2$export$d9f1ccf0bdb05d45;
}
function $144b43512ff6b0e2$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $144b43512ff6b0e2$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $144b43512ff6b0e2$export$be92b6f5f03c0fe9 = $144b43512ff6b0e2$export$8c6ed5c666ac1360;



"use client";
function $4c997e459ed9f4e5$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $734c31b1f2793eab$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $144b43512ff6b0e2$export$8c6ed5c666ac1360), {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $144b43512ff6b0e2$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}




// packages/react/direction/src/Direction.tsx

var $acw62 = parcelRequire("acw62");

var $897c357432cec481$var$DirectionContext = $acw62.createContext(void 0);
var $897c357432cec481$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($897c357432cec481$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $897c357432cec481$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($897c357432cec481$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $897c357432cec481$export$2881499e37b75b9a = $897c357432cec481$export$c760c09fdd558351;



var $acw62 = parcelRequire("acw62");

// packages/react/primitive/src/Primitive.tsx

var $acw62 = parcelRequire("acw62");



var $3a849823db0e7dc9$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $3a849823db0e7dc9$export$250ffa63cdc0d034 = $3a849823db0e7dc9$var$NODES.reduce((primitive, node)=>{
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $144b43512ff6b0e2$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $3a849823db0e7dc9$export$6d1a0317bde7de7f(target, event) {
    if (target) $11492dca620dcaa5$exports.flushSync(()=>target.dispatchEvent(event));
}
var $3a849823db0e7dc9$export$be92b6f5f03c0fe9 = $3a849823db0e7dc9$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $acw62 = parcelRequire("acw62");
function $d7bcbdb538768a1a$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $acw62 = parcelRequire("acw62");

function $ead5e62f80ac6471$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $acw62.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $39738647392f0b48$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $39738647392f0b48$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $39738647392f0b48$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $39738647392f0b48$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $39738647392f0b48$var$originalBodyPointerEvents;
var $39738647392f0b48$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $39738647392f0b48$export$177fb62ff3ec1f22 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($39738647392f0b48$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $39738647392f0b48$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $39738647392f0b48$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $ead5e62f80ac6471$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $39738647392f0b48$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $39738647392f0b48$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $39738647392f0b48$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $39738647392f0b48$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($39738647392f0b48$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($39738647392f0b48$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$39738647392f0b48$export$177fb62ff3ec1f22.displayName = $39738647392f0b48$var$DISMISSABLE_LAYER_NAME;
var $39738647392f0b48$var$BRANCH_NAME = "DismissableLayerBranch";
var $39738647392f0b48$export$4d5eb2109db14228 = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $acw62.useContext($39738647392f0b48$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$39738647392f0b48$export$4d5eb2109db14228.displayName = $39738647392f0b48$var$BRANCH_NAME;
function $39738647392f0b48$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $39738647392f0b48$var$handleAndDispatchCustomEvent($39738647392f0b48$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $39738647392f0b48$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $39738647392f0b48$var$handleAndDispatchCustomEvent($39738647392f0b48$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $39738647392f0b48$var$dispatchUpdate() {
    const event = new CustomEvent($39738647392f0b48$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $39738647392f0b48$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $3a849823db0e7dc9$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $39738647392f0b48$export$be92b6f5f03c0fe9 = $39738647392f0b48$export$177fb62ff3ec1f22;
var $39738647392f0b48$export$aecb2ddcb55c95be = $39738647392f0b48$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");
"use client";
var $a949c8bc51c5c49e$var$count = 0;
function $a949c8bc51c5c49e$export$ac5b58043b79449b(props) {
    $a949c8bc51c5c49e$export$b7ece24a22aeda8c();
    return props.children;
}
function $a949c8bc51c5c49e$export$b7ece24a22aeda8c() {
    $acw62.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $a949c8bc51c5c49e$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $a949c8bc51c5c49e$var$createFocusGuard());
        $a949c8bc51c5c49e$var$count++;
        return ()=>{
            if ($a949c8bc51c5c49e$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $a949c8bc51c5c49e$var$count--;
        };
    }, []);
}
function $a949c8bc51c5c49e$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
var $a949c8bc51c5c49e$export$be92b6f5f03c0fe9 = $a949c8bc51c5c49e$export$ac5b58043b79449b;



var $acw62 = parcelRequire("acw62");




"use client";
var $36279d10a0d5b706$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $36279d10a0d5b706$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $36279d10a0d5b706$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $36279d10a0d5b706$var$FOCUS_SCOPE_NAME = "FocusScope";
var $36279d10a0d5b706$export$20e40289641fbbb6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $acw62.useState(null);
    const onMountAutoFocus = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $acw62.useRef(null);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $acw62.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $acw62.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $36279d10a0d5b706$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $36279d10a0d5b706$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $36279d10a0d5b706$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $acw62.useEffect(()=>{
        if (container) {
            $36279d10a0d5b706$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($36279d10a0d5b706$var$AUTOFOCUS_ON_MOUNT, $36279d10a0d5b706$var$EVENT_OPTIONS);
                container.addEventListener($36279d10a0d5b706$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $36279d10a0d5b706$var$focusFirst($36279d10a0d5b706$var$removeLinks($36279d10a0d5b706$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $36279d10a0d5b706$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($36279d10a0d5b706$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($36279d10a0d5b706$var$AUTOFOCUS_ON_UNMOUNT, $36279d10a0d5b706$var$EVENT_OPTIONS);
                    container.addEventListener($36279d10a0d5b706$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $36279d10a0d5b706$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($36279d10a0d5b706$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $36279d10a0d5b706$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $36279d10a0d5b706$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $36279d10a0d5b706$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $36279d10a0d5b706$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$36279d10a0d5b706$export$20e40289641fbbb6.displayName = $36279d10a0d5b706$var$FOCUS_SCOPE_NAME;
function $36279d10a0d5b706$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $36279d10a0d5b706$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $36279d10a0d5b706$var$getTabbableEdges(container) {
    const candidates = $36279d10a0d5b706$var$getTabbableCandidates(container);
    const first = $36279d10a0d5b706$var$findVisible(candidates, container);
    const last = $36279d10a0d5b706$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $36279d10a0d5b706$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $36279d10a0d5b706$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$36279d10a0d5b706$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $36279d10a0d5b706$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $36279d10a0d5b706$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $36279d10a0d5b706$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $36279d10a0d5b706$var$isSelectableInput(element) && select) element.select();
    }
}
var $36279d10a0d5b706$var$focusScopesStack = $36279d10a0d5b706$var$createFocusScopesStack();
function $36279d10a0d5b706$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $36279d10a0d5b706$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $36279d10a0d5b706$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $36279d10a0d5b706$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $36279d10a0d5b706$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $36279d10a0d5b706$export$be92b6f5f03c0fe9 = $36279d10a0d5b706$export$20e40289641fbbb6;


// packages/react/id/src/id.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $acw62 = parcelRequire("acw62");
var $90bf774f7151cbfe$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $acw62.useLayoutEffect : ()=>{};


var $f1dc4e0906c8967e$var$useReactId = $acw62["useId".toString()] || (()=>void 0);
var $f1dc4e0906c8967e$var$count = 0;
function $f1dc4e0906c8967e$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($f1dc4e0906c8967e$var$useReactId());
    (0, $90bf774f7151cbfe$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($f1dc4e0906c8967e$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $acw62 = parcelRequire("acw62");

// packages/react/arrow/src/Arrow.tsx

var $acw62 = parcelRequire("acw62");


var $956277d5074d3a26$var$NAME = "Arrow";
var $956277d5074d3a26$export$21b07c8f274aebd5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$956277d5074d3a26$export$21b07c8f274aebd5.displayName = $956277d5074d3a26$var$NAME;
var $956277d5074d3a26$export$be92b6f5f03c0fe9 = $956277d5074d3a26$export$21b07c8f274aebd5;







// packages/react/use-size/src/useSize.tsx

var $acw62 = parcelRequire("acw62");

function $aec6d185cdf2227f$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $acw62.useState(void 0);
    (0, $90bf774f7151cbfe$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



"use client";
var $c900eaabac86a93f$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $c900eaabac86a93f$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $c900eaabac86a93f$var$POPPER_NAME = "Popper";
var [$c900eaabac86a93f$var$createPopperContext, $c900eaabac86a93f$export$722aac194ae923] = (0, $734c31b1f2793eab$export$50c7b4e9d9f19c1)($c900eaabac86a93f$var$POPPER_NAME);
var [$c900eaabac86a93f$var$PopperProvider, $c900eaabac86a93f$var$usePopperContext] = $c900eaabac86a93f$var$createPopperContext($c900eaabac86a93f$var$POPPER_NAME);
var $c900eaabac86a93f$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $acw62.useState(null);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c900eaabac86a93f$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$c900eaabac86a93f$export$badac9ada3a0bdf9.displayName = $c900eaabac86a93f$var$POPPER_NAME;
var $c900eaabac86a93f$var$ANCHOR_NAME = "PopperAnchor";
var $c900eaabac86a93f$export$ecd4e1ccab6ed6d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $c900eaabac86a93f$var$usePopperContext($c900eaabac86a93f$var$ANCHOR_NAME, __scopePopper);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        context.onAnchorChange(virtualRef?.current || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$c900eaabac86a93f$export$ecd4e1ccab6ed6d.displayName = $c900eaabac86a93f$var$ANCHOR_NAME;
var $c900eaabac86a93f$var$CONTENT_NAME = "PopperContent";
var [$c900eaabac86a93f$var$PopperContentProvider, $c900eaabac86a93f$var$useContentContext] = $c900eaabac86a93f$var$createPopperContext($c900eaabac86a93f$var$CONTENT_NAME);
var $c900eaabac86a93f$export$bc4ae5855d3c4fc = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $c900eaabac86a93f$var$usePopperContext($c900eaabac86a93f$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $acw62.useState(null);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $acw62.useState(null);
    const arrowSize = (0, $aec6d185cdf2227f$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($c900eaabac86a93f$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $23a8f689f1d4c3be$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $461947879dcdbcd4$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $23a8f689f1d4c3be$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $23a8f689f1d4c3be$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $23a8f689f1d4c3be$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $23a8f689f1d4c3be$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $23a8f689f1d4c3be$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $23a8f689f1d4c3be$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $c900eaabac86a93f$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $23a8f689f1d4c3be$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $c900eaabac86a93f$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onPlaced);
    (0, $90bf774f7151cbfe$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $acw62.useState();
    (0, $90bf774f7151cbfe$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c900eaabac86a93f$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$c900eaabac86a93f$export$bc4ae5855d3c4fc.displayName = $c900eaabac86a93f$var$CONTENT_NAME;
var $c900eaabac86a93f$var$ARROW_NAME = "PopperArrow";
var $c900eaabac86a93f$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $c900eaabac86a93f$export$79d62cd4e10a3fd0 = $acw62.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $c900eaabac86a93f$var$useContentContext($c900eaabac86a93f$var$ARROW_NAME, __scopePopper);
    const baseSide = $c900eaabac86a93f$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($956277d5074d3a26$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$c900eaabac86a93f$export$79d62cd4e10a3fd0.displayName = $c900eaabac86a93f$var$ARROW_NAME;
function $c900eaabac86a93f$var$isNotNull(value) {
    return value !== null;
}
var $c900eaabac86a93f$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $c900eaabac86a93f$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $c900eaabac86a93f$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $c900eaabac86a93f$export$be92b6f5f03c0fe9 = $c900eaabac86a93f$export$badac9ada3a0bdf9;
var $c900eaabac86a93f$export$b688253958b8dfe7 = $c900eaabac86a93f$export$ecd4e1ccab6ed6d;
var $c900eaabac86a93f$export$7c6e2c02157bb7d2 = $c900eaabac86a93f$export$bc4ae5855d3c4fc;
var $c900eaabac86a93f$export$21b07c8f274aebd5 = $c900eaabac86a93f$export$79d62cd4e10a3fd0;



var $acw62 = parcelRequire("acw62");




"use client";
var $e3eccf78e3e5930f$var$PORTAL_NAME = "Portal";
var $e3eccf78e3e5930f$export$602eac185826482c = $acw62.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $90bf774f7151cbfe$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$e3eccf78e3e5930f$export$602eac185826482c.displayName = $e3eccf78e3e5930f$var$PORTAL_NAME;
var $e3eccf78e3e5930f$export$be92b6f5f03c0fe9 = $e3eccf78e3e5930f$export$602eac185826482c;



var $acw62 = parcelRequire("acw62");



"use client";
function $78b45d01ed879d75$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $78b45d01ed879d75$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $78b45d01ed879d75$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(presence.ref, $78b45d01ed879d75$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
};
$78b45d01ed879d75$export$99c2b779aa4e8b8b.displayName = "Presence";
function $78b45d01ed879d75$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef({});
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $78b45d01ed879d75$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        const currentAnimationName = $78b45d01ed879d75$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $90bf774f7151cbfe$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $78b45d01ed879d75$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $90bf774f7151cbfe$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $78b45d01ed879d75$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) $11492dca620dcaa5$exports.flushSync(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $78b45d01ed879d75$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $78b45d01ed879d75$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $78b45d01ed879d75$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $acw62 = parcelRequire("acw62");
// packages/core/primitive/src/primitive.tsx
function $7492fe09bba0446f$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}



var $acw62 = parcelRequire("acw62");
// packages/react/context/src/createContext.tsx

var $acw62 = parcelRequire("acw62");

function $e8745532867bc6f7$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $e8745532867bc6f7$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $e8745532867bc6f7$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $e8745532867bc6f7$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $e75bc43f0e18686b$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $e75bc43f0e18686b$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$e75bc43f0e18686b$var$setRef(ref, node));
}
function $e75bc43f0e18686b$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($e75bc43f0e18686b$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");


var $08625a31f448a127$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($08625a31f448a127$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($08625a31f448a127$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($08625a31f448a127$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$08625a31f448a127$export$8c6ed5c666ac1360.displayName = "Slot";
var $08625a31f448a127$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $08625a31f448a127$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$08625a31f448a127$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $e75bc43f0e18686b$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$08625a31f448a127$var$SlotClone.displayName = "SlotClone";
var $08625a31f448a127$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $08625a31f448a127$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $08625a31f448a127$export$d9f1ccf0bdb05d45;
}
function $08625a31f448a127$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $08625a31f448a127$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $08625a31f448a127$export$be92b6f5f03c0fe9 = $08625a31f448a127$export$8c6ed5c666ac1360;



"use client";
function $47b05106583966d2$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $e8745532867bc6f7$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $e75bc43f0e18686b$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $08625a31f448a127$export$8c6ed5c666ac1360), {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $e75bc43f0e18686b$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $08625a31f448a127$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}




// packages/react/id/src/id.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $acw62 = parcelRequire("acw62");
var $8196f54f0edb9940$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $acw62.useLayoutEffect : ()=>{};


var $d875019770ffcc8f$var$useReactId = $acw62["useId".toString()] || (()=>void 0);
var $d875019770ffcc8f$var$count = 0;
function $d875019770ffcc8f$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($d875019770ffcc8f$var$useReactId());
    (0, $8196f54f0edb9940$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($d875019770ffcc8f$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// packages/react/primitive/src/Primitive.tsx

var $acw62 = parcelRequire("acw62");



var $576e67707dc01225$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $576e67707dc01225$export$250ffa63cdc0d034 = $576e67707dc01225$var$NODES.reduce((primitive, node)=>{
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $08625a31f448a127$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $576e67707dc01225$export$6d1a0317bde7de7f(target, event) {
    if (target) $11492dca620dcaa5$exports.flushSync(()=>target.dispatchEvent(event));
}
var $576e67707dc01225$export$be92b6f5f03c0fe9 = $576e67707dc01225$export$250ffa63cdc0d034;


// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $acw62 = parcelRequire("acw62");
function $9b7790949f04871d$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $acw62 = parcelRequire("acw62");

function $0e3b3d11366af198$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $0e3b3d11366af198$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $9b7790949f04871d$export$25bec8c6f54ee79a)(onChange);
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $0e3b3d11366af198$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $acw62.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $acw62.useRef(value);
    const handleChange = (0, $9b7790949f04871d$export$25bec8c6f54ee79a)(onChange);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/direction/src/Direction.tsx

var $acw62 = parcelRequire("acw62");

var $ddf482dece3faf1c$var$DirectionContext = $acw62.createContext(void 0);
var $ddf482dece3faf1c$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ddf482dece3faf1c$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $ddf482dece3faf1c$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($ddf482dece3faf1c$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $ddf482dece3faf1c$export$2881499e37b75b9a = $ddf482dece3faf1c$export$c760c09fdd558351;



"use client";
var $0483c88073bf4923$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $0483c88073bf4923$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0483c88073bf4923$var$GROUP_NAME = "RovingFocusGroup";
var [$0483c88073bf4923$var$Collection, $0483c88073bf4923$var$useCollection, $0483c88073bf4923$var$createCollectionScope] = (0, $47b05106583966d2$export$c74125a8e3af6bb2)($0483c88073bf4923$var$GROUP_NAME);
var [$0483c88073bf4923$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $e8745532867bc6f7$export$50c7b4e9d9f19c1)($0483c88073bf4923$var$GROUP_NAME, [
    $0483c88073bf4923$var$createCollectionScope
]);
var [$0483c88073bf4923$var$RovingFocusProvider, $0483c88073bf4923$var$useRovingFocusContext] = $0483c88073bf4923$var$createRovingFocusGroupContext($0483c88073bf4923$var$GROUP_NAME);
var $0483c88073bf4923$export$8699f7c8af148338 = $acw62.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$0483c88073bf4923$export$8699f7c8af148338.displayName = $0483c88073bf4923$var$GROUP_NAME;
var $0483c88073bf4923$var$RovingFocusGroupImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $e75bc43f0e18686b$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $ddf482dece3faf1c$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $0e3b3d11366af198$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $acw62.useState(false);
    const handleEntryFocus = (0, $9b7790949f04871d$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $acw62.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $acw62.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $acw62.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $576e67707dc01225$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $7492fe09bba0446f$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $7492fe09bba0446f$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$ENTRY_FOCUS, $0483c88073bf4923$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $0483c88073bf4923$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $7492fe09bba0446f$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $0483c88073bf4923$var$ITEM_NAME = "RovingFocusGroupItem";
var $0483c88073bf4923$export$ab9df7c53fe8454 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $d875019770ffcc8f$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$useRovingFocusContext($0483c88073bf4923$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    $acw62.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $576e67707dc01225$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $7492fe09bba0446f$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $7492fe09bba0446f$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $7492fe09bba0446f$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $0483c88073bf4923$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $0483c88073bf4923$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$0483c88073bf4923$var$focusFirst(candidateNodes));
                }
            })
        })
    });
});
$0483c88073bf4923$export$ab9df7c53fe8454.displayName = $0483c88073bf4923$var$ITEM_NAME;
var $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $0483c88073bf4923$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $0483c88073bf4923$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $0483c88073bf4923$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $0483c88073bf4923$export$be92b6f5f03c0fe9 = $0483c88073bf4923$export$8699f7c8af148338;
var $0483c88073bf4923$export$6d08773d2e66f8f2 = $0483c88073bf4923$export$ab9df7c53fe8454;







var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $8c29bec41a1a1b26$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $fd1e522ab70c935c$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $fd1e522ab70c935c$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $fd1e522ab70c935c$var$nothing,
        onWheelCapture: $fd1e522ab70c935c$var$nothing,
        onTouchMoveCapture: $fd1e522ab70c935c$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $8c29bec41a1a1b26$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$fd1e522ab70c935c$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$fd1e522ab70c935c$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};





var $acw62 = parcelRequire("acw62");


var $ec828813b0ccba36$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $ec828813b0ccba36$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $ec828813b0ccba36$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $ec828813b0ccba36$var$options, $ec828813b0ccba36$var$options);
    // @ts-ignore
    window.removeEventListener('test', $ec828813b0ccba36$var$options, $ec828813b0ccba36$var$options);
} catch (err) {
    $ec828813b0ccba36$var$passiveSupported = false;
}
var $ec828813b0ccba36$export$10a6e88623fa9454 = $ec828813b0ccba36$var$passiveSupported ? {
    passive: false
} : false;


var $1f3f10ad9b61e329$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $1f3f10ad9b61e329$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$1f3f10ad9b61e329$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $1f3f10ad9b61e329$var$elementCouldBeVScrolled = function(node) {
    return $1f3f10ad9b61e329$var$elementCanBeScrolled(node, 'overflowY');
};
var $1f3f10ad9b61e329$var$elementCouldBeHScrolled = function(node) {
    return $1f3f10ad9b61e329$var$elementCanBeScrolled(node, 'overflowX');
};
var $1f3f10ad9b61e329$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $1f3f10ad9b61e329$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $1f3f10ad9b61e329$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $1f3f10ad9b61e329$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $1f3f10ad9b61e329$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $1f3f10ad9b61e329$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $1f3f10ad9b61e329$var$elementCouldBeVScrolled(node) : $1f3f10ad9b61e329$var$elementCouldBeHScrolled(node);
};
var $1f3f10ad9b61e329$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $1f3f10ad9b61e329$var$getVScrollVariables(node) : $1f3f10ad9b61e329$var$getHScrollVariables(node);
};
var $1f3f10ad9b61e329$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $1f3f10ad9b61e329$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $1f3f10ad9b61e329$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $1f3f10ad9b61e329$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($1f3f10ad9b61e329$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $eb8e385c6b1a8a0e$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $eb8e385c6b1a8a0e$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $eb8e385c6b1a8a0e$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $eb8e385c6b1a8a0e$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $eb8e385c6b1a8a0e$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $eb8e385c6b1a8a0e$var$idCounter = 0;
var $eb8e385c6b1a8a0e$var$lockStack = [];
function $eb8e385c6b1a8a0e$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($eb8e385c6b1a8a0e$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($eb8e385c6b1a8a0e$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $eb8e385c6b1a8a0e$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        var canBeScrolledInMainDirection = (0, $1f3f10ad9b61e329$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $1f3f10ad9b61e329$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $1f3f10ad9b61e329$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$eb8e385c6b1a8a0e$var$lockStack.length || $eb8e385c6b1a8a0e$var$lockStack[$eb8e385c6b1a8a0e$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $eb8e385c6b1a8a0e$export$39efaa2ca254a28d(event) : $eb8e385c6b1a8a0e$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $eb8e385c6b1a8a0e$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($eb8e385c6b1a8a0e$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $eb8e385c6b1a8a0e$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $eb8e385c6b1a8a0e$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $eb8e385c6b1a8a0e$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $eb8e385c6b1a8a0e$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $eb8e385c6b1a8a0e$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $ec828813b0ccba36$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $ec828813b0ccba36$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $ec828813b0ccba36$export$10a6e88623fa9454));
        return function() {
            $eb8e385c6b1a8a0e$var$lockStack = $eb8e385c6b1a8a0e$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $ec828813b0ccba36$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $ec828813b0ccba36$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $ec828813b0ccba36$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $eb8e385c6b1a8a0e$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $eb8e385c6b1a8a0e$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $43d2c1969708a546$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $8c29bec41a1a1b26$export$e27363444bedfeac), (0, $eb8e385c6b1a8a0e$export$a09dbff87b5da2d));


var $496eb03ebbf5db4c$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $fd1e522ab70c935c$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $43d2c1969708a546$export$2e2bcd8739ae039)
    }));
});
$496eb03ebbf5db4c$var$ReactRemoveScroll.classNames = (0, $fd1e522ab70c935c$export$22940b497e769dee).classNames;
var $496eb03ebbf5db4c$export$2e2bcd8739ae039 = $496eb03ebbf5db4c$var$ReactRemoveScroll;



"use client";
var $82110f2367303f9b$var$SELECTION_KEYS = [
    "Enter",
    " "
];
var $82110f2367303f9b$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
var $82110f2367303f9b$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
var $82110f2367303f9b$var$FIRST_LAST_KEYS = [
    ...$82110f2367303f9b$var$FIRST_KEYS,
    ...$82110f2367303f9b$var$LAST_KEYS
];
var $82110f2367303f9b$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$82110f2367303f9b$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$82110f2367303f9b$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
var $82110f2367303f9b$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
var $82110f2367303f9b$var$MENU_NAME = "Menu";
var [$82110f2367303f9b$var$Collection, $82110f2367303f9b$var$useCollection, $82110f2367303f9b$var$createCollectionScope] = (0, $4c997e459ed9f4e5$export$c74125a8e3af6bb2)($82110f2367303f9b$var$MENU_NAME);
var [$82110f2367303f9b$var$createMenuContext, $82110f2367303f9b$export$4027731b685e72eb] = (0, $734c31b1f2793eab$export$50c7b4e9d9f19c1)($82110f2367303f9b$var$MENU_NAME, [
    $82110f2367303f9b$var$createCollectionScope,
    (0, $c900eaabac86a93f$export$722aac194ae923),
    (0, $0483c88073bf4923$export$c7109489551a4f4)
]);
var $82110f2367303f9b$var$usePopperScope = (0, $c900eaabac86a93f$export$722aac194ae923)();
var $82110f2367303f9b$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
var [$82110f2367303f9b$var$MenuProvider, $82110f2367303f9b$var$useMenuContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$MENU_NAME);
var [$82110f2367303f9b$var$MenuRootProvider, $82110f2367303f9b$var$useMenuRootContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$MENU_NAME);
var $82110f2367303f9b$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu, open: open = false, children: children, dir: dir, onOpenChange: onOpenChange, modal: modal = true } = props;
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    const [content, setContent] = $acw62.useState(null);
    const isUsingKeyboardRef = $acw62.useRef(false);
    const handleOpenChange = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onOpenChange);
    const direction = (0, $897c357432cec481$export$b39126d51d94e6f3)(dir);
    $acw62.useEffect(()=>{
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c900eaabac86a93f$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuRootProvider, {
                scope: __scopeMenu,
                onClose: $acw62.useCallback(()=>handleOpenChange(false), [
                    handleOpenChange
                ]),
                isUsingKeyboardRef: isUsingKeyboardRef,
                dir: direction,
                modal: modal,
                children: children
            })
        })
    });
};
$82110f2367303f9b$export$d9b273488cd8ce6f.displayName = $82110f2367303f9b$var$MENU_NAME;
var $82110f2367303f9b$var$ANCHOR_NAME = "MenuAnchor";
var $82110f2367303f9b$export$9fa5ebd18bee4d43 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...anchorProps } = props;
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c900eaabac86a93f$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$9fa5ebd18bee4d43.displayName = $82110f2367303f9b$var$ANCHOR_NAME;
var $82110f2367303f9b$var$PORTAL_NAME = "MenuPortal";
var [$82110f2367303f9b$var$PortalProvider, $82110f2367303f9b$var$usePortalContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$PORTAL_NAME, {
    forceMount: void 0
});
var $82110f2367303f9b$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, children: children, container: container } = props;
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$PORTAL_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $78b45d01ed879d75$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e3eccf78e3e5930f$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$82110f2367303f9b$export$793392f970497feb.displayName = $82110f2367303f9b$var$PORTAL_NAME;
var $82110f2367303f9b$var$CONTENT_NAME = "MenuContent";
var [$82110f2367303f9b$var$MenuContentProvider, $82110f2367303f9b$var$useMenuContentContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$CONTENT_NAME);
var $82110f2367303f9b$export$479f0f2f71193efe = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $82110f2367303f9b$var$usePortalContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $78b45d01ed879d75$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: rootContext.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuRootContentModal, {
                    ...contentProps,
                    ref: forwardedRef
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuRootContentNonModal, {
                    ...contentProps,
                    ref: forwardedRef
                })
            })
        })
    });
});
var $82110f2367303f9b$var$MenuRootContentModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const content = ref.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $82110f2367303f9b$var$MenuRootContentNonModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $82110f2367303f9b$var$MenuContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, loop: loop = false, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEntryFocus: onEntryFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, disableOutsideScroll: disableOutsideScroll, ...contentProps } = props;
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $82110f2367303f9b$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $82110f2367303f9b$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = $acw62.useState(null);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = $acw62.useRef(0);
    const searchRef = $acw62.useRef("");
    const pointerGraceTimerRef = $acw62.useRef(0);
    const pointerGraceIntentRef = $acw62.useRef(null);
    const pointerDirRef = $acw62.useRef("right");
    const lastPointerXRef = $acw62.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $496eb03ebbf5db4c$export$2e2bcd8739ae039) : $acw62.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: (0, $144b43512ff6b0e2$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    } : void 0;
    const handleTypeaheadSearch = (key)=>{
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = items.find((item)=>item.ref.current === currentItem)?.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $82110f2367303f9b$var$getNextMatch(values, search, currentMatch);
        const newItem = items.find((item)=>item.textValue === nextMatch)?.ref.current;
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
        if (newItem) setTimeout(()=>newItem.focus());
    };
    $acw62.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    (0, $a949c8bc51c5c49e$export$b7ece24a22aeda8c)();
    const isPointerMovingToSubmenu = $acw62.useCallback((event)=>{
        const isMovingTowards = pointerDirRef.current === pointerGraceIntentRef.current?.side;
        return isMovingTowards && $82110f2367303f9b$var$isPointerInGraceArea(event, pointerGraceIntentRef.current?.area);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: $acw62.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: $acw62.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) return;
            contentRef.current?.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: $acw62.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: $acw62.useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ScrollLockWrapper, {
            ...scrollLockWrapperProps,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $36279d10a0d5b706$export$20e40289641fbbb6), {
                asChild: true,
                trapped: trapFocus,
                onMountAutoFocus: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(onOpenAutoFocus, (event)=>{
                    event.preventDefault();
                    contentRef.current?.focus({
                        preventScroll: true
                    });
                }),
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $39738647392f0b48$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: disableOutsidePointerEvents,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: onFocusOutside,
                    onInteractOutside: onInteractOutside,
                    onDismiss: onDismiss,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$be92b6f5f03c0fe9, {
                        asChild: true,
                        ...rovingFocusGroupScope,
                        dir: rootContext.dir,
                        orientation: "vertical",
                        loop: loop,
                        currentTabStopId: currentItemId,
                        onCurrentTabStopIdChange: setCurrentItemId,
                        onEntryFocus: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(onEntryFocus, (event)=>{
                            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                        }),
                        preventScrollOnEntryFocus: true,
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c900eaabac86a93f$export$7c6e2c02157bb7d2, {
                            role: "menu",
                            "aria-orientation": "vertical",
                            "data-state": $82110f2367303f9b$var$getOpenState(context.open),
                            "data-radix-menu-content": "",
                            dir: rootContext.dir,
                            ...popperScope,
                            ...contentProps,
                            ref: composedRefs,
                            style: {
                                outline: "none",
                                ...contentProps.style
                            },
                            onKeyDown: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                                const target = event.target;
                                const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                                const isCharacterKey = event.key.length === 1;
                                if (isKeyDownInside) {
                                    if (event.key === "Tab") event.preventDefault();
                                    if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                                }
                                const content = contentRef.current;
                                if (event.target !== content) return;
                                if (!$82110f2367303f9b$var$FIRST_LAST_KEYS.includes(event.key)) return;
                                event.preventDefault();
                                const items = getItems().filter((item)=>!item.disabled);
                                const candidateNodes = items.map((item)=>item.ref.current);
                                if ($82110f2367303f9b$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                                $82110f2367303f9b$var$focusFirst(candidateNodes);
                            }),
                            onBlur: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onBlur, (event)=>{
                                if (!event.currentTarget.contains(event.target)) {
                                    window.clearTimeout(timerRef.current);
                                    searchRef.current = "";
                                }
                            }),
                            onPointerMove: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$whenMouse((event)=>{
                                const target = event.target;
                                const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                                if (event.currentTarget.contains(target) && pointerXHasChanged) {
                                    const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                                    pointerDirRef.current = newDir;
                                    lastPointerXRef.current = event.clientX;
                                }
                            }))
                        })
                    })
                })
            })
        })
    });
});
$82110f2367303f9b$export$479f0f2f71193efe.displayName = $82110f2367303f9b$var$CONTENT_NAME;
var $82110f2367303f9b$var$GROUP_NAME = "MenuGroup";
var $82110f2367303f9b$export$22a631d1f72787bb = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        role: "group",
        ...groupProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$22a631d1f72787bb.displayName = $82110f2367303f9b$var$GROUP_NAME;
var $82110f2367303f9b$var$LABEL_NAME = "MenuLabel";
var $82110f2367303f9b$export$dd37bec0e8a99143 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        ...labelProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$dd37bec0e8a99143.displayName = $82110f2367303f9b$var$LABEL_NAME;
var $82110f2367303f9b$var$ITEM_NAME = "MenuItem";
var $82110f2367303f9b$var$ITEM_SELECT = "menu.itemSelect";
var $82110f2367303f9b$export$2ce376c2cc3355c8 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disabled: disabled = false, onSelect: onSelect, ...itemProps } = props;
    const ref = $acw62.useRef(null);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $82110f2367303f9b$var$useMenuContentContext($82110f2367303f9b$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const isPointerDownRef = $acw62.useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($82110f2367303f9b$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($82110f2367303f9b$var$ITEM_SELECT, (event)=>onSelect?.(event), {
                once: true
            });
            (0, $3a849823db0e7dc9$export$6d1a0317bde7de7f)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuItemImpl, {
        ...itemProps,
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            props.onPointerDown?.(event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            if (!isPointerDownRef.current) event.currentTarget?.click();
        }),
        onKeyDown: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($82110f2367303f9b$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                event.preventDefault();
            }
        })
    });
});
$82110f2367303f9b$export$2ce376c2cc3355c8.displayName = $82110f2367303f9b$var$ITEM_NAME;
var $82110f2367303f9b$var$MenuItemImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, disabled: disabled = false, textValue: textValue, ...itemProps } = props;
    const contentContext = $82110f2367303f9b$var$useMenuContentContext($82110f2367303f9b$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $82110f2367303f9b$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [isFocused, setIsFocused] = $acw62.useState(false);
    const [textContent, setTextContent] = $acw62.useState("");
    $acw62.useEffect(()=>{
        const menuItem = ref.current;
        if (menuItem) setTextContent((menuItem.textContent ?? "").trim());
    }, [
        itemProps.children
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue ?? textContent,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$6d08773d2e66f8f2, {
            asChild: true,
            ...rovingFocusGroupScope,
            focusable: !disabled,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
                role: "menuitem",
                "data-highlighted": isFocused ? "" : void 0,
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                ...itemProps,
                ref: composedRefs,
                onPointerMove: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$whenMouse((event)=>{
                    if (disabled) contentContext.onItemLeave(event);
                    else {
                        contentContext.onItemEnter(event);
                        if (!event.defaultPrevented) {
                            const item = event.currentTarget;
                            item.focus({
                                preventScroll: true
                            });
                        }
                    }
                })),
                onPointerLeave: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onPointerLeave, $82110f2367303f9b$var$whenMouse((event)=>contentContext.onItemLeave(event))),
                onFocus: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsFocused(false))
            })
        })
    });
});
var $82110f2367303f9b$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var $82110f2367303f9b$export$f6f243521332502d = $acw62.forwardRef((props, forwardedRef)=>{
    const { checked: checked = false, onCheckedChange: onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$2ce376c2cc3355c8, {
            role: "menuitemcheckbox",
            "aria-checked": $82110f2367303f9b$var$isIndeterminate(checked) ? "mixed" : checked,
            ...checkboxItemProps,
            ref: forwardedRef,
            "data-state": $82110f2367303f9b$var$getCheckedState(checked),
            onSelect: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(checkboxItemProps.onSelect, ()=>onCheckedChange?.($82110f2367303f9b$var$isIndeterminate(checked) ? true : !checked), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$82110f2367303f9b$export$f6f243521332502d.displayName = $82110f2367303f9b$var$CHECKBOX_ITEM_NAME;
var $82110f2367303f9b$var$RADIO_GROUP_NAME = "MenuRadioGroup";
var [$82110f2367303f9b$var$RadioGroupProvider, $82110f2367303f9b$var$useRadioGroupContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$RADIO_GROUP_NAME, {
    value: void 0,
    onValueChange: ()=>{}
});
var $82110f2367303f9b$export$ea2200c9eee416b3 = $acw62.forwardRef((props, forwardedRef)=>{
    const { value: value, onValueChange: onValueChange, ...groupProps } = props;
    const handleValueChange = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onValueChange);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$22a631d1f72787bb, {
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$82110f2367303f9b$export$ea2200c9eee416b3.displayName = $82110f2367303f9b$var$RADIO_GROUP_NAME;
var $82110f2367303f9b$var$RADIO_ITEM_NAME = "MenuRadioItem";
var $82110f2367303f9b$export$69bd225e9817f6d0 = $acw62.forwardRef((props, forwardedRef)=>{
    const { value: value, ...radioItemProps } = props;
    const context = $82110f2367303f9b$var$useRadioGroupContext($82110f2367303f9b$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$2ce376c2cc3355c8, {
            role: "menuitemradio",
            "aria-checked": checked,
            ...radioItemProps,
            ref: forwardedRef,
            "data-state": $82110f2367303f9b$var$getCheckedState(checked),
            onSelect: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(radioItemProps.onSelect, ()=>context.onValueChange?.(value), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$82110f2367303f9b$export$69bd225e9817f6d0.displayName = $82110f2367303f9b$var$RADIO_ITEM_NAME;
var $82110f2367303f9b$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
var [$82110f2367303f9b$var$ItemIndicatorProvider, $82110f2367303f9b$var$useItemIndicatorContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$ITEM_INDICATOR_NAME, {
    checked: false
});
var $82110f2367303f9b$export$a2593e23056970a3 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = $82110f2367303f9b$var$useItemIndicatorContext($82110f2367303f9b$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $78b45d01ed879d75$export$99c2b779aa4e8b8b), {
        present: forceMount || $82110f2367303f9b$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).span, {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": $82110f2367303f9b$var$getCheckedState(indicatorContext.checked)
        })
    });
});
$82110f2367303f9b$export$a2593e23056970a3.displayName = $82110f2367303f9b$var$ITEM_INDICATOR_NAME;
var $82110f2367303f9b$var$SEPARATOR_NAME = "MenuSeparator";
var $82110f2367303f9b$export$1cec7dcdd713e220 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3a849823db0e7dc9$export$250ffa63cdc0d034).div, {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$1cec7dcdd713e220.displayName = $82110f2367303f9b$var$SEPARATOR_NAME;
var $82110f2367303f9b$var$ARROW_NAME = "MenuArrow";
var $82110f2367303f9b$export$bcdda4773debf5fa = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...arrowProps } = props;
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c900eaabac86a93f$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$82110f2367303f9b$export$bcdda4773debf5fa.displayName = $82110f2367303f9b$var$ARROW_NAME;
var $82110f2367303f9b$var$SUB_NAME = "MenuSub";
var [$82110f2367303f9b$var$MenuSubProvider, $82110f2367303f9b$var$useMenuSubContext] = $82110f2367303f9b$var$createMenuContext($82110f2367303f9b$var$SUB_NAME);
var $82110f2367303f9b$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu, children: children, open: open = false, onOpenChange: onOpenChange } = props;
    const parentMenuContext = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$SUB_NAME, __scopeMenu);
    const popperScope = $82110f2367303f9b$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = $acw62.useState(null);
    const [content, setContent] = $acw62.useState(null);
    const handleOpenChange = (0, $d7bcbdb538768a1a$export$25bec8c6f54ee79a)(onOpenChange);
    $acw62.useEffect(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c900eaabac86a93f$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuSubProvider, {
                scope: __scopeMenu,
                contentId: (0, $f1dc4e0906c8967e$export$f680877a34711e37)(),
                triggerId: (0, $f1dc4e0906c8967e$export$f680877a34711e37)(),
                trigger: trigger,
                onTriggerChange: setTrigger,
                children: children
            })
        })
    });
};
$82110f2367303f9b$export$71bdb9d1e2909932.displayName = $82110f2367303f9b$var$SUB_NAME;
var $82110f2367303f9b$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
var $82110f2367303f9b$export$5fbbb3ba7297405f = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $82110f2367303f9b$var$useMenuSubContext($82110f2367303f9b$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $82110f2367303f9b$var$useMenuContentContext($82110f2367303f9b$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = $acw62.useRef(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef, onPointerGraceIntentChange: onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = $acw62.useCallback(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    $acw62.useEffect(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    $acw62.useEffect(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$9fa5ebd18bee4d43, {
        asChild: true,
        ...scope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuItemImpl, {
            id: subContext.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": subContext.contentId,
            "data-state": $82110f2367303f9b$var$getOpenState(context.open),
            ...props,
            ref: (0, $57e2e2154cec12ed$export$43e446d32b3d21af)(forwardedRef, subContext.onTriggerChange),
            onClick: (event)=>{
                props.onClick?.(event);
                if (props.disabled || event.defaultPrevented) return;
                event.currentTarget.focus();
                if (!context.open) context.onOpenChange(true);
            },
            onPointerMove: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onPointerMove, $82110f2367303f9b$var$whenMouse((event)=>{
                contentContext.onItemEnter(event);
                if (event.defaultPrevented) return;
                if (!props.disabled && !context.open && !openTimerRef.current) {
                    contentContext.onPointerGraceIntentChange(null);
                    openTimerRef.current = window.setTimeout(()=>{
                        context.onOpenChange(true);
                        clearOpenTimer();
                    }, 100);
                }
            })),
            onPointerLeave: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onPointerLeave, $82110f2367303f9b$var$whenMouse((event)=>{
                clearOpenTimer();
                const contentRect = context.content?.getBoundingClientRect();
                if (contentRect) {
                    const side = context.content?.dataset.side;
                    const rightSide = side === "right";
                    const bleed = rightSide ? -5 : 5;
                    const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                    const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                    contentContext.onPointerGraceIntentChange({
                        area: [
                            // Apply a bleed on clientX to ensure that our exit point is
                            // consistently within polygon bounds
                            {
                                x: event.clientX + bleed,
                                y: event.clientY
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.bottom
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.bottom
                            }
                        ],
                        side: side
                    });
                    window.clearTimeout(pointerGraceTimerRef.current);
                    pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
                } else {
                    contentContext.onTriggerLeave(event);
                    if (event.defaultPrevented) return;
                    contentContext.onPointerGraceIntentChange(null);
                }
            })),
            onKeyDown: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                const isTypingAhead = contentContext.searchRef.current !== "";
                if (props.disabled || isTypingAhead && event.key === " ") return;
                if ($82110f2367303f9b$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                    context.onOpenChange(true);
                    context.content?.focus();
                    event.preventDefault();
                }
            })
        })
    });
});
$82110f2367303f9b$export$5fbbb3ba7297405f.displayName = $82110f2367303f9b$var$SUB_TRIGGER_NAME;
var $82110f2367303f9b$var$SUB_CONTENT_NAME = "MenuSubContent";
var $82110f2367303f9b$export$e7142ab31822bde6 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $82110f2367303f9b$var$usePortalContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = $82110f2367303f9b$var$useMenuContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$useMenuRootContext($82110f2367303f9b$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $82110f2367303f9b$var$useMenuSubContext($82110f2367303f9b$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $57e2e2154cec12ed$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $78b45d01ed879d75$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$var$MenuContentImpl, {
                    id: subContext.contentId,
                    "aria-labelledby": subContext.triggerId,
                    ...subContentProps,
                    ref: composedRefs,
                    align: "start",
                    side: rootContext.dir === "rtl" ? "left" : "right",
                    disableOutsidePointerEvents: false,
                    disableOutsideScroll: false,
                    trapFocus: false,
                    onOpenAutoFocus: (event)=>{
                        if (rootContext.isUsingKeyboardRef.current) ref.current?.focus();
                        event.preventDefault();
                    },
                    onCloseAutoFocus: (event)=>event.preventDefault(),
                    onFocusOutside: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
                        if (event.target !== subContext.trigger) context.onOpenChange(false);
                    }),
                    onEscapeKeyDown: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onEscapeKeyDown, (event)=>{
                        rootContext.onClose();
                        event.preventDefault();
                    }),
                    onKeyDown: (0, $05e3357d1fc31649$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                        const isKeyDownInside = event.currentTarget.contains(event.target);
                        const isCloseKey = $82110f2367303f9b$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
                        if (isKeyDownInside && isCloseKey) {
                            context.onOpenChange(false);
                            subContext.trigger?.focus();
                            event.preventDefault();
                        }
                    })
                })
            })
        })
    });
});
$82110f2367303f9b$export$e7142ab31822bde6.displayName = $82110f2367303f9b$var$SUB_CONTENT_NAME;
function $82110f2367303f9b$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $82110f2367303f9b$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $82110f2367303f9b$var$getCheckedState(checked) {
    return $82110f2367303f9b$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $82110f2367303f9b$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $82110f2367303f9b$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
function $82110f2367303f9b$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $82110f2367303f9b$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $82110f2367303f9b$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $82110f2367303f9b$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $82110f2367303f9b$var$isPointInPolygon(cursorPos, area);
}
function $82110f2367303f9b$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : void 0;
}
var $82110f2367303f9b$export$be92b6f5f03c0fe9 = $82110f2367303f9b$export$d9b273488cd8ce6f;
var $82110f2367303f9b$export$b688253958b8dfe7 = $82110f2367303f9b$export$9fa5ebd18bee4d43;
var $82110f2367303f9b$export$602eac185826482c = $82110f2367303f9b$export$793392f970497feb;
var $82110f2367303f9b$export$7c6e2c02157bb7d2 = $82110f2367303f9b$export$479f0f2f71193efe;
var $82110f2367303f9b$export$eb2fcfdbd7ba97d4 = $82110f2367303f9b$export$22a631d1f72787bb;
var $82110f2367303f9b$export$b04be29aa201d4f5 = $82110f2367303f9b$export$dd37bec0e8a99143;
var $82110f2367303f9b$export$6d08773d2e66f8f2 = $82110f2367303f9b$export$2ce376c2cc3355c8;
var $82110f2367303f9b$export$16ce288f89fa631c = $82110f2367303f9b$export$f6f243521332502d;
var $82110f2367303f9b$export$a98f0dcb43a68a25 = $82110f2367303f9b$export$ea2200c9eee416b3;
var $82110f2367303f9b$export$371ab307eab489c0 = $82110f2367303f9b$export$69bd225e9817f6d0;
var $82110f2367303f9b$export$c3468e2714d175fa = $82110f2367303f9b$export$a2593e23056970a3;
var $82110f2367303f9b$export$1ff3c3f08ae963c0 = $82110f2367303f9b$export$1cec7dcdd713e220;
var $82110f2367303f9b$export$21b07c8f274aebd5 = $82110f2367303f9b$export$bcdda4773debf5fa;
var $82110f2367303f9b$export$d7a01e11500dfb6f = $82110f2367303f9b$export$71bdb9d1e2909932;
var $82110f2367303f9b$export$2ea8a7a591ac5eac = $82110f2367303f9b$export$5fbbb3ba7297405f;
var $82110f2367303f9b$export$6d4de93b380beddf = $82110f2367303f9b$export$e7142ab31822bde6;


// packages/react/id/src/id.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $acw62 = parcelRequire("acw62");
var $0d64c93df981b46d$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $acw62.useLayoutEffect : ()=>{};


var $d08d3bbba48851a0$var$useReactId = $acw62["useId".toString()] || (()=>void 0);
var $d08d3bbba48851a0$var$count = 0;
function $d08d3bbba48851a0$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($d08d3bbba48851a0$var$useReactId());
    (0, $0d64c93df981b46d$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($d08d3bbba48851a0$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



"use client";
var $a51a7192f883dda1$var$DROPDOWN_MENU_NAME = "DropdownMenu";
var [$a51a7192f883dda1$var$createDropdownMenuContext, $a51a7192f883dda1$export$c0623cd925aeb687] = (0, $bd30d951836c8e03$export$50c7b4e9d9f19c1)($a51a7192f883dda1$var$DROPDOWN_MENU_NAME, [
    (0, $82110f2367303f9b$export$4027731b685e72eb)
]);
var $a51a7192f883dda1$var$useMenuScope = (0, $82110f2367303f9b$export$4027731b685e72eb)();
var [$a51a7192f883dda1$var$DropdownMenuProvider, $a51a7192f883dda1$var$useDropdownMenuContext] = $a51a7192f883dda1$var$createDropdownMenuContext($a51a7192f883dda1$var$DROPDOWN_MENU_NAME);
var $a51a7192f883dda1$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, dir: dir, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = $acw62.useRef(null);
    const [open = false, setOpen] = (0, $b5cf47ad6bad92ad$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $d08d3bbba48851a0$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        contentId: (0, $d08d3bbba48851a0$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$be92b6f5f03c0fe9, {
            ...menuScope,
            open: open,
            onOpenChange: setOpen,
            dir: dir,
            modal: modal,
            children: children
        })
    });
};
$a51a7192f883dda1$export$e44a253a59704894.displayName = $a51a7192f883dda1$var$DROPDOWN_MENU_NAME;
var $a51a7192f883dda1$var$TRIGGER_NAME = "DropdownMenuTrigger";
var $a51a7192f883dda1$export$d2469213b3befba9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $a51a7192f883dda1$var$useDropdownMenuContext($a51a7192f883dda1$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$b688253958b8dfe7, {
        asChild: true,
        ...menuScope,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03b33fdb9adb443d$export$250ffa63cdc0d034).button, {
            type: "button",
            id: context.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": context.open ? context.contentId : void 0,
            "data-state": context.open ? "open" : "closed",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            ...triggerProps,
            ref: (0, $dd9035981542232d$export$43e446d32b3d21af)(forwardedRef, context.triggerRef),
            onPointerDown: (0, $639c769a9ab8b7ad$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) {
                    context.onOpenToggle();
                    if (!context.open) event.preventDefault();
                }
            }),
            onKeyDown: (0, $639c769a9ab8b7ad$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (disabled) return;
                if ([
                    "Enter",
                    " "
                ].includes(event.key)) context.onOpenToggle();
                if (event.key === "ArrowDown") context.onOpenChange(true);
                if ([
                    "Enter",
                    " ",
                    "ArrowDown"
                ].includes(event.key)) event.preventDefault();
            })
        })
    });
});
$a51a7192f883dda1$export$d2469213b3befba9.displayName = $a51a7192f883dda1$var$TRIGGER_NAME;
var $a51a7192f883dda1$var$PORTAL_NAME = "DropdownMenuPortal";
var $a51a7192f883dda1$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$602eac185826482c, {
        ...menuScope,
        ...portalProps
    });
};
$a51a7192f883dda1$export$cd369b4d4d54efc9.displayName = $a51a7192f883dda1$var$PORTAL_NAME;
var $a51a7192f883dda1$var$CONTENT_NAME = "DropdownMenuContent";
var $a51a7192f883dda1$export$6e76d93a37c01248 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...contentProps } = props;
    const context = $a51a7192f883dda1$var$useDropdownMenuContext($a51a7192f883dda1$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$7c6e2c02157bb7d2, {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: (0, $639c769a9ab8b7ad$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
            hasInteractedOutsideRef.current = false;
            event.preventDefault();
        }),
        onInteractOutside: (0, $639c769a9ab8b7ad$export$b9ecd428b558ff10)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$a51a7192f883dda1$export$6e76d93a37c01248.displayName = $a51a7192f883dda1$var$CONTENT_NAME;
var $a51a7192f883dda1$var$GROUP_NAME = "DropdownMenuGroup";
var $a51a7192f883dda1$export$246bebaba3a2f70e = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$eb2fcfdbd7ba97d4, {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$246bebaba3a2f70e.displayName = $a51a7192f883dda1$var$GROUP_NAME;
var $a51a7192f883dda1$var$LABEL_NAME = "DropdownMenuLabel";
var $a51a7192f883dda1$export$76e48c5b57f24495 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$b04be29aa201d4f5, {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$76e48c5b57f24495.displayName = $a51a7192f883dda1$var$LABEL_NAME;
var $a51a7192f883dda1$var$ITEM_NAME = "DropdownMenuItem";
var $a51a7192f883dda1$export$ed97964d1871885d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$6d08773d2e66f8f2, {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$ed97964d1871885d.displayName = $a51a7192f883dda1$var$ITEM_NAME;
var $a51a7192f883dda1$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
var $a51a7192f883dda1$export$53a69729da201fa9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$16ce288f89fa631c, {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$53a69729da201fa9.displayName = $a51a7192f883dda1$var$CHECKBOX_ITEM_NAME;
var $a51a7192f883dda1$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
var $a51a7192f883dda1$export$3323ad73d55f587e = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$a98f0dcb43a68a25, {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$3323ad73d55f587e.displayName = $a51a7192f883dda1$var$RADIO_GROUP_NAME;
var $a51a7192f883dda1$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
var $a51a7192f883dda1$export$e4f69b41b1637536 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$371ab307eab489c0, {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$e4f69b41b1637536.displayName = $a51a7192f883dda1$var$RADIO_ITEM_NAME;
var $a51a7192f883dda1$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
var $a51a7192f883dda1$export$42355ae145153fb6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$c3468e2714d175fa, {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$42355ae145153fb6.displayName = $a51a7192f883dda1$var$INDICATOR_NAME;
var $a51a7192f883dda1$var$SEPARATOR_NAME = "DropdownMenuSeparator";
var $a51a7192f883dda1$export$da160178fd3bc7e9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$1ff3c3f08ae963c0, {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$da160178fd3bc7e9.displayName = $a51a7192f883dda1$var$SEPARATOR_NAME;
var $a51a7192f883dda1$var$ARROW_NAME = "DropdownMenuArrow";
var $a51a7192f883dda1$export$34b8980744021ec5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$21b07c8f274aebd5, {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$34b8980744021ec5.displayName = $a51a7192f883dda1$var$ARROW_NAME;
var $a51a7192f883dda1$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, open: openProp, onOpenChange: onOpenChange, defaultOpen: defaultOpen } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    const [open = false, setOpen] = (0, $b5cf47ad6bad92ad$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$d7a01e11500dfb6f, {
        ...menuScope,
        open: open,
        onOpenChange: setOpen,
        children: children
    });
};
var $a51a7192f883dda1$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
var $a51a7192f883dda1$export$21dcb7ec56f874cf = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$2ea8a7a591ac5eac, {
        ...menuScope,
        ...subTriggerProps,
        ref: forwardedRef
    });
});
$a51a7192f883dda1$export$21dcb7ec56f874cf.displayName = $a51a7192f883dda1$var$SUB_TRIGGER_NAME;
var $a51a7192f883dda1$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
var $a51a7192f883dda1$export$f34ec8bc2482cc5f = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = $a51a7192f883dda1$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$6d4de93b380beddf, {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$a51a7192f883dda1$export$f34ec8bc2482cc5f.displayName = $a51a7192f883dda1$var$SUB_CONTENT_NAME;
var $a51a7192f883dda1$export$be92b6f5f03c0fe9 = $a51a7192f883dda1$export$e44a253a59704894;
var $a51a7192f883dda1$export$41fb9f06171c75f4 = $a51a7192f883dda1$export$d2469213b3befba9;
var $a51a7192f883dda1$export$602eac185826482c = $a51a7192f883dda1$export$cd369b4d4d54efc9;
var $a51a7192f883dda1$export$7c6e2c02157bb7d2 = $a51a7192f883dda1$export$6e76d93a37c01248;
var $a51a7192f883dda1$export$eb2fcfdbd7ba97d4 = $a51a7192f883dda1$export$246bebaba3a2f70e;
var $a51a7192f883dda1$export$b04be29aa201d4f5 = $a51a7192f883dda1$export$76e48c5b57f24495;
var $a51a7192f883dda1$export$6d08773d2e66f8f2 = $a51a7192f883dda1$export$ed97964d1871885d;
var $a51a7192f883dda1$export$16ce288f89fa631c = $a51a7192f883dda1$export$53a69729da201fa9;
var $a51a7192f883dda1$export$a98f0dcb43a68a25 = $a51a7192f883dda1$export$3323ad73d55f587e;
var $a51a7192f883dda1$export$371ab307eab489c0 = $a51a7192f883dda1$export$e4f69b41b1637536;
var $a51a7192f883dda1$export$c3468e2714d175fa = $a51a7192f883dda1$export$42355ae145153fb6;
var $a51a7192f883dda1$export$1ff3c3f08ae963c0 = $a51a7192f883dda1$export$da160178fd3bc7e9;
var $a51a7192f883dda1$export$21b07c8f274aebd5 = $a51a7192f883dda1$export$34b8980744021ec5;
var $a51a7192f883dda1$export$d7a01e11500dfb6f = $a51a7192f883dda1$export$2f307d81a64f5442;
var $a51a7192f883dda1$export$2ea8a7a591ac5eac = $a51a7192f883dda1$export$21dcb7ec56f874cf;
var $a51a7192f883dda1$export$6d4de93b380beddf = $a51a7192f883dda1$export$f34ec8bc2482cc5f;



const $d613ba4b2c8b01a2$export$941fd5c4dbed963a = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_289_202",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_289_202)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M7.202 18.5V17H14.3788C15.4224 17 16.3205 16.6554 17.073 15.9663C17.8257 15.2773 18.202 14.4263 18.202 13.4135C18.202 12.4007 17.8257 11.5512 17.073 10.8652C16.3205 10.1794 15.4224 9.8365 14.3788 9.8365H7.35775L10.1402 12.6193L9.0865 13.673L4.5 9.0865L9.0865 4.5L10.1402 5.55375L7.35775 8.3365H14.3788C15.8416 8.3365 17.0945 8.82467 18.1375 9.801C19.1805 10.7773 19.702 11.9815 19.702 13.4135C19.702 14.8455 19.1805 16.0513 18.1375 17.0308C17.0945 18.0103 15.8416 18.5 14.3788 18.5H7.202Z",
                    fill: "#a3a3a3"
                })
            })
        ]
    });
};



const $0d64611e07d35c6b$export$d275b7689549104e = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_289_206",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_289_206)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M9.62122 18.5C8.15839 18.5 6.90547 18.0103 5.86247 17.0308C4.81947 16.0513 4.29797 14.8455 4.29797 13.4135C4.29797 11.9815 4.81947 10.7773 5.86247 9.801C6.90547 8.82467 8.15839 8.3365 9.62122 8.3365H16.6422L13.8597 5.55375L14.9135 4.5L19.5 9.0865L14.9135 13.673L13.8597 12.6193L16.6422 9.8365H9.62122C8.57756 9.8365 7.67947 10.1794 6.92697 10.8652C6.17431 11.5512 5.79797 12.4007 5.79797 13.4135C5.79797 14.4263 6.17431 15.2773 6.92697 15.9663C7.67947 16.6554 8.57756 17 9.62122 17H16.798V18.5H9.62122Z",
                    fill: "#a3a3a3"
                })
            })
        ]
    });
};



const $a0289962040cc13a$export$fc6234d5b1c606d7 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_289_210",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_289_210)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M12 19.2692C11.5875 19.2692 11.2344 19.1223 10.9408 18.8285C10.6469 18.5348 10.5 18.1817 10.5 17.7692C10.5 17.3567 10.6469 17.0035 10.9408 16.7097C11.2344 16.416 11.5875 16.2692 12 16.2692C12.4125 16.2692 12.7656 16.416 13.0592 16.7097C13.3531 17.0035 13.5 17.3567 13.5 17.7692C13.5 18.1817 13.3531 18.5348 13.0592 18.8285C12.7656 19.1223 12.4125 19.2692 12 19.2692ZM12 13.5C11.5875 13.5 11.2344 13.353 10.9408 13.0592C10.6469 12.7655 10.5 12.4125 10.5 12C10.5 11.5875 10.6469 11.2344 10.9408 10.9407C11.2344 10.6469 11.5875 10.5 12 10.5C12.4125 10.5 12.7656 10.6469 13.0592 10.9407C13.3531 11.2344 13.5 11.5875 13.5 12C13.5 12.4125 13.3531 12.7655 13.0592 13.0592C12.7656 13.353 12.4125 13.5 12 13.5ZM12 7.73071C11.5875 7.73071 11.2344 7.58388 10.9408 7.29021C10.6469 6.99638 10.5 6.64321 10.5 6.23071C10.5 5.81821 10.6469 5.46513 10.9408 5.17146C11.2344 4.87763 11.5875 4.73071 12 4.73071C12.4125 4.73071 12.7656 4.87763 13.0592 5.17146C13.3531 5.46513 13.5 5.81821 13.5 6.23071C13.5 6.64321 13.3531 6.99638 13.0592 7.29021C12.7656 7.58388 12.4125 7.73071 12 7.73071Z",
                    fill: "#a3a3a3"
                })
            })
        ]
    });
};


function $0ef7333827c05d3b$export$a274e22fb40f762e(...classNames) {
    return classNames.filter((it)=>typeof it === "string").join(" ");
}




const $d97f4495e5002ba5$var$textMap = {
    undo: {
        en: "Undo",
        ja: "\u5143\u306B\u623B\u3059"
    },
    redo: {
        en: "Redo",
        ja: "\u3084\u308A\u76F4\u3059"
    },
    "export to clipboard": {
        en: "Export to clipboard",
        ja: "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u66F8\u304D\u51FA\u3057"
    },
    "export to file": {
        en: "Export to file",
        ja: "\u30D5\u30A1\u30A4\u30EB\u306B\u66F8\u304D\u51FA\u3057"
    },
    "zoom in": {
        en: "Zoom in",
        ja: "\u30BA\u30FC\u30E0\u30A4\u30F3"
    },
    "zoom out": {
        en: "Zoom out",
        ja: "\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8"
    },
    "zoom to 100%": {
        en: "Zoom to 100%",
        ja: "100% \u306B\u30BA\u30FC\u30E0"
    },
    "select all": {
        en: "Select all",
        ja: "\u3059\u3079\u3066\u9078\u629E"
    }
};
const $d97f4495e5002ba5$export$11a6fe490bbc4873 = (props)=>{
    const texts = (0, $c17f85d6c45c40da$export$2ecf1baeef3275cf)($d97f4495e5002ba5$var$textMap);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).historyButtons,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                        label: texts.undo,
                        shortcut: "\u2318Z",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            disabled: props.disabled || !props.canUndo,
                            className: (0, $0ef7333827c05d3b$export$a274e22fb40f762e)((0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).button, (0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).undo),
                            onClick: props.onUndoClick,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d613ba4b2c8b01a2$export$941fd5c4dbed963a), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$28c660c63b792dea), {
                        label: texts.redo,
                        shortcut: "\u21E7\u2318Z",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            disabled: props.disabled || !props.canRedo,
                            className: (0, $0ef7333827c05d3b$export$a274e22fb40f762e)((0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).button, (0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).redo),
                            onClick: props.onRedoClick,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d64611e07d35c6b$export$d275b7689549104e), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).menuWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$be92b6f5f03c0fe9, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$41fb9f06171c75f4, {
                            disabled: props.disabled,
                            className: (0, $0ef7333827c05d3b$export$a274e22fb40f762e)((0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).button, (0, (/*@__PURE__*/$parcel$interopDefault($ec64125824bb00fd$exports))).menu),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a0289962040cc13a$export$fc6234d5b1c606d7), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$602eac185826482c, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$7c6e2c02157bb7d2, {
                                side: "bottom",
                                sideOffset: 8,
                                align: "end",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).content,
                                onKeyDown: (e)=>e.stopPropagation(),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$6d08773d2e66f8f2, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                                        onSelect: ()=>props.onMenuItemSelect("export_to_clipboard"),
                                        children: [
                                            texts["export to clipboard"],
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                                children: "\u21E7\u2318C"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$6d08773d2e66f8f2, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                                        onSelect: ()=>props.onMenuItemSelect("export_to_file"),
                                        children: texts["export to file"]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$1ff3c3f08ae963c0, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).separator
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$6d08773d2e66f8f2, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                                        onSelect: ()=>props.onMenuItemSelect("zoom_in"),
                                        children: [
                                            texts["zoom in"],
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                                children: "\u2318+"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$6d08773d2e66f8f2, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                                        onSelect: ()=>props.onMenuItemSelect("zoom_out"),
                                        children: [
                                            texts["zoom out"],
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                                children: "\u2318-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$6d08773d2e66f8f2, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                                        onSelect: ()=>props.onMenuItemSelect("zoom_to_100"),
                                        children: [
                                            texts["zoom to 100%"],
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                                children: "\u23180"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51a7192f883dda1$export$1ff3c3f08ae963c0, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).separator
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a51a7192f883dda1$export$6d08773d2e66f8f2, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                                        onSelect: ()=>props.onMenuItemSelect("select_all"),
                                        children: [
                                            texts["select all"],
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                                children: "\u2318A"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};




async function $2ad0921b83387183$export$ddb2291e6e5fa9a7(file) {
    if (file.type !== "image/png") return undefined;
    const image = await file.arrayBuffer();
    const dpi = (0, $516ef8e471c65448$export$f790c636e73721c6)(image)?.x ?? 72;
    const density = dpi / 72;
    const bitmap = await createImageBitmap(file);
    return {
        bitmap: bitmap,
        density: density
    };
}




var $acw62 = parcelRequire("acw62");
var $3db54e1da86db304$exports = {};

$parcel$export($3db54e1da86db304$exports, "bottomLeft", () => $3db54e1da86db304$export$5909307a9e24921b, (v) => $3db54e1da86db304$export$5909307a9e24921b = v);
$parcel$export($3db54e1da86db304$exports, "bottomRight", () => $3db54e1da86db304$export$310433d43d4a6657, (v) => $3db54e1da86db304$export$310433d43d4a6657 = v);
$parcel$export($3db54e1da86db304$exports, "container", () => $3db54e1da86db304$export$34e0f9847d4c02dd, (v) => $3db54e1da86db304$export$34e0f9847d4c02dd = v);
$parcel$export($3db54e1da86db304$exports, "corner", () => $3db54e1da86db304$export$32c9958544d81ba4, (v) => $3db54e1da86db304$export$32c9958544d81ba4 = v);
$parcel$export($3db54e1da86db304$exports, "paragraph", () => $3db54e1da86db304$export$9c206ddddb32a9b, (v) => $3db54e1da86db304$export$9c206ddddb32a9b = v);
$parcel$export($3db54e1da86db304$exports, "paragraphs", () => $3db54e1da86db304$export$c4a79ec0e91224d1, (v) => $3db54e1da86db304$export$c4a79ec0e91224d1 = v);
$parcel$export($3db54e1da86db304$exports, "selectImage", () => $3db54e1da86db304$export$372b20ebaf057fb6, (v) => $3db54e1da86db304$export$372b20ebaf057fb6 = v);
$parcel$export($3db54e1da86db304$exports, "selectImageLink", () => $3db54e1da86db304$export$a2332cc81ada5634, (v) => $3db54e1da86db304$export$a2332cc81ada5634 = v);
$parcel$export($3db54e1da86db304$exports, "selectInput", () => $3db54e1da86db304$export$4f502711de93d534, (v) => $3db54e1da86db304$export$4f502711de93d534 = v);
$parcel$export($3db54e1da86db304$exports, "shortcut", () => $3db54e1da86db304$export$ec0409edb5e28490, (v) => $3db54e1da86db304$export$ec0409edb5e28490 = v);
$parcel$export($3db54e1da86db304$exports, "title", () => $3db54e1da86db304$export$fb184b623420d9be, (v) => $3db54e1da86db304$export$fb184b623420d9be = v);
$parcel$export($3db54e1da86db304$exports, "topLeft", () => $3db54e1da86db304$export$b36ce604e2cd7590, (v) => $3db54e1da86db304$export$b36ce604e2cd7590 = v);
$parcel$export($3db54e1da86db304$exports, "topRight", () => $3db54e1da86db304$export$eff07f92f1a4dad9, (v) => $3db54e1da86db304$export$eff07f92f1a4dad9 = v);
var $3db54e1da86db304$export$5909307a9e24921b;
var $3db54e1da86db304$export$310433d43d4a6657;
var $3db54e1da86db304$export$34e0f9847d4c02dd;
var $3db54e1da86db304$export$32c9958544d81ba4;
var $3db54e1da86db304$export$9c206ddddb32a9b;
var $3db54e1da86db304$export$c4a79ec0e91224d1;
var $3db54e1da86db304$export$372b20ebaf057fb6;
var $3db54e1da86db304$export$a2332cc81ada5634;
var $3db54e1da86db304$export$4f502711de93d534;
var $3db54e1da86db304$export$ec0409edb5e28490;
var $3db54e1da86db304$export$fb184b623420d9be;
var $3db54e1da86db304$export$b36ce604e2cd7590;
var $3db54e1da86db304$export$eff07f92f1a4dad9;
$3db54e1da86db304$export$5909307a9e24921b = `gr__XG_bottomLeft`;
$3db54e1da86db304$export$310433d43d4a6657 = `gr__XG_bottomRight`;
$3db54e1da86db304$export$34e0f9847d4c02dd = `gr__XG_container`;
$3db54e1da86db304$export$32c9958544d81ba4 = `gr__XG_corner`;
$3db54e1da86db304$export$9c206ddddb32a9b = `gr__XG_paragraph`;
$3db54e1da86db304$export$c4a79ec0e91224d1 = `gr__XG_paragraphs`;
$3db54e1da86db304$export$372b20ebaf057fb6 = `gr__XG_selectImage`;
$3db54e1da86db304$export$a2332cc81ada5634 = `gr__XG_selectImageLink`;
$3db54e1da86db304$export$4f502711de93d534 = `gr__XG_selectInput`;
$3db54e1da86db304$export$ec0409edb5e28490 = `gr__XG_shortcut`;
$3db54e1da86db304$export$fb184b623420d9be = `gr__XG_title`;
$3db54e1da86db304$export$b36ce604e2cd7590 = `gr__XG_topLeft`;
$3db54e1da86db304$export$eff07f92f1a4dad9 = `gr__XG_topRight`;




const $661b3888850954f4$var$textMap = {
    "welcome to snapink": {
        en: "Welcome to SnapInk",
        ja: "SnapInk \u3078\u3088\u3046\u3053\u305D"
    },
    "press %s to paste an image from your clipboard.": {
        en: "Press %s to paste an image from your clipboard.",
        ja: "%s \u3092\u62BC\u3059\u3068\u3001\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u304B\u3089\u753B\u50CF\u3092\u8CBC\u308A\u4ED8\u3051\u307E\u3059\u3002"
    },
    "press %s to export your work as a PNG to your clipboard.": {
        en: "Press %s to export your work as a PNG to your clipboard.",
        ja: "%s \u3092\u62BC\u3059\u3068\u3001\u4F5C\u696D\u5185\u5BB9\u3092 PNG \u3067\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u66F8\u304D\u51FA\u3057\u307E\u3059\u3002"
    },
    "you can also %s to start drawing.": {
        en: "You can also %s to start drawing.",
        ja: "%s\u3057\u3066\u63CF\u753B\u3092\u958B\u59CB\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"
    },
    "select an image": {
        en: "select an image",
        ja: "\u753B\u50CF\u3092\u9078\u629E"
    }
};
const $661b3888850954f4$export$23191e4434a9e834 = (props)=>{
    const texts = (0, $c17f85d6c45c40da$export$2ecf1baeef3275cf)($661b3888850954f4$var$textMap);
    const inputRef = (0, $acw62.useRef)(null);
    const handleSelectImageClick = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        inputRef.current?.click();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $0ef7333827c05d3b$export$a274e22fb40f762e)((0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).corner, (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).topLeft)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $0ef7333827c05d3b$export$a274e22fb40f762e)((0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).corner, (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).topRight)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $0ef7333827c05d3b$export$a274e22fb40f762e)((0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).corner, (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).bottomRight)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $0ef7333827c05d3b$export$a274e22fb40f762e)((0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).corner, (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).bottomLeft)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).title,
                children: texts["welcome to snapink"]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).paragraphs,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).paragraph,
                        children: (0, $c17f85d6c45c40da$export$95672295c50ede1f)(texts["press %s to paste an image from your clipboard."], /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).shortcut,
                            children: "\u2318V"
                        }))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).paragraph,
                        children: (0, $c17f85d6c45c40da$export$95672295c50ede1f)(texts["press %s to export your work as a PNG to your clipboard."], /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).shortcut,
                            children: "\u21E7\u2318C"
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).selectImage,
                children: (0, $c17f85d6c45c40da$export$95672295c50ede1f)(texts["you can also %s to start drawing."], /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "#",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).selectImageLink,
                    onClick: handleSelectImageClick,
                    children: texts["select an image"]
                }))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                ref: inputRef,
                type: "file",
                accept: "image/png",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3db54e1da86db304$exports))).selectInput,
                onChange: props.onImageSelect
            })
        ]
    });
};





var $650a7633ee6aa1ee$exports = {};

$parcel$export($650a7633ee6aa1ee$exports, "container", () => $650a7633ee6aa1ee$export$34e0f9847d4c02dd, (v) => $650a7633ee6aa1ee$export$34e0f9847d4c02dd = v);
var $650a7633ee6aa1ee$export$34e0f9847d4c02dd;
$650a7633ee6aa1ee$export$34e0f9847d4c02dd = `rNVYSq_container`;



var $acw62 = parcelRequire("acw62");





var $4cea5c4c900ca768$exports = {};

$parcel$export($4cea5c4c900ca768$exports, "container", () => $4cea5c4c900ca768$export$34e0f9847d4c02dd, (v) => $4cea5c4c900ca768$export$34e0f9847d4c02dd = v);
$parcel$export($4cea5c4c900ca768$exports, "cornerHandleWrapper", () => $4cea5c4c900ca768$export$3ca1333f4688ee52, (v) => $4cea5c4c900ca768$export$3ca1333f4688ee52 = v);
$parcel$export($4cea5c4c900ca768$exports, "horizontalHandleWrapper", () => $4cea5c4c900ca768$export$b2789a14a78b1c8e, (v) => $4cea5c4c900ca768$export$b2789a14a78b1c8e = v);
$parcel$export($4cea5c4c900ca768$exports, "verticalHandleWrapper", () => $4cea5c4c900ca768$export$819e44c8fe383d27, (v) => $4cea5c4c900ca768$export$819e44c8fe383d27 = v);
var $4cea5c4c900ca768$export$34e0f9847d4c02dd;
var $4cea5c4c900ca768$export$3ca1333f4688ee52;
var $4cea5c4c900ca768$export$b2789a14a78b1c8e;
var $4cea5c4c900ca768$export$819e44c8fe383d27;
$4cea5c4c900ca768$export$34e0f9847d4c02dd = `pzEMaa_container`;
$4cea5c4c900ca768$export$3ca1333f4688ee52 = `pzEMaa_cornerHandleWrapper`;
$4cea5c4c900ca768$export$b2789a14a78b1c8e = `pzEMaa_horizontalHandleWrapper`;
$4cea5c4c900ca768$export$819e44c8fe383d27 = `pzEMaa_verticalHandleWrapper`;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $690af920b5992a36$exports = {};

$parcel$export($690af920b5992a36$exports, "container", () => $690af920b5992a36$export$34e0f9847d4c02dd, (v) => $690af920b5992a36$export$34e0f9847d4c02dd = v);
var $690af920b5992a36$export$34e0f9847d4c02dd;
$690af920b5992a36$export$34e0f9847d4c02dd = `X7hrkW_container`;



var $acw62 = parcelRequire("acw62");
function $950dfe08f13bfdcd$export$7941f8aafa4b6021(handlers) {
    const { onDragStart: onDragStart, onDragMove: onDragMove, onDragEnd: onDragEnd } = handlers;
    const sessionRef = (0, $acw62.useRef)();
    const handleMouseDown = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        sessionRef.current = {
            pageX: e.pageX,
            pageY: e.pageY
        };
        onDragStart?.();
    }, [
        onDragStart
    ]);
    const onDragRef = (0, $acw62.useRef)(onDragMove);
    (0, $acw62.useEffect)(()=>{
        onDragRef.current = onDragMove;
    }, [
        onDragMove
    ]);
    (0, $acw62.useEffect)(()=>{
        const handle = (e)=>{
            if (sessionRef.current === undefined) return;
            e.stopPropagation();
            onDragRef.current?.({
                deltaX: e.pageX - sessionRef.current.pageX,
                deltaY: e.pageY - sessionRef.current.pageY
            }, e);
        };
        window.addEventListener("mousemove", handle);
        return ()=>{
            window.removeEventListener("mousemove", handle);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const handle = (_e)=>{
            sessionRef.current = undefined;
            onDragEnd?.();
        };
        window.addEventListener("mouseup", handle);
        return ()=>{
            window.removeEventListener("mouseup", handle);
        };
    }, [
        onDragEnd
    ]);
    return handleMouseDown;
}


const $c924da69b4bd0d96$export$b815d23d228c87e0 = (props)=>{
    const { onDragMove: onDragMove } = props;
    const handleDragMove = (0, $acw62.useCallback)((offset, event)=>{
        onDragMove?.({
            deltaX: offset.deltaX / props.zoom,
            deltaY: offset.deltaY / props.zoom
        }, event);
    }, [
        onDragMove,
        props.zoom
    ]);
    const handleMouseDown = (0, $950dfe08f13bfdcd$export$7941f8aafa4b6021)({
        onDragStart: props.onDragStart,
        onDragMove: handleDragMove,
        onDragEnd: props.onDragEnd
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-orientation": props.orientation,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($690af920b5992a36$exports))).container,
        onMouseDown: handleMouseDown
    });
};




var $acw62 = parcelRequire("acw62");
var $15eadb630b0a5875$exports = {};

$parcel$export($15eadb630b0a5875$exports, "container", () => $15eadb630b0a5875$export$34e0f9847d4c02dd, (v) => $15eadb630b0a5875$export$34e0f9847d4c02dd = v);
var $15eadb630b0a5875$export$34e0f9847d4c02dd;
$15eadb630b0a5875$export$34e0f9847d4c02dd = `_7fW-ya_container`;



const $c55188dec9b3ce4d$export$d340defc6c4bb014 = (props)=>{
    const { onDragMove: onDragMove } = props;
    const handleDragMove = (0, $acw62.useCallback)((offset)=>{
        onDragMove?.({
            deltaX: 0,
            deltaY: offset.deltaY / props.zoom
        });
    }, [
        onDragMove,
        props.zoom
    ]);
    const handleMouseDown = (0, $950dfe08f13bfdcd$export$7941f8aafa4b6021)({
        onDragStart: props.onDragStart,
        onDragMove: handleDragMove,
        onDragEnd: props.onDragEnd
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($15eadb630b0a5875$exports))).container,
        onMouseDown: handleMouseDown
    });
};




var $acw62 = parcelRequire("acw62");
var $d111ee81fae1768b$exports = {};

$parcel$export($d111ee81fae1768b$exports, "container", () => $d111ee81fae1768b$export$34e0f9847d4c02dd, (v) => $d111ee81fae1768b$export$34e0f9847d4c02dd = v);
var $d111ee81fae1768b$export$34e0f9847d4c02dd;
$d111ee81fae1768b$export$34e0f9847d4c02dd = `yW6mTW_container`;



const $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7 = (props)=>{
    const { onDragMove: onDragMove } = props;
    const handleDragMove = (0, $acw62.useCallback)((offset)=>{
        onDragMove?.({
            deltaX: offset.deltaX / props.zoom,
            deltaY: 0
        });
    }, [
        onDragMove,
        props.zoom
    ]);
    const handleMouseDown = (0, $950dfe08f13bfdcd$export$7941f8aafa4b6021)({
        onDragStart: props.onDragStart,
        onDragMove: handleDragMove,
        onDragEnd: props.onDragEnd
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d111ee81fae1768b$exports))).container,
        onMouseDown: handleMouseDown
    });
};


const $6e93e394e2956c08$export$9510202bd83f2907 = (props)=>{
    const { onChange: onChange } = props;
    const draggingInkRef = (0, $acw62.useRef)();
    const handleDragStart = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = props.ink;
    }, [
        props.ink
    ]);
    const handleTopEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $80dcf17a2beee8f0$export$f93b3ee0f49492f6)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleRightEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $80dcf17a2beee8f0$export$fcdbee1caa981465)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleBottomEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $80dcf17a2beee8f0$export$9cf01ce061f2bbd7)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleLeftEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $80dcf17a2beee8f0$export$367ff58ac29d6775)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleTopLeftCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $80dcf17a2beee8f0$export$975e17ec41bb5e0c)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleTopRightCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $80dcf17a2beee8f0$export$9f38204495ba8bd8)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleBottomRightCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $80dcf17a2beee8f0$export$91ca2d2f98318195)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleBottomLeftCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $80dcf17a2beee8f0$export$4948a210352679f1)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleDragEnd = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = undefined;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).container,
        onDoubleClick: ()=>console.log("double click"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).horizontalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c55188dec9b3ce4d$export$d340defc6c4bb014), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).verticalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleRightEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).horizontalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c55188dec9b3ce4d$export$d340defc6c4bb014), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).verticalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleLeftEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");




const $c4047a94f6943a6f$export$924e1c9ec8e55262 = (props)=>{
    const { onChange: onChange } = props;
    const draggingInkRef = (0, $acw62.useRef)();
    const handleDragStart = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = props.ink;
    }, [
        props.ink
    ]);
    const handleTopEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $f5a06b5bcdfe432f$export$e8c13e484bd53c82)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleRightEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $f5a06b5bcdfe432f$export$a1b250cbf2e0a633)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleBottomEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $f5a06b5bcdfe432f$export$35759e8a112b8755)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleLeftEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $f5a06b5bcdfe432f$export$b5682991096303c)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleTopLeftCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $f5a06b5bcdfe432f$export$9d62931ffa1ccee)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleTopRightCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $f5a06b5bcdfe432f$export$74fe098fa9e05854)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleBottomRightCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $f5a06b5bcdfe432f$export$67722def53ce0035)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleBottomLeftCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $f5a06b5bcdfe432f$export$ab1792ea5b9e4ae2)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleDragEnd = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = undefined;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).container,
        onDoubleClick: ()=>console.log("double click"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).horizontalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c55188dec9b3ce4d$export$d340defc6c4bb014), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).verticalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleRightEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).horizontalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c55188dec9b3ce4d$export$d340defc6c4bb014), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).verticalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleLeftEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");




const $956847726ccbca89$export$b587666af69dcdea = (props)=>{
    const { onChange: onChange } = props;
    const draggingInkRef = (0, $acw62.useRef)();
    const handleDragStart = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = props.ink;
    }, [
        props.ink
    ]);
    const handleTopEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $8071ceaf67484368$export$dcafbeaa63c2ac27)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleRightEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $8071ceaf67484368$export$7cb5362de47d5d9f)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleBottomEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $8071ceaf67484368$export$7bc2ff4821620609)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleLeftEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $8071ceaf67484368$export$9d306a8e57f45060)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleTopLeftCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $8071ceaf67484368$export$38e8be81ef723df3)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleTopRightCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $8071ceaf67484368$export$bef44d630a61e521)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleBottomRightCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $8071ceaf67484368$export$97c4f6dd04bc4a69)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleBottomLeftCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $8071ceaf67484368$export$e7a74b46cf5cd44c)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleDragEnd = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = undefined;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).container,
        onDoubleClick: ()=>console.log("double click"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).horizontalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c55188dec9b3ce4d$export$d340defc6c4bb014), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).verticalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleRightEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).horizontalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c55188dec9b3ce4d$export$d340defc6c4bb014), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).verticalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleLeftEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");


const $a1e2576086bfcd82$export$7e15e59eff12d8d7 = (props)=>{
    const { onChange: onChange } = props;
    const draggingInkRef = (0, $acw62.useRef)();
    const handleDragStart = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = props.ink;
    }, [
        props.ink
    ]);
    const handleTopLeftCornerDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $ebf28d92b6229f56$export$87195ecc5d4af4bd)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleTopRightCornerDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $ebf28d92b6229f56$export$fe1c5a42c9d838ec)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleBottomRightCornerDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $ebf28d92b6229f56$export$5542862c5d63062d)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleBottomLeftCornerDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $ebf28d92b6229f56$export$f05fd951a2c6cb41)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleDragEnd = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = undefined;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).container,
        onDoubleClick: ()=>console.log("double click"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4cea5c4c900ca768$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
var $e049d244ba6aff7f$exports = {};

$parcel$export($e049d244ba6aff7f$exports, "container", () => $e049d244ba6aff7f$export$34e0f9847d4c02dd, (v) => $e049d244ba6aff7f$export$34e0f9847d4c02dd = v);
$parcel$export($e049d244ba6aff7f$exports, "pointHandle", () => $e049d244ba6aff7f$export$dafeed3d0263088e, (v) => $e049d244ba6aff7f$export$dafeed3d0263088e = v);
$parcel$export($e049d244ba6aff7f$exports, "pointHandleWrapper", () => $e049d244ba6aff7f$export$9f27ccb3fad5cbe9, (v) => $e049d244ba6aff7f$export$9f27ccb3fad5cbe9 = v);
var $e049d244ba6aff7f$export$34e0f9847d4c02dd;
var $e049d244ba6aff7f$export$dafeed3d0263088e;
var $e049d244ba6aff7f$export$9f27ccb3fad5cbe9;
$e049d244ba6aff7f$export$34e0f9847d4c02dd = `_1zzcOq_container`;
$e049d244ba6aff7f$export$dafeed3d0263088e = `_1zzcOq_pointHandle`;
$e049d244ba6aff7f$export$9f27ccb3fad5cbe9 = `_1zzcOq_pointHandleWrapper`;




const $5c37b7e2991a4682$export$b614e722fb6ae508 = (props)=>{
    const [editMode, setEditMode] = (0, $acw62.useState)(false);
    const boundingBox = (0, $acw62.useMemo)(()=>{
        return (0, $189e06d909ce30c1$export$e1942d4b7c93f2ed)((0, $b82449888acec1e3$export$2e4d925d07cbfdc)(props.ink));
    }, [
        props.ink,
        props.pan,
        props.zoom
    ]);
    const handleDoubleClick = (0, $acw62.useCallback)(()=>{
        setEditMode(true);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e049d244ba6aff7f$exports))).container,
        onDoubleClick: handleDoubleClick,
        children: editMode && props.ink.points.map((point, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: (point.y - boundingBox.y) * props.zoom,
                    left: (point.x - boundingBox.x) * props.zoom
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($e049d244ba6aff7f$exports))).pointHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5c37b7e2991a4682$var$PointHandle, {})
            }, i))
    });
};
const $5c37b7e2991a4682$var$PointHandle = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($e049d244ba6aff7f$exports))).pointHandle
    });
};




var $acw62 = parcelRequire("acw62");
var $3132c395f06462b3$exports = {};

$parcel$export($3132c395f06462b3$exports, "alignmentButton", () => $3132c395f06462b3$export$db277403d3c93192, (v) => $3132c395f06462b3$export$db277403d3c93192 = v);
$parcel$export($3132c395f06462b3$exports, "alignmentButtons", () => $3132c395f06462b3$export$71990b2da2dc46c8, (v) => $3132c395f06462b3$export$71990b2da2dc46c8 = v);
$parcel$export($3132c395f06462b3$exports, "button", () => $3132c395f06462b3$export$2ba01fb71ed41cb6, (v) => $3132c395f06462b3$export$2ba01fb71ed41cb6 = v);
$parcel$export($3132c395f06462b3$exports, "buttons", () => $3132c395f06462b3$export$bbea856fdb3e3c5f, (v) => $3132c395f06462b3$export$bbea856fdb3e3c5f = v);
$parcel$export($3132c395f06462b3$exports, "container", () => $3132c395f06462b3$export$34e0f9847d4c02dd, (v) => $3132c395f06462b3$export$34e0f9847d4c02dd = v);
$parcel$export($3132c395f06462b3$exports, "content", () => $3132c395f06462b3$export$a7db06668cad9adb, (v) => $3132c395f06462b3$export$a7db06668cad9adb = v);
$parcel$export($3132c395f06462b3$exports, "cornerHandleWrapper", () => $3132c395f06462b3$export$3ca1333f4688ee52, (v) => $3132c395f06462b3$export$3ca1333f4688ee52 = v);
$parcel$export($3132c395f06462b3$exports, "footer", () => $3132c395f06462b3$export$adb608be33961c98, (v) => $3132c395f06462b3$export$adb608be33961c98 = v);
$parcel$export($3132c395f06462b3$exports, "form", () => $3132c395f06462b3$export$6210fa4921d2a466, (v) => $3132c395f06462b3$export$6210fa4921d2a466 = v);
$parcel$export($3132c395f06462b3$exports, "newLineHint", () => $3132c395f06462b3$export$c3b1bc8d44df8d69, (v) => $3132c395f06462b3$export$c3b1bc8d44df8d69 = v);
$parcel$export($3132c395f06462b3$exports, "overlay", () => $3132c395f06462b3$export$29dd17c7f3c81c36, (v) => $3132c395f06462b3$export$29dd17c7f3c81c36 = v);
$parcel$export($3132c395f06462b3$exports, "shortcut", () => $3132c395f06462b3$export$ec0409edb5e28490, (v) => $3132c395f06462b3$export$ec0409edb5e28490 = v);
$parcel$export($3132c395f06462b3$exports, "textarea", () => $3132c395f06462b3$export$a3574df893ffa88d, (v) => $3132c395f06462b3$export$a3574df893ffa88d = v);
$parcel$export($3132c395f06462b3$exports, "textareaWrapper", () => $3132c395f06462b3$export$17cd36fd75b0cc4d, (v) => $3132c395f06462b3$export$17cd36fd75b0cc4d = v);
$parcel$export($3132c395f06462b3$exports, "verticalHandleWrapper", () => $3132c395f06462b3$export$819e44c8fe383d27, (v) => $3132c395f06462b3$export$819e44c8fe383d27 = v);
var $3132c395f06462b3$export$db277403d3c93192;
var $3132c395f06462b3$export$71990b2da2dc46c8;
var $3132c395f06462b3$export$2ba01fb71ed41cb6;
var $3132c395f06462b3$export$bbea856fdb3e3c5f;
var $3132c395f06462b3$export$34e0f9847d4c02dd;
var $3132c395f06462b3$export$a7db06668cad9adb;
var $3132c395f06462b3$export$3ca1333f4688ee52;
var $3132c395f06462b3$export$adb608be33961c98;
var $3132c395f06462b3$export$6210fa4921d2a466;
var $3132c395f06462b3$export$c3b1bc8d44df8d69;
var $3132c395f06462b3$export$29dd17c7f3c81c36;
var $3132c395f06462b3$export$ec0409edb5e28490;
var $3132c395f06462b3$export$a3574df893ffa88d;
var $3132c395f06462b3$export$17cd36fd75b0cc4d;
var $3132c395f06462b3$export$819e44c8fe383d27;
$3132c395f06462b3$export$db277403d3c93192 = `fDuRPq_alignmentButton`;
$3132c395f06462b3$export$71990b2da2dc46c8 = `fDuRPq_alignmentButtons`;
$3132c395f06462b3$export$2ba01fb71ed41cb6 = `fDuRPq_button`;
$3132c395f06462b3$export$bbea856fdb3e3c5f = `fDuRPq_buttons`;
$3132c395f06462b3$export$34e0f9847d4c02dd = `fDuRPq_container`;
$3132c395f06462b3$export$a7db06668cad9adb = `fDuRPq_content`;
$3132c395f06462b3$export$3ca1333f4688ee52 = `fDuRPq_cornerHandleWrapper`;
$3132c395f06462b3$export$adb608be33961c98 = `fDuRPq_footer`;
$3132c395f06462b3$export$6210fa4921d2a466 = `fDuRPq_form`;
$3132c395f06462b3$export$c3b1bc8d44df8d69 = `fDuRPq_newLineHint`;
$3132c395f06462b3$export$29dd17c7f3c81c36 = `fDuRPq_overlay`;
$3132c395f06462b3$export$ec0409edb5e28490 = `fDuRPq_shortcut`;
$3132c395f06462b3$export$a3574df893ffa88d = `fDuRPq_textarea`;
$3132c395f06462b3$export$17cd36fd75b0cc4d = `fDuRPq_textareaWrapper`;
$3132c395f06462b3$export$819e44c8fe383d27 = `fDuRPq_verticalHandleWrapper`;







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");














/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = 'Dialog';
const [$eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogProvider, $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$createDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $eeaeb48e23f662e7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = (0, $acw62.useRef)(null);
    const contentRef = (0, $acw62.useRef)(null);
    const [open = false, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        titleId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        descriptionId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $acw62.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$3ddf2d174ce01153, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = 'DialogTrigger';
const $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$2e1e1122cf0cba88, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = 'DialogPortal';
const [$eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PortalProvider, $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$createDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $eeaeb48e23f662e7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $acw62.Children).map(children, (child)=>/*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $acw62.createElement)((0, $95d053caea9c023a$export$602eac185826482c), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$dad7c95542bacce0, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = 'DialogOverlay';
const $eeaeb48e23f662e7$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$usePortalContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$bd1d06c79be19e17, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $acw62.createElement)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        as: (0, $cf381de56a25bc52$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-state": $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: 'auto',
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = 'DialogContent';
const $eeaeb48e23f662e7$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$usePortalContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$b6d9565de1e068cf, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $acw62.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $acw62.useRef)(false);
    const hasPointerDownOutsideRef = (0, $acw62.useRef)(false);
    return /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === 'pointerdown') hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === 'focusin' && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $30a399657994b369$export$177fb62ff3ec1f22), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = 'DialogTitle';
const $eeaeb48e23f662e7$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).h2, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$16f7638e4a34b909, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = 'DialogDescription';
const $eeaeb48e23f662e7$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).p, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$94e94c2ec2c954d5, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = 'DialogClose';
const $eeaeb48e23f662e7$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$fba2fb7cd781b7ac, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? 'open' : 'closed';
}
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = 'DialogTitleWarning';
const [$eeaeb48e23f662e7$export$69b62a49393917d6, $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $45e038b71f97d914$export$fd42f52fd3ae1109)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: 'dialog'
});
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useWarningContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $acw62.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = 'DialogDescriptionWarning';
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useWarningContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $acw62.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute('aria-describedby'); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $eeaeb48e23f662e7$export$be92b6f5f03c0fe9 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
const $eeaeb48e23f662e7$export$41fb9f06171c75f4 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
const $eeaeb48e23f662e7$export$602eac185826482c = $eeaeb48e23f662e7$export$dad7c95542bacce0;
const $eeaeb48e23f662e7$export$c6fdb837b070b4ff = $eeaeb48e23f662e7$export$bd1d06c79be19e17;
const $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = $eeaeb48e23f662e7$export$b6d9565de1e068cf;
const $eeaeb48e23f662e7$export$f99233281efd08a0 = $eeaeb48e23f662e7$export$16f7638e4a34b909;
const $eeaeb48e23f662e7$export$393edc798c47379d = $eeaeb48e23f662e7$export$94e94c2ec2c954d5;
const $eeaeb48e23f662e7$export$f39c2d165cd861fe = $eeaeb48e23f662e7$export$fba2fb7cd781b7ac;




var $acw62 = parcelRequire("acw62");
// packages/react/context/src/createContext.tsx

var $acw62 = parcelRequire("acw62");

function $1cbbc6fc29f3bee3$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $1cbbc6fc29f3bee3$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $1cbbc6fc29f3bee3$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $1cbbc6fc29f3bee3$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/primitive/src/Primitive.tsx

var $acw62 = parcelRequire("acw62");

// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $586a90439904f0d4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $586a90439904f0d4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$586a90439904f0d4$var$setRef(ref, node));
}
function $586a90439904f0d4$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($586a90439904f0d4$export$43e446d32b3d21af(...refs), refs);
}



var $ad3c229972c01475$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($ad3c229972c01475$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ad3c229972c01475$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ad3c229972c01475$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$ad3c229972c01475$export$8c6ed5c666ac1360.displayName = "Slot";
var $ad3c229972c01475$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $ad3c229972c01475$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$ad3c229972c01475$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $586a90439904f0d4$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$ad3c229972c01475$var$SlotClone.displayName = "SlotClone";
var $ad3c229972c01475$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $ad3c229972c01475$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $ad3c229972c01475$export$d9f1ccf0bdb05d45;
}
function $ad3c229972c01475$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $ad3c229972c01475$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $ad3c229972c01475$export$be92b6f5f03c0fe9 = $ad3c229972c01475$export$8c6ed5c666ac1360;



var $f6b2033918d2ad6b$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $f6b2033918d2ad6b$export$250ffa63cdc0d034 = $f6b2033918d2ad6b$var$NODES.reduce((primitive, node)=>{
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $ad3c229972c01475$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $f6b2033918d2ad6b$export$6d1a0317bde7de7f(target, event) {
    if (target) $11492dca620dcaa5$exports.flushSync(()=>target.dispatchEvent(event));
}
var $f6b2033918d2ad6b$export$be92b6f5f03c0fe9 = $f6b2033918d2ad6b$export$250ffa63cdc0d034;




var $acw62 = parcelRequire("acw62");
// packages/core/primitive/src/primitive.tsx
function $ac5005ff12e31a39$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $acw62 = parcelRequire("acw62");
function $56c76efbbdf61bc7$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $2ed7ffbff667d695$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $2ed7ffbff667d695$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $56c76efbbdf61bc7$export$25bec8c6f54ee79a)(onChange);
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $2ed7ffbff667d695$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $acw62.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $acw62.useRef(value);
    const handleChange = (0, $56c76efbbdf61bc7$export$25bec8c6f54ee79a)(onChange);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/primitive/src/Primitive.tsx

var $acw62 = parcelRequire("acw62");

// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $e5e6426e67094a07$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $e5e6426e67094a07$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$e5e6426e67094a07$var$setRef(ref, node));
}
function $e5e6426e67094a07$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($e5e6426e67094a07$export$43e446d32b3d21af(...refs), refs);
}



var $4dd9b2e4f59b71e5$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($4dd9b2e4f59b71e5$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4dd9b2e4f59b71e5$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4dd9b2e4f59b71e5$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$4dd9b2e4f59b71e5$export$8c6ed5c666ac1360.displayName = "Slot";
var $4dd9b2e4f59b71e5$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $4dd9b2e4f59b71e5$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$4dd9b2e4f59b71e5$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $e5e6426e67094a07$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$4dd9b2e4f59b71e5$var$SlotClone.displayName = "SlotClone";
var $4dd9b2e4f59b71e5$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $4dd9b2e4f59b71e5$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $4dd9b2e4f59b71e5$export$d9f1ccf0bdb05d45;
}
function $4dd9b2e4f59b71e5$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $4dd9b2e4f59b71e5$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $4dd9b2e4f59b71e5$export$be92b6f5f03c0fe9 = $4dd9b2e4f59b71e5$export$8c6ed5c666ac1360;



var $d7c103ab5acf82e5$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $d7c103ab5acf82e5$export$250ffa63cdc0d034 = $d7c103ab5acf82e5$var$NODES.reduce((primitive, node)=>{
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $4dd9b2e4f59b71e5$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $d7c103ab5acf82e5$export$6d1a0317bde7de7f(target, event) {
    if (target) $11492dca620dcaa5$exports.flushSync(()=>target.dispatchEvent(event));
}
var $d7c103ab5acf82e5$export$be92b6f5f03c0fe9 = $d7c103ab5acf82e5$export$250ffa63cdc0d034;



"use client";
var $62b265af90252982$var$NAME = "Toggle";
var $62b265af90252982$export$bea8ebba691c5813 = $acw62.forwardRef((props, forwardedRef)=>{
    const { pressed: pressedProp, defaultPressed: defaultPressed = false, onPressedChange: onPressedChange, ...buttonProps } = props;
    const [pressed = false, setPressed] = (0, $2ed7ffbff667d695$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d7c103ab5acf82e5$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0,
        ...buttonProps,
        ref: forwardedRef,
        onClick: (0, $ac5005ff12e31a39$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    });
});
$62b265af90252982$export$bea8ebba691c5813.displayName = $62b265af90252982$var$NAME;
var $62b265af90252982$export$be92b6f5f03c0fe9 = $62b265af90252982$export$bea8ebba691c5813;


// packages/react/use-controllable-state/src/useControllableState.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $acw62 = parcelRequire("acw62");
function $56054a838ba025dc$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $154248d0b97bde83$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $154248d0b97bde83$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $56054a838ba025dc$export$25bec8c6f54ee79a)(onChange);
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $154248d0b97bde83$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $acw62.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $acw62.useRef(value);
    const handleChange = (0, $56054a838ba025dc$export$25bec8c6f54ee79a)(onChange);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


// packages/react/direction/src/Direction.tsx

var $acw62 = parcelRequire("acw62");

var $407051ff54f536fc$var$DirectionContext = $acw62.createContext(void 0);
var $407051ff54f536fc$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($407051ff54f536fc$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $407051ff54f536fc$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($407051ff54f536fc$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $407051ff54f536fc$export$2881499e37b75b9a = $407051ff54f536fc$export$c760c09fdd558351;



"use client";
var $57c1675cf83b8426$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var [$57c1675cf83b8426$var$createToggleGroupContext, $57c1675cf83b8426$export$d1c7c4bcd9f26dd4] = (0, $1cbbc6fc29f3bee3$export$50c7b4e9d9f19c1)($57c1675cf83b8426$var$TOGGLE_GROUP_NAME, [
    (0, $0483c88073bf4923$export$c7109489551a4f4)
]);
var $57c1675cf83b8426$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
var $57c1675cf83b8426$export$af3ec21f6cfb5e30 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { type: type, ...toggleGroupProps } = props;
    if (type === "single") {
        const singleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImplSingle, {
            ...singleProps,
            ref: forwardedRef
        });
    }
    if (type === "multiple") {
        const multipleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImplMultiple, {
            ...multipleProps,
            ref: forwardedRef
        });
    }
    throw new Error(`Missing prop \`type\` expected on \`${$57c1675cf83b8426$var$TOGGLE_GROUP_NAME}\``);
});
$57c1675cf83b8426$export$af3ec21f6cfb5e30.displayName = $57c1675cf83b8426$var$TOGGLE_GROUP_NAME;
var [$57c1675cf83b8426$var$ToggleGroupValueProvider, $57c1675cf83b8426$var$useToggleGroupValueContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImplSingle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupSingleProps } = props;
    const [value, setValue] = (0, $154248d0b97bde83$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "single",
        value: value ? [
            value
        ] : [],
        onItemActivate: setValue,
        onItemDeactivate: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setValue(""), [
            setValue
        ]),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupSingleProps,
            ref: forwardedRef
        })
    });
});
var $57c1675cf83b8426$var$ToggleGroupImplMultiple = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupMultipleProps } = props;
    const [value = [], setValue] = (0, $154248d0b97bde83$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const handleButtonActivate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleButtonDeactivate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "multiple",
        value: value,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupMultipleProps,
            ref: forwardedRef
        })
    });
});
$57c1675cf83b8426$export$af3ec21f6cfb5e30.displayName = $57c1675cf83b8426$var$TOGGLE_GROUP_NAME;
var [$57c1675cf83b8426$var$ToggleGroupContext, $57c1675cf83b8426$var$useToggleGroupContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImpl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, disabled: disabled = false, rovingFocus: rovingFocus = true, orientation: orientation, dir: dir, loop: loop = true, ...toggleGroupProps } = props;
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0, $407051ff54f536fc$export$b39126d51d94e6f3)(dir);
    const commonProps = {
        role: "group",
        dir: direction,
        ...toggleGroupProps
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled,
        children: rovingFocus ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$be92b6f5f03c0fe9, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f6b2033918d2ad6b$export$250ffa63cdc0d034).div, {
                ...commonProps,
                ref: forwardedRef
            })
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f6b2033918d2ad6b$export$250ffa63cdc0d034).div, {
            ...commonProps,
            ref: forwardedRef
        })
    });
});
var $57c1675cf83b8426$var$ITEM_NAME = "ToggleGroupItem";
var $57c1675cf83b8426$export$b453109e13abe10b = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $57c1675cf83b8426$var$useToggleGroupContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = {
        ...props,
        pressed: pressed,
        disabled: disabled
    };
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: pressed,
        ref: ref,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
            ...commonProps,
            ref: forwardedRef
        })
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
        ...commonProps,
        ref: forwardedRef
    });
});
$57c1675cf83b8426$export$b453109e13abe10b.displayName = $57c1675cf83b8426$var$ITEM_NAME;
var $57c1675cf83b8426$var$ToggleGroupItemImpl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, value: value, ...itemProps } = props;
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: "radio",
        "aria-checked": props.pressed,
        "aria-pressed": void 0
    };
    const typeProps = valueContext.type === "single" ? singleProps : void 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $62b265af90252982$export$bea8ebba691c5813), {
        ...typeProps,
        ...itemProps,
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    });
});
var $57c1675cf83b8426$export$be92b6f5f03c0fe9 = $57c1675cf83b8426$export$af3ec21f6cfb5e30;
var $57c1675cf83b8426$export$6d08773d2e66f8f2 = $57c1675cf83b8426$export$b453109e13abe10b;



const $074c0f26e47c0442$export$43a2a6205c884160 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_463_9744",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                className: props.className,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_463_9744)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M3 18.6465V16.6465H15V18.6465H3ZM3 12.6465V10.6465H15V12.6465H3ZM3 6.64648V4.64648H21V6.64648H3Z",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};



const $deb3d3b05321a4a8$export$33adf9b7a9609a58 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_463_9745",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_463_9745)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M5 19V17H19V19H5ZM7 13V11H17V13H7ZM3 7V5H21V7H3Z",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};



const $2655057eeee457aa$export$589ba7400e24d687 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("mask", {
                id: "mask0_463_9746",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "24",
                height: "24",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    width: "24",
                    height: "24",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                mask: "url(#mask0_463_9746)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M3 7V5H21V7H3ZM9 13V11H21V13H9ZM9 19V17H21V19H9Z",
                    fill: "#A3A3A3"
                })
            })
        ]
    });
};


const $93376667685a0b26$var$textMap = {
    "press %s to insert a new line.": {
        en: "Press %s to insert a new line.",
        ja: "%s \u3067\u6539\u884C\u3092\u633F\u5165\u3067\u304D\u307E\u3059\u3002"
    },
    "type here...": {
        en: "Type here...",
        ja: "\u3053\u3053\u306B\u5165\u529B..."
    },
    ok: {
        en: "OK",
        ja: "OK"
    },
    cancel: {
        en: "Cancel",
        ja: "\u30AD\u30E3\u30F3\u30BB\u30EB"
    }
};
const $93376667685a0b26$export$f285e9b1c2b91a5b = (props)=>{
    const { onSubmit: onSubmit, onCancel: onCancel } = props;
    const texts = (0, $c17f85d6c45c40da$export$2ecf1baeef3275cf)($93376667685a0b26$var$textMap);
    const [text, setText] = (0, $acw62.useState)(props.initialValue.text);
    const [align, setAlign] = (0, $acw62.useState)(props.initialValue.align);
    const submit = (0, $acw62.useCallback)(()=>{
        onSubmit({
            ...props.initialValue,
            text: text,
            align: align
        });
    }, [
        onSubmit,
        props.initialValue,
        text,
        align
    ]);
    const handleOpenChange = (0, $acw62.useCallback)((open)=>{
        if (!open) onCancel();
    }, [
        onCancel
    ]);
    const handleMouseDown = (0, $acw62.useCallback)((e)=>{
        // ダイアログ内のマウスイベントで ItemEditor が移動しないように伝播を止める
        e.stopPropagation();
    }, []);
    const handleWheel = (0, $acw62.useCallback)((e)=>{
        // ダイアログ内のホイールイベントでビューポートが操作されないように伝播を止める
        // ItemEditor を Viewport の外側に出すとアイテム上でも Viewport の操作ができなくなるのでそれはできない
        e.stopPropagation();
    }, []);
    const handleEditTextChange = (0, $acw62.useCallback)((e)=>{
        setText(e.target.value);
    }, []);
    const handleKeyDown = (0, $acw62.useCallback)((e)=>{
        // ダイアログ内でグローバルなショートカットが効かないように伝播を止める
        e.stopPropagation();
        if (!e.nativeEvent.isComposing) {
            if (e.key === "Escape") onCancel();
            if (e.key === "Enter" && !e.shiftKey) submit();
        }
    }, [
        onCancel,
        submit
    ]);
    const handleAlignValueChange = (0, $acw62.useCallback)((value)=>{
        if (value === "left" || value === "center" || value === "right") setAlign(value);
    }, []);
    const handleSubmit = (0, $acw62.useCallback)((e)=>{
        e.preventDefault();
        submit();
    }, [
        submit
    ]);
    const handleCancelClick = (0, $acw62.useCallback)(()=>{
        onCancel();
    }, [
        onCancel
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
        open: true,
        onOpenChange: handleOpenChange,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($eeaeb48e23f662e7$export$602eac185826482c, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$c6fdb837b070b4ff, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).overlay
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).content,
                    onMouseDown: handleMouseDown,
                    onWheel: handleWheel,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).form,
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).textareaWrapper,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).newLineHint,
                                        children: (0, $c17f85d6c45c40da$export$95672295c50ede1f)(texts["press %s to insert a new line."], /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).shortcut,
                                            children: "\u21E7\u21A9"
                                        }))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        value: text,
                                        placeholder: texts["type here..."],
                                        style: {
                                            textAlign: align
                                        },
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).textarea,
                                        onChange: handleEditTextChange,
                                        onKeyDown: handleKeyDown
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).footer,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($57c1675cf83b8426$export$be92b6f5f03c0fe9, {
                                        type: "single",
                                        value: align,
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).alignmentButtons,
                                        onValueChange: handleAlignValueChange,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$export$6d08773d2e66f8f2, {
                                                value: "left",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).alignmentButton,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $074c0f26e47c0442$export$43a2a6205c884160), {})
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$export$6d08773d2e66f8f2, {
                                                value: "center",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).alignmentButton,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $deb3d3b05321a4a8$export$33adf9b7a9609a58), {})
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$export$6d08773d2e66f8f2, {
                                                value: "right",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).alignmentButton,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2655057eeee457aa$export$589ba7400e24d687), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).buttons,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).button,
                                                onClick: handleCancelClick,
                                                children: texts.cancel
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).button,
                                                type: "submit",
                                                children: texts.ok
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};


const $02aac7e67ee8e24c$export$1fd955a821d28353 = (props)=>{
    const { onChange: onChange, onCancelCreate: onCancelCreate } = props;
    const ref = (0, $acw62.useRef)(null);
    const draggingInkRef = (0, $acw62.useRef)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const handleKeyDown = (0, $acw62.useCallback)((e)=>{
        if (e.key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
            setOpen(true);
        }
    }, []);
    const handleDoubleClick = (0, $acw62.useCallback)(()=>{
        setOpen(true);
    }, [
        props.ink.text
    ]);
    const handleVerticalEdgeDoubleClick = (0, $acw62.useCallback)((e)=>{
        e.stopPropagation();
        onChange({
            ...props.ink,
            width: undefined
        });
    }, [
        onChange,
        props.ink
    ]);
    const handleDragStart = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = props.ink;
    }, [
        props.ink
    ]);
    const handleRightEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $c555d3b6b65c69d0$export$f585374aef3acb00)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleLeftEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $c555d3b6b65c69d0$export$d201aaa29f1979b5)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleDragEnd = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = undefined;
    }, []);
    const handleSubmit = (0, $acw62.useCallback)((ink)=>{
        if (ink.text === "") {
            if (props.ink.text === "") // 最初から空文字だった場合はただの削除ではなく作成キャンセルの扱いにする。
            // 作成キャンセルによる削除は history に記録されない。
            onCancelCreate();
            else onChange(undefined);
        } else onChange(ink);
        setOpen(false);
        setTimeout(()=>{
            // Radix Dialog が閉じるときのフォーカスマネジメントと競合する？timeout しないとフォーカスできない
            ref.current?.focus();
        }, 0);
    }, [
        onChange
    ]);
    const handleCancel = (0, $acw62.useCallback)(()=>{
        if (props.ink.text === "") onCancelCreate();
        setOpen(false);
        setTimeout(()=>{
            // Radix Dialog が閉じるときのフォーカスマネジメントと競合する？timeout しないとフォーカスできない
            ref.current?.focus();
        }, 0);
    }, [
        props.ink.text
    ]);
    (0, $acw62.useEffect)(()=>{
        ref.current?.focus();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        tabIndex: -1,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).container,
        onKeyDown: handleKeyDown,
        onDoubleClick: handleDoubleClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).verticalHandleWrapper,
                onDoubleClick: handleVerticalEdgeDoubleClick,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleRightEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).verticalHandleWrapper,
                onDoubleClick: handleVerticalEdgeDoubleClick,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleLeftEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleLeftEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleRightEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleRightEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($3132c395f06462b3$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleLeftEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93376667685a0b26$export$f285e9b1c2b91a5b), {
                initialValue: props.ink,
                onSubmit: handleSubmit,
                onCancel: handleCancel
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
var $04820143f9bf142e$exports = {};

$parcel$export($04820143f9bf142e$exports, "container", () => $04820143f9bf142e$export$34e0f9847d4c02dd, (v) => $04820143f9bf142e$export$34e0f9847d4c02dd = v);
$parcel$export($04820143f9bf142e$exports, "pointHandle", () => $04820143f9bf142e$export$dafeed3d0263088e, (v) => $04820143f9bf142e$export$dafeed3d0263088e = v);
var $04820143f9bf142e$export$34e0f9847d4c02dd;
var $04820143f9bf142e$export$dafeed3d0263088e;
$04820143f9bf142e$export$34e0f9847d4c02dd = `YrjMgq_container`;
$04820143f9bf142e$export$dafeed3d0263088e = `YrjMgq_pointHandle`;





const $de547e5243a2993c$export$3263410389e7149a = (props)=>{
    const { onChange: onChange } = props;
    const draggingInkRef = (0, $acw62.useRef)();
    const boundingBox = (0, $acw62.useMemo)(()=>{
        return (0, $b2b9a792bd78c26f$export$9fe85f8270a5de02)(props.ink);
    }, [
        props.ink,
        props.pan,
        props.zoom
    ]);
    const handleDragStart = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = props.ink;
    }, [
        props.ink
    ]);
    const handleDragEnd = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = undefined;
    }, []);
    const handleFromDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b2b9a792bd78c26f$export$f84bfdd9ff03c447)(draggingInkRef.current, (0, $0a2b0b5969e29723$export$dbd442ab0564e9dc)(offset, props.zoom)));
    }, [
        onChange,
        props.zoom
    ]);
    const handleToDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b2b9a792bd78c26f$export$d711ae35cab56ac9)(draggingInkRef.current, (0, $0a2b0b5969e29723$export$dbd442ab0564e9dc)(offset, props.zoom)));
    }, [
        onChange,
        props.zoom
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($04820143f9bf142e$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($de547e5243a2993c$var$PointHandle, {
                top: (props.ink.from.y - boundingBox.y) * props.zoom,
                left: (props.ink.from.x - boundingBox.x) * props.zoom,
                onDragStart: handleDragStart,
                onDragMove: handleFromDragMove,
                onDragEnd: handleDragEnd
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($de547e5243a2993c$var$PointHandle, {
                top: (props.ink.to.y - boundingBox.y) * props.zoom,
                left: (props.ink.to.x - boundingBox.x) * props.zoom,
                onDragStart: handleDragStart,
                onDragMove: handleToDragMove,
                onDragEnd: handleDragEnd
            })
        ]
    });
};
const $de547e5243a2993c$var$PointHandle = (props)=>{
    const { onDragMove: onDragMove } = props;
    const handleDragMove = (0, $acw62.useCallback)((offset, event)=>{
        onDragMove?.({
            viewportDeltaX: offset.deltaX,
            viewportDeltaY: offset.deltaY
        }, event);
    }, [
        onDragMove
    ]);
    const handleMouseDown = (0, $950dfe08f13bfdcd$export$7941f8aafa4b6021)({
        onDragStart: props.onDragStart,
        onDragMove: handleDragMove,
        onDragEnd: props.onDragEnd
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            top: props.top,
            right: props.right,
            bottom: props.bottom,
            left: props.left
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($04820143f9bf142e$exports))).pointHandle,
        onMouseDown: handleMouseDown
    });
};




var $acw62 = parcelRequire("acw62");
var $6ad7724672bcd9fc$exports = {};

$parcel$export($6ad7724672bcd9fc$exports, "container", () => $6ad7724672bcd9fc$export$34e0f9847d4c02dd, (v) => $6ad7724672bcd9fc$export$34e0f9847d4c02dd = v);
$parcel$export($6ad7724672bcd9fc$exports, "cornerHandleWrapper", () => $6ad7724672bcd9fc$export$3ca1333f4688ee52, (v) => $6ad7724672bcd9fc$export$3ca1333f4688ee52 = v);
$parcel$export($6ad7724672bcd9fc$exports, "horizontalHandleWrapper", () => $6ad7724672bcd9fc$export$b2789a14a78b1c8e, (v) => $6ad7724672bcd9fc$export$b2789a14a78b1c8e = v);
$parcel$export($6ad7724672bcd9fc$exports, "verticalHandleWrapper", () => $6ad7724672bcd9fc$export$819e44c8fe383d27, (v) => $6ad7724672bcd9fc$export$819e44c8fe383d27 = v);
var $6ad7724672bcd9fc$export$34e0f9847d4c02dd;
var $6ad7724672bcd9fc$export$3ca1333f4688ee52;
var $6ad7724672bcd9fc$export$b2789a14a78b1c8e;
var $6ad7724672bcd9fc$export$819e44c8fe383d27;
$6ad7724672bcd9fc$export$34e0f9847d4c02dd = `jUG6aG_container`;
$6ad7724672bcd9fc$export$3ca1333f4688ee52 = `jUG6aG_cornerHandleWrapper`;
$6ad7724672bcd9fc$export$b2789a14a78b1c8e = `jUG6aG_horizontalHandleWrapper`;
$6ad7724672bcd9fc$export$819e44c8fe383d27 = `jUG6aG_verticalHandleWrapper`;






const $66536c030d6b8e78$export$54b867d72a48f9a2 = (props)=>{
    const { onChange: onChange } = props;
    const draggingInkRef = (0, $acw62.useRef)();
    const handleDragStart = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = props.ink;
    }, [
        props.ink
    ]);
    const handleTopEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b22dcebef2fd1cbb$export$b74ebbce02349990)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleRightEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b22dcebef2fd1cbb$export$2fd327c6682504fb)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleBottomEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b22dcebef2fd1cbb$export$744f1c78affeae80)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleLeftEdgeDragMove = (0, $acw62.useCallback)((offset)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b22dcebef2fd1cbb$export$4493d1b52d442dc2)(draggingInkRef.current, offset));
    }, [
        onChange
    ]);
    const handleTopLeftCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b22dcebef2fd1cbb$export$eb4f7537c9825084)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleTopRightCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b22dcebef2fd1cbb$export$f1a7cad759b4da4d)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleBottomRightCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b22dcebef2fd1cbb$export$a952def1cabdb7da)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleBottomLeftCornerDragMove = (0, $acw62.useCallback)((offset, event)=>{
        if (draggingInkRef.current === undefined) return;
        onChange((0, $b22dcebef2fd1cbb$export$5221f3fb0c6f5f19)(draggingInkRef.current, offset, event.shiftKey));
    }, [
        onChange
    ]);
    const handleDragEnd = (0, $acw62.useCallback)(()=>{
        draggingInkRef.current = undefined;
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).container,
        onDoubleClick: ()=>console.log("double click"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).horizontalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c55188dec9b3ce4d$export$d340defc6c4bb014), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).verticalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleRightEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).horizontalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c55188dec9b3ce4d$export$d340defc6c4bb014), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).verticalHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $800dcc2e42c93cb8$export$4dc9ba7b77fddaf7), {
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleLeftEdgeDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: 0,
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleTopRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: "100%"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nwse",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomRightCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    top: "100%",
                    left: 0
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ad7724672bcd9fc$exports))).cornerHandleWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c924da69b4bd0d96$export$b815d23d228c87e0), {
                    orientation: "nesw",
                    zoom: props.zoom,
                    onDragStart: handleDragStart,
                    onDragMove: handleBottomLeftCornerDragMove,
                    onDragEnd: handleDragEnd
                })
            })
        ]
    });
};


const $461411394c0d7da4$export$c41fcbd13639d87a = (props)=>{
    if (props.ink.type === "rect") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e93e394e2956c08$export$9510202bd83f2907), {
        ...props,
        ink: props.ink
    });
    if (props.ink.type === "image") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1e2576086bfcd82$export$7e15e59eff12d8d7), {
        ...props,
        ink: props.ink
    });
    if (props.ink.type === "blur") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4047a94f6943a6f$export$924e1c9ec8e55262), {
        ...props,
        ink: props.ink
    });
    if (props.ink.type === "pixelate") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $956847726ccbca89$export$b587666af69dcdea), {
        ...props,
        ink: props.ink
    });
    if (props.ink.type === "text") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02aac7e67ee8e24c$export$1fd955a821d28353), {
        ...props,
        ink: props.ink
    });
    if (props.ink.type === "pen") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5c37b7e2991a4682$export$b614e722fb6ae508), {
        ...props,
        ink: props.ink
    });
    if (props.ink.type === "arrow") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de547e5243a2993c$export$3263410389e7149a), {
        ...props,
        ink: props.ink
    });
    if (props.ink.type === "number") return null;
    if (props.ink.type === "redact") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66536c030d6b8e78$export$54b867d72a48f9a2), {
        ...props,
        ink: props.ink
    });
    (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(props.ink);
};







var $acw62 = parcelRequire("acw62");
// packages/core/primitive/src/primitive.tsx
function $ed5c5b4a876e8fb6$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/context/src/createContext.tsx

var $acw62 = parcelRequire("acw62");

function $69ba537d7bffc3be$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $69ba537d7bffc3be$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $69ba537d7bffc3be$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $69ba537d7bffc3be$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/primitive/src/Primitive.tsx

var $acw62 = parcelRequire("acw62");

// packages/react/slot/src/Slot.tsx

var $acw62 = parcelRequire("acw62");
// packages/react/compose-refs/src/composeRefs.tsx

var $acw62 = parcelRequire("acw62");
function $bd306cc4c7802abe$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $bd306cc4c7802abe$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$bd306cc4c7802abe$var$setRef(ref, node));
}
function $bd306cc4c7802abe$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($bd306cc4c7802abe$export$43e446d32b3d21af(...refs), refs);
}



var $05455314a4305b9d$export$8c6ed5c666ac1360 = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $acw62.Children.toArray(children);
    const slottable = childrenArray.find($05455314a4305b9d$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($acw62.Children.count(newElement) > 1) return $acw62.Children.only(null);
                return $acw62.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($05455314a4305b9d$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $acw62.isValidElement(newElement) ? $acw62.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($05455314a4305b9d$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$05455314a4305b9d$export$8c6ed5c666ac1360.displayName = "Slot";
var $05455314a4305b9d$var$SlotClone = $acw62.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($acw62.isValidElement(children)) {
        const childrenRef = $05455314a4305b9d$var$getElementRef(children);
        return $acw62.cloneElement(children, {
            ...$05455314a4305b9d$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $bd306cc4c7802abe$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $acw62.Children.count(children) > 1 ? $acw62.Children.only(null) : null;
});
$05455314a4305b9d$var$SlotClone.displayName = "SlotClone";
var $05455314a4305b9d$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
function $05455314a4305b9d$var$isSlottable(child) {
    return $acw62.isValidElement(child) && child.type === $05455314a4305b9d$export$d9f1ccf0bdb05d45;
}
function $05455314a4305b9d$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $05455314a4305b9d$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $05455314a4305b9d$export$be92b6f5f03c0fe9 = $05455314a4305b9d$export$8c6ed5c666ac1360;



var $d008d9e50e9b27ca$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $d008d9e50e9b27ca$export$250ffa63cdc0d034 = $d008d9e50e9b27ca$var$NODES.reduce((primitive, node)=>{
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $05455314a4305b9d$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $d008d9e50e9b27ca$export$6d1a0317bde7de7f(target, event) {
    if (target) $11492dca620dcaa5$exports.flushSync(()=>target.dispatchEvent(event));
}
var $d008d9e50e9b27ca$export$be92b6f5f03c0fe9 = $d008d9e50e9b27ca$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $acw62 = parcelRequire("acw62");
function $625acb7811da010b$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $acw62 = parcelRequire("acw62");

function $ed56f8d156b0c087$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $ed56f8d156b0c087$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $625acb7811da010b$export$25bec8c6f54ee79a)(onChange);
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $ed56f8d156b0c087$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $acw62.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $acw62.useRef(value);
    const handleChange = (0, $625acb7811da010b$export$25bec8c6f54ee79a)(onChange);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



"use client";
var $ad7b718bbfb8a2d3$var$CONTEXT_MENU_NAME = "ContextMenu";
var [$ad7b718bbfb8a2d3$var$createContextMenuContext, $ad7b718bbfb8a2d3$export$1059331f43ddcc82] = (0, $69ba537d7bffc3be$export$50c7b4e9d9f19c1)($ad7b718bbfb8a2d3$var$CONTEXT_MENU_NAME, [
    (0, $82110f2367303f9b$export$4027731b685e72eb)
]);
var $ad7b718bbfb8a2d3$var$useMenuScope = (0, $82110f2367303f9b$export$4027731b685e72eb)();
var [$ad7b718bbfb8a2d3$var$ContextMenuProvider, $ad7b718bbfb8a2d3$var$useContextMenuContext] = $ad7b718bbfb8a2d3$var$createContextMenuContext($ad7b718bbfb8a2d3$var$CONTEXT_MENU_NAME);
var $ad7b718bbfb8a2d3$export$8dc6765e8be191c7 = (props)=>{
    const { __scopeContextMenu: __scopeContextMenu, children: children, onOpenChange: onOpenChange, dir: dir, modal: modal = true } = props;
    const [open, setOpen] = $acw62.useState(false);
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    const handleOpenChangeProp = (0, $625acb7811da010b$export$25bec8c6f54ee79a)(onOpenChange);
    const handleOpenChange = $acw62.useCallback((open2)=>{
        setOpen(open2);
        handleOpenChangeProp(open2);
    }, [
        handleOpenChangeProp
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ad7b718bbfb8a2d3$var$ContextMenuProvider, {
        scope: __scopeContextMenu,
        open: open,
        onOpenChange: handleOpenChange,
        modal: modal,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$be92b6f5f03c0fe9, {
            ...menuScope,
            dir: dir,
            open: open,
            onOpenChange: handleOpenChange,
            modal: modal,
            children: children
        })
    });
};
$ad7b718bbfb8a2d3$export$8dc6765e8be191c7.displayName = $ad7b718bbfb8a2d3$var$CONTEXT_MENU_NAME;
var $ad7b718bbfb8a2d3$var$TRIGGER_NAME = "ContextMenuTrigger";
var $ad7b718bbfb8a2d3$export$be6fc7b1d5b0beb9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $ad7b718bbfb8a2d3$var$useContextMenuContext($ad7b718bbfb8a2d3$var$TRIGGER_NAME, __scopeContextMenu);
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    const pointRef = $acw62.useRef({
        x: 0,
        y: 0
    });
    const virtualRef = $acw62.useRef({
        getBoundingClientRect: ()=>DOMRect.fromRect({
                width: 0,
                height: 0,
                ...pointRef.current
            })
    });
    const longPressTimerRef = $acw62.useRef(0);
    const clearLongPress = $acw62.useCallback(()=>window.clearTimeout(longPressTimerRef.current), []);
    const handleOpen = (event)=>{
        pointRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        context.onOpenChange(true);
    };
    $acw62.useEffect(()=>clearLongPress, [
        clearLongPress
    ]);
    $acw62.useEffect(()=>void (disabled && clearLongPress()), [
        disabled,
        clearLongPress
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$b688253958b8dfe7, {
                ...menuScope,
                virtualRef: virtualRef
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d008d9e50e9b27ca$export$250ffa63cdc0d034).span, {
                "data-state": context.open ? "open" : "closed",
                "data-disabled": disabled ? "" : void 0,
                ...triggerProps,
                ref: forwardedRef,
                style: {
                    WebkitTouchCallout: "none",
                    ...props.style
                },
                onContextMenu: disabled ? props.onContextMenu : (0, $ed5c5b4a876e8fb6$export$b9ecd428b558ff10)(props.onContextMenu, (event)=>{
                    clearLongPress();
                    handleOpen(event);
                    event.preventDefault();
                }),
                onPointerDown: disabled ? props.onPointerDown : (0, $ed5c5b4a876e8fb6$export$b9ecd428b558ff10)(props.onPointerDown, $ad7b718bbfb8a2d3$var$whenTouchOrPen((event)=>{
                    clearLongPress();
                    longPressTimerRef.current = window.setTimeout(()=>handleOpen(event), 700);
                })),
                onPointerMove: disabled ? props.onPointerMove : (0, $ed5c5b4a876e8fb6$export$b9ecd428b558ff10)(props.onPointerMove, $ad7b718bbfb8a2d3$var$whenTouchOrPen(clearLongPress)),
                onPointerCancel: disabled ? props.onPointerCancel : (0, $ed5c5b4a876e8fb6$export$b9ecd428b558ff10)(props.onPointerCancel, $ad7b718bbfb8a2d3$var$whenTouchOrPen(clearLongPress)),
                onPointerUp: disabled ? props.onPointerUp : (0, $ed5c5b4a876e8fb6$export$b9ecd428b558ff10)(props.onPointerUp, $ad7b718bbfb8a2d3$var$whenTouchOrPen(clearLongPress))
            })
        ]
    });
});
$ad7b718bbfb8a2d3$export$be6fc7b1d5b0beb9.displayName = $ad7b718bbfb8a2d3$var$TRIGGER_NAME;
var $ad7b718bbfb8a2d3$var$PORTAL_NAME = "ContextMenuPortal";
var $ad7b718bbfb8a2d3$export$14afd0be83e45060 = (props)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...portalProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$602eac185826482c, {
        ...menuScope,
        ...portalProps
    });
};
$ad7b718bbfb8a2d3$export$14afd0be83e45060.displayName = $ad7b718bbfb8a2d3$var$PORTAL_NAME;
var $ad7b718bbfb8a2d3$var$CONTENT_NAME = "ContextMenuContent";
var $ad7b718bbfb8a2d3$export$572205900c9369e = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...contentProps } = props;
    const context = $ad7b718bbfb8a2d3$var$useContextMenuContext($ad7b718bbfb8a2d3$var$CONTENT_NAME, __scopeContextMenu);
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$7c6e2c02157bb7d2, {
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        side: "right",
        sideOffset: 2,
        align: "start",
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented && hasInteractedOutsideRef.current) event.preventDefault();
            hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented && !context.modal) hasInteractedOutsideRef.current = true;
        },
        style: {
            ...props.style,
            "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$ad7b718bbfb8a2d3$export$572205900c9369e.displayName = $ad7b718bbfb8a2d3$var$CONTENT_NAME;
var $ad7b718bbfb8a2d3$var$GROUP_NAME = "ContextMenuGroup";
var $ad7b718bbfb8a2d3$export$9860523b0fcdd664 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...groupProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$eb2fcfdbd7ba97d4, {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$9860523b0fcdd664.displayName = $ad7b718bbfb8a2d3$var$GROUP_NAME;
var $ad7b718bbfb8a2d3$var$LABEL_NAME = "ContextMenuLabel";
var $ad7b718bbfb8a2d3$export$d4b9d3b609a10742 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...labelProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$b04be29aa201d4f5, {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$d4b9d3b609a10742.displayName = $ad7b718bbfb8a2d3$var$LABEL_NAME;
var $ad7b718bbfb8a2d3$var$ITEM_NAME = "ContextMenuItem";
var $ad7b718bbfb8a2d3$export$16a26dc176a49100 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...itemProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$6d08773d2e66f8f2, {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$16a26dc176a49100.displayName = $ad7b718bbfb8a2d3$var$ITEM_NAME;
var $ad7b718bbfb8a2d3$var$CHECKBOX_ITEM_NAME = "ContextMenuCheckboxItem";
var $ad7b718bbfb8a2d3$export$b6adbe51d5d8b7ec = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...checkboxItemProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$16ce288f89fa631c, {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$b6adbe51d5d8b7ec.displayName = $ad7b718bbfb8a2d3$var$CHECKBOX_ITEM_NAME;
var $ad7b718bbfb8a2d3$var$RADIO_GROUP_NAME = "ContextMenuRadioGroup";
var $ad7b718bbfb8a2d3$export$db5c89af5ed9aa07 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...radioGroupProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$a98f0dcb43a68a25, {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$db5c89af5ed9aa07.displayName = $ad7b718bbfb8a2d3$var$RADIO_GROUP_NAME;
var $ad7b718bbfb8a2d3$var$RADIO_ITEM_NAME = "ContextMenuRadioItem";
var $ad7b718bbfb8a2d3$export$8a727d09a7d9bfc2 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...radioItemProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$371ab307eab489c0, {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$8a727d09a7d9bfc2.displayName = $ad7b718bbfb8a2d3$var$RADIO_ITEM_NAME;
var $ad7b718bbfb8a2d3$var$INDICATOR_NAME = "ContextMenuItemIndicator";
var $ad7b718bbfb8a2d3$export$9ed8194dee42d94b = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...itemIndicatorProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$c3468e2714d175fa, {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$9ed8194dee42d94b.displayName = $ad7b718bbfb8a2d3$var$INDICATOR_NAME;
var $ad7b718bbfb8a2d3$var$SEPARATOR_NAME = "ContextMenuSeparator";
var $ad7b718bbfb8a2d3$export$8d6b009fadfe1207 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...separatorProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$1ff3c3f08ae963c0, {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$8d6b009fadfe1207.displayName = $ad7b718bbfb8a2d3$var$SEPARATOR_NAME;
var $ad7b718bbfb8a2d3$var$ARROW_NAME = "ContextMenuArrow";
var $ad7b718bbfb8a2d3$export$f47d0a58228a61e2 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...arrowProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$21b07c8f274aebd5, {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$f47d0a58228a61e2.displayName = $ad7b718bbfb8a2d3$var$ARROW_NAME;
var $ad7b718bbfb8a2d3$var$SUB_NAME = "ContextMenuSub";
var $ad7b718bbfb8a2d3$export$5bc21d1c00c4b201 = (props)=>{
    const { __scopeContextMenu: __scopeContextMenu, children: children, onOpenChange: onOpenChange, open: openProp, defaultOpen: defaultOpen } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    const [open, setOpen] = (0, $ed56f8d156b0c087$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$d7a01e11500dfb6f, {
        ...menuScope,
        open: open,
        onOpenChange: setOpen,
        children: children
    });
};
$ad7b718bbfb8a2d3$export$5bc21d1c00c4b201.displayName = $ad7b718bbfb8a2d3$var$SUB_NAME;
var $ad7b718bbfb8a2d3$var$SUB_TRIGGER_NAME = "ContextMenuSubTrigger";
var $ad7b718bbfb8a2d3$export$30b2b5c64556d316 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...triggerItemProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$2ea8a7a591ac5eac, {
        ...menuScope,
        ...triggerItemProps,
        ref: forwardedRef
    });
});
$ad7b718bbfb8a2d3$export$30b2b5c64556d316.displayName = $ad7b718bbfb8a2d3$var$SUB_TRIGGER_NAME;
var $ad7b718bbfb8a2d3$var$SUB_CONTENT_NAME = "ContextMenuSubContent";
var $ad7b718bbfb8a2d3$export$2c967063bd2dc512 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...subContentProps } = props;
    const menuScope = $ad7b718bbfb8a2d3$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($82110f2367303f9b$export$6d4de93b380beddf, {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$ad7b718bbfb8a2d3$export$2c967063bd2dc512.displayName = $ad7b718bbfb8a2d3$var$SUB_CONTENT_NAME;
function $ad7b718bbfb8a2d3$var$whenTouchOrPen(handler) {
    return (event)=>event.pointerType !== "mouse" ? handler(event) : void 0;
}
var $ad7b718bbfb8a2d3$export$be92b6f5f03c0fe9 = $ad7b718bbfb8a2d3$export$8dc6765e8be191c7;
var $ad7b718bbfb8a2d3$export$41fb9f06171c75f4 = $ad7b718bbfb8a2d3$export$be6fc7b1d5b0beb9;
var $ad7b718bbfb8a2d3$export$602eac185826482c = $ad7b718bbfb8a2d3$export$14afd0be83e45060;
var $ad7b718bbfb8a2d3$export$7c6e2c02157bb7d2 = $ad7b718bbfb8a2d3$export$572205900c9369e;
var $ad7b718bbfb8a2d3$export$eb2fcfdbd7ba97d4 = $ad7b718bbfb8a2d3$export$9860523b0fcdd664;
var $ad7b718bbfb8a2d3$export$b04be29aa201d4f5 = $ad7b718bbfb8a2d3$export$d4b9d3b609a10742;
var $ad7b718bbfb8a2d3$export$6d08773d2e66f8f2 = $ad7b718bbfb8a2d3$export$16a26dc176a49100;
var $ad7b718bbfb8a2d3$export$16ce288f89fa631c = $ad7b718bbfb8a2d3$export$b6adbe51d5d8b7ec;
var $ad7b718bbfb8a2d3$export$a98f0dcb43a68a25 = $ad7b718bbfb8a2d3$export$db5c89af5ed9aa07;
var $ad7b718bbfb8a2d3$export$371ab307eab489c0 = $ad7b718bbfb8a2d3$export$8a727d09a7d9bfc2;
var $ad7b718bbfb8a2d3$export$c3468e2714d175fa = $ad7b718bbfb8a2d3$export$9ed8194dee42d94b;
var $ad7b718bbfb8a2d3$export$1ff3c3f08ae963c0 = $ad7b718bbfb8a2d3$export$8d6b009fadfe1207;
var $ad7b718bbfb8a2d3$export$21b07c8f274aebd5 = $ad7b718bbfb8a2d3$export$f47d0a58228a61e2;
var $ad7b718bbfb8a2d3$export$d7a01e11500dfb6f = $ad7b718bbfb8a2d3$export$5bc21d1c00c4b201;
var $ad7b718bbfb8a2d3$export$2ea8a7a591ac5eac = $ad7b718bbfb8a2d3$export$30b2b5c64556d316;
var $ad7b718bbfb8a2d3$export$6d4de93b380beddf = $ad7b718bbfb8a2d3$export$2c967063bd2dc512;



const $29d5457f3e83bcbc$var$textMap = {
    delete: {
        en: "Delete",
        ja: "\u524A\u9664"
    },
    "bring to front": {
        en: "Bring to front",
        ja: "\u6700\u524D\u9762\u306B\u79FB\u52D5"
    },
    "bring forward": {
        en: "Bring forward",
        ja: "\u524D\u9762\u306B\u79FB\u52D5"
    },
    "send backward": {
        en: "Send backward",
        ja: "\u80CC\u9762\u306B\u79FB\u52D5"
    },
    "send to back": {
        en: "Send to back",
        ja: "\u6700\u80CC\u9762\u306B\u79FB\u52D5"
    }
};
const $29d5457f3e83bcbc$export$be4c2397a30fb5ee = (props)=>{
    const texts = (0, $c17f85d6c45c40da$export$2ecf1baeef3275cf)($29d5457f3e83bcbc$var$textMap);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad7b718bbfb8a2d3$export$be92b6f5f03c0fe9, {
        onOpenChange: props.onOpenChange,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad7b718bbfb8a2d3$export$41fb9f06171c75f4, {
                asChild: true,
                children: props.children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad7b718bbfb8a2d3$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad7b718bbfb8a2d3$export$7c6e2c02157bb7d2, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).content,
                    onKeyDown: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad7b718bbfb8a2d3$export$6d08773d2e66f8f2, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                            onClick: ()=>props.onMenuItemSelect("delete"),
                            children: [
                                texts["delete"],
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                    children: "\u232B"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad7b718bbfb8a2d3$export$1ff3c3f08ae963c0, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).separator
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad7b718bbfb8a2d3$export$6d08773d2e66f8f2, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                            onClick: ()=>props.onMenuItemSelect("bring_to_front"),
                            children: [
                                texts["bring to front"],
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                    children: "]"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad7b718bbfb8a2d3$export$6d08773d2e66f8f2, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                            onClick: ()=>props.onMenuItemSelect("bring_forward"),
                            children: [
                                texts["bring forward"],
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                    children: "\u2318 ]"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad7b718bbfb8a2d3$export$6d08773d2e66f8f2, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                            onClick: ()=>props.onMenuItemSelect("send_backward"),
                            children: [
                                texts["send backward"],
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                    children: "\u2318 ["
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad7b718bbfb8a2d3$export$6d08773d2e66f8f2, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).item,
                            onClick: ()=>props.onMenuItemSelect("send_to_back"),
                            children: [
                                texts["send to back"],
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($70ca71161747feb3$exports))).shortcut,
                                    children: "["
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


const $564121fb632508d5$export$c1521c9298bce699 = (props)=>{
    const { onClick: onClick, onDrag: onDrag, onChange: onChange, onDelete: onDelete } = props;
    const dragSessionRef = (0, $acw62.useRef)();
    const viewportBox = (0, $acw62.useMemo)(()=>{
        const boundingBox = (0, $189e06d909ce30c1$export$e1942d4b7c93f2ed)((0, $1345f3e3159b23e9$export$4bb6209356900d5e)(props.item.ink));
        return (0, $189e06d909ce30c1$export$979103305a6a55a0)(boundingBox, props.pan, props.zoom);
    }, [
        props.item.ink,
        props.pan,
        props.zoom
    ]);
    const handleMouseDown = (0, $acw62.useCallback)((e)=>{
        if (e.button !== 0) return;
        e.stopPropagation();
        dragSessionRef.current = {
            pageX: e.pageX,
            pageY: e.pageY,
            moved: false
        };
    }, []);
    const onDragRef = (0, $acw62.useRef)(onDrag);
    (0, $acw62.useLayoutEffect)(()=>{
        onDragRef.current = onDrag;
    }, [
        onDrag
    ]);
    (0, $acw62.useEffect)(()=>{
        const handler = (e)=>{
            const dragPos = dragSessionRef.current;
            if (dragPos === undefined) return;
            e.stopPropagation();
            onDragRef.current?.({
                deltaX: (e.pageX - dragPos.pageX) / props.zoom,
                deltaY: (e.pageY - dragPos.pageY) / props.zoom
            }, e.shiftKey);
            dragSessionRef.current = {
                pageX: e.pageX,
                pageY: e.pageY,
                moved: true
            };
        };
        document.addEventListener("mousemove", handler);
        return ()=>{
            document.removeEventListener("mousemove", handler);
        };
    }, [
        props.zoom
    ]);
    (0, $acw62.useEffect)(()=>{
        const handler = (e)=>{
            const dragSession = dragSessionRef.current;
            if (dragSession === undefined) return;
            e.stopPropagation();
            dragSessionRef.current = undefined;
            if (!dragSession.moved) onClick(e.shiftKey);
        };
        document.addEventListener("mouseup", handler);
        return ()=>{
            document.removeEventListener("mouseup", handler);
        };
    }, [
        onClick
    ]);
    const handleInkChange = (0, $acw62.useCallback)((ink)=>{
        if (ink === undefined) onDelete();
        else onChange({
            ...props.item,
            ink: ink
        });
    }, [
        props.item,
        onChange,
        onDelete
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29d5457f3e83bcbc$export$be4c2397a30fb5ee), {
        onOpenChange: props.onContextMenuOpenChange,
        onMenuItemSelect: props.onContextMenuItemSelect,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "data-active": props.isActive,
            style: {
                top: viewportBox.viewportY,
                left: viewportBox.viewportX,
                width: viewportBox.viewportWidth,
                height: viewportBox.viewportHeight
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($650a7633ee6aa1ee$exports))).container,
            onMouseDown: handleMouseDown,
            children: props.isActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $461411394c0d7da4$export$c41fcbd13639d87a), {
                ink: props.item.ink,
                pan: props.pan,
                zoom: props.zoom,
                onChange: handleInkChange,
                onCancelCreate: props.onCancelCreate
            })
        })
    });
};





const $3d74bff2846008b2$var$textMap = {
    "reset zoom to 100%": {
        en: "Reset zoom to 100%",
        ja: "\u30BA\u30FC\u30E0\u3092 100% \u306B\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F"
    },
    "pasted from clipboard": {
        en: "Pasted from clipboard",
        ja: "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u304B\u3089\u8CBC\u308A\u4ED8\u3051\u307E\u3057\u305F"
    },
    "copied to clipboard": {
        en: "Copied to clipboard",
        ja: "\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F"
    },
    "file exported": {
        en: "File exported",
        ja: "\u30D5\u30A1\u30A4\u30EB\u306B\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u3057\u307E\u3057\u305F"
    }
};
function $3d74bff2846008b2$var$reducer(state, action) {
    if (action.type === "pan") return {
        ...state,
        pan: (0, $0a2b0b5969e29723$export$82e05f0987eca85a)(state.pan, action.offset)
    };
    if (action.type === "zoom") {
        const pos = (0, $490a55307ea505bd$export$49a851a6b4d84ded)((0, $490a55307ea505bd$export$a6663a2df30dcc74)(action.origin, state.pan, state.zoom), (0, $0a2b0b5969e29723$export$a59aa03203e9f00c)(state.pan));
        const newScale = $3d74bff2846008b2$var$minmax(0.02, 256, state.zoom * action.factor);
        const ratio = newScale / state.zoom;
        return {
            ...state,
            zoom: newScale,
            pan: {
                deltaX: state.pan.deltaX + (pos.x - pos.x / ratio),
                deltaY: state.pan.deltaY + (pos.y - pos.y / ratio)
            }
        };
    }
    if (action.type === "reset_zoom") {
        const pos = (0, $490a55307ea505bd$export$49a851a6b4d84ded)((0, $490a55307ea505bd$export$a6663a2df30dcc74)(action.origin, state.pan, state.zoom), (0, $0a2b0b5969e29723$export$a59aa03203e9f00c)(state.pan));
        const newScale = 1;
        const ratio = newScale / state.zoom;
        return {
            ...state,
            zoom: 1,
            pan: {
                deltaX: state.pan.deltaX + (pos.x - pos.x / ratio),
                deltaY: state.pan.deltaY + (pos.y - pos.y / ratio)
            }
        };
    }
    if (action.type === "set_zoom") {
        const pos = (0, $490a55307ea505bd$export$49a851a6b4d84ded)((0, $490a55307ea505bd$export$a6663a2df30dcc74)(action.origin, state.pan, state.zoom), (0, $0a2b0b5969e29723$export$a59aa03203e9f00c)(state.pan));
        const newScale = $3d74bff2846008b2$var$minmax(0.02, 256, action.zoom);
        const ratio = newScale / state.zoom;
        return {
            ...state,
            zoom: newScale,
            pan: {
                deltaX: state.pan.deltaX + (pos.x - pos.x / ratio),
                deltaY: state.pan.deltaY + (pos.y - pos.y / ratio)
            }
        };
    }
    if (action.type === "reset_viewport") return {
        ...state,
        pan: {
            deltaX: 0,
            deltaY: 0
        },
        zoom: 1
    };
    if (action.type === "add_image_item") {
        const center = (0, $490a55307ea505bd$export$a6663a2df30dcc74)(action.pos, state.pan, state.zoom);
        const ink = (0, $ebf28d92b6229f56$export$ca4a7157dbffaf01)((0, $ebf28d92b6229f56$export$d2ff61685afcdd8d)(center, action.png));
        const item = {
            id: crypto.randomUUID(),
            ink: ink
        };
        if (state.mainItem === undefined) return {
            ...state,
            mainItem: item
        };
        else return {
            ...state,
            items: [
                ...state.items,
                item
            ],
            activeItemIds: [
                item.id
            ],
            history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
                items: state.items
            })
        };
    }
    if (action.type === "move_items") return {
        ...state,
        items: state.items.map((item)=>state.activeItemIds.includes(item.id) ? {
                ...item,
                ink: (0, $1345f3e3159b23e9$export$191039ca16d612e5)(item.ink, action.offset)
            } : item),
        history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
            items: state.items
        })
    };
    if (action.type === "draw") {
        const pos = (0, $490a55307ea505bd$export$a6663a2df30dcc74)(action.pos, state.pan, state.zoom);
        if (state.draftItem === undefined) {
            if (state.tool === undefined) return state;
            return {
                ...state,
                draftItem: {
                    id: crypto.randomUUID(),
                    ink: (0, $1345f3e3159b23e9$export$f0e3f80f78769eaf)(state.tool, state.style, pos)
                }
            };
        }
        return {
            ...state,
            draftItem: {
                ...state.draftItem,
                ink: (0, $1345f3e3159b23e9$export$9cf47addb252f0c3)(state.draftItem.ink, pos)
            }
        };
    }
    if (action.type === "finish_draw") {
        if (state.draftItem === undefined) return state;
        if (state.draftItem.ink.type === "text") return {
            ...state,
            draftItem: undefined,
            draftTextItem: {
                ...state.draftItem,
                ink: state.draftItem.ink
            }
        };
        const ink = (0, $1345f3e3159b23e9$export$d82b1c8b01edf336)(state.draftItem.ink);
        if (ink === undefined) return {
            ...state,
            tool: undefined,
            draftItem: undefined,
            activeItemIds: []
        };
        return {
            ...state,
            tool: state.tool === "pen" ? state.tool : undefined,
            draftItem: undefined,
            items: [
                ...state.items,
                {
                    ...state.draftItem,
                    ink: ink
                }
            ],
            activeItemIds: [
                state.draftItem.id
            ],
            history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
                items: state.items
            })
        };
    }
    if (action.type === "finish_draw_text_ink") {
        if (state.draftTextItem === undefined) return state;
        const ink = action.ink === undefined ? undefined : (0, $c555d3b6b65c69d0$export$1a1628e41e592a64)(action.ink);
        if (ink === undefined) return {
            ...state,
            tool: undefined,
            draftTextItem: undefined
        };
        return {
            ...state,
            tool: undefined,
            items: [
                ...state.items,
                {
                    ...state.draftTextItem,
                    ink: ink
                }
            ],
            draftTextItem: undefined,
            activeItemIds: [
                state.draftTextItem.id
            ],
            history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
                items: state.items
            })
        };
    }
    if (action.type === "update_item") return {
        ...state,
        items: state.items.map((it)=>it.id === action.item.id ? action.item : it),
        history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
            items: state.items
        })
    };
    if (action.type === "select_item") {
        const item = state.items.find((it)=>it.id === action.itemId);
        return {
            ...state,
            activeItemIds: action.multiple ? [
                ...state.activeItemIds,
                action.itemId
            ] : [
                action.itemId
            ],
            // 選択したアイテムのスタイルを現在のスタイルにする
            style: item !== undefined ? {
                ...state.style,
                ...$3d74bff2846008b2$var$extractStyle(item.ink)
            } : state.style
        };
    }
    if (action.type === "select_all_items") return {
        ...state,
        activeItemIds: state.items.map((item)=>item.id)
    };
    if (action.type === "select_item_if_not") {
        const item = state.items.find((it)=>it.id === action.itemId);
        return {
            ...state,
            activeItemIds: state.activeItemIds.includes(action.itemId) ? state.activeItemIds : action.multiple ? [
                ...state.activeItemIds,
                action.itemId
            ] : [
                action.itemId
            ],
            // 選択したアイテムのスタイルを現在のスタイルにする
            style: item !== undefined ? {
                ...state.style,
                ...$3d74bff2846008b2$var$extractStyle(item.ink)
            } : state.style
        };
    }
    if (action.type === "select_area") {
        const box = (0, $189e06d909ce30c1$export$9b14637080ce9a85)(action.area, state.pan, state.zoom);
        const touchingItemIds = state.items.filter((item)=>{
            const boundingBox = (0, $189e06d909ce30c1$export$e1942d4b7c93f2ed)((0, $1345f3e3159b23e9$export$4bb6209356900d5e)(item.ink));
            return (0, $189e06d909ce30c1$export$c961dc362da894e1)(boundingBox, box);
        }).map((it)=>it.id);
        const firstItem = state.items.find((it)=>it.id === touchingItemIds[0]);
        return {
            ...state,
            activeItemIds: action.multiple ? [
                ...state.activeItemIds,
                ...touchingItemIds
            ] : touchingItemIds,
            // 選択したアイテムのスタイルを現在のスタイルにする
            style: firstItem !== undefined ? {
                ...state.style,
                ...$3d74bff2846008b2$var$extractStyle(firstItem.ink)
            } : state.style
        };
    }
    if (action.type === "delete_item") return {
        ...state,
        items: state.items.filter((it)=>it.id !== action.itemId),
        history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
            items: state.items
        })
    };
    if (action.type === "delete_items") return {
        ...state,
        items: state.items.filter((item)=>!state.activeItemIds.includes(item.id)),
        history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
            items: state.items
        })
    };
    if (action.type === "cancel_create_item") return {
        ...state,
        items: state.items.filter((it)=>it.id !== action.itemId)
    };
    if (action.type === "bring_to_front") return {
        ...state,
        items: $3d74bff2846008b2$var$bringForward(state.items, state.activeItemIds, true),
        history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
            items: state.items
        })
    };
    if (action.type === "bring_forward") return {
        ...state,
        items: $3d74bff2846008b2$var$bringForward(state.items, state.activeItemIds, false),
        history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
            items: state.items
        })
    };
    if (action.type === "send_backward") return {
        ...state,
        items: $3d74bff2846008b2$var$sendBackward(state.items, state.activeItemIds, false),
        history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
            items: state.items
        })
    };
    if (action.type === "send_to_back") return {
        ...state,
        items: $3d74bff2846008b2$var$sendBackward(state.items, state.activeItemIds, true),
        history: $3d74bff2846008b2$var$addHistoryStep(state.history, {
            items: state.items
        })
    };
    if (action.type === "change_color") {
        let modified = false;
        const newItems = [];
        for (const item of state.items)if (state.activeItemIds.includes(item.id)) {
            newItems.push({
                ...item,
                ink: (0, $1345f3e3159b23e9$export$52239b0468db5694)(item.ink, action.color)
            });
            modified = true;
        } else newItems.push(item);
        return {
            ...state,
            style: {
                ...state.style,
                color: action.color
            },
            items: modified ? newItems : state.items,
            history: modified ? $3d74bff2846008b2$var$addHistoryStep(state.history, {
                items: state.items
            }) : state.history
        };
    }
    if (action.type === "change_size") {
        let modified = false;
        const newItems = [];
        for (const item of state.items)if (state.activeItemIds.includes(item.id)) {
            newItems.push({
                ...item,
                ink: (0, $1345f3e3159b23e9$export$216a43761424912e)(item.ink, action.size)
            });
            modified = true;
        } else newItems.push(item);
        return {
            ...state,
            style: {
                ...state.style,
                size: action.size
            },
            items: modified ? newItems : state.items,
            history: modified ? $3d74bff2846008b2$var$addHistoryStep(state.history, {
                items: state.items
            }) : state.history
        };
    }
    if (action.type === "set_tool") return {
        ...state,
        tool: action.tool
    };
    if (action.type === "escape") return {
        ...state,
        tool: undefined,
        activeItemIds: []
    };
    if (action.type === "undo") {
        const past = [
            ...state.history.past
        ];
        const last = past.pop();
        if (last === undefined) return state;
        console.log("undo:", last.state);
        return {
            ...state,
            ...last.state,
            history: {
                past: past,
                future: [
                    ...state.history.future,
                    {
                        ts: Date.now(),
                        state: {
                            items: state.items
                        }
                    }
                ]
            }
        };
    }
    if (action.type === "redo") {
        const future = [
            ...state.history.future
        ];
        const recent = future.pop();
        if (recent === undefined) return state;
        console.log("redo:", recent.state);
        return {
            ...state,
            ...recent.state,
            history: {
                past: [
                    ...state.history.past,
                    {
                        ts: Date.now(),
                        state: {
                            items: state.items
                        }
                    }
                ],
                future: future
            }
        };
    }
    (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(action);
}
function $3d74bff2846008b2$var$addHistoryStep(history, state) {
    const step = {
        ts: Date.now(),
        state: state
    };
    if (history.past.length === 0) {
        console.log("history added:", step);
        return {
            past: [
                step
            ],
            future: []
        };
    }
    const last = history.past[history.past.length - 1];
    if (step.ts - last.ts <= 100) return {
        past: [
            ...history.past.slice(0, -1),
            {
                ts: step.ts,
                state: last.state
            }
        ],
        future: []
    };
    console.log("history added:", step);
    return {
        past: [
            ...history.past,
            step
        ],
        future: []
    };
}
function $3d74bff2846008b2$var$extractStyle(ink) {
    if (ink.kind === "drawing") return ink.style;
    if (ink.kind === "filter") return {
        size: ink.size
    };
    if (ink.kind === "image") return {};
    (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(ink);
}
function $3d74bff2846008b2$var$minmax(min, max, x) {
    return Math.max(min, Math.min(max, x));
}
const $3d74bff2846008b2$export$86fbec116b87613f = ()=>{
    const texts = (0, $c17f85d6c45c40da$export$2ecf1baeef3275cf)($3d74bff2846008b2$var$textMap);
    const canvasRef = (0, $acw62.useRef)(null);
    const pixiCanvasRef = (0, $acw62.useRef)(null);
    const { show: show } = (0, $83c3827d0c2b2403$export$f46171b59bb094f9)();
    const [cursorPos, setCursorPos] = (0, $acw62.useState)({
        x: 0,
        y: 0
    });
    const [state, dispatch] = (0, $acw62.useReducer)($3d74bff2846008b2$var$reducer, {
        pan: {
            deltaX: 0,
            deltaY: 0
        },
        zoom: 1,
        tool: undefined,
        style: {
            color: "red",
            size: "m"
        },
        mainItem: undefined,
        items: [],
        draftItem: undefined,
        draftTextItem: undefined,
        activeItemIds: [],
        history: {
            past: [],
            future: []
        }
    });
    const allItems = (0, $acw62.useMemo)(()=>{
        return $3d74bff2846008b2$var$concatItems(state.mainItem, ...state.items, state.draftItem);
    }, [
        state.mainItem,
        state.items,
        state.draftItem
    ]);
    const addImageItem = (0, $acw62.useCallback)(async (png)=>{
        const rect = canvasRef.current?.getBoundingClientRect();
        if (rect === undefined) return;
        const center = {
            viewportX: rect.width / 2,
            viewportY: rect.height / 2
        };
        dispatch({
            type: "add_image_item",
            pos: center,
            png: png
        });
    }, []);
    const exportToClipboard = (0, $acw62.useCallback)(async ()=>{
        if (pixiCanvasRef.current === null) return;
        const item = new ClipboardItem({
            "image/png": await pixiCanvasRef.current.exportPng()
        });
        await navigator.clipboard.write([
            item
        ]);
        show(texts["copied to clipboard"]);
    }, [
        show,
        texts
    ]);
    const exportToFile = (0, $acw62.useCallback)(async ()=>{
        if (pixiCanvasRef.current === null) return;
        const png = await pixiCanvasRef.current.exportPng();
        const url = URL.createObjectURL(png);
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = "download";
        a.click();
        URL.revokeObjectURL(url);
        show(texts["file exported"]);
    }, [
        show,
        texts
    ]);
    const zoomIn = (0, $acw62.useCallback)(()=>{
        const rect = canvasRef.current?.getBoundingClientRect();
        if (rect === undefined) return;
        const origin = {
            viewportX: rect.width / 2,
            viewportY: rect.height / 2
        };
        dispatch({
            type: "zoom",
            origin: origin,
            factor: 1.25
        });
    }, []);
    const zoomOut = (0, $acw62.useCallback)(()=>{
        const rect = canvasRef.current?.getBoundingClientRect();
        if (rect === undefined) return;
        const origin = {
            viewportX: rect.width / 2,
            viewportY: rect.height / 2
        };
        dispatch({
            type: "zoom",
            origin: origin,
            factor: 0.8
        });
    }, []);
    const zoomTo100 = (0, $acw62.useCallback)(()=>{
        const rect = canvasRef.current?.getBoundingClientRect();
        if (rect === undefined) return;
        const origin = {
            viewportX: rect.width / 2,
            viewportY: rect.height / 2
        };
        dispatch({
            type: "reset_zoom",
            origin: origin
        });
        show(texts["reset zoom to 100%"]);
    }, [
        show,
        texts
    ]);
    const moveUp = (0, $acw62.useCallback)((shift)=>{
        dispatch({
            type: "move_items",
            offset: {
                deltaX: 0,
                deltaY: shift ? -10 : -1
            }
        });
    }, []);
    const moveRight = (0, $acw62.useCallback)((shift)=>{
        dispatch({
            type: "move_items",
            offset: {
                deltaX: shift ? 10 : 1,
                deltaY: 0
            }
        });
    }, []);
    const moveBottom = (0, $acw62.useCallback)((shift)=>{
        dispatch({
            type: "move_items",
            offset: {
                deltaX: 0,
                deltaY: shift ? 10 : 1
            }
        });
    }, []);
    const moveLeft = (0, $acw62.useCallback)((shift)=>{
        dispatch({
            type: "move_items",
            offset: {
                deltaX: shift ? -10 : -1,
                deltaY: 0
            }
        });
    }, []);
    const handleItemChange = (0, $acw62.useCallback)((item)=>{
        dispatch({
            type: "update_item",
            item: item
        });
    }, []);
    const handleItemDelete = (0, $acw62.useCallback)((itemId)=>{
        dispatch({
            type: "delete_item",
            itemId: itemId
        });
    }, []);
    const handleItemCancelCreate = (0, $acw62.useCallback)((itemId)=>{
        dispatch({
            type: "cancel_create_item",
            itemId: itemId
        });
    }, []);
    const handleItemDrag = (0, $acw62.useCallback)((itemId, offset, multiple)=>{
        dispatch({
            type: "select_item_if_not",
            itemId: itemId,
            multiple: multiple
        });
        dispatch({
            type: "move_items",
            offset: offset
        });
    }, []);
    const handleDraw = (0, $acw62.useCallback)((pos)=>{
        dispatch({
            type: "draw",
            pos: pos
        });
    }, []);
    const handleDrawEnd = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: "finish_draw"
        });
    }, []);
    const handleSelectArea = (0, $acw62.useCallback)((area, multiple)=>{
        dispatch({
            type: "select_area",
            area: area,
            multiple: multiple
        });
    }, []);
    const handleItemClick = (0, $acw62.useCallback)((itemId, shift)=>{
        dispatch({
            type: "select_item",
            itemId: itemId,
            multiple: shift
        });
    }, []);
    const handleItemContextMenuOpenChange = (0, $acw62.useCallback)((itemId, open)=>{
        if (open) dispatch({
            type: "select_item_if_not",
            itemId: itemId,
            multiple: false
        });
    }, []);
    const handleItemContextMenuItemSelect = (0, $acw62.useCallback)((menuItem)=>{
        switch(menuItem){
            case "delete":
                dispatch({
                    type: "delete_items"
                });
                break;
            case "bring_to_front":
                dispatch({
                    type: "bring_to_front"
                });
                break;
            case "bring_forward":
                dispatch({
                    type: "bring_forward"
                });
                break;
            case "send_backward":
                dispatch({
                    type: "send_backward"
                });
                break;
            case "send_to_back":
                dispatch({
                    type: "send_to_back"
                });
                break;
            default:
                (0, $c68e5267cadbcc45$export$cbadc5a7223772a8)(menuItem);
        }
    }, []);
    const handleDraftTextInkSubmit = (0, $acw62.useCallback)((ink)=>{
        dispatch({
            type: "finish_draw_text_ink",
            ink: ink
        });
    }, []);
    const handleDraftTextInkCancel = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: "finish_draw_text_ink",
            ink: undefined
        });
    }, []);
    const handlePan = (0, $acw62.useCallback)((offset)=>{
        dispatch({
            type: "pan",
            offset: offset
        });
    }, []);
    const handleZoom = (0, $acw62.useCallback)((origin, factor)=>{
        dispatch({
            type: "zoom",
            origin: origin,
            factor: factor
        });
    }, []);
    const handleMouseMove = (0, $acw62.useCallback)((e)=>{
        requestAnimationFrame(()=>{
            setCursorPos({
                x: e.nativeEvent.offsetX,
                y: e.nativeEvent.offsetY
            });
        });
    }, []);
    const handleColorChange = (0, $acw62.useCallback)((color)=>{
        dispatch({
            type: "change_color",
            color: color
        });
    }, []);
    const handleSizeChange = (0, $acw62.useCallback)((size)=>{
        dispatch({
            type: "change_size",
            size: size
        });
    }, []);
    const handleWelcomeImageSelect = (0, $acw62.useCallback)(async (e)=>{
        const file = e.target.files?.[0];
        if (file !== undefined) {
            const png = await (0, $2ad0921b83387183$export$ddb2291e6e5fa9a7)(file);
            if (png !== undefined) await addImageItem(png);
        }
        if (state.mainItem === undefined) await (0, $dbfd69960405e39c$export$73d0a139caca1fee)({
            name: "start",
            by: "select"
        });
    }, [
        addImageItem,
        state.mainItem
    ]);
    const handleUndoClick = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: "undo"
        });
    }, []);
    const handleRedoClick = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: "redo"
        });
    }, []);
    const handleMenuBarMenuItemSelect = (0, $acw62.useCallback)(async (item)=>{
        switch(item){
            case "export_to_clipboard":
                await exportToClipboard();
                await (0, $dbfd69960405e39c$export$73d0a139caca1fee)({
                    name: "export",
                    to: "clipboard",
                    via: "menu"
                });
                break;
            case "export_to_file":
                await exportToFile();
                await (0, $dbfd69960405e39c$export$73d0a139caca1fee)({
                    name: "export",
                    to: "file",
                    via: "menu"
                });
                break;
            case "zoom_in":
                zoomIn();
                break;
            case "zoom_out":
                zoomOut();
                break;
            case "zoom_to_100":
                zoomTo100();
                break;
            case "select_all":
                dispatch({
                    type: "select_all_items"
                });
                break;
        }
    }, [
        exportToClipboard,
        exportToFile,
        zoomIn,
        zoomOut,
        zoomTo100
    ]);
    (0, $acw62.useEffect)(()=>{
        if (state.mainItem === undefined) return;
        const handler = async (e)=>{
            if (e.key === "r") dispatch({
                type: "set_tool",
                tool: "rect"
            });
            if (e.key === "t") dispatch({
                type: "set_tool",
                tool: "text"
            });
            if (e.key === "p" || e.key === "P") dispatch({
                type: "set_tool",
                tool: "pen"
            });
            if (e.key === "a" && !e.metaKey || e.key === "L") dispatch({
                type: "set_tool",
                tool: "arrow"
            });
            if (e.key === "n") dispatch({
                type: "set_tool",
                tool: "number"
            });
            if (e.key === "b") dispatch({
                type: "set_tool",
                tool: "blur"
            });
            if (e.key === "x") dispatch({
                type: "set_tool",
                tool: "pixelate"
            });
            if (e.key === "d") dispatch({
                type: "set_tool",
                tool: "redact"
            });
            if (e.key === "Escape") dispatch({
                type: "escape"
            });
            if (e.key === "Backspace" || e.key === "Delete") {
                e.stopPropagation();
                dispatch({
                    type: "delete_items"
                });
            }
            if (e.metaKey && e.key === "a") {
                e.preventDefault();
                dispatch({
                    type: "select_all_items"
                });
            }
            if (e.key === "[") {
                e.preventDefault();
                if (e.metaKey) dispatch({
                    type: "send_backward"
                });
                else dispatch({
                    type: "send_to_back"
                });
            }
            if (e.key === "]") {
                e.preventDefault();
                if (e.metaKey) dispatch({
                    type: "bring_forward"
                });
                else dispatch({
                    type: "bring_to_front"
                });
            }
            if (e.metaKey && (e.key === ";" || e.key === "+")) {
                e.preventDefault();
                zoomIn();
            }
            if (e.metaKey && e.key === "-") {
                e.preventDefault();
                zoomOut();
            }
            if (e.metaKey && e.key === "0") zoomTo100();
            if (e.key === "ArrowUp") moveUp(e.shiftKey);
            if (e.key === "ArrowRight") moveRight(e.shiftKey);
            if (e.key === "ArrowDown") moveBottom(e.shiftKey);
            if (e.key === "ArrowLeft") moveLeft(e.shiftKey);
            if (e.metaKey && e.key === "z") {
                if (e.shiftKey) dispatch({
                    type: "redo"
                });
                else dispatch({
                    type: "undo"
                });
            }
            if (e.metaKey && e.shiftKey && e.key === "c") {
                e.preventDefault();
                await exportToClipboard();
                await (0, $dbfd69960405e39c$export$73d0a139caca1fee)({
                    name: "export",
                    to: "clipboard",
                    via: "shortcut"
                });
            }
        };
        document.addEventListener("keydown", handler);
        return ()=>{
            document.removeEventListener("keydown", handler);
        };
    }, [
        state.mainItem,
        state.activeItemIds,
        exportToClipboard,
        zoomIn,
        zoomOut,
        zoomTo100,
        moveUp,
        moveRight,
        moveBottom,
        moveLeft
    ]);
    (0, $acw62.useEffect)(()=>{
        const handler = async (e)=>{
            console.log("paste", e);
            const file = e.clipboardData?.files[0];
            if (file !== null && file !== undefined) {
                const png = await (0, $2ad0921b83387183$export$ddb2291e6e5fa9a7)(file);
                if (png !== undefined) {
                    await addImageItem(png);
                    show(texts["pasted from clipboard"]);
                    if (state.mainItem === undefined) await (0, $dbfd69960405e39c$export$73d0a139caca1fee)({
                        name: "start",
                        by: "paste"
                    });
                }
            }
        };
        document.addEventListener("paste", handler);
        return ()=>{
            document.removeEventListener("paste", handler);
        };
    }, [
        addImageItem,
        show,
        texts,
        state.mainItem
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: canvasRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).canvas,
                onMouseMove: handleMouseMove,
                children: state.mainItem !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8ee2ef5ebacaefc$export$1fb5379e7a082abb), {
                            ref: pixiCanvasRef,
                            items: allItems,
                            pan: state.pan,
                            zoom: state.zoom
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6909c5c697445ce4$export$d5c6c08dc2d3ca7), {
                            pan: state.pan,
                            zoom: state.zoom,
                            onPan: handlePan,
                            onZoom: handleZoom,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $897df39b26075d44$export$7cda8d932e2f33c0), {
                                    tool: state.tool,
                                    activeItemIds: state.activeItemIds,
                                    onDraw: handleDraw,
                                    onDrawEnd: handleDrawEnd,
                                    onSelectArea: handleSelectArea
                                }),
                                state.tool === undefined && state.items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $564121fb632508d5$export$c1521c9298bce699), {
                                        item: item,
                                        pan: state.pan,
                                        zoom: state.zoom,
                                        isActive: state.activeItemIds.includes(item.id),
                                        onClick: (shift)=>handleItemClick(item.id, shift),
                                        onDrag: (offset, multiple)=>handleItemDrag(item.id, offset, multiple),
                                        onChange: handleItemChange,
                                        onDelete: ()=>handleItemDelete(item.id),
                                        onCancelCreate: ()=>handleItemCancelCreate(item.id),
                                        onContextMenuOpenChange: (open)=>handleItemContextMenuOpenChange(item.id, open),
                                        onContextMenuItemSelect: handleItemContextMenuItemSelect
                                    }, item.id)),
                                state.draftTextItem !== undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93376667685a0b26$export$f285e9b1c2b91a5b), {
                                    initialValue: state.draftTextItem.ink,
                                    onSubmit: handleDraftTextInkSubmit,
                                    onCancel: handleDraftTextInkCancel
                                })
                            ]
                        })
                    ]
                })
            }),
            state.mainItem === undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).welcomeWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $661b3888850954f4$export$23191e4434a9e834), {
                    onImageSelect: handleWelcomeImageSelect
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).logoWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a274207f4b4b8a3$export$e6ff31bff12b7ff4), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).toolBarWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94a8de0c3414f61b$export$bfbece8a621a006f), {
                    tool: state.tool,
                    style: state.style,
                    disabled: state.mainItem === undefined,
                    onColorChange: handleColorChange,
                    onSizeChange: handleSizeChange,
                    onToolChange: (tool)=>dispatch({
                            type: "set_tool",
                            tool: tool
                        })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).menuBarWrapper,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d97f4495e5002ba5$export$11a6fe490bbc4873), {
                    canUndo: state.history.past.length > 0,
                    canRedo: state.history.future.length > 0,
                    disabled: state.mainItem === undefined,
                    onUndoClick: handleUndoClick,
                    onRedoClick: handleRedoClick,
                    onMenuItemSelect: handleMenuBarMenuItemSelect
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).infoWrapper,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).info,
                        children: [
                            "pan: [",
                            state.pan.deltaX.toFixed(2),
                            ", ",
                            state.pan.deltaY.toFixed(2),
                            "]"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).info,
                        children: [
                            "zoom: ",
                            state.zoom.toFixed(2)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7396131ab649a5ba$exports))).info,
                        children: [
                            "cursor: [",
                            cursorPos.x.toFixed(2),
                            ", ",
                            cursorPos.y.toFixed(2),
                            "]"
                        ]
                    })
                ]
            })
        ]
    });
};
function $3d74bff2846008b2$var$concatItems(...items) {
    return items.filter((it)=>it !== undefined);
}
function $3d74bff2846008b2$var$bringForward(items, targetItemIds, toFront) {
    const temp = [];
    const result = [];
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        if (targetItemIds.includes(item.id)) temp.push(item);
        else {
            result.push(item);
            if (!toFront) {
                result.push(...temp);
                temp.length = 0;
            }
        }
    }
    result.push(...temp);
    return result;
}
function $3d74bff2846008b2$var$sendBackward(items, targetItemIds, toBack) {
    const temp = [];
    const result = [];
    for(let i = items.length - 1; i >= 0; i--){
        const item = items[i];
        if (targetItemIds.includes(item.id)) temp.push(item);
        else {
            result.push(item);
            if (!toBack) {
                result.push(...temp);
                temp.length = 0;
            }
        }
    }
    result.push(...temp);
    result.reverse();
    return result;
}




const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("app"));
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c17f85d6c45c40da$export$2ac87225e978ab39), {
    lang: "en",
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83c3827d0c2b2403$export$fb98e3a2a4cd92d7), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0273e7dadee8ce4c$export$f78649fb9ca566b8), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d74bff2846008b2$export$86fbec116b87613f), {})
        })
    })
}));


//# sourceMappingURL=repo.6eba5c60.js.map
